webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(3);
var createDesc = __webpack_require__(10);
module.exports = __webpack_require__(4) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(28);
var toPrimitive = __webpack_require__(16);
var dP = Object.defineProperty;

exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(9)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(51);
var defined = __webpack_require__(13);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(20)('wks');
var uid = __webpack_require__(11);
var Symbol = __webpack_require__(0).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(32);
var enumBugKeys = __webpack_require__(21);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(20)('keys');
var uid = __webpack_require__(11);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(3).f;
var has = __webpack_require__(1);
var TAG = __webpack_require__(6)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(6);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(15);
var LIBRARY = __webpack_require__(14);
var wksExt = __webpack_require__(23);
var defineProperty = __webpack_require__(3).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(14);
var $export = __webpack_require__(27);
var redefine = __webpack_require__(30);
var hide = __webpack_require__(2);
var has = __webpack_require__(1);
var Iterators = __webpack_require__(17);
var $iterCreate = __webpack_require__(49);
var setToStringTag = __webpack_require__(22);
var getPrototypeOf = __webpack_require__(56);
var ITERATOR = __webpack_require__(6)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(15);
var ctx = __webpack_require__(47);
var hide = __webpack_require__(2);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(4) && !__webpack_require__(9)(function () {
  return Object.defineProperty(__webpack_require__(29)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(50);
var enumBugKeys = __webpack_require__(21);
var IE_PROTO = __webpack_require__(19)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(29)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(55).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(1);
var toIObject = __webpack_require__(5);
var arrayIndexOf = __webpack_require__(52)(false);
var IE_PROTO = __webpack_require__(19)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(32);
var hiddenKeys = __webpack_require__(21).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*globals define:true, window:true, module:true*/
(function () {
  var eventSplitter = /^(\S+)\s*(.*)$/;
  // for extend callParent  
  Function.prototype.defineMethod = function (methodName, methodBody) {
    this.prototype[methodName] = methodBody;
    // if ((typeof methodBody) == 'function')
    if (methodBody) {
      methodBody.$name = methodName;
      methodBody.$owner = this;
    }
  };
  // Namespace object
  var my = {};
  // Return as AMD module or attach to head object
  if (true)
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return my;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  else if (typeof window !== 'undefined')
    window.my = my;
  else
    module.exports = my;




  var Events = __webpack_require__(76);


  var Module = {
    __bindEvents__ : function(events) {
      var eventName, key, match, method, selector, _results,
        _this = this;
      _results = [];
      for (key in events) {
        method = events[key];
        if (typeof method !== 'function') {
          method = (function(method) {
            return function() {
              _this[method].apply(_this, arguments);
              return true;
            };
          })(method);
        }
        match = key.match(eventSplitter);
        eventName = match[1];
        selector = match[2];
        if (selector === '') {
          _results.push(this.el.bind(eventName, method));
        } else {
          _results.push(this.el.delegate(selector, eventName, method));
        }
      }
      return _results;
    },
    __unbindEvents__ : function(events) {
      var eventName, key, match, method, selector, _results,
        _this = this;
      _results = [];
      for (key in events) {
        match = key.match(eventSplitter);
        eventName = match[1];
        selector = match[2];
        if (selector === '') {
          _results.push(this.el.unbind(eventName, method));
        } else {
          _results.push(this.el.undelegate(selector, eventName));
        }
      }
      return _results;
    },
    proxy:function(func){
      var _this = this;
      return function() {
        return func.apply(_this, arguments);
      };
    },
    callParent: function() {
      var method = arguments.callee.caller;
      return method.$owner.$baseType.prototype[method.$name].apply(this, arguments);
    }
  };

  //============================================================================
  // @method my.Class
  // @params body:Object
  // @params SuperClass:function, ImplementClasses:function..., body:Object
  // @description:
  // @return function
  my.createClass = function () {

    var len = arguments.length;
    var body = arguments[len - 1];
    var SuperClass = len > 1 ? arguments[0] : null;
    var hasImplementClasses = len > 2;
    var Class, SuperClassEmpty;

    if (body.constructor === Object) {
      Class = function() {};
    } else {
      Class = body.constructor;
      delete body.constructor;
    }

    if (SuperClass) {
      SuperClassEmpty = function() {};
      SuperClassEmpty.prototype = SuperClass.prototype;
      Class.prototype = new SuperClassEmpty();
      // Class.prototype.constructor = Class;
      Class.defineMethod('constructor', Class);
      Class.Super = SuperClass;
      extend(Class, SuperClass, false);
      Class.$baseType = SuperClass;
      // Class.super = function () {
      //   return SuperClass.prototype;
      // };

    }
    var fn = Class.prototype;


    if (hasImplementClasses)
      for (var i = 1; i < len - 1; i++)
        extend(fn, arguments[i].prototype, false);    

    extendClass(Class, body);

    //追加事件代理
    extend(fn,Events);

    extend(fn,Module);


    return Class;

  };

  //============================================================================
  // @method my.extendClass
  // @params Class:function, extension:Object, ?override:boolean=true
  var extendClass = my.extendClass = function (Class, extension, override) {
    if (extension.STATIC) {
      extend(Class, extension.STATIC, override);
      delete extension.STATIC;
    }
    // extend(Class.prototype, extension, override);
    var prop;
    if (override === false) {
      for (prop in extension)
        if (!(prop in Class.prototype))
          Class.defineMethod(prop, extension[prop]);
    } else {
      for (prop in extension)
        Class.defineMethod(prop, extension[prop]);
      if (extension.toString !== Object.prototype.toString)
        Class.defineMethod('toString', extension.toString);
    }
  };

  //============================================================================
  var extend = my.extend = function (obj, extension, override) {
    var prop;
    if (override === false) {
      for (prop in extension)
        if (!(prop in obj))
          obj[prop] = extension[prop];
    } else {
      for (prop in extension)
        obj[prop] = extension[prop];
      if (extension.toString !== Object.prototype.toString)
        obj.toString = extension.toString;
    }
  };




})();

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * artDialog
 * Date: 2014-11-09
 * https://github.com/aui/artDialog
 * (c) 2009-2014 TangBin, http://www.planeArt.cn
 *
 * This is licensed under the GNU LGPL, version 2.1 or later.
 * For details, see: http://www.gnu.org/licenses/lgpl-2.1.html
 */
+(function($){
  __webpack_require__(77);
  var Popup = __webpack_require__(78);
  var defaults = __webpack_require__(79);
  


  var _count = 0;
  var _expando = new Date() - 0; // Date.now()
  var _isIE6 = !('minWidth' in $('html')[0].style);
  var _isMobile = 'createTouch' in document && !('onmousemove' in document)
      || /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
  var _isFixed = !_isIE6 && !_isMobile;


  var artDialog = function (options, ok, cancel) {

    options.width = options.width || 480;
    var originalOptions = options = options || {};
      


    if (typeof options === 'string' || options.nodeType === 1) {
    
        options = {content: options, fixed: !_isMobile};
    }
    

    options = $.extend(true, {}, artDialog.defaults, options);
    options.original = originalOptions;
   
    

    var id = options.id = options.id || _expando + _count;
    var api = artDialog.get(id);
    
    
    // 如果存在同名的对话框对象，则直接返回
    if (api) {
        return api.focus();
    }
    
    
    // 目前主流移动设备对fixed支持不好，禁用此特性
    if (!_isFixed) {
        options.fixed = false;
    }


    // 快捷关闭支持：点击对话框外快速关闭对话框
    if (options.quickClose) {
        options.modal = true;
        options.backdropOpacity = 0;
    }
    

    // 按钮组
    if (!$.isArray(options.button)) {
        options.button = [];
    }


    // 取消按钮
    if (cancel !== undefined) {
        options.cancel = cancel;
    }
    
    if (options.cancel) {
        options.button.push({
            id: 'cancel',
            value: options.cancelValue,
            callback: options.cancel,
            display: options.cancelDisplay
        });
    }
    
    
    // 确定按钮
    if (ok !== undefined) {
        options.ok = ok;
    }
    
    if (options.ok) {
        options.button.push({
            id: 'ok',
            value: options.okValue,
            callback: options.ok,
            autofocus: true
        });
    }
    

    return artDialog.list[id] = new artDialog.create(options);
  };

  var popup = function () {};
  popup.prototype = Popup.prototype;
  var prototype = artDialog.prototype = new popup();

  artDialog.create = function (options) {
      var that = this;

      $.extend(this, new Popup());

      var originalOptions = options.original;
      var $popup = $(this.node).html(options.innerHTML);
      var $backdrop = $(this.backdrop);

      this.options = options;
      this._popup = $popup;

      
      $.each(options, function (name, value) {
          if (typeof that[name] === 'function') {
              that[name](value);
          } else {
              that[name] = value;
          }
      });


      // 更新 zIndex 全局配置
      if (options.zIndex) {
          Popup.zIndex = options.zIndex;
      }


      // 设置 ARIA 信息
      $popup.attr({
          'aria-labelledby': this._$('title')
              .attr('id', 'title:' + this.id).attr('id'),
          'aria-describedby': this._$('content')
              .attr('id', 'content:' + this.id).attr('id')
      });


      // 关闭按钮
      this._$('close')
      .css('display', this.cancel === false ? 'none' : '')
      .attr('title', this.cancelValue)
      .on('click', function (event) {
          that._trigger('cancel');
          event.preventDefault();
      });
      

      // 添加视觉参数
      this._$('dialog').addClass(this.skin);
      this._$('body').css('padding', this.padding);


      // 点击任意空白处关闭对话框
      if (options.quickClose) {
          $backdrop
          .on(
              'onmousedown' in document ? 'mousedown' : 'click',
              function () {
              that._trigger('cancel');
              return false;// 阻止抢夺焦点
          });
      }


      // 遮罩设置
      this.addEventListener('show', function () {
          $backdrop.css({
              opacity: 0,
              background: options.backdropBackground
          }).animate(
              {opacity: options.backdropOpacity}
          , 150);
      });


      // ESC 快捷键关闭对话框
      this._esc = function (event) {
          var target = event.target;
          var nodeName = target.nodeName;
          var rinput = /^input|textarea$/i;
          var isTop = Popup.current === that;
          var keyCode = event.keyCode;

          // 避免输入状态中 ESC 误操作关闭
          if (!isTop || rinput.test(nodeName) && target.type !== 'button') {
              return;
          }
          
          if (keyCode === 27) {
              that._trigger('cancel');
          }
      };

      $(document).on('keydown', this._esc);
      this.addEventListener('remove', function () {
          $(document).off('keydown', this._esc);
          delete artDialog.list[this.id];
      });


      _count ++;
      
      artDialog.oncreate(this);

      return this;
  };


  artDialog.create.prototype = prototype;



  $.extend(prototype, {

      /**
       * 显示对话框
       * @name artDialog.prototype.show
       * @param   {HTMLElement Object, Event Object}  指定位置（可选）
       */
      
      /**
       * 显示对话框（模态）
       * @name artDialog.prototype.showModal
       * @param   {HTMLElement Object, Event Object}  指定位置（可选）
       */

      /**
       * 关闭对话框
       * @name artDialog.prototype.close
       * @param   {String, Number}    返回值，可被 onclose 事件收取（可选）
       */

      /**
       * 销毁对话框
       * @name artDialog.prototype.remove
       */

      /**
       * 重置对话框位置
       * @name artDialog.prototype.reset
       */

      /**
       * 让对话框聚焦（同时置顶）
       * @name artDialog.prototype.focus
       */

      /**
       * 让对话框失焦（同时置顶）
       * @name artDialog.prototype.blur
       */

      /**
       * 添加事件
       * @param   {String}    事件类型
       * @param   {Function}  监听函数
       * @name artDialog.prototype.addEventListener
       */

      /**
       * 删除事件
       * @param   {String}    事件类型
       * @param   {Function}  监听函数
       * @name artDialog.prototype.removeEventListener
       */

      /**
       * 对话框显示事件，在 show()、showModal() 执行
       * @name artDialog.prototype.onshow
       * @event
       */

      /**
       * 关闭事件，在 close() 执行
       * @name artDialog.prototype.onclose
       * @event
       */

      /**
       * 销毁前事件，在 remove() 前执行
       * @name artDialog.prototype.onbeforeremove
       * @event
       */

      /**
       * 销毁事件，在 remove() 执行
       * @name artDialog.prototype.onremove
       * @event
       */

      /**
       * 重置事件，在 reset() 执行
       * @name artDialog.prototype.onreset
       * @event
       */

      /**
       * 焦点事件，在 foucs() 执行
       * @name artDialog.prototype.onfocus
       * @event
       */

      /**
       * 失焦事件，在 blur() 执行
       * @name artDialog.prototype.onblur
       * @event
       */

      
      /**
       * 设置内容
       * @param    {String, HTMLElement}   内容
       */
      content: function (html) {
        
          var $content = this._$('content');

          // HTMLElement
          if (typeof html === 'object') {
              html = $(html);
              $content.empty('').append(html.show());
              this.addEventListener('beforeremove', function () {
                  $('body').append(html.hide());
              });
          // String
          } else {
              $content.html(html);
          }
                  
          return this.reset();
      },

      /**
       * 设置类型，内置有 warning,error,success
       * @param    {String, HTMLElement}   内容
       */
      type: function(type){
        var $type = this._$('type');
        var typeText = type.text || '提示文字';
        var html = '<div class="y-clear">';
        var icon = '';
        switch(type.icon){
          case 'warning':
            icon = 'icon-bang';
            break;
          case 'error':
            icon = 'icon-no3';
            break;
          case 'success':
            icon = 'icon-yes3';
            break;
          default:
            break;
        }
        html += '<span style="'+ (type.leftWidth ? type.leftWidth : '' )  +'" class="type-icon '+ icon +'"></span>';
        html += '<span style="'+ (type.rightWidth ? type.rightWidth : '' ) +'">'+ typeText +'</span></div>';
        $type.html(html).show();
        return this;
      },
      
      
      /**
       * 设置标题
       * @param    {String}   标题内容
       */
      title: function (text) {
          this._$('title').text(text);
          this._$('header')[text ? 'show' : 'hide']();
          return this;
      },


      /** 设置宽度 */
      width: function (value) {
          this._$('content').css('width', value);
          return this.reset();
      },


      /** 设置高度 */
      height: function (value) {
          this._$('content').css('height', value);
          return this.reset();
      },


      /**
       * 设置按钮组
       * @param   {Array, String}
       * Options: value, callback, autofocus, disabled 
       */
      button: function (args) {
          args = args || [];
          var that = this;
          var html = '';
          var number = 0;
          this.callbacks = {};
          
             
          if (typeof args === 'string') {
              html = args;
              number ++;
          } else {
              $.each(args, function (i, val) {

                  var id = val.id = val.id || val.value;
                  var style = '';
                  that.callbacks[id] = val.callback;


                  if (val.display === false) {
                      style = ' style="display:none"';
                  } else {
                      number ++;
                  }

                  html +=
                    '<button'
                  + ' type="button"'
                  + ' i-id="' + id + '"'
                  + style
                  + (val.disabled ? ' disabled' : '')
                  + (val.autofocus ? ' autofocus class="ui-dialog-autofocus"' : '')
                  + '>'
                  +   val.value
                  + '</button>';

                  that._$('button')
                    .on('click', '[i-id=' + id +']', function (event) {                
                        var $this = $(this);
                        if (!$this.attr('disabled')) {// IE BUG
                            that._trigger(id);
                        }
                    
                        event.preventDefault();
                    });

              });
          }

          this._$('button').html(html);
          this._$('footer')[number ? 'show' : 'hide']();

          return this;
      },
      

      statusbar: function (html) {
          this._$('statusbar')
          .html(html)[html ? 'show' : 'hide']();

          return this;
      },


      _$: function (i) {
          return this._popup.find('[i=' + i + ']');
      },
      
      
      // 触发按钮回调函数
      _trigger: function (id) {
          var fn = this.callbacks[id];
              
          return typeof fn !== 'function' || fn.call(this) !== false ?
              this.close().remove() : this;
      }
      
  });



  artDialog.oncreate = $.noop;



  /** 获取最顶层的对话框API */
  artDialog.getCurrent = function () {
      return Popup.current;
  };



  /**
   * 根据 ID 获取某对话框 API
   * @param    {String}    对话框 ID
   * @return   {Object}    对话框 API (实例)
   */
  artDialog.get = function (id) {
      return id === undefined
      ? artDialog.list
      : artDialog.list[id];
  };

  artDialog.list = {};



  /**
   * 默认配置
   */
  artDialog.defaults = defaults;



  module.exports = artDialog;
})(jQuery);



/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 引入样式
__webpack_require__(81);
// 加载基类
var DblClass = __webpack_require__(36);
// 地址
var region = __webpack_require__(82);

// 加载弹框组件
var dbl_dialog = __webpack_require__(37);

var toChineseSpell = __webpack_require__(83);

var form = DblClass.createClass({
  // 模板
  tpl: __webpack_require__(95),
  // 构造函数
  constructor: function constructor(data) {
    this.extendCfg(data);
  },
  // 扩展配置
  extendCfg: function extendCfg(data) {
    var data = data || {};
    data = $.extend(true, {}, this.config, data);
    this.config = data;
  },
  // 绑定事件
  events: {},
  defaultAjaxReq: {
    url: null,
    type: 'post',
    dataType: 'jsonp',
    async: false,
    jsonp: 'callback',
    data: null
  },
  // 异步请求方法
  ajaxRequest: function ajaxRequest(ajaxReq) {
    ajaxReq = $.extend(true, {}, this.defaultAjaxReq, ajaxReq);
    var ajaxOptions = $.ajax(ajaxReq);
    return $.when(ajaxOptions);
  },
  // 自动填充
  autoFillCustomerInfo: function autoFillCustomerInfo() {
    var self = this;
    var select = self.dataBind.autoFillCustomerInfoCheckBox.select;
    if (!select.prop('checked')) {
      // 清空
      var defaultData = { telArea: '86' };
      self.clear();
      self.fill(defaultData);
      return;
    }
    var ajaxReq = {
      url: self.config.ajaxAutoUrl,
      type: 'get',
      data: { regType: self.regType }
    };
    // jsonp 获取数据
    self.ajaxRequest(ajaxReq).then(function (result) {
      var _d = result.data;
      if (_d.c_province) {
        if (_d.c_province == '新疆维吾尔自治区') {
          _d.c_province = '新疆';
        } else if (_d.c_province == '内蒙古自治区') {
          _d.c_province = '内蒙古';
        } else if (_d.c_province == '宁夏回族自治区') {
          _d.c_province = '宁夏';
        } else if (_d.c_province == '广西壮族自治区') {
          _d.c_province = '广西';
        } else if (_d.c_province == '西藏自治区') {
          _d.c_province = '西藏';
        } else if (_d.c_province == '香港特别行政区') {
          _d.c_province = '香港';
        } else if (_d.c_province == '澳门特别行政区') {
          _d.c_province = '澳门';
        } else if (_d.c_province.indexOf('省', _d.c_province.length - '省'.length) !== -1) {
          _d.c_province = _d.c_province.substring(0, _d.c_province.length - 1);
        } else if (_d.c_province.indexOf('市', _d.c_province.length - '市'.length) !== -1) {
          _d.c_province = _d.c_province.substring(0, _d.c_province.length - 1);
        }
      }
      self.fill(_d);
      // 模拟触发校验一次
      $('input[class*=\'form-control\']').blur();
      $('select[class*=\'form-control\']').blur();
      $('input[name*=\'telMain\']').blur();
      //
    }).fail(function () {
      alert('自动添加信息模板错误，请重试');
    });
  },
  popup: function popup(options) {
    if (!options || !options.callback) {
      return;
    }

    ////历史数据不存在auditStatus 默认为2 未提交实名认证
    if (options.data && options.data.realNameStatus === undefined) options.data.realNameStatus = 'NONAUDIT';

    var self = this;
    var innerHTML = self.tpl({ config: self.config });
    var html = '<div id="' + self.config.selectId + '">' + innerHTML + '</div>';
    var dialogOptions = {
      content: html,
      title: '域名持有者信息',
      width: 900,
      okValue: '确定',
      ok: ~[1, 3].indexOf(options.data && options.data.auditStatus ? options.data.auditStatus : 'undefined') ? undefined : function () {
        self.valid().success(function () {
          dialogOptions.callback(self);
          dialog.close();
          dialog.remove();
        }).fail(function () {});
        return false;
      },
      cancelValue: '取消',
      cancel: function cancel() {},
      callback: options.callback
    };
    if (options.title) {
      dialogOptions.title = options.title;
    }
    if (options.width) {
      dialogOptions.width = options.width;
    }
    if (options.okValue) {
      dialogOptions.okValue = options.okValue;
    }
    if (options.cancelValue) {
      dialogOptions.cancelValue = options.cancelValue;
    }

    var dialog = dbl_dialog(dialogOptions);
    dialog.showModal();
    self.initDataBind();
    self.bindEvents();
    self.clear();
    if (options.data) {
      self.fill(options.data);
    } else {
      var defaultData = { telArea: '86' };
      self.fill(defaultData);
    }
  },
  render: function render() {
    var self = this;
    var innerHTML = self.tpl({ config: self.config });
    $('#' + self.config.selectId).html(innerHTML);
    self.initDataBind();
    self.bindEvents();
    var defaultData = { telArea: '86' };
    self.fill(defaultData);
  },
  // 表单验证是否通过
  valid: function valid() {
    var self = this;
    var successCallback = function successCallback() {};
    var failCallback = function failCallback() {};
    var retObj = {
      success: function success(callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        successCallback = callback;
        return retObj;
      },
      fail: function fail(callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        failCallback = callback;
        return retObj;
      }
    };
    setTimeout(function () {
      var valid = self.dataBind.contact_form.select.valid();
      if (valid) {
        self.checkContact().success(successCallback).fail(failCallback);
      } else {
        failCallback();
      }
    }, 1);
    return retObj;
  },
  //变更企业类型,在做为域名联系人信息嵌入表单时使用
  switchRegType: function switchRegType(regType) {
    var self = this;
    self.dataBind.regType.set(regType);
  },
  // 初始化配置

  config: {
    selectId: 'contact_form',
    displayMode: 2, //1:域名信息模板新建/详情编辑弹窗页面 2:域名联系人信息嵌入表单
    regType: 1, //默认所有者类型
    validation: $.extend({}, __webpack_require__(96)),
    ajaxAutoUrl: '//' + contactTemplate.baseUri + '/contacttemplate/contactTmplApi/fillContactWithCustomerInfo.json',
    // ajaxValidUrl: "//domain.console.aliyun.com/contacttemplate/contactTmplApi/checkContactInfoData.json",
    ajaxValidUrl: '//' + contactTemplate.baseUri + '/contacttemplate/contactTmplApi/checkContactInfoData.json?dtoken=' + (window.domainTokenID || ''),
    displayNameFieldAlways: 0,
    displayEnglishFields: 1
  },
  dataBindFn: {
    contact_form: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId + '_contactForm');
      },
      bindEvent: function bindEvent() {
        var self = this;
        if (self.select.length == 0) {
          return;
        }
        var validator = self.select.validate(self.form.config.validation);
        validator.errorsFor = function (element) {
          var name = element.name;
          var m = this.settings.tips[name];
          if (m && m.groupName) name = m.groupName;

          var tipsID = name + '_tips';
          return $('#' + self.form.config.selectId + '_' + tipsID);
        };
      }
    },
    regType: {
      init: function init(form) {
        this.form = form;
        if (form.config.regType) {
          this.val = form.config.regType;
        }
      },
      bindEvent: function bindEvent() {},
      regTypeChangeHandler: function regTypeChangeHandler() {
        var self = this;
        if (self.get() == '1') {
          $('#' + this.form.config.selectId).find('input[name=\'regType\']').val('1');
          if (this.form.config.displayMode == 1) {
            var regTypeDesc_selector = $('#' + this.form.config.selectId + '_regTypeDesc');
            regTypeDesc_selector.html('个人');
          }
          var c_company_selector = $('#' + this.form.config.selectId).find('input[name=\'c_company\']');
          c_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者名称（中文）：');
          var e_company_selector;
          if (self.form.config.displayEnglishFields == 1) {
            e_company_selector = $('#' + this.form.config.selectId).find('input[name=\'e_company\']');
            e_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者名称（英文）：');
          }
          if (self.form.config.displayNameFieldAlways == 0) {
            var c_name_selector = $('#' + this.form.config.selectId).find('input[name=\'c_name\']');
            if (c_name_selector.length > 0) {
              self.c_name = c_name_selector.val();
              c_name_selector.closest('tr').remove();
            }
            if (self.form.config.displayEnglishFields == 1) {
              var e_name_selector = $('#' + this.form.config.selectId).find('input[name=\'e_name\']');
              if (e_name_selector.length > 0) {
                self.e_name = e_name_selector.val();
                e_name_selector.closest('tr').remove();
              }
            }
          }
        } else if (self.get() == '2') {
          $('#' + this.form.config.selectId).find('input[name=\'regType\']').val('2');
          if (this.form.config.displayMode == 1) {
            var regTypeDesc_selector = $('#' + this.form.config.selectId + '_regTypeDesc');
            regTypeDesc_selector.html('企业');
          }
          var c_company_selector = $('#' + this.form.config.selectId).find('input[name=\'c_company\']');
          c_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者单位名称（中文）：');
          var e_company_selector;
          if (self.form.config.displayEnglishFields == 1) {
            e_company_selector = $('#' + this.form.config.selectId).find('input[name=\'e_company\']');
            e_company_selector.closest('tr').find('td:first').html('<span class="text-danger">*</span>域名持有者单位名称（英文）：');
          }
          if (self.form.config.displayNameFieldAlways == 0) {
            var c_name_selector = $('#' + this.form.config.selectId).find('input[name=\'c_name\']');
            if (c_name_selector.length == 0) {
              c_company_selector.closest('tr').after('          <tr >\r' + '            <td  align="right"><span class="text-danger">*</span>域名管理联系人（中文）：</td>\r' + '            <td >\r' + '                <input type="text" class="form-control tao-w300 " maxlength="128" name="c_name" value=""  />\r' + '                <span class="tips" id="' + self.form.config.selectId + '_c_name_tips"></span>\r' + '            </td>\r' + '        </tr>\r');
              if (self.c_name) {
                $('#' + this.form.config.selectId).find('input[name=\'c_name\']').val(self.c_name);
              }
              if (self.form.config.displayEnglishFields == 1) {
                var e_name_selector = $('#' + this.form.config.selectId).find('input[name=\'e_name\']');
                if (e_name_selector.length == 0) {
                  e_company_selector.closest('tr').after('          <tr >\r' + '            <td  align="right"><span class="text-danger">*</span>域名管理联系人（英文）：</td>\r' + '            <td >\r' + '                <input type="text" class="form-control tao-w300 " maxlength="128" name="e_name" value=""  />\r' + '                <span class="tips" id="' + self.form.config.selectId + '_e_name_tips"></span>\r' + '            </td>\r' + '        </tr>\r');
                  if (self.e_name) {
                    $('#' + this.form.config.selectId).find('input[name=\'e_name\']').val(self.e_name);
                  }
                }
              }
            }
          }
        }
      },
      set: function set(val) {
        if (!val || val != '1' && val != '2') {
          return;
        }
        this.val = val;
        this.regTypeChangeHandler();
      },
      get: function get() {
        return this.val;
      }
    },
    autoFillCustomerInfoCheckBox: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId + '_autoFillCustomerInfo');
      },
      bindEvent: function bindEvent() {
        var self = this;
        if (self.select.length > 0) {
          self.select.on('click', function (event) {
            self.form.autoFillCustomerInfo();
          });
        }
      }
    },
    c_country: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('select[name=\'c_country\']');
      },
      set: function set(val) {
        if (!val) {
          return;
        }
        try {
          if (isNaN(val)) {
            var country = region.getRegionByCode(val);
          } else {
            var country = region.getRegionByID(val);
          }

          this.select.val(country.code);
          if ($.inArray(country.code, ['CN', 'HK', 'OM', 'TW']) != -1) {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('1');
          } else {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('2');
          }
          this.form.dataBind.c_province.renderProvinceSelect();
        } catch (e) {
          var country = region.getRegionByCode('CN');
          this.select.val(country.code);
          if ($.inArray(country.code, ['CN', 'HK', 'OM', 'TW']) != -1) {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('1');
          } else {
            $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('2');
          }
          this.form.dataBind.c_province.renderProvinceSelect();
        }
      },
      get: function get() {
        return this.select.val();
      },
      renderRegionSelect: function renderRegionSelect() {
        var regions = region.getAllRegions();
        for (var i in regions) {
          this.select.append('<option value="' + regions[i].code + '">' + regions[i].title + '</option>');
        }
        this.form.dataBind.c_province.renderProvinceSelect();
        //this.select.val() 
        this.setTelArea(this.select.val());
      },
      // 国家代码强制86 
      setTelArea: function setTelArea(code) {
        var telArea = $('#' + this.form.config.selectId).find('input[name=\'telArea\']');
        var regions = region.getAllRegions();
        if (telArea.length == 1) {
          for (var i in regions) {
            if (code == regions[i].code) {
              telArea.val(regions[i].prefix);
            }
          }
        }
      },
      regionChangeHandler: function regionChangeHandler() {
        this.form.dataBind.c_province.renderProvinceSelect();
        var code = this.select.val();
        this.setTelArea(code);

        if ($.inArray(code, ['CN', 'HK', 'OM', 'TW']) != -1) {
          $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('1');
        } else {
          $('#' + this.form.config.selectId).find('input[name=\'regionType\']').val('2');
        }
      },
      bindEvent: function bindEvent() {
        var self = this;
        this.select.change(function () {
          self.regionChangeHandler();
        });
      }
    },
    c_province: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('select[name=\'c_province\']');
      },
      set: function set(val) {
        try {
          this.select.val(val);
          this.form.dataBind.c_city.renderCitySelect();
        } catch (e) {}
      },
      get: function get() {
        return this.select.val();
      },
      provinceChangeHandler: function provinceChangeHandler() {
        this.form.dataBind.c_city.renderCitySelect();
        var val = this.get();
        if (val) {
          var selectedProvince = region.getProvinceByTitle(val);
          if (selectedProvince != null) {
            var provincePinYin = toChineseSpell(selectedProvince.title);
            $('#' + this.form.config.selectId).find('input[name=\'e_province\']').val(provincePinYin);
          }
        }
      },
      renderProvinceSelect: function renderProvinceSelect() {
        var code = this.form.dataBind.c_country.get();
        var rg = region.getRegionByCode(code);
        this.select.empty();
        this.select.append('<option value="">-省份-</option>');
        if (rg == null) {
          this.form.dataBind.c_city.renderCitySelect();
          return;
        }
        var provinces = region.getProvinces(rg.regionID);
        var citySelect = this.form.dataBind.c_city.select;
        if (provinces.length < 1) {
          this.select.hide();
          citySelect.hide();
          this.set(rg.title);
          this.form.dataBind.c_city.set(rg.title);
          var regionPinyin = toChineseSpell(rg.title);
          $('#' + this.form.config.selectId).find('input[name=\'e_province\']').val(regionPinyin);
          $('#' + this.form.config.selectId).find('input[name=\'e_city\']').val(regionPinyin);
        } else {
          this.select.show();
          citySelect.show();
          for (var i in provinces) {
            this.select.append('<option value="' + provinces[i].title + '">' + provinces[i].title + '</option>');
          }
        }
        this.form.dataBind.c_city.renderCitySelect();
      },
      bindEvent: function bindEvent() {
        var self = this;
        this.select.change(function () {
          self.provinceChangeHandler();
        });
      }
    },
    c_city: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('select[name=\'c_city\']');
      },
      set: function set(val) {
        try {
          this.select.val(val);
        } catch (e) {}
      },
      get: function get() {
        return this.select.val();
      },
      cityChangeHandler: function cityChangeHandler() {
        var cityVal = this.get();
        var provinceVal = this.form.dataBind.c_province.get();
        if (cityVal && provinceVal) {
          var selectedCity = region.getCityByTitle(cityVal, provinceVal);
          if (selectedCity != null) {
            var regionPinyin = toChineseSpell(selectedCity.title);
            $('#' + this.form.config.selectId).find('input[name=\'e_city\']').val(regionPinyin);
          }
        }
      },
      renderCitySelect: function renderCitySelect() {
        var provinceTitle = this.form.dataBind.c_province.get();

        this.select.empty();
        this.select.append('<option value="">-城市-</option>');
        if (provinceTitle == '') {
          return;
        }
        var citys = region.getCityByProvinceTitle(provinceTitle);
        if (!citys) {
          return;
        }
        for (var i in citys) {
          this.select.append('<option value="' + citys[i].title + '">' + citys[i].title + '</option>');
        }
      },
      bindEvent: function bindEvent() {
        var self = this;
        this.select.change(function () {
          self.cityChangeHandler();
        });
      }
    },
    c_company: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'c_company\']');
      },
      set: function set(val) {
        this.select.val(val);
      },
      get: function get() {
        return this.select.val();
      },
      bindEvent: function bindEvent() {
        var self = this;
        this.select.change(function () {
          self.changeHandler();
        });
      },
      changeHandler: function changeHandler() {
        var self = this;
        var e_company_select = $('#' + this.form.config.selectId).find('input[name=\'e_company\']');
        if (e_company_select.length > 0) {
          var val = toChineseSpell(self.get());
          e_company_select.val(val);
        }
      }
    },
    c_name: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'c_name\']');
      },
      set: function set(val) {
        this.select.val(val);
      },
      get: function get() {
        return this.select.val();
      },
      bindEvent: function bindEvent() {
        var self = this;
        this.select.change(function () {
          self.changeHandler();
        });
      },
      changeHandler: function changeHandler() {
        var self = this;
        var e_name_select = $('#' + this.form.config.selectId).find('input[name=\'e_name\']');
        if (e_name_select.length > 0) {
          var val = toChineseSpell(self.get());
          e_name_select.val(val);
        }
      }
    },
    c_venu: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'c_venu\']');
      },
      set: function set(val) {
        this.select.val(val);
      },
      get: function get() {
        return this.select.val();
      },
      bindEvent: function bindEvent() {
        var self = this;
        this.select.change(function () {
          self.changeHandler();
        });
      },
      changeHandler: function changeHandler() {
        var self = this;
        var e_venu_select = $('#' + this.form.config.selectId).find('input[name=\'e_venu\']');
        if (e_venu_select.length > 0) {
          var val = toChineseSpell(self.get());
          e_venu_select.val(val);
        }
      }
    },
    defaultTemplate: {
      init: function init(form) {
        this.form = form;
        this.select = $('#' + this.form.config.selectId).find('input[name=\'defaultTemplate\']');
      },
      bindEvent: function bindEvent() {
        var self = this;
        if (self.select.length > 0) {
          self.select.click(function () {
            if (self.select.is(':checked')) {
              self.select.val('1');
            } else {
              self.select.val('0');
            }
          });
        }
      },
      set: function set(val) {
        if (this.select.length == 0) {
          return;
        }
        if (val != '0' && val != '1') {
          return;
        }
        this.select.val(val);
        if (val == '1') {
          this.select.prop('checked', true);
        }
      },
      get: function get() {
        if (this.select.length == 0) {
          return;
        }
        return this.select.val();
      }
    }

  },

  fill: function fill(data) {
    var self = this;
    data = data || {};
    //需要按顺序填充的字段
    var exludeFields = ['c_country', 'c_province', 'e_province', 'c_city', 'e_city'];
    self.dataBind.contact_form.select.find('input,select,textarea').each(function () {
      var element = $(this);
      var name = element.attr('name');
      if (name == 'regionType') {
        return;
      }
      if ($.inArray(name, exludeFields) != -1) {
        return;
      }
      if (name && data[name] !== undefined) {
        if (self.dataBind[name] && self.dataBind[name].set) {
          self.dataBind[name].set(data[name]);
        } else {
          // 判断国家地区为CN 
          if (data.c_country == 'CN' && name == 'telArea') {
            element.attr('value', 86);
          } else if (name == 'telArea' && !data[name]) {
            element.attr('value', 86);
          } else {
            element.attr('value', data[name]);
          }
        }
      }
    });
    if (data.c_country) {
      self.dataBind.c_country.set(data.c_country);
    }
    if (data.c_province) {
      self.dataBind.c_province.set(data.c_province);
      if (data['c_province'] && !data['e_province']) {
        self.dataBind.c_province.select.change();
      }
    }
    if (data.c_city) {
      self.dataBind.c_city.set(data.c_city);
      if (data['c_city'] && !data['e_city']) {
        self.dataBind.c_city.select.change();
      }
    }
    if (data.e_province) {
      $('#' + self.config.selectId).find('input[name=e_province]').val(data.e_province);
    }
    if (data.e_city) {
      $('#' + self.config.selectId).find('input[name=e_city]').val(data.e_city);
    }
    if (data['c_company'] && !data['e_company']) {
      self.dataBind.c_company.select.change();
    }
    if (data['c_name'] && !data['e_name']) {
      self.dataBind.c_name.select.change();
    }
    if (data['c_venu'] && !data['e_venu']) {
      self.dataBind.c_venu.select.change();
    }
  },
  clear: function clear() {
    var self = this;
    this.dataBind.contact_form.select.find('input,select,textarea').each(function () {
      var element = $(this);
      if (element.is(':hidden')) {
        return;
      }
      var name = element.attr('name');
      if (self.dataBind[name] && self.dataBind[name].set) {
        self.dataBind[name].set('');
      } else {
        element.attr('value', '');
      }
    });
    var defaultData = { telArea: '86' };
    self.fill(defaultData);
  },
  getFormData: function getFormData() {

    var o = {};
    var a = this.dataBind.contact_form.select.serializeArray();
    $.each(a, function () {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    if (this.config.displayMode == 1) {
      o.defaultTemplate = this.dataBind.defaultTemplate.get();
    } else if (this.config.displayMode == 2) {
      //if (o.c_name === undefined  && o.regType && (o.regType=="1")  && o.c_company !==undefined) {
      //  o.e_company = o.c_company;
      //}
      //if (o.e_name === undefined  && o.regType && (o.regType=="1")  && o.e_company !==undefined) {
      //  o.e_name = o.e_company;
      //}
    }
    if ($.inArray(o.c_country, ['CN', 'HK', 'OM', 'TW']) == -1) {
      var rg = region.getRegionByCode(o.c_country);
      o.c_province = rg.title;
      o.c_city = rg.title;
    }
    if (o.regionType) {
      delete o.regionType;
    }
    return o;
  },
  checkContact: function checkContact() {
    var self = this;
    var successCallback = function successCallback() {};
    var failCallback = function failCallback() {};
    var retObj = {
      success: function success(callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        successCallback = callback;
        return retObj;
      },
      fail: function fail(callback) {
        if (!callback || typeof callback !== 'function') {
          return retObj;
        }
        failCallback = callback;
        return retObj;
      }
    };
    var template = self.getFormData();
    if (template._csrf_token) {
      delete template._csrf_token;
    }
    var jqxhr = $.ajax({
      url: self.config.ajaxValidUrl,
      //type: 'get',
      dataType: 'jsonp',
      async: false,
      cache: false,
      jsonp: 'callback',
      data: template
    });
    jqxhr.done(function (data) {
      var html = '';
      if (!data.success) {
        for (var x in data.module) {
          // if (template[name] !== undefined) {
          html += '<p>' + data.module[x] + '</p>';
          // }
        }
        if (html) {
          var dialogOptions = {
            content: html,
            title: '错误信息',
            width: 400,
            okValue: '确定',
            ok: function ok() {
              return true;
            },
            cancelValue: '取消',
            cancel: function cancel() {}
          };
          var dialog = dbl_dialog(dialogOptions);
          dialog.show();
          return;
        }
      }
      successCallback();
    }).fail(failCallback);
    return retObj;
  },
  initDataBind: function initDataBind() {
    var self = this;
    self.dataBind = {};
    for (var prop in self.dataBindFn) {
      if (!self.dataBindFn.hasOwnProperty(prop) || !self.dataBindFn[prop].init) {
        continue;
      }
      self.dataBindFn[prop].init.prototype = self.dataBindFn[prop];
      self.dataBind[prop] = new self.dataBindFn[prop].init(this);
    }
  },
  bindEvents: function bindEvents() {
    var self = this;
    self.dataBind.contact_form.bindEvent();
    self.dataBind.regType.bindEvent();
    self.dataBind.c_country.bindEvent();
    self.dataBind.c_province.bindEvent();
    self.dataBind.c_city.bindEvent();
    self.dataBind.defaultTemplate.bindEvent();
    self.dataBind.autoFillCustomerInfoCheckBox.bindEvent();
    self.dataBind.c_company.bindEvent();
    self.dataBind.c_name.bindEvent();
    self.dataBind.c_venu.bindEvent();
    self.dataBind.c_country.renderRegionSelect();
  },
  addHiddenInputField: function addHiddenInputField(html) {
    $('#' + this.config.selectId + '_contactForm').append(html);
  },
  replaceField: function replaceField(fieldName, html) {
    if (!fieldName) {
      return;
    }
    var select = $('#' + this.config.selectId + '_' + fieldName + '_td');
    if (select.length > 0) {
      select.html(html);
    }
  },
  resetFieldDefault: function resetFieldDefault(fieldName) {
    var self = this;
    if (!fieldName) {
      return;
    }
    var select = $('#' + this.config.selectId + '_' + fieldName + '_td');
    if (select.length == 0) {
      return;
    }
    var html = void 0;
    if (fieldName == 'c_company') {
      html = '' + '                <input type="text" class="form-control tao-w300 " maxlength="128" name="c_company" value=""  />\n' + '                <span class="tips" id=' + this.config.selectId + '_c_company_tips"></span>';
      select.html(html);
      self.dataBind.c_company.init(self);
      self.dataBind.c_company.bindEvent();
    } else if (fieldName == 'e_company') {
      html = '' + '                <input type="text" class="form-control tao-w300 " maxlength="128" name="e_company" value=""  />\n' + '                <span class="tips" id="' + this.config.selectId + '_e_company_tips"></span>';
      select.html(html);
    }
  },
  replaceFieldLabel: function replaceFieldLabel(fieldName, val) {
    if (!fieldName) {
      return;
    }
    var select = $('#' + this.config.selectId + '_' + fieldName + '_label_td');
    if (select.length == 0) {
      return;
    }
    var self = this;
    if (fieldName == 'c_company' || fieldName == 'e_company') {
      select.html('<span class="text-danger">*</span>' + val);
    } else if (fieldName == 'c_name' || fieldName == 'e_name') {
      select.html('<span class="text-danger">*</span>' + val);
    }
  },
  resetFieldLabelDefault: function resetFieldLabelDefault(fieldName) {
    if (!fieldName) {
      return;
    }
    var select = $('#' + this.config.selectId + '_' + fieldName + '_label_td');
    if (select.length == 0) {
      return;
    }
    if (fieldName == 'c_company') {
      var regType = $('#' + this.config.selectId).find('input[name=\'regType\']').val();
      if (regType == '1') {
        select.html('<span class="text-danger">*</span>' + '域名持有者名称（中文）：');
      } else {
        select.html('<span class="text-danger">*</span>' + '域名持有者单位名称（中文）：');
      }
    } else if (fieldName == 'e_company') {
      var regType = $('#' + this.config.selectId).find('input[name=\'regType\']').val();
      if (regType == '1') {
        select.html('<span class="text-danger">*</span>' + '域名持有者名称（英文）：');
      } else {
        select.html('<span class="text-danger">*</span>' + '域名持有者单位名称（英文）：');
      }
    } else if (fieldName == 'c_name') {
      select.html('<span class="text-danger">*</span>' + '域名管理联系人（中文）：');
    } else if (fieldName == 'e_name') {
      select.html('<span class="text-danger">*</span>' + '域名管理联系人（英文）：');
    }
  },
  addRow: function addRow(data) {
    if (!data || !data.labelName && !data.labelHtml || !data.fieldHtml) {
      return;
    }
    var select = void 0;
    if (data.afterRow) {
      select = $('#' + this.config.selectId).find('input[name=\'' + data.afterRow + '\']');
    } else if (data.beforeRow) {
      select = $('#' + this.config.selectId).find('input[name=\'' + data.beforeRow + '\']');
    } else {
      select = $('#' + this.config.selectId).find('form > table > tbody');
    }
    if (select.length > 0) {
      var innerHTMLArray = new Array();
      innerHTMLArray.push('        <tr >\r');
      innerHTMLArray.push('       <td  align="right">');
      if (data.labelHtml) {
        innerHTMLArray.push(data.labelHtml);
      } else if (data.labelName) {
        if (data.labelRequire) {
          innerHTMLArray.push('<span class="text-danger">*</span>');
        }
        innerHTMLArray.push(data.labelName);
      }
      innerHTMLArray.push('</td>\\r');
      innerHTMLArray.push('        <td >\r');
      innerHTMLArray.push(data.fieldHtml);
      innerHTMLArray.push('\r');
      innerHTMLArray.push('            </td>\r');
      innerHTMLArray.push('            </tr>\r');
      if (data.beforeRow) {
        select.closest('tr').before(innerHTMLArray.join());
      } else {
        select.closest('tr').after(innerHTMLArray.join());
      }
    }
  },
  removeRow: function removeRow(data) {
    if (!data || !data.fieldName && !data.selector) {
      return;
    }
    var select = void 0;
    if (data.selector) {
      select = $(selector);
    } else if (data.fieldName) {
      select = $('#' + this.config.selectId).find('input[name=\'' + data.fieldName + '\']').closest('tr');
    }
    if (select.length > 0) {
      select.remove();
    }
  },

  disable: function disable(fieldName) {
    $('[name="' + fieldName + '"]').attr('readonly', true);
  },

  enable: function enable(fieldName) {
    $('[name="' + fieldName + '"]').removeAttr('readonly');
  },

  after: function after(fieldName, element) {
    $('[name="' + fieldName + '"]').after(element);
  }

});

module.exports = form;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41);
__webpack_require__(73);

$(document).ready(function ($) {
  window.contactTemplate = window.contactTemplate || {};
  window.contactTemplate.baseUri = window.contactTemplate.baseUri || 'domain.console.aliyun.com';
  window.contactTemplate.queryUri = window.contactTemplate.queryUri || 'dc.console.aliyun.com';
  window.contactTemplate.list = __webpack_require__(74);
  window.contactTemplate.form = __webpack_require__(38);
  window.creatContactList = window.contactTemplate.list;
  window.creatContactForm = window.contactTemplate.form;
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2 = __webpack_require__(42);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  by zhanxp
 */

(function ($) {

  $.extend($.fn, {
    // http://docs.jquery.com/Plugins/Validation/validate
    validate: function validate(options) {

      // if nothing is selected, return nothing; can't chain anyway
      if (!this.length) {
        options && options.debug && window.console && console.warn('nothing selected, can\'t validate, returning nothing');
        return;
      }

      // check if a validator for this form was already created
      var validator = $.data(this[0], 'validator');
      if (validator) {
        return validator;
      }

      validator = new $.validator(options, this[0]);
      $.data(this[0], 'validator', validator);

      if (validator.settings.onsubmit) {

        // allow suppresing validation by adding a cancel class to the submit button
        this.find('input, button').filter('.cancel').click(function () {
          validator.cancelSubmit = true;
        });

        // when a submitHandler is used, capture the submitting button
        if (validator.settings.submitHandler) {
          this.find('input, button').filter(':submit').click(function () {
            validator.submitButton = this;
          });
        }

        // validate the form on submit
        this.submit(function (event) {
          if (validator.settings.debug)
            // prevent form submit to be able to see console output
            event.preventDefault();

          function handle() {
            if (validator.settings.submitHandler) {
              if (validator.submitButton) {
                // insert a hidden input as a replacement for the missing submit button
                var hidden = $('<input type=\'hidden\'/>').attr('name', validator.submitButton.name).val(validator.submitButton.value).appendTo(validator.currentForm);
              }
              validator.settings.submitHandler.call(validator, validator.currentForm);
              if (validator.submitButton) {
                // and clean up afterwards; thanks to no-block-scope, hidden can be referenced
                hidden.remove();
              }
              return false;
            }
            return true;
          }

          // prevent submit for invalid forms or custom submit handlers
          if (validator.cancelSubmit) {
            validator.cancelSubmit = false;
            return handle();
          }
          if (validator.form()) {
            if (validator.pendingRequest) {
              validator.formSubmitted = true;
              return false;
            }
            return handle();
          } else {
            validator.focusInvalid();
            return false;
          }
        });
      }

      return validator;
    },
    // http://docs.jquery.com/Plugins/Validation/valid
    valid: function valid() {
      if ($(this[0]).is('form')) {
        return this.validate().form();
      } else {
        var valid = true;
        var validator = $(this[0].form).validate();
        this.each(function () {
          valid &= validator.element(this);
        });
        return valid;
      }
    },
    // attributes: space seperated list of attributes to retrieve and remove
    removeAttrs: function removeAttrs(attributes) {
      var result = {},
          $element = this;
      $.each(attributes.split(/\s/), function (index, value) {
        result[value] = $element.attr(value);
        $element.removeAttr(value);
      });
      return result;
    },
    // http://docs.jquery.com/Plugins/Validation/rules
    rules: function rules(command, argument) {
      var element = this[0];

      if (command) {
        var settings = $.data(element.form, 'validator').settings;
        var staticRules = settings.rules;
        var existingRules = $.validator.staticRules(element);
        switch (command) {
          case 'add':
            $.extend(existingRules, $.validator.normalizeRule(argument));
            staticRules[element.name] = existingRules;
            if (argument.messages) settings.messages[element.name] = $.extend(settings.messages[element.name], argument.messages);
            break;
          case 'remove':
            if (!argument) {
              delete staticRules[element.name];
              return existingRules;
            }
            var filtered = {};
            $.each(argument.split(/\s/), function (index, method) {
              filtered[method] = existingRules[method];
              delete existingRules[method];
            });
            return filtered;
        }
      }

      var data = $.validator.normalizeRules($.extend({}, $.validator.metadataRules(element), $.validator.classRules(element), $.validator.attributeRules(element), $.validator.staticRules(element)), element);

      // make sure required is at front
      //if (data.required) {
      //var param = data.required;
      //delete data.required;
      //data = $.extend({ required: param }, data);
      //}

      return data;
    }
  });

  // Custom selectors
  $.extend($.expr[':'], {
    // http://docs.jquery.com/Plugins/Validation/blank
    blank: function blank(a) {
      return !$.trim('' + a.value);
    },
    // http://docs.jquery.com/Plugins/Validation/filled
    filled: function filled(a) {
      return !!$.trim('' + a.value);
    },
    // http://docs.jquery.com/Plugins/Validation/unchecked
    unchecked: function unchecked(a) {
      return !a.checked;
    }
  });

  // constructor for validator
  $.validator = function (options, form) {
    this.settings = $.extend({}, $.validator.defaults, options);
    this.currentForm = form;
    this.init();
  };

  $.validator.format = function (source, params) {
    if (arguments.length == 1) return function () {
      var args = $.makeArray(arguments);
      args.unshift(source);
      return $.validator.format.apply(this, args);
    };
    if (arguments.length > 2 && params.constructor != Array) {
      params = $.makeArray(arguments).slice(1);
    }
    if (params.constructor != Array) {
      params = [params];
    }
    $.each(params, function (i, n) {
      source = source.replace(new RegExp('\\{' + i + '\\}', 'g'), n);
    });
    return source;
  };

  // zhanxp
  $.extend($.validator, {

    defaults: {
      messages: {},
      groups: {},
      rules: {},
      tips: {},
      errorClass: 'form-tip text-danger',
      validClass: 'form-tip text-success',
      tipClass: 'form-tip text-info',
      errorElement: 'span',
      focusInvalid: true,
      errorContainer: $([]),
      errorLabelContainer: $([]),
      onsubmit: true,
      ignore: [],
      ignoreTitle: false,
      alertError: true,
      //errorPlacement: function(error, element) {
      //if (error.size() > 0) {
      //var name = $(element).attr("name");
      //var obj = $("#" + name.replace(".", "_") + "_validationMessage");
      //obj.attr("class", error[0].classList[0]);
      //obj.text(error[0].childNodes[0].wholeText);
      //}
      //},
      onfocusin: function onfocusin(element) {
        this.lastActive = element;
        this.tipsFor(element);
      },
      onfocusout: function onfocusout(element) {
        this.element(element);
        if (this.invalidElements && element in this.invalidElements) {
          var label = this.errorsFor(element);
          if (label.length > 0) label.removeClass().addClass(errorClass);
        }
        if (this.validElements && element in this.validElements) {
          var label = this.errorsFor(element);
          if (label.length > 0) label.removeClass().addClass(validClass);
        }
      },
      onkeyup: function onkeyup(element) {},
      onclick: function onclick(element) {
        if (element.name in this.submitted) this.element(element);else if (element.parentNode.name in this.submitted) this.element(element.parentNode);
      },
      highlight: function highlight(element, errorClass, validClass) {
        var label = this.errorsFor(element);
        if (label.length > 0) label.addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function unhighlight(element, errorClass, validClass) {
        var label = this.errorsFor(element);
        if (label.length > 0) label.removeClass(errorClass).addClass(validClass);
      }
    },

    // http://docs.jquery.com/Plugins/Validation/Validator/setDefaults
    setDefaults: function setDefaults(settings) {
      $.extend($.validator.defaults, settings);
    },

    messages: {
      required: '必须填写该项！',
      remote: '填写的值无效！',
      email: '请填写正确的Email地址！',
      url: '  请填写正确的Url地址！',
      date: '请填写正确的日期！',
      dateISO: '请填写格式如：1990-01-01 的日期格式！',
      number: '只能填写数字！',
      digits: '只能填写整数！',
      creditcard: 'Please enter a valid credit card number.',
      equalTo: '两次输入的值不相等！',
      accept: '请选择符合要求的文件',
      maxlength: $.validator.format('最多输入{0}个字符！'),
      minlength: $.validator.format('请最少输入{0}个字符！'),
      rangelength: $.validator.format('请输入{0}-{1}个字符！'),
      range: $.validator.format('请输入介于{0}-{1}的值！'),
      max: $.validator.format('请输入大于{0}的值！'),
      min: $.validator.format('请输入小于{0}的值！')
    },

    autoCreateRanges: false,

    prototype: {

      init: function init() {
        this.labelContainer = $(this.settings.errorLabelContainer);
        this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
        this.containers = $(this.settings.errorContainer).add(this.settings.errorLabelContainer);
        this.submitted = {};
        this.valueCache = {};
        this.pendingRequest = 0;
        this.pending = {};
        this.invalid = {};
        this.reset();

        var groups = this.groups = {};
        $.each(this.settings.groups, function (key, value) {
          $.each(value.split(/\s/), function (index, name) {
            groups[name] = key;
          });
        });
        var rules = this.settings.rules;
        $.each(rules, function (key, value) {
          rules[key] = $.validator.normalizeRule(value);
        });

        function delegate(event) {
          var validator = $.data(this[0].form, 'validator');
          validator.settings['on' + event.type] && validator.settings['on' + event.type].call(validator, this[0]);
        }
        $(this.currentForm).mydelegate('focusin focusout keyup', ':text, :password, :file, select, textarea', delegate).mydelegate('click', ':radio, :checkbox, select, option', delegate);

        if (this.settings.invalidHandler) $(this.currentForm).bind('invalid-form.validate', this.settings.invalidHandler);
      },

      // http://docs.jquery.com/Plugins/Validation/Validator/form
      form: function form() {
        this.checkForm();
        $.extend(this.submitted, this.errorMap);
        this.invalid = $.extend({}, this.errorMap);
        var valid = this.valid();
        this.showErrors();
        if (!this.valid()) {
          $(this.currentForm).triggerHandler('invalid-form', [this]);
          this.showAlertErrors();
          return false;
        }
        return true;
      },

      checkForm: function checkForm() {
        this.prepareForm();
        for (var _i = 0, elements = this.currentElements = this.elements(); elements[_i]; _i++) {
          this.check(elements[_i]);
        }
        return this.valid();
      },

      // http://docs.jquery.com/Plugins/Validation/Validator/element
      element: function element(_element) {
        _element = this.clean(_element);
        this.lastElement = _element;
        this.prepareElement(_element);
        this.currentElements = $(_element);
        var result = this.check(_element);
        if (result) {
          delete this.invalid[_element.name];
        } else {
          this.invalid[_element.name] = true;
        }
        if (!this.numberOfInvalids()) {
          // Hide error containers on last error
          this.toHide = this.toHide.add(this.containers);
        }
        this.showErrors();
        return result;
      },
      showAlertErrors: function showAlertErrors(errors) {
        if (this.settings.alertError) {
          var haveError = [];
          for (var _i2 = 0; this.errorList[_i2]; _i2++) {
            var error = this.errorList[_i2];
            if (!error) continue;
            var ii = haveError.length;
            var have = false;
            while (ii--) {
              if (haveError[ii] === error.message) {
                have = true;
              }
            }
            if (!have) haveError.push(error.message);
          }
          if (haveError.length > 0) alert(haveError.join('\r\n'));
        }
      },
      // http://docs.jquery.com/Plugins/Validation/Validator/showErrors
      showErrors: function showErrors(errors) {
        if (errors) {
          // add items to error list and map
          $.extend(this.errorMap, errors);
          this.errorList = [];
          for (var name in errors) {
            this.errorList.push({
              message: errors[name],
              element: this.findByName(name)[0]
            });
          }
          // remove items from success list
          this.successList = $.grep(this.successList, function (element) {
            return !(element.name in errors);
          });
        }

        this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors();
      },

      // http://docs.jquery.com/Plugins/Validation/Validator/resetForm
      resetForm: function resetForm() {
        if ($.fn.resetForm) $(this.currentForm).resetForm();
        this.submitted = {};
        this.prepareForm();
        this.hideErrors();
        this.elements().removeClass(this.settings.errorClass);
      },

      numberOfInvalids: function numberOfInvalids() {
        return this.objectLength(this.invalid);
      },

      objectLength: function objectLength(obj) {
        var count = 0;
        for (var _i3 in obj) {
          count++;
        }return count;
      },

      hideErrors: function hideErrors() {
        this.addWrapper(this.toHide).hide();
      },

      valid: function valid() {
        return this.size() == 0;
      },

      size: function size() {
        return this.errorList.length;
      },

      focusInvalid: function focusInvalid() {
        if (this.settings.focusInvalid) {
          try {
            $(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(':visible').focus();
          } catch (e) {
            // ignore IE throwing errors when focusing hidden elements
          }
        }
      },

      findLastActive: function findLastActive() {
        var lastActive = this.lastActive;
        return lastActive && $.grep(this.errorList, function (n) {
          return n.element.name == lastActive.name;
        }).length == 1 && lastActive;
      },

      elements: function elements() {
        var validator = this,
            rulesCache = {};

        // select all valid inputs inside the form (no submit or reset buttons)
        return $(this.currentForm).find('input, select, textarea').not(':submit, :reset, :image, [disabled]').not(this.settings.ignore).filter(function () {
          !this.name && validator.settings.debug && window.console && console.error('%o has no name assigned', this);

          // select only the first element for each name, and only those with rules specified
          if (this.name in rulesCache || !validator.objectLength($(this).rules())) return false;

          rulesCache[this.name] = true;
          return true;
        });
      },

      clean: function clean(selector) {
        return $(selector)[0];
      },

      errors: function errors() {
        return $(this.settings.errorElement + '.' + this.settings.errorClass, this.errorContext);
      },

      reset: function reset() {
        this.successList = [];
        this.errorList = [];
        this.errorMap = {};
        this.toShow = $([]);
        this.toHide = $([]);
        this.currentElements = $([]);
      },

      prepareForm: function prepareForm() {
        this.reset();
        this.toHide = this.errors().add(this.containers);
      },

      prepareElement: function prepareElement(element) {
        this.reset();
        this.toHide = this.errorsFor(element);
      },

      check: function check(element) {
        element = this.clean(element);
        // if radio/checkbox, validate first element in group instead
        if (this.checkable(element)) {
          element = this.findByName(element.name)[0];
        }

        if ($(element).attr('type') == 'text') {
          //去除空格
          var thisVal = $.trim($(element).val());
          $(element).val(thisVal);
        }

        var rules = $(element).rules();
        var dependencyMismatch = false;
        var breakvalidate = false;
        for (var method in rules) {
          var rule = { method: method, parameters: rules[method] };
          try {
            var result = $.validator.methods[method].call(this, element.value.replace(/\r/g, ''), element, rule.parameters);
            if (result == 'break-validate') {
              breakvalidate = true;
              break;
            }

            // if a method indicates that the field is optional and therefore valid,
            // don't mark it as valid when there are no other rules
            if (result == 'dependency-mismatch') {
              dependencyMismatch = true;
              continue;
            }

            dependencyMismatch = false;

            if (result == 'pending') {
              this.toHide = this.toHide.not(this.errorsFor(element));
              return;
            }

            if (!result) {
              this.formatAndAdd(element, rule);
              return false;
            }
          } catch (e) {
            this.settings.debug && window.console && console.log('exception occured when checking element ' + element.name + ', check the \'' + rule.method + '\' method', e);
            throw e;
          }
        }
        if (breakvalidate) {
          return;
        }

        if (dependencyMismatch) return;

        if (this.objectLength(rules)) this.successList.push(element);

        return true;
      },

      // return the custom message for the given element and validation method
      // specified in the element's "messages" metadata
      customMetaMessage: function customMetaMessage(element, method) {
        if (!$.metadata) return;

        var meta = this.settings.meta ? $(element).metadata()[this.settings.meta] : $(element).metadata();

        return meta && meta.messages && meta.messages[method];
      },

      // return the custom message for the given element name and validation method
      customMessage: function customMessage(name, method) {
        var m = this.settings.messages[name];
        return m && (m.constructor == String ? m : m[method]);
      },

      //zhanxp
      customTip: function customTip(element) {
        var name = element.name;
        var m = this.settings.tips[name];
        if (m) {
          return m.tips;
        } else {
          return '';
        }
      },
      //zhanxp
      customSucceedMessage: function customSucceedMessage(element) {
        var name = element.name;
        var m = this.settings.tips[name];
        if (m && m.SucceedMessage) {
          return m.SucceedMessage;
        } else {
          return '';
        }
      },

      // return the first defined argument, allowing empty strings
      findDefined: function findDefined() {
        for (var _i4 = 0; _i4 < arguments.length; _i4++) {
          if (arguments[_i4] !== undefined) return arguments[_i4];
        }
        return undefined;
      },

      defaultMessage: function defaultMessage(element, method) {
        return this.findDefined(this.customMessage(element.name, method), this.customMetaMessage(element, method),
        // title is never undefined, so handle empty string as undefined
        !this.settings.ignoreTitle && element.title || undefined, $.validator.messages[method], '<strong>Warning: No message defined for ' + element.name + '</strong>');
      },

      formatAndAdd: function formatAndAdd(element, rule) {
        var message = this.defaultMessage(element, rule.method),
            theregex = /\$?\{(\d+)\}/g;
        if (typeof message == 'function') {
          message = message.call(this, rule.parameters, element);
        } else if (theregex.test(message)) {
          message = jQuery.format(message.replace(theregex, '{$1}'), rule.parameters);
        }
        this.errorList.push({
          message: message,
          element: element
        });

        this.errorMap[element.name] = message;
        this.submitted[element.name] = message;
      },

      // zhanxp
      addWrapper: function addWrapper(toToggle) {
        if (this.settings.wrapper) toToggle = toToggle.add(toToggle.parent(this.settings.wrapper));
        return toToggle;
      },

      // zhanxp
      defaultShowErrors: function defaultShowErrors() {

        for (var i = 0; this.errorList[i]; i++) {
          var error = this.errorList[i];
          this.settings.highlight && this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass);
          this.showLabel(error.element, error.message);
        }
        for (var i = 0; this.successList[i]; i++) {
          this.showLabel(this.successList[i]);
        }
        if (this.errorList.length) {
          this.toShow = this.toShow.add(this.containers);
        }
        if (this.settings.success) {
          for (var i = 0; this.successList[i]; i++) {
            this.showLabel(this.successList[i]);
          }
        }
        if (this.settings.unhighlight) {
          for (var i = 0, elements = this.validElements(); elements[i]; i++) {
            this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
          }
        }
        this.toHide = this.toHide.not(this.toShow);
        //this.hideErrors();
        this.addWrapper(this.toShow).show();
      },

      validElements: function validElements() {
        return this.currentElements.not(this.invalidElements());
      },

      invalidElements: function invalidElements() {
        return $(this.errorList).map(function () {
          return this.element;
        });
      },

      // zhanxp
      showLabel: function showLabel(element, message) {
        var label = this.errorsFor(element);
        if (message) {
          label.removeClass().addClass(this.settings.errorClass);
          label.html(message);
        } else {
          label.html(this.customSucceedMessage(element));
          label.removeClass().addClass(this.settings.validClass);
        }
        this.toShow = this.toShow.add(label);
      },
      //zhanxp
      errorsFor: function errorsFor(element) {
        var name = element.name;
        var m = this.settings.tips[name];
        if (m && m.groupName) name = m.groupName;

        var tipsID = name + '_tips';
        return $('#' + tipsID);
      },
      //zhanxp tip
      tipsFor: function tipsFor(element) {
        var text = this.customTip(element);
        var label = this.errorsFor(element);
        if (label.length <= 0) return;
        label.html(text);
        label.removeClass().addClass(this.settings.tipClass);
        label.show();
      },
      idOrName: function idOrName(element) {
        return this.groups[element.name] || (this.checkable(element) ? element.name : element.name || element.name);
      },

      checkable: function checkable(element) {
        return (/radio|checkbox/i.test(element.type)
        );
      },

      findByName: function findByName(name) {
        // select by name and filter by form for performance over form.find("[name=...]")
        var form = this.currentForm;
        return $(document.getElementsByName(name)).map(function (index, element) {
          return element.form == form && element.name == name && element || null;
        });
      },

      getLength: function getLength(value, element) {
        switch (element.nodeName.toLowerCase()) {
          case 'select':
            return $('option:selected', element).length;
          case 'input':
            if (this.checkable(element)) return this.findByName(element.name).filter(':checked').length;
        }
        // return value.length;
        return value.replace(/[^\x00-\xff]/g, 'xx').length;
      },

      getLengthENCN: function getLengthENCN(value, element) {
        switch (element.nodeName.toLowerCase()) {
          case 'select':
            return $('option:selected', element).length;
          case 'input':
            if (this.checkable(element)) return this.findByName(element.name).filter(':checked').length;
        }
        return value.length;
      },

      getBytesLen: function getBytesLen(str) {
        var sum = 0;
        for (var _i5 = 0; _i5 < str.length; _i5++) {
          if (str.charCodeAt(_i5) >= 0 && str.charCodeAt(_i5) <= 255) sum = sum + 1;else sum = sum + 2;
        }
        return sum;
      },

      depend: function depend(param, element) {
        return this.dependTypes[typeof param === 'undefined' ? 'undefined' : (0, _typeof3.default)(param)] ? this.dependTypes[typeof param === 'undefined' ? 'undefined' : (0, _typeof3.default)(param)](param, element) : true;
      },

      dependTypes: {
        'boolean': function boolean(param, element) {
          return param;
        },
        'string': function string(param, element) {
          return !!$(param, element.form).length;
        },
        'function': function _function(param, element) {
          return param(element);
        }
      },

      optional: function optional(element) {
        return !$.validator.methods.required.call(this, $.trim(element.value), element) && 'dependency-mismatch';
      },

      startRequest: function startRequest(element) {
        if (!this.pending[element.name]) {
          this.pendingRequest++;
          this.pending[element.name] = true;
        }
      },

      stopRequest: function stopRequest(element, valid) {
        this.pendingRequest--;
        // sometimes synchronization fails, make sure pendingRequest is never < 0
        if (this.pendingRequest < 0) this.pendingRequest = 0;
        delete this.pending[element.name];
        if (valid && this.pendingRequest == 0 && this.formSubmitted && this.form()) {
          $(this.currentForm).submit();
          this.formSubmitted = false;
        } else if (!valid && this.pendingRequest == 0 && this.formSubmitted) {
          $(this.currentForm).triggerHandler('invalid-form', [this]);
          this.formSubmitted = false;
        }
      },

      previousValue: function previousValue(element) {
        return $.data(element, 'previousValue') || $.data(element, 'previousValue', {
          old: null,
          valid: true,
          message: this.defaultMessage(element, 'remote')
        });
      }

    },

    classRuleSettings: {
      required: { required: true },
      email: { email: true },
      url: { url: true },
      date: { date: true },
      dateISO: { dateISO: true },
      dateDE: { dateDE: true },
      number: { number: true },
      numberDE: { numberDE: true },
      digits: { digits: true },
      creditcard: { creditcard: true }
    },

    addClassRules: function addClassRules(className, rules) {
      className.constructor == String ? this.classRuleSettings[className] = rules : $.extend(this.classRuleSettings, className);
    },

    classRules: function classRules(element) {
      var rules = {};
      var classes = $(element).attr('class');
      classes && $.each(classes.split(' '), function () {
        if (this in $.validator.classRuleSettings) {
          $.extend(rules, $.validator.classRuleSettings[this]);
        }
      });
      return rules;
    },

    attributeRules: function attributeRules(element) {
      var rules = {};
      var $element = $(element);

      for (var method in $.validator.methods) {
        var value = $element.attr(method);
        if (value) {
          rules[method] = value;
        }
      }

      // maxlength may be returned as -1, 2147483647 (IE) and 524288 (safari) for text inputs
      if (rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) {
        delete rules.maxlength;
      }

      return rules;
    },

    metadataRules: function metadataRules(element) {
      if (!$.metadata) return {};

      var meta = $.data(element.form, 'validator').settings.meta;
      return meta ? $(element).metadata()[meta] : $(element).metadata();
    },

    staticRules: function staticRules(element) {
      var rules = {};
      var validator = $.data(element.form, 'validator');
      if (validator.settings.rules) {
        rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
      }
      return rules;
    },

    normalizeRules: function normalizeRules(rules, element) {
      // handle dependency check
      $.each(rules, function (prop, val) {
        // ignore rule when param is explicitly false, eg. required:false
        if (val === false) {
          delete rules[prop];
          return;
        }
        if (val.param || val.depends) {
          var keepRule = true;
          switch ((0, _typeof3.default)(val.depends)) {
            case 'string':
              keepRule = !!$(val.depends, element.form).length;
              break;
            case 'function':
              keepRule = val.depends.call(element, element);
              break;
          }
          if (keepRule) {
            rules[prop] = val.param !== undefined ? val.param : true;
          } else {
            delete rules[prop];
          }
        }
      });

      // evaluate parameters
      $.each(rules, function (rule, parameter) {
        rules[rule] = $.isFunction(parameter) ? parameter(element) : parameter;
      });

      // clean number parameters
      $.each(['minlength', 'maxlength', 'min', 'max'], function () {
        if (rules[this]) {
          rules[this] = Number(rules[this]);
        }
      });
      $.each(['rangelength', 'range', 'rangelengthENCN'], function () {
        if (rules[this]) {
          rules[this] = [Number(rules[this][0]), Number(rules[this][1])];
        }
      });

      if ($.validator.autoCreateRanges) {
        // auto-create ranges
        if (rules.min && rules.max) {
          rules.range = [rules.min, rules.max];
          delete rules.min;
          delete rules.max;
        }
        if (rules.minlength && rules.maxlength) {
          rules.rangelength = [rules.minlength, rules.maxlength];
          delete rules.minlength;
          delete rules.maxlength;
        }
      }

      // To support custom messages in metadata ignore rule methods titled "messages"
      if (rules.messages) {
        delete rules.messages;
      }

      return rules;
    },

    // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
    normalizeRule: function normalizeRule(data) {
      if (typeof data == 'string') {
        var transformed = {};
        $.each(data.split(/\s/), function () {
          transformed[this] = true;
        });
        data = transformed;
      }
      return data;
    },

    // http://docs.jquery.com/Plugins/Validation/Validator/addMethod
    addMethod: function addMethod(name, method, message) {
      $.validator.methods[name] = method;
      $.validator.messages[name] = message != undefined ? message : $.validator.messages[name];
      if (method.length < 3) {
        $.validator.addClassRules(name, $.validator.normalizeRule(name));
      }
    },

    methods: {

      // http://docs.jquery.com/Plugins/Validation/Methods/required
      required: function required(value, element, param) {
        // check if dependency is met
        if (!this.depend(param, element)) return 'dependency-mismatch';
        switch (element.nodeName.toLowerCase()) {
          case 'select':
            // could be an array for select-multiple or a string, both are fine this way
            var val = $(element).val();
            return val && val.length > 0;
          case 'input':
            if (this.checkable(element)) return this.getLength(value, element) > 0;
          default:
            return $.trim(value).length > 0;
        }
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/remote
      // http://docs.jquery.com/Plugins/Validation/Methods/remote
      remote: function remote(value, element, param) {
        if (this.optional(element)) return 'dependency-mismatch';

        var previous = this.previousValue(element);
        if (!this.settings.messages[element.name]) this.settings.messages[element.name] = {};
        previous.originalMessage = this.settings.messages[element.name].remote;
        this.settings.messages[element.name].remote = previous.message;

        param = typeof param == 'string' && { url: param } || param;

        if (previous.old !== value) {
          previous.old = value;
          var validator = this;
          this.startRequest(element);
          var data = 'val=' + encodeURIComponent(value);

          var success = function success(response) {
            validator.settings.messages[element.name].remote = previous.originalMessage;
            var valid = response === true;
            if (valid) {
              var submitted = validator.formSubmitted;
              validator.prepareElement(element);
              validator.formSubmitted = submitted;
              validator.successList.push(element);
              validator.showErrors();
            } else {
              var errors = {};
              var message = previous.message = response || validator.defaultMessage(element, 'remote');
              errors[element.name] = $.isFunction(message) ? message(value) : message;
              validator.showErrors(errors);
            }
            previous.valid = valid;
            validator.stopRequest(element, valid);
          };

          if (window.needCrossDomain && window.obpHost) {
            $.ajax({
              url: window.obpHost + param.url,
              mode: 'abort',
              port: 'validate' + element.name,
              dataType: 'jsonp',
              data: data,
              success: success
            });
          } else {
            $.ajax($.extend(true, {
              url: param,
              mode: 'abort',
              port: 'validate' + element.name,
              dataType: 'json',
              type: 'POST',
              data: data,
              success: success
            }, param));
          }

          return 'pending';
        } else if (this.pending[element.name]) {
          return 'pending';
        }
        return previous.valid;
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/minlength
      minlength: function minlength(value, element, param) {
        return this.optional(element) || this.getLength($.trim(value), element) >= param;
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/maxlength
      maxlength: function maxlength(value, element, param) {
        return this.optional(element) || this.getLength($.trim(value), element) <= param;
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/rangelength
      rangelength: function rangelength(value, element, param) {
        var length = this.getLength($.trim(value), element);
        return this.optional(element) || length >= param[0] && length <= param[1];
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/rangelengthENCN
      rangelengthENCN: function rangelengthENCN(value, element, param) {
        var length = this.getLengthENCN($.trim(value), element);
        return this.optional(element) || length >= param[0] && length <= param[1];
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/rangelengthENCN
      rangelengthENANDCN: function rangelengthENANDCN(value, element, param) {
        var regOne = /^[-a-zA-Z0-9]{1,63}$/;
        var regTwo = new RegExp(/^[-a-zA-Z0-9\u4E00-\u9FA5]{1,}$/);
        var length = this.getLengthENCN($.trim(value), element);
        if (regOne.test(value)) {
          return this.optional(element) || length >= 3 && length <= 63;
        }
        if (regTwo.test(value)) {
          return this.optional(element) || length >= 1 && length <= 40;
        }
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/min
      min: function min(value, element, param) {
        return this.optional(element) || value >= param;
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/max
      max: function max(value, element, param) {
        return this.optional(element) || value <= param;
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/range
      range: function range(value, element, param) {
        return this.optional(element) || value >= param[0] && value <= param[1];
      },

      email: function email(value, element) {
        var reg = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/);
        return this.optional(element) || reg.test(value);
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/url
      url: function url(value, element) {
        // contributed by Scott Gonzalez: http://projects.scottsplayground.com/iri/
        return this.optional(element) || /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/date
      date: function date(value, element) {
        return this.optional(element) || !/Invalid|NaN/.test(new Date(value));
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/dateISO
      dateISO: function dateISO(value, element) {
        return this.optional(element) || /^\d{4}[\/-]\d{1,2}[\/-]\d{1,2}$/.test(value);
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/number
      number: function number(value, element) {
        return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(value);
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/digits
      digits: function digits(value, element) {
        return this.optional(element) || /^\d+$/.test(value);
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/creditcard
      // based on http://en.wikipedia.org/wiki/Luhn
      creditcard: function creditcard(value, element) {
        if (this.optional(element)) return 'dependency-mismatch';
        // accept only digits and dashes
        if (/[^0-9-]+/.test(value)) return false;
        var nCheck = 0,
            nDigit = 0,
            bEven = false;

        value = value.replace(/\D/g, '');

        for (var n = value.length - 1; n >= 0; n--) {
          var cDigit = value.charAt(n);
          var nDigit = parseInt(cDigit, 10);
          if (bEven) {
            if ((nDigit *= 2) > 9) nDigit -= 9;
          }
          nCheck += nDigit;
          bEven = !bEven;
        }

        return nCheck % 10 == 0;
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/accept
      accept: function accept(value, element, param) {
        param = typeof param == 'string' ? param.replace(/,/g, '|').replaceAll('image/', '') : 'png|jpe?g|gif';
        return this.optional(element) || value.match(new RegExp('.(' + param + ')$', 'i'));
      },

      // http://docs.jquery.com/Plugins/Validation/Methods/equalTo
      equalTo: function equalTo(value, element, param) {
        // bind to the blur event of the target in order to revalidate whenever the target field is updated
        // TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
        var target = $(param).unbind('.validate-equalTo').bind('blur.validate-equalTo', function () {
          $(element).valid();
        });
        return value == target.val();
      }

    }

  });

  // deprecated, use $.validator.format instead
  $.format = $.validator.format;
})(jQuery);

// ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()

(function ($) {
  var ajax = $.ajax;
  var pendingRequests = {};
  $.ajax = function (settings) {
    // create settings for compatibility with ajaxSetup
    settings = $.extend(settings, $.extend({}, $.ajaxSettings, settings));
    var port = settings.port;
    if (settings.mode == 'abort') {
      if (pendingRequests[port]) {
        pendingRequests[port].abort();
      }
      return pendingRequests[port] = ajax.apply(this, arguments);
    }
    return ajax.apply(this, arguments);
  };
})(jQuery);

// provides cross-browser focusin and focusout events
// IE has native support, in other browsers, use event caputuring (neither bubbles)

// provides delegate(type: String, delegate: Selector, handler: Callback) plugin for easier event delegation
// handler is only called when $(event.target).is(delegate), in the scope of the jquery-object for event.target

// provides triggerEvent(type: String, target: Element) to trigger delegated events

(function ($) {
  $.each({
    focus: 'focusin',
    blur: 'focusout'
  }, function (original, fix) {
    $.event.special[fix] = {
      setup: function setup() {
        if ($.browser.msie) return false;
        this.addEventListener(original, $.event.special[fix].handler, true);
      },
      teardown: function teardown() {
        if ($.browser.msie) return false;
        this.removeEventListener(original, $.event.special[fix].handler, true);
      },
      handler: function handler(e) {
        arguments[0] = $.event.fix(e);
        arguments[0].type = fix;
        return $.event.dispatch.apply(this, arguments);
      }
    };
  });
  $.extend($.fn, {
    mydelegate: function mydelegate(type, delegate, handler) {
      return this.bind(type, function (event) {
        var target = $(event.target);
        if (target.is(delegate)) {
          return handler.apply(target, arguments);
        }
      });
    },
    triggerEvent: function triggerEvent(type, target) {
      return this.triggerHandler(type, [$.event.fix({ type: type, target: target })]);
    }
  });
})(jQuery);

// 正则验证 zhanxp
jQuery.validator.addMethod('regular', function (value, element, param) {

  var reg = new RegExp(param);
  return this.optional(element) || reg.test(value);
}, '不符合指定格式！');

// requiredif zhanxp
jQuery.validator.addMethod('requiredif', function (value, element, param) {

  var target = $('input[name=' + param[0] + ']');
  if ($('input[name=' + param[0] + ']').size() > 1) {
    target = $('input:checked:[name=' + param[0] + ']');
  }

  $(target).unbind('.validate-requiredif').bind('blur.validate-requiredif', function () {
    $(element).valid();
  });

  if ($(target).val() != param[1]) return true;

  switch (element.nodeName.toLowerCase()) {
    case 'select':
      // could be an array for select-multiple or a string, both are fine this way
      var val = $(element).val();
      return val && val.length > 0;
    case 'input':
      if (this.checkable(element)) return this.getLength(value, element) > 0;
    default:
      return $.trim(value).length > 0;
  }
}, '必须填写该项！');

// breakif zhanxp
jQuery.validator.addMethod('breakif', function (value, element, param) {
  var target = $('*.[name=' + param[0] + ']');
  if ($('input:[name=' + param[0] + ']').size() > 1) {
    target = $('input:checked:[name=' + param[0] + ']');
  }
  $(target).unbind('.validate-breakif').bind('blur.validate-breakif', function () {
    $(element).valid();
  });

  if ($(target).val() == param[1]) return 'break-validate';
  return true;
}, '');

// requiredifnot zhanxp
jQuery.validator.addMethod('requiredifnot', function (value, element, param) {

  var target = $('*.[name=' + param[0] + ']');
  if ($('input:[name=' + param[0] + ']').size() > 1) {
    target = $('input:checked:[name=' + param[0] + ']');
  }

  $(target).unbind('.validate-requiredifnot').bind('blur.validate-requiredifnot', function () {
    $(element).valid();
  });

  if ($(target).val() == param[1]) return true;

  switch (element.nodeName.toLowerCase()) {
    case 'select':
      // could be an array for select-multiple or a string, both are fine this way
      var val = $(element).val();
      return val && val.length > 0;
    case 'input':
      if (this.checkable(element)) return this.getLength(value, element) > 0;
    default:
      return $.trim(value).length > 0;
  }
}, '必须填写该项！');

// breakifnot zhanxp
jQuery.validator.addMethod('breakifnot', function (value, element, param) {

  var target = $('*.[name=' + param[0] + ']');
  if ($('input:[name=' + param[0] + ']').size() > 1) {
    target = $('input:checked:[name=' + param[0] + ']');
  }

  $(target).unbind('.validate-requiredifnot').bind('blur.validate-breakifnot', function () {
    $(element).valid();
  });

  if ($(target).val() != param[1]) return 'break-validate';

  return true;
}, '');

// 正则验证 zhanxp
jQuery.validator.addMethod('notequalTo', function (value, element, param) {
  var target = $(param).unbind('.validate-notequalTo').bind('blur.validate-notequalTo', function () {
    $(element).valid();
  });
  return value != target.val();
}, '请输入不同的值！');

//birthday
jQuery.validator.addMethod('birthday', function (value, element, param) {
  var reg = new RegExp(/^(?:(?:1[6-9]|[2-9][0-9])[0-9]{2}([-])(?:(?:0?[1-9]|1[0-2])\1(?:0?[1-9]|1[0-9]|2[0-8])|(?:0?[13-9]|1[0-2])\1(?:29|30)|(?:0?[13578]|1[02])\1(?:31))|(?:(?:1[6-9]|[2-9][0-9])(?:0[48]|[2468][048]|[13579][26])|(?:16|[2468][048]|[3579][26])00)([-])0?2\2(?:29))$/);
  return this.optional(element) || reg.test(value);
}, '请输入正确的生日格式！');

//telDomain
jQuery.validator.addMethod('telDomain', function (value, element, param) {
  var regTail = /(.tel)$/;
  return this.optional(element) || !regTail.test(value);
}, 'tel域名不能支持解析！');

// domain
jQuery.validator.addMethod('domain', function (value, element, param) {
  var reg = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5][-a-zA-Z0-9\u4e00-\u9fa5]{0,62}(\.[a-zA-Z0-9\u4e00-\u9fa5][-a-zA-Z0-9\u4e00-\u9fa5]{0,62})+\.?$/);
  return this.optional(element) || reg.test(value);
}, '请输入正确的域名！');

//domain
jQuery.validator.addMethod('domainwww', function (value, element, param) {
  if ($.trim(value).indexOf('www.') > -1) {
    value = value.split('www.')[1];
  }
  var reg = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5][-a-zA-Z0-9\u4e00-\u9fa5]{0,62}(\.[a-zA-Z0-9\u4e00-\u9fa5][-a-zA-Z0-9\u4e00-\u9fa5]{0,62})+\.?$/);
  return this.optional(element) || reg.test(value);
}, '请输入正确的域名！');

// domainen
jQuery.validator.addMethod('domainen', function (value, element, param) {
  var reg = new RegExp(/^[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?$/);
  return this.optional(element) || reg.test(value);
}, '请输入正确的英文域名！');

//domainen without ext
jQuery.validator.addMethod('domainEnWithoutExt', function (value, element, param) {
  var reg = /^[-a-zA-Z0-9]{1,63}$/;
  var regHead = /^[a-zA-Z0-9]/;
  var regTail = /[a-zA-Z0-9]$/;
  return this.optional(element) || reg.test(value) && regHead.test(value) && regTail.test(value) && !(value.indexOf('xn--') == 0);
}, '请输入正确的英文域名！');

//domaincn without ext
jQuery.validator.addMethod('domainCnWithoutExt', function (value, element, param) {
  var reg = new RegExp(/^[-a-zA-Z0-9\u4E00-\u9FA5]{1,}$/);
  var regCn = /[\u4E00-\u9FA5]/;
  var regHead = /^[a-zA-Z0-9\u4E00-\u9FA5]/;
  var regTail = /[a-zA-Z0-9\u4E00-\u9FA5]$/;
  return this.optional(element) || reg.test(value) && regCn.test(value) && regHead.test(value) && regTail.test(value) && this.getBytesLen(value) <= 63;
}, '请输入正确的中文域名！');

//domaincc without ext
jQuery.validator.addMethod('domaincc', function (value, element, param) {
  var reg = /^[0-9]{6,14}$/;
  return this.optional(element) || !reg.test(value);
}, 'cc域名不允许注册6-14的纯数字！');

//domainname
jQuery.validator.addMethod('domainname', function (value, element, param) {
  var reg = /^[0-9]+$/;
  return this.optional(element) || !reg.test(value);
}, '.name域名不能注册纯数字！');

//====20120306加入域名检测函数相关
jQuery.validator.addMethod('isDomain', function (value, element, param) {
  var cnlist = ',AC,AD,AE,AERO,AF,AG,AI,AL,AM,AN,AO,AQ,AR,ARPA,AS,ASIA,AT,AU,AW,AX,AZ';
  cnlist += ',BA,BB,BD,BE,BF,BG,BH,BI,BIZ,BJ,BL,BM,BN,BO,BR,BS,BT,BV,BW,BY,BZ';
  cnlist += ',CA,CAT,CC,CD,CF,CG,CH,CI,CK,CL,CM,CN,CO,COM,COOP,CR,CU,CV,CX,CY,CZ,DE,DJ,DK,DM,DO,DZ';
  cnlist += ',EC,EDU,EE,EG,EH,ER,ES,ET,EU,FI,FJ,FK,FM,FO,FR,GA,GB,GD,GE,GF,GG,GH,GI,GL,GM,GN,GOV,GP,GQ,GR,GS,GT,GU,GW,GY';
  cnlist += ',HK,HM,HN,HR,HT,HU,ID,IE,IL,IM,IN,INFO,INT,IO,IQ,IR,IS,IT,JE,JM,JO,JOBS,JP,KE,KG,KH,KI,KM,KN,KP,KR,KW,KY,KZ';
  cnlist += ',LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MIL,MK,ML,MM,MN,MO,MOBI,MP,MQ,MR,MS,MT,MU,MUSEUM,MV,MW,MX,MY,MZ,NA,NAME,NC,NE,NET,NF,NG,NI,NL,NO,NP,NR,NU,NZ';
  cnlist += ',OM,ORG,PA,PE,PF,PG,PH,PK,PL,PM,PN,PR,PRO,PS,PT,PW,PY,QA,RE,RO,RS,RU,RW,SA,SB,SC,SD,SE,SG,SH,SI,SJ,SK,SL,SM,SN,SO,SR,ST,SU,SV,SY,SZ';
  cnlist += ',TC,TD,TEL,TF,TG,TH,TJ,TK,TL,TM,TN,TO,TP,TR,TRAVEL,TT,TV,TW,TZ,UA,UG,GB,UK,UM,US,UY,UZ,VA,VC,VE,VG,VI,VN,VU,WF,WS,YE,YT,YU,ZA,ZM,ZW,中国,公司,网络,';
  var i = 0;
  var j = 0;
  var length = value.length;
  if (value.charAt(0) == '.') return false;
  if (value.charAt(length - 1) == '.') return false;
  if (value.charAt(0) == '-') return false;
  if (value.charAt(length - 1) == '-') return false;
  while (i < length) {
    if (value.charAt(i) == '.') j++;
    i++;
  }
  if (j == 0) return false;else {
    var domainObjArray = value.split(';');
    var reg = new RegExp(/^[0-9a-zA-Z-]{1,}$/);
    for (i = 0; i < domainObjArray.length; i++) {
      var domainElementsArray = domainObjArray[i].split('.');
      for (var j = 0; j < domainElementsArray.length; j++) {
        if (reg.test(domainElementsArray[j]) == false) return false;
        if (cnlist.indexOf(',' + domainElementsArray[domainElementsArray.length - 1].toUpperCase() + ',') <= 0) return false;
      }
    }
  }

  return true;
}, '网站域名输入有误,请检查！ ');

//====20120306加入域名检测函数相关//域名可以使中英文.
jQuery.validator.addMethod('isDomainEnglishChinese', function (value, element, param) {
  var cnlist = ',AC,AD,AE,AERO,AF,AG,AI,AL,AM,AN,AO,AQ,AR,ARPA,AS,ASIA,AT,AU,AW,AX,AZ';
  cnlist += ',BA,BB,BD,BE,BF,BG,BH,BI,BIZ,BJ,BL,BM,BN,BO,BR,BS,BT,BV,BW,BY,BZ';
  cnlist += ',CA,CAT,CC,CD,CF,CG,CH,CI,CK,CL,CM,CN,CO,COM,COOP,CR,CU,CV,CX,CY,CZ,DE,DJ,DK,DM,DO,DZ';
  cnlist += ',EC,EDU,EE,EG,EH,ER,ES,ET,EU,FI,FJ,FK,FM,FO,FR,GA,GB,GD,GE,GF,GG,GH,GI,GL,GM,GN,GOV,GP,GQ,GR,GS,GT,GU,GW,GY';
  cnlist += ',HK,HM,HN,HR,HT,HU,ID,IE,IL,IM,IN,INFO,INT,IO,IQ,IR,IS,IT,JE,JM,JO,JOBS,JP,KE,KG,KH,KI,KM,KN,KP,KR,KW,KY,KZ';
  cnlist += ',LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MIL,MK,ML,MM,MN,MO,MOBI,MP,MQ,MR,MS,MT,MU,MUSEUM,MV,MW,MX,MY,MZ,NA,NAME,NC,NE,NET,NF,NG,NI,NL,NO,NP,NR,NU,NZ';
  cnlist += ',OM,ORG,PA,PE,PF,PG,PH,PK,PL,PM,PN,PR,PRO,PS,PT,PW,PY,QA,RE,RO,RS,RU,RW,SA,SB,SC,SD,SE,SG,SH,SI,SJ,SK,SL,SM,SN,SO,SR,ST,SU,SV,SY,SZ';
  cnlist += ',TC,TD,TEL,TF,TG,TH,TJ,TK,TL,TM,TN,TO,TP,TR,TRAVEL,TT,TV,TW,TZ,UA,UG,GB,UK,UM,US,UY,UZ,VA,VC,VE,VG,VI,VN,VU,WF,WS,YE,YT,YU,ZA,ZM,ZW,中国,公司,网络,';
  var i = 0;
  var j = 0;
  var length = value.length;
  if (value.charAt(0) == '.') return false;
  if (value.charAt(length - 1) == '.') return false;
  if (value.charAt(0) == '-') return false;
  if (value.charAt(length - 1) == '-') return false;
  while (i < length) {
    if (value.charAt(i) == '.') j++;
    i++;
  }
  if (j == 0) return false;else {
    var domainObjArray = value.split(';');
    var reg = new RegExp(/^[\u4e00-\u9fa5-!a-zA-Z0-9]+$/);
    for (i = 0; i < domainObjArray.length; i++) {
      var domainElementsArray = domainObjArray[i].split('.');
      for (var j = 0; j < domainElementsArray.length; j++) {
        if (reg.test(domainElementsArray[j]) == false) return false;
        if (cnlist.indexOf(',' + domainElementsArray[domainElementsArray.length - 1].toUpperCase() + ',') <= 0) return false;
      }
    }
  }

  return true;
}, '网站域名输入有误,请检查！ ');

jQuery.validator.addMethod('isCommonDomain', function (value, element, param) {
  var cnlist = ',AC,AD,AE,AERO,AF,AG,AI,AL,AM,AN,AO,AQ,AR,ARPA,AS,ASIA,AT,AU,AW,AX,AZ';
  cnlist += ',BA,BB,BD,BE,BF,BG,BH,BI,BIZ,BJ,BL,BM,BN,BO,BR,BS,BT,BV,BW,BY,BZ';
  cnlist += ',CA,CAT,CC,CD,CF,CG,CH,CI,CK,CL,CM,CN,CO,COM,COOP,CR,CU,CV,CX,CY,CZ,DE,DJ,DK,DM,DO,DZ';
  cnlist += ',EC,EDU,EE,EG,EH,ER,ES,ET,EU,FI,FJ,FK,FM,FO,FR,GA,GB,GD,GE,GF,GG,GH,GI,GL,GM,GN,GOV,GP,GQ,GR,GS,GT,GU,GW,GY';
  cnlist += ',HK,HM,HN,HR,HT,HU,ID,IE,IL,IM,IN,INFO,INT,IO,IQ,IR,IS,IT,JE,JM,JO,JOBS,JP,KE,KG,KH,KI,KM,KN,KP,KR,KW,KY,KZ';
  cnlist += ',LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MF,MG,MH,MIL,MK,ML,MM,MN,MO,MOBI,MP,MQ,MR,MS,MT,MU,MUSEUM,MV,MW,MX,MY,MZ,NA,NAME,NC,NE,NET,NF,NG,NI,NL,NO,NP,NR,NU,NZ';
  cnlist += ',OM,ORG,PA,PE,PF,PG,PH,PK,PL,PM,PN,PR,PRO,PS,PT,PW,PY,QA,RE,RO,RS,RU,RW,SA,SB,SC,SD,SE,SG,SH,SI,SJ,SK,SL,SM,SN,SO,SR,ST,SU,SV,SY,SZ';
  cnlist += ',TC,TD,TEL,TF,TG,TH,TJ,TK,TL,TM,TN,TO,TP,TR,TRAVEL,TT,TV,TW,TZ,UA,UG,GB,UK,UM,US,UY,UZ,VA,VC,VE,VG,VI,VN,VU,WF,WS,YE,YT,YU,ZA,ZM,ZW,中国,公司,网络,';
  var i = 0;
  var j = 0;
  //默认加入www和cn结尾的模板前缀和后缀，主要是为了验证通用域名中间部分的合法性
  value = 'www.' + $.trim(value) + '.com';

  var length = value.length;
  if (value.charAt(0) == '.') return false;
  if (value.charAt(length - 1) == '.') return false;
  if (value.charAt(0) == '-') return false;
  if (value.charAt(length - 1) == '-') return false;
  while (i < length) {
    if (value.charAt(i) == '.') j++;
    i++;
  }
  if (j == 0) return false;else {
    var domainObjArray = value.split(';');
    var reg = new RegExp(/^[\u4e00-\u9fa5-!a-zA-Z0-9]+$/);
    for (i = 0; i < domainObjArray.length; i++) {
      var domainElementsArray = domainObjArray[i].split('.');
      for (var j = 0; j < domainElementsArray.length; j++) {
        if (reg.test(domainElementsArray[j]) == false) return false;
        if (cnlist.indexOf(',' + domainElementsArray[domainElementsArray.length - 1].toUpperCase() + ',') <= 0) return false;
      }
    }
  }

  return true;
}, '只允许输入中文字母数字!-号！ ');
//检测域名是否最多只输入三个域名；分隔并且不能重复
jQuery.validator.addMethod('domianWithInThree_unrepeat', function (value, element, param) {
  var domainArray = value.replace(/"；"/g, ';').split(';');
  if (domainArray.length > 3) {
    return false;
  }
  //代替旧版的same函数
  var str = value.replace(/"；"/g, ';');
  str = str.toUpperCase();
  var arr = str.split(';');
  for (var _i6 = 0; _i6 < arr.length; _i6++) {
    for (var j = _i6 + 1; j < arr.length; j++) {
      if (arr[_i6] == arr[j]) {
        return false;
      }
    }
  }
  return true;
}, '最多只输入三个域名；分隔并且不能重复');

//====================20120306结束========================
//domaintop
jQuery.validator.addMethod('domaintop', function (value, element, param) {
  if (this.optional(element)) return true;

  var exts = '.com.edu.gov.int.net.org.biz.info.pro.name.museum.coop.aero.idv.mobi.tel.asia.me.tv.公司.网络.中国.ac.ad.ae.af.ag.ah.ai.al';
  exts = exts + '.am.an.ao.aq.ar.as.at.au.aw.az.ba.bb.bd.be.bf.bg.bh.bi.bj.bm.bn.bo.br.bs.bt.bv.bw.by.bz.ca';
  exts = exts + '.cc.cd.cf.cg.ch.ci.ck.cl.cm.cn.co.cq.cr.cu.cv.cx.cy.cz.de.dj.dk.dm.do.dz.ec.ee.eg.eh.er.es';
  exts = exts + '.et.eu.fi.fj.fk.fm.fo.fr.ga.gd.ge.gf.gg.gh.gi.gl.gm.gn.gp.gq.gr.gs.gt.gu.gw.gx.gy.gz.ha.hb';
  exts = exts + '.he.hi.hk.hl.hm.hn.hr.ht.hu.id.ie.il.im.in.io.iq.ir.is.it.je.jl.jm.jo.jp.js.jx.ke.kg.kh.ki';
  exts = exts + '.km.kn.kp.kr.kw.ky.kz.la.lb.lc.li.lk.ln.lr.ls.lt.lu.lv.ly.ma.mc.md.mg.mh.mk.ml.mm.mn.mo.mp';
  exts = exts + '.mq.mr.ms.mt.mu.mv.mw.mx.my.mz.na.nc.ne.nf.ng.ni.nl.nm.no.np.nr.nu.nx.nz.om.pa.pe.pf.pg.ph';
  exts = exts + '.pk.pl.pm.pn.pr.ps.pt.pw.py.qa.qh.re.ro.ru.rw.sa.sb.sc.sd.se.sg.sh.si.sj.sk.sl.sm.sn.so.sr';
  exts = exts + '.st.sv.sx.sy.sz.tc.td.tf.tg.th.tj.tk.tl.tm.tn.to.tp.tr.tt.tv.tw.tz.ua.ug.uk.um.us.uy.uz.va';
  exts = exts + '.vc.ve.vg.vi.vn.vu.wf.ws.xj.xz.ye.yn.yt.yu.yr.za.zj.zm.zw';

  var valList = value.split('.');
  if (valList.length >= 4 || valList.length <= 1) return false;
  if (valList[0] == 'mail') return false;
  if (valList[0].indexOf('xn--') == 0) return false;

  if (valList.length == 2) {
    //后缀为顶级域名或则国别域名
    if (exts.indexOf('.' + valList[1]) == -1) return false;
  }
  if (valList.length == 3) {
    //二级域名
    if (exts.indexOf('.' + valList[1]) == -1) return false;else {
      if (valList[1] == '' || valList[2] == '') return false;
      if (valList[1].length > 2) {
        if (valList[2].length > 2 || exts.indexOf('.' + valList[2]) == -1) return false;
      }
      if (',cc,tv,me,cn,'.indexOf(valList[1]) > 0) //.cc .tv .me .hk .cn都是顶级域名 暂时后边不接任何其他根域名
        return false;
      if (exts.indexOf('.' + valList[2]) == -1) return false;
    }
  }
  return true;
}, '请输入正确的顶级域名！');

//====================20120306结束========================
//domainTwo 二级域名以下（包含二级域名）
jQuery.validator.addMethod('domainTwo', function (value, element, param) {
  if (this.optional(element)) return true;

  var exts = '.com.edu.gov.int.net.org.biz.info.pro.name.museum.coop.aero.idv.mobi.tel.asia.me.tv.公司.网络.中国.ac.ad.ae.af.ag.ah.ai.al';
  exts = exts + '.am.an.ao.aq.ar.as.at.au.aw.az.ba.bb.bd.be.bf.bg.bh.bi.bj.bm.bn.bo.br.bs.bt.bv.bw.by.bz.ca';
  exts = exts + '.cc.cd.cf.cg.ch.ci.ck.cl.cm.cn.co.cq.cr.cu.cv.cx.cy.cz.de.dj.dk.dm.do.dz.ec.ee.eg.eh.er.es';
  exts = exts + '.et.eu.fi.fj.fk.fm.fo.fr.ga.gd.ge.gf.gg.gh.gi.gl.gm.gn.gp.gq.gr.gs.gt.gu.gw.gx.gy.gz.ha.hb';
  exts = exts + '.he.hi.hk.hl.hm.hn.hr.ht.hu.id.ie.il.im.in.io.iq.ir.is.it.je.jl.jm.jo.jp.js.jx.ke.kg.kh.ki';
  exts = exts + '.km.kn.kp.kr.kw.ky.kz.la.lb.lc.li.lk.ln.lr.ls.lt.lu.lv.ly.ma.mc.md.mg.mh.mk.ml.mm.mn.mo.mp';
  exts = exts + '.mq.mr.ms.mt.mu.mv.mw.mx.my.mz.na.nc.ne.nf.ng.ni.nl.nm.no.np.nr.nu.nx.nz.om.pa.pe.pf.pg.ph';
  exts = exts + '.pk.pl.pm.pn.pr.ps.pt.pw.py.qa.qh.re.ro.ru.rw.sa.sb.sc.sd.se.sg.sh.si.sj.sk.sl.sm.sn.so.sr';
  exts = exts + '.st.sv.sx.sy.sz.tc.td.tf.tg.th.tj.tk.tl.tm.tn.to.tp.tr.tt.tv.tw.tz.ua.ug.uk.um.us.uy.uz.va';
  exts = exts + '.vc.ve.vg.vi.vn.vu.wf.ws.xj.xz.ye.yn.yt.yu.yr.za.zj.zm.zw';

  var valList = value.split('.');
  if (valList.length >= 5 || valList.length <= 1) return false;
  if (valList[0] == 'mail') return false;
  if (valList[0].indexOf('xn--') == 0) return false;

  if (valList.length == 2) {
    //后缀为顶级域名或则国别域名
    if (exts.indexOf('.' + valList[1]) == -1) return false;
  }
  if (valList.length == 3) {
    //二级域名或顶级
    if (exts.indexOf('.' + valList[2]) == -1) return false;
  }
  if (valList.length == 4) {
    //二级域名
    if (exts.indexOf('.' + valList[2]) == -1) return false;else {
      if (valList[2] == '' || valList[3] == '') return false;
      if (valList[2].length > 2) {
        if (valList[3].length > 2 || exts.indexOf('.' + valList[3]) == -1) return false;
      }
      if (',cc,tv,me,cn,'.indexOf(valList[2]) > 0) //.cc .tv .me .hk .cn都是顶级域名 暂时后边不接任何其他根域名
        return false;
      if (exts.indexOf('.' + valList[3]) == -1) return false;
    }
  }
  return true;
}, '请输入顶级域名或二级域名！');
// ip
jQuery.validator.addMethod('ip', function (value, element, param) {
  var reg = new RegExp(/((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)(\.((25[0-5])|(2[0-4]\d)|(1\d\d)|([1-9]\d)|\d)){3}/);
  return this.optional(element) || reg.test(value);
}, '请输入正确的IP地址！');

//非阿里云邮箱
jQuery.validator.addMethod('noAliyunEmail', function (value, element, param) {
  var arg = value.split('@');
  return this.optional(element) || arg[1] != 'aliyun.com';
}, '请输入非阿里云邮箱！');

//endDate
jQuery.validator.addMethod('endDate', function (value, element, param) {
  var startDate = $('#' + param).val();
  return startDate <= value;
}, '结束日期必须大于开始日期!');

// 身份证
jQuery.validator.addMethod('personalid', function (value, element, param) {
  var reg = new RegExp(/^(\d{6})(18|19|20)?(\d{2})([01]\d)([0123]\d)(\d{3})(\d|X|x)?$/);
  return this.optional(element) || reg.test(value);
}, '请输入正确身份证号码！');

// 国家号码
jQuery.validator.addMethod('countryCode', function (value, element, param) {
  var str = '\'244\',\'93\',\'355\',\'213\',\'376\',\'1264\',\'1268\',\'54\',\'374\',\'247\',\'61\',\'43\',\'994\',\'1242\',\'973\',\'880\',\'1246\',\'375\',\'32\',\'501\',\'229\',\'1441\',\'591\',\'267\',\'55\',\'673\',\'359\',\'226\',\'95\',\'257\',\'237\',\'1\',\'1345\',\'236\',\'235\',\'56\',\'86\',\'57\',\'242\',\'682\',\'506\',\'53\',\'357\',\'420\',\'45\',\'253\',\'1890\',\'593\',\'20\',\'503\',\'372\',\'251\',\'679\',\'358\',\'33\',\'594\',\'241\',\'220\',\'995\',\'49\',\'233\',\'350\',\'30\',\'1809\',\'1671\',\'502\',\'224\',\'592\',\'509\',\'504\',\'852\',\'36\',\'354\',\'91\',\'62\',\'98\',\'964\',\'353\',\'972\',\'39\',\'225\',\'1876\',\'81\',\'962\',\'855\',\'327\',\'254\',\'82\',\'965\',\'331\',\'856\',\'371\',\'961\',\'266\',\'231\',\'218\',\'423\',\'370\',\'352\',\'853\',\'261\',\'265\',\'60\',\'960\',\'223\',\'356\',\'1670\',\'596\',\'230\',\'52\',\'373\',\'377\',\'976\',\'1664\',\'212\',\'258\',\'264\',\'674\',\'977\',\'599\',\'31\',\'64\',\'505\',\'227\',\'234\',\'850\',\'47\',\'968\',\'92\',\'507\',\'675\',\'595\',\'51\',\'63\',\'48\',\'689\',\'351\',\'1787\',\'974\',\'262\',\'40\',\'7\',\'1758\',\'1784\',\'684\',\'685\',\'378\',\'239\',\'966\',\'221\',\'248\',\'232\',\'65\',\'421\',\'386\',\'677\',\'252\',\'27\',\'34\',\'94\',\'1758\',\'1784\',\'249\',\'597\',\'268\',\'46\',\'41\',\'963\',\'886\',\'992\',\'255\',\'66\',\'228\',\'676\',\'1809\',\'216\',\'90\',\'993\',\'256\',\'380\',\'971\',\'44\',\'598\',\'233\',\'58\',\'84\',\'967\',\'381\',\'263\',\'243\',\'260\'';
  var reg = '\'' + value + '\'';
  return str.search(reg) > -1;
}, '请输入86或者正确的国家区号！');

//通用网址通信信息限制
jQuery.validator.addMethod('tongyongMenu', function (value, element, param) {
  var cMenu = ['广东', '广州', '深圳', '珠海', '汕头', '韶关', '河源', '梅州', '惠州', '汕尾', '东莞', '中山', '佛山', '阳江', '湛江', '茂名', '肇庆', '清远', '潮州', '番禺', '潮洲', '花都', '惠洲', '大亚湾', '连州', '清新', '潮安', '普宁', '揭东', '顺德', '澳门', '香港'];
  for (var _i7 = 0; _i7 < cMenu.length; _i7++) {
    if (value.indexOf(cMenu[_i7]) > -1) {
      return false;
    }
  }
  return true;
}, '对不起，包含受限信息，请参见提示2');

//通用网址电话区号限制
jQuery.validator.addMethod('tongyongTelCode', function (value, element, param) {
  var telCode = ['020', '0660', '0661', '0662', '0663', '0668', '0750', '0751', '0752', '0753', '0754', '0755', '0756', '0757', '0758', '0759', '0760', '0762', '0763', '0765', '0766', '0768', '0769', '853', '00853', '852', '00852'];
  for (var _i8 = 0; _i8 < telCode.length; _i8++) {
    if (value.indexOf(telCode[_i8]) > -1) {
      return false;
    }
  }
  return true;
}, '对不起，包含受限信息，请参见提示2');

//通用网址邮政编码限制
jQuery.validator.addMethod('tongyongPostCode', function (value, element, param) {
  var postCode = ['510000', '511400', '510800', '510900', '511300', '516600', '516400', '516700', '516500', '515100', '529500', '529600', '529500', '529800', '515500', '515500', '515200', '515400', '515300', '525000', '525100', '525200', '525300', '525400', '529000', '529200', '529300', '529400', '529100', '529700', '512000', '512100', '512600', '511100', '512500', '512300', '512400', '512700', '512200', '516000', '526300', '516200', '516100', '511200', '514000', '514000', '514100', '514200', '514300', '514400', '514500', '514600', '515000', '515800', '515900', '518000', '518100', '519000', '519100', '528000', '528200', '528500', '528100', '526000', '526100', '526200', '526400', '526500', '526600', '526300', '524000', '524300', '524400', '524500', '524100', '524200', '528400', '517000', '517100', '517200', '517300', '517400', '511500', '511600', '513000', '513200', '513100', '513300', '513400', '528300', '527300', '527200', '527100', '527400', '515600', '515600', '515700', '511700', '999077', '999078'];
  for (var _i9 = 0; _i9 < postCode.length; _i9++) {
    if (value.indexOf(postCode[_i9]) > -1) {
      return false;
    }
  }
  return true;
}, '对不起，包含受限信息，请参见提示2');

//弱密码校验--单引号空格等特别字符判断
jQuery.validator.addMethod('password_especially_character', function (value, element) {
  var reg = new RegExp(/[\s\"\”\“\‘\’\']/);
  var flag = reg.test(value);
  if (flag) {
    return false;
  } else {
    return true;
  }
}, '密码不能包含非法字符');

//弱密码校验--单一字符组成的字符串判断,如：aaaaaaaa
jQuery.validator.addMethod('password_same_character', function (value, element) {
  var reg = new RegExp(/^(.)\1*$/);
  return !reg.test(value);
}, '密码不能设置为同一字符');

//弱密码校验--单一种类字符判断
jQuery.validator.addMethod('password_single_character', function (value, element) {
  var number_modes = 0;
  var english_modes = 0;
  var punctuation_modes = 0;
  for (i = 0; i < value.length; i++) {
    //密码模式
    modes = value.charCodeAt(i);
    if (modes >= 48 && modes <= 57) //数字
      number_modes = 1;else if (modes >= 65 && modes <= 90) //大写
      english_modes = 1;else if (modes >= 97 && modes <= 122) //小写
      english_modes = 1;else punctuation_modes = 1;
  }
  if (number_modes + english_modes + punctuation_modes > 1) {
    return true;
  } else {
    return false;
  }
}, '密码不能设置为纯数字、字母或符号');

//shj
jQuery.validator.addMethod('isEmptyNotTrim', function (value, element, param) {

  var target = $('*.[name=' + param[0] + ']');
  if ($('input:[name=' + param[0] + ']').size() > 1) {
    target = $('input:checked:[name=' + param[0] + ']');
  }

  $(target).unbind('.validate-requiredif').bind('blur.validate-requiredif', function () {
    $(element).valid();
  });

  if ($(target).val() != param[1]) return true;

  switch (element.nodeName.toLowerCase()) {
    case 'select':
      // could be an array for select-multiple or a string, both are fine this way
      var val = $(element).val();
      return val && val.length > 0;
    case 'input':
      if (this.checkable(element)) return this.getLength(value, element) > 0;
    default:
      return value.length > 0;
  }
}, '必须填写该项！');

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(43);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(62);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(44), __esModule: true };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(45);
__webpack_require__(58);
module.exports = __webpack_require__(23).f('iterator');


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(46)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(26)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(12);
var defined = __webpack_require__(13);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(48);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(31);
var descriptor = __webpack_require__(10);
var setToStringTag = __webpack_require__(22);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(2)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(3);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(18);

module.exports = __webpack_require__(4) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(33);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(5);
var toLength = __webpack_require__(53);
var toAbsoluteIndex = __webpack_require__(54);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(12);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(12);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;
module.exports = document && document.documentElement;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(1);
var toObject = __webpack_require__(57);
var IE_PROTO = __webpack_require__(19)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(13);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(59);
var global = __webpack_require__(0);
var hide = __webpack_require__(2);
var Iterators = __webpack_require__(17);
var TO_STRING_TAG = __webpack_require__(6)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(60);
var step = __webpack_require__(61);
var Iterators = __webpack_require__(17);
var toIObject = __webpack_require__(5);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(26)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(63), __esModule: true };

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
__webpack_require__(70);
__webpack_require__(71);
__webpack_require__(72);
module.exports = __webpack_require__(15).Symbol;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(0);
var has = __webpack_require__(1);
var DESCRIPTORS = __webpack_require__(4);
var $export = __webpack_require__(27);
var redefine = __webpack_require__(30);
var META = __webpack_require__(65).KEY;
var $fails = __webpack_require__(9);
var shared = __webpack_require__(20);
var setToStringTag = __webpack_require__(22);
var uid = __webpack_require__(11);
var wks = __webpack_require__(6);
var wksExt = __webpack_require__(23);
var wksDefine = __webpack_require__(24);
var enumKeys = __webpack_require__(66);
var isArray = __webpack_require__(67);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(7);
var toIObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(16);
var createDesc = __webpack_require__(10);
var _create = __webpack_require__(31);
var gOPNExt = __webpack_require__(68);
var $GOPD = __webpack_require__(69);
var $DP = __webpack_require__(3);
var $keys = __webpack_require__(18);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(35).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(25).f = $propertyIsEnumerable;
  __webpack_require__(34).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(14)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(2)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(11)('meta');
var isObject = __webpack_require__(7);
var has = __webpack_require__(1);
var setDesc = __webpack_require__(3).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(9)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(18);
var gOPS = __webpack_require__(34);
var pIE = __webpack_require__(25);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(33);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(5);
var gOPN = __webpack_require__(35).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(25);
var createDesc = __webpack_require__(10);
var toIObject = __webpack_require__(5);
var toPrimitive = __webpack_require__(16);
var has = __webpack_require__(1);
var IE8_DOM_DEFINE = __webpack_require__(28);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(4) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {



/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)('asyncIterator');


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(24)('observable');


/***/ }),
/* 73 */
/***/ (function(module, exports) {

if (jQuery) {
  jQuery.browser = {};
  (function () {
    jQuery.browser.msie = false;
    jQuery.browser.version = 0;
    if (navigator.userAgent.match(/MSIE ([0-9]+)./)) {
      jQuery.browser.msie = true;
      jQuery.browser.version = RegExp.$1;
    }
  })();
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 引入样式
__webpack_require__(75);
// 加载基类
var DblClass = __webpack_require__(36);
// 加载弹框组件
var dbl_dialog = __webpack_require__(37);
// 表单组件
var creatFormList = __webpack_require__(38);
//URL常量
var urls = {
  ajaxUrl: '//' + contactTemplate.baseUri + '/contacttemplate/contactTmplApi/queryContactTemplateList.json',
  ajaxQueryUrl: '//' + contactTemplate.queryUri + '/ContactTemplateApi/queryContactTemplateExt.jsonp',
  ajaxSaveTemUrl: '//' + contactTemplate.queryUri + '/ContactTemplateApi/saveContactTemplateExt.jsonp',
  ajaxViewUrl: '//' + contactTemplate.baseUri + '/contacttemplate/contactTmplApi/queryContactTemplateInfo.json',
  ajaxSaveUrl: '//' + contactTemplate.baseUri + '/contacttemplate/contactTmplApi/saveContactTemplate.json',
  ajaxEditUrl: '//' + contactTemplate.baseUri + '/contacttemplate/contactTmplApi/saveContactTemplate.json',
  ajaxTplNumURL: '//' + contactTemplate.baseUri + '/contacttemplate/contactTmplApi/queryContactTemplateCount.json'
};
// console.log('urls', urls);

var infoList = DblClass.createClass({
  // 模板
  tpl: __webpack_require__(97),
  // 构造函数
  constructor: function constructor(data) {
    // 合并数据
    this.extendCfg(data);
    // 渲染元素 var html = require('./list.ejs'); $('#domain_contact_list').html(html);
    // 绑定事件
    this.__bindEvents__(this.events);
  },
  // 扩展配置
  extendCfg: function extendCfg(data) {
    var data = data || {};
    data = $.extend(true, {}, urls, this.config, data);
    this.config = data;
    if (this.config.selectId) {
      this.el = $('#' + this.config.selectId);
    }
    this.foldClose = !this.config.defaultFoldList;
  },
  // 绑定事件
  events: {
    // 'click .add-template': 'addTemplate',
    'click .fold-list': 'foldList',
    'click .template-id': 'selectDefaultTmp',
    'click .view-detail': 'viewDetail',
    'click .current-page': 'pagination'
  },
  // 保存或编辑信息模板
  saveOrUpdateTemplate: function saveOrUpdateTemplate(formObj) {
    var self = this;
    var template = formObj.getFormData();
    var statues = ["FAILED", "SUCCEED", "NONAUDIT", "AUDITING"];
    var saveobj = {
      "zhCity": template.c_city,
      "createTime": template.createTime,
      "registrantProfileId": template.id,
      "zhAddress": template.c_venu,
      "emailVerificationStatus": template.emailVerificationStatus,
      "updateTime": template.updateTime,
      "defaultRegistrantProfile": template.defaultTemplate,
      "telArea": template.telArea,
      "zhProvince": template.c_province,
      "registrantType": template.regType,
      "city": template.e_city,
      "country": template.c_country,
      "registrantOrganization": template.e_company,
      "postalCode": template.postalcode,
      "registrantName": template.e_name,
      "address": template.e_venu,
      "email": template.email,
      "zhRegistrantOrganization": template.c_company,
      "province": template.e_province,
      "telephone": template.telMain,
      "zhRegistrantName": template.c_name,
      "realNameStatus": statues[template.auditStatus]
      // template.validation = 1;
      // let url;
      // if (!template.id) {
      //   url = self.config.ajaxSaveUrl;
      // } else {
      //   url = self.config.ajaxEditUrl;
      // }
    };self.ajaxRequest({ url: self.config.ajaxSaveTemUrl, type: 'post', data: saveobj }).then(function (data) {
      // 显示返回结果
      if (data.code != '200') {
        if (data.code == '150001') {
          alert('亲，超过信息模版数量限制，请删除或修改已创建信息模版。');
        } else {
          alert('保存域名信息模板错误，请重试');
        }
        return;
      }
      // let id;
      // if (!template.id) {
      //   id = data.data;
      //   self
      //     .ajaxRequest({
      //       url: self.config.ajaxViewUrl,
      //       type: 'get',
      //       data: {
      //         id: id
      //       }
      //     })
      //     .then(function (data) {
      //       // 显示返回结果
      //       if (data.code != '200') {
      //         alert('查询域名信息模板错误，请重试');
      //         return;
      //       }
      //       let template = data.data;
      //       if (self.config.filterStatus) {
      //         template = Boolean(template.auditStatus && template.auditStatus == 1) || false;
      //       }
      //       if (template) {
      //         if (!self[self.regType].templates) {
      //           self[self.regType].templates = [];
      //         }
      //         self[self.regType]
      //           .templates
      //           .splice(0, 0, template);
      //         //self[self.regType].selectTemplate = template;
      //         self.render(self.regType);
      //       }
      //     });
      // } else {
      //   id = template.id;
      //   self
      //     .ajaxRequest({
      //       url: self.config.ajaxViewUrl,
      //       type: 'get',
      //       data: {
      //         id: id
      //       }
      //     })
      //     .then(function (data) {
      //       // 显示返回结果
      //       if (data.code != '200') {
      //         alert('查询域名信息模板错误，请重试');
      //         return;
      //       }
      //       let newtemplate = data.data;
      //       if (newtemplate) {
      //         for (let i = 0; i < self[self.regType].templates.length; i++) {
      //           let template = self[self.regType].templates[i];
      //           if (newtemplate.id == template.id) {
      //             self[self.regType].templates[i] = newtemplate;
      //           } else if (newtemplate.defaultTemplate == '1' && newtemplate.regType == template.regType && template.defaultTemplate == '1') {
      //             template.defaultTemplate == 0;
      //           }
      //         }
      //         //self[self.regType].selectTemplate = newtemplate;
      //         self.render(self.regType);
      //       }
      //     });
      // }
    }).fail(function () {
      alert('保存域名信息模板错误，请重试');
    });
  },
  defaultAjaxReq: {
    url: null,
    type: 'post',
    dataType: 'jsonp',
    async: false,
    jsonp: 'callback',
    data: null
  },
  // 异步请求方法
  ajaxRequest: function ajaxRequest(ajaxReq) {
    ajaxReq = $.extend(true, {}, this.defaultAjaxReq, ajaxReq);
    var ajaxOptions = $.ajax(ajaxReq);
    return $.when(ajaxOptions);
  },
  // 添加模板方法
  addTemplate: function addTemplate(e) {
    // 表单模板对象
    var self = this;
    infoList.getContactTemplateCount1().success(function (count) {
      if (count < (self.config.templateLimit || 500)) {
        var regTypeVal = self.regType;
        if (regTypeVal != 1 && regTypeVal != 2) {
          regTypeVal = 1;
        }
        var formObj = new creatFormList({ selectId: 'addTemplate_contactForm', displayMode: 1, regType: regTypeVal });
        formObj.popup({
          callback: function callback(obj) {
            return self.saveOrUpdateTemplate(obj);
          }
        });
      } else {
        alert('亲，超过信息模版数量限制，请删除或修改已创建信息模版。');
        // alert("亲，最多创建" + (self.config.templateLimit || 20) +
        // "个域名信息模版哟，请删除或修改已创建信息模版。");
      }
    });
  },
  // 收起方法
  foldClose: true,
  foldList: function foldList(e) {
    var self = this;
    var obj = $(e.target);
    this.foldClose = !this.foldClose;
    this.render(this.regType);
  },
  // 查看详情方法
  viewDetail: function viewDetail(e) {
    var self = this;
    var id = $(e.target).attr('data-id');
    self.ajaxRequest({
      url: self.config.ajaxQueryUrl,
      type: 'get',
      data: {
        registrantProfileId: id
      }
    }).then(function (data) {
      // 显示返回结果
      if (data.code != '200') {
        alert('查询域名信息模板错误，请重试');
        return;
      }
      console.log(data);
      var template = data.data.registrantProfiles[0];
      var status = {
        "FAILED": 0,
        "SUCCEED": 1,
        "NONAUDIT": 2,
        "AUDITING": 3
      };
      var newobj = {
        c_city: template.zhCity,
        c_company: template.zhRegistrantOrganization,
        c_country: template.country,
        c_name: template.zhRegistrantName,
        c_province: template.zhProvince,
        c_venu: template.zhAddress,
        createTime: template.createTime,
        defaultTemplate: template.defaultRegistrantProfile,
        e_city: template.city,
        e_company: template.registrantOrganization,
        e_name: template.registrantName,
        e_province: template.province,
        e_venu: template.address,
        email: template.email,
        emailVerificationStatus: template.emailVerificationStatus,
        id: template.registrantProfileId,
        postalcode: template.postalCode,
        regType: template.registrantType,
        telArea: template.telArea,
        telMain: template.telephone,
        updateTime: template.updateTime,
        auditStatus: status[template.realNameStatus]
      };
      var formObj = new creatFormList({ selectId: 'viewDetail_contactForm', displayMode: 1, regType: self.regType });
      formObj.popup({
        data: newobj,
        callback: function callback(obj) {
          return self.saveOrUpdateTemplate(obj);
        }
      });
    }).fail(function () {
      alert('查询域名信息模板错误，请重试');
    });

    // var template = self.getContactTemplateFromList(self.regType,id); var formObj =
    // new
    // creatFormList({selectId:"viewDetail_contactForm",displayMode:1,regType:self.re
    // gType}); formObj.popup({data:template,callback:function(obj){return
    // self.saveOrUpdateTemplate(obj);}});
  },
  getContactTemplateFromList: function getContactTemplateFromList(regType, id) {
    var self = this;
    if (self.regType && self[self.regType] && self[self.regType].templates) {
      for (var i = 0; i < self[self.regType].templates.length; i++) {
        var template = self[self.regType].templates[i];
        if (id == template.id) {
          return template;
        }
      }
    }
  },
  getContactTemplateIndexFromList: function getContactTemplateIndexFromList(regType, id) {
    var self = this;
    if (self.regType && self[self.regType] && self[self.regType].templates) {
      for (var i = 0; i < self[self.regType].templates.length; i++) {
        var template = self[self.regType].templates[i];
        if (id == template.id) {
          return i;
        }
      }
    }
  },
  // 选择默认模板
  selectDefaultTmp: function selectDefaultTmp(e) {
    var id = $(e.target).val();
    var self = this;
    for (var i = 0; i < self[self.regType].templates.length; i++) {
      var template = self[self.regType].templates[i];
      if (id == template.registrantProfileId) {
        var popstatus = {
          "FAILED": 0,
          "SUCCEED": 1,
          "NONAUDIT": 2,
          "AUDITING": 3
        };
        var selectobj = {
          c_city: template.zhCity,
          c_company: template.zhRegistrantOrganization,
          c_country: template.country,
          c_name: template.zhRegistrantName,
          c_province: template.zhProvince,
          c_venu: template.zhAddress,
          createTime: template.createTime,
          defaultTemplate: template.defaultRegistrantProfile,
          e_city: template.city,
          e_company: template.registrantOrganization,
          e_name: template.registrantName,
          e_province: template.province,
          e_venu: template.address,
          email: template.email,
          emailVerificationStatus: template.emailVerificationStatus,
          id: template.registrantProfileId,
          postalcode: template.postalCode,
          regType: template.registrantType,
          telArea: template.telArea,
          telMain: template.telephone,
          updateTime: template.updateTime,
          auditStatus: popstatus[template.realNameStatus]
        };
        self[self.regType].selectTemplate = selectobj;
        if (self.config.selectContactTemplateCallback) {
          self.config.selectContactTemplateCallback(selectobj);
        }
        break;
      }
    }
  },
  onSelectContactTemplate: function onSelectContactTemplate(callback) {
    if (callback && typeof callback === 'function') {
      this.config.selectContactTemplateCallback = callback;
    }
  },
  // 默认配置
  config: {
    selectId: '',
    defaultSelect: true,
    defaultFoldList: false,
    selectContactTemplateCallback: function selectContactTemplateCallback(contactTemplate) {}
  },
  // 分页
  pagination: function pagination(e) {
    var self = this;
    var nextpage = $(e.target).attr("value");
    self.render(self.regType, nextpage);
  },
  // 渲染元素
  render: function render(regType, nextpage) {
    // debugger;
    // console.log('list render ' + regType);
    var self = this;
    // loading
    if (!regType && !self.regType) {
      return;
    } else if (regType) {
      self.regType = regType;
    }
    if (!self[self.regType] || nextpage) {
      // ajax 配置
      var ajaxReq = {};
      if (self.config.filterStatus) {
        ajaxReq = {
          url: self.config.ajaxQueryUrl,
          type: 'get',
          data: nextpage ? {
            currentPage: nextpage,
            pageSize: 10,
            realNameStatus: 'SUCCEED',
            registrantType: self.regType
          } : {
            currentPage: 1,
            pageSize: 10,
            realNameStatus: 'SUCCEED',
            registrantType: self.regType
          }
        };
      } else {
        ajaxReq = {
          url: self.config.ajaxQueryUrl,
          type: 'get',
          data: nextpage ? {
            currentPage: nextpage,
            pageSize: 10,
            registrantType: self.regType
          } : {
            currentPage: 1,
            pageSize: 10,
            registrantType: self.regType
          }
        };
      }
      // jsonp 获取数据
      self.ajaxRequest(ajaxReq).then(function (data) {
        // 遍历默认模板
        var templates = data.data.registrantProfiles || [];
        var totalpage = data.data.totalPageNum || 0;
        var currentpage = data.data.currentPageNum || 1;
        // console.log(templates);
        //支持模板信息认证状态筛选
        if (self.config.filterStatus) {
          templates = templates.filter(function (info) {
            return info.realNameStatus && info.realNameStatus == 'SUCCEED';
          });
        }

        var defaultTemplate = null;
        if (self.config.defaultSelect && (self.regType == 1 || self.regType == 2)) {
          for (var i in templates) {
            if (templates[i].defaultRegistrantProfile == true) {
              defaultTemplate = templates[i];
              break;
            }
          }
        }
        self[self.regType] = {
          templates: templates,
          selectTemplate: null,
          totalpage: totalpage,
          currentpage: currentpage
        };
        // 模板绑定
        if (self[self.regType]) {
          var renderParams = {};
          renderParams.templates = self[self.regType].templates;
          renderParams.totalpage = self[self.regType].totalpage;
          renderParams.currentpage = self[self.regType].currentpage;
          renderParams.selectTemplate = self[self.regType].selectTemplate;
          renderParams.foldClose = self.foldClose;
          renderParams.config = self.config;
          var html = self.tpl(renderParams);
          // 渲染
          self.el.html(html);
          if (self.config.selectContactTemplateCallback && self[self.regType].selectTemplate) {
            self.config.selectContactTemplateCallback(self[self.regType].selectTemplate);
          }
        }
      });
    } else {
      var renderParams = {};
      renderParams.templates = self[self.regType].templates;
      renderParams.totalpage = self[self.regType].totalpage;
      renderParams.currentpage = self[self.regType].currentpage;
      renderParams.selectTemplate = self[self.regType].selectTemplate;
      renderParams.foldClose = self.foldClose;
      renderParams.config = self.config;
      var html = self.tpl(renderParams);
      // 渲染
      self.el.html(html);
      if (self.config.selectContactTemplateCallback && self[self.regType].selectTemplate) {
        self.config.selectContactTemplateCallback(self[self.regType].selectTemplate);
      }
    }
  },
  regType: null,
  isSelectContactTemplate: function isSelectContactTemplate() {
    return this.regType && this[this.regType] && this[this.regType].selectTemplate;
  },
  getSelectContactTemplate: function getSelectContactTemplate() {
    if (this.isSelectContactTemplate()) {
      return this[this.regType].selectTemplate;
    }
  }
});

//分类信息完整的模板
infoList.getContactTemplateCount = function (regType, callback) {
  var jqxhr = $.ajax({
    url: urls.ajaxTplNumURL,
    type: 'get',
    dataType: 'jsonp',
    async: false,
    cache: false,
    jsonp: 'callback',
    data: regType === undefined || regType == 3 ? {
      validation: 1
    } : {
      regType: regType,
      validation: 1
    }
  });
  var retObj = {
    success: function success(callback) {
      jqxhr.done(function (data) {
        if (data.code == 200) {
          callback(data.data);
        }
      });
    }
  };
  return retObj;
};

//所有模板
infoList.getContactTemplateCount1 = function (regType, callback) {

  var jqxhr = $.ajax({
    url: urls.ajaxTplNumURL,
    type: 'get',
    dataType: 'jsonp',
    async: false,
    cache: false,
    jsonp: 'callback'
  });
  var retObj = {
    success: function success(callback) {
      jqxhr.done(function (data) {
        if (data.code == 200) {
          callback(data.data);
        }
      });
    }
  };
  return retObj;
};
module.exports = infoList;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

/***
  Events
  ****/
  var eventSplitter = /^(\S+)\s*(.*)$/,
   __slice = [].slice,
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor; child.__super__ = parent.prototype; return child; },
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  window.__dblEvents_20160101__ =  window.__dblEvents_20160101__ || {}; 
  var calls = window.__dblEvents_20160101__;
  var Events = {
    on: function(ev, callback) {
      var evs, name, _i, _len;
      evs = ev.split(' ');
      var _calls = calls._callbacks || (calls._callbacks = {});
      for (_i = 0, _len = evs.length; _i < _len; _i++) {
        name = evs[_i];
        _calls[name] || (_calls[name] = []);
        _calls[name].push(callback);
      }
      return this;
    },
    one: function(ev, callback) {
      return this.on(ev, function() {
        this.un(ev, arguments.callee);
        return callback.apply(this, arguments);
      });
    },
    emit: function() {
      var args, callback, ev, list, _i, _len, _ref;
      args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
      ev = args.shift();
      list = (_ref = calls._callbacks) != null ? _ref[ev] : void 0;
      if (!list) {
        return;
      }
      for (_i = 0, _len = list.length; _i < _len; _i++) {
        callback = list[_i];
        if (callback.apply(this, args) === false) {
          break;
        }
      }
      return true;
    },
    un: function(ev, callback) {
      var cb, i, list, _i, _len, _ref;
      if (!ev) {
        this._callbacks = {};
        return this;
      }
      list = (_ref = calls._callbacks) != null ? _ref[ev] : void 0;
      if (!list) {
        return this;
      }
      if (!callback) {
        delete calls._callbacks[ev];
        return this;
      }
      for (i = _i = 0, _len = list.length; _i < _len; i = ++_i) {
        cb = list[i];
        if (!(cb === callback)) {
          continue;
        }
        list = list.slice();
        list.splice(i, 1);
        calls._callbacks[ev] = list;
        break;
      }
      return this;
    }
  };

  module.exports = Events;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

(function($){
    var _count = 0;
    var _isIE6 = !('minWidth' in $('html')[0].style);
    var _isFixed = !_isIE6;


    function Popup () {

        this.destroyed = false;


        this.__popup = $('<div />')
        /*使用 <dialog /> 元素可能导致 z-index 永远置顶的问题(chrome)*/
        .css({
            display: 'none',
            position: 'absolute',
            /*
            left: 0,
            top: 0,
            bottom: 'auto',
            right: 'auto',
            margin: 0,
            padding: 0,
            border: '0 none',
            background: 'transparent'
            */
            outline: 0
        })
        .attr('tabindex', '-1')
        .html(this.innerHTML)
        .appendTo('body');


        this.__backdrop = this.__mask = $('<div />')
        .css({
            opacity: .7,
            background: '#000'
        });


        // 使用 HTMLElement 作为外部接口使用，而不是 jquery 对象
        // 统一的接口利于未来 Popup 移植到其他 DOM 库中
        this.node = this.__popup[0];
        this.backdrop = this.__backdrop[0];

        _count ++;
    }


    $.extend(Popup.prototype, {
        
        /**
         * 初始化完毕事件，在 show()、showModal() 执行
         * @name Popup.prototype.onshow
         * @event
         */

        /**
         * 关闭事件，在 close() 执行
         * @name Popup.prototype.onclose
         * @event
         */

        /**
         * 销毁前事件，在 remove() 前执行
         * @name Popup.prototype.onbeforeremove
         * @event
         */

        /**
         * 销毁事件，在 remove() 执行
         * @name Popup.prototype.onremove
         * @event
         */

        /**
         * 重置事件，在 reset() 执行
         * @name Popup.prototype.onreset
         * @event
         */

        /**
         * 焦点事件，在 foucs() 执行
         * @name Popup.prototype.onfocus
         * @event
         */

        /**
         * 失焦事件，在 blur() 执行
         * @name Popup.prototype.onblur
         * @event
         */

        /** 浮层 DOM 素节点[*] */
        node: null,

        /** 遮罩 DOM 节点[*] */
        backdrop: null,

        /** 是否开启固定定位[*] */
        fixed: false,

        /** 判断对话框是否删除[*] */
        destroyed: true,

        /** 判断对话框是否显示 */
        open: false,

        /** close 返回值 */
        returnValue: '',

        /** 是否自动聚焦 */
        autofocus: true,

        /** 对齐方式[*] */
        align: 'bottom left',

        /** 内部的 HTML 字符串 */
        innerHTML: '',

        /** CSS 类名 */
        className: 'dbl-popup',

        /**
         * 显示浮层
         * @param   {HTMLElement, Event}  指定位置（可选）
         */
        show: function (anchor) {

            if (this.destroyed) {
                return this;
            }

            var that = this;
            var popup = this.__popup;
            var backdrop = this.__backdrop;

            this.__activeElement = this.__getActive();

            this.open = true;
            this.follow = anchor || this.follow;


            // 初始化 show 方法
            if (!this.__ready) {

                popup
                .addClass(this.className)
                .attr('role', this.modal ? 'alertdialog' : 'dialog')
                .css('position', this.fixed ? 'fixed' : 'absolute');

                if (!_isIE6) {
                    $(window).on('resize', $.proxy(this.reset, this));
                }

                // 模态浮层的遮罩
                if (this.modal) {
                    var backdropCss = {
                        position: 'fixed',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                        overflow: 'hidden',
                        userSelect: 'none',
                        zIndex: this.zIndex || Popup.zIndex
                    };


                    popup.addClass(this.className + '-modal');


                    if (!_isFixed) {
                        $.extend(backdropCss, {
                            position: 'absolute',
                            width: $(window).width() + 'px',
                            height: $(document).height() + 'px'
                        });
                    }


                    backdrop
                    .css(backdropCss)
                    .attr({tabindex: '0'})
                    .on('focus', $.proxy(this.focus, this));

                    // 锁定 tab 的焦点操作
                    this.__mask = backdrop
                    .clone(true)
                    .attr('style', '')
                    .insertAfter(popup);

                    backdrop
                    .addClass(this.className + '-backdrop')
                    .insertBefore(popup);

                    this.__ready = true;
                }


                if (!popup.html()) {
                    popup.html(this.innerHTML);
                }
            }


            popup
            .addClass(this.className + '-show')
            .show();

            backdrop.show();


            this.reset().focus();
            this.__dispatchEvent('show');

            return this;
        },


        /** 显示模态浮层。参数参见 show() */
        showModal: function () {
            this.modal = true;
            return this.show.apply(this, arguments);
        },
        
        
        /** 关闭浮层 */
        close: function (result) {
            
            if (!this.destroyed && this.open) {
                
                if (result !== undefined) {
                    this.returnValue = result;
                }
                
                this.__popup.hide().removeClass(this.className + '-show');
                this.__backdrop.hide();
                this.open = false;
                this.blur();// 恢复焦点，照顾键盘操作的用户
                this.__dispatchEvent('close');
            }
        
            return this;
        },


        /** 销毁浮层 */
        remove: function () {

            if (this.destroyed) {
                return this;
            }

            this.__dispatchEvent('beforeremove');
            
            if (Popup.current === this) {
                Popup.current = null;
            }


            // 从 DOM 中移除节点
            this.__popup.remove();
            this.__backdrop.remove();
            this.__mask.remove();


            if (!_isIE6) {
                $(window).off('resize', this.reset);
            }


            this.__dispatchEvent('remove');

            for (var i in this) {
                delete this[i];
            }

            return this;
        },


        /** 重置位置 */
        reset: function () {

            var elem = this.follow;

            if (elem) {
                this.__follow(elem);
            } else {
                this.__center();
            }

            this.__dispatchEvent('reset');

            return this;
        },


        /** 让浮层获取焦点 */
        focus: function () {

            var node = this.node;
            var popup = this.__popup;
            var current = Popup.current;
            var index = this.zIndex = Popup.zIndex ++;

            if (current && current !== this) {
                current.blur(false);
            }

            // 检查焦点是否在浮层里面
            if (!$.contains(node, this.__getActive())) {
                var autofocus = popup.find('[autofocus]')[0];

                if (!this._autofocus && autofocus) {
                    this._autofocus = true;
                } else {
                    autofocus = node;
                }

                this.__focus(autofocus);
            }

            // 设置叠加高度
            popup.css('zIndex', index);
            //this.__backdrop.css('zIndex', index);

            Popup.current = this;
            popup.addClass(this.className + '-focus');

            this.__dispatchEvent('focus');

            return this;
        },


        /** 让浮层失去焦点。将焦点退还给之前的元素，照顾视力障碍用户 */
        blur: function () {

            var activeElement = this.__activeElement;
            var isBlur = arguments[0];


            if (isBlur !== false) {
                this.__focus(activeElement);
            }

            this._autofocus = false;
            this.__popup.removeClass(this.className + '-focus');
            this.__dispatchEvent('blur');

            return this;
        },


        /**
         * 添加事件
         * @param   {String}    事件类型
         * @param   {Function}  监听函数
         */
        addEventListener: function (type, callback) {
            this.__getEventListener(type).push(callback);
            return this;
        },


        /**
         * 删除事件
         * @param   {String}    事件类型
         * @param   {Function}  监听函数
         */
        removeEventListener: function (type, callback) {
            var listeners = this.__getEventListener(type);
            for (var i = 0; i < listeners.length; i ++) {
                if (callback === listeners[i]) {
                    listeners.splice(i--, 1);
                }
            }
            return this;
        },


        // 获取事件缓存
        __getEventListener: function (type) {
            var listener = this.__listener;
            if (!listener) {
                listener = this.__listener = {};
            }
            if (!listener[type]) {
                listener[type] = [];
            }
            return listener[type];
        },


        // 派发事件
        __dispatchEvent: function (type) {
            var listeners = this.__getEventListener(type);

            if (this['on' + type]) {
                this['on' + type]();
            }

            for (var i = 0; i < listeners.length; i ++) {
                listeners[i].call(this);
            }
        },


        // 对元素安全聚焦
        __focus: function (elem) {
            // 防止 iframe 跨域无权限报错
            // 防止 IE 不可见元素报错
            try {
                // ie11 bug: iframe 页面点击会跳到顶部
                if (this.autofocus && !/^iframe$/i.test(elem.nodeName)) {
                    elem.focus();
                }
            } catch (e) {}
        },


        // 获取当前焦点的元素
        __getActive: function () {
            try {// try: ie8~9, iframe #26
                var activeElement = document.activeElement;
                var contentDocument = activeElement.contentDocument;
                var elem = contentDocument && contentDocument.activeElement || activeElement;
                return elem;
            } catch (e) {}
        },


        // 居中浮层
        __center: function () {
        
            var popup = this.__popup;
            var $window = $(window);
            var $document = $(document);
            var fixed = this.fixed;
            var dl = fixed ? 0 : $document.scrollLeft();
            var dt = fixed ? 0 : $document.scrollTop();
            var ww = $window.width();
            var wh = $window.height();
            var ow = popup.width();
            var oh = popup.height();
            var left = (ww - ow) / 2 + dl;
            var top = (wh - oh) * 382 / 1000 + dt;// 黄金比例
            var style = popup[0].style;

            
            style.left = Math.max(parseInt(left), dl) + 'px';
            style.top = Math.max(parseInt(top), dt) + 'px';
        },
        
        
        // 指定位置 @param    {HTMLElement, Event}  anchor
        __follow: function (anchor) {
            
            var $elem = anchor.parentNode && $(anchor);
            var popup = this.__popup;
            

            if (this.__followSkin) {
                popup.removeClass(this.__followSkin);
            }


            // 隐藏元素不可用
            if ($elem) {
                var o = $elem.offset();
                if (o.left * o.top < 0) {
                    return this.__center();
                }
            }
            
            var that = this;
            var fixed = this.fixed;

            var $window = $(window);
            var $document = $(document);
            var winWidth = $window.width();
            var winHeight = $window.height();
            var docLeft =  $document.scrollLeft();
            var docTop = $document.scrollTop();


            var popupWidth = popup.width();
            var popupHeight = popup.height();
            var width = $elem ? $elem.outerWidth() : 0;
            var height = $elem ? $elem.outerHeight() : 0;
            var offset = this.__offset(anchor);
            var x = offset.left;
            var y = offset.top;
            var left =  fixed ? x - docLeft : x;
            var top = fixed ? y - docTop : y;


            var minLeft = fixed ? 0 : docLeft;
            var minTop = fixed ? 0 : docTop;
            var maxLeft = minLeft + winWidth - popupWidth;
            var maxTop = minTop + winHeight - popupHeight;


            var css = {};
            var align = this.align.split(' ');
            var className = this.className + '-';
            var reverse = {top: 'bottom', bottom: 'top', left: 'right', right: 'left'};
            var name = {top: 'top', bottom: 'top', left: 'left', right: 'left'};


            var temp = [{
                top: top - popupHeight,
                bottom: top + height,
                left: left - popupWidth,
                right: left + width
            }, {
                top: top,
                bottom: top - popupHeight + height,
                left: left,
                right: left - popupWidth + width
            }];


            var center = {
                left: left + width / 2 - popupWidth / 2,
                top: top + height / 2 - popupHeight / 2
            };

            
            var range = {
                left: [minLeft, maxLeft],
                top: [minTop, maxTop]
            };


            // 超出可视区域重新适应位置
            $.each(align, function (i, val) {

                // 超出右或下边界：使用左或者上边对齐
                if (temp[i][val] > range[name[val]][1]) {
                    val = align[i] = reverse[val];
                }

                // 超出左或右边界：使用右或者下边对齐
                if (temp[i][val] < range[name[val]][0]) {
                    align[i] = reverse[val];
                }

            });


            // 一个参数的情况
            if (!align[1]) {
                name[align[1]] = name[align[0]] === 'left' ? 'top' : 'left';
                temp[1][align[1]] = center[name[align[1]]];
            }


            //添加follow的css, 为了给css使用
            className += align.join('-') + ' '+ this.className+ '-follow';
            
            that.__followSkin = className;


            if ($elem) {
                popup.addClass(className);
            }

            
            css[name[align[0]]] = parseInt(temp[0][align[0]]);
            css[name[align[1]]] = parseInt(temp[1][align[1]]);
            popup.css(css);

        },


        // 获取元素相对于页面的位置（包括iframe内的元素）
        // 暂时不支持两层以上的 iframe 套嵌
        __offset: function (anchor) {

            var isNode = anchor.parentNode;
            var offset = isNode ? $(anchor).offset() : {
                left: anchor.pageX,
                top: anchor.pageY
            };


            anchor = isNode ? anchor : anchor.target;
            var ownerDocument = anchor.ownerDocument;
            var defaultView = ownerDocument.defaultView || ownerDocument.parentWindow;
            
            if (defaultView == window) {// IE <= 8 只能使用两个等于号
                return offset;
            }

            // {Element: Ifarme}
            var frameElement = defaultView.frameElement;
            var $ownerDocument = $(ownerDocument);
            var docLeft =  $ownerDocument.scrollLeft();
            var docTop = $ownerDocument.scrollTop();
            var frameOffset = $(frameElement).offset();
            var frameLeft = frameOffset.left;
            var frameTop = frameOffset.top;
            
            return {
                left: offset.left + frameLeft - docLeft,
                top: offset.top + frameTop - docTop
            };
        }
        
    });


    /** 当前叠加高度 */
    Popup.zIndex = 1024;


    /** 顶层浮层的实例 */
    Popup.current = null;


    module.exports = Popup;
})(jQuery);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {

    /* -----已注释的配置继承自 popup.js，仍可以再这里重新定义它----- */

    // 对齐方式
    //align: 'bottom left',
    
    // 是否固定定位
    //fixed: false,
    
    // 对话框叠加高度值(重要：此值不能超过浏览器最大限制)
    //zIndex: 1024,

    // 设置遮罩背景颜色
    backdropBackground: '#000',

    // 设置遮罩透明度
    backdropOpacity: 0.3,

    // 消息内容
    content: '<span class="ui-dialog-loading">Loading..</span>',
    
    // 标题
    title: '',

    // 对话框状态栏区域 HTML 代码
    statusbar: '',
    
    // 自定义按钮
    button: null,
    
    // 确定按钮回调函数
    ok: null,
    
    // 取消按钮回调函数
    cancel: null,

    // 确定按钮文本
    okValue: 'ok',
    
    // 取消按钮文本
    cancelValue: 'cancel',

    cancelDisplay: true,
    
    // 内容宽度
    width: '',
    
    // 内容高度
    height: '',
    
    // 内容与边界填充距离
    padding: '',
    
    // 对话框自定义 className
    skin: '',

    // 是否支持快捷关闭（点击遮罩层自动关闭）
    quickClose: false,

    // css 文件路径，留空则不会使用 js 自动加载样式
    // 注意：css 只允许加载一个
    cssUri: '../css/ui-dialog.css',

    // 模板（使用 table 解决 IE7 宽度自适应的 BUG）
    // js 使用 i="***" 属性识别结构，其余的均可自定义
    innerHTML:__webpack_require__(80)()
    
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\n<div i="dialog" class="ui-dialog dbl-components-dialog">\n    <div class="ui-dialog-arrow-a"></div>\n    <div class="ui-dialog-arrow-b"></div>\n    <table class="ui-dialog-grid">\n        <tr>\n            <td i="header" class="ui-dialog-header">\n                <button i="close" class="ui-dialog-close">&#215;</button>\n                <div i="title" class="ui-dialog-title"></div>\n            </td>\n        </tr>\n        <tr>\n            <td i="body" class="ui-dialog-body">\n                <div i="type" class="ui-dialog-type"></div>\n                <div i="content" class="ui-dialog-content"></div>\n            </td>\n        </tr>\n        <tr>\n            <td i="footer" class="ui-dialog-footer">\n                <div i="statusbar" class="ui-dialog-statusbar"></div>\n                <div i="button" class="ui-dialog-button"></div>\n            </td>\n        </tr>\n    </table>\n</div>\n';

}
return __p
}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

var region = {

  // 按地区获取省
  getProvinces: function getProvinces(regionID) {
    var provinces = this.getAllProvinces();
    var re = [];
    for (var i = 0; i < provinces.length; i++) {
      if (provinces[i].regionID == regionID) re.push(provinces[i]);
    }
    return re;
  },

  // 获取单个省
  getProvince: function getProvince(pid) {
    var provinces = this.getAllProvinces();
    for (var i = 0; i < provinces.length; i++) {
      if (provinces[i].provinceID == pid) return provinces[i];
    }
    return null;
  },

  // 获取单个省
  getProvinceByPrefix: function getProvinceByPrefix(prefix) {
    var citys = this.getAllCitys();
    for (var i = 0; i < citys.length; i++) {
      if (citys[i].prefix == prefix) {
        return this.getProvince(citys[i].provinceID);
      }
    }
    return null;
  },

  // 获取单个省
  getProvinceByTitle: function getProvinceByTitle(title) {
    var list = this.getAllProvinces();
    for (var i = 0; i < list.length; i++) {
      if (list[i].title == title) {
        return list[i];
      }
    }
    return null;
  },

  // 获取某省的市
  getCitys: function getCitys(pid) {
    var citys = this.getAllCitys();
    var re = [];
    for (var i = 0; i < citys.length; i++) {
      if (citys[i].provinceID == pid) re.push(citys[i]);
    }
    return re;
  },

  // 获取单个市
  getCity: function getCity(cid) {
    var citys = this.getAllCitys();
    for (var i = 0; i < citys.length; i++) {
      if (citys[i].cityID == cid) return citys[i];
    }
    return null;
  },

  // 获取单个市
  getCityByTitle: function getCityByTitle(title, ptitle) {
    var citys = this.getAllCitys();
    if (ptitle) {
      var p = this.getProvinceByTitle(ptitle);
      citys = this.getCitys(p.provinceID);
    }

    for (var i = 0; i < citys.length; i++) {
      if (citys[i].title == title) return citys[i];
    }
    return null;
  },

  getCityByProvinceTitle: function getCityByProvinceTitle(title) {
    var p = this.getProvinceByTitle(title);
    if (!p) {
      return null;
    }
    return this.getCitys(p.provinceID);
  },

  // 获取所有区域
  getAllArea: function getAllArea() {
    var areas = [{
      'areaID': 1,
      'title': '上海辖区'
    }, {
      'areaID': 2,
      'title': '广州辖区'
    }, {
      'areaID': 3,
      'title': '北京辖区'
    }];
    return areas;
  },

  // 获取所有地区
  getAllRegions: function getAllRegions() {
    var regions = [{
      'regionID': 0,
      'title': '中国',
      'code': 'CN',
      'prefix': '86'
    }, {
      'regionID': 1,
      'title': '中国香港',
      'code': 'HK',
      'prefix': '852'
    }, {
      'regionID': 2,
      'title': '中国澳门',
      'code': 'OM',
      'prefix': '853'
    }, {
      'regionID': 3,
      'title': '中国台湾',
      'code': 'TW',
      'prefix': '886'
    }, {
      'regionID': 4,
      'code': 'AD',
      'title': '安道尔共和国',
      'prefix': 376
    }, {
      'regionID': 4,
      'code': 'AE',
      'title': '阿拉伯联合酋长国',
      'prefix': 971
    }, {
      'regionID': 4,
      'code': 'AF',
      'title': '阿富汗',
      'prefix': 93
    }, {
      'regionID': 4,
      'code': 'AG',
      'title': '安提瓜和巴布达',
      'prefix': 86 //1268
    }, {
      'regionID': 4,
      'code': 'AI',
      'title': '安圭拉岛',
      'prefix': 86 //1264
    }, {
      'regionID': 4,
      'code': 'AL',
      'title': '阿尔巴尼亚',
      'prefix': 355
    }, {
      'regionID': 4,
      'code': 'AM',
      'title': '亚美尼亚',
      'prefix': 374
    }, {
      'regionID': 4,
      'code': 'AO',
      'title': '安哥拉',
      'prefix': 244
    }, {
      'regionID': 4,
      'code': 'AR',
      'title': '阿根廷',
      'prefix': 54
    }, {
      'regionID': 4,
      'code': 'AT',
      'title': '奥地利',
      'prefix': 43
    }, {
      'regionID': 4,
      'code': 'AU',
      'title': '澳大利亚',
      'prefix': 61
    }, {
      'regionID': 4,
      'code': 'AZ',
      'title': '阿塞拜疆',
      'prefix': 994
    }, {
      'regionID': 4,
      'code': 'BB',
      'title': '巴巴多斯',
      'prefix': 86 //1246
    }, {
      'regionID': 4,
      'code': 'BD',
      'title': '孟加拉国',
      'prefix': 880
    }, {
      'regionID': 4,
      'code': 'BE',
      'title': '比利时',
      'prefix': 32
    }, {
      'regionID': 4,
      'code': 'BF',
      'title': '布基纳法索',
      'prefix': 226
    }, {
      'regionID': 4,
      'code': 'BG',
      'title': '保加利亚',
      'prefix': 359
    }, {
      'regionID': 4,
      'code': 'BH',
      'title': '巴林',
      'prefix': 973
    }, {
      'regionID': 4,
      'code': 'BI',
      'title': '布隆迪',
      'prefix': 257
    }, {
      'regionID': 4,
      'code': 'BJ',
      'title': '贝宁',
      'prefix': 229
    }, {
      'regionID': 4,
      'code': 'BL',
      'title': '巴勒斯坦',
      'prefix': 970
    }, {
      'regionID': 4,
      'code': 'BM',
      'title': '百慕大群岛',
      'prefix': 86 //1441
    }, {
      'regionID': 4,
      'code': 'BN',
      'title': '文莱',
      'prefix': 673
    }, {
      'regionID': 4,
      'code': 'BO',
      'title': '玻利维亚',
      'prefix': 591
    }, {
      'regionID': 4,
      'code': 'BR',
      'title': '巴西',
      'prefix': 55
    }, {
      'regionID': 4,
      'code': 'BS',
      'title': '巴哈马',
      'prefix': 86 //1242
    }, {
      'regionID': 4,
      'code': 'BW',
      'title': '博茨瓦纳',
      'prefix': 267
    }, {
      'regionID': 4,
      'code': 'BY',
      'title': '白俄罗斯',
      'prefix': 375
    }, {
      'regionID': 4,
      'code': 'BZ',
      'title': '伯利兹',
      'prefix': 501
    }, {
      'regionID': 4,
      'code': 'CA',
      'title': '加拿大',
      'prefix': 1
    }, {
      'regionID': 4,
      'code': 'KY',
      'title': '开曼群岛',
      'prefix': 86 //1345
    }, {
      'regionID': 4,
      'code': 'CF',
      'title': '中非共和国',
      'prefix': 236
    }, {
      'regionID': 4,
      'code': 'CG',
      'title': '刚果',
      'prefix': 242
    }, {
      'regionID': 4,
      'code': 'CH',
      'title': '瑞士',
      'prefix': 41
    }, {
      'regionID': 4,
      'code': 'CK',
      'title': '库克群岛',
      'prefix': 682
    }, {
      'regionID': 4,
      'code': 'CL',
      'title': '智利',
      'prefix': 56
    }, {
      'regionID': 4,
      'code': 'CM',
      'title': '喀麦隆',
      'prefix': 237
    }, {
      'regionID': 4,
      'code': 'CO',
      'title': '哥伦比亚',
      'prefix': 57
    }, {
      'regionID': 4,
      'code': 'CR',
      'title': '哥斯达黎加',
      'prefix': 506
    }, {
      'regionID': 4,
      'code': 'CS',
      'title': '捷克',
      'prefix': 420
    }, {
      'regionID': 4,
      'code': 'CU',
      'title': '古巴',
      'prefix': 53
    }, {
      'regionID': 4,
      'code': 'CY',
      'title': '塞浦路斯',
      'prefix': 357
    }, {
      'regionID': 4,
      'code': 'CZ',
      'title': '捷克',
      'prefix': 420
    }, {
      'regionID': 4,
      'code': 'DE',
      'title': '德国',
      'prefix': 49
    }, {
      'regionID': 4,
      'code': 'DJ',
      'title': '吉布提',
      'prefix': 253
    }, {
      'regionID': 4,
      'code': 'DK',
      'title': '丹麦',
      'prefix': 45
    }, {
      'regionID': 4,
      'code': 'DO',
      'title': '多米尼加共和国',
      'prefix': 86 //1890
    }, {
      'regionID': 4,
      'code': 'DZ',
      'title': '阿尔及利亚',
      'prefix': 213
    }, {
      'regionID': 4,
      'code': 'EC',
      'title': '厄瓜多尔',
      'prefix': 593
    }, {
      'regionID': 4,
      'code': 'EE',
      'title': '爱沙尼亚',
      'prefix': 372
    }, {
      'regionID': 4,
      'code': 'EG',
      'title': '埃及',
      'prefix': 20
    }, {
      'regionID': 4,
      'code': 'ES',
      'title': '西班牙',
      'prefix': 34
    }, {
      'regionID': 4,
      'code': 'ET',
      'title': '埃塞俄比亚',
      'prefix': 251
    }, {
      'regionID': 4,
      'code': 'FI',
      'title': '芬兰',
      'prefix': 358
    }, {
      'regionID': 4,
      'code': 'FJ',
      'title': '斐济',
      'prefix': 679
    }, {
      'regionID': 4,
      'code': 'FR',
      'title': '法国',
      'prefix': 33
    }, {
      'regionID': 4,
      'code': 'GA',
      'title': '加蓬',
      'prefix': 241
    }, {
      'regionID': 4,
      'code': 'GB',
      'title': '英国',
      'prefix': 44
    }, {
      'regionID': 4,
      'code': 'GD',
      'title': '格林纳达',
      'prefix': 86 //1809
    }, {
      'regionID': 4,
      'code': 'GE',
      'title': '格鲁吉亚',
      'prefix': 995
    }, {
      'regionID': 4,
      'code': 'GF',
      'title': '法属圭亚那',
      'prefix': 594
    }, {
      'regionID': 4,
      'code': 'GH',
      'title': '加纳',
      'prefix': 233
    }, {
      'regionID': 4,
      'code': 'GI',
      'title': '直布罗陀',
      'prefix': 350
    }, {
      'regionID': 4,
      'code': 'GM',
      'title': '冈比亚',
      'prefix': 220
    }, {
      'regionID': 4,
      'code': 'GN',
      'title': '几内亚',
      'prefix': 224
    }, {
      'regionID': 4,
      'code': 'GR',
      'title': '希腊',
      'prefix': 30
    }, {
      'regionID': 4,
      'code': 'GT',
      'title': '危地马拉',
      'prefix': 502
    }, {
      'regionID': 4,
      'code': 'GU',
      'title': '关岛',
      'prefix': 86 //1671
    }, {
      'regionID': 4,
      'code': 'GY',
      'title': '圭亚那',
      'prefix': 592
    }, {
      'regionID': 4,
      'code': 'HN',
      'title': '洪都拉斯',
      'prefix': 504
    }, {
      'regionID': 4,
      'code': 'HT',
      'title': '海地',
      'prefix': 509
    }, {
      'regionID': 4,
      'code': 'HU',
      'title': '匈牙利',
      'prefix': 36
    }, {
      'regionID': 4,
      'code': 'ID',
      'title': '印度尼西亚',
      'prefix': 62
    }, {
      'regionID': 4,
      'code': 'IE',
      'title': '爱尔兰',
      'prefix': 353
    }, {
      'regionID': 4,
      'code': 'IL',
      'title': '以色列',
      'prefix': 972
    }, {
      'regionID': 4,
      'code': 'IN',
      'title': '印度',
      'prefix': 91
    }, {
      'regionID': 4,
      'code': 'IQ',
      'title': '伊拉克',
      'prefix': 964
    }, {
      'regionID': 4,
      'code': 'IR',
      'title': '伊朗',
      'prefix': 98
    }, {
      'regionID': 4,
      'code': 'IS',
      'title': '冰岛',
      'prefix': 354
    }, {
      'regionID': 4,
      'code': 'IT',
      'title': '意大利',
      'prefix': 39
    }, {
      'regionID': 4,
      'code': 'CI',
      'title': '科特迪瓦',
      'prefix': 225
    }, {
      'regionID': 4,
      'code': 'JM',
      'title': '牙买加',
      'prefix': 86 //1876
    }, {
      'regionID': 4,
      'code': 'JO',
      'title': '约旦',
      'prefix': 962
    }, {
      'regionID': 4,
      'code': 'JP',
      'title': '日本',
      'prefix': 81
    }, {
      'regionID': 4,
      'code': 'KE',
      'title': '肯尼亚',
      'prefix': 254
    }, {
      'regionID': 4,
      'code': 'KG',
      'title': '吉尔吉斯坦',
      'prefix': 331
    }, {
      'regionID': 4,
      'code': 'KH',
      'title': '柬埔寨',
      'prefix': 855
    }, {
      'regionID': 4,
      'code': 'KP',
      'title': '朝鲜',
      'prefix': 850
    }, {
      'regionID': 4,
      'code': 'KR',
      'title': '韩国',
      'prefix': 82
    }, {
      'regionID': 4,
      'code': 'KW',
      'title': '科威特',
      'prefix': 965
    }, {
      'regionID': 4,
      'code': 'KZ',
      'title': '哈萨克斯坦',
      'prefix': 327
    }, {
      'regionID': 4,
      'code': 'LA',
      'title': '老挝',
      'prefix': 856
    }, {
      'regionID': 4,
      'code': 'LB',
      'title': '黎巴嫩',
      'prefix': 961
    }, {
      'regionID': 4,
      'code': 'LC',
      'title': '圣卢西亚',
      'prefix': 86 //1758
    }, {
      'regionID': 4,
      'code': 'LI',
      'title': '列支敦士登',
      'prefix': 423
    }, {
      'regionID': 4,
      'code': 'LK',
      'title': '斯里兰卡',
      'prefix': 94
    }, {
      'regionID': 4,
      'code': 'LR',
      'title': '利比里亚',
      'prefix': 231
    }, {
      'regionID': 4,
      'code': 'LS',
      'title': '莱索托',
      'prefix': 266
    }, {
      'regionID': 4,
      'code': 'LT',
      'title': '立陶宛',
      'prefix': 370
    }, {
      'regionID': 4,
      'code': 'LU',
      'title': '卢森堡',
      'prefix': 352
    }, {
      'regionID': 4,
      'code': 'LV',
      'title': '拉脱维亚',
      'prefix': 371
    }, {
      'regionID': 4,
      'code': 'LY',
      'title': '利比亚',
      'prefix': 218
    }, {
      'regionID': 4,
      'code': 'MA',
      'title': '摩洛哥',
      'prefix': 212
    }, {
      'regionID': 4,
      'code': 'MC',
      'title': '摩纳哥',
      'prefix': 377
    }, {
      'regionID': 4,
      'code': 'MD',
      'title': '摩尔多瓦',
      'prefix': 373
    }, {
      'regionID': 4,
      'code': 'MG',
      'title': '马达加斯加',
      'prefix': 261
    }, {
      'regionID': 4,
      'code': 'ML',
      'title': '马里',
      'prefix': 223
    }, {
      'regionID': 4,
      'code': 'MM',
      'title': '缅甸',
      'prefix': 95
    }, {
      'regionID': 4,
      'code': 'MN',
      'title': '蒙古',
      'prefix': 976
    }, {
      'regionID': 4,
      'code': 'MS',
      'title': '蒙特塞拉特岛',
      'prefix': 86 //1664
    }, {
      'regionID': 4,
      'code': 'MT',
      'title': '马耳他',
      'prefix': 356
    }, {
      'regionID': 4,
      'code': 'MU',
      'title': '毛里求斯',
      'prefix': 230
    }, {
      'regionID': 4,
      'code': 'MV',
      'title': '马尔代夫',
      'prefix': 960
    }, {
      'regionID': 4,
      'code': 'MW',
      'title': '马拉维',
      'prefix': 265
    }, {
      'regionID': 4,
      'code': 'MX',
      'title': '墨西哥',
      'prefix': 52
    }, {
      'regionID': 4,
      'code': 'MY',
      'title': '马来西亚',
      'prefix': 60
    }, {
      'regionID': 4,
      'code': 'MZ',
      'title': '莫桑比克',
      'prefix': 258
    }, {
      'regionID': 4,
      'code': 'NA',
      'title': '纳米比亚',
      'prefix': 264
    }, {
      'regionID': 4,
      'code': 'NE',
      'title': '尼日尔',
      'prefix': 977
    }, {
      'regionID': 4,
      'code': 'NG',
      'title': '尼日利亚',
      'prefix': 234
    }, {
      'regionID': 4,
      'code': 'NI',
      'title': '尼加拉瓜',
      'prefix': 505
    }, {
      'regionID': 4,
      'code': 'NL',
      'title': '荷兰',
      'prefix': 31
    }, {
      'regionID': 4,
      'code': 'NO',
      'title': '挪威',
      'prefix': 47
    }, {
      'regionID': 4,
      'code': 'NP',
      'title': '尼泊尔',
      'prefix': 977
    }, {
      'regionID': 4,
      'code': 'NR',
      'title': '瑙鲁',
      'prefix': 674
    }, {
      'regionID': 4,
      'code': 'NZ',
      'title': '新西兰',
      'prefix': 64
    }, {
      'regionID': 4,
      'code': 'OM',
      'title': '阿曼',
      'prefix': 968
    }, {
      'regionID': 4,
      'code': 'PA',
      'title': '巴拿马',
      'prefix': 507
    }, {
      'regionID': 4,
      'code': 'PE',
      'title': '秘鲁',
      'prefix': 51
    }, {
      'regionID': 4,
      'code': 'PF',
      'title': '法属玻利尼西亚',
      'prefix': 689
    }, {
      'regionID': 4,
      'code': 'PG',
      'title': '巴布亚新几内亚',
      'prefix': 675
    }, {
      'regionID': 4,
      'code': 'PH',
      'title': '菲律宾',
      'prefix': 63
    }, {
      'regionID': 4,
      'code': 'PK',
      'title': '巴基斯坦',
      'prefix': 92
    }, {
      'regionID': 4,
      'code': 'PL',
      'title': '波兰',
      'prefix': 48
    }, {
      'regionID': 4,
      'code': 'PR',
      'title': '波多黎各',
      'prefix': 86 //1787
    }, {
      'regionID': 4,
      'code': 'PT',
      'title': '葡萄牙',
      'prefix': 351
    }, {
      'regionID': 4,
      'code': 'PY',
      'title': '巴拉圭',
      'prefix': 595
    }, {
      'regionID': 4,
      'code': 'QA',
      'title': '卡塔尔',
      'prefix': 974
    }, {
      'regionID': 4,
      'code': 'RO',
      'title': '罗马尼亚',
      'prefix': 40
    }, {
      'regionID': 4,
      'code': 'RU',
      'title': '俄罗斯',
      'prefix': 7
    }, {
      'regionID': 4,
      'code': 'SA',
      'title': '沙特阿拉伯',
      'prefix': 966
    }, {
      'regionID': 4,
      'code': 'SB',
      'title': '所罗门群岛',
      'prefix': 677
    }, {
      'regionID': 4,
      'code': 'SC',
      'title': '塞舌尔',
      'prefix': 248
    }, {
      'regionID': 4,
      'code': 'SD',
      'title': '苏丹',
      'prefix': 249
    }, {
      'regionID': 4,
      'code': 'SE',
      'title': '瑞典',
      'prefix': 46
    }, {
      'regionID': 4,
      'code': 'SG',
      'title': '新加坡',
      'prefix': 65
    }, {
      'regionID': 4,
      'code': 'SI',
      'title': '斯洛文尼亚',
      'prefix': 386
    }, {
      'regionID': 4,
      'code': 'SK',
      'title': '斯洛伐克',
      'prefix': 421
    }, {
      'regionID': 4,
      'code': 'SL',
      'title': '塞拉利昂',
      'prefix': 232
    }, {
      'regionID': 4,
      'code': 'SM',
      'title': '圣马力诺',
      'prefix': 378
    }, {
      'regionID': 4,
      'code': 'SN',
      'title': '塞内加尔',
      'prefix': 221
    }, {
      'regionID': 4,
      'code': 'SO',
      'title': '索马里',
      'prefix': 252
    }, {
      'regionID': 4,
      'code': 'SR',
      'title': '苏里南',
      'prefix': 597
    }, {
      'regionID': 4,
      'code': 'ST',
      'title': '圣多美和普林西比',
      'prefix': 239
    }, {
      'regionID': 4,
      'code': 'SV',
      'title': '萨尔瓦多',
      'prefix': 503
    }, {
      'regionID': 4,
      'code': 'SY',
      'title': '叙利亚',
      'prefix': 963
    }, {
      'regionID': 4,
      'code': 'SZ',
      'title': '斯威士兰',
      'prefix': 268
    }, {
      'regionID': 4,
      'code': 'TD',
      'title': '乍得',
      'prefix': 235
    }, {
      'regionID': 4,
      'code': 'TG',
      'title': '多哥',
      'prefix': 228
    }, {
      'regionID': 4,
      'code': 'TH',
      'title': '泰国',
      'prefix': 66
    }, {
      'regionID': 4,
      'code': 'TJ',
      'title': '塔吉克斯坦',
      'prefix': 992
    }, {
      'regionID': 4,
      'code': 'TM',
      'title': '土库曼斯坦',
      'prefix': 993
    }, {
      'regionID': 4,
      'code': 'TN',
      'title': '突尼斯',
      'prefix': 216
    }, {
      'regionID': 4,
      'code': 'TO',
      'title': '汤加',
      'prefix': 676
    }, {
      'regionID': 4,
      'code': 'TR',
      'title': '土耳其',
      'prefix': 90
    }, {
      'regionID': 4,
      'code': 'TT',
      'title': '特立尼达和多巴哥',
      'prefix': 86 //1809
    }, {
      'regionID': 4,
      'code': 'TZ',
      'title': '坦桑尼亚',
      'prefix': 255
    }, {
      'regionID': 4,
      'code': 'UA',
      'title': '乌克兰',
      'prefix': 380
    }, {
      'regionID': 4,
      'code': 'UG',
      'title': '乌干达',
      'prefix': 256
    }, {
      'regionID': 4,
      'code': 'US',
      'title': '美国',
      'prefix': 1
    }, {
      'regionID': 4,
      'code': 'UY',
      'title': '乌拉圭',
      'prefix': 598
    }, {
      'regionID': 4,
      'code': 'UZ',
      'title': '乌兹别克斯坦',
      'prefix': 233
    }, {
      'regionID': 4,
      'code': 'VC',
      'title': '圣文森特岛',
      'prefix': 86 //1784
    }, {
      'regionID': 4,
      'code': 'VE',
      'title': '委内瑞拉',
      'prefix': 58
    }, {
      'regionID': 4,
      'code': 'VN',
      'title': '越南',
      'prefix': 84
    }, {
      'regionID': 4,
      'code': 'YE',
      'title': '也门',
      'prefix': 967
    }, {
      'regionID': 4,
      'code': 'YU',
      'title': '南斯拉夫',
      'prefix': 381
    }, {
      'regionID': 4,
      'code': 'ZA',
      'title': '南非',
      'prefix': 27
    }, {
      'regionID': 4,
      'code': 'ZM',
      'title': '赞比亚',
      'prefix': 260
    }, {
      'regionID': 4,
      'code': 'ZR',
      'title': '扎伊尔',
      'prefix': 243
    }, {
      'regionID': 4,
      'code': 'ZW',
      'title': '津巴布韦',
      'prefix': 263
    }];
    return regions;
  },

  getRegion: function getRegion(rid) {
    var list = this.getAllRegions();
    for (var i = 0; i < list.length; i++) {
      if (list[i].regionID == rid) return list[i];
    }
    return null;
  },

  getRegionByCode: function getRegionByCode(code) {
    var list = this.getAllRegions();
    for (var i = 0; i < list.length; i++) {
      if (list[i].code == code) return list[i];
    }
    return null;
  },
  getRegionByTitle: function getRegionByTitle(title) {
    var list = this.getAllRegions();
    for (var i = 0; i < list.length; i++) {
      if (list[i].title == title) return list[i];
    }
    return null;
  },
  getRegionByID: function getRegionByID(regionID) {
    var list = this.getAllRegions();
    for (var i = 0; i < list.length; i++) {
      if (list[i].regionID == regionID) return list[i];
    }
    return null;
  },
  // 获取所有的省
  getAllProvinces: function getAllProvinces() {
    var provinces = [{
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 1,
      'title': '北京',
      'areaID': 3,
      'pinYin': 'bei jing'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 2,
      'title': '上海',
      'areaID': 1,
      'pinYin': 'shang hai'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 3,
      'title': '天津',
      'areaID': 3,
      'pinYin': 'tian jin'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 4,
      'title': '重庆',
      'areaID': 3,
      'pinYin': 'zhong qing'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 5,
      'title': '内蒙古',
      'areaID': 3,
      'pinYin': 'nei meng gu'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 6,
      'title': '山西',
      'areaID': 3,
      'pinYin': 'shan xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 7,
      'title': '河北',
      'areaID': 3,
      'pinYin': 'he bei'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 8,
      'title': '辽宁',
      'areaID': 3,
      'pinYin': 'liao ning'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 9,
      'title': '吉林',
      'areaID': 3,
      'pinYin': 'ji lin'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 10,
      'title': '黑龙江',
      'areaID': 3,
      'pinYin': 'hei long jiang'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 11,
      'title': '江苏',
      'areaID': 1,
      'pinYin': 'jiang su'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 12,
      'title': '安徽',
      'areaID': 3,
      'pinYin': 'an hui'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 13,
      'title': '山东',
      'areaID': 3,
      'pinYin': 'shan dong'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 14,
      'title': '浙江',
      'areaID': 1,
      'pinYin': 'zhe jiang'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 15,
      'title': '江西',
      'areaID': 3,
      'pinYin': 'jiang xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 16,
      'title': '福建',
      'areaID': 2,
      'pinYin': 'fu jian'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 17,
      'title': '湖南',
      'areaID': 2,
      'pinYin': 'hu nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 18,
      'title': '湖北',
      'areaID': 3,
      'pinYin': 'hu bei'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 19,
      'title': '河南',
      'areaID': 3,
      'pinYin': 'he nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 20,
      'title': '广东',
      'areaID': 2,
      'pinYin': 'guang dong'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 21,
      'title': '海南',
      'areaID': 2,
      'pinYin': 'hai nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 22,
      'title': '广西',
      'areaID': 2,
      'pinYin': 'guang xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 23,
      'title': '贵州',
      'areaID': 3,
      'pinYin': 'gui zhou'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 24,
      'title': '四川',
      'areaID': 3,
      'pinYin': 'si chuan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 25,
      'title': '云南',
      'areaID': 3,
      'pinYin': 'yun nan'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 26,
      'title': '陕西',
      'areaID': 3,
      'pinYin': 'shaan xi'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 27,
      'title': '甘肃',
      'areaID': 3,
      'pinYin': 'gan su'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 28,
      'title': '宁夏',
      'areaID': 3,
      'pinYin': 'ning xia'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 29,
      'title': '青海',
      'areaID': 3,
      'pinYin': 'qing hai'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 30,
      'title': '新疆',
      'areaID': 3,
      'pinYin': 'xin jiang'
    }, {
      'region': '中国',
      'regionID': 0,
      'prefix': '',
      'provinceID': 31,
      'title': '西藏',
      'areaID': 3,
      'pinYin': 'xi cang'
    }, {
      'region': '香港地区',
      'regionID': 1,
      'prefix': '',
      'provinceID': 32,
      'title': '香港',
      'areaID': 2,
      'pinYin': 'xiang gang'
    }, {
      'region': '澳门地区',
      'regionID': 2,
      'prefix': '',
      'provinceID': 33,
      'title': '澳门',
      'areaID': 2,
      'pinYin': 'ao men'
    }, {
      'region': '台湾地区',
      'regionID': 3,
      'prefix': '',
      'provinceID': 34,
      'title': '台湾',
      'areaID': 2,
      'pinYin': 'tai wan'
    }];
    return provinces;
  },

  // 获取所有的市
  getAllCitys: function getAllCitys() {
    var citys = [{
      'provinceID': 1,
      'cityID': 1,
      'title': '北京市',
      'prefix': '010',
      'pinYin': 'bei jing shi'
    }, {
      'provinceID': 2,
      'cityID': 19,
      'title': '上海市',
      'prefix': '021',
      'pinYin': 'shang hai shi'
    }, {
      'provinceID': 3,
      'cityID': 40,
      'title': '天津市',
      'prefix': '022',
      'pinYin': 'tian jin shi'
    }, {
      'provinceID': 4,
      'cityID': 58,
      'title': '重庆市',
      'prefix': '023',
      'pinYin': 'zhong qing shi'
    }, {
      'provinceID': 5,
      'cityID': 99,
      'title': '呼和浩特市',
      'prefix': '0471',
      'pinYin': 'hu he hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 100,
      'title': '包头市',
      'prefix': '0472',
      'pinYin': 'bao tou shi'
    }, {
      'provinceID': 5,
      'cityID': 101,
      'title': '乌海市',
      'prefix': '0473',
      'pinYin': 'wu hai shi'
    }, {
      'provinceID': 5,
      'cityID': 102,
      'title': '赤峰市',
      'prefix': '0476',
      'pinYin': 'chi feng shi'
    }, {
      'provinceID': 5,
      'cityID': 111,
      'title': '通辽市',
      'prefix': '0475',
      'pinYin': 'tong liao shi'
    }, {
      'provinceID': 5,
      'cityID': 2626,
      'title': '鄂尔多斯市',
      'prefix': '0477',
      'pinYin': 'e er duo si shi'
    }, {
      'provinceID': 5,
      'cityID': 2627,
      'title': '呼伦贝尔市',
      'prefix': '0470',
      'pinYin': 'hu lun bei er shi'
    }, {
      'provinceID': 5,
      'cityID': 2628,
      'title': '巴彦淖尔市',
      'prefix': '0478',
      'pinYin': 'ba yan nao er shi'
    }, {
      'provinceID': 5,
      'cityID': 2629,
      'title': '乌兰察布市',
      'prefix': '0474',
      'pinYin': 'wu lan cha bu shi'
    }, {
      'provinceID': 5,
      'cityID': 2630,
      'title': '兴安盟',
      'prefix': '0482',
      'pinYin': 'xing an meng'
    }, {
      'provinceID': 5,
      'cityID': 2631,
      'title': '锡林郭勒盟',
      'prefix': '0479',
      'pinYin': 'xi lin guo le meng'
    }, {
      'provinceID': 5,
      'cityID': 2632,
      'title': '阿拉善盟',
      'prefix': '0483',
      'pinYin': 'a la shan meng'
    }, {
      'provinceID': 5,
      'cityID': 104,
      'title': '丰镇市',
      'prefix': '0474',
      'pinYin': 'feng zhen shi'
    }, {
      'provinceID': 5,
      'cityID': 105,
      'title': '锡林浩特市',
      'prefix': '0479',
      'pinYin': 'xi lin hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 106,
      'title': '二连浩特市',
      'prefix': '0479',
      'pinYin': 'er lian hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 108,
      'title': '满州里市',
      'prefix': '0470',
      'pinYin': 'man zhou li shi'
    }, {
      'provinceID': 5,
      'cityID': 109,
      'title': '牙克石市',
      'prefix': '0470',
      'pinYin': 'ya ke shi shi'
    }, {
      'provinceID': 5,
      'cityID': 110,
      'title': '扎兰屯市',
      'prefix': '0470',
      'pinYin': 'zha lan tun shi'
    }, {
      'provinceID': 5,
      'cityID': 112,
      'title': '霍林郭勒市',
      'prefix': '0475',
      'pinYin': 'huo lin guo le shi'
    }, {
      'provinceID': 5,
      'cityID': 2346,
      'title': '乌兰浩特市',
      'prefix': '0482',
      'pinYin': 'wu lan hao te shi'
    }, {
      'provinceID': 5,
      'cityID': 2633,
      'title': '根河市',
      'prefix': '0470',
      'pinYin': 'gen he shi'
    }, {
      'provinceID': 5,
      'cityID': 2634,
      'title': '额尔古纳市',
      'prefix': '0470',
      'pinYin': 'e er gu na shi'
    }, {
      'provinceID': 5,
      'cityID': 2635,
      'title': '阿尔山市',
      'prefix': '0482',
      'pinYin': 'a er shan shi'
    }, {
      'provinceID': 6,
      'cityID': 180,
      'title': '太原市',
      'prefix': '0351',
      'pinYin': 'tai yuan shi'
    }, {
      'provinceID': 6,
      'cityID': 18,
      'title': '大同市',
      'prefix': '0352',
      'pinYin': 'da tong shi'
    }, {
      'provinceID': 6,
      'cityID': 182,
      'title': '阳泉市',
      'prefix': '0353',
      'pinYin': 'yang quan shi'
    }, {
      'provinceID': 6,
      'cityID': 183,
      'title': '长治市',
      'prefix': '0355',
      'pinYin': 'chang zhi shi'
    }, {
      'provinceID': 6,
      'cityID': 184,
      'title': '晋城市',
      'prefix': '0356',
      'pinYin': 'jin cheng shi'
    }, {
      'provinceID': 6,
      'cityID': 185,
      'title': '朔州市',
      'prefix': '0349',
      'pinYin': 'shuo zhou shi'
    }, {
      'provinceID': 6,
      'cityID': 187,
      'title': '忻州市',
      'prefix': '0350',
      'pinYin': 'xin zhou shi'
    }, {
      'provinceID': 6,
      'cityID': 189,
      'title': '临汾市',
      'prefix': '0357',
      'pinYin': 'lin fen shi'
    }, {
      'provinceID': 6,
      'cityID': 192,
      'title': '运城市',
      'prefix': '0359',
      'pinYin': 'yun cheng shi'
    }, {
      'provinceID': 6,
      'cityID': 2601,
      'title': '晋中市',
      'prefix': '0354',
      'pinYin': 'jin zhong shi'
    }, {
      'provinceID': 6,
      'cityID': 186,
      'title': '古交市',
      'prefix': '0351',
      'pinYin': 'gu jiao shi'
    }, {
      'provinceID': 6,
      'cityID': 191,
      'title': '霍州市',
      'prefix': '0357',
      'pinYin': 'huo zhou shi'
    }, {
      'provinceID': 6,
      'cityID': 205,
      'title': '潞城市',
      'prefix': '0355',
      'pinYin': 'lu cheng shi'
    }, {
      'provinceID': 6,
      'cityID': 209,
      'title': '高平市',
      'prefix': '0356',
      'pinYin': 'gao ping shi'
    }, {
      'provinceID': 6,
      'cityID': 228,
      'title': '原平市',
      'prefix': '0350',
      'pinYin': 'yuan ping shi'
    }, {
      'provinceID': 6,
      'cityID': 242,
      'title': '介休市',
      'prefix': '0354',
      'pinYin': 'jie xiu shi'
    }, {
      'provinceID': 6,
      'cityID': 251,
      'title': '汾阳市',
      'prefix': '0358',
      'pinYin': 'fen yang shi'
    }, {
      'provinceID': 6,
      'cityID': 254,
      'title': '孝义市',
      'prefix': '0358',
      'pinYin': 'xiao yi shi'
    }, {
      'provinceID': 6,
      'cityID': 276,
      'title': '河津市',
      'prefix': '0359',
      'pinYin': 'he jin shi'
    }, {
      'provinceID': 6,
      'cityID': 277,
      'title': '永济市',
      'prefix': '0359',
      'pinYin': 'yong ji shi'
    }, {
      'provinceID': 6,
      'cityID': 2314,
      'title': '侯马市',
      'prefix': '0357',
      'pinYin': 'hou ma shi'
    }, {
      'provinceID': 6,
      'cityID': 2643,
      'title': '吕梁市',
      'prefix': '0358',
      'pinYin': 'lv liang shi'
    }, {
      'provinceID': 7,
      'cityID': 284,
      'title': '石家庄市',
      'prefix': '0311',
      'pinYin': 'shi jia zhuang shi'
    }, {
      'provinceID': 7,
      'cityID': 285,
      'title': '邯郸市',
      'prefix': '0310',
      'pinYin': 'han dan shi'
    }, {
      'provinceID': 7,
      'cityID': 286,
      'title': '邢台市',
      'prefix': '0319',
      'pinYin': 'xing tai shi'
    }, {
      'provinceID': 7,
      'cityID': 287,
      'title': '保定市',
      'prefix': '0312',
      'pinYin': 'bao ding shi'
    }, {
      'provinceID': 7,
      'cityID': 288,
      'title': '张家口市',
      'prefix': '0313',
      'pinYin': 'zhang jia kou shi'
    }, {
      'provinceID': 7,
      'cityID': 289,
      'title': '承德市',
      'prefix': '0314',
      'pinYin': 'cheng de shi'
    }, {
      'provinceID': 7,
      'cityID': 290,
      'title': '唐山市',
      'prefix': '0315',
      'pinYin': 'tang shan shi'
    }, {
      'provinceID': 7,
      'cityID': 291,
      'title': '秦皇岛市',
      'prefix': '0335',
      'pinYin': 'qin huang dao shi'
    }, {
      'provinceID': 7,
      'cityID': 292,
      'title': '沧州市',
      'prefix': '0317',
      'pinYin': 'cang zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 293,
      'title': '廊坊市',
      'prefix': '0316',
      'pinYin': 'lang fang shi'
    }, {
      'provinceID': 7,
      'cityID': 300,
      'title': '衡水市',
      'prefix': '0318',
      'pinYin': 'heng shui shi'
    }, {
      'provinceID': 7,
      'cityID': 294,
      'title': '武安市',
      'prefix': '0310',
      'pinYin': 'wu an shi'
    }, {
      'provinceID': 7,
      'cityID': 295,
      'title': '霸州市',
      'prefix': '0316',
      'pinYin': 'ba zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 296,
      'title': '泊头市',
      'prefix': '0317',
      'pinYin': 'bo tou shi'
    }, {
      'provinceID': 7,
      'cityID': 297,
      'title': '任丘市',
      'prefix': '0317',
      'pinYin': 'ren qiu shi'
    }, {
      'provinceID': 7,
      'cityID': 298,
      'title': '黄骅市',
      'prefix': '0317',
      'pinYin': 'huang  shi'
    }, {
      'provinceID': 7,
      'cityID': 299,
      'title': '河间市',
      'prefix': '0317',
      'pinYin': 'he jian shi'
    }, {
      'provinceID': 7,
      'cityID': 312,
      'title': '迁安市',
      'prefix': '0315',
      'pinYin': 'qian an shi'
    }, {
      'provinceID': 7,
      'cityID': 317,
      'title': '遵化市',
      'prefix': '0315',
      'pinYin': 'zun hua shi'
    }, {
      'provinceID': 7,
      'cityID': 327,
      'title': '三河市',
      'prefix': '0316',
      'pinYin': 'san he shi'
    }, {
      'provinceID': 7,
      'cityID': 2234,
      'title': '定州市',
      'prefix': '0312',
      'pinYin': 'ding zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2235,
      'title': '安国市',
      'prefix': '0312',
      'pinYin': 'an guo shi'
    }, {
      'provinceID': 7,
      'cityID': 2240,
      'title': '涿州市',
      'prefix': '0312',
      'pinYin': 'zhuo zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2241,
      'title': '高碑店市',
      'prefix': '0312',
      'pinYin': 'gao bei dian shi'
    }, {
      'provinceID': 7,
      'cityID': 2253,
      'title': '辛集市',
      'prefix': '0311',
      'pinYin': 'xin ji shi'
    }, {
      'provinceID': 7,
      'cityID': 2254,
      'title': '晋州市',
      'prefix': '0311',
      'pinYin': 'jin zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2255,
      'title': '藁城市',
      'prefix': '0311',
      'pinYin': 'gao cheng shi'
    }, {
      'provinceID': 7,
      'cityID': 2256,
      'title': '新乐市',
      'prefix': '0311',
      'pinYin': 'xin le shi'
    }, {
      'provinceID': 7,
      'cityID': 2257,
      'title': '鹿泉市',
      'prefix': '0311',
      'pinYin': 'lu quan shi'
    }, {
      'provinceID': 7,
      'cityID': 2268,
      'title': '沙河市',
      'prefix': '0319',
      'pinYin': 'sha he shi'
    }, {
      'provinceID': 7,
      'cityID': 2271,
      'title': '南宫市',
      'prefix': '0319',
      'pinYin': 'nan gong shi'
    }, {
      'provinceID': 7,
      'cityID': 2277,
      'title': '冀州市',
      'prefix': '0318',
      'pinYin': 'ji zhou shi'
    }, {
      'provinceID': 7,
      'cityID': 2278,
      'title': '深州市',
      'prefix': '0318',
      'pinYin': 'shen zhou shi'
    }, {
      'provinceID': 8,
      'cityID': 352,
      'title': '沈阳市',
      'prefix': '024',
      'pinYin': 'shen yang shi'
    }, {
      'provinceID': 8,
      'cityID': 353,
      'title': '大连市',
      'prefix': '0411',
      'pinYin': 'da lian shi'
    }, {
      'provinceID': 8,
      'cityID': 354,
      'title': '鞍山市',
      'prefix': '0412',
      'pinYin': 'an shan shi'
    }, {
      'provinceID': 8,
      'cityID': 355,
      'title': '抚顺市',
      'prefix': '0413',
      'pinYin': 'fu shun shi'
    }, {
      'provinceID': 8,
      'cityID': 356,
      'title': '本溪市',
      'prefix': '0414',
      'pinYin': 'ben xi shi'
    }, {
      'provinceID': 8,
      'cityID': 357,
      'title': '丹东市',
      'prefix': '0415',
      'pinYin': 'dan dong shi'
    }, {
      'provinceID': 8,
      'cityID': 358,
      'title': '锦州市',
      'prefix': '0416',
      'pinYin': 'jin zhou shi'
    }, {
      'provinceID': 8,
      'cityID': 359,
      'title': '葫芦岛市',
      'prefix': '0429',
      'pinYin': 'hu lu dao shi'
    }, {
      'provinceID': 8,
      'cityID': 360,
      'title': '营口市',
      'prefix': '0417',
      'pinYin': 'ying kou shi'
    }, {
      'provinceID': 8,
      'cityID': 361,
      'title': '阜新市',
      'prefix': '0418',
      'pinYin': 'fu xin shi'
    }, {
      'provinceID': 8,
      'cityID': 362,
      'title': '辽阳市',
      'prefix': '0419',
      'pinYin': 'liao yang shi'
    }, {
      'provinceID': 8,
      'cityID': 363,
      'title': '铁岭市',
      'prefix': '0410',
      'pinYin': 'tie ling shi'
    }, {
      'provinceID': 8,
      'cityID': 364,
      'title': '朝阳市',
      'prefix': '0421',
      'pinYin': 'chao yang shi'
    }, {
      'provinceID': 8,
      'cityID': 2207,
      'title': '盘锦市',
      'prefix': '0427',
      'pinYin': 'pan jin shi'
    }, {
      'provinceID': 8,
      'cityID': 365,
      'title': '瓦房店市',
      'prefix': '0411',
      'pinYin': 'wa fang dian shi'
    }, {
      'provinceID': 8,
      'cityID': 366,
      'title': '海城市',
      'prefix': '0412',
      'pinYin': 'hai cheng shi'
    }, {
      'provinceID': 8,
      'cityID': 367,
      'title': '兴城市',
      'prefix': '0429',
      'pinYin': 'xing cheng shi'
    }, {
      'provinceID': 8,
      'cityID': 368,
      'title': '调兵山市',
      'prefix': '0410',
      'pinYin': 'tie fa shi'
    }, {
      'provinceID': 8,
      'cityID': 369,
      'title': '北票市',
      'prefix': '0421',
      'pinYin': 'bei piao shi'
    }, {
      'provinceID': 8,
      'cityID': 370,
      'title': '开原市',
      'prefix': '0410',
      'pinYin': 'kai yuan shi'
    }, {
      'provinceID': 8,
      'cityID': 371,
      'title': '新民市',
      'prefix': '024',
      'pinYin': 'xin min shi'
    }, {
      'provinceID': 8,
      'cityID': 374,
      'title': '庄河市',
      'prefix': '0411',
      'pinYin': 'zhuang he shi'
    }, {
      'provinceID': 8,
      'cityID': 384,
      'title': '凤城市',
      'prefix': '0415',
      'pinYin': 'feng cheng shi'
    }, {
      'provinceID': 8,
      'cityID': 389,
      'title': '北镇市',
      'prefix': '0416',
      'pinYin': 'bei zhen shi'
    }, {
      'provinceID': 8,
      'cityID': 397,
      'title': '灯塔市',
      'prefix': '0419',
      'pinYin': 'deng ta shi'
    }, {
      'provinceID': 8,
      'cityID': 404,
      'title': '凌源市',
      'prefix': '0421',
      'pinYin': 'ling yuan shi'
    }, {
      'provinceID': 8,
      'cityID': 2347,
      'title': '盖州市',
      'prefix': '0417',
      'pinYin': 'gai zhou shi'
    }, {
      'provinceID': 8,
      'cityID': 2351,
      'title': '东港市',
      'prefix': '0415',
      'pinYin': 'dong gang shi'
    }, {
      'provinceID': 8,
      'cityID': 2534,
      'title': '普兰店市',
      'prefix': '0411',
      'pinYin': 'pu lan dian shi'
    }, {
      'provinceID': 8,
      'cityID': 2535,
      'title': '凌海市',
      'prefix': '0416',
      'pinYin': 'ling hai shi'
    }, {
      'provinceID': 8,
      'cityID': 2625,
      'title': '大石桥市',
      'prefix': '0417',
      'pinYin': 'da shi qiao shi'
    }, {
      'provinceID': 9,
      'cityID': 407,
      'title': '长春市',
      'prefix': '0431',
      'pinYin': 'chang chun shi'
    }, {
      'provinceID': 9,
      'cityID': 408,
      'title': '吉林市',
      'prefix': '0432',
      'pinYin': 'ji lin shi'
    }, {
      'provinceID': 9,
      'cityID': 409,
      'title': '四平市',
      'prefix': '0434',
      'pinYin': 'si ping shi'
    }, {
      'provinceID': 9,
      'cityID': 410,
      'title': '辽源市',
      'prefix': '0437',
      'pinYin': 'liao yuan shi'
    }, {
      'provinceID': 9,
      'cityID': 411,
      'title': '通化市',
      'prefix': '0435',
      'pinYin': 'tong hua shi'
    }, {
      'provinceID': 9,
      'cityID': 420,
      'title': '白城市',
      'prefix': '0436',
      'pinYin': 'bai cheng shi'
    }, {
      'provinceID': 9,
      'cityID': 2352,
      'title': '白山市',
      'prefix': '0439',
      'pinYin': 'bai shan shi'
    }, {
      'provinceID': 9,
      'cityID': 2353,
      'title': '松原市',
      'prefix': '0438',
      'pinYin': 'song yuan shi'
    }, {
      'provinceID': 9,
      'cityID': 2623,
      'title': '延边朝鲜族自治州',
      'prefix': '0433',
      'pinYin': 'yan bian chao xian zi zhi zhou'
    }, {
      'provinceID': 9,
      'cityID': 413,
      'title': '公主岭市',
      'prefix': '0434',
      'pinYin': 'gong zhu ling shi'
    }, {
      'provinceID': 9,
      'cityID': 414,
      'title': '梅河口市',
      'prefix': '0435',
      'pinYin': 'mei he kou shi'
    }, {
      'provinceID': 9,
      'cityID': 415,
      'title': '集安市',
      'prefix': '0435',
      'pinYin': 'ji an shi'
    }, {
      'provinceID': 9,
      'cityID': 416,
      'title': '九台市',
      'prefix': '0431',
      'pinYin': 'jiu tai shi'
    }, {
      'provinceID': 9,
      'cityID': 417,
      'title': '桦甸市',
      'prefix': '0432',
      'pinYin': 'dian shi'
    }, {
      'provinceID': 9,
      'cityID': 418,
      'title': '蛟河市',
      'prefix': '0432',
      'pinYin': 'he shi'
    }, {
      'provinceID': 9,
      'cityID': 419,
      'title': '榆树市',
      'prefix': '0431',
      'pinYin': 'yu shu shi'
    }, {
      'provinceID': 9,
      'cityID': 421,
      'title': '洮南市',
      'prefix': '0436',
      'pinYin': 'nan shi'
    }, {
      'provinceID': 9,
      'cityID': 423,
      'title': '大安市',
      'prefix': '0436',
      'pinYin': 'da an shi'
    }, {
      'provinceID': 9,
      'cityID': 424,
      'title': '延吉市',
      'prefix': '0433',
      'pinYin': 'yan ji shi'
    }, {
      'provinceID': 9,
      'cityID': 425,
      'title': '图们市',
      'prefix': '0433',
      'pinYin': 'tu men shi'
    }, {
      'provinceID': 9,
      'cityID': 426,
      'title': '敦化市',
      'prefix': '0433',
      'pinYin': 'dun hua shi'
    }, {
      'provinceID': 9,
      'cityID': 427,
      'title': '龙井市',
      'prefix': '0433',
      'pinYin': 'long jing shi'
    }, {
      'provinceID': 9,
      'cityID': 428,
      'title': '珲春市',
      'prefix': '0433',
      'pinYin': 'chun shi'
    }, {
      'provinceID': 9,
      'cityID': 431,
      'title': '德惠市',
      'prefix': '0431',
      'pinYin': 'de hui shi'
    }, {
      'provinceID': 9,
      'cityID': 433,
      'title': '磐石市',
      'prefix': '0432',
      'pinYin': 'pan shi shi'
    }, {
      'provinceID': 9,
      'cityID': 434,
      'title': '舒兰市',
      'prefix': '0432',
      'pinYin': 'shu lan shi'
    }, {
      'provinceID': 9,
      'cityID': 436,
      'title': '双辽市',
      'prefix': '0434',
      'pinYin': 'shuang liao shi'
    }, {
      'provinceID': 9,
      'cityID': 453,
      'title': '和龙市',
      'prefix': '0433',
      'pinYin': 'he long shi'
    }, {
      'provinceID': 9,
      'cityID': 2354,
      'title': '临江市',
      'prefix': '0439',
      'pinYin': 'lin jiang shi'
    }, {
      'provinceID': 10,
      'cityID': 454,
      'title': '哈尔滨市',
      'prefix': '0451',
      'pinYin': 'ha er bin shi'
    }, {
      'provinceID': 10,
      'cityID': 455,
      'title': '齐齐哈尔市',
      'prefix': '0452',
      'pinYin': 'qi qi ha er shi'
    }, {
      'provinceID': 10,
      'cityID': 456,
      'title': '鹤岗市',
      'prefix': '0468',
      'pinYin': 'he gang shi'
    }, {
      'provinceID': 10,
      'cityID': 457,
      'title': '双鸭山市',
      'prefix': '0469',
      'pinYin': 'shuang ya shan shi'
    }, {
      'provinceID': 10,
      'cityID': 458,
      'title': '鸡西市',
      'prefix': '0467',
      'pinYin': 'ji xi shi'
    }, {
      'provinceID': 10,
      'cityID': 459,
      'title': '大庆市',
      'prefix': '0459',
      'pinYin': 'da qing shi'
    }, {
      'provinceID': 10,
      'cityID': 460,
      'title': '伊春市',
      'prefix': '0458',
      'pinYin': 'yi chun shi'
    }, {
      'provinceID': 10,
      'cityID': 461,
      'title': '牡丹江市',
      'prefix': '0453',
      'pinYin': 'mu dan jiang shi'
    }, {
      'provinceID': 10,
      'cityID': 462,
      'title': '佳木斯市',
      'prefix': '0454',
      'pinYin': 'jia mu si shi'
    }, {
      'provinceID': 10,
      'cityID': 463,
      'title': '七台河市',
      'prefix': '0464',
      'pinYin': 'qi tai he shi'
    }, {
      'provinceID': 10,
      'cityID': 470,
      'title': '绥化市',
      'prefix': '0455',
      'pinYin': 'sui hua shi'
    }, {
      'provinceID': 10,
      'cityID': 474,
      'title': '黑河市',
      'prefix': '0456',
      'pinYin': 'hei he shi'
    }, {
      'provinceID': 10,
      'cityID': 534,
      'title': '大兴安岭地区',
      'prefix': '0457',
      'pinYin': 'da xing an ling di qu'
    }, {
      'provinceID': 10,
      'cityID': 464,
      'title': '绥芬河市',
      'prefix': '0453',
      'pinYin': 'sui fen he shi'
    }, {
      'provinceID': 10,
      'cityID': 466,
      'title': '同江市',
      'prefix': '0454',
      'pinYin': 'tong jiang shi'
    }, {
      'provinceID': 10,
      'cityID': 467,
      'title': '富锦市',
      'prefix': '0454',
      'pinYin': 'fu jin shi'
    }, {
      'provinceID': 10,
      'cityID': 468,
      'title': '铁力市',
      'prefix': '0458',
      'pinYin': 'tie li shi'
    }, {
      'provinceID': 10,
      'cityID': 469,
      'title': '密山市',
      'prefix': '0467',
      'pinYin': 'mi shan shi'
    }, {
      'provinceID': 10,
      'cityID': 471,
      'title': '安达市',
      'prefix': '0455',
      'pinYin': 'an da shi'
    }, {
      'provinceID': 10,
      'cityID': 472,
      'title': '肇东市',
      'prefix': '0455',
      'pinYin': 'zhao dong shi'
    }, {
      'provinceID': 10,
      'cityID': 473,
      'title': '海伦市',
      'prefix': '0455',
      'pinYin': 'hai lun shi'
    }, {
      'provinceID': 10,
      'cityID': 475,
      'title': '北安市',
      'prefix': '0456',
      'pinYin': 'bei an shi'
    }, {
      'provinceID': 10,
      'cityID': 476,
      'title': '五大连池市',
      'prefix': '0456',
      'pinYin': 'wu da lian chi shi'
    }, {
      'provinceID': 10,
      'cityID': 477,
      'title': '尚志市',
      'prefix': '0451',
      'pinYin': 'shang zhi shi'
    }, {
      'provinceID': 10,
      'cityID': 478,
      'title': '双城市',
      'prefix': '0451',
      'pinYin': 'shuang cheng shi'
    }, {
      'provinceID': 10,
      'cityID': 483,
      'title': '讷河市',
      'prefix': '0452',
      'pinYin': 'ne he shi'
    }, {
      'provinceID': 10,
      'cityID': 499,
      'title': '海林市',
      'prefix': '0453',
      'pinYin': 'hai lin shi'
    }, {
      'provinceID': 10,
      'cityID': 500,
      'title': '穆棱市',
      'prefix': '0453',
      'pinYin': 'mu leng shi'
    }, {
      'provinceID': 10,
      'cityID': 501,
      'title': '虎林市',
      'prefix': '0467',
      'pinYin': 'hu lin shi'
    }, {
      'provinceID': 10,
      'cityID': 502,
      'title': '宁安市',
      'prefix': '0453',
      'pinYin': 'ning an shi'
    }, {
      'provinceID': 10,
      'cityID': 528,
      'title': '五常市',
      'prefix': '0451',
      'pinYin': 'wu chang shi'
    }, {
      'provinceID': 11,
      'cityID': 535,
      'title': '南京市',
      'prefix': '025',
      'pinYin': 'nan jing shi'
    }, {
      'provinceID': 11,
      'cityID': 536,
      'title': '徐州市',
      'prefix': '0516',
      'pinYin': 'xu zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 537,
      'title': '连云港市',
      'prefix': '0518',
      'pinYin': 'lian yun gang shi'
    }, {
      'provinceID': 11,
      'cityID': 539,
      'title': '盐城市',
      'prefix': '0515',
      'pinYin': 'yan cheng shi'
    }, {
      'provinceID': 11,
      'cityID': 540,
      'title': '扬州市',
      'prefix': '0514',
      'pinYin': 'yang zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 541,
      'title': '南通市',
      'prefix': '0513',
      'pinYin': 'nan tong shi'
    }, {
      'provinceID': 11,
      'cityID': 542,
      'title': '镇江市',
      'prefix': '0511',
      'pinYin': 'zhen jiang shi'
    }, {
      'provinceID': 11,
      'cityID': 544,
      'title': '常州市',
      'prefix': '0519',
      'pinYin': 'chang zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 545,
      'title': '无锡市',
      'prefix': '0510',
      'pinYin': 'wu xi shi'
    }, {
      'provinceID': 11,
      'cityID': 546,
      'title': '苏州市',
      'prefix': '0512',
      'pinYin': 'su zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 547,
      'title': '泰州市',
      'prefix': '0523',
      'pinYin': 'tai zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 552,
      'title': '宿迁市',
      'prefix': '0527',
      'pinYin': 'su qian shi'
    }, {
      'provinceID': 11,
      'cityID': 556,
      'title': '淮安市',
      'prefix': '0517',
      'pinYin': 'huai an shi'
    }, {
      'provinceID': 11,
      'cityID': 548,
      'title': '仪征市',
      'prefix': '0514',
      'pinYin': 'yi zheng shi'
    }, {
      'provinceID': 11,
      'cityID': 549,
      'title': '常熟市',
      'prefix': '0512',
      'pinYin': 'chang shu shi'
    }, {
      'provinceID': 11,
      'cityID': 550,
      'title': '张家港市',
      'prefix': '0512',
      'pinYin': 'zhang jia gang shi'
    }, {
      'provinceID': 11,
      'cityID': 551,
      'title': '江阴市',
      'prefix': '0510',
      'pinYin': 'jiang yin shi'
    }, {
      'provinceID': 11,
      'cityID': 553,
      'title': '丹阳市',
      'prefix': '0511',
      'pinYin': 'dan yang shi'
    }, {
      'provinceID': 11,
      'cityID': 554,
      'title': '东台市',
      'prefix': '0515',
      'pinYin': 'dong tai shi'
    }, {
      'provinceID': 11,
      'cityID': 555,
      'title': '兴化市',
      'prefix': '0523',
      'pinYin': 'xing hua shi'
    }, {
      'provinceID': 11,
      'cityID': 557,
      'title': '宜兴市',
      'prefix': '0510',
      'pinYin': 'yi xing shi'
    }, {
      'provinceID': 11,
      'cityID': 558,
      'title': '昆山市',
      'prefix': '0512',
      'pinYin': 'kun shan shi'
    }, {
      'provinceID': 11,
      'cityID': 559,
      'title': '启东市',
      'prefix': '0513',
      'pinYin': 'qi dong shi'
    }, {
      'provinceID': 11,
      'cityID': 560,
      'title': '新沂市',
      'prefix': '0516',
      'pinYin': 'xin yi shi'
    }, {
      'provinceID': 11,
      'cityID': 561,
      'title': '溧阳市',
      'prefix': '0519',
      'pinYin': 'yang shi'
    }, {
      'provinceID': 11,
      'cityID': 589,
      'title': '大丰市',
      'prefix': '0515',
      'pinYin': 'da feng shi'
    }, {
      'provinceID': 11,
      'cityID': 592,
      'title': '泰兴市',
      'prefix': '0523',
      'pinYin': 'tai xing shi'
    }, {
      'provinceID': 11,
      'cityID': 594,
      'title': '江都市',
      'prefix': '0514',
      'pinYin': 'jiang du shi'
    }, {
      'provinceID': 11,
      'cityID': 595,
      'title': '靖江市',
      'prefix': '0523',
      'pinYin': 'jing jiang shi'
    }, {
      'provinceID': 11,
      'cityID': 596,
      'title': '高邮市',
      'prefix': '0514',
      'pinYin': 'gao you shi'
    }, {
      'provinceID': 11,
      'cityID': 598,
      'title': '如皋市',
      'prefix': '0513',
      'pinYin': 'ru gao shi'
    }, {
      'provinceID': 11,
      'cityID': 600,
      'title': '海门市',
      'prefix': '0513',
      'pinYin': 'hai men shi'
    }, {
      'provinceID': 11,
      'cityID': 603,
      'title': '句容市',
      'prefix': '0511',
      'pinYin': 'ju rong shi'
    }, {
      'provinceID': 11,
      'cityID': 604,
      'title': '扬中市',
      'prefix': '0511',
      'pinYin': 'yang zhong shi'
    }, {
      'provinceID': 11,
      'cityID': 606,
      'title': '金坛市',
      'prefix': '0519',
      'pinYin': 'jin tan shi'
    }, {
      'provinceID': 11,
      'cityID': 609,
      'title': '吴江市',
      'prefix': '0512',
      'pinYin': 'wu jiang shi'
    }, {
      'provinceID': 11,
      'cityID': 610,
      'title': '太仓市',
      'prefix': '0512',
      'pinYin': 'tai cang shi'
    }, {
      'provinceID': 11,
      'cityID': 2211,
      'title': '通州市',
      'prefix': '0513',
      'pinYin': 'tong zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 2359,
      'title': '邳州市',
      'prefix': '0516',
      'pinYin': 'pi zhou shi'
    }, {
      'provinceID': 11,
      'cityID': 2624,
      'title': '姜堰市',
      'prefix': '0523',
      'pinYin': 'jiang yan shi'
    }, {
      'provinceID': 12,
      'cityID': 611,
      'title': '合肥市',
      'prefix': '0551',
      'pinYin': 'he fei shi'
    }, {
      'provinceID': 12,
      'cityID': 612,
      'title': '淮南市',
      'prefix': '0554',
      'pinYin': 'huai nan shi'
    }, {
      'provinceID': 12,
      'cityID': 613,
      'title': '淮北市',
      'prefix': '0561',
      'pinYin': 'huai bei shi'
    }, {
      'provinceID': 12,
      'cityID': 614,
      'title': '芜湖市',
      'prefix': '0553',
      'pinYin': 'wu hu shi'
    }, {
      'provinceID': 12,
      'cityID': 615,
      'title': '铜陵市',
      'prefix': '0562',
      'pinYin': 'tong ling shi'
    }, {
      'provinceID': 12,
      'cityID': 616,
      'title': '蚌埠市',
      'prefix': '0552',
      'pinYin': 'bang bu shi'
    }, {
      'provinceID': 12,
      'cityID': 617,
      'title': '马鞍山市',
      'prefix': '0555',
      'pinYin': 'ma an shan shi'
    }, {
      'provinceID': 12,
      'cityID': 618,
      'title': '安庆市',
      'prefix': '0556',
      'pinYin': 'an qing shi'
    }, {
      'provinceID': 12,
      'cityID': 619,
      'title': '黄山市',
      'prefix': '0559',
      'pinYin': 'huang shan shi'
    }, {
      'provinceID': 12,
      'cityID': 620,
      'title': '宿州市',
      'prefix': '0557',
      'pinYin': 'su zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 621,
      'title': '滁州市',
      'prefix': '0550',
      'pinYin': 'chu zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 622,
      'title': '巢湖市',
      'prefix': '0565',
      'pinYin': 'chao hu shi'
    }, {
      'provinceID': 12,
      'cityID': 626,
      'title': '六安市',
      'prefix': '0564',
      'pinYin': 'liu an shi'
    }, {
      'provinceID': 12,
      'cityID': 627,
      'title': '阜阳市',
      'prefix': '0558',
      'pinYin': 'fu yang shi'
    }, {
      'provinceID': 12,
      'cityID': 628,
      'title': '亳州市',
      'prefix': '0558',
      'pinYin': 'hao zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 2368,
      'title': '宣城市',
      'prefix': '0563',
      'pinYin': 'xuan cheng shi'
    }, {
      'provinceID': 12,
      'cityID': 2602,
      'title': '池州市',
      'prefix': '0566',
      'pinYin': 'chi zhou shi'
    }, {
      'provinceID': 12,
      'cityID': 629,
      'title': '界首市',
      'prefix': '0558',
      'pinYin': 'jie shou shi'
    }, {
      'provinceID': 12,
      'cityID': 643,
      'title': '桐城市',
      'prefix': '0556',
      'pinYin': 'tong cheng shi'
    }, {
      'provinceID': 12,
      'cityID': 663,
      'title': '天长市',
      'prefix': '0550',
      'pinYin': 'tian chang shi'
    }, {
      'provinceID': 12,
      'cityID': 671,
      'title': '宁国市',
      'prefix': '0563',
      'pinYin': 'ning guo shi'
    }, {
      'provinceID': 12,
      'cityID': 2366,
      'title': '明光市',
      'prefix': '0550',
      'pinYin': 'ming guang shi'
    }, {
      'provinceID': 13,
      'cityID': 692,
      'title': '济南市',
      'prefix': '0531',
      'pinYin': 'ji nan shi'
    }, {
      'provinceID': 13,
      'cityID': 693,
      'title': '青岛市',
      'prefix': '0532',
      'pinYin': 'qing dao shi'
    }, {
      'provinceID': 13,
      'cityID': 694,
      'title': '淄博市',
      'prefix': '0533',
      'pinYin': 'zi bo shi'
    }, {
      'provinceID': 13,
      'cityID': 695,
      'title': '枣庄市',
      'prefix': '0632',
      'pinYin': 'zao zhuang shi'
    }, {
      'provinceID': 13,
      'cityID': 696,
      'title': '东营市',
      'prefix': '0546',
      'pinYin': 'dong ying shi'
    }, {
      'provinceID': 13,
      'cityID': 698,
      'title': '烟台市',
      'prefix': '0535',
      'pinYin': 'yan tai shi'
    }, {
      'provinceID': 13,
      'cityID': 699,
      'title': '威海市',
      'prefix': '0631',
      'pinYin': 'wei hai shi'
    }, {
      'provinceID': 13,
      'cityID': 700,
      'title': '济宁市',
      'prefix': '0537',
      'pinYin': 'ji ning shi'
    }, {
      'provinceID': 13,
      'cityID': 701,
      'title': '泰安市',
      'prefix': '0538',
      'pinYin': 'tai an shi'
    }, {
      'provinceID': 13,
      'cityID': 702,
      'title': '日照市',
      'prefix': '0633',
      'pinYin': 'ri zhao shi'
    }, {
      'provinceID': 13,
      'cityID': 706,
      'title': '莱芜市',
      'prefix': '0634',
      'pinYin': 'lai wu shi'
    }, {
      'provinceID': 13,
      'cityID': 719,
      'title': '德州市',
      'prefix': '0534',
      'pinYin': 'de zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 721,
      'title': '滨州市',
      'prefix': '0543',
      'pinYin': 'bin zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 722,
      'title': '临沂市',
      'prefix': '0539',
      'pinYin': 'lin yi shi'
    }, {
      'provinceID': 13,
      'cityID': 724,
      'title': '聊城市',
      'prefix': '0635',
      'pinYin': 'liao cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 2208,
      'title': '潍坊市',
      'prefix': '0536',
      'pinYin': 'wei fang shi'
    }, {
      'provinceID': 13,
      'cityID': 2209,
      'title': '菏泽市',
      'prefix': '0530',
      'pinYin': 'he ze shi'
    }, {
      'provinceID': 13,
      'cityID': 703,
      'title': '青州市',
      'prefix': '0536',
      'pinYin': 'qing zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 704,
      'title': '龙口市',
      'prefix': '0535',
      'pinYin': 'long kou shi'
    }, {
      'provinceID': 13,
      'cityID': 705,
      'title': '曲阜市',
      'prefix': '0537',
      'pinYin': 'qu fu shi'
    }, {
      'provinceID': 13,
      'cityID': 707,
      'title': '新泰市',
      'prefix': '0538',
      'pinYin': 'xin tai shi'
    }, {
      'provinceID': 13,
      'cityID': 708,
      'title': '胶州市',
      'prefix': '0532',
      'pinYin': 'jiao zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 709,
      'title': '诸城市',
      'prefix': '0536',
      'pinYin': 'zhu cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 710,
      'title': '莱阳市',
      'prefix': '0535',
      'pinYin': 'lai yang shi'
    }, {
      'provinceID': 13,
      'cityID': 711,
      'title': '莱州市',
      'prefix': '0535',
      'pinYin': 'lai zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 712,
      'title': '滕州市',
      'prefix': '0632',
      'pinYin': 'zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 713,
      'title': '文登市',
      'prefix': '0631',
      'pinYin': 'wen deng shi'
    }, {
      'provinceID': 13,
      'cityID': 714,
      'title': '荣成市',
      'prefix': '0631',
      'pinYin': 'rong cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 715,
      'title': '即墨市',
      'prefix': '0532',
      'pinYin': 'ji mo shi'
    }, {
      'provinceID': 13,
      'cityID': 716,
      'title': '平度市',
      'prefix': '0532',
      'pinYin': 'ping du shi'
    }, {
      'provinceID': 13,
      'cityID': 717,
      'title': '莱西市',
      'prefix': '0532',
      'pinYin': 'lai xi shi'
    }, {
      'provinceID': 13,
      'cityID': 718,
      'title': '胶南市',
      'prefix': '0532',
      'pinYin': 'jiao nan shi'
    }, {
      'provinceID': 13,
      'cityID': 720,
      'title': '乐陵市',
      'prefix': '0534',
      'pinYin': 'le ling shi'
    }, {
      'provinceID': 13,
      'cityID': 725,
      'title': '临清市',
      'prefix': '0635',
      'pinYin': 'lin qing shi'
    }, {
      'provinceID': 13,
      'cityID': 726,
      'title': '章丘市',
      'prefix': '0531',
      'pinYin': 'zhang qiu shi'
    }, {
      'provinceID': 13,
      'cityID': 737,
      'title': '昌邑市',
      'prefix': '0536',
      'pinYin': 'chang yi shi'
    }, {
      'provinceID': 13,
      'cityID': 739,
      'title': '高密市',
      'prefix': '0536',
      'pinYin': 'gao mi shi'
    }, {
      'provinceID': 13,
      'cityID': 742,
      'title': '安丘市',
      'prefix': '0536',
      'pinYin': 'an qiu shi'
    }, {
      'provinceID': 13,
      'cityID': 743,
      'title': '寿光市',
      'prefix': '0536',
      'pinYin': 'shou guang shi'
    }, {
      'provinceID': 13,
      'cityID': 745,
      'title': '招远市',
      'prefix': '0535',
      'pinYin': 'zhao yuan shi'
    }, {
      'provinceID': 13,
      'cityID': 746,
      'title': '栖霞市',
      'prefix': '0535',
      'pinYin': 'qi xia shi'
    }, {
      'provinceID': 13,
      'cityID': 747,
      'title': '海阳市',
      'prefix': '0535',
      'pinYin': 'hai yang shi'
    }, {
      'provinceID': 13,
      'cityID': 748,
      'title': '蓬莱市',
      'prefix': '0535',
      'pinYin': 'peng lai shi'
    }, {
      'provinceID': 13,
      'cityID': 750,
      'title': '乳山市',
      'prefix': '0631',
      'pinYin': 'ru shan shi'
    }, {
      'provinceID': 13,
      'cityID': 751,
      'title': '兖州市',
      'prefix': '0537',
      'pinYin': 'yan zhou shi'
    }, {
      'provinceID': 13,
      'cityID': 762,
      'title': '肥城市',
      'prefix': '0538',
      'pinYin': 'fei cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 766,
      'title': '禹城市',
      'prefix': '0534',
      'pinYin': 'yu cheng shi'
    }, {
      'provinceID': 13,
      'cityID': 2396,
      'title': '邹城市',
      'prefix': '0537',
      'pinYin': 'zou cheng shi'
    }, {
      'provinceID': 14,
      'cityID': 802,
      'title': '杭州市',
      'prefix': '0571',
      'pinYin': 'hang zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 803,
      'title': '宁波市',
      'prefix': '0574',
      'pinYin': 'ning bo shi'
    }, {
      'provinceID': 14,
      'cityID': 804,
      'title': '温州市',
      'prefix': '0577',
      'pinYin': 'wen zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 805,
      'title': '嘉兴市',
      'prefix': '0573',
      'pinYin': 'jia xing shi'
    }, {
      'provinceID': 14,
      'cityID': 806,
      'title': '湖州市',
      'prefix': '0572',
      'pinYin': 'hu zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 807,
      'title': '绍兴市',
      'prefix': '0575',
      'pinYin': 'shao xing shi'
    }, {
      'provinceID': 14,
      'cityID': 808,
      'title': '金华市',
      'prefix': '0579',
      'pinYin': 'jin hua shi'
    }, {
      'provinceID': 14,
      'cityID': 809,
      'title': '衢州市',
      'prefix': '0570',
      'pinYin': 'zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 810,
      'title': '舟山市',
      'prefix': '0580',
      'pinYin': 'zhou shan shi'
    }, {
      'provinceID': 14,
      'cityID': 826,
      'title': '丽水市',
      'prefix': '0578',
      'pinYin': 'li shui shi'
    }, {
      'provinceID': 14,
      'cityID': 2216,
      'title': '台州市',
      'prefix': '0576',
      'pinYin': 'tai zhou shi'
    }, {
      'provinceID': 14,
      'cityID': 811,
      'title': '余姚市',
      'prefix': '0574',
      'pinYin': 'yu yao shi'
    }, {
      'provinceID': 14,
      'cityID': 812,
      'title': '海宁市',
      'prefix': '0573',
      'pinYin': 'hai ning shi'
    }, {
      'provinceID': 14,
      'cityID': 813,
      'title': '兰溪市',
      'prefix': '0579',
      'pinYin': 'lan xi shi'
    }, {
      'provinceID': 14,
      'cityID': 814,
      'title': '瑞安市',
      'prefix': '0577',
      'pinYin': 'rui an shi'
    }, {
      'provinceID': 14,
      'cityID': 816,
      'title': '江山市',
      'prefix': '0570',
      'pinYin': 'jiang shan shi'
    }, {
      'provinceID': 14,
      'cityID': 818,
      'title': '东阳市',
      'prefix': '0579',
      'pinYin': 'dong yang shi'
    }, {
      'provinceID': 14,
      'cityID': 819,
      'title': '义乌市',
      'prefix': '0579',
      'pinYin': 'yi wu shi'
    }, {
      'provinceID': 14,
      'cityID': 820,
      'title': '慈溪市',
      'prefix': '0574',
      'pinYin': 'ci xi shi'
    }, {
      'provinceID': 14,
      'cityID': 821,
      'title': '奉化市',
      'prefix': '0574',
      'pinYin': 'feng hua shi'
    }, {
      'provinceID': 14,
      'cityID': 822,
      'title': '诸暨市',
      'prefix': '0575',
      'pinYin': 'zhu  shi'
    }, {
      'provinceID': 14,
      'cityID': 824,
      'title': '临海市',
      'prefix': '0576',
      'pinYin': 'lin hai shi'
    }, {
      'provinceID': 14,
      'cityID': 827,
      'title': '龙泉市',
      'prefix': '0578',
      'pinYin': 'long quan shi'
    }, {
      'provinceID': 14,
      'cityID': 829,
      'title': '临安市',
      'prefix': '0571',
      'pinYin': 'lin an shi'
    }, {
      'provinceID': 14,
      'cityID': 831,
      'title': '富阳市',
      'prefix': '0571',
      'pinYin': 'fu yang shi'
    }, {
      'provinceID': 14,
      'cityID': 832,
      'title': '建德市',
      'prefix': '0571',
      'pinYin': 'jian de shi'
    }, {
      'provinceID': 14,
      'cityID': 843,
      'title': '乐清市',
      'prefix': '0577',
      'pinYin': 'le qing shi'
    }, {
      'provinceID': 14,
      'cityID': 846,
      'title': '平湖市',
      'prefix': '0573',
      'pinYin': 'ping hu shi'
    }, {
      'provinceID': 14,
      'cityID': 848,
      'title': '桐乡市',
      'prefix': '0573',
      'pinYin': 'tong shig shi'
    }, {
      'provinceID': 14,
      'cityID': 855,
      'title': '上虞市',
      'prefix': '0575',
      'pinYin': 'shang yu shi'
    }, {
      'provinceID': 14,
      'cityID': 858,
      'title': '永康市',
      'prefix': '0579',
      'pinYin': 'yong kang shi'
    }, {
      'provinceID': 14,
      'cityID': 869,
      'title': '温岭市',
      'prefix': '0576',
      'pinYin': 'wen ling shi'
    }, {
      'provinceID': 14,
      'cityID': 2361,
      'title': '嵊州市',
      'prefix': '0575',
      'pinYin': 'sheng zhou shi'
    }, {
      'provinceID': 15,
      'cityID': 879,
      'title': '南昌市',
      'prefix': '0791',
      'pinYin': 'nan chang shi'
    }, {
      'provinceID': 15,
      'cityID': 880,
      'title': '景德镇市',
      'prefix': '0798',
      'pinYin': 'jing de zhen shi'
    }, {
      'provinceID': 15,
      'cityID': 881,
      'title': '萍乡市',
      'prefix': '0799',
      'pinYin': 'ping xiang shi'
    }, {
      'provinceID': 15,
      'cityID': 882,
      'title': '新余市',
      'prefix': '0790',
      'pinYin': 'xin yu shi'
    }, {
      'provinceID': 15,
      'cityID': 883,
      'title': '九江市',
      'prefix': '0792',
      'pinYin': 'jiu jiang shi'
    }, {
      'provinceID': 15,
      'cityID': 884,
      'title': '鹰潭市',
      'prefix': '0701',
      'pinYin': 'ying tan shi'
    }, {
      'provinceID': 15,
      'cityID': 886,
      'title': '上饶市',
      'prefix': '0793',
      'pinYin': 'shang rao shi'
    }, {
      'provinceID': 15,
      'cityID': 888,
      'title': '宜春市',
      'prefix': '0795',
      'pinYin': 'yi chun shi'
    }, {
      'provinceID': 15,
      'cityID': 892,
      'title': '吉安市',
      'prefix': '0796',
      'pinYin': 'ji an shi'
    }, {
      'provinceID': 15,
      'cityID': 894,
      'title': '赣州市',
      'prefix': '0797',
      'pinYin': 'gan zhou shi'
    }, {
      'provinceID': 15,
      'cityID': 2377,
      'title': '抚州市',
      'prefix': '0794',
      'pinYin': 'fu zhou shi'
    }, {
      'provinceID': 15,
      'cityID': 885,
      'title': '瑞昌市',
      'prefix': '0792',
      'pinYin': 'rui chang shi'
    }, {
      'provinceID': 15,
      'cityID': 887,
      'title': '德兴市',
      'prefix': '0793',
      'pinYin': 'de xing shi'
    }, {
      'provinceID': 15,
      'cityID': 889,
      'title': '丰城市',
      'prefix': '0795',
      'pinYin': 'feng cheng shi'
    }, {
      'provinceID': 15,
      'cityID': 890,
      'title': '樟树市',
      'prefix': '0795',
      'pinYin': 'zhang shu shi'
    }, {
      'provinceID': 15,
      'cityID': 899,
      'title': '乐平市',
      'prefix': '0798',
      'pinYin': 'le ping shi'
    }, {
      'provinceID': 15,
      'cityID': 911,
      'title': '贵溪市',
      'prefix': '0701',
      'pinYin': 'gui xi shi'
    }, {
      'provinceID': 15,
      'cityID': 925,
      'title': '高安市',
      'prefix': '0795',
      'pinYin': 'gao an shi'
    }, {
      'provinceID': 15,
      'cityID': 957,
      'title': '南康市',
      'prefix': '0797',
      'pinYin': 'nan kang shi'
    }, {
      'provinceID': 15,
      'cityID': 964,
      'title': '瑞金市',
      'prefix': '0797',
      'pinYin': 'rui jin shi'
    }, {
      'provinceID': 15,
      'cityID': 2376,
      'title': '井冈山市',
      'prefix': '0796',
      'pinYin': 'jing gang shan shi'
    }, {
      'provinceID': 16,
      'cityID': 969,
      'title': '福州市',
      'prefix': '0591',
      'pinYin': 'fu zhou shi'
    }, {
      'provinceID': 16,
      'cityID': 970,
      'title': '厦门市',
      'prefix': '0592',
      'pinYin': 'xia men shi'
    }, {
      'provinceID': 16,
      'cityID': 971,
      'title': '三明市',
      'prefix': '0598',
      'pinYin': 'san ming shi'
    }, {
      'provinceID': 16,
      'cityID': 972,
      'title': '莆田市',
      'prefix': '0594',
      'pinYin': 'pu tian shi'
    }, {
      'provinceID': 16,
      'cityID': 973,
      'title': '泉州市',
      'prefix': '0595',
      'pinYin': 'quan zhou shi'
    }, {
      'provinceID': 16,
      'cityID': 974,
      'title': '漳州市',
      'prefix': '0596',
      'pinYin': 'zhang zhou shi'
    }, {
      'provinceID': 16,
      'cityID': 978,
      'title': '南平市',
      'prefix': '0599',
      'pinYin': 'nan ping shi'
    }, {
      'provinceID': 16,
      'cityID': 981,
      'title': '宁德市',
      'prefix': '0593',
      'pinYin': 'ning de shi'
    }, {
      'provinceID': 16,
      'cityID': 983,
      'title': '龙岩市',
      'prefix': '0597',
      'pinYin': 'long yan shi'
    }, {
      'provinceID': 16,
      'cityID': 975,
      'title': '永安市',
      'prefix': '0598',
      'pinYin': 'yong an shi'
    }, {
      'provinceID': 16,
      'cityID': 976,
      'title': '石狮市',
      'prefix': '0595',
      'pinYin': 'shi shi shi'
    }, {
      'provinceID': 16,
      'cityID': 977,
      'title': '福清市',
      'prefix': '0591',
      'pinYin': 'fu qing shi'
    }, {
      'provinceID': 16,
      'cityID': 979,
      'title': '邵武市',
      'prefix': '0599',
      'pinYin': 'shao wu shi'
    }, {
      'provinceID': 16,
      'cityID': 980,
      'title': '武夷山市',
      'prefix': '0599',
      'pinYin': 'wu yi shan shi'
    }, {
      'provinceID': 16,
      'cityID': 982,
      'title': '福安市',
      'prefix': '0593',
      'pinYin': 'fu an shi'
    }, {
      'provinceID': 16,
      'cityID': 984,
      'title': '漳平市',
      'prefix': '0597',
      'pinYin': 'zhang ping shi'
    }, {
      'provinceID': 16,
      'cityID': 991,
      'title': '长乐市',
      'prefix': '0591',
      'pinYin': 'chang le shi'
    }, {
      'provinceID': 16,
      'cityID': 1007,
      'title': '南安市',
      'prefix': '0595',
      'pinYin': 'nan an shi'
    }, {
      'provinceID': 16,
      'cityID': 1008,
      'title': '晋江市',
      'prefix': '0595',
      'pinYin': 'jin jiang shi'
    }, {
      'provinceID': 16,
      'cityID': 1011,
      'title': '龙海市',
      'prefix': '0596',
      'pinYin': 'long hai shi'
    }, {
      'provinceID': 16,
      'cityID': 1020,
      'title': '建阳市',
      'prefix': '0599',
      'pinYin': 'jian yang shi'
    }, {
      'provinceID': 16,
      'cityID': 1023,
      'title': '建瓯市',
      'prefix': '0599',
      'pinYin': 'jian ou xian'
    }, {
      'provinceID': 16,
      'cityID': 1032,
      'title': '福鼎市',
      'prefix': '0593',
      'pinYin': 'fu ding shi'
    }, {
      'provinceID': 17,
      'cityID': 1040,
      'title': '长沙市',
      'prefix': '0731',
      'pinYin': 'chang sha shi'
    }, {
      'provinceID': 17,
      'cityID': 1041,
      'title': '株洲市',
      'prefix': '0731',
      'pinYin': 'zhu zhou shi'
    }, {
      'provinceID': 17,
      'cityID': 1042,
      'title': '湘潭市',
      'prefix': '0731',
      'pinYin': 'xiang tan shi'
    }, {
      'provinceID': 17,
      'cityID': 1043,
      'title': '衡阳市',
      'prefix': '0734',
      'pinYin': 'heng yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1044,
      'title': '岳阳市',
      'prefix': '0730',
      'pinYin': 'yue yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1045,
      'title': '常德市',
      'prefix': '0736',
      'pinYin': 'chang de shi'
    }, {
      'provinceID': 17,
      'cityID': 1046,
      'title': '张家界市',
      'prefix': '0744',
      'pinYin': 'da yong shi'
    }, {
      'provinceID': 17,
      'cityID': 1053,
      'title': '郴州市',
      'prefix': '0735',
      'pinYin': 'chen zhou shi'
    }, {
      'provinceID': 17,
      'cityID': 1055,
      'title': '永州市',
      'prefix': '0746',
      'pinYin': 'yong zhou shi'
    }, {
      'provinceID': 17,
      'cityID': 1057,
      'title': '娄底市',
      'prefix': '0738',
      'pinYin': 'lou di shi'
    }, {
      'provinceID': 17,
      'cityID': 1060,
      'title': '怀化市',
      'prefix': '0745',
      'pinYin': 'huai hua shi'
    }, {
      'provinceID': 17,
      'cityID': 1062,
      'title': '益阳市',
      'prefix': '0737',
      'pinYin': 'yi yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1080,
      'title': '邵阳市',
      'prefix': '0739',
      'pinYin': 'shao yang shi'
    }, {
      'provinceID': 17,
      'cityID': 2621,
      'title': '湘西土家族苗族自治州',
      'prefix': '0743',
      'pinYin': 'xiang xi tu jia zu miao zu zi zhi zhou'
    }, {
      'provinceID': 17,
      'cityID': 1047,
      'title': '醴陵市',
      'prefix': '0731',
      'pinYin': 'ling shi'
    }, {
      'provinceID': 17,
      'cityID': 1048,
      'title': '湘乡市',
      'prefix': '0731',
      'pinYin': 'xiang xiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1051,
      'title': '津市市',
      'prefix': '0736',
      'pinYin': 'jin shi shi'
    }, {
      'provinceID': 17,
      'cityID': 1052,
      'title': '韶山市',
      'prefix': '0731',
      'pinYin': 'shao shan shi'
    }, {
      'provinceID': 17,
      'cityID': 1054,
      'title': '资兴市',
      'prefix': '0735',
      'pinYin': 'zi xing shi'
    }, {
      'provinceID': 17,
      'cityID': 1058,
      'title': '冷水江市',
      'prefix': '0738',
      'pinYin': 'leng shui jiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1059,
      'title': '涟源市',
      'prefix': '0738',
      'pinYin': 'lian yuan shi'
    }, {
      'provinceID': 17,
      'cityID': 1061,
      'title': '洪江市',
      'prefix': '0745',
      'pinYin': 'hong jiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1063,
      'title': '沅江市',
      'prefix': '0737',
      'pinYin': 'jiang shi'
    }, {
      'provinceID': 17,
      'cityID': 1064,
      'title': '吉首市',
      'prefix': '0743',
      'pinYin': 'ji shou shi'
    }, {
      'provinceID': 17,
      'cityID': 1068,
      'title': '浏阳市',
      'prefix': '0731',
      'pinYin': 'liu yang shi'
    }, {
      'provinceID': 17,
      'cityID': 1076,
      'title': '武冈市',
      'prefix': '0739',
      'pinYin': 'wu gang shi'
    }, {
      'provinceID': 17,
      'cityID': 1086,
      'title': '临湘市',
      'prefix': '0730',
      'pinYin': 'lin shig shi'
    }, {
      'provinceID': 17,
      'cityID': 2416,
      'title': '耒阳市',
      'prefix': '0734',
      'pinYin': 'lei yang shi'
    }, {
      'provinceID': 17,
      'cityID': 2421,
      'title': '常宁市',
      'prefix': '0734',
      'pinYin': 'chang ning shi'
    }, {
      'provinceID': 17,
      'cityID': 2622,
      'title': '汨罗市',
      'prefix': '0730',
      'pinYin': 'mi luo shi'
    }, {
      'provinceID': 18,
      'cityID': 1138,
      'title': '武汉市',
      'prefix': '027',
      'pinYin': 'wu han shi'
    }, {
      'provinceID': 18,
      'cityID': 1139,
      'title': '黄石市',
      'prefix': '0714',
      'pinYin': 'huang shi shi'
    }, {
      'provinceID': 18,
      'cityID': 1140,
      'title': '襄樊市',
      'prefix': '0710',
      'pinYin': 'xiang fan shi'
    }, {
      'provinceID': 18,
      'cityID': 1142,
      'title': '荆州市',
      'prefix': '0716',
      'pinYin': 'jing zhou shi'
    }, {
      'provinceID': 18,
      'cityID': 1144,
      'title': '荆门市',
      'prefix': '0724',
      'pinYin': 'jing men shi'
    }, {
      'provinceID': 18,
      'cityID': 1145,
      'title': '鄂州市',
      'prefix': '0711',
      'pinYin': 'e zhou shi'
    }, {
      'provinceID': 18,
      'cityID': 1146,
      'title': '随州市',
      'prefix': '0722',
      'pinYin': 'sui zhou shi'
    }, {
      'provinceID': 18,
      'cityID': 1149,
      'title': '孝感市',
      'prefix': '0712',
      'pinYin': 'xiao gan shi'
    }, {
      'provinceID': 18,
      'cityID': 1156,
      'title': '咸宁市',
      'prefix': '0715',
      'pinYin': 'xian ning shi'
    }, {
      'provinceID': 18,
      'cityID': 1158,
      'title': '仙桃市',
      'prefix': '0728',
      'pinYin': 'xian tao shi'
    }, {
      'provinceID': 18,
      'cityID': 1160,
      'title': '天门市',
      'prefix': '0728',
      'pinYin': 'tian men shi'
    }, {
      'provinceID': 18,
      'cityID': 1162,
      'title': '潜江市',
      'prefix': '0728',
      'pinYin': 'qian jiang shi'
    }, {
      'provinceID': 18,
      'cityID': 1163,
      'title': '宜昌市',
      'prefix': '0717',
      'pinYin': 'yi chang shi'
    }, {
      'provinceID': 18,
      'cityID': 1166,
      'title': '十堰市',
      'prefix': '0719',
      'pinYin': 'shi yan shi'
    }, {
      'provinceID': 18,
      'cityID': 1180,
      'title': '神农架林区',
      'prefix': '0719',
      'pinYin': 'shen nong jia lin qu'
    }, {
      'provinceID': 18,
      'cityID': 2412,
      'title': '黄冈市',
      'prefix': '0713',
      'pinYin': 'huang gang shi'
    }, {
      'provinceID': 18,
      'cityID': 2618,
      'title': '恩施土家族苗族自治州',
      'prefix': '0718',
      'pinYin': 'en shi tu jia zu miao zu zi zhi zhou'
    }, {
      'provinceID': 18,
      'cityID': 1147,
      'title': '老河口市',
      'prefix': '0710',
      'pinYin': 'lao he kou shi'
    }, {
      'provinceID': 18,
      'cityID': 1148,
      'title': '枣阳市',
      'prefix': '0710',
      'pinYin': 'zao yang shi'
    }, {
      'provinceID': 18,
      'cityID': 1150,
      'title': '应城市',
      'prefix': '0712',
      'pinYin': 'ying cheng shi'
    }, {
      'provinceID': 18,
      'cityID': 1151,
      'title': '安陆市',
      'prefix': '0712',
      'pinYin': 'an lu shi'
    }, {
      'provinceID': 18,
      'cityID': 1152,
      'title': '广水市',
      'prefix': '0722',
      'pinYin': 'guang shui shi'
    }, {
      'provinceID': 18,
      'cityID': 1153,
      'title': '麻城市',
      'prefix': '0713',
      'pinYin': 'ma cheng shi'
    }, {
      'provinceID': 18,
      'cityID': 1154,
      'title': '武穴市',
      'prefix': '0713',
      'pinYin': 'wu xue shi'
    }, {
      'provinceID': 18,
      'cityID': 1159,
      'title': '石首市',
      'prefix': '0716',
      'pinYin': 'shi shou shi'
    }, {
      'provinceID': 18,
      'cityID': 1161,
      'title': '洪湖市',
      'prefix': '0716',
      'pinYin': 'hong hu shi'
    }, {
      'provinceID': 18,
      'cityID': 1165,
      'title': '当阳市',
      'prefix': '0717',
      'pinYin': 'dang yang shi'
    }, {
      'provinceID': 18,
      'cityID': 1167,
      'title': '丹江口市',
      'prefix': '0719',
      'pinYin': 'dan jiang kou shi'
    }, {
      'provinceID': 18,
      'cityID': 1168,
      'title': '恩施市',
      'prefix': '0718',
      'pinYin': 'en shi shi'
    }, {
      'provinceID': 18,
      'cityID': 1169,
      'title': '利川市',
      'prefix': '0718',
      'pinYin': 'li chuan shi'
    }, {
      'provinceID': 18,
      'cityID': 1181,
      'title': '汉川市',
      'prefix': '0712',
      'pinYin': 'han chuan shi'
    }, {
      'provinceID': 18,
      'cityID': 1197,
      'title': '钟祥市',
      'prefix': '0724',
      'pinYin': 'zhong shig shi'
    }, {
      'provinceID': 18,
      'cityID': 1201,
      'title': '松滋市',
      'prefix': '0716',
      'pinYin': 'song zi shi'
    }, {
      'provinceID': 18,
      'cityID': 1206,
      'title': '枝江市',
      'prefix': '0717',
      'pinYin': 'zhi jiang shi'
    }, {
      'provinceID': 18,
      'cityID': 2410,
      'title': '大冶市',
      'prefix': '0714',
      'pinYin': 'da ye shi'
    }, {
      'provinceID': 18,
      'cityID': 2619,
      'title': '宜都市',
      'prefix': '0717',
      'pinYin': 'yi du shi'
    }, {
      'provinceID': 18,
      'cityID': 2620,
      'title': '赤壁市',
      'prefix': '0715',
      'pinYin': 'chi bi shi'
    }, {
      'provinceID': 19,
      'cityID': 1220,
      'title': '郑州市',
      'prefix': '0371',
      'pinYin': 'zheng zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1221,
      'title': '开封市',
      'prefix': '0378',
      'pinYin': 'kai feng shi'
    }, {
      'provinceID': 19,
      'cityID': 1222,
      'title': '洛阳市',
      'prefix': '0379',
      'pinYin': 'luo yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1223,
      'title': '平顶山市',
      'prefix': '0375',
      'pinYin': 'ping ding shan shi'
    }, {
      'provinceID': 19,
      'cityID': 1224,
      'title': '焦作市',
      'prefix': '0391',
      'pinYin': 'jiao zuo shi'
    }, {
      'provinceID': 19,
      'cityID': 1225,
      'title': '鹤壁市',
      'prefix': '0392',
      'pinYin': 'he bi shi'
    }, {
      'provinceID': 19,
      'cityID': 1226,
      'title': '新乡市',
      'prefix': '0373',
      'pinYin': 'xin xiang shi'
    }, {
      'provinceID': 19,
      'cityID': 1227,
      'title': '安阳市',
      'prefix': '0372',
      'pinYin': 'an yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1228,
      'title': '濮阳市',
      'prefix': '0393',
      'pinYin': 'yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1229,
      'title': '许昌市',
      'prefix': '0374',
      'pinYin': 'xu chang shi'
    }, {
      'provinceID': 19,
      'cityID': 1230,
      'title': '漯河市',
      'prefix': '0395',
      'pinYin': 'he shi'
    }, {
      'provinceID': 19,
      'cityID': 1231,
      'title': '三门峡市',
      'prefix': '0398',
      'pinYin': 'san men xia shi'
    }, {
      'provinceID': 19,
      'cityID': 1234,
      'title': '济源市',
      'prefix': '0391',
      'pinYin': 'ji yuan shi'
    }, {
      'provinceID': 19,
      'cityID': 1240,
      'title': '商丘市',
      'prefix': '0370',
      'pinYin': 'shang qiu shi'
    }, {
      'provinceID': 19,
      'cityID': 1241,
      'title': '周口市',
      'prefix': '0394',
      'pinYin': 'zhou kou shi'
    }, {
      'provinceID': 19,
      'cityID': 1242,
      'title': '驻马店市',
      'prefix': '0396',
      'pinYin': 'zhu ma dian shi'
    }, {
      'provinceID': 19,
      'cityID': 1243,
      'title': '信阳市',
      'prefix': '0376',
      'pinYin': 'xin yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1244,
      'title': '南阳市',
      'prefix': '0377',
      'pinYin': 'nan yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1232,
      'title': '义马市',
      'prefix': '0398',
      'pinYin': 'yi ma shi'
    }, {
      'provinceID': 19,
      'cityID': 1233,
      'title': '汝州市',
      'prefix': '0375',
      'pinYin': 'ru zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1235,
      'title': '禹州市',
      'prefix': '0374',
      'pinYin': 'yu zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1236,
      'title': '卫辉市',
      'prefix': '0373',
      'pinYin': 'wei hui shi'
    }, {
      'provinceID': 19,
      'cityID': 1237,
      'title': '辉县市',
      'prefix': '0373',
      'pinYin': 'hui xian shi'
    }, {
      'provinceID': 19,
      'cityID': 1238,
      'title': '沁阳市',
      'prefix': '0391',
      'pinYin': 'qin yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1239,
      'title': '舞钢市',
      'prefix': '0375',
      'pinYin': 'wu gang shi'
    }, {
      'provinceID': 19,
      'cityID': 1245,
      'title': '邓州市',
      'prefix': '0377',
      'pinYin': 'deng zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 1246,
      'title': '荥阳市',
      'prefix': '0371',
      'pinYin': 'ying yang shi'
    }, {
      'provinceID': 19,
      'cityID': 1247,
      'title': '登封市',
      'prefix': '0371',
      'pinYin': 'deng feng shi'
    }, {
      'provinceID': 19,
      'cityID': 1249,
      'title': '新郑市',
      'prefix': '0371',
      'pinYin': 'xin zheng shi'
    }, {
      'provinceID': 19,
      'cityID': 1260,
      'title': '偃师市',
      'prefix': '0379',
      'pinYin': 'yan shi shi'
    }, {
      'provinceID': 19,
      'cityID': 1295,
      'title': '长葛市',
      'prefix': '0374',
      'pinYin': 'chang ge shi'
    }, {
      'provinceID': 19,
      'cityID': 1300,
      'title': '灵宝市',
      'prefix': '0398',
      'pinYin': 'ling bao shi'
    }, {
      'provinceID': 19,
      'cityID': 1308,
      'title': '永城市',
      'prefix': '0370',
      'pinYin': 'yong cheng shi'
    }, {
      'provinceID': 19,
      'cityID': 1320,
      'title': '项城市',
      'prefix': '0394',
      'pinYin': 'xiang cheng shi'
    }, {
      'provinceID': 19,
      'cityID': 2398,
      'title': '巩义市',
      'prefix': '0371',
      'pinYin': 'gong yi shi'
    }, {
      'provinceID': 19,
      'cityID': 2403,
      'title': '林州市',
      'prefix': '0372',
      'pinYin': 'lin zhou shi'
    }, {
      'provinceID': 19,
      'cityID': 2616,
      'title': '新密市',
      'prefix': '0371',
      'pinYin': 'xin mi shi'
    }, {
      'provinceID': 19,
      'cityID': 2617,
      'title': '孟州市',
      'prefix': '0391',
      'pinYin': 'meng zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1350,
      'title': '广州市',
      'prefix': '020',
      'pinYin': 'guang zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1351,
      'title': '深圳市',
      'prefix': '0755',
      'pinYin': 'shen  shi'
    }, {
      'provinceID': 20,
      'cityID': 1352,
      'title': '珠海市',
      'prefix': '0756',
      'pinYin': 'zhu hai shi'
    }, {
      'provinceID': 20,
      'cityID': 1353,
      'title': '汕头市',
      'prefix': '0754',
      'pinYin': 'shan tou shi'
    }, {
      'provinceID': 20,
      'cityID': 1354,
      'title': '韶关市',
      'prefix': '0751',
      'pinYin': 'shao guan shi'
    }, {
      'provinceID': 20,
      'cityID': 1355,
      'title': '河源市',
      'prefix': '0762',
      'pinYin': 'he yuan shi'
    }, {
      'provinceID': 20,
      'cityID': 1356,
      'title': '梅州市',
      'prefix': '0753',
      'pinYin': 'mei zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1357,
      'title': '惠州市',
      'prefix': '0752',
      'pinYin': 'hui zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1358,
      'title': '汕尾市',
      'prefix': '0660',
      'pinYin': 'shan wei shi'
    }, {
      'provinceID': 20,
      'cityID': 1359,
      'title': '东莞市',
      'prefix': '0769',
      'pinYin': 'dong  shi'
    }, {
      'provinceID': 20,
      'cityID': 1360,
      'title': '中山市',
      'prefix': '0760',
      'pinYin': 'zhong shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1361,
      'title': '江门市',
      'prefix': '0750',
      'pinYin': 'jiang men shi'
    }, {
      'provinceID': 20,
      'cityID': 1362,
      'title': '佛山市',
      'prefix': '0757',
      'pinYin': 'fo shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1363,
      'title': '阳江市',
      'prefix': '0662',
      'pinYin': 'yang jiang shi'
    }, {
      'provinceID': 20,
      'cityID': 1364,
      'title': '湛江市',
      'prefix': '0759',
      'pinYin': 'zhan jiang shi'
    }, {
      'provinceID': 20,
      'cityID': 1365,
      'title': '茂名市',
      'prefix': '0668',
      'pinYin': 'mao ming shi'
    }, {
      'provinceID': 20,
      'cityID': 1366,
      'title': '肇庆市',
      'prefix': '0758',
      'pinYin': 'zhao qing shi'
    }, {
      'provinceID': 20,
      'cityID': 1367,
      'title': '清远市',
      'prefix': '0763',
      'pinYin': 'qing yuan shi'
    }, {
      'provinceID': 20,
      'cityID': 1368,
      'title': '潮州市',
      'prefix': '0768',
      'pinYin': 'chao zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1382,
      'title': '揭阳市',
      'prefix': '0663',
      'pinYin': 'jie yang shi'
    }, {
      'provinceID': 20,
      'cityID': 1434,
      'title': '云浮市',
      'prefix': '0766',
      'pinYin': 'yun fu shi'
    }, {
      'provinceID': 20,
      'cityID': 1370,
      'title': '从化市',
      'prefix': '020',
      'pinYin': 'cong hua shi'
    }, {
      'provinceID': 20,
      'cityID': 1371,
      'title': '增城市',
      'prefix': '020',
      'pinYin': 'zeng cheng shi'
    }, {
      'provinceID': 20,
      'cityID': 1384,
      'title': '南雄市',
      'prefix': '0751',
      'pinYin': 'nan xiong shi'
    }, {
      'provinceID': 20,
      'cityID': 1389,
      'title': '乐昌市',
      'prefix': '0751',
      'pinYin': 'le chang shi'
    }, {
      'provinceID': 20,
      'cityID': 1400,
      'title': '兴宁市',
      'prefix': '0753',
      'pinYin': 'xing ning shi'
    }, {
      'provinceID': 20,
      'cityID': 1408,
      'title': '陆丰市',
      'prefix': '0660',
      'pinYin': 'lu feng shi'
    }, {
      'provinceID': 20,
      'cityID': 1410,
      'title': '台山市',
      'prefix': '0750',
      'pinYin': 'tai shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1411,
      'title': '开平市',
      'prefix': '0750',
      'pinYin': 'kai ping shi'
    }, {
      'provinceID': 20,
      'cityID': 1412,
      'title': '恩平市',
      'prefix': '0750',
      'pinYin': 'en ping shi'
    }, {
      'provinceID': 20,
      'cityID': 1413,
      'title': '鹤山市',
      'prefix': '0750',
      'pinYin': 'he shan shi'
    }, {
      'provinceID': 20,
      'cityID': 1419,
      'title': '阳春市',
      'prefix': '0662',
      'pinYin': 'yang chun shi'
    }, {
      'provinceID': 20,
      'cityID': 1420,
      'title': '吴川市',
      'prefix': '0759',
      'pinYin': 'wu chuan shi'
    }, {
      'provinceID': 20,
      'cityID': 1424,
      'title': '廉江市',
      'prefix': '0759',
      'pinYin': 'lian jiang shi'
    }, {
      'provinceID': 20,
      'cityID': 1425,
      'title': '高州市',
      'prefix': '0668',
      'pinYin': 'gao zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1426,
      'title': '信宜市',
      'prefix': '0668',
      'pinYin': 'xin yi shi'
    }, {
      'provinceID': 20,
      'cityID': 1428,
      'title': '化州市',
      'prefix': '0668',
      'pinYin': 'hua zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 1429,
      'title': '高要市',
      'prefix': '0758',
      'pinYin': 'gao yao shi'
    }, {
      'provinceID': 20,
      'cityID': 1431,
      'title': '四会市',
      'prefix': '0758',
      'pinYin': 'si hui shi'
    }, {
      'provinceID': 20,
      'cityID': 1433,
      'title': '罗定市',
      'prefix': '0766',
      'pinYin': 'luo ding shi'
    }, {
      'provinceID': 20,
      'cityID': 1439,
      'title': '英德市',
      'prefix': '0763',
      'pinYin': 'ying de shi'
    }, {
      'provinceID': 20,
      'cityID': 2425,
      'title': '连州市',
      'prefix': '0763',
      'pinYin': 'lian zhou shi'
    }, {
      'provinceID': 20,
      'cityID': 2428,
      'title': '普宁市',
      'prefix': '0663',
      'pinYin': 'pu ning shi'
    }, {
      'provinceID': 20,
      'cityID': 2607,
      'title': '雷州市',
      'prefix': '0759',
      'pinYin': 'lei zhou shi'
    }, {
      'provinceID': 21,
      'cityID': 1446,
      'title': '海口市',
      'prefix': '0898',
      'pinYin': 'hai kou shi'
    }, {
      'provinceID': 21,
      'cityID': 1447,
      'title': '三亚市',
      'prefix': '0898',
      'pinYin': 'san ya shi'
    }, {
      'provinceID': 21,
      'cityID': 1448,
      'title': '五指山市',
      'prefix': '0898',
      'pinYin': 'tong shi shi'
    }, {
      'provinceID': 21,
      'cityID': 1450,
      'title': '文昌市',
      'prefix': '0898',
      'pinYin': 'wen chang shi'
    }, {
      'provinceID': 21,
      'cityID': 1451,
      'title': '琼海市',
      'prefix': '0898',
      'pinYin': 'qiong hai shi'
    }, {
      'provinceID': 21,
      'cityID': 1452,
      'title': '万宁市',
      'prefix': '0898',
      'pinYin': 'wan ning shi'
    }, {
      'provinceID': 21,
      'cityID': 1460,
      'title': '东方市',
      'prefix': '0898',
      'pinYin': 'dong fang shi'
    }, {
      'provinceID': 21,
      'cityID': 2615,
      'title': '儋州市',
      'prefix': '0898',
      'pinYin': 'dan zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 1465,
      'title': '南宁市',
      'prefix': '0771',
      'pinYin': 'nan ning shi'
    }, {
      'provinceID': 22,
      'cityID': 1466,
      'title': '柳州市',
      'prefix': '0772',
      'pinYin': 'liu zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 1467,
      'title': '桂林市',
      'prefix': '0773',
      'pinYin': 'gui lin shi'
    }, {
      'provinceID': 22,
      'cityID': 1468,
      'title': '梧州市',
      'prefix': '0774',
      'pinYin': 'wu zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 1469,
      'title': '北海市',
      'prefix': '0779',
      'pinYin': 'bei hai shi'
    }, {
      'provinceID': 22,
      'cityID': 1472,
      'title': '玉林市',
      'prefix': '0775',
      'pinYin': 'yu lin shi'
    }, {
      'provinceID': 22,
      'cityID': 1473,
      'title': '贵港市',
      'prefix': '0775',
      'pinYin': 'gui gang shi'
    }, {
      'provinceID': 22,
      'cityID': 1474,
      'title': '百色市',
      'prefix': '0776',
      'pinYin': 'bai se shi'
    }, {
      'provinceID': 22,
      'cityID': 1475,
      'title': '河池市',
      'prefix': '0778',
      'pinYin': 'he chi shi'
    }, {
      'provinceID': 22,
      'cityID': 1497,
      'title': '来宾市',
      'prefix': '0772',
      'pinYin': 'lai bin shi'
    }, {
      'provinceID': 22,
      'cityID': 1517,
      'title': '贺州市',
      'prefix': '0774',
      'pinYin': 'he xian'
    }, {
      'provinceID': 22,
      'cityID': 2430,
      'title': '钦州市',
      'prefix': '0777',
      'pinYin': 'qin zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 2434,
      'title': '祟左',
      'prefix': '',
      'pinYin': 'sui zuo'
    }, {
      'provinceID': 22,
      'cityID': 2435,
      'title': '防城港市',
      'prefix': '0770',
      'pinYin': 'fang cheng gang shi'
    }, {
      'provinceID': 22,
      'cityID': 1470,
      'title': '凭祥市',
      'prefix': '0771',
      'pinYin': 'ping xiang shi'
    }, {
      'provinceID': 22,
      'cityID': 1471,
      'title': '合山市',
      'prefix': '0772',
      'pinYin': 'he shan shi'
    }, {
      'provinceID': 22,
      'cityID': 1488,
      'title': '崇左市',
      'prefix': '0771',
      'pinYin': 'chong zuo shi'
    }, {
      'provinceID': 22,
      'cityID': 1515,
      'title': '岑溪市',
      'prefix': '0774',
      'pinYin': 'cen xi shi'
    }, {
      'provinceID': 22,
      'cityID': 1521,
      'title': '桂平市',
      'prefix': '0775',
      'pinYin': 'gui ping shi'
    }, {
      'provinceID': 22,
      'cityID': 1522,
      'title': '北流市',
      'prefix': '0775',
      'pinYin': 'bei liu shi'
    }, {
      'provinceID': 22,
      'cityID': 2608,
      'title': '宜州市',
      'prefix': '0778',
      'pinYin': 'yi zhou shi'
    }, {
      'provinceID': 22,
      'cityID': 2609,
      'title': '东兴市',
      'prefix': '0770',
      'pinYin': 'dong xing shi'
    }, {
      'provinceID': 23,
      'cityID': 1546,
      'title': '贵阳市',
      'prefix': '0851',
      'pinYin': 'gui yang shi'
    }, {
      'provinceID': 23,
      'cityID': 1547,
      'title': '六盘水市',
      'prefix': '0858',
      'pinYin': 'liu pan shui shi'
    }, {
      'provinceID': 23,
      'cityID': 1548,
      'title': '遵义市',
      'prefix': '0852',
      'pinYin': 'zun yi shi'
    }, {
      'provinceID': 23,
      'cityID': 1552,
      'title': '安顺市',
      'prefix': '0853',
      'pinYin': 'an shun shi'
    }, {
      'provinceID': 23,
      'cityID': 2610,
      'title': '黔西南布依族苗族自治州',
      'prefix': '0859',
      'pinYin': 'qian xi nan bu yi zu miao zu zi zhi zhou'
    }, {
      'provinceID': 23,
      'cityID': 2611,
      'title': '黔东南苗族侗族自治州',
      'prefix': '0855',
      'pinYin': 'qian dong nan miao zu dong zu zi zhi zhou'
    }, {
      'provinceID': 23,
      'cityID': 2612,
      'title': '黔南布依族苗族自治州',
      'prefix': '0854',
      'pinYin': 'qian nan bu yi zu miao zu zi zhi zhou'
    }, {
      'provinceID': 23,
      'cityID': 2613,
      'title': '铜仁地区',
      'prefix': '0856',
      'pinYin': 'tong ren di qu'
    }, {
      'provinceID': 23,
      'cityID': 2614,
      'title': '毕节地区',
      'prefix': '0857',
      'pinYin': 'bi jie di qu'
    }, {
      'provinceID': 23,
      'cityID': 1549,
      'title': '赤水市',
      'prefix': '0852',
      'pinYin': 'chi shui shi'
    }, {
      'provinceID': 23,
      'cityID': 1550,
      'title': '铜仁市',
      'prefix': '0856',
      'pinYin': 'tong ren shi'
    }, {
      'provinceID': 23,
      'cityID': 1553,
      'title': '兴义市',
      'prefix': '0859',
      'pinYin': 'xing yi shi'
    }, {
      'provinceID': 23,
      'cityID': 1554,
      'title': '凯里市',
      'prefix': '0855',
      'pinYin': 'kai li shi'
    }, {
      'provinceID': 23,
      'cityID': 1555,
      'title': '都匀市',
      'prefix': '0854',
      'pinYin': 'du yun shi'
    }, {
      'provinceID': 23,
      'cityID': 1563,
      'title': '仁怀市',
      'prefix': '0852',
      'pinYin': 'ren huai shi'
    }, {
      'provinceID': 23,
      'cityID': 1581,
      'title': '毕节市',
      'prefix': '0857',
      'pinYin': 'bi jie shi'
    }, {
      'provinceID': 23,
      'cityID': 1594,
      'title': '清镇市',
      'prefix': '0851',
      'pinYin': 'qing zhen shi'
    }, {
      'provinceID': 23,
      'cityID': 1627,
      'title': '福泉市',
      'prefix': '0854',
      'pinYin': 'fu quan shi'
    }, {
      'provinceID': 24,
      'cityID': 1631,
      'title': '成都市',
      'prefix': '028',
      'pinYin': 'cheng du shi'
    }, {
      'provinceID': 24,
      'cityID': 1632,
      'title': '自贡市',
      'prefix': '0813',
      'pinYin': 'zi gong shi'
    }, {
      'provinceID': 24,
      'cityID': 1633,
      'title': '攀枝花市',
      'prefix': '0812',
      'pinYin': 'pan zhi hua shi'
    }, {
      'provinceID': 24,
      'cityID': 1634,
      'title': '泸州市',
      'prefix': '0830',
      'pinYin': 'zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1635,
      'title': '德阳市',
      'prefix': '0838',
      'pinYin': 'de yang shi'
    }, {
      'provinceID': 24,
      'cityID': 1636,
      'title': '绵阳市',
      'prefix': '0816',
      'pinYin': 'mian yang shi'
    }, {
      'provinceID': 24,
      'cityID': 1637,
      'title': '广元市',
      'prefix': '0839',
      'pinYin': 'guang yuan shi'
    }, {
      'provinceID': 24,
      'cityID': 1638,
      'title': '遂宁市',
      'prefix': '0825',
      'pinYin': 'sui ning shi'
    }, {
      'provinceID': 24,
      'cityID': 1639,
      'title': '内江市',
      'prefix': '0832',
      'pinYin': 'nei jiang shi'
    }, {
      'provinceID': 24,
      'cityID': 1640,
      'title': '乐山市',
      'prefix': '0833',
      'pinYin': 'le shan shi'
    }, {
      'provinceID': 24,
      'cityID': 1641,
      'title': '南充市',
      'prefix': '0817',
      'pinYin': 'nan chong shi'
    }, {
      'provinceID': 24,
      'cityID': 1642,
      'title': '宜宾市',
      'prefix': '0831',
      'pinYin': 'yi bin shi'
    }, {
      'provinceID': 24,
      'cityID': 1643,
      'title': '广安市',
      'prefix': '0826',
      'pinYin': 'guang an shi'
    }, {
      'provinceID': 24,
      'cityID': 1651,
      'title': '巴中市',
      'prefix': '0827',
      'pinYin': 'ba zhong shi'
    }, {
      'provinceID': 24,
      'cityID': 1652,
      'title': '雅安市',
      'prefix': '0835',
      'pinYin': 'ya an shi'
    }, {
      'provinceID': 24,
      'cityID': 1653,
      'title': '眉山市',
      'prefix': '0833',
      'pinYin': 'mei shan shi'
    }, {
      'provinceID': 24,
      'cityID': 1654,
      'title': '阿坝藏族羌族自治州',
      'prefix': '0837',
      'pinYin': 'a ba cang zu qiang zu zi zhi zhou'
    }, {
      'provinceID': 24,
      'cityID': 1655,
      'title': '甘孜藏族自治州',
      'prefix': '0836',
      'pinYin': 'gan zi cang zu zi zhi zhou'
    }, {
      'provinceID': 24,
      'cityID': 1656,
      'title': '凉山彝族自治州',
      'prefix': '0834',
      'pinYin': 'liang shan yi zu zi zhi zhou'
    }, {
      'provinceID': 24,
      'cityID': 2489,
      'title': '资阳市',
      'prefix': '0832',
      'pinYin': 'zi yang shi'
    }, {
      'provinceID': 24,
      'cityID': 2645,
      'title': '达州市',
      'prefix': '0818',
      'pinYin': 'da zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1644,
      'title': '广汉市',
      'prefix': '0838',
      'pinYin': 'guang han shi'
    }, {
      'provinceID': 24,
      'cityID': 1645,
      'title': '西昌市',
      'prefix': '0834',
      'pinYin': 'xi chang shi'
    }, {
      'provinceID': 24,
      'cityID': 1646,
      'title': '江油市',
      'prefix': '0816',
      'pinYin': 'jiang you shi'
    }, {
      'provinceID': 24,
      'cityID': 1647,
      'title': '彭州市',
      'prefix': '028',
      'pinYin': 'peng zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1648,
      'title': '崇州市',
      'prefix': '028',
      'pinYin': 'chong zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 1649,
      'title': '都江堰市',
      'prefix': '028',
      'pinYin': 'du jiang yan shi'
    }, {
      'provinceID': 24,
      'cityID': 2452,
      'title': '邛崃市',
      'prefix': '028',
      'pinYin': 'qiong lai shi'
    }, {
      'provinceID': 24,
      'cityID': 2459,
      'title': '峨眉山市',
      'prefix': '0833',
      'pinYin': 'e mei shan shi'
    }, {
      'provinceID': 24,
      'cityID': 2467,
      'title': '简阳市',
      'prefix': '0832',
      'pinYin': 'jian yang shi'
    }, {
      'provinceID': 24,
      'cityID': 2472,
      'title': '绵竹市',
      'prefix': '0838',
      'pinYin': 'mian zhu shi'
    }, {
      'provinceID': 24,
      'cityID': 2473,
      'title': '什邡市',
      'prefix': '0838',
      'pinYin': 'shi fang shi'
    }, {
      'provinceID': 24,
      'cityID': 2646,
      'title': '阆中市',
      'prefix': '0817',
      'pinYin': 'lang zhou shi'
    }, {
      'provinceID': 24,
      'cityID': 2647,
      'title': '华蓥市',
      'prefix': '0826',
      'pinYin': 'hua ying shi'
    }, {
      'provinceID': 24,
      'cityID': 2648,
      'title': '万源市',
      'prefix': '0818',
      'pinYin': 'wan yuan shi'
    }, {
      'provinceID': 25,
      'cityID': 1659,
      'title': '昆明市',
      'prefix': '0871',
      'pinYin': 'kun ming shi'
    }, {
      'provinceID': 25,
      'cityID': 1661,
      'title': '昭通市',
      'prefix': '0870',
      'pinYin': 'zhao tong shi'
    }, {
      'provinceID': 25,
      'cityID': 1662,
      'title': '曲靖市',
      'prefix': '0874',
      'pinYin': 'qu jing shi'
    }, {
      'provinceID': 25,
      'cityID': 1663,
      'title': '玉溪市',
      'prefix': '0877',
      'pinYin': 'yu xi shi'
    }, {
      'provinceID': 25,
      'cityID': 1664,
      'title': '保山市',
      'prefix': '0875',
      'pinYin': 'bao shan shi'
    }, {
      'provinceID': 25,
      'cityID': 1706,
      'title': '普洱市',
      'prefix': '0879',
      'pinYin': 'pu er shi'
    }, {
      'provinceID': 25,
      'cityID': 1714,
      'title': '临沧市',
      'prefix': '0883',
      'pinYin': 'lin cang shi'
    }, {
      'provinceID': 25,
      'cityID': 1728,
      'title': '丽江市',
      'prefix': '0888',
      'pinYin': 'li jiang shi'
    }, {
      'provinceID': 25,
      'cityID': 2670,
      'title': '西双版纳傣族自治州',
      'prefix': '0691',
      'pinYin': 'xi shuang ban na dai zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2671,
      'title': '德宏傣族景颇族自治州',
      'prefix': '0692',
      'pinYin': 'de hong dai zu jing po zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2672,
      'title': '怒江傈僳族自治州',
      'prefix': '0886',
      'pinYin': 'nu jiang li su zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2673,
      'title': '迪庆藏族自治州',
      'prefix': '0887',
      'pinYin': 'di qing zang zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2674,
      'title': '文山壮族苗族自治州',
      'prefix': '0876',
      'pinYin': 'wen shan zhuang zu miao zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2675,
      'title': '红河哈尼族彝族自治州',
      'prefix': '0873',
      'pinYin': 'hong he ha ni zu yi zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2676,
      'title': '楚雄彝族自治州',
      'prefix': '0878',
      'pinYin': 'zhu xiong yi zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 2677,
      'title': '大理白族自治州',
      'prefix': '0872',
      'pinYin': 'da li bai zu zi zhi zhou'
    }, {
      'provinceID': 25,
      'cityID': 1665,
      'title': '个旧市',
      'prefix': '0873',
      'pinYin': 'ge jiu shi'
    }, {
      'provinceID': 25,
      'cityID': 1666,
      'title': '开远市',
      'prefix': '0873',
      'pinYin': 'kai yuan shi'
    }, {
      'provinceID': 25,
      'cityID': 1667,
      'title': '楚雄市',
      'prefix': '0878',
      'pinYin': 'chu xiong shi'
    }, {
      'provinceID': 25,
      'cityID': 1668,
      'title': '大理市',
      'prefix': '0872',
      'pinYin': 'da li shi'
    }, {
      'provinceID': 25,
      'cityID': 1675,
      'title': '安宁市',
      'prefix': '0871',
      'pinYin': 'an ning shi'
    }, {
      'provinceID': 25,
      'cityID': 1688,
      'title': '宣威市',
      'prefix': '0874',
      'pinYin': 'xuan wei shi'
    }, {
      'provinceID': 25,
      'cityID': 1749,
      'title': '景洪市',
      'prefix': '0691',
      'pinYin': 'jing hong shi'
    }, {
      'provinceID': 25,
      'cityID': 1772,
      'title': '潞西市',
      'prefix': '0692',
      'pinYin': 'lu xi shi'
    }, {
      'provinceID': 25,
      'cityID': 1775,
      'title': '瑞丽市',
      'prefix': '0692',
      'pinYin': 'rui li shi'
    }, {
      'provinceID': 26,
      'cityID': 1785,
      'title': '西安市',
      'prefix': '029',
      'pinYin': 'xi an shi'
    }, {
      'provinceID': 26,
      'cityID': 1787,
      'title': '宝鸡市',
      'prefix': '0917',
      'pinYin': 'bao ji shi'
    }, {
      'provinceID': 26,
      'cityID': 1788,
      'title': '咸阳市',
      'prefix': '029',
      'pinYin': 'xian yang shi'
    }, {
      'provinceID': 26,
      'cityID': 1789,
      'title': '榆林市',
      'prefix': '0912',
      'pinYin': 'yu lin shi'
    }, {
      'provinceID': 26,
      'cityID': 1790,
      'title': '延安市',
      'prefix': '0911',
      'pinYin': 'yan an shi'
    }, {
      'provinceID': 26,
      'cityID': 1791,
      'title': '渭南市',
      'prefix': '0913',
      'pinYin': 'wei nan shi'
    }, {
      'provinceID': 26,
      'cityID': 1795,
      'title': '安康市',
      'prefix': '0915',
      'pinYin': 'an kang shi'
    }, {
      'provinceID': 26,
      'cityID': 1796,
      'title': '汉中市',
      'prefix': '0916',
      'pinYin': 'han zhong shi'
    }, {
      'provinceID': 26,
      'cityID': 2505,
      'title': '铜川市',
      'prefix': '0919',
      'pinYin': 'tong chuan shi'
    }, {
      'provinceID': 26,
      'cityID': 2644,
      'title': '商洛市',
      'prefix': '0914',
      'pinYin': 'shang luo shi'
    }, {
      'provinceID': 26,
      'cityID': 1792,
      'title': '韩城市',
      'prefix': '0913',
      'pinYin': 'han cheng shi'
    }, {
      'provinceID': 26,
      'cityID': 1793,
      'title': '华阴市',
      'prefix': '0913',
      'pinYin': 'hua yin shi'
    }, {
      'provinceID': 26,
      'cityID': 1820,
      'title': '兴平市',
      'prefix': '029',
      'pinYin': 'xing ping shi'
    }, {
      'provinceID': 27,
      'cityID': 1882,
      'title': '兰州市',
      'prefix': '0931',
      'pinYin': 'lan zhou shi'
    }, {
      'provinceID': 27,
      'cityID': 1883,
      'title': '金昌市',
      'prefix': '0935',
      'pinYin': 'jin chang shi'
    }, {
      'provinceID': 27,
      'cityID': 1884,
      'title': '白银市',
      'prefix': '0943',
      'pinYin': 'bai yin shi'
    }, {
      'provinceID': 27,
      'cityID': 1885,
      'title': '天水市',
      'prefix': '0938',
      'pinYin': 'tian shui shi'
    }, {
      'provinceID': 27,
      'cityID': 1886,
      'title': '嘉峪关市',
      'prefix': '0937',
      'pinYin': 'jia yu guan shi'
    }, {
      'provinceID': 27,
      'cityID': 1887,
      'title': '平凉市',
      'prefix': '0933',
      'pinYin': 'ping liang shi'
    }, {
      'provinceID': 27,
      'cityID': 1889,
      'title': '武威市',
      'prefix': '0935',
      'pinYin': 'wu wei shi'
    }, {
      'provinceID': 27,
      'cityID': 1890,
      'title': '张掖市',
      'prefix': '0936',
      'pinYin': 'zhang ye shi'
    }, {
      'provinceID': 27,
      'cityID': 1892,
      'title': '酒泉市',
      'prefix': '0937',
      'pinYin': 'jiu quan shi'
    }, {
      'provinceID': 27,
      'cityID': 1907,
      'title': '定西市',
      'prefix': '0932',
      'pinYin': 'ding xi shi'
    }, {
      'provinceID': 27,
      'cityID': 1920,
      'title': '庆阳市',
      'prefix': '0934',
      'pinYin': 'qing yang shi'
    }, {
      'provinceID': 27,
      'cityID': 2603,
      'title': '陇南市',
      'prefix': '0939',
      'pinYin': 'long nan shi'
    }, {
      'provinceID': 27,
      'cityID': 2604,
      'title': '临夏回族自治州',
      'prefix': '0930',
      'pinYin': 'lin xia hui zuo zi zhi zhou'
    }, {
      'provinceID': 27,
      'cityID': 2605,
      'title': '甘南藏族自治州',
      'prefix': '0941',
      'pinYin': 'gan nan zang zu zi zhi zhou'
    }, {
      'provinceID': 27,
      'cityID': 1891,
      'title': '玉门市',
      'prefix': '0937',
      'pinYin': 'yu men shi'
    }, {
      'provinceID': 27,
      'cityID': 1894,
      'title': '临夏市',
      'prefix': '0930',
      'pinYin': 'lin xia shi'
    }, {
      'provinceID': 27,
      'cityID': 2606,
      'title': '合作市',
      'prefix': '0941',
      'pinYin': 'he zuo shi'
    }, {
      'provinceID': 28,
      'cityID': 1964,
      'title': '银川市',
      'prefix': '0951',
      'pinYin': 'yin chuan shi'
    }, {
      'provinceID': 28,
      'cityID': 1965,
      'title': '石嘴山市',
      'prefix': '0952',
      'pinYin': 'shi zui shan shi'
    }, {
      'provinceID': 28,
      'cityID': 1966,
      'title': '吴忠市',
      'prefix': '0953',
      'pinYin': 'wu zhong shi'
    }, {
      'provinceID': 28,
      'cityID': 1978,
      'title': '固原市',
      'prefix': '0954',
      'pinYin': 'gu yuan shi'
    }, {
      'provinceID': 28,
      'cityID': 1967,
      'title': '青铜峡市',
      'prefix': '0953',
      'pinYin': 'qing tong xia shi'
    }, {
      'provinceID': 28,
      'cityID': 1975,
      'title': '灵武市',
      'prefix': '0951',
      'pinYin': 'ling wu shi'
    }, {
      'provinceID': 28,
      'cityID': 1976,
      'title': '中卫市',
      'prefix': '0955',
      'pinYin': 'zhong wei shi'
    }, {
      'provinceID': 29,
      'cityID': 1984,
      'title': '西宁市',
      'prefix': '0971',
      'pinYin': 'xi ning shi'
    }, {
      'provinceID': 29,
      'cityID': 1988,
      'title': '海东地区',
      'prefix': '0972',
      'pinYin': 'hai dong di qu'
    }, {
      'provinceID': 29,
      'cityID': 2636,
      'title': '海北藏族自治州',
      'prefix': '0970',
      'pinYin': 'hai bei zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2637,
      'title': '黄南藏族自治州',
      'prefix': '0973',
      'pinYin': 'huang nan zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2638,
      'title': '海南藏族自治州',
      'prefix': '0974',
      'pinYin': 'hai nan zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2639,
      'title': '果洛藏族自治州',
      'prefix': '0975',
      'pinYin': 'guo luo zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2640,
      'title': '玉树藏族自治州',
      'prefix': '0976',
      'pinYin': 'yu shu zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 2641,
      'title': '海西蒙古族藏族自治州',
      'prefix': '0979',
      'pinYin': 'hai xi meng gu zu zang zu zi zhi zhou'
    }, {
      'provinceID': 29,
      'cityID': 1985,
      'title': '格尔木市',
      'prefix': '0979',
      'pinYin': 'ge er mu shi'
    }, {
      'provinceID': 29,
      'cityID': 1986,
      'title': '德令哈市',
      'prefix': '0979',
      'pinYin': 'de ling ha shi'
    }, {
      'provinceID': 29,
      'cityID': 2642,
      'title': '冷湖行委',
      'prefix': '0977',
      'pinYin': 'leng hu xing wei'
    }, {
      'provinceID': 30,
      'cityID': 2026,
      'title': '乌鲁木齐市',
      'prefix': '0991',
      'pinYin': 'wu lu mu qi shi'
    }, {
      'provinceID': 30,
      'cityID': 2027,
      'title': '克拉玛依市',
      'prefix': '0990',
      'pinYin': 'ke la ma yi shi'
    }, {
      'provinceID': 30,
      'cityID': 2028,
      'title': '石河子市',
      'prefix': '0993',
      'pinYin': 'shi he zi shi'
    }, {
      'provinceID': 30,
      'cityID': 2520,
      'title': '五家渠市',
      'prefix': '0994',
      'pinYin': 'wu jia qu shi'
    }, {
      'provinceID': 30,
      'cityID': 2525,
      'title': '阿拉尔市',
      'prefix': '0997',
      'pinYin': 'a la er shi'
    }, {
      'provinceID': 30,
      'cityID': 2655,
      'title': '博尔塔拉蒙古自治州',
      'prefix': '0909',
      'pinYin': 'bo er ta la meng gu zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2656,
      'title': '巴音郭楞蒙古自治州',
      'prefix': '0996',
      'pinYin': 'ba yin guo leng meng gu zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2657,
      'title': '克孜勒苏柯尔克孜自治州',
      'prefix': '0908',
      'pinYin': 'ke zi le su ke er ke zi zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2658,
      'title': '伊犁哈萨克自治州',
      'prefix': '0999',
      'pinYin': 'yi li ha sa ke zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2659,
      'title': '图木舒克市',
      'prefix': '0998',
      'pinYin': 'tu mu shu ke shi'
    }, {
      'provinceID': 30,
      'cityID': 2660,
      'title': '吐鲁番地区',
      'prefix': '0995',
      'pinYin': 'tu lu fan di qu'
    }, {
      'provinceID': 30,
      'cityID': 2661,
      'title': '哈密地区',
      'prefix': '0902',
      'pinYin': 'ha mi di qu'
    }, {
      'provinceID': 30,
      'cityID': 2662,
      'title': '和田地区',
      'prefix': '0903',
      'pinYin': 'he tian di qu'
    }, {
      'provinceID': 30,
      'cityID': 2663,
      'title': '阿克苏地区',
      'prefix': '0997',
      'pinYin': 'a ke su di qu'
    }, {
      'provinceID': 30,
      'cityID': 2664,
      'title': '喀什地区',
      'prefix': '0998',
      'pinYin': 'ka shi di qu '
    }, {
      'provinceID': 30,
      'cityID': 2665,
      'title': '昌吉回族自治州',
      'prefix': '0994',
      'pinYin': 'chang ji hui zu zi zhi zhou'
    }, {
      'provinceID': 30,
      'cityID': 2666,
      'title': '塔城地区',
      'prefix': '0901',
      'pinYin': 'ta cheng di qu'
    }, {
      'provinceID': 30,
      'cityID': 2667,
      'title': '阿勒泰地区',
      'prefix': '0906',
      'pinYin': 'a le tai di qu'
    }, {
      'provinceID': 30,
      'cityID': 2668,
      'title': '吐鲁番地区',
      'prefix': '0995',
      'pinYin': 'tu lu fan di qu'
    }, {
      'provinceID': 30,
      'cityID': 2029,
      'title': '吐鲁番市',
      'prefix': '0995',
      'pinYin': 'tu lu fan shi'
    }, {
      'provinceID': 30,
      'cityID': 2030,
      'title': '哈密市',
      'prefix': '0902',
      'pinYin': 'ha mi shi'
    }, {
      'provinceID': 30,
      'cityID': 2031,
      'title': '和田市',
      'prefix': '0903',
      'pinYin': 'he tian shi'
    }, {
      'provinceID': 30,
      'cityID': 2032,
      'title': '阿克苏市',
      'prefix': '0997',
      'pinYin': 'a ke su shi'
    }, {
      'provinceID': 30,
      'cityID': 2033,
      'title': '喀什市',
      'prefix': '0998',
      'pinYin': 'ka shi shi'
    }, {
      'provinceID': 30,
      'cityID': 2034,
      'title': '阿图什市',
      'prefix': '0908',
      'pinYin': 'a tu shi shi'
    }, {
      'provinceID': 30,
      'cityID': 2035,
      'title': '库尔勒市',
      'prefix': '0996',
      'pinYin': 'ku er le shi'
    }, {
      'provinceID': 30,
      'cityID': 2036,
      'title': '昌吉市',
      'prefix': '0994',
      'pinYin': 'chang ji shi'
    }, {
      'provinceID': 30,
      'cityID': 2037,
      'title': '博乐市',
      'prefix': '0909',
      'pinYin': 'bo le shi'
    }, {
      'provinceID': 30,
      'cityID': 2039,
      'title': '伊宁市',
      'prefix': '0999',
      'pinYin': 'yi ning shi'
    }, {
      'provinceID': 30,
      'cityID': 2040,
      'title': '塔城市',
      'prefix': '0901',
      'pinYin': 'ta cheng shi'
    }, {
      'provinceID': 30,
      'cityID': 2041,
      'title': '阿勒泰市',
      'prefix': '0906',
      'pinYin': 'a le tai shi'
    }, {
      'provinceID': 30,
      'cityID': 2085,
      'title': '阜康市',
      'prefix': '0994',
      'pinYin': 'fu kang shi'
    }, {
      'provinceID': 30,
      'cityID': 2104,
      'title': '乌苏市',
      'prefix': '0992',
      'pinYin': 'wu su shi'
    }, {
      'provinceID': 30,
      'cityID': 2519,
      'title': '奎屯市',
      'prefix': '0992',
      'pinYin': 'kui tun shi'
    }, {
      'provinceID': 30,
      'cityID': 2669,
      'title': '博乐市',
      'prefix': '0909',
      'pinYin': 'bu le shi'
    }, {
      'provinceID': 31,
      'cityID': 2114,
      'title': '拉萨市',
      'prefix': '0891',
      'pinYin': 'la sa shi'
    }, {
      'provinceID': 31,
      'cityID': 2527,
      'title': '山南地区',
      'prefix': '0893',
      'pinYin': 'shan nan di qu'
    }, {
      'provinceID': 31,
      'cityID': 2649,
      'title': '阿里地区',
      'prefix': '0897',
      'pinYin': 'a li di qu'
    }, {
      'provinceID': 31,
      'cityID': 2650,
      'title': '林芝地区',
      'prefix': '0894',
      'pinYin': 'li zhi di qu'
    }, {
      'provinceID': 31,
      'cityID': 2651,
      'title': '山南地区',
      'prefix': '',
      'pinYin': 'shan nan di qu'
    }, {
      'provinceID': 31,
      'cityID': 2652,
      'title': '日喀则地区',
      'prefix': '0892',
      'pinYin': 'ri ka ze di qu'
    }, {
      'provinceID': 31,
      'cityID': 2653,
      'title': '那曲地区',
      'prefix': '0896',
      'pinYin': 'na qu di qu'
    }, {
      'provinceID': 31,
      'cityID': 2654,
      'title': '昌都地区',
      'prefix': '0895',
      'pinYin': 'chang du di qu'
    }, {
      'provinceID': 31,
      'cityID': 2115,
      'title': '日喀则市',
      'prefix': '0892',
      'pinYin': 'ri ka ze shi'
    }, {
      'provinceID': 31,
      'cityID': 2123,
      'title': '那曲县',
      'prefix': '0896',
      'pinYin': 'na qu xian'
    }, {
      'provinceID': 31,
      'cityID': 2133,
      'title': '昌都县',
      'prefix': '0895',
      'pinYin': 'chang du xian'
    }, {
      'provinceID': 31,
      'cityID': 2186,
      'title': '林芝县',
      'prefix': '0894',
      'pinYin': 'lin zhi xian'
    }, {
      'provinceID': 32,
      'cityID': 2530,
      'title': '香港地区',
      'prefix': '0852',
      'pinYin': 'xiang gang di qu'
    }, {
      'provinceID': 33,
      'cityID': 2531,
      'title': '澳门地区',
      'prefix': '0853',
      'pinYin': 'ao men di qu'
    }, {
      'provinceID': 34,
      'cityID': 2532,
      'title': '台湾全省',
      'prefix': '0886',
      'pinYin': 'tai wan quan sheng'
    }];
    return citys;
  }

};
module.exports = region;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var chineseToPinyin = __webpack_require__(84);
var utils = __webpack_require__(94);

var fixedDic = {
  '晟': 'sheng'
};

function dbs2sbc(str) {
  var result = "";
  for (var i = 0; i < str.length; i++) {
    code = str.charCodeAt(i);
    if (code >= 65281 && code <= 65373) {
      var d = str.charCodeAt(i) - 65248;
      result += String.fromCharCode(d);
    } else if (code == 12288) {
      var d = str.charCodeAt(i) - 12288 + 32;
      result += String.fromCharCode(d);
    } else {
      result += str.charAt(i);
    }
  }
  return result;
}

function pinyin(text) {
  text = dbs2sbc(String(text || ''));
  utils.each(fixedDic, function (name, value) {
    text = text.replace(new RegExp(name, 'igm'), value);
  });
  return chineseToPinyin(text, {
    noTone: true,
    filterChinese: true
  });
};

window.pinyin = pinyin;
module.exports = pinyin;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(85);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dictionary_ = __webpack_require__(86);

var _dictionary_2 = _interopRequireDefault(_dictionary_);

var _dictionary_3 = __webpack_require__(87);

var _dictionary_4 = _interopRequireDefault(_dictionary_3);

var _dictionary_5 = __webpack_require__(88);

var _dictionary_6 = _interopRequireDefault(_dictionary_5);

var _dictionary_7 = __webpack_require__(89);

var _dictionary_8 = _interopRequireDefault(_dictionary_7);

var _dictionary_9 = __webpack_require__(90);

var _dictionary_10 = _interopRequireDefault(_dictionary_9);

var _dictionary_11 = __webpack_require__(91);

var _dictionary_12 = _interopRequireDefault(_dictionary_11);

var _surnames = __webpack_require__(92);

var _surnames2 = _interopRequireDefault(_surnames);

var _tone = __webpack_require__(93);

var _tone2 = _interopRequireDefault(_tone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reg = new RegExp(/[\u4E00-\u9FA5]/);

var dictionarys = [_dictionary_2.default, _dictionary_4.default, _dictionary_6.default, _dictionary_8.default, _dictionary_10.default, _dictionary_12.default, _surnames2.default];

var noTone = function noTone(str) {
  Object.keys(_tone2.default).forEach(function (key) {
    if (str.indexOf(key) !== -1) {
      str = str.replace(new RegExp(key, 'g'), _tone2.default[key][0]);
    }
  });
  return str;
};

var numberTone = function numberTone(str) {
  var strs = str.split(' ');
  strs.forEach(function (val, index) {
    var thisKey = null;

    Object.keys(_tone2.default).forEach(function (key) {
      if (val.indexOf(key) !== -1) {
        thisKey = key;
        strs[index] = val.replace(new RegExp(key, 'g'), _tone2.default[key][0]);
      }
    });
    strs[index] += _tone2.default[thisKey][1];
  });

  return strs.join(' ');
};

var convert = function convert(str, options) {
  options = options || {};

  var chn = str.match(/[\u4E00-\u9FA5]*/g).join('');

  var i = 0;
  var lens = dictionarys.length;
  for (; i < lens; i++) {
    var complete = false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.keys(dictionarys[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (chn.indexOf(key) !== -1) {
          chn = chn.replace(new RegExp(key, 'g'), dictionarys[i][key]);
          if (!reg.test(chn)) {
            chn = chn.replace(/ /, '');
            if (options.numberTone) {
              chn = numberTone(chn);
            } else if (options.noTone) {
              chn = noTone(chn);
            }
            complete = true;
            break;
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    if (complete) {
      break;
    }
  }
  if (options.filterChinese) {
    (function () {
      chn = chn.split(' ');
      var otherArr = ['']; // 特殊字符映射
      var preIsChinese = false;
      var len = str.length;
      for (i = 0; i < len; i++) {
        if (!reg.test(str[i])) {
          // 非汉字字符
          if (preIsChinese) {
            otherArr[otherArr.length] = str[i];
          } else {
            otherArr[otherArr.length - 1] += str[i];
          }
          preIsChinese = false;
        } else {
          // 汉字
          otherArr.push('');
          preIsChinese = true;
        }
      }
      var res = '';
      if (otherArr[0]) {
        res = otherArr[0] + ' ';
      }

      var k = 0;
      otherArr.forEach(function (val, index) {
        if (index !== 0) {
          if (val) {
            res += val + ' ';
          } else {
            res += chn[k] + ' ';
            k++;
          }
        }
      });
      chn = res;
    })();
  }
  return chn.trim();
};

module.exports = convert;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var DICTIONARY={'踉踉跄跄':' liàng liàng qiàng qiàng','以古为鉴':' yǐ gǔ wéi jiàn','称心如意':' chèn xīn rú yì','稻荷寿司':' dào hè shòu sī','繁花似锦':' fán huā sì jǐn','积德累功':' jī dé lěi gōng','以利累形':' yǐ lì lěi xíng','积极反应':' jī jí fǎn yìng','以古为镜':' yǐ gǔ wéi jìng','一干人犯':' yī gān rén fàn','一还一报':' yī huán yī bào','一发千钧':' yī fà qiān jūn','番窠倒臼':' fān kē dǎo jiù','一成不易':' yī chéng bù yì','窝阔台汗':' wō kuò tái hán','反劳为逸':' fǎn láo wéi yì','义薄云天':' yì bó yún tiān','立地成佛':' lì dì chéng fó','反应速度':' fǎn yìng sù dù','犯而不校':' fàn ér bù jiào','衣锦夜行':' yì jǐn yè xíng','积累毒性':' jī lěi dú xìng','诱掖后进':' yòu yè hòu jìn','男子篮球':' nán zǐ lán qíu','鬻鸡为凤':' yù jī wéi fèng','优游卒岁':' yōu yóu zú suì','优游自若':' yōu yóu zì ruò','画地为牢':' huà dì wéi láo','画荻教子':' huà dí jiào zǐ','斗南一人':' dǒu nán yī rén','当回事儿':' dàng huí shì r','斗挹箕扬':' dǒu yì jī yáng','一蹶不兴':' yī juě bù xīng','发奋有为':' fā fèn yǒu wéi','杜门面壁':' dù mén mian bì','于家为国':' yú jiā wéi guó','鼎折餗覆':' dǐng shé sù fù','看在眼里':' kàn zài yǎn li','遗老遗少':' yí lǎo yí shào','以苦为荣':' yǐ kǔ wéi róng','科学知识':' kē xué zhī shi','仰事俯畜':' yǎng shì fǔ xù','看不习惯':' kān bù xí guàn','于今为烈':' yú jīn wéi liè','蹈厉之志':' dǎo lì zhī zhì','法定假日':' fǎ dìng jià rì','知识分子':' zhī shí fèn zǐ','犯罪分子':' fàn zuì fēn zǐ','鼎折覆餗':' dǐng shé fù sù','云朝雨暮':' yún zhāo yǔ mù','倒持戈矛':' dǎo chí gē máo','混为一谈':' hùn wéi yī tán','道尽途殚':' dào jìn tú dān','拽耙扶犁':' zhuāi pá fú lí','二竖为虐':' èr shù wéi nüè','拽布披麻':' zhuài bù pī má','叨陪末座':' tāo péi mò zuò','主要部分':' zhǔ yào bù fen','倒峡泻河':' dǎo xiá xiè hé','逐物不还':' zhú wù bù huán','温情脉脉':' wēn qíng mò mò','寸积铢累':' cùn jī zhū lěi','混水摸鱼':' hún shuǐ mō yú','一日三省':' yī rì sān xǐng','儿女亲家':' ér nǚ qìng jiā','衣马轻肥':' yì mǎ qīng féi','以微知著':' yǐ wēi zhī zhù','一目数行':' yī mù shù háng','多文为富':' duō wén wéi fù','亿兆一心':' yì zhào yī xīn','朵颐大嚼':' duǒ yī dà jiáo','阿党比周':' ē dǎng bǐ zhōu','以言为讳':' yǐ yán wéi huì','屙金溺银':' ē jīn niào yín','一无长物':' yī wú cháng wù','阿房宫赋':' ē páng gōng fù','重足一迹':' chóng zú yī jì','蒙古大夫':' měng gǔ dài fu','依头缕当':' yī tóu lǚ dàng','知识宝库':' zhī shi bǎo kù','一头儿沉':' yī tou er chén','阿世盗名':' ē shì dào míng','阿谀逢迎':' ē yú féng yíng','以是为恨':' yǐ shì wéi hèn','破涕为笑':' pò tì wéi xiào','有人家儿':' yǒu rén jiā ér','舆论哗然':' yú lùn huá rán','捣虚批吭':' dǎo xū pī háng','难割难舍':' nán gē nán shè','关门弟子':' guān mén dì zǐ','难以应付':' nán yǐ yìng fù','杂和面儿':' zá huo miàn er','奇偶校验':' jī ǒu jiào yàn','阿拉善盟':' a lā shàn méng','波骇云属':' bō hài yún zhǔ','阿松森岛':' a sōng sēn dǎo','阿森松岛':' a sēn sōng dǎo','阿空加瓜':' a kōng jiā guā','毛发倒竖':' máo fā dǎo shù','南贩北贾':' nán fàn běi gǔ','拿糖作醋':' ná táng zuò cù','暮雨朝云':' mù yǔ zhāo yún','肌肉萎缩':' jī ròu wěi suō','沐猴衣冠':' mù hóu yī guàn','脉脉含情':' mò mò hán qíng','暮虢朝虞':' mù guó zhāo yú','墨汁未干':' mò zhī wèi gān','电子货币':' diàn zǐ huò bì','霍林郭勒':' huò lín guō lè','莫为已甚':' mò wéi yǐ shèn','摸门不着':' mō mén bù zháo','积岁累月':' jī suì lěi yuè','名流巨子':' míng liú jù zǐ','电子学系':' diàn zǐ xué xì','敏而好学':' mǐn ér hào xué','积铢累寸':' jī zhū lěi cùn','屏气慑息':' bǐng qì shè xī','骥子龙文':' jì zǐ lóng wén','面似靴皮':' miàn sì xuē pí','绵力薄材':' mián lì bó cái','假模假式':' jiǎ mú jiǎ shì','电子游戏':' diàn zǐ yóu xì','绵薄之力':' mián bó zhī lì','蜜里调油':' mì lǐ tiáo yóu','弥缝其阙':' mí féng qí què','架肩击毂':' jià jiān jī gū','冰解的破':' bīng jiě dì pò','门殚户尽':' mén dān hù jìn','没头没尾':' méi tóu mò wěi','莫知所为':' mò zhī suǒ wéi','摸头不着':' mō tóu bù zháo','与世沉浮':' yú shì chén fú','触处机来':' chù chǔ jī lái','因树为屋':' yīn shù wéi wū','顿开茅塞':' dùn kāi máo sè','因祸为福':' yīn huò wéi fú','出处殊途':' chū chǔ shū tú','衣租食税':' yì zū shí shuì','以珠弹雀':' yǐ zhū tán què','一之已甚':' yī zhī yǐ shèn','尽职尽责':' jìn zhí jìn zé','笃实好学':' dǔ shí hào xué','引以为豪':' yǐn yǐ wéi háo','杜门自守':' dù mén zì shòu','东扶西倒':' dōng fú xī dǎo','东猎西渔':' dōng liè xī yú','琴瑟不调':' qín sè bù tiáo','玉卮无当':' yù zhī wú dàng','鱼游燋釜':' yú yóu zhuó fǔ','用得其所':' yòng de qí suǒ','鱼书雁帖':' yú shū yàn tiě','引以为耻':' yǐn yǐ wéi chǐ','引以为戒':' yǐn yǐ wéi jiè','没食子酸':' méi sì zǐ suān','百度知道':' bǎi dù zhī dao','隐身草儿':' yǐn shēn cǎo r','只鸡斗酒':' zhī jī dǒu jiǔ','技术要求':' jì shù yāo qiú','没世不忘':' mò shì bù wàng','谋为不轨':' móu wéi bù guǐ','西子捧心':' xī zǐ pěng xīn','外合里应':' wài hé lǐ yìng','读书得间':' dú shū dé jiàn','都头异姓':' dū tóu yì xìng','白马王子':' bái mǎ wáng zǐ','睹微知著':' dǔ wēi zhī zhù','处理系统':' chǔ lǐ xì tǒng','处理方法':' chǔ lǐ fāng fǎ','益觉困难':' yì jué kùn nan','睹著知微':' dǔ zhù zhī wēi','尽心尽力':' jìn xīn jìn lì','尽心竭力':' jìn xīn jié lì','应答如流':' yìng dá rú liú','朱盘玉敦':' zhū pán yù duì','铢积寸累':' zhū jī cùn lěi','莫此为甚':' mò cǐ wéi shèn','奉公不阿':' fèng gōng bù ē','凤靡鸾吪':' fèng mǐ luán é','虚应故事':' xū yìng gù shì','分液漏斗':' fēn yè lòu dǒu','味如嚼蜡':' wèi rú jiáo là','总理衙门':' zǒng lǐ yá men','为蛇画足':' wéi shé huà zú','罐头起子':' guàn tou qǐ zi','舞台音乐':' wǔ tái yīn yuè','置之度外':' zhì zhī dù wài','考波什堡':' kǎo bō shí bǎo','风号雨泣':' fēng háo yǔ qì','兴家立业':' xīng jiā lì yè','罗锅儿桥':' luó guō r qiáo','岗头泽底':' gāng tóu zé dǐ','风禾尽起':' fēng hé jìn qǐ','齿牙为猾':' chǐ yá wéi huá','置之不问':' zhì zhī bù wèn','苦尽甘来':' kǔ jìn gān lái','翘足而待':' qiáo zú ér dài','见素抱朴':' xiàn sù bào pǔ','涡轮增压':' wō lún zēng yà','小眼薄皮':' xiǎo yǎn bó pí','朝云暮雨':' zhāo yún mù yǔ','无业闲散':' wú yè xián sǎn','笑口弥勒':' xiào kǒu mí lè','以退为进':' yǐ tuì wéi jìn','橘化为枳':' jú huà wéi zhǐ','舌下含服':' shé xià hán fù','佛头加秽':' fó tóu jiā huì','齿牙为祸':' chǐ yá wéi huò','耻与哙伍':' chǐ yú kuài wǔ','浮皮潦草':' fú pí liáo cǎo','老少无欺':' lǎo shào wú qī','孝子慈孙':' xiào zǐ cí sūn','老鼠尾巴':' lǎo shǔ wěi ba','小姑独处':' xiǎo gū dú chǔ','佛心蛇口':' fó xīn shé kǒu','伏而咶天':' fú ér shì tiān','浮瓜沈李':' fú guā shěn lǐ','聚酯树脂':' jù zhǐ shù zhī','浮收勒折':' fú shōu lè shé','无下箸处':' wú xià zhù chǔ','绰有余裕':' chuò yǒu yú yù','脊索动物':' jǐ suǒ dòng wù','父严子孝':' fù yán zǐ xiào','五尺童子':' wǔ chǐ tóng zǐ','无颠无倒':' wú diān wú dǎo','无动为大':' wú dòng wéi dà','脉轮理论':' mài lún lǐ lùn','五斗折腰':' wǔ dǒu zhé yāo','福为祸始':' fú wéi huò shǐ','系统设计':' xì tǒng shè jì','兴都库什':' xīng dū kù shí','各自为战':' gè zì wéi zhàn','行号卧泣':' xíng háo wò qì','玄酒瓠脯':' xuán jiǔ hù fǔ','分毫不差':' fēn háo bù chā','万夫莫当':' wàn fū mò dāng','飞檐走脊':' fēi yán zǒu jǐ','结核杆菌':' jié hé gǎn jūn','莞尔一笑':' wǎn ěr yī xiào','胡作非为':' hú zuò fēi wéi','遐迩著闻':' xiá ěr zhù wén','五方杂处':' wǔ fāng zá chǔ','与时消息':' yǔ shí xiāo xi','无为之治':' wú wéi zhī zhì','兴安运河':' xīng ān yùn hé','自找麻烦':' zì zhǎo má fan','自由散漫':' zì yóu sǎn màn','误作非为':' wù zuò fēi wéi','改恶为善':' gǎi è wéi shàn','污水处理':' wū shuǐ chǔ lǐ','与此同时':' yú cǐ tóng shí','无能为役':' wú néng wéi yì','肉毒杆菌':' ròu dú gǎn jūn','改口沓舌':' gǎi kǒu tà shé','屋舍俨然':' wū shè yǎn rán','改曲易调':' gǎi qǔ yì diào','兴利除弊':' xīng lì chú bì','文子文孙':' wén zǐ wén sūn','细高挑儿':' xì gāo tiǎo ér','敷衍搪塞':' fū yǎn táng sè','听而不闻':' tīng ér bú wén','辙乱旗靡':' zhé luàn qí mǐ','煞费苦心':' shà fèi kǔ xīn','珠还合浦':' zhū huán hé pǔ','淡泊寡味':' dàn bó guǎ wèi','大辂椎轮':' dà lù zhuī lún','子孙后代':' zǐ sūn hòu dài','浮云朝露':' fú yún zhāo lù','大行大市':' dà háng dà shì','子宫内膜':' zǐ gōng nèi mó','大处着墨':' dà chù zhuó mò','淋漓尽致':' lín lí jìn zhì','淡泊名利':' dàn bó míng lì','深信不疑':' shēn xìn bù yí','撮科打哄':' cuō kē dǎ hòng','擢发莫数':' zhuó fà mò shǔ','子孙万代':' zǐ sūn wàn dài','云泥之差':' yún ní zhī chā','攒三集五':' cuán sān jí wǔ','直言贾祸':' zhí yán gǔ huò','朝三暮二':' zhāo sān mù èr','爆冷门儿':' bào lěng mén r','啜食吐哺':' chuò shí tǔ bǔ','自我调节':' zì wǒ tiáo jié','大难临头':' dà nàn lín tóu','电子信息':' diàn zǐ xìn xī','置之高阁':' zhì zhī gāo gé','漠然置之':' mò rán zhì zhī','汉藏语系':' hàn zàng yǔ xì','倒载干戈':' dào zài gān gē','昼度夜思':' zhòu duó yè sī','倒置干戈':' dào zhì gān gē','攒三聚五':' cuán sān jù wǔ','灰不溜秋':' huī bu līu qīu','竹篱茅舍':' zhú lí máo shè','倒持干戈':' dǎo chí gān gē','活跃分子':' huó yuè fèn zǐ','大肆铺张':' dà sì pū zhāng','泊松分布':' bó sōng fēn bù','罪恶昭著':' zuì è zhāo zhù','钻心刺骨':' zuàn xīn cì gǔ','大煞风趣':' dà shà fēng qù','租赁合同':' zū lìn hé tong','弹丸黑子':' dàn wán hēi zǐ','子曰诗云':' zǐ yuè shī yún','朝齑暮盐':' zhāo jī mù yán','电子杂志':' diàn zǐ zá zhì','此唱彼和':' cǐ chàng bǐ hè','涤故更新':' dí gù gēng xīn','芝麻开花':' zhī ma kāi huā','只轮无反':' zhī lún wú fǎn','只轮不反':' zhī lún bù fǎn','蹙蹙靡骋':' cù cù mǐ chěng','为所欲为':' wéi suǒ yù wéi','为时不晚':' wéi shí bù wǎn','为时已晚':' wéi shí yǐ wǎn','只鸡樽酒':' zhī jī zūn jiǔ','指腹为婚':' zhǐ fù wéi hūn','等离子态':' děng lí zǐ tài','颠仆流离':' diān pú liú lí','无所作为':' wú suǒ zuò wéi','无的放矢':' wú dì fàng shǐ','陟罚臧否':' zhì fá zāng pǐ','无能为力':' wú néng wéi lì','至当不易':' zhì dàng bù yì','稚齿婑媠':' zhì chǐ wǒ tuǒ','递兴递废':' dì xīng dì fèi','炭疽杆菌':' tàn jū gǎn jūn','朝夷暮跖':' zhāo yí mù zhí','朝发夕至':' zhāo fā xī zhì','独立钻石':' dú lì zuàn shí','朝发暮至':' zhāo fā mù zhì','昭德塞违':' zhāo dé sè wéi','狼子野心':' láng zǐ yě xīn','燕太子丹':' yān tài zǐ dān','朝不谋夕':' zhāo bù móu xī','垂头搨翼':' chuí tóu dá yì','吹弹歌舞':' chuī tán gē wǔ','独生子女':' dú shēng zǐ nǚ','吹弹得破':' chuī tán dé pò','朝闻夕死':' zhāo wén xī sǐ','贼臣逆子':' zéi chén nì zǐ','凿龟数策':' záo guī shǔ cè','臧否人物':' zāng pǐ rén wù','载驰载驱':' zǎi chí zǎi qū','玩儿得转':' wán r dé zhuàn','玩儿花招':' wán r huā zhāo','朝不保暮':' zhāo bù bǎo mù','质疑问难':' zhì yí wèn nàn','没齿无怨':' mò chǐ wú yuàn','抹粉施脂':' mò fěn shī zhī','奋发有为':' fèn fā yǒu wéi','提高认识':' tí gāo rèn shi','聚米为山':' jù mǐ wéi shān','夙兴夜处':' sù xīng yè chǔ','挂席为门':' guà xí wéi mén','肆意妄为':' sì yì wàng wéi','伺瑕导蠙':' sì xiá dǎo pín','思所逐之':' si shuo zhu zi','姑射神人':' gū yè shén rén','俟河之清':' sì hé zhī qīng','天覆地载':' tiān fù dì zǎi','里应外合':' lǐ yìng wài hé','瓦查尿溺':' wǎ chá niào nì','托物寓兴':' tuō wù yù xīng','吞言咽理':' tūn yán yān lǐ','薄利多销':' bó lì duō xiāo','屠门大嚼':' tú mén dà jiáo','头会箕赋':' tóu kuài jī fù','头出头没':' tóu chū tóu mò','童颜鹤发':' tóng yán hè fà','西塞山区':' xī sài shān qū','随风而靡':' suí fēng ér mǐ','苏打饼干':' sū dá bǐng gān','弹丝品竹':' tán sī pǐn zhú','铺锦列绣':' pū jǐn liè xiù','煞费心机':' shà fèi xīn jī','山雨欲来':' shān yǔ yù lái','特殊要求':' tè shū yāo qiú','叨在知己':' tāo zài zhī jǐ','滔滔不尽':' tāo tāo bù jìn','古调不弹':' gǔ diào bù tán','孤鸿寡鹄':' gū hóng guǎ hú','贪惏无餍':' tān lín wú yàn','寡鹄孤鸾':' guǎ hú gū luán','孤鸾寡鹄':' gū luán guǎ hú','衣裳钩儿':' yī shang gōu r','贪财好色':' tān cái hào sè','故事片儿':' gù shì piān er','故态复还':' gù tài fù huán','孤臣孽子':' gū chén niè zǐ','沓来麕至':' tà lái yǒu zhì','鼓乐齐鸣':' gǔ yuè qí míng','恬不为意':' tián bù wéi yì','躬自菲薄':' gōng zì fěi bó','前徒倒戈':' qián tú dǎo gē','身体部分':' shēn tǐ bù fèn','赤字累累':' chì zì lěi lěi','诸子百家':' zhū zǐ bǎi jiā','甚而至于':' shèn ér zhì yú','起重葫芦':' qǐ chóng hú lu','起飞弹射':' qǐ fēi tán shè','折腰五斗':' shé yāo wǔ dòu','河伯为患':' hé bó wéi huàn','蛇心佛口':' shé xīn fó kǒu','鹤发童颜':' hè fà tóng yán','呵壁问天':' hē bì wèn tiān','设心处虑':' shè xīn chǔ lǜ','赫赫之功':' hè hè zhì gōng','舍身饲虎':' shè shēn sì hǔ','设计要求':' shè jì yāo qiú','身单力薄':' shēn dān lì bó','视为知己':' shì wéi zhī jǐ','诸子十家':' zhū zǐ shí jiā','观者如堵':' guān zhě rú dǔ','赤子之心':' chì zǐ zhī xīn','质子轰击':' zhì zǐ hōng jī','处理能力':' chǔ lǐ néng lì','同心一意':' tóng xīn yī yì','虚心好学':' xū xīn hào xué','调三斡四':' tiáo sān wò sì','融为一体':' róng wéi yī tǐ','狗颠屁股':' gǒu diān pì gu','狗屁倒灶':' gǒu pì dǎo zào','调剂余缺':' tiáo jì yú quē','蛮横无理':' mán hèng wú lǐ','称体裁衣':' chèn tǐ cái yī','杀鸡为黍':' shā jī wéi shǔ','费尽心机':' fèi jìn xīn jī','视为畏途':' shì wéi wèi tú','亲力亲为':' qīn lì qīn wéi','好骑者堕':' hào qí zhě duò','豪气干云':' háo qì gān yún','贫嘴薄舌':' pín zuǐ bó shé','好事之徒':' hào shì zhī tú','好问决疑':' hào wèn jué yí','费尽心思':' fèi jìn xīn si','才轻德薄':' cái qīng dé bó','魂不着体':' hún bù zhuó tǐ','广譬曲谕':' guǎng pì qǔ yù','逃灾避难':' táo zāi bì nàn','河清难俟':' hé qīng nán sì','如登春台':' rú dé chūn tái','迄今为止':' qì jīn wéi zhǐ','近似等级':' jìn sì děng jí','肉薄骨并':' ròu bó gǔ bìng','日月入怀':' rì yuè rù huái','倡而不和':' chàng ér bù hè','退避三舍':' tuì bì sān shè','横蛮无理':' hèng mán wú lǐ','合浦珠还':' hé pǔ zhū huán','横无忌惮':' hèng wú jì dàn','日省月课':' rì xǐng yuè kè','入理切情':' rù lǐ qiē qíng','扫眉才子':' sǎo méi cái zǐ','铁板茄子':' tiě bǎn qié zi','铁杆粉丝':' tiě gǎn fěn sī','货而不售':' huo er bu shou','哺糟啜醨':' bǔ zāo chuò lí','日进斗金':' rì jìn dǒu jīn','塞翁得马':' sài wēng dé mǎ','气吞牛斗':' qì tūn niú dǒu','去太去甚':' qù tai qù shèn','鹄形菜色':' hú xíng cài sè','长安棋局':' cháng ān qí jú','裘弊金尽':' qiú bì jīn jìn','画荻和丸':' huà dí huò wán','化害为利':' huà hài wéi lì','画龙刻鹄':' huà lóng kè hú','差之毫厘':' chā zhī háo lí','差三错四':' chā sān cuò sì','情凄意切':' qíng qī yì qiē','合浦还珠':' hé pǔ huán zhū','日新月著':' rì xīn yuè zhù','三灾八难':' sān zāi bā nàn','三邻四舍':' sān lín sì shè','河落海干':' hé luò hǎi gān','三大差别':' sān dà chā bié','河南坠子':' hé nán zhuì zǐ','三差五错':' sān chā wǔ cuò','三不拗六':' sān bù niù liù','起偃为竖':' qǐ yǎn wéi shù','钻木取火':' zuàn mù qǔ huǒ','千载奇遇':' qiān zǎi qí yù','不足为凭':' bù zú wéi píng','患难夫妻':' huàn nàn fū qī','还朴反古':' huán pǔ fǎn gǔ','重足而立':' chóng zú ér lì','还珠合浦':' huán zhū hé pǔ','切理厌心':' qiē lǐ yàn xīn','切理会心':' qiē lǐ huì xīn','没齿不忘':' mò chǐ bù wàng','材优干济':' cái yōu gàn jǐ','财务会计':' cái wù kuài jì','琴瑟调和':' qín sè tiáo hé','才夸八斗':' cái kuā bā dǒu','千载一遇':' qiān zǎi yī yù','财竭力尽':' cái jié lì jìn','千载一日':' qiān zǎi yī rì','银行业务':' yín háng yè wù','晦盲否塞':' huì máng pǐ sè','铺天盖地':' pū tiān gài dì','财殚力尽':' cái dān lì jìn','重眼皮儿':' chóng yǎn pí r','测量记录':' cè liáng jì lù','豁然顿悟':' huò rán dùn wù','栖风宿雨':' qī fēng xiǔ yǔ','气势磅礴':' qì shì páng bó','七十二行':' qī shí èr háng','讫情尽意':' qì qíng jìn yì','奇技淫巧':' qí jì yín qiǎo','不足为怪':' bù zú wéi guài','不肖子孙':' bù xiào zǐ sūn','欺行霸市':' qī háng bà shì','起根由头':' qǐ gēn yóu tou','豁然开悟':' huò rán kāi wù','铺盖卷儿':' pū gài juǎn ér','七颠八倒':' qī diān bā dǎo','七病八倒':' qī bìng bā dǎo','铺胸纳地':' pū xiōng nà dì','豁然确斯':' huò rán què sī','蒲柳之质':' pú liǔ zhī zhì','七行俱下':' qī háng jù xià','华亭鹤唳':' huà tíng hè lì','前仆后踣':' qián pú hòu bó','亲密无间':' qīn mì wú jiàn','圭角不露':' guī jiǎo bù lù','难进易退':' nan jin yi tui','捱三顶四':' āi sān dǐng sì','鼠疫杆菌':' shǔ yì gǎn jūn','阿平绝倒':' ā píng jué dǎo','会计信息':' kuài jì xìn xī','九垓八埏':' jiǔ gāi bā yán','挨冻受饿':' ái dòng shòu è','会计分录':' kuài jì fēn lù','苦苦相逼':' kǔ kǔ xiàng bī','爱人好士':' ài rén hào shì','捱三顶五':' āi sān dǐng wǔ','窥间伺隙':' kuī jiàn sì xì','挨山塞海':' āi shān sè hǎi','爱生恶死':' ài shēng wù sǐ','口似悬河':' kǒu sì xuán hé','经史子集':' jīng shǐ zǐ jí','口腹之累':' kǒu fù zhī lěi','安身为乐':' ān shēn wéi lè','课嘴撩牙':' kè zuǐ liáo yá','金鳷擘海':' jīn zhī bò hǎi','尽态极妍':' jìn tài jí yán','默诵佛号':' mò sòng fó hào','假日经济':' jià rì jīng jì','鞠躬君子':' jū gōng jūn zǐ','救黥医劓':' jiù qíng yī yì','白发偕老':' bái fà xié lǎo','白发朱颜':' bái fà zhū yán','绝对误差':' jué duì wù chā','居不重席':' jū bù chóng xí','捐躯赴难':' juān qū fù nàn','举措不当':' jǔ cuò bù dàng','鞠为茂草':' jū wéi mào cǎo','聚合反应':' jù hé fǎn yìng','尽其所有':' jìn qí suǒ yǒu','绝子绝孙':' jué zǐ jué sūn','咸津津儿':' xián jīn jīn r','拔本塞源':' bá běn sè yuán','可逆反应':' kě nì fǎn yìng','老师宿儒':' lǎo shī xiǔ rú','麦盖提县':' mài gě tí xiàn','老白干儿':' lǎo bái gān ér','澜倒波随':' lán dǎo bō suí','破矩为圆':' pò jǔ wéi yuán','批吭捣虚':' pī háng dǎo xū','均匀分布':' jūn yún fēn bù','片词只句':' piàn cí zhī jù','破觚为圜':' pò gū wéi yuán','基本电荷':' jī běn diàn hè','平铺直叙':' píng pū zhí xù','基本要求':' jī běn yāo qiú','品竹弹丝':' pǐn zhú tán sī','撇呆打堕':' piě dāi dǎ duò','不露圭角':' bù lù guī jiǎo','积谗糜骨':' jī chán méi gǔ','积德累善':' jī dé lěi shàn','破家为国':' pò jiā wéi guó','不见舆薪':' bú jiàn yú xīn','急功好利':' jí gōng hào lì','被山带河':' pī shān dài hé','否极阳回':' pǐ jí yáng huí','批砉导窾':' pī huā dǎo táo','几不欲生':' jī bù yù shēng','家无担石':' jiā wú dàn shí','薄技在身':' bó jì zài shēn','破坏荷载':' pò huài hè zài','被褐怀珠':' pī hè huái zhū','批风抹月':' pī fēng mò yuè','波属云委':' bō zhǔ yún wěi','披发文身':' pī fà wén shēn','捧心西子':' pěng xīn xī zǐ','不当人子':' bù dāng rén zǐ','跑马卖解':' pǎo mǎ mài xiè','旁指曲谕':' páng zhǐ qǔ yù','不差累黍':' bù chā lěi shǔ','攀藤附葛':' pān téng fù gě','拨嘴撩牙':' bō zuǐ liáo yá','拨云撩雨':' bō yún liáo yǔ','脑脊髓炎':' nǎo jǐ suǐ yán','孽子孤臣':' niè zǐ gū chén','拨雨撩云':' bō yǔ liáo yún','开锣喝道':' kāi luó hè dào','逆子贼臣':' nì zǐ zéi chén','逆臣贼子':' nì chén zéi zǐ','霓裳羽衣':' ní cháng yǔ yī','伯乐相马':' bó lè xiàng mǎ','挠直为曲':' náo zhí wéi qū','攫为己有':' jué wéi jǐ yǒu','克尽厥职':' kè jìn jué zhí','水尽鹅飞':' shuǐ jìn é fēi','惊叹不已':' jīng tàn bù yǐ','饿莩遍野':' è piǎo biàn yě','力有未逮':' lì yǒu wèi dài','解衣磅礴':' jiě yī páng bó','奔走呼号':' bēn zǒu hū háo','理论知识':' lǐ lùn zhī shi','离鸾别鹄':' lí luán bié hú','解衣卸甲':' jiě yī xiè jiǎ','竭智尽力':' jié zhì jìn lì','离子反应':' lí zǐ fǎn yìng','破崖绝角':' pò yá jué jiǎo','蠡测管窥':' lǐ cè guǎn kuī','尽瘁至死':' jìn cuì zhì sǐ','高能粒子':' gāo néng lì zǐ','高高手儿':' gāo gāo shǒu r','高丽棒子':' gāo lí bàng zi','累苏积块':' lěi sū jī kuài','累累如珠':' lěi lěi rú zhū','累块积苏':' lěi kuài jī sū','饿莩载道':' è piǎo zài dào','首足异处':' shǒu zú yì chǔ','乐尽悲来':' lè jìn bēi lái','过都历块':' guò dū lì kuài','观衅伺隙':' guān xìn sì xì','率马以骥':' shuài mǎ yǐ jì','桂折一枝':' guì shé yī zhī','数米量柴':' shǔ mǐ ér chái','数米而炊':' shǔ mǐ ér chuī','好丹非素':' hào dān fēi sù','桂子兰孙':' guì zǐ lán sūn','收支差额':' shōu zhī chā é','收入差距':' shōu rù chā jù','调和分析':' tiáo hé fēn xī','诗云子曰':' shī yún zǐ yuè','事与心违':' shì yù xīn wéi','什袭以藏':' shí xí yǐ cáng','什袭而藏':' shí xī ér cáng','什伍东西':' shí wǔ dōng xī','过甚其辞':' guò shèn qí cí','十魔九难':' shí mó jiǔ nàn','调三窝四':' tiáo sān wō sì','累计折旧':' lěi jì zhé jiù','金尽裘敝':' jīn jìn qiú bì','白发丹心':' bái fà dān xīn','丽池卡登':' lí chí kǎ dēng','燎发摧枯':' liǎo fà cuī kū','避军三舍':' bì jūn sān shè','风雨欲来':' fēng yǔ yù lái','碧波万顷':' bì bō wàn qǐng','风靡一时':' fēng mǐ yī shí','变贪厉薄':' biǎn tān lì bó','剪发杜门':' jiǎn fà dù mén','劳务合同':' láo wù hé tong','刻鹄成鹜':' kè hú chéng wù','撩云拨雨':' liáo yún bō yǔ','九行八业':' jiǔ háng bā yè','八斗之才':' bā dǒu zhī cái','抱法处势':' bào fǎ chǔ shì','八难三灾':' bā nàn sān zāi','救苦救难':' jiù kǔ jiù nàn','百辞莫辩':' bǎi cí mò biàn','君子三戒':' jūn zǐ sān jiè','君子好逑':' jūn zǐ hǎo qiú','颠覆分子':' diān fù fèn zǐ','临深履薄':' lín shēn lǚ bó','背曲腰弯':' bèi qǔ yāo wān','落后分子':' luò hòu fēn zǐ','鸠摩罗什':' jīu mó luó shí','连鬓胡子':' lián bìn hú zǐ','解甲倒戈':' jiě jiǎ dǎo gē','肩摩毂接':' jiān mó gū jiē','非异人任':' fēi yì rén rèn','非都会郡':' fēi dū huì jùn','鞠躬尽力':' jū gōng jìn lì','履薄临深':' lǚ bó lín shēn','简丝数米':' jiǎn sī shǔ mǐ','头半天儿':' tóu bàn tiān r','掠美市恩':' lüě měi shì ēn','绿林豪士':' lù lín háo shì','绿林豪杰':' lù lín háo jié','露红烟绿':' lù hóng yān lǜ','见义必为':' jiàn yì bì wéi','竭尽心力':' jié jìn xīn lì','预备知识':' yù bèi zhī shi','流行歌曲':' liú xíng gē qǔ','笃信好学':' dǔ xìn hào xué','匪伊朝夕':' fěi yí zhāo xī','互为表里':' hù wéi biǎo lǐ','早占勿药':' zǎo zhān wù yào','仰屋著书':' yǎng wū zhù shū','一时千载':' yī shí qiān zǎi','任人唯亲':' rèn rén wéi qīn','一朝之忿':' yī zhāo zhī fèn','瞻予马首':' zhān yú mǎ shǒu','交通堵塞':' jiāo tōng dǔ sè','亚曼牙乡':' yà màn yá xiāng','曾母投杼':' zēng mǔ tóu zhù','匀速运动':' yún sù yùn dòng','以疏间亲':' yǐ shū jiàn qīn','缊褐瓢箪':' yùn hè piáo dān','月晕而风':' yuè yùn ér fēng','月夜花朝':' yuè yè huā zhāo','干净俐落':' gān jìng lì luò','干净利落':' gān jìng lì luò','月夕花朝':' yuè xī huā zhāo','原始积累':' yuán shǐ jī lěi','冤家路狭':' yuān jia lù xiá','以眼还眼':' yǐ yǎn huán yǎn','以水济水':' yǐ shuǐ jǐ shuǐ','于无声处':' yú wú shēng chǔ','一掷乾坤':' yī zhì qián kūn','亹亹不倦':' tān wěi bù juàn','人情味儿':' rén qíng wèi ér','人模狗样':' rén mú gǒu yàng','饮马投钱':' yìn mǎ tóu qián','人谁无过':' rén shéi wú guò','人鱼小姐':' rén yú xiǎo jie','一坐尽倾':' yī zuò jìn qīng','一坐尽惊':' yī zuò jìn jīng','什锦果盘':' shí jǐn guǒ pán','一网尽扫':' yī wǎng jìn sǎo','什么地方':' shén me dì fang','交通阻塞':' jiāo tōng zǔ sè','什么时候':' shén me shí hòu','一朝千里':' yī zhāo qiān lǐ','一叶扁舟':' yī yè piān zhōu','一言中的':' yī yán zhōng dì','意兴索然':' yì xīng suǒ rán','令人发指':' lìng rén fà zhǐ','予智予雄':' yú zhì yú xióng','鹰觑鹘望':' yīng qù hú wàng','应付票据':' yìng fù piào jù','孟什维克':' mèng shí wéi kè','鸣锣喝道':' míng luó hè dào','善自为谋':' shàn zì wéi móu','喇叭水仙':' lā bā shuǐ xiān','邈处欿视':' miǎo chǔ jī shì','勉为其难':' miǎn wéi qí nán','难更仆数':' nán gēng pú shǔ','面谩腹诽':' miàn màn fù fěi','靡靡之声':' mǐ mǐ zhī shēng','蒙蒙细雨':' mēng mēng xì yǔ','啦啦队长':' lā lā duì zhǎng','貌似强大':' mào sì qiáng dà','锚固长度':' máo gù cháng dù','毛发之功':' máo fà zhī gōng','尨眉皓发':' mánɡ méi hào fà','满堂喝彩':' mǎn táng hè cǎi','埋三怨四':' mán sān yuàn sì','谩辞哗说':' màn cí huá shuō','麦丘之祝':' mài qiū zhī zhù','名我固当':' ming wo gu dang','摸不着边':' mō bù zhuó biān','与民更始':' yǔ rén gēng shǐ','有借无还':' yǒu jiè wú huán','优游岁月':' yōu yóu suì yuè','优游不断':' yōu yóu bù duàn','有以善处':' yǒu yǐ shàn chǔ','有所作为':' yǒu suǒ zuò wéi','事在人为':' shì zài rén wéi','事怕行家':' shì pà háng jiā','褎如充耳':' yòu rú chōng ěr','褎然举首':' yòu rán jǔ shǒu','有的放矢':' yǒu dì fàng shǐ','没世难忘':' mò shì nán wàng','二重母音':' èr chóng mǔ yīn','用词不当':' yòng cí bù dàng','有志之士':' yǒu zhì zhī shì','钜人长德':' jù rén cháng dé','遂非文过':' suí fēi wén guò','初露头角':' chū lù tóu jiǎo','暮暮朝朝':' mù mù zhāo zhāo','唾面自干':' tuò miàn zì gān','引以为鉴':' yǐn yǐ wéi jiàn','九齿钉耙':' jǐu chǐ dīng pá','买卖合同':' mǎi mài hé tong','铸剑为犁':' zhù jiàn wéi lí','脱袍退位':' tuō páo tuì wèi','拖麻拽布':' tuō má zhuài bù','屯蹶否塞':' tún juě fǒu sāi','为数不少':' wéi shù bù shǎo','遂迷忘反':' suí mí wàng fǎn','以人为鉴':' yǐ rén wéi jiàn','一日之长':' yī rì zhī cháng','助桀为暴':' zhù jié wéi bào','昼乾夕惕':' zhòu qián xī tì','望风披靡':' wàng fēng pī mǐ','周郎顾曲':' zhōu láng gù qǔ','不可胜数':' bù kě shèng shǔ','置锥之地':' zhì zhuī zhī dì','指皂为白':' zhǐ zào wéi bái','不定冠词':' bù dìng guàn cí','知识结构':' zhī shi jié gòu','知识产业':' zhī shi chǎn yè','指山卖磨':' zhǐ shān mài mò','歪歪倒倒':' wāi wāi dǎo dǎo','枉曲直凑':' wǎng qǔ zhí còu','助桀为虐':' zhù jié wéi nüè','委委佗佗':' wēi wēi tuó tuó','无间是非':' wú jiàn shì fēi','无缝天衣':' wú féng tiān yī','恶恶从短':' wù wù cóng duǎn','五倍子虫':' wǔ bèi zǐ chóng','优哉游哉':' yōu zāi yóu zāi','文过遂非':' wén guò suí fēi','文房四侯':' wén fáng sì hòu','危于累卵':' wēi yú lěi luǎn','畏威怀德':' wèi wēi huái dé','违法行为':' wéi fǎ xíng wéi','唯唯否否':' wěi wěi fǒu fǒu','兆电子伏':' zhào diàn zǐ fú','兔角龟毛':' tu jiao gui mao','威望素著':' wēi wàng sù zhù','为蛇添足':' wéi shé tiān zú','先入为主':' xiān rù wéi zhǔ','光禄大夫':' guāng lù dài fu','为国为民':' wéi guó wéi mín','不求甚解':' bù qiú shèn jiě','不为所动':' bù wéi suǒ dòng','朝歌暮弦':' zhāo gē mù xián','一矢中的':' yī shǐ zhòng dì','一年半载':' yī nián bàn zǎi','一弹指顷':' yī tán zhǐ qǐng','子孙满堂':' zǐ sūn mǎn táng','三藏法师':' sān zàng fǎ shī','一念之差':' yī niàn zhī chā','子丑寅卯':' zǐ chǒu yín mǎo','追趋逐耆':' zhuī qū zhú shì','一无所长':' yī wú suǒ cháng','一笑置之':' yī xiào zhì zhī','总体要求':' zǒng tǐ yāo qiú','一言为定':' yī yán wéi dìng','一走了之':' yī zǒu liǎo zhī','抓破脸子':' zhuā pò liǎn zǐ','著作权法':' zhù zuò quán fǎ','属垣有耳':' zhǔ yuán yǒu ěr','三更半夜':' sān gēng bàn yè','一技之长':' yī jì zhī cháng','以人为镜':' yǐ rén wéi jìng','一年到头':' yì nián dào tóu','一天到晚':' yì tiān dào wǎn','栉风酾雨':' zhì fēng shī yǔ','朝华夕秀':' zhāo huá xī xiù','不省人事':' bù xǐng rén shì','指不胜偻':' zhǐ bù shèng lǚ','不着边际':' bù zhuó biān jì','枕曲藉糟':' zhěn qū jiè zāo','中子俘获':' zhōng zǐ fú huò','朝折暮折':' zhāo shé mù shé','朝攀暮折':' zhāo pān mù shé','朝欢暮乐':' zhāo huān mù lè','止戈兴仁':' zhǐ gē xīng rén','一多对应':' yī duō duì yìng','朝歌夜弦':' zhāo gē yè xián','主客颠倒':' zhǔ kè diān dǎo','褚小杯大':' zhǔ xiǎo bēi dà','左右为难':' zuǒ yòu wéi nán','一之为甚':' yī zhī wéi shèn','一之谓甚':' yī zhī wèi shèn','作歹为非':' zuò dǎi wéi fēi','坐不重席':' zuò bù chóng xí','棉花套子':' mián huā tào zǐ','南郭处士':' nán guō chǔ shì','投资银行':' tóu zī yín háng','顺蔓摸瓜':' shùn wàn mō guā','三尺童子':' sān chǐ tóng zǐ','日朘月削':' rì juān yuè xuē','深文曲折':' shēn wén qǔ shé','神至之笔':' shén zhì zhī bǐ','宋词元曲':' sòng cí yuán qǔ','肆意横行':' sì yì héng xíng','四方之志':' sì fāng zhī zhì','铄古切今':' shuò gǔ qiē jīn','削职为民':' xuē zhí wéi mín','日省月修':' rì xǐng yuè xiū','削铅笔机':' xiāo qiān bǐ jī','前半天儿':' qián bàn tiān r','刚正不阿':' gāng zhèng bù ē','梳云掠月':' shū yún lüě yuè','束缊还妇':' shù yūn huán fù','熟思审处':' shú sī shěn chǔ','深恶痛疾':' shēn wù tòng jí','束身自好':' shù shēn zì hào','日省月试':' rì xǐng yuè shì','日削月朘':' rì xuē yuè juān','疏不间亲':' shū bù jiàn qīn','半夜三更':' bàn yè sān gēng','深厉浅揭':' shēn lì qiǎn qì','审己度人':' shěn jǐ duó rén','化险为夷':' huà xiǎn wéi yí','北斗七星':' běi dǒu qī xīng','神号鬼哭':' shén háo guǐ kū','汇业银行':' huì yè yín háng','十四行诗':' shí sì háng shī','蛇蝎为心':' shé xiē wéi xīn','半身不遂':' bàn shēn bù suí','日以为常':' rì yǐ wéi cháng','苫眼铺眉':' shān yǎn pū méi','三老五更':' sān lǎo wǔ gēng','塞翁之马':' sài wēng zhī mǎ','洒扫应对':' sǎ sào yìng duì','汝成人耶':' nu cheng ren ye','肉山脯林':' ròu shān fǔ lín','危如累卵':' wēi rú lěi luǎn','危若朝露':' wēi ruò zhāo lù','树倒根摧':' shù dǎo gēn cuī','书本知识':' shū běn zhī shi','沈诗任笔':' shěn shī rèn bǐ','千里之志':' qiān lǐ zhī zhì','千载一会':' qiān zǎi yī huì','且住为佳':' qiě zhù wéi jiā','各尽所能':' gè jìn suǒ néng','合同各方':' hé tong gè fāng','千载难遇':' qiān zǎi nán yù','乾乾翼翼':' qián qián yì yì','合众为一':' hé zhòng wéi yī','千磨百折':' qiān mó bǎi shé','千金之子':' qiān jīn zhī zǐ','将伯之呼':' qiāng bó zhī hū','同归于尽':' tóng guī yú jìn','泣数行下':' qì shù háng xià','吐蕃王朝':' tǔ bō wáng cháo','君子之交':' jūn zǐ zhī jiāo','七返还丹':' qī fǎn huán dān','千载一弹':' qiān zǎi yī dàn','日长似岁':' rì cháng sì suì','只说不做':' zhī shuō bù zuò','千载一时':' qiān zǎi yī shí','强得易贫':' qiǎng dé yì pín','力尽神危':' lì jìn shén wēi','束戈卷甲':' shù gē juàn jiǎ','实验研究':' shí yàn yán jiū','什围伍攻':' shí wéi wǔ gōng','失马塞翁':' shī mǎ sài wēng','十行俱下':' shí háng jù xià','十夫楺椎':' shí fū zhī zhuī','十夫桡椎':' shí fū ráo zhuī','诗肠鼓吹':' shī chá gǔ chuì','生死未卜':' shēng sǐ wèi bǔ','仆仆风尘':' pú pú fēng chén','强而后可':' qiǎng ér hòu kě','人自为战':' rén zì wéi zhàn','切树倒根':' qiē shù dǎo gēn','切近的当':' qiē jìn de dāng','翘首企足':' qiáo shǒu qǐ zú','敲骨剥髓':' qiāo gǔ bāo suǐ','强自取折':' qiáng zì qǔ shé','强食自爱':' qiǎng shí zì ài','包皮环切':' bāo pí huán qiē','暴腮龙门':' pù sāi lóng mén','难以为情':' nán yǐ wéi qíng','乐尽哀生':' lè jìn āi shēng','黏黏糊糊':' nián nián hū hū','逆施倒行':' nì shī dǎo xíng','泥名失实':' nì míng shī shí','内省不疚':' nèi xǐng bù jiù','培训要求':' péi xùn yāo qiú','铺眉苫眼':' pū méi shàn yǎn','马咽车阗':' mǎ yān chē tián','洛阳才子':' luò yáng cái zǐ','了不可见':' liǎo bù kě jiàn','宁折不弯':' nìng zhé bù wān','腊尽春回':' là jìn chūn huí','揆情度理':' kuí qíng duó lǐ','揆理度情':' kuí lǐ duó qíng','塞翁失马':' sài wēng shī mǎ','快心遂意':' kuài xīn suí yì','会计核算':' kuài jì hé suàn','苦尽甜来':' kǔ jìn tián lái','口血未干':' kǒu xuè wèi gān','年谊世好':' nián yì shì hào','怒涛澎湃':' nù tāo péng pài','空调机组':' kōng tiáo jī zǔ','否终复泰':' pǐ zhōng fù tài','铺眉蒙眼':' pū méi méng yǎn','凭虚公子':' píng xū gōng zǐ','平均误差':' píng jūn wù chā','品竹调丝':' pǐn zhú tiáo sī','漂母进饭':' piāo mǔ jìn fàn','漂泊无定':' piāo bó wú dìng','骈拇枝指':' pián mǔ zhī zhǐ','否终则泰':' pǐ zhōng zé tài','和尚打伞':' hé shang dǎ sǎn','攀花折柳':' pān huā shé liǔ','否往泰来':' pǐ wǎng tài lái','和睦相处':' hé mù xiāng chǔ','难乎为情':' nán hū wéi qíng','披发缨冠':' pī fā yīng guàn','咬文嚼字':' yǎo wén jiáo zì','庞眉皓发':' páng méi hào fà','庞眉白发':' páng méi bái fà','攀藤揽葛':' pān téng lǎn gě','口轻舌薄':' kǒu qīng shé bó','恪尽职守':' kè jìn zhí shǒu','诞谩不经':' dàn màn bù jīng','敛色屏气':' liǎn sè bǐng qì','临难不恐':' lín nàn bù kǒng','临敌易将':' lín dí yì jiàng','裂眦嚼齿':' liè zì jiáo chǐ','劣迹昭著':' liè jì zhāo zhù','劣迹昭着':' liè jì zhāo zhe','累土至山':' lěi tǔ zhì shān','量力度德':' liàng lì duó dé','国定假日':' guó dìng jià rì','图像处理':' tú xiàng chǔ lǐ','凌波仙子':' líng bō xiān zǐ','礼为情貌':' lǐ wéi qíng mào','里挑外撅':' lǐ tiǎo wài juē','立身处世':' lì shēn chǔ shì','礼让为国':' lǐ ràng wéi guó','历精为治':' lì jīng wéi zhì','历尽艰辛':' lì jìn jiān xīn','李广不侯':' lǐ guǎng bù hòu','夙兴昧旦':' sù xīng mèi dàn','麟子凤雏':' lín zǐ fèng chú','领导班子':' líng dǎo bān zǐ','累教不改':' lěi jiào bù gǎi','大便干燥':' dà biàn gān zào','看守内阁':' kān shǒu nèi gé','开户银行':' kāi hù yín háng','君子协定':' jūn zǐ xié dìng','多灾多难':' duō zāi duō nàn','君子固穷':' jūn zǐ gù qióng','倔头倔脑':' juè tou juè nǎo','倔强倨傲':' jué jiàng jù ào','抉奥阐幽':' jué ào chǎn yōu','卷甲韬戈':' juàn jiǎ tāo gē','流血漂橹':' liú xiě piāo lǔ','句子成分':' jù zi chéng fèn','看家本事':' kān jiā běn shì','嗜血杆菌':' shì xuè gǎn jūn','擂天倒地':' léi tiān dǎo dì','累足成步':' lěi zú chéng bù','落草为寇':' luò cǎo wéi kòu','乱作胡为':' luàn zuò hú wéi','哗啦一声':' huā lā yī shēng','推轮捧毂':' tuī lún pěng gū','乌面鹄形':' wū miàn hú xíng','万夫不当':' wàn fū bù dāng','精义入神':' jing yi ru shen','敢作敢为':' gǎn zuò gǎn wéi','鼓衰力尽':' gǔ shuāi lì jìn','思觉失调':' sī jué shī tiáo','公正不阿':' gōng zhèng bù ē','更难仆数':' gēng nán pú shù','倒绷孩儿':' dào bēng hái ér','顾曲周郎':' gù qǔ zhōu láng','尽付东流':' jìn fù dōng liú','鼓角齐鸣':' gǔ jiǎo qí míng','干名采誉':' gān míng cǎi yù','道在人为':' dào zài rén wéi','敢为敢做':' gǎn wéi gǎn zuò','太阳黑子':' tài yáng hēi zǐ','好吃懒做':' hào chī lǎn zuò','福为祸先':' fú wéi huò xiān','间不容息':' jiàn bù róng xī','峨峨汤汤':' é é shāng shāng','祸为福先':' huò wéi fú xiān','干卿底事':' gān qīng dǐ shì','微电子学':' wēi diàn zǐ xué','豁然省悟':' huò rán xǐng wù','解除合同':' jiě chú hé tong','钩章棘句':' gōu zhāng jí jù','心急火燎':' xīn jí huǒ liǎo','心神不属':' xīn shén bù zhǔ','倒三颠四':' dǎo sān diān sì','进退出处':' jìn tuì chū chǔ','各自为政':' gè zì wéi zhèng','狗续侯冠':' gǒu xù hòu guàn','狗追耗子':' gǒu zhuī hào zǐ','倒因为果':' dǎo yīn wéi guǒ','大处着眼':' dà chù zhuó yǎn','故技重演':' gù jì chóng yǎn','干将莫邪':' gān jiàng mò yé','澄沙汰砾':' dèng shā tài lì','更仆难尽':' gèng pú nán jìn','小里小气':' xiǎo li xiǎo qì','解衣盘磅':' jiě yī pán páng','瞪目哆口':' dèng mù chǐ kǒu','古为今用':' gǔ wéi jīn yòng','娱乐场所':' yú lè cháng suǒ','带薪休假':' dài xīn xiū jià','天竺牡丹':' tiān zhú mǔ dan','淮橘为枳':' huái jú wéi zhǐ','凤雏麟子':' fèng chú lín zǐ','风驰草靡':' fēng chí cǎo mǐ','夺人所好':' duó rén suǒ hào','蜂攒蚁集':' fēng cuán yǐ jí','引吭高歌':' yǐn háng gāo gē','洪炉燎发':' hóng lú liáo fà','还我河山':' huán wǒ hé shān','花攒锦簇':' huā cuán jǐn cù','怀敌附远':' huái dí fù yuǎn','度德量力':' duó dé liàng lì','几可乱真':' jī kě luàn zhēn','非分之财':' fēi fèn zhī cái','花簇锦攒':' huā cù jǐn cuán','花朝月夜':' huā zhāo yuè yè','花攒锦聚':' huā cuán jǐn jù','哗世取名':' huá shì qǔ míng','哗世动俗':' huá shì dòng sú','方正不阿':' fāng zhèng bù ē','度己以绳':' duó jǐ yǐ shéng','激薄停浇':' jī bó tíng jiāo','客户应用':' kè hù yìng yòng','分内之事':' fèn nèi zhī shì','黑更半夜':' hēi gēng bàn yè','横倒竖卧':' héng dǎo shù wò','分风劈流':' fēn fēng pǐ liú','横行不法':' héng xíng bù fǎ','扼腕长叹':' è wàn cháng tàn','横行无忌':' héng xíng wú jì','廊坊地区':' láng fáng dì qū','火急火燎':' huǒ jí huǒ liǎo','守正不阿':' shǒu zhèng bù ē','蜂攒蚁聚':' fēng cuán yǐ jù','分外妖娆':' fèn wài yāo ráo','帝王切开':' dì wáng qiē kāi','引以为荣':' yǐn yǐ wéi róng','多财善贾':' duō cái shàn gǔ','度长絜大':' dù cháng xié dà','丰富知识':' fēng fù zhī shi','缝缝补补':' féng féng bǔ bǔ','合同管理':' hé tong guǎn lǐ','心宽体胖':' xīn kuān tǐ pán','尽其所能':' jìn qí suǒ néng','方差分析':' fāng chā fēn xī','炫玉贾石':' xuàn yù gǔ shí','燕市悲歌':' yān shì bēi gē','粪金龟子':' fèn jīn guī zǐ','萎靡不振':' wěi mǐ bù zhèn','为裘为箕':' wéi qiú wéi jī','燕驾越毂':' yān jià yuè gū','忘恩失义':' wàng ēn shī yì','莞尔而笑':' wǎn ěr ér xiào','为期不远':' wéi qī bù yuǎn','抵死谩生':' dǐ sǐ màn shēng','燕雀处屋':' yàn què chǔ wū','对牛弹琴':' duì niú tán qín','浇风薄俗':' jiāo fēng bó sú','大兴安岭':' dà xīng ān lǐng','教一识百':' jiāo yī shí bǎi','供认不讳':' gòng rèn bù huì','性别角色':' xìng bié jué sè','教书育人':' jiāo shū yù rén','工业会计':' gōng yè kuài jì','绿林好汉':' lù lín hǎo hàn','燕金募秀':' yān jīn mù xiù','嚼铁咀金':' jiáo tiě jǔ jīn','为鬼为蜮':' wéi guǐ wéi yù','燕歌赵舞':' yān gē zhào wǔ','哑子托梦':' yǎ zǐ tuō mèng','纷至沓来':' fēn zhì tà lái','岩栖穴处':' yán qī xué chǔ','哑子寻梦':' yǎ zǐ xún mèng','王八羔子':' wáng bā gāo zǐ','哑子做梦':' yǎ zǐ zuò mèng','为虺弗摧':' wéi huǐ fú cuī','唯邻是卜':' wéi lín shì bǔ','精疲力尽':' jīng pí lì jìn','帏薄不修':' wéi báo bù xiū','芽孢杆菌':' yá bāo gǎn jūn','眼饧耳热':' yǎn xíng ěr rè','言气卑弱':' yan qi bei ruo','粘皮著骨':' nián pí zhù gǔ','茅塞顿开':' máo sè dùn kāi','惟日为岁':' wéi rì wéi suì','岩居穴处':' yán jū xué chǔ','冠屦倒施':' guàn jù dǎo shī','奏鸣曲式':' zòu míng qǔ shì','各取所长':' gè qǔ suǒ cháng','间接推理':' jiàn jiē tuī lǐ','见义敢为':' jiàn yì gǎn wéi','复兴时代':' fù xīng shí dài','尖嘴薄舌':' jiān zuǐ bó shé','将门虎子':' jiàng mén hǔ zǐ','甘分随时':' gān fèn suí shí','瞪眼咋舌':' dèng yǎn zé shé','对称破缺':' duì chèn pò quē','工作任务':' gōng zuò rèn wu','工作态度':' gōng zuò tài du','公共服务':' gōng gòng fú wù','谨毛失貌':' jǐn máo shī mào','德薄能鲜':' dé bó néng xiǎn','膏唇岐舌':' gào chún qí shé','经史百子':' jīng shǐ bǎi zǐ','膏粱子弟':' gāo liáng zǐ dì','告朔饩羊':' gù shuò xì yáng','经纶济世':' jing lun ji shi','古调单弹':' gǔ diào dān tán','箪食瓢饮':' dān sì piáo yǐn','久要不忘':' jiǔ yāo bù wàng','淡然处之':' dàn rán chǔ zhī','甘处下流':' gān chǔ xià liú','淡然置之':' dàn rán zhì zhī','后翻筋斗':' hòu fān jīn dǒu','箪食壶浆':' dān sì hú jiāng','鞠躬屏气':' jū gōng bǐng qì','举措失当':' jǔ cuò shī dàng','好久不见':' hǎo jǐu bu jiàn','功薄蝉翼':' gōng bó chán yì','居不重茵':' jū bù chóng yīn','捡洋落儿':' jiǎn yáng là ér','干戈扰攘':' gān gē rǎo rǎng','女性厌恶':' nǔ: xìng yàn wù','尖酸刻薄':' jiān suān kè bó','功夫片儿':' gōng fū piān er','管理会计':' guǎn lǐ kuài jì','左邻右舍':' zuǒ lín yòu shè','儋石之储':' dàn shí zhī chǔ','冠绝一时':' guàn jué yī shí','大腹便便':' dà fù pián pián','反应迅速':' fǎn yìng xùn sù','反目为仇':' fǎn mù wéi chóu','韬戈卷甲':' tāo gē juàn jiǎ','袖里乾坤':' xiù lǐ qián kūn','夕惕朝乾':' xī tì zhāo qián','假假若是':' jiǎ jià ruò shì','没羞没臊':' méi xīu méi sào','无为自成':' wú wéi zì chéng','无为而成':' wú wéi ér chéng','倒买倒卖':' dǎo mǎi dǎo mài','无声无臭':' wú shēng wú xiù','行侠好义':' xíng xiá hào yì','以毛相马':' yǐ máo xiàng mǎ','蹊田夺牛':' xī tián duó niú','以规为瑱':' yǐ guī wéi tiàn','遗臭万载':' yí chòu wàn zǎi','一重一掩':' yī chóng yī yǎn','占为己有':' zhàn wéi jǐ yǒu','异常处理':' yì cháng chǔ lǐ','鹞子翻身':' yào zǐ fān shēn','瑶台银阙':' yáo tái yín què','摇滚音乐':' yáo gǔn yīn yuè','值得敬佩':' zhí de jìng pèi','借花献佛':' jiè huā xiàn fó','燕子衔食':' yàn zǐ xián shí','心在魏阙':' xīn zài wèi què','信以为真':' xìn yǐ wéi zhēn','形式逻辑':' xíng shì luó ji','省身克己':' xǐng shēn kè jǐ','兴如嚼蜡':' xìng rú jiáo là','兴利除害':' xīng lì chú hài','兴废继绝':' xīng fèi jì jué','兴讹造讪':' xīng é zào shàn','性别差异':' xìng bié chā yì','心驰魏阙':' xīn chí wèi què','借腹生子':' jiè fù shēng zǐ','胁肩累足':' xié jiān lěi zú','校园歌曲':' xiào yuán gē qǔ','倒果为因':' dào guǒ wéi yīn','兴微继绝':' xīng wēi jì jué','相与为一':' xiāng yǔ wéi yī','相女配夫':' xiàng nǚ pèi fū','相差无几':' xiāng chā wú jǐ','先自隗始':' xiān zì wěi shǐ','洋里洋气':' yáng li yáng qì','燕昭好马':' yān zhāo hǎo mǎ','化合反应':' huà hé fǎn yìng','唐虞之治':' táng yú zhī zhì','分毫之差':' fēn háo zhī chā','分解代谢':' fēn jiě dài xiè','天干地支':' tiān gān dì zhī','田父献曝':' tián fǔ xiàn pù','恬淡无为':' tián dàn wú wéi','切向速度':' qiē xiàng sù dù','投传而去':' tóu zhuàn ér qù','腾腾兀兀':' téng téng wū wū','切磋琢磨':' qiē cuō zhuó mó','调皮捣蛋':' tiáo pí dǎo dàn','弹剑作歌':' tán jiàn zuò gē','叹观止矣':' tàn guān zhǐ yǐ','泰然处之':' tài rán chǔ zhī','泰来否往':' tài lái pǐ wǎng','嗒然若丧':' tà rán ruò sàng','隋珠弹雀':' suí zhū tán què','岁序更新':' suì xù gēng xīn','遂心快意':' suí xīn kuài yì','调墨弄笔':' tiáo mò nòng bǐ','调丝品竹':' tiáo sī pǐn zhú','兴云致雨':' xīng yún zhì yǔ','寻行数墨':' xún háng shǔ mò','燕跃鹄踊':' yàn yuè hú yǒng','佛蒙特州':' fó méng tè zhōu','眼观六路':' yǎn guān liù lù','偃革为轩':' yǎn gé wéi xuān','言颠语倒':' yán diān yǔ dǎo','燕岱之石':' yān dài zhī shí','压卷之作':' yā juàn zhī zuò','压倒元白':' yā dǎo yuán bái','炫石为玉':' xuàn shí wéi yù','出没无常':' chū mò wú cháng','宿雨餐风':' xiǔ yǔ cān fēng','偃武兴文':' yǎn wǔ xīng wén','一曲阳关':' yī qǔ yáng guān','舞衫歌扇':' wǔ shān gē shàn','无尽无穷':' wú jìn wú qióng','通同一气':' tōng tóng yī yì','同工异曲':' tóng gōng yì qǔ','调朱傅粉':' tiáo zhū fù fěn','举世混浊':' jǔ shì hún zhuó','计穷力尽':' jì qióng lì jìn','鸿鹄之志':' hóng hú zhī zhì','弹痕累累':' dàn hén léi léi','积以为常':' jī yǐ wéi cháng','吉凶未卜':' jí xiōng wèi bǔ','过而能改':' guò ér néng gǎi','画蛇著足':' huà shé zhuó zú','戟指嚼舌':' jǐ zhǐ jiáo shé','刁钻刻薄':' diāo zuān kè bó','弹道导弹':' dàn dào dǎo dàn','含混不清':' hán hún bù qīng','行间字里':' háng jiān zì lǐ','雕蚶镂蛤':' diāo hān lòu gé','东邻西舍':' dōng lín xī shè','过为已甚':' guò wéi yǐ shèn','东飘西泊':' dōng piāo xī bó','父债子还':' fù zhài zǐ huán','好高骛远':' hào gāo wù yuǎn','专心一意':' zhuān xīn yī yì','佳人薄命':' jiā rén bó mìng','电子设备':' diàn zǐ shè bèi','基因重组':' jī yīn chóng zǔ','弱不禁风':' ruò bù jīn fēng','桂折兰摧':' guì shé lán cuī','反间之计':' fǎn jiàn zhī jì','还珠返璧':' huán zhū fǎn bì','胡作乱为':' hú zuò luàn wéi','婚生子女':' hūn shēng zǐ nǚ','康巴藏区':' kāng bā zàng qū','分兵把口':' fèn bīng bǎ kǒu','发引千钧':' fà yǐn qiān jūn','魂飞魄丧':' hún fēi pò sāng','红颜白发':' hóng yán bái fà','回天倒日':' huí tiān dǎo rì','疾风甚雨':' jí fēng shèn yǔ','回干就湿':' huí gān jiù shī','子宫颈癌':' zǐ gōng jǐng ái','黄口孺子':' huáng kǒu rú zǐ','黄发儿齿':' huáng fà ér chǐ','飞将数奇':' fē jiàng shù jī','字里行间':' zì lǐ háng jiān','费尽心血':' fèi jìn xīn xuè','电子词典':' diàn zǐ cí diǎn','好为人师':' hào wéi rén shī','如数家珍':' rú shǔ jiā zhēn','好学不倦':' hào xué bù juàn','宁左勿右':' nìng zuǒ wù yòu','急公好施':' jí gōng hào shī','独有千秋':' dú yòu qiān qiū','箕山之志':' jī shān zhī zhì','强词夺理':' qiǎng cí duó lǐ','佛头着粪':' fó tóu zhuó fèn','宁缺毋滥':' nìng quē wú làn','宁缺勿滥':' nìng quē wù làn','东西易面':' dōng xi yì miàn','好善乐施':' hào shàn lè shī','合两为一':' hé liǎng wéi yī','察微知著':' chá wēi zhī zhù','积年累岁':' jī nián lěi suì','计穷虑尽':' jì qióng lǜ jìn','东踅西倒':' dōng xué xī dǎo','极情尽致':' jí qíng jìn zhì','毫无用处':' háo wú yòng chu','斗酒学士':' dǒu jiǔ xué shì','斗榫合缝':' dǒu sǔn hé fèng','河梁之谊':' hé liáng zhì yí','赫赫之光':' hè hè zhì guāng','刿心鉥肾':' guì xīn xù shèn','东歪西倒':' dōng wāi xī dǎo','刿鉥肝肾':' guì xù gān shèn','好酒贪杯':' hào jiǔ tān bēi','规旋矩折':' guī xuán jǔ shé','鬼蜮伎俩':' guǐ yù jì liǎng','射频干扰':' shè pín gān rǎo','电子音乐':' diàn zǐ yīn yuè','断子绝孙':' duàn zǐ jué sūn','冬裘夏葛':' dōng qiú xià gě','计尽力穷':' jì jìn lì qióng','风流才子':' fēng liú cái zǐ','读书种子':' dú shū zhǒng zǐ','奉为楷模':' fèng wéi kǎi mó','蜂扇蚁聚':' fēng shān yǐ jù','饥寒交切':' jī hán jiāo qiē','枫桥夜泊':' fēng qiáo yè bó','积累经验':' jī lěi jīng yàn','睹物兴情':' dǔ wù xīng qíng','积功兴业':' jī gōng xīng yè','曲尽其妙':' qū jìn qí miào','去甚去泰':' qù shèn qù tài','厚死薄生':' hòu sǐ bó shēng','大头娃娃':' dà tóu wá wa','干戈四起':' gān gē sì qǐ','厚此薄彼':' hòu cǐ bó bǐ','子虚乌有':' zǐ xū wū yǒu','大难不死':' dà nàn bù sǐ','聱牙诘屈':' áo yá jié qū','日居月诸':' rì jī yuè zh','聚米为谷':' jù mǐ wéi gǔ','居里夫人':' jū lǐ fū ren','柏蒂切利':' bó dì qiè lì','居礼夫人':' jū lǐ fū ren','矮子看戏':' ǎi zǐ kàn xì','参差不一':' cēn cī bù yī','太子河区':' tài zǐ hé qū','呆似木鸡':' dāi sì mù jī','服务态度':' fú wù tài du','耶利米书':' yē lì mǐ shū','刻薄寡思':' kè bó guǎ sī','刻木为吏':' kè mù wéi lì','刻木为鹄':' kè mù wéi hú','削发披缁':' xuē fà pī zī','高足弟子':' gāo zú dì zǐ','私淑弟子':' sī shū dì zǐ','以斯帖记':' yǐ sī tiě jì','故家子弟':' gù jiā zǐ dì','柴立不阿':' chái lì bù ē','膏腴子弟':' gāo yú zǐ dì','刻足适屦':' kè zú shì jù','日不暇给':' rì bù xiá jǐ','大雅君子':' dà yǎ jūn zǐ','人莫予毒':' rén mò yú dú','打闷葫芦':' dǎ mèn hú lu','胳膊腕子':' gē bo wàn zǐ','误人子弟':' wù rén zǐ dì','高歌一曲':' gāo gē yī qǔ','热毛子马':' rè máo zǐ mǎ','刻薄寡恩':' kè bó guǎ ēn','打马虎眼':' dǎ mǎ hu yǎn','刻鹄类鹜':' kè hú lèi wù','学习目的':' xué xí mù dì','压压脚儿':' yā ya jiǎo r','认死扣儿':' rèn sǐ kòu r','视民如子':' shì mín rú zǐ','毕毕剥剥':' bì bì bāo bāo','娱妻弄子':' yú qī nòng zǐ','别太客气':' bié tài kè qi','委肉虎蹊':' wěi ròu hǔ xī','左宜右有':' zuǒ yí yòu fú','据为己有':' jù wéi jǐ yǒu','头足异处':' tóu zú yì chǔ','出臭子儿':' chū chòu zǐ r','没有意思':' méi yǒu yì si','温切斯特':' wēn qiē sī tè','公子哥儿':' gōng zǐ gē ér','死亡无日':' sǐ wáng wú rì','白日衣绣':' bái rì yì xiù','似醉如痴':' sì zuì rú chī','比什凯克':' bǐ shí kǎi kè','伺瑕抵蠙':' sì xiá dǐ pín','曲意迎合':' qǔ yì yíng hé','一丘之貉':' yī qiū zhī hé','为富不仁':' wéi fù bù rén','丝恩发怨':' sī ēn fà yuàn','不可分割':' bù kě fēn gē','孺子可教':' rú zǐ kě jiào','参差不齐':' cēn cī bù qí','耶鲁大学':' yē lǔ dà xué','群雌粥粥':' qún cí yù yù','八字帖儿':' bā zì tiě ér','实与有力':' shí yù yǒu lì','加德满都':' jiā dé mǎn dū','为仁不富':' wéi rén bù fù','含含糊糊':' hán hán hu hū','一哄而起':' yī hòng ér qǐ','暴衣露冠':' pù yī lù guàn','加利肋亚':' jiā lì lèi yà','凯撒肋雅':' kǎi sā lèi yǎ','四不拗六':' sì bù niù liù','扑杀此獠':' pū shā cǐ lǎo','头没杯案':' tóu mò bēi àn','投袂荷戈':' tóu mèi hè gē','神不附体':' shén bù fù tǐ','阿非利加':' a fēi lì jiā','厚积薄发':' hòu jī bó fā','味如鸡肋':' wèi rú jī lèi','达到目的':' dá dào mù dì','铁哥们儿':' tiě gē men r','狗玩儿的':' gǒu wán r de','至死靡它':' zhì sǐ mǐ tā','艾哈迈德':' aì hǎ mài dé','倒打一耙':' dào dǎ yī pá','村夫俗子':' cūn fū sú zǐ','搭把手儿':' dā bǎ shǒu r','不对劲儿':' bù duì jìn r','不对碴儿':' bù duì chá r','萨哈诺夫':' sà hǎ nuò fū','萨哈罗夫':' sà hǎ luó fū','鹘入鸦群':' hú rù yā qún','拭目以俟':' shì mù yǐ sì','薄胎瓷器':' bó tāi cí qì','糊涂一时':' hú tu yī shí','呼卢喝雉':' hū lú hè zhì','不足为虑':' bù zú wéi lǜ','奥西娜斯':' aò xī nuó sī','扎格罗斯':' zā gé luó sī','胡子拉碴':' hú zǐ lā chā','即心即佛':' jí xīn jí fó','诘屈聱牙':' jié qū áo yá','徒子徒孙':' tú zǐ tú sūn','词不逮理':' cí bù dài lǐ','词不逮意':' cí bù dài yì','吱哩哇啦':' zhī lī wā lā','赍志而没':' jī zhì ér mò','齐眉穗儿':' qí méi suì r','集体宿舍':' jí tǐ sù shè','易子而食':' yì zǐ ér shí','三臡八菹':' sān ní bā zū','历历可数':' lì lì kě shǔ','舍利子塔':' shè lì zi tǎ','爱素好古':' ài sù hào gǔ','除恶务尽':' chú è wù jìn','打击乐器':' dǎ jī yuè qì','结发夫妻':' jié fà fū qī','失而复得':' shī ér fù de','漫无目的':' màn wú mù dì','咸丝丝儿':' xián sī sī r','大吃大喝':' dà chī dà hè','为德不卒':' wéi dé bù zú','心细如发':' xīn xì rú fà','一字不差':' yī zì bù chā','时移俗易':' shí yí sú yì','豁达大度':' huò dá dà dù','过河卒子':' guò hé zú zǐ','懒得搭理':' lǎn de dā lǐ','铆足劲儿':' mǎo zú jìn r','螺丝起子':' luó sī qǐ zǐ','包袱底儿':' bāo fú dǐ ér','只字不提':' zhī zì bù tí','兔起鹘落':' tù qǐ hú luò','毫不客气':' háo bù kè qi','葡萄干儿':' pú tao gān r','葛瑞格尔':' gě ruì gé ěr','易卜拉辛':' yì bǔ lā xīn','扞格不入':' hàn gé bù rù','夫子自道':' fū zǐ zì dào','狐狸尾巴':' hú li wěi ba','妻离子散':' qī lí zǐ sàn','积露为波':' jī lù wéi bō','画虎刻鹄':' huà hǔ kè hú','不足为奇':' bù zú wéi qí','虚与委蛇':' xū yǔ wēi yí','何足为奇':' hé zú wéi qí','除恶务本':' chú è wù běn','木骨都束':' mù gǔ dū shù','鹤子梅妻':' hè zǐ méi qī','予取予求':' yú qǔ yú qiú','予取予携':' yú qǔ yú xié','魂不附体':' hún bù fù tǐ','叽里呱啦':' jī lǐ guā lā','不计其数':' bù jì qí shù','何乐不为':' hé lè bù wéi','合二为一':' hé èr wéi yī','予取予夺':' yú qǔ yú duó','须弥芥子':' xū mí jiè zǐ','疾不可为':' jí bù kě wéi','皈依佛法':' guī yī fó fǎ','姿态婀娜':' zī tài ē nuó','阿苏火山':' a sū huǒ shān','无以为报':' wú yǐ wéi bào','如花似玉':' rú huā sì yù','气克斗牛':' qì kè dǒu niú','仁义君子':' rén yì jūn zǐ','否极泰来':' pǐ jí tài lái','为非作恶':' wéi fēi zuò è','只眼独具':' zhī yǎn dú jù','二十八宿':' èr shí bā xiù','为恶不悛':' wéi è bù quān','御史大夫':' yù shǐ dài fū','弃甲倒戈':' qì jiǎ dǎo gē','七老八倒':' qī lǎo bā dǎo','原子武器':' yuán zǐ wǔ qì','阿肯色州':' a kěn sè zhōu','分析处理':' fēn xī chǔ lǐ','桃蹊柳曲':' táo qī liǔ qǔ','日薄西山':' rì bó xī shān','通都大邑':' tōng dū dà yì','吆五喝六':' yāo wǔ hè liù','济济一堂':' jǐ jǐ yī táng','绨袍之义':' tì páo zhī yì','骨头架子':' gú tou jià zi','吁天呼地':' yù tiān hū dì','济宁地区':' jǐ níng dì qū','帷薄不修':' wéi bó bù xiū','皮包骨头':' pí bāo gú tou','功不可没':' gōng bù kě mò','余勇可贾':' yú yǒng kě gǔ','骑驴倒堕':' qí lǘ dǎo duò','马萨诸塞':' mǎ sà zhū sài','鼓起勇气':' gǔ qǐ yǒng qì','父慈子孝':' fù cí zǐ xiào','鼻口部分':' bí kǒu bù fèn','青紫被体':' qīng zǐ pī tǐ','人足家给':' rén zú jiā jǐ','黑芝麻糊':' hēi zhī ma hú','卑礼厚币':' bēi lǐ hòu bì','骨头节儿':' gú tou jié ér','一分为二':' yī fēn wéi èr','厚古薄今':' hòu gǔ bó jīn','模糊不清':' mó hu bù qīng','一年四季':' yì nián sì jì','气息奄奄':' qì xī yān yān','卜昼卜夜':' bǔ zhòu bǔ yè','日甚一日':' rì shèn yī rì','高音喇叭':' gāo yīn lǎ ba','未知数儿':' wèi zhī shù r','狐藉虎威':' hú jiè hǔ wēi','藉资挹注':' jiè zī yì zhù','互不干涉':' hù bù gān shè','厚味腊毒':' hòu wèi xī dú','吼三喝四':' hǒu sān hè sì','厚今薄古':' hòu jīn bó gǔ','厚德载福':' hòu dé zǎi fú','葫芦依样':' hú lu yī yàng','苏州码子':' sū zhōu mǎ zǐ','处理办法':' chǔ lǐ bàn fǎ','红得发紫':' hóng de fā zǐ','宏都拉斯':' hóng dū lā sī','出处语默':' chū chǔ yǔ mò','何所不为':' hé suǒ bù wéi','处心积虑':' chǔ xīn jī lǜ','虎珀拾芥':' hǔ pò shí jiè','蒙帕纳斯':' měng pà nà sī','萨摩耶犬':' sà mó yē quǎn','子为父隐':' zǐ wéi fù yǐn','各行各业':' gè háng gè yè','分离分子':' fēn lí fèn zǐ','阿旺曲培':' a wàng qū péi','阿旺曲沛':' a wàng qǔ pèi','日乾夕惕':' rì qián xī tì','气动葫芦':' qì dòng hú lu','扫地俱尽':' sǎo dì jù jìn','扫地以尽':' sǎo dì yǐ jìn','书不尽意':' shū bù jìn yì','太阿倒持':' tài ē dào chí','模糊数学':' mó hu shù xué','右翼分子':' yòu yì fēn zǐ','吉电子伏':' jí diàn zǐ fú','投河自尽':' tóu hé zì jìn','八大胡同':' bā dà hú tòng','发指眦裂':' fà zhǐ zì liè','推枯折腐':' tuī kū shé fǔ','卸磨杀驴':' xiè mò shā lǘ','刻意为之':' kè yì wéi zhī','千里一曲':' qiān lǐ yī qǔ','自以为然':' zì yǐ wéi rán','如履薄冰':' rú lǚ bó bīng','伺瑕导隙':' sì xiá dǎo xì','四马攒蹄':' sì mǎ cuán tí','似水如鱼':' sì shuǐ rú yú','克仑特罗':' kè lún tè luō','呲牙咧嘴':' zī yá liě zuǐ','曲曲折折':' qū qū zhé shé','靡靡之音':' mǐ mǐ zhī yīn','动嘴皮儿':' dòng zuǐ pí r','湮没无闻':' yān mò wú wén','靡有孑遗':' mǐ yǒu jié yí','热热闹闹':' rè rè nāo nao','百堕俱举':' bǎi huī jù jǔ','石头子儿':' shí tou zǐ er','似漆如胶':' sì qī rú jiāo','分子医学':' fēn zǐ yī xué','卑辞厚币':' bēi cí hòu bì','歙漆阿胶':' shè qī ē jiāo','取之不尽':' qǔ zhī bù jìn','卡文迪什':' kǎ wén dí shí','背碑覆局':' bèi bēi fù jú','实逼处此':' shí bī chǔ cǐ','身体发肤':' shēn tǐ fà fū','清辞丽曲':' qīng cí lì qǔ','毓子孕孙':' yù zǐ yùn sūn','男子气概':' nán zǐ qì gài','撒都该人':' sā dū gāi rén','无所不为':' wú suǒ bù wéi','比佛利山':' bǐ fó lì shān','看不过去':' kàn bu guò qu','郁郁累累':' yù yù lěi lěi','列缺霹雳':' liè quē pī lì','时移世易':' shí yí shì yì','画地为狱':' huà dì wéi yù','电荷耦合':' diàn hè ǒu hé','及时处理':' jí shí chǔ lǐ','呢呢痴痴':' ní ní chī chī','加里肋亚':' jiā lǐ lèi yà','视为儿戏':' shì wéi ér xì','为民父母':' wéi mín fù mǔ','白费力气':' bái fèi lì qi','插入因子':' chā rù yīn zǐ','似非而是':' sì fēi ér shì','坐地自划':' zuò dì zì huá','鲍子知我':' bào zǐ zhī wǒ','一意孤行':' yī yì gū xíng','独具只眼':' dú jù zhī yǎn','爱莫之助':' ài mò zhī zhù','渔阳鞞鼓':' yǔ yáng pí gǔ','独山子区':' dú shān zǐ qū','如拾地芥':' rú shí dì jiè','累土聚沙':' lěi tǔ jù shā','苞苴竿牍':' bāo jū gān dú','百思莫解':' bǎi sī mò jiě','如鱼似水':' rú yú sì shuǐ','白眼珠儿':' bái yǎn zhū r','雷扎耶湖':' léi zhá yē hú','电子伏特':' diàn zǐ fú tè','阿尔山市':' a ěr shān shì','尽力而为':' jìn lì ér wéi','如花似月':' rú huā sì yuè','皮诺切特':' pí nuò qiē tè','如龙似虎':' rú lóng sì hǔ','如切如磋':' rú qiē rú cuō','独辟蹊径':' dú pì xī jìng','唐突西子':' táng tū xī zǐ','庆父不死':' qìng fǔ bù sǐ','如痴似醉':' rú chī sì zuì','运移时易':' yùn yí shí yì','允许误差':' yǔn xǔ wù chā','如花似朵':' rú huā sì duǒ','狗拿耗子':' gǒu ná hào zǐ','载入史册':' zǎi rù shǐ cè','如花似锦':' rú huā sì jǐn','眦裂发指':' zì liè fà zhǐ','没人味儿':' méi rén wèi r','二道贩子':' èr dào fàn zǐ','卑鄙无耻':' bēi bǐ wú chǐ','束蒲为脯':' shù pú wéi pú','半部论语':' bàn bù lún yǔ','被褐怀玉':' pī hè huái yù','安分知足':' ān fèn zhī zú','三闾大夫':' sān lǘ dài fū','激进分子':' jī jìn fèn zǐ','史蒂文斯':' shǐ dì wén sī','如金似玉':' rú jīn sì yù','济南地区':' jǐ nán dì qū','子母炸弹':' zǐ mǔ zhà dàn','乐乐呵呵':' lè lè hē hē','科纳克里':' kē nà kè lǐ','阿克伦河':' a kè lún hé','阿瓦鲁阿':' a wǎ lǔ ā','哇哩哇啦':' wā lǐ wā lā','塔塔儿人':' tǎ tǎ r rén','百色起义':' bó sè qǐ yì','墨子泣丝':' mò zǐ qì sī','模模糊糊':' mó mó hu hū','大麻哈鱼':' dà má hǎ yú','可泣可歌':' kě qì kě gē','吧唧吧唧':' bā ji bā ji','一语破的':' yī yǔ pò dì','塞拉耶佛':' sè lā yē fó','阿拉尔市':' a lā ěr shì','耶稣基督':' yē sū jī dū','耶哥尼雅':' yē gē ní yǎ','提拉米苏':' dī lā mǐ sū','自给自足':' zì jǐ zì zú','哩哩啦啦':' li li lā lā','格拉斯哥':' gé lā sī gē','阿尔泰语':' a ěr tài yǔ','无以塞责':' wú yǐ sè zé','阿普尔顿':' a pǔ ěr dùn','呜呜咽咽':' wū wū yè yè','粒子物理':' lì zǐ wù lǐ','的黎波里':' dì lí bō lǐ','薄物细故':' bó wù xì gù','嗳气呕逆':' ài qì ǒu nì','阿尔盖达':' a ěr gài dá','不可移易':' bù kě yí yì','握发吐哺':' wò fà tǔ bǔ','叽哩咕噜':' jī li gū lū','阿特金斯':' a tè jīn sī','阿金库尔':' a jīn kù ěr','阿伦达尔':' a lún dá ěr','克拉科夫':' kè lā kē fū','胳臂箍儿':' gē bei gū r','哪儿的话':' nǎ r de huà','目无余子':' mù wú yú zǐ','阿时趋俗':' ē shí qū sú','阿尔卑斯':' a ěr bēi sī','不起眼儿':' bù qǐ yǎn r','认死理儿':' rèn sǐ lǐ r','希腊字母':' xī là zì mǔ','以利亚撒':' yǐ lì yà sǎ','鹤发鸡皮':' hè fà jī pí','负固不服':' fù gù bù fú','乌尔都语':' wū ěr dū yǔ','诃佛诋巫':' hē fó dǐ wū','呵佛骂祖':' hē fó mà zǔ','蹀儿鸭子':' dié r yā zi','马路牙子':' mǎ lù yá zǐ','一发破的':' yī fā pò dì','迷离马虎':' mí lí mǎ hu','密密麻麻':' mì mì mā mɑ','迷迷糊糊':' mí mi hū hū','迪斯科吧':' dí sī kē bā','头儿脑儿':' tóu r nǎo r','差不离儿':' chà bù lí r','与物无忤':' yǔ wù wú wǔ','滴滴答答':' dī dī dā dā','马路沿儿':' mǎ lù yán r','巴克科思':' bā kè kē sī','一笔抹摋':' yī bǐ mò sà','巴尔的摩':' bā ěr dì mó','法不阿贵':' fǎ bù ē guì','嘀里嘟噜':' dī lǐ dū lū','一字不易':' yī zì bù yì','饿虎之蹊':' è hǔ zhī xī','第一义谛':' dì yī yì dì','劈里啪啦':' pī li pā lā','一口气儿':' yī kǒu qì r','巴耶利巴':' bā yē lì bā','那曲地区':' nà qǔ dì qū','疙疙瘩瘩':' gē gē dā dá','格格不吐':' gē gē bù tǔ','霹雳啪啦':' pī lì pā lā','格格不纳':' gē gē bù nà','忍饥挨饿':' rěn jī ái è','一古脑儿':' yī gǔ nǎo r','乌衣子弟':' wū yī zǐ dì','可歌可泣':' kě gē kě qì','遗妻弃子':' yí qī qì zǐ','阿卡迪亚':' a kǎ dí yà','阿拉米语':' a lā mǐ yǔ','阿拉法特':' a lā fǎ tè','阿布达比':' a bù dá bǐ','阿斯伯格':' a sī bó gé','阿斯塔纳':' a sī tǎ nà','阿卜杜拉':' a bǔ dù lā','阿布扎比':' a bù zā bǐ','阿克苏河':' a kè sū hé','阿拉巴马':' a lā bā mǎ','挨饥抵饿':' ái jī dǐ è','阿拉塔斯':' a lā tǎ sī','阿布哈兹':' a bù hā zī','阿格尼迪':' a gé ní dí','阿姆哈拉':' a mǔ hā lā','扎尔达里':' zā ěr dá lǐ','扎鲁特旗':' zā lǔ tè qí','莫扎里拉':' mò zā lǐ lā','茶叶末儿':' chá yè mò r','阿奇里斯':' a qí lǐ sī','阿斯马拉':' a sī mǎ lā','阿拉伯文':' a lā bó wén','阿里巴巴':' a lǐ bā bā','不大离儿':' bù dà lí r','苦不唧儿':' kǔ bu jī r','纳德阿里':' nà dé a lǐ','阿迪达斯':' a dí dá sī','阿达比尔':' a dá bǐ ěr','正宫娘娘':' zhēng gōng niáng niáng','阿丽亚娜':' a lì yà nà','阿里地区':' a lǐ dì qū','打哈哈儿':' dǎ hā ha r','阿兹特克':' a zī tè kè','阿瓦里德':' a wǎ lǐ dé','阿尔萨斯':' a ěr sà sī','阿尔卡特':' a ěr kǎ tè','阿尔伯特':' a ěr bó tè','阿尔伯塔':' a ěr bó tǎ','阿穆尔河':' a mù ěr hé','阿耳戈斯':' a ěr gē sī','阿利坎特':' a lì kǎn tè','卡拉奇那':' kǎ lā jī nà','糊糊涂涂':' hū hū tú tú','阿美尼亚':' a měi ní yà','阿德雷德':' a dé léi dé','卡波耶拉':' kǎ bō yē lā','一大早儿':' yī dà zǎo r','叽叽哇哇':' jī jī wā wā','闭目塞耳':' bì mù sè ěr','卡尔扎伊':' kǎ ěr zā yī','阿美恩斯':' a měi ēn sī','不易一字':' bù yì yī zì','七子八婿':' qī zǐ bā xù','计日而俟':' jì rì ér sì','第比利斯':' dì bì lì sī','古希腊语':' gǔ xī là yǔ','傻大个儿':' shǎ dà gè r','阿摩司书':' a mó sī shū','无恶不为':' wú è bù wéi','喀啦喀啦':' kā lā kā lā','子女玉帛':' zǐ nǚ yù bó','欲取姑与':' yù qǔ gū yǔ','计日以俟':' jì rì yǐ sì','击其不意':' jī qí bù yì','福斯塔夫':' fú sī tǎ fū','阿多尼斯':' a duō ní sī','批哩啪啦':' pī li pā la','阿克苏市':' a kè sū shì','卡拉季奇':' kǎ lā jì jī','六安地区':' lù ān dì qū','阿加迪尔':' a jiā dí ěr','如饥似渴':' rú jī sì kě','噼里啪啦':' pī lǐ pā lā','阿弥陀佛':' ē mí tuó fó','鸡皮鹤发':' jī pí hè fà','阿得莱德':' a dé lái dé','鸡蛋壳儿':' jī dàn ké r','阿富汗语':' a fù hàn yǔ','呼不给吸':' hū bù jǐ xī','吐哺握发':' tǔ bǔ wò fà','孤立子波':' gū lì zǐ bō','阿德莱德':' a dé lái dé','余子碌碌':' yú zǐ lù lù','阿尔瓦雷':' a ěr wǎ léi','爱民如子':' ài mín rú zǐ','一仆二主':' yī pú èr zhǔ','不绝如发':' bù jué rú fà','阿尔加维':' a ěr jiā wéi','无与为比':' wú yǔ wéi bǐ','可疑分子':' kě yí fèn zǐ','得马折足':' dé mǎ shé zú','几何拓扑':' jǐ hé tuò pū','卖妻鬻子':' mài qī yù zǐ','毛发丝粟':' máo fà sī sù','以蠡测海':' yǐ lǐ cè hǎi','包袱皮儿':' bāo fú pí er','值得一提':' zhí de yī tí','细细地流':' xì xì de líu','自给有余':' zì jǐ yǒu yú','亚麻子油':' yà má zǐ yóu','阿尔都塞':' a ěr dōu sāi','阿尔衮琴':' a ěr gǔn qín','悉索薄赋':' xī suǒ bó fù','绿林起义':' lù lín qǐ yì','克什米尔':' kè shí mǐ ěr','纨绔子弟':' wán kù zǐ dì','哈德逊河':' hā dé xùn hé','我负子戴':' wǒ fù zǐ dài','积极分子':' jī jí fèn zǐ','泥足巨人':' ní zú jù rén','闭门塞户':' bì kǒu sè hù','过一会儿':' guò yī huì r','呼来喝去':' hū lái hè qù','曲霉毒素':' qǔ méi dú sù','一呵而就':' yī hē ér jiù','依阿取容':' yī ē qǔ róng','阿图什市':' a tú shí shì','以耳为目':' yǐ ěr wéi mù','哈佛大学':' hā fó dà xué','法尔卡什':' fǎ ěr kǎ shí','磁单极子':' cí dān jí zǐ','呢喃细语':' ní nán xì yǔ','看得过儿':' kàn de guò r','阿合奇县':' a hé qí xiàn','纨裤子弟':' wán kù zǐ dì','碌碌无为':' lù lù wú wéi','拿印把儿':' ná yìn bà er','吁咈都俞':' yù fú dōu yú','目不暇给':' mù bù xiá jǐ','靡颜腻理':' mǐ yán nì lǐ','合而为一':' hé ér wéi yī','模糊逻辑':' mó hu luó ji','业余爱好':' yè yú ài hào','以苦为乐':' yǐ kǔ wéi lè','洗发水儿':' xǐ fà shuǐ r','杜塞道夫':' dù sè dào fū','六枝特区':' lù zhī tè qū','色厉胆薄':' sè lì dǎn bó','草字头儿':' cǎo zì tóu r','普什图语':' pǔ shí tú yǔ','撒马尔干':' sǎ mǎ ěr gàn','阿赖耶识':' ā lài yē shí','撒马尔罕':' sǎ mǎ ěr hǎn','茄子河区':' qié zi hé qū','小媳妇儿':' xiǎo xí fu r','不拔一毛':' bù bá yì máo','敌特分子':' dí tè fèn zǐ','析骸易子':' xī hái yì zǐ','喀什噶尔':' kā shí gá ěr','遭遇不偶':' zāo yù bù ǒu','妻梅子鹤':' qī mén zǐ hè','博物君子':' bó wù jūn zǐ','阿意取容':' ē yì qǔ róng','喜不自禁':' xǐ bù zì jīn','阿世媚俗':' ē shì mèi sú','喀喇沁旗':' kā lā qìn qí','喀什地区':' kā shí dì qū','擘肌分理':' bò jī fēn lǐ','梅妻鹤子':' méi qī hè zǐ','企业倒闭':' qǐ yè dǎo bì','一鼻子灰':' yī bí zǐ huī','婀娜多姿':' ē nuó duō zī','无地自处':' wú dì zì chǔ','入不敷出':' rù bù fū chū','入土为安':' rù tú wéi ān','第二个人':' dì èr ge rén','阿谀取容':' ē yú qǔ róng','我黼子佩':' wǒ fǔ zǐ pèi','低音喇叭':' dī yīn lǎ ba','父析子荷':' fù xī zǐ hé','似有如无':' sì yǒu rú wú','凡夫俗子':' fán fū sú zǐ','布鲁塞尔':' bù lǔ sài ěr','不足部分':' bù zú bù fen','跗萼载韡':' fū è zǎi wěi','遂迷不寤':' suí mí bù wù','不足为法':' bù zú wéi fǎ','基本粒子':' jī běn lì zǐ','曲不离口':' qǔ bù lí kǒu','赫鲁雪夫':' hè lǔ xuě fu','阿育吠陀':' a yù fèi tuó','累及无辜':' lěi jí wú gū','绕弯子儿':' rào wān zǐ r','岁聿其莫':' suì yù qí mù','去本趋末':' qù běn qū mò','罗马尼亚':' luō mǎ ní yà','佛洛伊德':' fó luò yī dé','一心一意':' yī xīn yī yì','负担不起':' fù dān bu qǐ','妇人孺子':' fù rén rú zǐ','依撒意亚':' yī sā yì yà','分丝析缕':' fēn sī xī lǚ','塞浦路斯':' sài pǔ lù sī','粪土不如':' fèn tú bù rú','走背字儿':' zǒu bèi zì r','子母扣儿':' zǐ mǔ kòu ér','伺瑕抵隙':' sì xiá dǐ xì','曲突移薪':' qǔ tū yí xīn','严了眼儿':' yán le yǎn r','阿瓦提县':' a wǎ tí xiàn','塞哥维亚':' sè gē wéi yà','帕特丽夏':' pà tè lí xià','四季豆腐':' sì jì dòu fu','曲学阿世':' qǔ xué ā shì','不足为意':' bù zú wéi yì','不足为据':' bù zú wéi jù','阿其所好':' ē qí suǒ hào','暴衣露盖':' pù yī lù gài','易地而处':' yì dì ér chǔ','毒泷恶雾':' dú lóng è wù','蠹居棋处':' dù jū qí chǔ','阿克赛钦':' a kè sài qīn','泥多佛大':' ní duō fó dà','敷衍塞责':' fū yǎn sè zé','泥而不滓':' niè ér bù zǐ','稀里哗啦':' xī lǐ huā lā','泥古不化':' nì gǔ bù huà','握发吐飧':' wò fà tǔ sūn','泰西大儒':' tài xī dà rú','慕古薄今':' mù gǔ bó jīn','唏哩哗啦':' xī lī huā lā','嘁哩喀喳':' qī lǐ kā chā','为法自弊':' wéi fǎ zì bì','的一确二':' dí yī què èr','母以子贵':' mǔ yǐ zǐ guì','科尼赛克':' kē ní sài kè','仆仆道途':' pú pú dào tú','核子医学':' hé zǐ yī xué','偃旗仆鼓':' yǎn qí pú gǔ','离本趣末':' lí běn qū mò','格洛纳斯':' gé luò nà sī','巴甫洛夫':' bā fǔ luò fū','囤积居奇':' tún jī jū qí','不以为意':' bù yǐ wéi yì','不以为奇':' bù yǐ wéi qí','泰极而否':' tài jí ér pǐ','格子花呢':' gé zi huā ní','异议分子':' yì yì fèn zǐ','秘鲁苦蘵':' bì lǔ kǔ zhí','佛罗里达':' fó luó lǐ dá','格洛斯特':' gé luò sī tè','马拉喀什':' mǎ lā kā shí','以鹿为马':' yǐ lù wéi mǎ','支吾其词':' zhī wū qí cí','仆仆亟拜':' pú pú jí bài','贝塔粒子':' bèi tǎ lì zǐ','一览无遗':' yī lǎi wú yí','子母炮弹':' zǐ mǔ pào dàn','呼天吁地':' hū tiān yù dì','认贼作子':' rèn zéi zuò zǐ','急公好义':' jí gōng hào yì','怎么得了':' zěn me dé liǎo','带电粒子':' dài diàn lì zǐ','极端分子':' jí duān fèn zǐ','佛朗机炮':' fó lǎng jī pào','柔佛海峡':' róu fó hǎi xiá','巴塞隆纳':' bā sài lóng nà','忍俊不禁':' rěn jùn bù jīn','新式拚法':' xīn shì pīn fǎ','一劳永逸':' yī láo yǒng yì','自以为是':' zì yǐ wéi shì','人尽其材':' rén jìn qí cái','一小阵儿':' yī xiǎo zhèn r','原子序数':' yuán zǐ xù shù','拨弦乐器':' bō xián yuè qì','多劳多得':' duō láo duō de','极为庞大':' jí wéi páng dà','极深研几':' jí shēn yán jī','手板葫芦':' shǒu bǎn hú lu','杜松子酒':' dù sōng zǐ jiǔ','大兴土木':' dà xīng tǔ mù','才高八斗':' cái gāo bā dǒu','骂骂咧咧':' mà mà liē liē','外孙女儿':' wài sūn nǔ: r','多哈回合':' duō hā huí hé','自怨自艾':' zì yuàn zì yì','不可数集':' bù kě shuò jí','不以为然':' bù yǐ wéi rán','胡椒薄荷':' hú jiāo bò he','罗切斯特':' luó qiē sī tè','自繇自在':' zì yóu zì zai','置之死地':' zhì zhī sǐ dì','倒霉蛋儿':' dǎo méi dàn r','胳臂肘儿':' gē bei zhǒu r','离本徼末':' lí běn yāo mò','才疏德薄':' cái shū dé bó','耶酥会士':' yē sū huì shì','投机倒把':' tóu jī dǎo bǎ','牢什古子':' láo shí gǔ zi','乐山大佛':' lè shān dà fó','岂弟君子':' kǎi tì jūn zǐ','好大喜功':' hào dà xǐ gōng','好自为之':' hào zì wéi zhī','财殚力痡':' cái dān lì pū','伽马射线':' gā mǎ shè xiàn','一干二净':' yī gān èr jìng','克什克腾':' kè shí kè téng','太仆寺卿':' tài pú sì qīng','太子太保':' tài zǐ tài bǎo','一气呵成':' yī qì hē chéng','互为因果':' hù wéi yīn guò','张掖地区':' zhāng yè dì qū','伸缩喇叭':' shēn suō lǎ ba','曲麻莱县':' qǔ má lái xiàn','搞花样儿':' gǎo huā yàng r','扼襟控咽':' è jīn kòng yān','彬彬君子':' bīn bīn jūn zǐ','彼唱此和':' bǐ chàng cǐ hè','危如朝露':' wēi rú zhāo lù','步斗踏罡':' bù dǒu tà gāng','往心里去':' wǎng xīn li qù','弹射座椅':' tán shè zuò yǐ','往泥里踩':' wǎng nì lǐ cǎi','天雨路滑':' tiān yù lù huá','咬舌自尽':' yǎo shé zì jìn','多那太罗':' duō nǎ tài luó','任人宰割':' rèn rén zǎi gē','曾外祖父':' zēng wài zǔ fù','挑三窝四':' tiǎo sān wō sì','倒戈卸甲':' dǎo gē xiè jiǎ','才子佳人':' cái zǐ jiā rén','昌都地区':' chāng dū dì qū','不怀好意':' bù huái hào yì','曾外祖母':' zēng wài zǔ mǔ','不可估量':' bù kě gū liang','哲人其萎':' zhé rén qí wěi','投其所好':' tóu qí suǒ hào','五行八作':' wǔ háng bā zuò','希腊神话':' xī là shén huà','列别杰夫':' liè biè jié fū','启应祈祷':' qǐ yìng qí dǎo','凸面部分':' tū miàn bù fèn','佛兰芒语':' fó lán máng yǔ','一网打尽':' yī wǎng dǎ jìn','沉不住气':' chén bú zhù qì','多子多福':' duō zǐ duō fú','泪眼模糊':' lèi yǎn mó hu','枯草杆菌':' kū cǎo gǎn jūn','靡衣偷食':' mǐ yī tōu shí','五侯七贵':' wǔ hòu qī guì','啼饥号寒':' tí jī háo hán','无后为大':' wú hòu wéi dà','等一下儿':' děng yī xià r','等一会儿':' děng yī huì r','无间可伺':' wú jiān kě sì','等离子体':' děng lí zǐ tǐ','无尽无休':' wú jìn wú xiū','筋疲力尽':' jīn pí lì jìn','五侯蜡烛':' wǔ hòu là zhú','恶居下流':' wù jū xià liú','主要目的':' zhǔ yào mù dì','别开一格':' bié kāi yí gé','凿坏以遁':' záo pī yǐ dùn','难乎为继':' nán hū wéi jì','彬彬济济':' bīn bīn jǐ jǐ','阿什拉维':' a shén lā wéi','目眦尽裂':' mù zì jìn liè','森海塞尔':' sēn hǎi sè ěr','一饮而尽':' yī yǐn ér jìn','数一数二':' shǔ yī shǔ èr','阿图什县':' a tú shí xiàn','谓予不信':' wèi yú bù xìn','披发左衽':' pī fà zuǒ rèn','未为不可':' wèi wéi bù kě','椎髻布衣':' zhuī jì bù yī','咖啡馆儿':' kā fēi guǎn r','避祸求福':' bì huò qiú fù','石河子市':' shí hé zǐ shì','咭咭呱呱':' jī jī guā guā','砚水壶儿':' yàn shuǐ hú r','著于竹帛':' zhù yú zhú bó','一模一样':' yī mú yī yàng','靡靡之乐':' mǐ mǐ zhī yuè','五斗米道':' wǔ dǒu mǐ dào','哩哩罗罗':' lī lī luō luō','播糠眯目':' bō kāng mǐ mù','波流茅靡':' bō liú máo mǐ','喀拉汗国':' kā lā hán guó','指鹿为马':' zhǐ lù wéi mǎ','木头人儿':' mù tóu rén er','默而识之':' mò ér zhì zhī','拖拖沓沓':' tuō tuō tà tà','卷席而居':' juàn xí ér jū','朝露暮霭':' zhāo lù mù ǎi','差异分析':' chā yì fēn xī','引喻失义':' yǐn yù shī yì','大不列蹀':' dà bu lie die','耶路撒冷':' yē lù sā lěng','耶稣会士':' yē sū huì shì','披头散发':' pī tóu sàn fà','耳鼻咽喉':' ěr bí yān hóu','耶律大石':' yē lù: dà shí','来日大难':' lái rì dà nàn','大吃苦头':' dà chī kǔ tou','胳膊肘子':' gē bo zhǒu zǐ','大大咧咧':' dà dà liē liē','具体地说':' jù tǐ de shuō','咳珠唾玉':' ké zhū tuò yù','劳筋苦骨':' láo jīn kǔ gǔ','不切实际':' bù qiē shí jì','大陆漂移':' dà lù piāo yí','之子于归':' zhī zǐ yú guī','大溪豆干':' dà xī dòu gān','目空余子':' mù kōng yú zǐ','置之不理':' zhì zhī bù lǐ','母慈子孝':' mǔ cí zǐ xiào','恶不去善':' wù bù qù shàn','五尺竖子':' wǔ chǐ shù zǐ','业余教育':' yè yú jiào yù','乌踆兔走':' wū cún tù zǒu','莫可究诘':' mò kě jiū jié','墨迹未干':' mò jì wèi gān','极右分子':' jí yòu fèn zǐ','会计科目':' kuài jì kē mù','拉枯折朽':' lā kū shé xiǔ','瞰瑕伺隙':' kàn xiá sì xì','新斯科舍':' xīn sī kē shè','大有可为':' dà yǒu kě wéi','下不为例':' xià bù wéi lì','塞尔维亚':' sài ěr wéi yà','塞拉利昂':' sài lā lì áng','拉卜楞寺':' lā bǔ lèng sì','聊以塞责':' liáo yǐ sè zé','步罡踏斗':' bù gāng tà dǒu','和记黄埔':' hé jì huáng pǔ','批亢抵巇':' pī gāng dǐ xī','柔情脉脉':' róu qíng mò mò','不干不净':' bù gān bù jìng','以人为本':' yǐ rén wéi běn','孙子兵法':' sūn zǐ bīng fǎ','数不过来':' shǔ bù guò lái','乙种粒子':' yǐ zhǒng lì zǐ','棒子面儿':' bàng zi miàn r','别具只眼':' bié jù zhī yǎn','不是东西':' bù shì dōng xi','南箕北斗':' nán jī běi dǒu','右派分子':' yòu pài fèn zǐ','斜愣眼儿':' xié leng yǎn r','恐怖分子':' kǒng bù fèn zi','恐怖片儿':' kǒng bù piān r','各有所好':' gè yǒu suǒ hào','恣意妄为':' zì yì wàng wéi','各奔东西':' gè bèn dōng xī','乳臭未干':' rǔ xiù wèi gān','小菜碟儿':' xiǎo cài dié r','卑鄙龌龊':' bēi bǐ wò chuò','令狐德棻':' líng hú dé fēn','尺寸过大':' chǐ cun guò dà','反叛分子':' fǎn pàn fèn zǐ','动弹不得':' dòng tan bù dé','孑孑为义':' jié jié wéi yì','助人为乐':' zhù rén wéi lè','四方台区':' sì fāng tái qū','孔子家语':' kǒng zǐ jiā yǔ','四海为家':' sì hǎi wéi jiā','信号处理':' xìn hào chǔ lǐ','人际关系':' rén jì guān xì','利他行为':' lì tā xíng wéi','小苏打粉':' xiǎo sū dá fěn','不为人知':' bù wéi rén zhī','一小部分':' yī xiǎo bù fèn','巨海扇蛤':' jù hǎi shàn gé','水磨沟区':' shuǐ mò gōu qū','不为已甚':' bù wéi yǐ shèn','妄自菲薄':' wàng zì fěi bó','不为酒困':' bù wéi jǐu kùn','到此为止':' dào cǐ wéi zhǐ','有子存焉':' yǒu zǐ cún yān','四大名著':' sì dà míng zhù','认贼为子':' rèn zéi wéi zǐ','代数拓扑':' dài shù tuò pū','偏差距离':' piān chā jù lí','倒背手儿':' dào bèi shǒu r','嘉柏隆里':' jiā bó lóng lǐ','丫头片子':' yā tou piān zi','找台阶儿':' zhǎo tái jiē r','一一对应':' yī yī duì yìng','晰毛辨发':' xī máo biàn fà','道德认识':' dào dé rèn shi','悲歌当哭':' bēi gē dàng kū','认贼为父':' rèn zéi wéi fù','任人摆布':' rèn rén bǎi bù','互教互学':' hù jiāo hù xué','热闹非凡':' rè nao fēi fán','热核反应':' rè hé fǎn yìng','麇至沓来':' qún zhì tà lái','群居穴处':' qún jū xué chǔ','壶里乾坤':' hú lǐ qián kūn','剃发留辫':' tì fà líu biàn','有好奇心':' yǒu hào qí xīn','可数名词':' kě shǔ míng cí','嘎嘎小姐':' gā gā xiǎo jie','全军覆没':' quán jūn fù mò','情不自禁':' qíng bù zì jīn','并不在乎':' bìng bù zài hu','嘉兴地区':' jiā xīng dì qū','委内瑞拉':' wěi nèi ruì lā','委靡不振':' wěi mǐ bù zhèn','有朝一日':' yǒu zhāo yī rì','千钧一发':' qiān jūn yī fà','有头无尾':' yǒu tóu wú wěi','暴虎冯河':' bào hǔ píng hé','手扳葫芦':' shǒu bān hú lu','佳人才子':' jiā rén cái zǐ','横竖劲儿':' héng shù jìn r','前途未卜':' qián tú wèi bǔ','死海古卷':' sǐ hǎi gǔ juàn','会计制度':' kuài jì zhì dù','败子回头':' bài zǐ huí tóu','压轴好戏':' yā zhòu hǎo xì','孤家寡人':' gū jiā guǎ rén','一唱一和':' yī chàng yī hè','技术知识':' jì shù zhī shi','一目十行':' yī mù shí háng','夷为平地':' yí wéi píng dì','打躬作揖':' dǎ gōng zuō yī','广安地区':' guǎng ān dì qū','失败主义':' shī bài zhǔ yì','大有作为':' dà yǒu zuò wéi','分而治之':' fēn ér zhì zhī','一盘散沙':' yī pán sǎn shā','核战斗部':' hé zhàn dǒu bù','厦门大学':' xià mén dà xué','棋高一着':' qí gāo yī zhāo','夙兴夜寐':' sù xīng yè mèi','殒身不恤':' yǔn shēn bú xù','爱丽舍宫':' ài lì shè gōng','子宫肌瘤':' zǐ gōng jī liú','化为乌有':' huà wéi wū yǒu','值得品味':' zhí de pǐn wèi','慈悲为本':' cí bēi wéi běn','松巴哇岛':' sōng bā wā dǎo','一目了然':' yī mù liǎo rán','嗳气吞酸':' ài qì tūn suān','大动干戈':' dà dòng gān gē','步步为营':' bù bù wéi yíng','林荫大道':' lín yìn dà dào','分子杂交':' fēn zǐ zá jiāo','含糊不清':' hán hu bù qīng','书不尽言':' shū bù jìn yán','几乎完全':' jī hū wán quán','一言难尽':' yī yán nán jìn','沐猴而冠':' mù hóu ér guàn','含情脉脉':' hán qíng mò mò','佛口蛇心':' fó kǒu shé xīn','哩溜歪斜':' li liū wāi xié','一语中的':' yī yǔ zhōng dì','人尽其才':' rén jìn qí cái','沉得住气':' chén de zhù qì','心肌梗塞':' xīn jī gěng sè','心里有数':' xīn li yǒu shù','打家劫舍':' dǎ jiā jié shè','引以为憾':' yǐn yǐ wéi hàn','塞韦里诺':' sài wéi lǐ nuò','是非曲直':' shì fēi qǔ zhí','啰里啰嗦':' luō li luō suo','反客为主':' fǎn kè wéi zhǔ','拓扑结构':' tuò pū jié gòu','受冻挨饿':' shòu dòng ái è','国际关系':' guó jì guān xì','侯门似海':' hóu mén sì hǎi','室町幕府':' shì tǐng mù fǔ','木管乐器':' mù guǎn yuè qì','文艺复兴':' wén yì fù xīng','安步当车':' ān bù dàng chē','俄勒冈州':' e lè gāng zhōu','小时候儿':' xiǎo shí hou r','核电荷数':' hé diàn hè shù','勉力而为':' miǎn lì ér wéi','母音调和':' mǔ yīn tiáo hé','借方差额':' jiè fāng chā é','安分守己':' ān fèn shǒu jǐ','文书处理':' wén shū chǔ lǐ','堆案盈几':' duī àn yíng jī','罗曼带克':' luō màn dài kè','子弹火车':' zǐ dàn huǒ chē','仁人君子':' rén rén jūn zǐ','值得信赖':' zhí de xìn lài','一吐为快':' yī tǔ wéi kuài','嗳腐吞酸':' ài fǔ tūn suān','拉开架势':' lā kāi jià shi','朝露溘至':' zhāo lù kè zhì','化敌为友':' huà dí wéi yǒu','封妻荫子':' fēng qī yìn zǐ','气鸣乐器':' qì míng yuè qì','氧乙炔炬':' yǎng yǐ quē jù','意犹未尽':' yì yóu wèi jìn','仁至义尽':' rén zhì yì jìn','斗酒只鸡':' dǒu jiǔ zhī jī','一呼百应':' yī hū bǎi yìng','印度音乐':' yìn dù yīn yuè','戴高帽子':' dài gāo mào zǐ','供大于求':' gòng dà yú qiú','参差错落':' cēn cī cuò luò','朝三暮四':' zhāo sān mù sì','朝不保夕':' zhāo bù bǎo xī','干脆利落':' gān cuì lì luò','否极泰回':' pǐ jí tài huí','匹马只轮':' pǐ mǎ zhī lún','不置可否':' bù zhì kě fǒu','言无不尽':' yán wú bù jìn','发秃齿豁':' fà tū chǐ huò','一劳久逸':' yī láo jiǔ yì','法家拂士':' fǎ jiā bì shì','儿童歌曲':' ér tóng gē qǔ','一目五行':' yī mù wǔ háng','二三君子':' èr sān jūn zǐ','必和必拓':' bì huó bì tuò','以牙还牙':' yǐ yá huán yá','贸易逆差':' mào yì nì chā','一谦四益':' yī qiān sì yì','巴巴结结':' bā bā jiē jiē','佛罗伦萨':' fó luó lún sà','倒持太阿':' dǎo chí tài ā','以邻为壑':' yǐ lín wéi hè','菲食薄衣':' fěi shí bó yī','巴马干酪':' bā mǎ gān lào','布隆伯格':' bù lōng bó gé','赞叹不已':' zàn tàn bù yǐ','佛山地区':' fó shān dì qū','跑堂儿的':' pǎo táng r de','纷纭杂沓':' fēn yún zá tà','积时累日':' jī shí lěi rì','如狼似虎':' rú láng sì hǔ','积日累月':' jī rì lěi yuè','如胶似漆':' rú jiāo sì qī','集腋为裘':' jí yè wéi qiú','心里踏实':' xīn li tā shi','积素累旧':' jī sù lěi jiù','万柏林区':' wàn bó lín qū','击石弹丝':' jī shí tán sī','不用客气':' bù yòng kè qi','逻辑错误':' luó ji cuò wù','只鸡絮酒':' zhī jī xù jiǔ','不是滋味':' bú shì zī wèi','寡凫单鹄':' guǎ fú dān hú','朝不虑夕':' zhāo bù lǜ xī','羿射九日':' yì shè jiǔ rì','踏踏实实':' tā tā shi shí','德薄才疏':' dé bó cái shū','一切万物':' yī qiē wàn wù','赫鲁晓夫':' hè lǔ xiǎo fu','佛法僧目':' fó fǎ sēng mù','信而好古':' xìn ér hào gǔ','读书君子':' dú shū jūn zǐ','阿谀谄媚':' ē yú chǎn mèi','移风易俗':' yí fēng yì sú','恶湿居下':' wù shī jū xià','恶迹昭著':' è jì zhāo zhù','恶迹昭着':' è jì zhāo zhe','弟男子侄':' dì nán zǐ zhí','引以为傲':' yǐn yǐ wéi ào','低音提琴':' dī yīn tí qín','杜默为诗':' dù mò wéi shī','一毫不差':' yī háo bù chā','一脚不移':' yī jiǎo bù yí','一定不易':' yī dìng bù yì','以己度人':' yǐ jǐ duó rén','斗粟尺布':' dǒu sù chǐ bù','笃学好古':' dǔ xué hào gǔ','呱嗒板儿':' guā dā bǎn ér','贫富差距':' pín fù chā jù','大而无当':' dà ér wú dàng','弹拨乐器':' tán bō yuè qì','曲靖地区':' qǔ jìng dì qū','曼切斯特':' màn qiē sī tè','似是而非':' sì shì ér fēi','倒戢干戈':' dǎo jí gān gē','布干维尔':' bù gān wéi ěr','贩夫走卒':' fàn fū zǒu fú','砥砺琢磨':' dǐ lì zhuó mó','阿世取容':' ē shì qǔ róng','斗米尺布':' dǒu mǐ chǐ bù','朝不及夕':' zhāo bù jí xī','斗绝一隅':' dǒu jué yī yú','典妻鬻子':' diǎn qī yù zǐ','丢卒保车':' diū zú bǎo jū','恫疑虚喝':' dòng yí xū hè','逐次近似':' zhú cì jìn sì','恫疑虚猲':' dòng yí xū gé','一佛出世':' yī fó chū shì','这早晚儿':' zhè zǎo wǎn r','曲高和寡':' qǔ gāo hè guǎ','东抹西涂':' dōng mò xī tú','过去分词':' guò qù fèn cí','只骑不反':' zhī qí bù fǎn','如法炮制':' rú fǎ páo zhì','屈指可数':' qū zhǐ kě shǔ','好问则裕':' hào wèn zé yù','感激不尽':' gǎn jī bù jìn','昭披耶河':' zhāo pī yē hé','鹤发松姿':' hè fà sōng zī','蒿子秆儿':' hāo zǐ gǎn ér','羞人答答':' xiū rén dā dā','好语似珠':' hǎo yǔ sì zhū','好逸恶劳':' hào yì wù láo','富得流油':' fù de líu yóu','出奇划策':' chū qí huá cè','畜妻养子':' xù qī yǎng zǐ','蜜月假期':' mì yuè jià qī','好善恶恶':' hǎo shàn wù è','宁死不屈':' nìng sǐ bù qū','号寒啼饥':' háo hán tí jī','不足为训':' bù zú wéi xùn','号啕大哭':' háo táo dà kū','世界屋脊':' shì jiè wū jǐ','因敌为资':' yīn dí wéi zī','衣单食薄':' yī dān shí bó','刿目鉥心':' guì mù xù xīn','孝子爱日':' xiào zǐ ài rì','鹤处鸡群':' hè chǔ jī qún','化腐为奇':' huà fǔ wéi qí','金发碧眼':' jīn fà bì yǎn','字纸篓子':' zì zhǐ lǒu zi','胡作胡为':' hú zuò hú wéi','丑类恶物':' chǒu lèi è wù','呼幺喝六':' hū yāo hè liù','淫词艳曲':' yín cí yàn qǔ','家给人足':' jiā jǐ rén zú','羞羞答答':' xiū xiū dā dā','刿鉥心腑':' guì xù xīn fǔ','不足为道':' bù zú wéi dào','不足齿数':' bù zú chǐ shǔ','羞与为伍':' xiū yǔ wéi wǔ','应付裕如':' yìng fù yù rú','血肉模糊':' xuè ròu mó hu','应付自如':' yìng fù zì rú','须发皆白':' xū fà jiē bái','须眉男子':' xū méi nán zǐ','止戈为武':' zhǐ gē wéi wǔ','日积月累':' rì jī yuè lěi','如其所好':' rú qí suǒ hào','积德累仁':' jī dé lěi rén','掎挈伺诈':' jǐ qiè sì zhà','击排冒没':' jī pái mào mò','手拉葫芦':' shǒu lā hú lu','鸡毛掸子':' jī máo dǎn zǐ','纪律处分':' jì lǜ chǔ fèn','畸流洽客':' jī liú qià kè','积累基金':' jī lěi jī jīn','积日累久':' jī rì lěi jiǔ','豁人耳目':' huò rén ěr mù','家给民足':' jiā jǐ mín zú','豁然大悟':' huò rán dà wù','火妻灰子':' huǒ qī huī zǐ','惠子知我':' huì zǐ zhī wǒ','子子孙孙':' zǐ zǐ sūn sūn','子孝父慈':' zǐ xiào fù cí','吉卜赛人':' jí bǔ sài rén','人给家足':' rén jǐ jiā zú','积日累岁':' jī rì lěi suì','好色之徒':' hào sè zhī tú','不当得利':' bù dàng de lì','打心眼里':' dǎ xīn yǎn li','不是味儿':' bú shì wèi ér','指头肚儿':' zhǐ tou dù er','人才济济':' rén cái jǐ jǐ','奥切诺斯':' aò qiē nuò sī','昆都仑区':' kūn dū lún qū','奥维耶多':' aò wéi yē duō','吃里扒外':' chī lǐ pá wài','杜莎夫人':' dù suō fū ren','尺布斗粟':' chǐ bù dǒu sù','扳不倒儿':' bān bù dǎo ér','至矣尽矣':' zhì yǐ jìn yǐ','置之不顾':' zhì zhī bù gù','与时俱进':' yǔ shí jū jìn','金吾不禁':' jīn wú bù jìn','尽如人意':' jìn rú rén yì','夹起尾巴':' jiā qǐ wěi ba','解衣衣人':' jiè yī yī rén','失去意识':' shī qù yì shí','居民点儿':' jū mín diǎn r','穴居野处':' xué jū yě chǔ','脾气暴躁':' pí qi bào zào','网路特务':' wǎng lù tè wu','纽几内亚':' nǐu jī nèi yà','丝毫不差':' sī háo bù chā','不亦善夫':' bù yi shàn fū','不以为耻':' bù yǐ wéi chǐ','了无惧色':' liǎo wū jǔ sè','四邻八舍':' sì lín bā shè','经济体系':' jīng jì tǐ xì','绿林豪客':' lù lín háo kè','卜夜卜昼':' bǔ yè bǔ zhòu','不差什么':' bù chà shí mǒ','格物致知':' gé wù zhì zhī','泽被后世':' zé pī hòu shì','不知起倒':' bù zhī qǐ dǎo','梨园弟子':' lí yuán dì zǐ','詈夷为跖':' lì yí wéi zhí','地区差价':' dì qū chā jià','犁牛之子':' lí niú zhī zǐ','朱干玉戚':' zhū gān yù qī','朱颜绿发':' zhū yán lǜ fà','物稀为贵':' wù xī wéi guì','属毛离里':' zhǔ máo lí lǐ','不差毫发':' bù chā háo fà','纳粹分子':' nà cuì fèn zǐ','不禁不由':' bù jīn bù yóu','嗓子眼儿':' sǎng zi yǎn r','门单户薄':' mén dān hù bó','朱颜鹤发':' zhū yán hè fà','不拔之志':' bù bá zhī zhì','节骨眼儿':' jiē gu yǎn er','没世无闻':' mò shì wú wén','不差毫厘':' bù chā háo lí','无为自化':' wú wéi zì huà','没金饮羽':' mò jīn yǐn yǔ','梨俱吠陀':' lí jū fèi tuó','数以万计':' shǔ yǐ wàn jì','不对茬儿':' bú duì chá ér','偶一为之':' ǒu yī wéi zhī','梨园子弟':' lí yuán zǐ dì','亚塞拜然':' yà sè bài rán','无为而治':' wú wéi ér zhì','力尽筋疲':' lì jìn jīn pí','络腮胡子':' luò sāi hú zǐ','绿林大盗':' lù lín dà dào','阿克塞县':' a kè sài xiàn','哈巴河县':' hā bā hé xiàn','神乎其技':' shén hū qí jì','挨打受骂':' ái dǎ shòu mà','驽马十舍':' nú mǎ shí shè','文似其人':' wén sì qí rén','泥古非今':' nì gǔ fēi jīn','阿克陶县':' a kè táo xiàn','挨打受气':' ái dǎ shòu qì','一般贸易':' yī bān mào yì','比物属事':' bǐ wù zhǔ shì','哩哩啰啰':' lī li luō luō','泥古拘方':' nì gǔ jū fāng','难以为继':' nán yǐ wéi jì','扒耳搔腮':' pá ěr sāo sāi','一暴十寒':' yī pù shí hán','否去泰来':' pǐ qù tài lái','一朝一夕':' yī zhāo yī xī','乐府诗集':' yuè fǔ shī jí','优游自得':' yōu yóu zì dé','蔽日干云':' bì rì gān yún','素食主义':' sù shí zhǔ yì','不识起倒':' bù shí qǐ dǎo','值得注意':' zhí de zhù yì','扎欧扎翁':' zā ōu zā wēng','扎马剌丁':' zā mǎ lá dīng','扎马鲁丁':' zā mǎ lǔ dīng','嗳气腐臭':' ài qì fǔ chòu','嗳气酸腐':' ài qì suān fǔ','四子王旗':' sì zǐ wáng qí','细磨刀石':' xì mò dāo shí','喷薄欲出':' pēn bó yù chū','无理要求':' wú lǐ yāo qiú','不随以止':' bu shui yi zi','数理逻辑':' shù lǐ luó ji','助桀为恶':' zhù jié wéi è','结结巴巴':' jiē jiē bā bā','绝大部分':' jué dà bù fen','临难不惧':' lín nàn bù jǔ','细胞因子':' xì bāo yīn zǐ','属辞比事':' zhǔ cí bǐ shì','恶紫夺朱':' wù zǐ duó zhū','纳什维尔':' nà shí wéi ěr','削木为吏':' xuē mù wéi lì','巴塞罗那':' bā sài luó nà','攒眉蹙额':' cuán mei cù é','小步舞曲':' xiǎo bù wǔ qǔ','意念移物':' yì niàn yí wù','少儿不宜':' shào ér bù yí','有机分子':' yǒu jī fēn zǐ','丢三落四':' diū sān là sì','以意为之':' yǐ yì wéi zhī','小日本儿':' xiǎo rì běn r','释迦牟尼':' shì jiā mù ní','故甚其词':' gù shèn qí cí','福孙荫子':' fú sūn yìn zǐ','俯拾地芥':' fǔ shí dì jiè','负气斗狠':' fù qì dǒu hěn','偃革倒戈':' yǎn gé dǎo gē','浮名薄利':' fú míng bó lì','符合要求':' fú hé yāo qiú','符号逻辑':' fú hào luó ji','覆亡无日':' fù wáng wú rì','打打闹闹':' dá dǎ nào nào','西格蒙德':' xī gé mēng dé','以书为御':' yǐ shū wéi yù','大拇指头':' dà mǔ zhǐ tou','个别差异':' gè bié chā yì','代客泊车':' dài kè bó chē','高义薄云':' gāo yì bó yún','一夕一朝':' yī xī yī zhāo','寻瑕伺隙':' xún xiá sì xì','膏车秣马':' gào chē mò mǎ','刚直不阿':' gāng zhí bù ē','大璞不完':' tài bú bù wán','爱丽思泉':' aì lí sī quán','干云蔽日':' gān yún bì rì','高干子弟':' gāo gàn zǐ dì','大气磅礴':' dà qì páng bó','言不尽意':' yán bù jìn yì','依样葫芦':' yī yàng hú lu','裸子植物':' luǒ zǐ zhí wù','孤行一意':' gū xíng yī yì','孤文只义':' gū wén zhī yì','服服帖帖':' fú fu tiē tiē','竖起耳朵':' shù qǐ ěr duo','数据处理':' shù jù chǔ lǐ','不可究诘':' bù kě jiū jié','雁泊人户':' yàn bó rén hù','荆棘塞途':' jīng jí sè tú','脊柱后凸':' jǐ zhù hòu tū','落魄不偶':' luo tuo bu ou','落拓不羁':' luò tuò bù jī','逻辑思维':' luó ji sī wéi','精子密度':' jīng zǐ mì dù','五子登科':' wǔ zǐ dēng kē','闭门塞窦':' bì kǒu sè dòu','箪食壶酒':' dān sì hú jiǔ','纶音佛语':' lún yīn fó yǔ','不尽人意':' bù jìn rén yì','糖醋里脊':' táng cù lǐ jǐ','吾自有处':' wu zi you chu','闭目塞听':' bì mù sè tīng','不可揆度':' bù kě kuí duó','路易十六':' lù yì shí liù','鲁难未已':' lǔ nàn wèi yǐ','服务行业':' fú wù háng yè','单鹄寡凫':' dān hú guǎ fú','浮白载笔':' fú bái zǎi bǐ','干戈载戢':' gàn gē zǎi jí','腐败分子':' fǔ bài fēn zǐ','朝斯夕斯':' zhāo sī xī sī','眼犄角儿':' yǎn jī jué ér','差额选举':' chā é xuǎn jǔ','佛眼佛心':' fó yǎn fó xīn','附肤落毛':' fù fū luò máo','以为后图':' yǐ wéi hòu tú','恰如其分':' qià rú qí fèn','移天易日':' yí tiān yì rì','易俗移风':' yì sú yí fēng','宴安酖毒':' yàn ān dān dú','胆大如斗':' dǎn dà rú dǒu','差一点儿':' chà yī diǎn r','差不多的':' chà bu duō de','干巴利落':' gān bā lì luò','父为子隐':' fù wéi zǐ yǐn','干巴利脆':' gān bā lì cuì','淡而不厌':' dàn ér bù yàn','寝丘之志':' qǐn qiū zhī zhì','物尽其用':' wù jìn qí yòng','原子爆弹':' yuán zǐ bào dàn','发植穿冠':' fà zhí chuān guān','分分秒秒':' fèn fēn miǎo miǎo','干扁豆角':' gān biǎn dòu jiǎo','非分之想':' fēi fèn zhī xiǎng','年轻有为':' nián qīng yǒu wéi','顿足椎胸':' dùn zú zhuī xiōng','应运而生':' yìng yùn ér shēng','重纸累札':' chóng zhǐ lèi zhá','返本还源':' fǎn běn huán yuán','发上指冠':' fà shàng zhǐ guān','重生父母':' chóng shēng fù mǔ','发短心长':' fà duǎn xīn cháng','愁多夜长':' chóu duō yè cháng','应用软体':' yìng yòng ruǎn tǐ','翻黄倒皂':' fān huáng dǎo zào','凤泊鸾漂':' fèng bó luán piāo','传为佳话':' chuán wéi jiā huà','东量西折':' dōng liàng xī shé','榱崩栋折':' cuī bēng dòng shé','重手累足':' chóng shǒu lěi zú','应用数学':' yìng yòng shù xué','倒山倾海':' dǎo shān qīng hǎi','短叹长吁':' duǎn tàn cháng xū','长才短驭':' cháng cái duǎn yù','鹄形鸟面':' hú xíng niǎo miàn','强人所难':' qiǎng rén suǒ nán','处实效功':' chǔ shí xiào gōng','度长絜短':' dù cháng xié duǎn','强迫劳动':' qiǎng pò láo dòng','斗筲穿窬':' dǒu shāo chuān yú','斗量筲计':' dǒu liáng shāo jì','斗方名士':' dǒu fāng míng shì','遁迹黄冠':' dùn jì huáng guàn','兜肚连肠':' dōu dǔ lián cháng','豆重榆瞑':' dòu chóng yú míng','传柄移藉':' chuán bǐng yí jiè','弹性模量':' tán xìng mó liàng','栋折榱坏':' dòng shé cuī huài','东山之志':' dōng shān zhī zhì','斗量车载':' dǒu liáng chē zài','东墙处子':' dōng qiáng chǔ zǐ','榱栋崩折':' cuī dòng bēng shé','心潮澎湃':' xīn cháo péng pài','鱼与熊掌':' yú yǔ xióng zhǎng','电子天平':' diàn zǐ tiān píng','电子邮箱':' diàn zǐ yóu xiāng','电子手表':' diàn zǐ shǒu biǎo','啜菽饮水':' chuò shū yǐn shuǐ','掂梢折本':' diān shāo shé běn','颠乾倒坤':' diān qiān dǎo kūn','电力供应':' diàn lì gōng yìng','掂斤抹两':' diān jīn mò liǎng','颠颠倒倒':' diān diān dǎo dǎo','鹄峙鸾翔':' hú zhì luán xiáng','电子元件':' diàn zǐ yuán jiàn','重明继焰':' chóng míng jì yàn','充类至尽':' chōng lèi zhì jìn','行号巷哭':' xíng háo xiàng kū','行行蛇蚓':' háng háng shé yǐn','海相沉积':' hǎi xiàng chén jī','国之干城':' guó zhī gān chéng','桂子飘香':' guì zǐ piāo xiāng','长绳系日':' cháng shéng jì rì','颠倒衣裳':' diān dǎo yī cháng','影像处理':' yǐng xiàng chǔ lǐ','心电感应':' xīn diàn gǎn yìng','党豺为虐':' dǎng chái wéi nüè','心灵感应':' xīn líng gǎn yìng','倒箧倾囊':' dǎo qiè qīng náng','颠倒乾坤':' diān dǎo qián kūn','寸有所长':' cùn yǒu suǒ cháng','怒目相向':' nù mù xiāng xiàng','当着不着':' dāng zhuó bù zhuó','当务始终':' dang wu shi zhong','患难之交':' huàn nàn zhī jiāo','大人先生':' dà rén xiān sheng','吹拉弹唱':' chuī lā tán chàng','悄然无声':' qiǎo rán wú shēng','厝火燎原':' cuò huǒ liǎo yuán','传为美谈':' chuán wéi měi tán','颠倒阴阳':' diān dǎo yīn yáng','弹尽粮绝':' dàn jìn liáng jué','吹花嚼蕊':' chuī huā jiáo ruǐ','鼎铛有耳':' dǐng chēng yǒu ěr','刁钻促搯':' diāo zuàn cù chāo','形单影只':' xíng dān yǐng zhī','冥行擿埴':' míng xíng zhì zhí','浪子宰相':' làng zǐ zǎi xiàng','承销利差':' chéng xiāo lì chā','酩酊烂醉':' mǐng dǐng làn zuì','了了可见':' liǎo liǎo kě jiàn','撩蜂吃螫':' liáo fēng chī shì','了不长进':' liǎo bù zhǎng jǐn','两世为人':' liǎng shì wéi rén','头昏脑涨':' tóu hūn nǎo zhàng','风调雨顺':' fēng tiáo yǔ shùn','乱葬岗子':' luàn zàng gǎng zǐ','散兵游勇':' sǎn bīng yóu yǒng','电子空间':' diàn zǐ kōng jiān','了身达命':' liǎo shēn dá mìng','梦撒撩丁':' mèng sā liáo dīng','猛将如云':' měng jiàng rú yún','梦魂颠倒':' mèng hún diān dǎo','蒙古人种':' měng gǔ rén zhǒng','昧旦晨兴':' mèi dàn chún xīng','鸾漂凤泊':' luán piāo fèng bó','满天星斗':' mǎn tiān xīng dǒu','满腔热枕':' mǎn qiāng rè chén','了然于胸':' liǎo rán yú xiōng','裂冠毁冕':' liè guàn huǐ miǎn','马瘦毛长':' mǎ shòu máo cháng','撅坑撅堑':' jué kēng jué qiàn','急景凋年':' jí yǐng diāo nián','不遑宁处':' bù huáng níng chǔ','藉草枕块':' jiè cǎo zhěn kuài','拳头产品':' quán tou chǎn pǐn','不甚了了':' bù shèn liǎo liǎo','极限量规':' jí xiàn liáng guī','缠绵蕴藉':' chán mián yùn jiè','绝长继短':' jué cháng jì duǎn','龙兴云属':' lóng xīng yún shǔ','头晕脑涨':' tóu yūn nǎo zhàng','龙兴凤举':' lóng xīng fèng jǔ','龙楼凤阙':' lóng lóu fèng què','流水游龙':' liú shuǐ yóu lóng','流觞曲水':' liú shāng qǔ shuǐ','六畜兴旺':' liù chù xīng wàng','凌霄之志':' líng xiāo zhī zhì','零零散散':' líng líng sǎn sǎn','鸾凤和鸣':' luán fèng hè míng','预防接种':' yù fáng jiē zhòng','青藏公路':' qīng zàng gōng lù','捋袖揎拳':' luō xiù xuān quán','黄埔军校':' huáng pǔ jūn xiào','累月经年':' lěi yuè jīng nián','援助之手':' yuán zhù zhī shǒu','连车平斗':' lián chē píng dǒu','黑汗王朝':' hēi hán wáng cháo','狼艰狈蹶':' láng jiān bèi juě','地久天长':' dì jiǔ tiān cháng','力能扛鼎':' lì néng gāng dǐng','高村正彦':' gāo cūn zhēng yàn','楞眉横眼':' lèng méi héng yǎn','垂死挣扎':' chuí sǐ zhēng zhá','插不上手':' chā bu shàng shǒu','高空弹跳':' gāo kōng tán tiào','高高兴兴':' gāo gāo xìng xīng','喟然长叹':' kuì rán cháng tàn','鬼使神差':' guǐ shǐ shén chāi','老之将至':' lǎo zhī jiāng zhì','鸾飘凤泊':' luán piāo fèng bó','麟角凤觜':' lín jiǎo fèng zuǐ','老老少少':' lǎo lǎo shào shào','倔头强脑':' juè tóu jiàng nǎo','多难兴邦':' duō nàn xīng bāng','音乐之声':' yīn yuè zhī shēng','狂风怒号':' kuáng fēng nù háo','论黄数黑':' lùn huáng shǔ hēi','音乐光碟':' yīn yuè guāng dié','鸾只凤单':' luán zhī fèng dān','青年旅舍':' qīng nián lǔ: shè','绝长续短':' jué cháng xù duǎn','敛容屏气':' liǎn róng bǐng qì','饶舌调唇':' ráo shé tiáo chún','框架结构':' kuàng jià jié gòu','龙生九子':' lóng shēng jiǔ zǐ','白发千丈':' bái fà qiān zhàng','矮人观场':' ǎi rén guān cháng','安常处顺':' ān cháng chǔ shùn','安常守分':' ān cháng shǒu fèn','暗箭中人':' àn jiàn zhòng rén','空腹便便':' kōng fù pián pián','鼎铛玉石':' dǐng chēng yù shí','溘然长往':' kè rán cháng wǎng','看清形势':' kān qīng xíng shì','拔山扛鼎':' bá shān gāng dǐng','长谈阔论':' cháng tán kuò lùn','长途车站':' cháng tú chē zhàn','挑战者号':' tiǎo zhàn zhě hào','长命富贵':' cháng mìng fù guì','弃短就长':' qì duǎn jiù cháng','受降仪式':' shòu xiáng yí shì','重新开始':' chóng xīn kāi shǐ','其应若响':' qí yìng ruò xiǎng','日短心长':' rì duǎn xīn cháng','辗转反侧':' zhǎn zhuǎn fǎn cè','受洗命名':' shòu xǐ mìng míng','强干弱枝':' qiáng gān ruò zhī','长吁短叹':' cháng xū duǎn tàn','皮相之见':' pí xiàng zhī jiàn','杀出重围':' shā chū chóng wéi','瓶沈簪折':' píng shěn zān shé','擎天之柱':' qíng tiān zhī zhù','转浑天仪':' zhuàn hún tiān yí','命名系统':' mìng míng xì tǒng','长期共存':' cháng qī gòng cún','斗转星移':' dǒu zhuǎn xīng yí','连锁反应':' lián suǒ fǎn yìng','长夜难明':' cháng yè nán míng','原子质量':' yuán zǐ zhì liàng','数黑论黄':' shǔ hēi lùn huáng','翩翩公子':' piān piān gōng zǐ','撒豆成兵':' sǎ dòu chéng bīng','金帐汗国':' jīn zhàng hán guó','乡村音乐':' xiāng cūn yīn yuè','返老还童':' fǎn lǎo huán tóng','间谍活动':' jiàn dié huó dòng','若崩厥角':' ruò bēng jué jiǎo','酒精中毒':' jǐu jīng zhòng dú','返还占有':' fǎn huán zhàn yǒu','能不称官':' néng bù chèn guān','抢购一空':' qiāng gòu yī kōng','长袖善舞':' cháng xiù shàn wǔ','重新造林':' chóng xīn zào lín','只争朝夕':' zhǐ zhēng zhāo xī','长期饭票':' cháng qī fàn piào','数见不鲜':' shuò jiàn bù xiān','数黄道黑':' shu huang dao hei','倾肠倒肚':' qīng cháng dào dǔ','盘水加剑':' pan shui jia jian','重新启动':' chóng xīn qǐ dòng','商业银行':' shāng yè yín háng','内部调整':' nèi bù tiáo zhěng','阿甘正传':' a gān zhèng zhuàn','链式反应':' liàn shì fǎn yìng','重整旗鼓':' chóng zhěng qí gǔ','铺床叠被':' pū chuáng dié bèi','各奔前程':' gè bèn qián chéng','任性妄为':' rèn xìng wàng wéi','绕梁之音':' rǎo liáng zhī yīn','长辔远驭':' cháng pèi yuǎn yù','更有甚者':' gèng yǒu shèn zhě','潜孔钻机':' qián kǒng zuàn jī','反败为胜':' fǎn bài wéi shèng','人事不省':' rén shì bù xǐng','三长四短':' sān cháng sì duǎn','铁血宰相':' tiě xuè zǎi xiàng','人头攒动':' rén tóu cuán dòng','长乐公主':' cháng lè gōng zhǔ','商业行为':' shāng yè xíng wéi','卷土重来':' juǎn tǔ chóng lái','金蝉脱壳':' jīn chán tuō qiào','合众银行':' hé zhòng yín háng','争强好胜':' zhēng qiáng hào shèng','重文轻武':' chóng wén qīng wǔ','琼楼金阙':' qióng lóu jīn què','戎马倥偬':' róng mǎ kǒng zǒng','骈兴错出':' pián xīng cuò chū','反应时间':' fǎn yìng shí jiān','长乐未央':' cháng lè wèi yāng','各显所长':' gè xiǎn suǒ cháng','磨盘两圆':' mò pán liǎng yuán','山公倒载':' shān gōng dǎo zǎi','游手好闲':' yóu shǒu hào xián','铺张浪费':' pū zhāng làng fèi','吉人天相':' jí rén tiān xiàng','曲水流觞':' qǔ shuǐ liú shāng','长途电话':' cháng tú diàn huà','更新换代':' gēng xīn huàn dài','星移斗转':' xīng yí dǒu zhuǎn','强作解人':' qiǎng zuò jiě rén','镜框舞台':' jìng kuàng wǔ tái','退耕还林':' tuì gēng huán lín','重新做人':' chóng xīn zuò rén','穷途潦倒':' qióng tú liáo dǎo','日久天长':' rì jiǔ tiān cháng','间歇训练':' jiàn xiē xùn liàn','光杆司令':' guāng gǎn sī lìng','高山反应':' gāo shān fǎn yìng','长念却虑':' cháng niàn què lǜ','长篇大论':' cháng piān dà lùn','长篇大套':' cháng piān dà tào','长篇累牍':' cháng piān lěi dú','横抢武夺':' hèng qiǎng wǔ duó','凤楼龙阙':' fèng lóu lóng què','吵吵闹闹':' chāo chao nào nào','顾虑重重':' gù lǜ chóng chóng','高风劲节':' gāo fēng jìng jié','呵欠连天':' hē qiàn lián tiān','扛鼎拔山':' gāng dǐng bá shān','感应电流':' gǎn yìng diàn liú','干霄凌云':' gān xiāo líng yún','充分发展':' chōng fèn fā zhǎn','充分利用':' chōng fèn lì yòng','干干净净':' gàn gān jìng jìng','高原反应':' gāo yuán fǎn yìng','重复使用':' chóng fù shǐ yòng','好行小惠':' hào xíng xiǎo huì','长驾远驭':' cháng jià yuǎn yù','冲冠眦裂':' chōng guàn zì liè','好梦不长':' hǎo mèng bù cháng','长途飞行':' cháng tú fēi xíng','观者成堵':' guān zhě chéng dǔ','寡廉鲜耻':' guǎ lián xiǎn chǐ','寡见鲜闻':' guǎ jiàn xiǎn wén','长斋绣佛':' cháng zhāi xiù fó','长枕大被':' cháng zhěn dà bèi','广寒仙子':' guǎng hán xiān zǐ','长枕大衾':' cháng zhěn dà qīn','长材茂学':' cháng cái mào xué','横恩滥赏':' hèng ēn làn shǎng','后生小子':' hòu shēng xiǎo zǐ','喉长气短':' hóu cháng qì duǎn','长春不老':' cháng chún bù lǎo','鸿鹄将至':' hóng hú jiāng zhì','红不棱登':' hóng bù lēng dēng','横征暴赋':' hèng zhēng bào fù','横殃飞祸':' hèng yāng fēi huò','好谋善断':' hào móu shàn duàn','横行直走':' héng xíng zhí zǒu','重关击柝':' chóng guān jī tuò','房贷银行':' fáng dài yín háng','间接证据':' jiàn jiē zhèng jù','前程似锦':' qián chéng sì jǐn','更仆难终':' gēng pú nán zhōng','少说为佳':' shǎo shuō wéi jiā','电子信箱':' diàn zǐ xìn xiāng','诘戎治兵':' jié róng zhì bīng','郢书燕说':' yǐng shū yān shuō','辽沈战役':' liáo shěn zhàn yì','却老还童':' què lǎo huán tóng','旁引曲证':' páng yǐn qǔ zhèng','签订合同':' qiān dìng hé tong','更生霉素':' gēng shēng méi sù','前功尽废':' qián gōng jìn fèi','前功尽灭':' qián gōng jìn miè','袅袅娜娜':' niǎo niǎo nuó nuó','鸟面鹄形':' niǎo miàn hú xíng','捻土为香':' niǎn tǔ wéi xiāng','长生不死':' cháng shēng bū sǐ','重新统一':' chóng xīn tǒng yī','强食靡角':' qiǎng shí mí jiǎo','更深夜静':' gēng shēn yè jìng','更弦改辙':' gēng xián gǎi zhé','户限为穿':' hù xiàn wéi chuān','车削加工':' chē xiāo jiā gōng','冲击钻头':' chōng jī zuàn tóu','重金兼紫':' chóng jīn jiān zǐ','缝纫车间':' féng rèn chē jiān','重金袭汤':' chóng jīn xí tāng','改行为善':' gǎi xíng wéi shàn','股票行情':' gǔ piào háng qíng','盛水不漏':' chéng shuǐ bù lòu','乘利席胜':' chéng lì xí shèng','沉谋重虑':' chén móu chóng lǜ','尺短寸长':' chǐ duǎn cù cháng','成本会计':' chéng běn kuài jì','称德度功':' chēng dé duó gōng','乘肥衣轻':' chéng féi yì qīng','共为唇齿':' gòng wéi chún chǐ','功遂身退':' gōng suí shēn tuì','攻过箴阙':' gōng guò zhēn què','更阑人静':' gēng lán rén jǐng','少男少女':' shào nán shào nǔ:','公共管理':' gōng gòng guǎn lǐ','泊船瓜洲':' bó chuán guā zhōu','挑灯夜战':' tiǎo dēng yè zhàn','逐行扫描':' zhú háng sǎo miáo','痛自创艾':' tòng zì chuāng yì','苦难深重':' kǔ nàn shēn zhòng','银行存款':' yín háng cún kuǎn','恫瘝在抱':' tōng guān zài bào','雨顺风调':' yǔ shùn fēng tiáo','为人正直':' wéi rén zhèng zhí','逾墙钻穴':' yú qiáng zuàn xué','逾墙钻蠙':' yú qiáng zuàn pín','委曲成全':' wěi qǔ chéng quán','止咳糖浆':' zhǐ ké táng jiāng','鸢肩鹄颈':' yuān jiān hú jǐng','蓝田种玉':' lán tián zhòng yù','薪尽火传':' xīn jìn huǒ chuán','光阴似箭':' guāng yīn sì jiàn','直接了当':' zhí jiē liǎo dàng','相向突击':' xiāng xiàng tū jī','云合响应':' yún hé xiǎng yìng','斩钉切铁':' zhǎn dīng qiē tiě','乍暖还寒':' zhà nuǎn huán hán','同恶相助':' tóng wù xiāng zhù','月经失调':' yuè jīng shī tiáo','蟏蛸满室':' xiāo shāo mǎn shì','璇霄丹阙':' xuán xiāo dān què','燕石妄珍':' yān shí wàng zhēn','调和振动':' tiáo hé zhèn dòng','化学成分':' huà xué chéng fèn','闲言长语':' xián yán cháng yǔ','轩轩甚得':' xuān xuān shèn dé','温室效应':' wēn shì xiào yìng','管弦乐队':' guǎn xián yuè duì','虱处裈中':' shī chǔ kūn zhōng','主要成分':' zhǔ yào chéng fèn','月落参横':' yuè luò shēn héng','先我着鞭':' xiān wǒ zhuó biān','言为心声':' yán wéi xīn shēng','什锦炒面':' shí jǐn chǎo miàn','沉没成本':' chén mò chéng běn','万古长春':' wàn gǔ cháng chūn','损军折将':' sǔn jūn zhé jiàng','夜长梦多':' yè cháng mèng duō','相依为命':' xiāng yī wéi mìng','朝鲜海峡':' cháo xiǎn hǎi xiá','调频电台':' tiáo pín diàn tái','失惊倒怪':' shī jīng dǎo guài','应变无方':' yìng biàn wú fāng','勇冠三军':' yǒng guàn sān jūn','两性差距':' liǎng xìng chā jù','直截了当':' zhí jié liǎo dàng','应时对景':' yìng shí duì jǐng','盈千累万':' yíng qiān lěi wàn','饮水啜菽':' yǐn shuǐ chuò shū','万头攒动':' wàn tóu cuán dòng','刓方为圆':' shū fāng wéi yuán','尽释前嫌':' jìn shì qián xián','两侧对称':' liǎng cè duì chèn','万箭攒心':' wàn jiàn cuán xīn','两肋插刀':' liǎng lèi chā dāo','银行贷款':' yín háng dài kuǎn','用其所长':' yòng qí suǒ cháng','公共设施':' gōng gòng shè shī','了如指掌':' liǎo rú zhǐ zhǎng','银行汇票':' yín háng huì piào','当世之冠':' dāng shì zhī guàn','公共团体':' gōng gòng tuán tǐ','万应灵丹':' wàn yìng líng dān','曾参杀人':' zēng shēn shā rén','调嘴弄舌':' tiáo zuǐ nòng shé','杠杆收购':' gàng gǎn shōu gòu','挑牙料唇':' tiǎo yá liào chún','月中折桂':' yuè zhōng shé guì','相对位置':' xiāng duì wèi zhi','先王之乐':' xiān wáng zhī yuè','调脂弄粉':' tiáo zhī nòng fěn','调朱弄粉':' tiáo zhū nòng fěn','调嘴调舌':' tiáo zuǐ diào shé','一字长城':' yī zì cháng chéng','应用化学':' yìng yòng huà xué','铁板钉钉':' tiě bǎn dìng dīng','云集响应':' yún jí xiǎng yìng','调养身体':' tiáo yǎng shēn tǐ','占风使帆':' zhān fēng shǐ fān','人行横道':' rén xíng héng dào','了却此生':' liǎo què cǐ shēng','影只形单':' yǐng zhī xíng dān','应用系统':' yìng yòng xì tǒng','枉口嚼舌':' wǎng kǒu jiáo shé','来日方长':' lái rì fāng cháng','十里长亭':' shí lǐ cháng tíng','人种差别':' rén zhǒng chā bié','保角对应':' bǎo jiǎo duì yìng','行政干预':' xíng zhèng gān yù','千载难逢':' qiān zǎi nán féng','钻山塞海':' zuàn shān sāi hǎi','终焉之志':' zhōng yān zhī zhì','钻洞觅缝':' zuàn dòng mì féng','侵权行为':' qīn quán xíng wéi','遥相呼应':' yáo xiāng hū yìng','重铬酸钾':' chóng gè suān jiǎ','咬钉嚼铁':' yǎo dīng jiáo tiě','火烧火燎':' huǒ shāo huǒ liǎo','水刑逼供':' shuǐ xíng bī gòng','宿水餐风':' xiǔ shuǐ cān fēng','下旋削球':' xià xuán xiāo qíu','深源地震':' shēn yuán dì zhèn','心长发短':' xīn cháng fà duǎn','心长力短':' xīn cháng lì duǎn','动态更新':' dòng tài gēng xīn','调研人员':' tiáo yán rén yuán','炎性反应':' yán xìng fǎn yìng','行政处罚':' xíng zhèng chǔ fá','使徒行传':' shǐ tú xíng zhuàn','竖子成名':' shù zǐ chéng míng','羊肠九曲':' yáng cháng jiǔ qǔ','形只影单':' xíng zhī yǐng dān','中间部分':' zhōng jiān bù fen','钻天觅缝':' zuàn tiān mì féng','车载斗量':' chē zài dǒu liáng','腰椎间盘':' yāo zhuī jiān pán','舍短取长':' shě duǎn qǔ cháng','钻坚研微':' zuàn jiān yán wēi','数白论黄':' shǔ bái lùn huáng','访问方式':' fǎng wèn fāng shì','舌咽神经':' shé yān shén jīng','汇丰银行':' huì fēng yín háng','蛇鼠横行':' shé shǔ héng xíng','网路应用':' wǎng lù yìng yòng','油炸圈饼':' yóu zhá quān bǐng','束椽为柱':' shù chuán wéi zhù','遥呼相应':' yáo hū xiāng yìng','众怨之的':' zhòng yuàn zhī dì','摇头晃脑':' yáo tóu huàng nǎo','盛必虑衰':' shèng bì lǜ shuāi','精尽人亡':' jīng jìn rén wáng','杼柚之空':' zhù zhóu zhī kōng','聪明过头':' cōng ming guò tóu','转嗔为喜':' zhuǎn chēn wéi xǐ','水浒后传':' shuǐ hǔ hòu zhuàn','声应气求':' shēng yìng qì qiú','揎拳捋袖':' xuān quán luō xiù','神哗鬼叫':' shén huá guǐ jiào','山行海宿':' shān xíng hǎi xiǔ','悬梁自尽':' xuán liáng zì jìn','筑坛拜将':' zhù tán bài jiàng','识明智审':' shí míng zhì shěn','压良为贱':' yā liáng wéi jiàn','语境效应':' yǔ jìng xiào yìng','参辰卯酉':' shēn chén mǎo yǒu','超敏反应':' chāo mǐn fǎn yìng','铢两悉称':' zhū liǎng xī chèn','铢量寸度':' zhū liáng cùn duó','洋场恶少':' yáng chǎng è shào','收拾收拾':' shōu shi shōu shi','著述等身':' zhù shù děng shēn','压电效应':' yā diàn xiào yìng','动词重叠':' dòng cí chóng dié','深切著明':' shēn qiè zhù míng','红泥月亮':' hóng ní yuè liang','延颈跂踵':' yán jǐng qǐ zhǒng','生理反应':' shēng lǐ fǎn yìng','经年累月':' jīng nián lěi yuè','声求气应':' shēng qiú qì yìng','声势显赫':' shēng shì xiǎn hè','相时而动':' xiàng shí ér dòng','著作等身':' zhù zuò děng shēn','翻江倒海':' fān jiāng dǎo hǎi','变态反应':' biàn tài fǎn yìng','倒海翻江':' dǎo hǎi fān jiāng','翻箱倒箧':' fān xiāng dǎo qiè','谋臣武将':' móu chén wǔ jiàng','身无长处':' shēn wú cháng chù','转愁为喜':' zhuǎn chóu wéi xǐ','翻箱倒柜':' fān xiāng dǎo guì','转辗反侧':' zhuǎn zhǎn fǎn cè','小子后生':' xiǎo zǐ hòu shēng','参商之虞':' shēn shāng zhī yú','细水长流':' xì shuǐ cháng liú','诱掖奖劝':' yòu yè jiǎng quàn','公诸同好':' gōng zhū tóng hào','不胜杯杓':' bù shèng bēi sháo','鼻孔撩天':' bí kǒng liáo tiān','截长补短':' jié cháng bǔ duǎn','教猱升木':' jiāo náo shēng mù','奉子成婚':' fèng zǐ chéng hūn','焦唇干肺':' jiāo chún gān fèi','强嘴硬牙':' jiàng zuǐ yìng yá','强嘴拗舌':' jiàng zuǐ niù shé','江淹才尽':' jiāng yān cái jìn','江翻海倒':' jiāng fān hǎi dǎo','辩证逻辑':' biàn zhèng luó ji','竭诚尽节':' jié chéng jìn jié','陂湖禀量':' bēi hú bǐng liáng','天长日久':' tiān cháng rì jiǔ','镌脾琢肾':' juān pí zhuó shèn','卷甲衔枚':' juàn jiǎ xián méi','败军之将':' bài jūn zhī jiàng','卷甲束兵':' juàn jiǎ shù bīng','居轴处中':' jū zhóu chǔ zhōng','百兽率舞':' bǎi shòu shuài wǔ','津关险塞':' jīn guān xiǎn sài','解发佯狂':' jiě fà yáng kuáng','白手兴家':' bái shǒu xīng jiā','温衾扇枕':' wēn qīn shān zhěn','惟肖惟妙':' wéi xiāo wéi miào','切片检查':' qiē piàn jiǎn chá','谈言微中':' tán yán wēi zhòng','卫氏朝鲜':' wèi shì cháo xiǎn','神差鬼使':' shén chāi guǐ shǐ','文子同升':' wén zǐ tóng shēng','朝梁暮晋':' zhāo liáng mù jìn','行侠仗义':' xìng xiá zhàng yì','朝乾夕愓':' zhāo qián xī dàng','戒奢宁俭':' jiè shē nìng jiān','兴妖作乱':' xīng yāo zuò luàn','不良反应':' bù liáng fǎn yìng','山鸣谷应':' shān míng gǔ yìng','尽诚竭节':' jìn chéng jié jié','竭忠尽智':' jié zhōng jìn zhì','竭智尽忠':' jié zhì jìn zhōng','截铁斩钉':' jié tiě zhǎn dìng','借尸还阳':' jiè shī huán yáng','白首为郎':' bái shǒu wéi láng','锦囊还矢':' jǐn náng huán shǐ','衣轻乘肥':' yì qīng chéng féi','间接经验':' jiàn jiē jīng yàn','残军败将':' cán jūn bài jiàng','还元返本':' huán yuán fǎn běn','沧浪老人':' cāng láng lǎo rén','还年却老':' huán nián què lǎo','坏裳为裤':' huài shang wéi kù','层见错出':' céng xiàn cuò chū','搀行夺市':' chān háng duó shì','黄冠草服':' huáng guàn cǎo fú','招降纳叛':' zhāo xiáng nà pàn','黄冠草履':' huáng guàn cǎo lǚ','挟势弄权':' jiā shì nòng quán','好景不长':' hǎo jǐng bù cháng','兵不由将':' bīng bù yóu jiàng','甲冠天下':' jiǎ guàn tiān xià','屏气凝神':' bǐng qì níng shén','摒弃前嫌':' bìng qì qián xián','家道从容':' jiā dào cōng róng','家长里短':' jiā cháng lǐ duǎn','黄干黑廋':' huáng gān hēi sōu','招揽生意':' zhāo lǎn shēng yi','挂在嘴上':' guà zai zuǐ shang','旧雨重逢':' jiù yǔ chóng féng','白衣卿相':' bái yī qīng xiàng','伴食宰相':' bàn shí zǎi xiàng','静影沉璧':' jing ying chen bi','经验教训':' jīng yàn jiào xun','径行直遂':' jìng xíng zhí suí','静电干扰':' jìng diàn gān rǎo','天人感应':' tiān rén gǎn yìng','天长地久':' tiān cháng dì jiǔ','绝长补短':' jué cháng bǔ duǎn','黄雀伺蝉':' huáng què sì chán','摽梅之年':' biào mén zhī nián','挟主行令':' jiā zhǔ xíng lìng','豁然贯通':' huò rán guàn tōng','活剥生吞':' huó bāo shēng tūn','昏镜重磨':' hūn jìng chóng mó','魂颠梦倒':' hún diān mèng dǎo','毁钟为铎':' huǐ zhōng wéi duó','裁长补短':' cái cháng bǔ duǎn','喙长三尺':' huì cháng sān chǐ','神魂颠倒':' shén hún diān dǎo','朝阳产业':' zhāo yáng chǎn yè','外公切线':' wài gōng qiē xiàn','弹冠振衿':' tán guān zhèn jīn','正式合同':' zhèng shì hé tong','传道受业':' chuán dào shòu yè','蒸沙为饭':' zhēng shā wéi fàn','正冠李下':' zhèng guàn lǐ xià','伴随效应':' bàn suí xiào yìng','科学种田':' kē xué zhòng tián','真命天子':' zhēn mìng tiān zǐ','伤痕累累':' shāng hén léi léi','衣锦还乡':' yì jǐn huán xiāng','一箭上垛':' yī jiàn shàng duò','真龙天子':' zhēn lóng tiān zǐ','植发穿冠':' zhí fà chuān guàn','兴奋高潮':' xīng fèn gāo cháo','置水之情':' zhì shuǐ zhī qíng','双柑斗酒':' shuài gān dǒu jiǔ','膀胱气化':' páng guāng qì huà','民穷财尽':' mín qióng cái jìn','水果罐头':' shuǐ guǒ guàn tóu','执鞭随蹬':' zhí biān suí dèng','直柄钻头':' zhí bǐng zuàn tóu','一鞭先著':' yī biān xiān zhuó','褎然冠首':' yòu rán guàn shǒu','万古长青':' wàn gǔ cháng qīng','事后聪明':' shì hòu cōng ming','友好相处':' yǒu hǎo xiāng chǔ','着着失败':' zhuó zhuó shī bài','有三有俩':' yǒu sān yǒu liǎng','望子成才':' wàng zǐ chéng cái','公共关系':' gōng gòng guān xì','公共开支':' gōng gòng kāi zhī','汪洋闳肆':' wāng yáng hóng sì','植发冲冠':' zhí fà chōng guàn','二重下标':' èr chóng xià biāo','直捷了当':' zhí jié liǎo dàng','率土宅心':' shuài tǔ zhái xīn','占风望气':' zhān fēng wàng qì','凶相毕露':' xiōng xiàng bì lù','松松散散':' sōng sōng sǎn sǎn','似曾相识':' sì céng xiāng shí','薮中荆曲':' sǒu zhōng jīng qǔ','兴妖作怪':' xīng yāo zuò guài','夜静更深':' yè jìng gēng shēn','一长半短':' yī cháng bàn duǎn','朝夕相处':' zhāo xī xiāng chǔ','调风变俗':' tiáo fēng biàn sú','特种警察':' tè zhòng jǐng chá','朝成暮毁':' zhāo chéng mù huǐ','充分考虑':' chōng fèn kǎo lù:','战争贩子':' zhàn zhēng fàn zǐ','天下为公':' tiān xià wéi gōng','天下为笼':' tiān xià wéi lóng','眼不转睛':' yǎn bù zhuàn jīng','歪打正着':' wāi dǎ zhèng zháo','真相大白':' zhēn xiàng dà bái','朝穿暮塞':' zhāo chuān mù sāi','狼狈为奸':' láng bèi wéi jiān','折长补短':' zhé cháng bǔ duǎn','中箭落马':' zhòng jiàn luò mǎ','意味深长':' yì wèi shēn cháng','兆载永劫':' zhào zǎi yǒng jié','烧香拜佛':' shāo xiāng bài fó','蜗杆传动':' wō gǎn chuán dòng','卫满朝鲜':' wèi mǎn cháo xiǎn','朝成夕毁':' zhāo chéng xī huǐ','切中要害':' qiē zhōng yào hài','水宿风餐':' shuǐ xiǔ fēng cān','置换反应':' zhì huàn fǎn yìng','五陵年少':' wǔ líng nián shào','智穷才尽':' zhì qióng cái jìn','自奉甚俭':' zì fèng shèn jiǎn','位置效应':' wèi zhì xiào yìng','支链反应':' zhī liàn fǎn yìng','止咳平喘':' zhǐ ké píng chuǎn','似鸟恐龙':' sì niǎo kǒng lóng','臭味相投':' xiù wèi xiāng tóu','见闻有限':' jiàn wén yǒu xiàn','天地长久':' tiān dì cháng jiǔ','质量要求':' zhì liàng yāo qiú','斩将夺旗':' zhǎn jiàng duó qí','贞观之治':' zhēn guān zhī zhì','弹空说嘴':' tán kōng shuō zuǐ','牵羊担酒':' qiān yáng dàn jiǔ','令人兴奋':' lìng rén xīng fèn','天长地老':' tiān cháng dì lǎo','朝鲜半岛':' cháo xiǎn bàn dǎo','天道好还':' tiān dào hǎo huán','千载一圣':' qiān zǎi yī shèng','侔色揣称':' móu sè chuǎi chèn','寥寥可数':' liáo liáo kě shǔ','唱筹量沙':' chàng chóu liáng shā','顶踵尽捐':' dǐng zhǒng jìn juān','生肖属相':' shēng xiào shǔ xiàng','兴衰成败':' xīng shuāi chéng bài','跌跌跄跄':' diē diē qiàng qiàng','重新装修':' chóng xīn zhuāng xīu','过关斩将':' guò guān zhǎn jiàng','反正还淳':' fǎn zhèng huán chún','源远流长':' yuán yuǎn liú cháng','九转功成':' jiǔ zhuàn gōng chéng','遣兵调将':' qiǎn bīng diào jiàng','深中肯綮':' shēn zhōng kěn qìng','兴兵动众':' xīng bīng dòng zhòng','堂皇冠冕':' táng huáng guàn miǎn','善善从长':' shàn shàn cóng cháng','振兴中华':' zhèn xīng zhōng huá','轰动效应':' hōng dòng xiào yìng','整躬率物':' zhěng gōng shuài wù','政治斗争':' zhèng zhì dòu zhēng','横行直撞':' héng xíng zhí zhuàng','寸长片善':' cùn cháng piàn shàn','斗转参横':' dǒu zhuǎn shēn héng','改弦更张':' gǎi xián gēng zhāng','多口相声':' duō kǒu xiàng sheng','晕头转向':' yūn tóu zhuàn xiàng','长街短巷':' cháng jiē duǎn xiàng','重光累洽':' chóng guāng lèi qià','铢称寸量':' zhū chēng cùn liáng','康乾盛世':' kāng qián shèng shì','转轮手枪':' zhuàn lún shǒu qiāng','锥处囊中':' zhuī chǔ náng zhōng','天兵天将':' tiān bīng tiān jiàng','朝阳鸣凤':' zhāo yáng míng fèng','众啄同音':' zhòng zhòu tóng yīn','重建家园':' chóng jiàn jiā yuán','山阴乘兴':' shān yīn chéng xīng','侜张为幻':' zhōu zhāng wéi huàn','当轴处中':' dāng zhóu chǔ zhōng','还魂橡胶':' huán hún xiàng jiāo','转败为成':' zhuǎn bài wéi chéng','微创手术':' wēi chuāng shǒu shù','沸沸汤汤':' fèi fèi shāng shāng','方领圆冠':' fāng lǐng yuán guàn','正中下怀':' zhèng zhòng xià huái','明窗净几':' míng chuāng jìng jī','应用程式':' yìng yòng chéng shì','宏观调控':' hóng guān tiáo kòng','说短道长':' shuō duǎn dào cháng','说短论长':' shuō duǎn lùn cháng','一长两短':' yī cháng liǎng duǎn','穷愁潦倒':' qióng chóu liáo dǎo','持枪抢劫':' chí qiāng qiāng jié','摇摇晃晃':' yáo yáo huàng huàng','车载船装':' chē zǎi chuán zhuāng','东方将白':' dong fang jiang bai','洋为中用':' yáng wéi zhōng yòng','窗明几净':' chuāng míng jī jìng','仰天长叹':' yǎng tiān cháng tàn','鞭长驾远':' biān cháng jià yuǎn','将门有将':' jiàng mén yǒu jiàng','算命先生':' suàn mìng xiān sheng','学有专长':' xué yǒu zhuān cháng','广文先生':' guǎng wén xiān sheng','纸短情长':' zhǐ duǎn qíng cháng','弹冠相庆':' tán guān xiāng qìng','应天承运':' yìng tiān chéng yùn','山长水阔':' shān cháng shuǐ kuò','正中己怀':' zhèng zhòng jǐ huái','下风方向':' xià fēng fāng xiàng','沉着应战':' chén zhuó yìng zhàn','中央银行':' zhōng yāng yín háng','从长商议':' cóng cháng shāng yì','神霄绛阙':' shén xiāo jiàng què','彰明较著':' zhāng míng jiào zhù','传为笑柄':' chuán wéi xiào bǐng','较短絜长':' jiào duǎn xié cháng','寸量铢称':' cùn liáng zhū chēng','中坚力量':' zhōng jiān lì liang','穿着讲究':' chuān zhuó jiǎng jiu','东窗消息':' dōng chuāng xiāo xi','雀屏中选':' què píng zhòng xuǎn','自坏长城':' zì huài cháng chéng','少成若性':' shào chéng ruò xìng','拽巷啰街':' zhuài xiàng luó jiē','寸善片长':' cùn shàn piàn cháng','生拉硬拽':' shēng lā yìng zhuài','应用软件':' yìng yòng ruǎn jiàn','较长絜短':' jiào cháng xié duǎn','青灯黄卷':' qīng dēng huáng juàn','将功折过':' jiāng gōng shé guò','间见层出':' jiàn xiàn céng chū','条件反应':' tiáo jiàn fǎn yìng','嚼穿龈血':' jiáo chuān yín xuè','见性成佛':' jiàn xìng chéng fó','鉴影度形':' jiàn yǐng duó xíng','梁上君子':' liáng shàng jūn zǐ','水浒全传':' shuǐ hǔ quán zhuàn','千了百当':' qiān liǎo bǎi dàng','传授知识':' chuán shòu zhī shi','简单明了':' jiǎn dān míng liǎo','将相之器':' jiàng xiàng zhī qì','将遇良才':' jiàng yù liáng cái','鉴真和尚':' jiàn zhēn hé shang','装模作样':' zhuāng mú zuò yàng','嚼齿穿龈':' jiáo chǐ chuān yín','精灵宝钻':' jīng líng bǎo zuàn','惊起梁尘':' jīng qǐ liáng chén','改姓更名':' gǎi xìng gēng míng','参回斗转':' shēn huí dǒu zhuǎn','简切了当':' jiǎn qiè liǎo dàng','娉婷袅娜':' pīng tíng niǎo nuó','保长对应':' bǎo cháng duì yìng','相得甚欢':' xiāng dé shèn huān','天旋地转':' tiān xuán dì zhuàn','进退消长':' jìn tuì xiāo cháng','进贤兴功':' jìn xián xīng gōng','憨豆先生':' hān dòu xiān sheng','软件调试':' ruǎn jiàn tiáo shì','长岛冰茶':' cháng dǎo bīng chá','永贞内禅':' yǒng zhēn nèi shàn','静电感应':' jìng diàn gǎn yìng','表里相应':' biǎo lǐ xiāng yìng','阶跃响应':' jiē yuè xiǎng yìng','雕章琢句':' diāo zhāng zhuó jù','同侪审查':' tóng chái shěn chá','标准偏差':' biāo zhǔn piān chā','穿红着绿':' chuān hóng zhuó lǜ','简截了当':' jiǎn jié liǎo dàng','钟鸣漏尽':' zhōng míng lòu jìn','长长短短':' cháng cháng duǎn duǎn','管弦乐团':' guǎn xián yuè tuán','拘神遣将':' jū shén qiǎn jiàng','江郎才尽':' jiāng láng cái jìn','长城饭店':' cháng chéng fàn diàn','天宝当年':' tian bao dang nian','织田信长':' zhī tián xìn cháng','感应线圈':' gǎn yìng xiàn quān','长年累月':' cháng nián lěi yuè','长柄勺子':' cháng bǐng sháo zi','旧梦重温':' jiù mèng chóng wēn','雕肝琢肾':' diāo gān zhuó shèn','羊瘙痒病':' yáng sào yǎng bìng','升斗小民':' shēng dǒu xiǎo mín','洞中肯綮':' dòng zhōng kěn qìng','转变抹角':' zhuǎn biàn mò jiǎo','蒙头转向':' mēng tóu zhuàn xiàng','凤鸣朝阳':' fèng míng zhāo yáng','重峦复嶂':' chóng luán fù zhàng','质量效应':' zhì liàng xiào yìng','传风扇火':' chuán fēng shān huǒ','发上冲冠':' fà shàng chōng guān','双足重茧':' shuāng zú chóng jiǎn','转败为胜':' zhuǎn bài wéi shèng','更高性能':' gēng gāo xìng néng','争短论长':' zhēng duǎn lùn cháng','详星拜斗':' xiáng xīng bài dǒu','拜将封侯':' bài jiàng fēng hóu','沅江九肋':' yuán jiāng jiǔ lèi','清史列传':' qīng shǐ liè zhuàn','败将残兵':' bài jiàng cán bīng','大中学生':' dà zhōng xué sheng','小时了了':' xiǎo shí liǎo liǎo','百舍重趼':' bǎi shè chóng jiǎn','长江流域':' cháng jiāng líu yù','清风劲节':' qīng fēng jìng jié','拣佛烧香':' jiǎn fó shāo xiāng','相去甚远':' xiāng qù shèn yuǎn','斜行横阵':' xié xíng héng zhèn','转败为功':' zhuǎn bài wéi gōng','转轮圣王':' zhuàn lún shèng wáng','百了千当':' bǎi liǎo qiān dāng','胸中万卷':' xiōng zhōng wàn juàn','长荣海运':' cháng róng hǎi yùn','倦鸟知还':' juàn niǎo zhī huán','拽象拖犀':' zhuài xiàng tuō xī','百舍重茧':' bǎi shè chóng jiǎn','校短推长':' xiào duǎn tuī cháng','旋转乾坤':' xuán zhuǎn qián kūn','弃短用长':' qì duǎn yòng cháng','圣经外传':' shèng jīng wài zhuàn','乘胜追击':' chéng shèng zhuī jī','广为流传':' guǎng wéi liú chuán','调兵遣将':' diào bīng qiǎn jiàng','扇枕温被':' shān zhěn wēn chuáng','少年老成':' shào nián lǎo chéng','作善降祥':' zuò shàn jiàng xiáng','公共行政':' gōng gòng xíng zhèng','蒸气重整':' zhēng qì chóng zhěng','敩学相长':' zuàn xué xiāng cháng','正当防卫':' zhèng dàng fáng wèi','逞娇呈美':' chěng jiāo chéng měi','盛衰兴废':' shèng shuāi xīng fèi','运动健将':' yùn dòng jiàn jiàng','山高水长':' shān gāo shuǐ cháng','对口相声':' duì kǒu xiàng sheng','项背相望':' xiàng bèi xiāng wàng','重生爷娘':' chóng shēng yé niáng','远涉重洋':' yuǎn shè chóng yáng','广种薄收':' guǎng zhòng bó shōu','使羊将狼':' shǐ yáng jiàng láng','壮发冲冠':' zhuàng fā chōng guàn','相门有相':' xiàng mén yǒu xiàng','光电效应':' guāng diàn xiào yìng','嫌长道短':' xián cháng dào duǎn','长生久视':' cháng shēng jiǔ shì','坑绷拐骗':' kēng bēng guǎi piàn','长话短说':' cháng huà duǎn shuō','五行相生':' wǔ háng xiāng shēng','防火长城':' fáng huǒ cháng chéng','山长水远':' shān cháng shuǐ yuǎn','抢风航行':' qiāng fēng háng xíng','秤斤注两':' chēng jīn zhù liǎng','强颜欢笑':' qiǎng yán huān xiào','着手成春':' zhuó shǒu chéng chūn','道长争短':' dào cháng zhēng duǎn','争长论短':' zhēng cháng lùn duǎn','上当受骗':' shàng dàng shòu piàn','山中宰相':' shān zhōng zǎi xiàng','恒生银行':' héng shēng yín háng','长往远引':' cháng wǎng yuǎn yǐn','书归正传':' shū guī zhèng zhuàn','庄严宝相':' zhuāng yán bǎo xiàng','相貌堂堂':' xiàng mào táng táng','衡短论长':' héng duǎn lùn cháng','逞性妄为':' chěng xìng wàng wéi','长算远略':' cháng suàn yuǎn lüè','首尾相应':' shǒu wěi xiāng yìng','情长纸短':' qíng cháng zhǐ duǎn','长绳系景':' cháng shéng xì jǐng','长颈鸟喙':' cháng jǐng niǎo huì','长虺成蛇':' zhǎng huǐ chéng shé','交响乐团':' jiāo xiǎng yuè tuán','工商银行':' gōng shāng yín háng','山穷水尽':' shān qióng shuǐ jìn','晃晃悠悠':' huàng huǎng yōu yōu','冲动行为':' chōng dòng xíng wéi','言归正传':' yán guī zhèng zhuàn','彰明昭着':' zhāng míng zhāo zhe','营养成分':' yíng yǎng chéng fèn','浩浩汤汤':' hào hào shāng shāng','干城之将':' gān chéng zhī jiàng','长篇连载':' cháng piān lián zǎi','说长道短':' shuō cháng dào duǎn','滚滚长江':' gǔn gǔn cháng jiāng','长线产品':' cháng xiàn chǎn pǐn','成为笑柄':' chéng wéi xiào bǐng','甚嚣尘上':' shèn xiāo chén shàng','膏粱年少':' gāo liáng nián shào','山峦重叠':' shān luán chóng dié','长荣航空':' cháng róng háng kōng','官方网站':' guān fāng wǎng zhàn','对证命名':' duì zhèng mìng míng','正中要害':' zhèng zhòng yào hài','承平盛世':' chéng píng shèng shì','说岳全传':' shuō yuè quán zhuàn','横抢硬夺':' hèng qiǎng yìng duó','沉着痛快':' chén zhuó tòng kuài','长篇小说':' cháng piān xiǎo shuō','乘胜逐北':' chéng shèng zhú běi','率由旧章':' shuài yóu jiù zhāng','受到影响':' shòu dào yǐng xiǎng','彰明昭著':' zhāng míng zhāo zhù','创巨痛深':' chuāng jù tòng shēn','青春年少':' qīng chūn nián shào','造谣中伤':' zào yáo zhòng shāng','香花供养':' xiāng huā gòng yǎng','翩翩少年':' piān piān shào nián','重新调整':' chóng xīn tiáo zhěng','行险侥幸':' xíng xiǎn jiǎo xìng','水穷山尽':' shuǐ qióng shān jìn','参横斗转':' shēn héng dǒu zhuǎn','水中著盐':' shuǐ zhōng zhuó yán','水中捉月':' shui zhong zhuo yue','瞬态响应':' shùn tài xiǎng yìng','昏镜重明':' hūn jìng chóng míng','水尽山穷':' shuǐ jìn shān qióng','双重国籍':' shuāng chóng guó jí','兢兢乾乾':' jīng jīng qián qián','亲水长廊':' qīn shuǐ cháng láng','板上钉钉':' bǎn shàng dìng dīng','旧景重现':' jìu jǐng chóng xiàn','连中三元':' lián zhòng sān yuán','草率收兵':' cǎo shuài shōu bīng','龙荒蛮甸':' lóng huāng mán diàn','响应时间':' xiǎng yìng shí jiān','长亭短亭':' cháng tíng duǎn tíng','论长说短':' lùn cháng shuō duǎn','还乡昼锦':' huán xiāng zhòu jǐn','火耕水种':' huǒ gēng shuǐ zhòng','单口相声':' dān kǒu xiàng sheng','说长论短':' shuō cháng lùn duǎn','说长说短':' shuō cháng shuō duǎn','解弦更张':' jiě xián gēng zhāng','汹涌澎湃':' xiōng yǒng péng pài','仰天长啸':' yǎng tiān cháng xiào','旋乾转坤':' xuán qián zhuǎn kūn','缅甸联邦':' miǎn diàn lián bāng','笼鸟槛猿':' lóng niǎo jiàn yuán','长山山脉':' cháng shān shān mài','说长话短':' shuō cháng huà duǎn','兵多将广':' bīng duō jiàng guǎng','长春新碱':' cháng chūn xīn jiǎn','双重人格':' shuāng chóng rén gé','量身定制':' liáng shēn dìng zhì','众星攒月':' zhòng xīng cuán yuè','霜行草宿':' shuāng xíng cǎo xiǔ','话长说短':' huà cháng shuō duǎn','短中取长':' duǎn zhōng qǔ cháng','产生偏差':' chǎn shēng piān chā','史传小说':' shǐ zhuàn xiǎo shuō','笑脸相迎':' xiào liǎn xiàng yíng','楞手楞脚':' lèng shǒu lèng jiǎo','山崩钟应':' shān bēng zhōng yìng','心事重重':' xīn shì chóng chóng','赤诚相见':' chì chéng xiàng jiàn','萍飘蓬转':' píng piāo péng zhuàn','姓甚名谁':' xìng shèn míng shuí','羊瘙痒症':' yáng sào yǎng zhèng','王侯将相':' wáng hóu jiàng xiàng','朝鲜战争':' cháo xiǎn zhàn zhēng','更长梦短':' gēng cháng mèng duǎn','心手相应':' xīn shǒu xiāng yìng','心长绠短':' xīn cháng gěng duǎn','困难重重':' kùn nán chóng chóng','重峦叠嶂':' chóng luán dié zhàng','长江三峡':' cháng jiāng sān xiá','漂蓬断梗':' piāo péng duàn gěng','调神畅情':' tiáo shén chàng qíng','降妖捉怪':' xiáng yāo zhuō guài','相切相磋':' xiāng qiē xiāng cuō','调停两用':' tiáo tíng liǎng yòng','阆苑琼楼':' làng yuàn qióng lóu','铢两相称':' zhū liǎng xiāng chèn','三长两短':' sān cháng liǎng duǎn','正身率下':' zhèng shēn shuài xià','乘风兴浪':' chéng fēng xīng làng','双栖双宿':' shuāng qī shuāng sù','丧尽天良':' sàng jìn tiān liáng','公共场所':' gōng gòng chǎng suǒ','推广应用':' tuī guǎng yìng yòng','梦想颠倒':' mèng xiǎng diān dǎo','穷形尽相':' qióng xíng jìn xiàng','黄钟长弃':' huáng zhōng cháng qì','水远山长':' shuǐ yuǎn shān cháng','公共卫生':' gōng gòng wèi shēng','率尔成章':' shuài ěr chéng zhāng','面折庭争':' miàn shé tíng zhēng','公共零点':' gōng gòng líng diǎn','黄卷青灯':' huáng juàn qīng dēng','电动转盘':' diàn dòng zhuàn pán','长盛不衰':' cháng shèng bù shuāi','鸣凤朝阳':' míng fèng zhāo yáng','公共交通':' gōng gòng jiāo tōng','长平之战':' cháng píng zhī zhàn','兴师动众':' xīng shī dòng zhòng','床头金尽':' chuáng tóu jīn jìn','传为笑谈':' chuán wéi xiào tán','重修旧好':' chóng xiū jiù hǎo','持人长短':' chí rén cháng duǎn','朝成暮遍':' zhāo chéng mù biàn','差分方程':' chā fēn fāng chéng','干劲冲天':' gān jìn chōng tiān','穷年累月':' qióng nián lěi yuè','朝梁暮陈':' zhāo liáng mù chén','张脉偾兴':' zhāng mài fèn xīng','朝梁暮周':' zhāo liáng mù zhōu','穷年累世':' qióng nián lěi shì','久别重逢':' jiǔ bié chóng féng','中兴新村':' zhōng xīng xīn cūn','秤平斗满':' chèng píng dǒu mǎn','条条框框':' tiáo tiáo kuàng kuàng','膏场绣浍':' gāo cháng xiù kuài','斩将搴旗':' zhǎn jiàng qiān qí','告老还乡':' gào lǎo huán xiāng','九九重阳':' jǐu jǐu chóng yáng','残兵败将':' cán bīng bài jiàng','事实真相':' shì shí zhēn xiàng','中规中矩':' zhòng guī zhòng jǔ','中国银行':' zhōng guó yín háng','重山复岭':' chóng shān fù lǐng','产前检查':' chǎn qián jiǎn chá','鼋鸣鳖应':' yuán míng biē yìng','适应环境':' shì yìng huán jìng','戎事倥偬':' róng shì kǒng zǒng','重山复水':' chóng shān fù shuǐ','少管闲事':' shào guǎn xián shì','全能冠军':' quán néng guàn jūn','飞流短长':' fēi liú duǎn cháng','重新评价':' chóng xīn píng jià','拱手而降':' gǒng shòu ér xiáng','成败兴废':' chéng bài xīng fèi','十载寒窗':' shí zǎi hán chuāng','师直为壮':' shī zhí wéi zhuàng','成都平原':' chéng dū píng yuán','遇难成祥':' yù nàn chéng xiáng','贞松劲柏':' zhēn sōng jìng bǎi','重熙累盛':' chóng xī lěi shèng','月亮女神':' yuè liang nǔ: shén','生意兴隆':' shēng yì xīng lóng','槁项黄馘':' gǎo xiàng huáng xù','风尘肮脏':' fēng chén āng zāng','成年累月':' chéng nián lěi yuè','愁潘病沈':' chóu pān bìng shěn','讯框中继':' xùn kuàng zhōng jì','阴凝坚冰':' yīn níng jiān bīng','春秋三传':' chūn qīu sān zhuàn','剪切形变':' jiǎn qiē xíng biàn','饮马长江':' yǐn mǎ cháng jiāng','长鸣都尉':' cháng míng dōu wèi','长命百岁':' cháng mìng bǎi suì','长林丰草':' cháng lín fēng cǎo','多言数穷':' duō yán shuò qióng','重碳酸盐':' chóng tàn suān yán','翘首引领':' qiáo shǒu yǐn lǐng','率土同庆':' shuài tǔ tóng qìng','黑白相间':' hēi bái xiāng jiàn','应用平台':' yìng yòng píng tái','重见天日':' chóng jiàn tiān rì','语短情长':' yǔ duǎn qíng cháng','应天顺民':' yìng tiān shùn mín','晨昏定省':' chén hūn dìng xǐng','发踊冲冠':' fà yǒng chōng guān','重碳酸钙':' chóng tàn suān gài','梗泛萍漂':' gěng fàn píng piāo','论长道短':' lùn cháng dào duǎn','丰草长林':' fēng cǎo cháng lín','率兽食人':' shuài shòu shí rén','穷困潦倒':' qióng kùn liáo dǎo','更令明号':' gēng lìng míng hào','封豕长蛇':' fēng shǐ cháng shé','弓长岭区':' gōng cháng lǐng qū','少先队员':' shào xiān duì yuán','语长心重':' yǔ cháng xīn zhòng','盈箱累箧':' yíng xiāng lěi qiè','恩甚怨生':' ēn shèn yuàn shēng','过分强调':' guò fèn qiáng diào','交通银行':' jiāo tōng yín háng','人丁兴旺':' rén dīng xīng wàng','应付账款':' yìng fù zhàng kuǎn','长蛇封豕':' cháng shé fēng shǐ','交响乐队':' jiāo xiǎng yuè duì','海水难量':' hǎi shuǐ nán liáng','养虺成蛇':' yǎng huǐ chéng shé','承销价差':' chéng xiāo jià chā','常年累月':' cháng nián lěi yuè','粉妆玉琢':' fěn zhuāng yù zhuó','手下败将':' shǒu xià bài jiàng','众口难调':' zhòng kǒu nán tiáo','睡眠失调':' shuì mián shī tiáo','断管残沈':' duàn guǎn cán shěn','知疼着痒':' zhī téng zháo yǎng','远渡重洋':' yuǎn dù chóng yáng','蒸发空调':' zhēng fā kōng tiáo','强的松龙':' qiáng dí sōng lóng','气贯长虹':' qì guàn cháng hóng','顺人应天':' shùn rén yìng tiān','进行性交':' jìn xíng xìng jiāo','长才广度':' cháng cái guǎng dù','众毛攒裘':' zhòng máo cuán qiú','化整为零':' huà zhěng wéi líng','应召女郎':' yìng zhào nǔ: láng','种植园主':' zhòng zhí yuán zhǔ','昼长夜短':' zhòu cháng yè duǎn','强词夺正':' qiǎng cí duó zhèng','空中少爷':' kōng zhōng shào ye','贫穷潦倒':' pín qíong liáo dǎo','睡回笼觉':' shuì huí lóng jiào','断还归宗':' duàn huán guī zōng','吃亏上当':' chī kuī shàng dàng','长安道上':' cháng ān dào shàng','重庆大学':' chóng qìng dà xué','穷理尽性':' qióng lǐ jìn xìng','转弯抹角':' zhuǎn wān mò jiǎo','弹冠结绶':' tán guān jié shòu','三差两错':' sān chā liǎng cuò','秋行夏令':' qiū xíng xià líng','金融杠杆':' jīn róng gàng gǎn','长安少年':' cháng ān shào nián','应天顺时':' yìng tiān shùn shí','长材小试':' cháng cái xiǎo shì','前缘未了':' qián yuán wèi liǎo','横征苛敛':' hèng zhēng kē liǎn','变徵之声':' biàn zhǐ zhī shēng','遁世长往':' dùn shì cháng wǎng','出将入相':' chū jiàng rù xiàng','学生运动':' xué sheng yùn dòng','对称中心':' duì chèn zhōng xīn','深山长谷':' shēn shān cháng gǔ','强死强活':' qiǎng sǐ qiǎng huó','不明真相':' bù míng zhēn xiàng','夜长梦短':' yè cháng mèng duǎn','更型换代':' gēng xíng huàn dài','福寿绵长':' fú shòu mián cháng','强弓劲弩':' qiáng gōng jìng nǔ','强迫观念':' qiǎng pò guān niàn','黄发垂髫':' huáng fà chuí tiáo','量子场论':' liàng zǐ chǎng lùn','水宿山行':' shuǐ xiǔ shān xíng','揣合逢迎':' chuǎi hé féng yíng','众好众恶':' zhòng hào zhòng wù','斗升之水':' dǒu shēng zhī shuǐ','率以为常':' shuài yǐ wéi cháng','子癫前症':' zǐ diān qián zhèng','昼短夜长':' zhòu duǎn yè cháng','横行天下':' héng xíng tiān xià','正义斗争':' zhèng yì dòu zhēng','中信银行':' zhōng xìn yín háng','说来话长':' shuō lái huà cháng','岳镇渊渟':' yuè zhèn yuān tīng','语重心长':' yǔ zhòng xīn cháng','重新审视':' chóng xīn shěn shì','钟鼎人家':' zhōng dǐng rén jia','神成为人':' shén chéng wéi rén','博采众长':' bó cǎi zhòng cháng','毁冠裂裳':' huǐ guān liè cháng','妙语横生':' miào yǔ hèng shēng','兵微将寡':' bīng wēi jiàng guǎ','昏定晨省':' hūn dìng chén xǐng','千乘之国':' qiān shèng zhī guó','望子成龙':' wàng zǐ chéng lóng','弹性形变':' tán xìng xíng biàn','氧炔吹管':' yǎng quē chuī guǎn','逼良为娼':' bī liáng wéi chāng','蝉联冠军':' chán lián guàn jūn','子孙娘娘':' zǐ sūn niáng niang','化零为整':' huà líng wéi zhěng','赌长较短':' dǔ cháng jiào duǎn','蝉喘雷干':' chán chuǎn léi gān','破镜重圆':' pò jìng chóng yuán','测量元件':' cè liáng yuán jiàn','以升量石':' yǐ shēng liáng dàn','确定效应':' què dìng xiào yìng','草率从事':' cǎo shuài cóng shì','抢劫银行':' qiǎng jié yín háng','全息照相':' quán xī zhào xiàng','超超玄著':' chāo chāo xuán zhù','较短比长':' jiào duǎn bǐ cháng','圣经贤传':' shèng jīng xián zhuàn','争长竞短':' zhēng cháng jìng duǎn','正邪相争':' zhèng xié xiāng zhēng','电子工程':' diàn zǐ gōng chéng','灭景追风':' miè yǐng zhuī fēng','明白了当':' míng bái liǎo dàng','山溜穿石':' shān liù chuān shí','代为说项':' dài wéi shuō xiàng','精兵强将':' jīng bīng qiáng jiàng','名声籍甚':' míng shēng jí shèn','旦种暮成':' dàn zhòng mù chéng','云窗雾槛':' yún chuāng wù jiàn','寸长尺短':' cùn cháng chǐ duǎn','万里长城':' wàn lǐ cháng chéng','王贡弹冠':' wáng gòng dàn guàn','粮尽援绝':' liáng jìn yuán jué','孽障种子':' niè zhàng zhǒng zǐ','颠鸾倒凤':' diān luán dǎo fèng','乜斜缠帐':' niè xié chán zhàng','电子手帐':' diàn zǐ shǒu zhàng','公共财产':' gōng gòng cái chǎn','袅娜娉婷':' niǎo nuó pīng tíng','逞强好胜':' chěng qiáng hào shèng','商人银行':' shāng rén yín háng','两样东西':' liǎng yàng dōng xi','藏茴香果':' zàng huí xiāng guǒ','万里长江':' wàn lǐ cháng jiāng','万象更新':' wàn xiàng gēng xīn','商业应用':' shāng yè yìng yòng','青藏高原':' qīng zàng gāo yuán','万里长征':' wàn lǐ cháng zhēng','藏传佛教':' zàng chuán fó jiào','电光朝露':' diàn guāng zhāo lù','上好下甚':' shàng hǎo xià shèn','中山狼传':' zhōng shān láng zhuàn','倒裳索领':' dào cháng suǒ lǐng','法轮常转':' fǎ lún cháng zhuàn','拳脚相向':' quán jiǎo xiāng xiàng','道长论短':' dào cháng lùn duǎn','忘啜废枕':' wàng chuò fèi zhěn','嘴快舌长':' zuǐ kuài shé cháng','作浪兴风':' zuò làng xīng fēng','蜚短流长':' fēi duǎn liú cháng','同声相应':' tóng shēng xiāng yìng','唯唯连声':' wěi wěi lián shēng','嚼腭搥床':' jiáo è chuí chuáng','村生泊长':' cūn shēng bó cháng','倒凤颠鸾':' dǎo fèng diān luán','顺应天时':' shùn yìng tiān shí','想出风头':' xiǎng chū fēng tou','长生禄位':' cháng shēng lù wèi','川渟岳峙':' chuān tīng yuè zhì','满口应承':' mǎn kǒu yìng chéng','迎接挑战':' yíng jiē tiǎo zhàn','损兵折将':' sǔn bīng zhé jiàng','藤野先生':' téng yě xiān sheng','深仇宿怨':' shēn chóu xiǔ yuàn','借面吊丧':' jiè miàn diào sāng','网络应用':' wǎng luò yìng yòng','洞鉴废兴':' dòng jiàn fèi xīng','钻坚仰高':' zuàn jiān yǎng gāo','悬石程书':' xuán dàn chéng shū','日月重光':' rì yuè chóng guāng','虚晃一枪':' xiù huàng yī qiāng','倒箧倾筐':' dǎo qiè qīng kuāng','枉口诳舌':' wǎng kǒu kuáng shé','捻捻转儿':' niǎn niǎn zhuàn ér','短中抽长':' duǎn zhōng chōu cháng','粘胶纤维':' nián jiāo xiān wéi','竞短争长':' jìng duǎn zhēng cháng','铜盘重肉':' tóng pán zhòng ròu','颂声载道':' sòng shēng zǎi dào','圣君贤相':' shèng jīng xián xiàng','勉勉强强':' miǎn miǎn qiǎng qiáng','间谍软件':' jiàn dié ruǎn jiàn','危机重重':' wēi jī chóng chóng','论短道长':' lùn duǎn dào cháng','陪唱小姐':' péi chàng xiǎo jie','漏尽钟鸣':' lòu jìn zhōng míng','为好成歉':' wéi hǎo chéng qiàn','顺应不良':' shùn yìng bù liáng','鸾颠凤倒':' luán diān fèng dǎo','乱箭攒心':' luàn jiàn cuán xīn','哗众取宠':' huá zhòng qǔ chǒng','长江天堑':' cháng jiāng tiān qiàn','往渚还汀':' wǎng zhǔ huán tīng','尝尽心酸':' cháng jìn xīn suān','虾兵蟹将':' xiā bīng xiè jiàng','转来转去':' zhuàn lái zhuàn qù','剂量效应':' jì liàng xiào yìng','调风弄月':' tiáo fēng nòng yuè','扬长补短':' yáng cháng bǔ duǎn','挑唇料嘴':' tiǎo chún liào zuǐ','调唇弄舌':' tiáo chún nòng shé','报应不爽':' bào yìng bù shuǎng','鹰击长空':' yīng jī cháng kōng','登台拜将':' dēng tái bài jiàng','鸟尽弓藏':' niǎo jìn gōng cáng','泪干肠断':' lèi gān cháng duàn','彷徨失措':' páng huáng shī cuò','惯用伎俩':' guàn yòng jì liǎng','膀胱结石':' páng guāng jié shí','长风破浪':' cháng fēng pò làng','调良稳泛':' tiáo liáng wěn fàn','掸邦高原':' shàn bāng gāo yuán','浓妆淡抹':' nóng zhuāng dàn mò','旁通曲畅':' páng tōng qǔ chàng','兴风作浪':' xīng fēng zuò làng','扭转乾坤':' niǔ zhuǎn qián kūn','搴旗斩将':' qiān qí zhǎn jiàng','应用程序':' yìng yòng chéng xù','攒零合整':' cuán líng hé zhěng','应天顺人':' yìng tiān shùn rén','手足重茧':' shǒu zú chóng jiǎn','不见经传':' bù jiàn jīng zhuàn','有效成分':' yǒu xiào chéng fèn','了若指掌':' liǎo ruò zhǐ zhǎng','重温旧梦':' chóng wēn jiù mèng','清都绛阙':' qīng dōu jiàng què','对称空间':' duì chèn kōng jiān','长远目标':' cháng yuǎn mù biāo','方寸万重':' fāng cùn wàn chóng','佹形僪状':' guǐ xíng yù zhuàng','广东音乐':' guǎng dōng yīn yuè','数短论长':' shǔ duǎn lùn cháng','广陵散绝':' guǎng líng sǎn jué','词长效应':' cí cháng xiào yìng','繁荣兴旺':' fán róng xīng wàng','重裀列鼎':' chóng yīn liè dǐng','专家评价':' zhuān jiā píng jià','应用卫星':' yìng yòng wèi xīng','反戈相向':' fǎn gē xiāng xiàng','撩是生非':' liáo shì shēng fēi','刀耕火种':' dāo gēng huǒ zhòng','从严惩处':' cóng yán chéng chǔ','帝王将相':' dì wáng jiòn xiàng','亢音高唱':' gāng yīn gāo chàng','三旨相公':' sān zhǐ xiàng gōng','望洋兴叹':' wàng yáng xīng tàn','朗朗乾坤':' lǎng lǎng qián kūn','切中时病':' qiè zhòng shí bìng','朝鲜太宗':' cháo xiǎn tài zōng','着人先鞭':' zhuó rén xiān biān','账房先生':' zhàng fáng xiān sheng','五言长城':' wǔ yán cháng chéng','援交小姐':' yuán jiāo xiǎo jie','从长计较':' cóng cháng jì jiào','从容应对':' cóng róng yìng duì','旷日长久':' kuàng rì cháng jiǔ','矿物成分':' kuàng wù chéng fèn','烹龙炮凤':' pēng lóng páo fèng','炮凤烹龙':' páo fèng pēng lóng','登坛拜将':' dēng tán bài jiàng','黄花姑娘':' huáng huā gū niang','扛鼎抃牛':' gāng dǐng biàn niú','夏虫朝菌':' xià chóng zhāo jūn','牛头刨床':' niú tóu bào chuáng','旧调重弹':' jiù diào chóng tán','餐桌转盘':' cān zhuō zhuàn pán','调舌弄唇':' tiáo shé nòng chún','连街倒巷':' lián jiē dǎo xiàng','连蒙带骗':' lián mēng dài piàn','飞短流长':' fēi duǎn liú cháng','问长问短':' wèn cháng wèn duǎn','敛声屏气':' liǎn shēng bǐng qì','浓抹淡妆':' nóng mò dàn zhuāng','傀儡政权':' kuǐ lěi zhèng quán','拔刀相向':' bá dāo xiāng xiàng','臭名昭著':' chòu míng zhāo zhù','联调联试':' lián tiáo lián shì','长生不老':' cháng shēng bù lǎo','聪明绝顶':' cōng ming jué dǐng','钧天广乐':' jūn tiān guǎng yuè','校短量长':' jiào duǎn liáng cháng','扬长避短':' yáng cháng bì duǎn','更深人静':' gēng shēn rén jìng','开疆拓境':' kāi jiāng tuò jìng','经济力量':' jīng jì lì liang','淡妆轻抹':' dàn zhuāng qīng mò','完全懂得':' wán quán dǒng de','相对误差':' xiāng duì wù chā','五行生克':' wǔ háng shēng kè','柏林围墙':' bó lín wéi qiáng','旷日累时':' kuàng rì lěi shí','会计报表':' kuài jì bào biǎo','千差万别':' qiān chā wàn bié','印象主义':' yìn xiàng zhǔ yì','抗颜为师':' kàng yán wéi shī','橡皮钉子':' xiàng pí dìng zǐ','白发青衫':' bái fà qīng shān','五行相克':' wǔ háng xiāng kè','聚变反应':' jù biàn fǎn yìng','多钱善贾':' duō qián shàn gǔ','多重国籍':' duō chóng guó jí','转悲为喜':' zhuǎn bēi wéi xǐ','显露头角':' xiǎn lù tóu jiǎo','扬长而去':' yáng cháng ér qù','借尸还魂':' jiè shī huán hún','百废俱兴':' bǎi fèi jù xīng','日久岁长':' rì jiǔ suì cháng','深切著白':' shēn qiè zhù bái','十字转门':' shí zì zhuàn mén','夕寐宵兴':' xī mèi xiāo xīng','白苋紫茄':' bái xiàn zǐ qié','咳唾成珠':' ké tuò chéng zhū','刻章琢句':' kè zhāng zhuó jù','著书立说':' zhù shū lì shuō','值得称赞':' zhí de chēng zàn','通讯行业':' tōng xùn háng yè','安老怀少':' ān lǎo huái shào','反应堆芯':' fǎn yìng duī xīn','口尚乳臭':' kǒu shàng rǔ xiù','卷帙浩繁':' juàn zhì hào fán','口燥唇干':' kǒu zào chún gān','霸道横行':' bà dào héng xíng','矮子观场':' ǎi zǐ guān cháng','连篇累牍':' lián piān lěi dú','会计人员':' kuài jì rén yuán','化学反应':' huà xué fǎn yìng','日朘月减':' rì juān yuè jiǎn','雾兴云涌':' wù xīng yún yǒng','款曲周至':' kuǎn qǔ zhōu zhì','军事力量':' jūn shì lì liang','百废具兴':' bǎi fèi jù xīng','溘然长逝':' kè rán cháng shì','天造草昧':' tiān zào cǎo mèi','亲朋好友':' qīn péng háo you','蔚为大观':' wèi wéi dà guān','强聒不舍':' qiǎng guō bù shě','长途网路':' cháng tú wǎng lù','长途话费':' cháng tú huà fèi','天王老子':' tiān wáng lǎo zǐ','天下为家':' tiān xià wéi jiā','有为有守':' yǒu wéi yǒu shǒu','天之骄子':' tiān zhī jiāo zǐ','是非颠倒':' shì fēi diān dǎo','调词架讼':' tiáo cí jià sòng','调和鼎鼐':' tiáo hé dǐng nài','前半晌儿':' qián bàn shǎng r','调和阴阳':' tiáo hé yīn yáng','强识博闻':' qiǎng shí bó wén','朝鲜日报':' cháo xiǎn rì bào','亲生子女':' qīn shēng zǐ nǔ:','强凫变鹤':' qiǎng fú biàn hè','血债累累':' xuè zhài lěi lěi','陆相沉积':' lù xiàng chén jī','白发苍苍':' bái fà cāng cāng','背景音乐':' bèi jǐng yīn yuè','系统更新':' xì tǒng gēng xīn','拜倒辕门':' bài dǎo yuán mén','参辰日月':' shēn chén rì yuè','听墙根儿':' tīng qiáng gēn r','长途奔袭':' cháng tú bēn xí','开疆拓土':' kāi jiāng tuò tǔ','开疆拓宇':' kāi jiāng tuò yǔ','看家本领':' kān jiā běn lǐng','深谷为陵':' shēn gǔ wéi líng','为山止篑':' wéi shān zhǐ kuì','融洽无间':' róng qià wú jiàn','故地重游':' gù dì chóng yóu','呷醋节帅':' xiā cù jié shuài','日中为市':' rì zhōng wéi shì','日月参辰':' rì yuè shēn chén','倭黑猩猩':' wō hēi xīng xing','柔情似水':' róu qíng sì shuǐ','糠豆不赡':' kang dou bu shan','如应斯响':' rú yìng sī xiǎng','脱不了身':' tuō bù liǎo shēn','化为泡影':' huà wéi pāo yǐng','斗筲之人':' dǒu shāo zhī rén','长揖不拜':' cháng yī bù bài','兴词构讼':' xīng cí gòu sòng','瑟调琴弄':' sè tiáo qín nòng','大肠杆菌':' dà cháng gǎn jūn','形孤影只':' xíng gū yǐng zhī','白衣宰相':' bái yī zǎi xiàng','鸠形鹄面':' jiū xíng hú miàn','翘居群首':' qiáo jū qún shǒu','博闻强识':' bó wén qiáng zhì','邪不干正':' xié bù gān zhèng','协调发展':' xié tiáo fā zhǎn','孝子贤孙':' xiào zǐ xián sūn','桑户棬枢':' sāng hù juàn shū','三占从二':' sān zhān cóng èr','孝子顺孙':' xiào zǐ shùn sūn','军团杆菌':' jūn tuán gǎn jūn','圈牢养物':' juàn láo yǎng wù','三省吾身':' sān xǐng wú shēn','老少咸宜':' lǎo shào xián yí','百下百着':' bǎi xià bǎi zháo','大洋中脊':' dà yáng zhōng jǐ','三十六行':' sān shí liù háng','蓬头散发':' péng tóu sàn fà','开发银行':' kāi fā yín háng','埋天怨地':' mán tiān yuàn dì','长虑后顾':' cháng lǜ hòu gù','酩酊大醉':' mǐng dǐng dà zuì','酌情处理':' zhuó qíng chǔ lǐ','累瓦结绳':' lěi wǎ jié shéng','电磁干扰':' diàn cí gān rǎo','风土人情':' fēng tú rén qíng','累屋重架':' lěi wū chóng jià','瑟弄琴调':' sè nòng qín tiáo','旧地重游':' jiù dì chóng yóu','兴高彩烈':' xīng gāo cǎi liè','电子器件':' diàn zǐ qì jiàn','自力更生':' zì lì gēng shēng','翘首以待':' qiáo shóu yǐ dài','欺人太甚':' qī rén tài shèn','翘足引领':' qiáo zú yǐn lǐng','心瞻魏阙':' xīn zhān wèi què','兴邦立国':' xīng bāng lì guó','电子工业':' diàn zǐ gōng yè','捐身徇义':' juān shēn xùn yì','日引月长':' rì yǐn yuè cháng','信息灵通':' xìn xi líng tōng','兴亡继绝':' xīng wáng jì jué','排山倒海':' pái shān dǎo hǎi','少不更事':' shào bù gēng shì','绷扒吊拷':' bēng bā diào kǎo','少不经事':' shào bù jīng shì','善财童子':' shàn cái tóng zǐ','包皮过长':' bāo pí guò cháng','少年得志':' shào nián dé zhì','绕梁三日':' rǎo liáng sān rì','行为不端':' xíng wéi bù duān','杀妻求将':' shā qī qiú jiàng','罪行累累':' zuì xíng lěi lěi','久安长治':' jiǔ ān cháng zhì','排起长队':' pái qǐ cháng duì','旧话重提':' jiù huà chóng tí','兴亡祸福':' xīng wáng huò fú','黑咕隆咚':' hēi gū lōng dōng','舍身为国':' shě shēn wéi guó','白黑颠倒':' bái hēi diān dǎo','百中百发':' bǎi zhòng bǎi fā','行为不检':' xíng wéi bù jiǎn','小廉曲谨':' xiǎo lián qǔ jǐn','缝衣工人':' féng yī gōng rén','折箭为誓':' shé jiàn wéi shì','转危为安':' zhuǎn wēi wéi ān','桑土绸缪':' sāng tǔ chóu miù','相鼠有皮':' xiàng shǔ yǒu pí','少小无猜':' shào xiǎo wú cāi','抱关执钥':' bào guān zhí yuè','刑讯逼供':' xíng xùn bī gòng','扇枕温席':' shān zhěn wēn xí','进退中度':' jìn tuì zhòng dù','行为规范':' xíng wéi guī fàn','长途直拨':' cháng tú zhí bō','兴文匽武':' xīng wén diào wǔ','权利要求':' quán lì yāo qíu','金相玉质':' jīn xiàng yù zhì','抱蔓摘瓜':' bào wàn zhāi guā','白喉杆菌':' bái hóu gǎn jūn','尽忠竭力':' jìn zhōng jié lì','行为能力':' xíng wéi néng lì','绷巴吊拷':' bèng bā diào kǎo','放不下心':' fàng bu xià xīn','骈肩累足':' pián jiān lěi zú','燕京大学':' yān jīng dà xué','破愁为笑':' pò chóu wéi xiào','肆虐横行':' sì nüè héng xíng','掊斗折衡':' pǒu dǒu zhé héng','行为准则':' xíng wéi zhǔn zé','似箭在弦':' sì jiàn zài xián','长度单位':' cháng dù dān wèi','新兴产业':' xīn xīng chǎn yè','视微知着':' shì wēi zhī zhuó','贪小便宜':' tān xiǎo pián yi','袒裼裸裎':' tǎn xī luǒ chéng','弹丸脱手':' tán wán tuō shǒu','陵劲淬砺':' líng jìng cuì lì','除旧更新':' chú jiù gēng xīn','挈瓶之知':' qiè píng zhī zhì','万家生佛':' wàn jiā shēng fó','鞠躬尽瘁':' jū gōng jìn cuì','青藏铁路':' qīng zàng tiě lù','什袭珍藏':' shí xí zhēn cáng','卖文为生':' mài wén wéi shēn','新都桥镇':' xīn dū qiáo zhèn','方兴未已':' fāng xīng wèi yǐ','非分之念':' fēi fèn zhī niàn','凭几据杖':' píng jī jù zhàng','方兴未艾':' fāng xīng wèi ài','味同嚼蜡':' wèi tóng jiáo là','左支右调':' zuǒ zhī yòu tiáo','核反应堆':' hé fǎn yìng duī','行家里手':' háng jiā lǐ shǒu','橡子面儿':' xiàng zi miàn r','频率成分':' pín lǜ chéng fèn','贫困潦倒':' pín kùn liáo dǎo','朝饔夕飧':' zhāo yōng xī sūn','弹性蛋白':' tán xìng dàn bái','思潮澎湃':' sī cháo péng pài','长治久安':' cháng zhì jiǔ ān','血流漂杵':' xuè liú piāo chǔ','片文只事':' piàn wén zhī shì','硕望宿德':' shuò wàng xiǔ dé','剔蝎撩蜂':' tī xiē liáo fēng','剔抽秃揣':' tī chōu tū chuǎi','铜管乐器':' tóng guǎn yuè qì','韬光俟奋':' tāo guāng sì fèn','晚食当肉':' wǎn shí dàng ròu','助纣为虐':' zhù zhòu wéi nüè','恬不为怪':' tián bù wéi guài','漏尽更阑':' lòu jìn gēng lán','单方恐吓':' dān fāng kǒng hè','收购要约':' shōu gòu yāo yuē','情绪反应':' qíng xù fǎn yìng','慢性咽炎':' màn xìng yān yán','取长补短':' qǔ cháng bǔ duǎn','公共事业':' gōng gòng shì yè','王孙公子':' wáng sūn gōng zǐ','鸾停鹄峙':' luán tíng hú zhì','间不容发':' jiān bù róng fà','青堂瓦舍':' qīng táng wǎ shè','未了公案':' wèi liǎo gōng àn','笼络人心':' lǒng luò rén xīn','荷枪实弹':' hè qiāng shí dàn','莘莘学子':' shēn shēn xué zǐ','龙举云兴':' lóng jǔ yún xīng','施工合同':' shī gōng hé tong','调味肉汁':' tiáo wèi ròu zhī','流年似水':' liú nián sì shuǐ','改善关系':' gǎi shàn guān xi','适应能力':' shì yìng néng lì','长目飞耳':' cháng mù fēi ěr','内线消息':' nèi xiàn xiāo xi','非杠杆化':' fēi gàng gǎn huà','叹为观止':' tàn wéi guān zhǐ','鞭长莫及':' biān cháng mò jí','长虑却顾':' cháng lǜ què gù','电动葫芦':' diàn dòng hú lu','韩国银行':' hán guó yín háng','裸裎袒裼':' luǒ chéng tǎn xī','雪山太子':' xuě shān tài zǐ','音乐学院':' yīn yuè xué yuàn','叶公好龙':' yè gōng hào lóng','识微知著':' shí wēi zhī zhuó','李氏朝鲜':' lǐ shì cháo xiǎn','万古长存':' wàn gǔ cháng cún','单眼相机':' dān yǎn xiàng jī','毛遂堕井':' máo suí duò jǐng','认知失调':' rèn zhī shī tiáo','收旗卷伞':' shōu qí juàn sǎn','猫鼠同处':' māo shǔ tóng chǔ','单反相机':' dān fǎn xiàng jī','铤而走险':' tǐng ér zǒu xiǎn','前功尽弃':' qián gōng jìn qì','骈肩累迹':' pián jiān lěi jì','数九寒天':' shǔ jiǔ hán tiān','数不胜数':' shǔ bù shèng shǔ','同恶相恤':' tóng wù xiāng xù','量化逻辑':' liàng huà luó ji','哭丧着脸':' kū sāng zhe liǎn','可共患难':' kě gòng huàn nàn','量入为出':' liàng rù wéi chū','防毒斗篷':' fáng dú dǒu péng','调理阴阳':' tiáo lǐ yīn yáng','率土之滨':' shuài tǔ zhī bīn','间隔摄影':' jiàn gé shè yǐng','孀妻弱子':' shuāng qī ruò zǐ','叱吒风云':' chì zhà fēng yún','农业银行':' nóng yè yín háng','蝴蝶效应':' hú dié xiào yìng','牛听弹琴':' niú tīng tán qín','扭亏为盈':' niǔ kuī wéi yíng','巧发奇中':' qiǎo fā qí zhòng','强死赖活':' qiǎng sǐ lài huó','间接选举':' jiàn jiē xuǎn jǔ','痛深恶绝':' tòng shēn wù jué','处堂燕雀':' chǔ táng yàn què','切中时弊':' qiè zhòng shí bì','片甲不还':' piàn jiǎ bù huán','抢地呼天':' qiāng dì hū tiān','天差地远':' tiān chā dì yuǎn','片长末技':' piàn cháng mò jì','田父之功':' tián fǔ zhī gōng','片长薄技':' piàn cháng bó jì','皮相之谈':' pí xiàng zhī tán','和平共处':' hé píng gòng chǔ','斗筲之材':' dǒu shāo zhī cái','铜筋铁肋':' tóng jīn tiě lèi','金山屯区':' jīn shān zhūn qū','命名作业':' mìng míng zuò yè','片鳞只甲':' piàn lín zhī jiǎ','朝鲜核谈':' cháo xiǎn hé tán','尽人皆知':' jìn rén jiē zhī','攀蟾折桂':' pān chán shé guì','能者为师':' néng zhě wéi shī','率土归心':' shuài tǔ guī xīn','内助之贤':' nèi zhù zhī xián','啮血为盟':' niè xuè wéi méng','率由旧则':' shuài yóu jiù zé','松筠之节':' sōng jūn zhī jié','朝思暮想':' zhāo sī mù xiǎng','千载一逢':' qiān zǎi yī féng','似水流年':' sì shuǐ liú nián','普天率土':' pǔ tiān shuài tǔ','长驱直入':' cháng qū zhí rù','松柏之志':' sōng bǎi zhī zhì','其应如响':' qí yìng rú xiǎng','见微知著':' jiàn wēi zhī zhù','朝令夕改':' zhāo lìng xī gǎi','同型配子':' tóng xíng pèi zǐ','收拾残局':' shōu shi cán jú','乾嘉学派':' qián jiā xué pài','望而兴叹':' wàng ér xīng tàn','早期效应':' zǎo qī xiào yìng','早生贵子':' zǎo shēng guì zǐ','送子观音':' sòng zǐ guān yīn','搴旗取将':' qiān qí qǔ jiàng','谦谦君子':' qiān qiān jūn zǐ','乾端坤倪':' qián duān kūn ní','索尽枯肠':' suǒ jìn kū cháng','铺张扬厉':' pū zhāng yáng lì','目下十行':' mù xià shí háng','放下包袱':' fàng xia bāo fu','尽收眼底':' jìn shōu yǎn dǐ','数典忘祖':' shǔ diǎn wàng zǔ','强直自遂':' qiáng zhí zì suí','解铃系铃':' jiě líng jì líng','强文假醋':' qiǎng wén jiǎ cù','降龙伏虎':' xiáng lóng fú hǔ','朝鲜八道':' cháo xiǎn bā dào','亲子鉴定':' qīn zǐ jiàn dìng','见义勇为':' jiàn yì yǒng wéi','钻头卡盘':' zuàn tóu qiǎ pán','七长八短':' qī cháng bā duǎn','钻头夹盘':' zuàn tóu jiá pán','弹冠振衣':' tán guān zhèn yī','死亡枕藉':' sǐ wáng zhěn jiè','棋输先着':' qí shū xiān zhāo','朋比为奸':' péng bǐ wéi jiān','尽欢而散':' jìn huān ér sàn','弹斤估两':' tán jīn gū liǎng','长夜漫漫':' cháng yè màn màn','气冲斗牛':' qì chōng dǒu niú','率尔操觚':' shuài ěr cāo gū','量才而为':' liàng cái ér wéi','凌云之志':' líng yún zhī zhì','为德不终':' wéi dé bù zhōng','誓死不降':' shì sǐ bù xiáng','都市传奇':' dū shì chuán qí','炸土豆片':' zhá tǔ dòu piàn','有缘无分':' yǒu yuán wú fèn','脱骨成佛':' tuō gǔ chéng fó','渣打银行':' zhā dǎ yín háng','为善最乐':' wéi shàn zuì lè','安时处顺':' ān shí chǔ shùn','措置得当':' cuò zhì dé dàng','并为一谈':' bìng wéi yī tán','挑拨是非':' tiǎo bō shì fēi','挑拨离间':' tiǎo bō lí jiàn','都会传奇':' dū huì chuán qí','出处进退':' chū chǔ jìn tuì','辐射对称':' fú shè duì chèn','安守本分':' ān shǒu běn fèn','熬姜呷醋':' áo jiāng xiā cù','脊椎动物':' jǐ zhuī dòng wù','存亡未卜':' cún wáng wèi bǔ','进退为难':' jìn tuì wéi nán','氢氧离子':' qīng yǎng lí zǐ','走漏消息':' zǒu lòu xiāo xi','鹑衣鹄面':' chún yī hú miàn','老两口儿':' lǎo liǎng kǒu r','应接不暇':' yìng jiē bù xiá','赶尽杀绝':' gǎn jìn shā jué','炸土豆条':' zhá tǔ dòu tiáo','适度微调':' shì dù wēi tiáo','拨乱为治':' bō luàn wéi zhì','除害兴利':' chú hài xīng lì','竹篮打水':' zhú lán dá shuǐ','恶名昭著':' è míng zhāo zhù','洋底地壳':' yáng dǐ dì qiào','民间故事':' mín jiān gù shi','贸易顺差':' mào yì shùn chā','更仆难数':' gēng pú nán shǔ','详尽无遗':' xiáng jìn wú yí','买椟还珠':' mǎi dú huán zhū','诛尽杀绝':' zhū jìn shā jué','逻辑演算':' luó ji yǎn suàn','认识不能':' rèn shi bù néng','量子力学':' liàng zǐ lì xué','屏气敛息':' bǐng qì liǎn xī','要买人心':' yāo mǎi rén xīn','白发红颜':' bái fà hóng yán','爱乐乐团':' ài yuè yuè tuán','浪卡子县':' làng kǎ zǐ xiàn','标题音乐':' biāo tí yīn yuè','曲肱而枕':' qǔ gōng ér zhěn','曲终奏雅':' qǔ zhōng zòu yǎ','量力而为':' liàng lì ér wéi','应对如流':' yìng duì rú liú','触目兴叹':' chù mù xīng tàn','出没不常':' chū mò bù cháng','白发苍颜':' bái fà cāng yán','氢原子核':' qīng yuán zǐ hé','这还了得':' zhè hái liǎo dé','处理程序':' chǔ lǐ chéng xù','标记原子':' biāo jì yuán zǐ','啛啛喳喳':' cuì cuì chā chā','变危为安':' biàn wēi wéi ān','提起精神':' tí qǐ jīng shen','圣德太子':' shèng dé tài zǐ','漏脯充饥':' lòu fǔ chōng jī','等差级数':' děng chā jí shù','有失厚道':' yǒu shī hòu dao','词穷理尽':' cí qióng lǐ jìn','竭尽全力':' jié jìn quán lì','别无长物':' bié wú cháng wù','淡泊明志':' dàn bó míng zhì','澎湖列岛':' péng hú liè dǎo','逼人太甚':' bī rén tài shèn','洁身自好':' jié shēn zì hào','重码词频':' chóng mǎ cí pín','百喙莫辩':' bǎi huì mò biàn','氧乙炔焊':' yǎng yǐ quē hàn','词项逻辑':' cí xiàng luó ji','别开蹊径':' bié kāi xī jìng','八方风雨':' bā fāng fēng yǔ','澎湖群岛':' péng hú qún dǎo','处尊居显':' chǔ zūn jū xiǎn','别别扭扭':' biè biè niú niu','八方呼应':' bā fāng hū yìng','设身处地':' shè shēn chǔ dì','浪子回头':' làng zǐ huí tóu','沈北新区':' shěn běi xīn qū','有求必应':' yǒu qiú bì yìng','悲悲切切':' bēi bēi qiè qiē','应急措施':' yìng jí cuò shī','碧波荡漾':' bì bō dàng yàng','芝麻小事':' zhī ma xiǎo shì','白云亲舍':' bái yún qīn shè','风尘仆仆':' fēng chén pú pú','蔽聪塞明':' bì cōnɡ sè mínɡ','东倒西歪':' dōng dǎo xī wāi','置之脑后':' zhì zhī nǎo hòu','礼废乐崩':' lǐ fèi yuè bēng','百载树人':' bǎi zǎi shù rén','花旗银行':' huā qí yín háng','瞎子摸象':' xiā zǐ mō xiàng','相体裁衣':' xiàng tǐ cái yī','操作系统':' cāo zuō xì tǒng','老少皆宜':' lǎo shào jiē yí','颠来倒去':' diān lái dǎo qù','颠三倒四':' diān sān dǎo sì','排难解纷':' pái nàn jiě fēn','直系血亲':' zhí xì xuè qìng','暴露文学':' bào lòu wén xué','闭明塞聪':' bì míng sè cōng','习以为常':' xí yǐ wéi cháng','网络铁路':' wǎng luò tiě lù','百口莫辩':' bǎi kǒu mò biàn','杏仁豆腐':' xìng rén dòu fu','薄命佳人':' bó mìng jiā rén','薄弱环节':' bó ruò huán jié','细嚼慢咽':' xì jiáo màn yàn','首都领地':' shǒu dū lǐng dì','绍兴地区':' shào xīng dì qū','苍颜白发':' cāng yán bái fà','首要任务':' shǒu yào rèn wu','神出鬼没':' shén chū guǐ mò','食物中毒':' shí wù zhòng dú','草头天子':' cǎo tóu tiān zǐ','组成部分':' zǔ chéng bù fen','参伍错综':' cēn wǔ cuò zōng','绝食抗议':' jué shí kàng yì','饶舌音乐':' ráo shé yīn yuè','石头火锅':' shí tou huǒ guō','乐善好施':' lè shàn hào shī','百身莫赎':' bǎi shēn mò shú','鞭辟着里':' biān bì zhuó lǐ','长恶不悛':' cháng è bù quān','排忧解难':' pái yōu jiě nàn','朝乾夕惕':' zhāo qián xī tì','兴旺发达':' xīng wàng fā dá','背曲腰躬':' bèi qǔ yāo gōng','不遗寸长':' bù yí cùn cháng','不着疼热':' bù zhuó téng rè','与人为善':' yǔ rén wéi shàn','不知颠倒':' bù zhī diān dǎo','空地导弹':' kòng dì dǎo dàn','才薄智浅':' cāi bó zhì qiǎn','果实累累':' guǒ shí lěi lěi','积年累月':' jī nián lěi yuè','自视甚高':' zì shì shèn gāo','采购合同':' cǎi gòu hé tong','移山倒海':' yí shān dǎo hǎi','北门锁钥':' běi mén suǒ yuè','才占八斗':' cái zhān bā dǒu','抱柱之信':' bào zhù zhī xìn','魂不守舍':' hún bù shǒu shè','北斗之尊':' běi dǒu zhī zūn','与世长辞':' yǔ shì cháng cí','卑辞重币':' bēi cí zhòng bì','与世无争':' yú shì wú zhēng','黎明时分':' lí míng shí fèn','长恶靡悛':' cháng è mǐ quān','腹笥甚宽':' fù sì shèn kuān','花花公子':' huā huā gōng zǐ','捏脊治疗':' niē jǐ zhì liáo','擢发难数':' zhuó fà nán shǔ','庄稼户儿':' zhuāng jia hù r','花朝月夕':' huā zhāo yuè xī','腹笥便便':' fù sì pián pián','兴灭继绝':' xīng miè jì jué','私生子女':' sī shēng zǐ nǔ:','拾级而上':' shè jí ér shàng','拜人为师':' bài rén wéi shī','爱出风头':' ài chū fēng tou','捧腹绝倒':' pěng fù jué dǎo','不遑启处':' bù huáng qǐ chǔ','不了不当':' bù liǎo bù dàng','不了而了':' bù liǎo ér liǎo','鼓鼓囊囊':' gǔ gǔ nāng nāng','胆大妄为':' dǎn dà wàng wéi','本相毕露':' běn xiàng bì lù','本本分分':' běn běn fèn fēn','应急出口':' yìng jí chū kǒu','考试卷子':' kǎo shì juàn zi','朝阳地区':' zhāo yáng dì qū','重熙累叶':' chóng xī lěi yè','游说集团':' yóu shuì jí tuán','人中狮子':' rén zhōng shī zǐ','朝朝暮暮':' zhāo zhāo mù mù','衣锦荣归':' yì jǐn róng guī','食不重味':' shí bù chóng wèi','临难苟免':' lín nàn gǒu miǎn','例行差事':' lì xíng chāi shì','审曲面埶':' shěn qǔ miàn xīn','风雨漂摇':' fēng yǔ piāo yáo','狼子兽心':' láng zǐ shòu xīn','沈腰潘鬓':' shěn yāo pān bìn','钻故纸堆':' zuàn gù zhǐ duī','曲意承迎':' qǔ yì chéng yíng','傻瓜相机':' shǎ guā xiàng jī','无肠公子':' wú cháng gōng zǐ','兴隆台区':' xīng lóng tái qū','花不棱登':' huā bù lēng dēng','立党为公':' lì dǎng wèi gōng','人自为政':' rén zì wéi zhèng','审曲面势':' shěn qǔ miàn shì','日电电子':' rì diàn diàn zǐ','日长一线':' rì cháng yī xiàn','温席扇枕':' wēn xí shān zhěn','闻风而兴':' wén fēng ér xīng','都铎王朝':' dū duó wáng cháo','重操旧业':' chóng cāo jiù yè','团体冠军':' tuán tǐ guàn jūn','先睹为快':' xiān dǔ wéi kuài','重提旧事':' chóng tí jìu shì','频率调制':' pín lù: tiáo zhì','停车位置':' tíng chē wèi zhi','豁然开朗':' huò rán kāi lǎng','停酒止乐':' tíng jǐu zhǐ yuè','临难铸兵':' lín nàn zhù bīng','颠倒是非':' diān dǎo shì fēi','重新组合':' chóng xīn zǔ hé','黄毛丫头':' huáng máo yā tou','取长弃短':' qǔ cháng qì duǎn','偶联反应':' ǒu lián fǎn yìng','临机应变':' lín jī yìng biàn','毁家纾难':' huǐ jiā shū nàn','生发未燥':' shēng fà wèi zào','东亚银行':' dōng yà yín háng','温枕扇席':' wēn zhěn shān xí','人烟浩穰':' rén yān hào rǎng','厚养薄葬':' hòu yǎng bó zàng','飞来横祸':' fēi lái hèng huò','朝花夕拾':' zhāo huā xī shī','累见不鲜':' lěi jiàn bù xiǎn','成吉思汗':' chéng jí sī hán','原子半径':' yuán zǐ bàn jìng','人造草坪':' rén zào cǎo píng','认影为头':' rèn yǐng wéi tóu','长安大学':' cháng ān dà xué','身无长物':' shēn wú cháng wù','撩蜂剔蝎':' liáo fēng tì xiē','朝过夕改':' zhāo guò xī gǎi','人心丧尽':' rén xīn sàng jìn','累卵之危':' lěi luǎn zhī wēi','高丽王朝':' gāo lí wáng cháo','燕京啤酒':' yān jīng pí jǐu','重起炉灶':' chóng qǐ lú zào','兴业银行':' xīng yè yín háng','重纰貤缪':' chóng pī yí miù','鲜为人知':' xiǎn wéi rén zhī','熬更守夜':' áo gēng shǒu yè','杀彘教子':' shā zhì jiào zǐ','理论框架':' lǐ lùn kuàng jià','日本银行':' rì běn yín háng','骄阳似火':' jiāo yáng sì huǒ','地方停车':' dì fang tíng chē','励精更始':' lì jīng gēng shǐ','香榭丽舍':' xiāng xiè lì shè','曲终人散':' qǔ zhōng rén sàn','充分就业':' chōng fèn jìu yè','劳动合同':' láo dòng hé tong','人类行为':' rén lèi xíng wéi','朝闻夕改':' zhāo wén xī gǎi','重熙累绩':' chóng xī lěi jì','首都机场':' shǒu dū jī chǎng','瓮尽杯干':' wèng jìn bēi gān','首都剧场':' shǒu dū jù chǎng','重理旧业':' chóng lǐ jiù yè','骆驼祥子':' luò tuó xiáng zǐ','地壳运动':' dì qiào yùn dòng','神武挂冠':' shén wǔ guà guàn','朝秦暮楚':' zhāo qín mù chǔ','诬良为盗':' wū liáng wéi dào','朝日新闻':' zhāo rì xīn wén','华纳兄弟':' huà nà xīong dì','长途汽车':' cháng tú qì chē','长足进步':' cháng zú jìn bù','没有关系':' méi yǒu guān xi','酸不溜秋':' suān bu līu qīu','灭此朝食':' miè cǐ zhāo shí','赤绳系足':' chì shéng jì zú','营业时候':' yíng yè shí hou','狼号鬼哭':' láng háo guǐ kū','为时过早':' wéi shí guò zǎo','泄露天机':' xiè lòu tiān jī','斗筲之器':' dǒu shāo zhī qì','轻嘴薄舌':' qīng zuǐ bó shé','长途跋涉':' cháng tú bá shè','大事铺张':' dà shì pū zhāng','觅食行为':' mì shí xíng wéi','尺二冤家':' chǐ èr yuān jia','数码相机':' shù mǎ xiàng jī','明智之举':' míng zhì zhī jǔ','数珠念佛':' shǔ zhū niàn fó','朝鲜字母':' cháo xiǎn zì mǔ','归心似箭':' guī xīn sì jiàn','无以为生':' wú yǐ wéi shēng','斜纹软呢':' xié wén ruǎn ní','攒锋聚镝':' cuán fēng jù dí','长虑顾后':' cháng lǜ gù hòu','有头有尾':' yǒu tóu yǒu wěi','重游故地':' chóng yóu gù dì','应机立断':' yìng jī lì duàn','重足累息':' chóng zú lèi xī','针线活儿':' zhēn xiàn huó r','吃着不尽':' chī zhuó bù jìn','重规袭矩':' chóng guī xí jǔ','没有什么':' méi yǒu shén me','所作所为':' suǒ zuò suǒ wéi','抽筋剥皮':' chōu jīn bāo pí','应县木塔':' yìng xiàn mù tǎ','所向披靡':' suǒ xiàng pī mǐ','重规沓矩':' chóng guī tà jǔ','为时未晚':' wéi shí wèi wǎn','爵士音乐':' jué shì yīn yuè','物资供应':' wù zī gōng yìng','没有差别':' méi yǒu chā bié','键盘乐器':' jiàn pán yuè qì','扎实推进':' zhā shi tuī jìn','颠倒过来':' diān dǎo guò lái','蠡酌管窥':' lǐ zhuó guǎn kuī','养虎为患':' yǎng hǔ wéi huàn','都江堰市':' dū jiāng yàn shì','了无生趣':' liǎo wú shēng qù','过敏反应':' guò mǐn fǎn yìng','五行并下':' wǔ háng bìng xià','燎如观火':' liǎo rú guān huǒ','长期以来':' cháng qī yǐ lái','文行出处':' wén xíng chū chǔ','调嘴学舌':' tiáo zuǐ xué shé','无量寿佛':' wú liàng shòu fó','玩儿不转':' wán ér bù zhuàn','兴师问罪':' xīng shī wèn zuì','裙屐少年':' qún jī shào nián','累牍连篇':' lěi dú lián piān','凶神恶煞':' xiōng shén è shà','良家女子':' liáng jiā nǔ: zǐ','朝气蓬勃':' zhāo qì péng bó','撩火加油':' liáo huǒ jiā yóu','煞有介事':' shà yǒu jiè shì','行为主义':' xíng wéi zhǔ yì','连编累牍':' lián biān lěi dú','无穷无尽':' wú qióng wú jìn','轻浪浮薄':' qīng làng fú bó','大相国寺':' dà xiàng guó sì','闭上嘴巴':' bì shang zuǐ bā','犹未为晚':' yóu wèi wéi wǎn','代表大会':' dài biǎo dà huì','溘先朝露':' kè xiān zhāo lù','没齿难忘':' mò chǐ nán wàng','为非作歹':' wéi fēi zuò dǎi','闭卷考试':' bì juàn kǎo shì','晏子春秋':' yàn zǐ chūn qīu','围魏救赵':' wéi wèi jiù zhào','应用物理':' yìng yòng wù lǐ','开卷有益':' kāi juàn yǒu yì','大局为重':' dà jú wéi zhòng','人多阙少':' rén duō què shǎo','处事原则':' chǔ shì yuán zé','养尊处优':' yǎng zūn chǔ yōu','颠倒黑白':' diān dǎo hēi bái','裂裳裹足':' liè cháng guǒ zú','埒才角妙':' liè cái jué miào','英语教学':' yīng yǔ jiāo xué','骨牌效应':' gǔ pái xiào yìng','令原之戚':' líng yuán zhī qī','东横西倒':' dōng héng xī dǎo','水底相机':' shuǐ dǐ xiàng jī','满口脏话':' mǎn kǒu zāng huà','上半部分':' shàng bàn bù fèn','三陪小姐':' sān péi xiǎo jie','筑舍道傍':' zhù shè dào bàng','柱石之坚':' zhù shí zhī jiān','弹尽援绝':' dàn jìn yuán jué','助天为虐':' zhù tiān wéi nüè','口干舌燥':' kǒu gān shé zào','指天为誓':' zhǐ tiān wéi shì','祝鮀之佞':' zhù tuó zhī nìng','溢出效应':' yì chū xiào yìng','丢车保帅':' diū jū bǎo shuài','褚小怀大':' zhǔ xiǎo huái dà','钉头磷磷':' ding tou lin lin','祝咽祝哽':' zhù yān zhù gěng','动画片儿':' dòng huà piān er','民间音乐':' mín jiān yīn yuè','弹指之间':' tán zhǐ zhī jiān','炎黄子孙':' yán huáng zǐ sūn','杼柚空虚':' zhù zhóu kōng xū','直言切谏':' zhí yán qiē jiàn','烈火干柴':' liè huǒ gān chái','断线鹞子':' duàn xiàn yào zǐ','都中纸贵':' dū zhōng zhǐ guì','处变不惊':' chǔ biàn bù jīng','青灯古佛':' qīng dēng gǔ fó','古典音乐':' gǔ diǎn yīn yuè','应试教育':' yìng shì jiào yù','重足屏气':' chóng zú bǐng qì','庚子国变':' gēng zǐ guó biàn','发人深省':' fā rén shēn xǐng','重足屏息':' chóng zú bǐng xī','发怒穿冠':' fà nù chuān guān','为人师表':' wéi rén shī biǎo','发怒冲冠':' fà nù chōng guān','儿女情长':' ér nǚ qíng cháng','儿女成行':' ér nǚ chéng háng','智尽能索':' zhì jìn néng suǒ','不治之症':' bù zhì zhī zhèng','应用科学':' yìng yòng kē xué','阿党相为':' ē dǎng xiāng wéi','弹射座舱':' tán shè zuò cāng','触物兴怀':' chù wù xīng huái','触类而长':' chù lèi ér cháng','孔子学院':' kǒng zǐ xué yuàn','哗世取宠':' huá shì qǔ chǒng','硕果累累':' shuò guǒ léi léi','化枭为鸠':' huà xiāo wéi jiū','任人唯贤':' rèn rén wéi xián','还淳反古':' huán chún fǎn gǔ','还淳返朴':' huán chún fǎn pǔ','情见力屈':' qíng xiàn lì qū','简能而任':' jiǎn néng ér rèn','言笑晏晏':' yán xiào yàn yàn','情见乎辞':' qíng xiàn hū cí','换斗移星':' huàn dǒu yí xīng','患难与共':' huàn nàn yǔ gòng','见哭兴悲':' jiàn kū xīng bēi','还年驻色':' huán nián zhù sè','拐弯抹角':' guǎi wān mò jiǎo','礼坏乐崩':' lǐ huài yuè bēng','苍劲有力':' cāng jìng yǒu lì','礼崩乐坏':' lǐ bēng yuè huài','表面处理':' biǎo miàn chǔ lǐ','层台累榭':' céng tái lěi xiè','仰屋兴叹':' yǎng wū xīng tàn','指雁为羹':' zhǐ yàn wéi gēng','漫漫长夜':' màn màn cháng yè','气冲牛斗':' qì chōng niú dǒu','口不应心':' kǒu bù yìng xīn','斗折蛇行':' dǒu zhé shé xíng','种豆得豆':' zhòng dòu dé dòu','逐机应变':' zhú jī yìng biàn','揣时度力':' chuǎi shí duó lì','不了了之':' bù liǎo liǎo zhī','斗酒百篇':' dǒu jiǔ bǎi piān','珠宫贝阙':' zhū gōng bèi què','石膏绷带':' shí gāo bēng dài','种瓜得瓜':' zhòng guā dé guā','毫不相干':' háo bù xiāng gān','善为说辞':' shàn wéi shuō cí','鹄面鸠形':' hú miàn jiū xíng','知之甚微':' zhī zhī shèn wēi','一天星斗':' yī tiān xīng dǒu','青山一发':' qīng shān yī fà','矮杆品种':' ǎi gǎn pǐn zhǒng','以守为攻':' yǐ shǒu wéi gōng','断发文身':' duàn fà wén shēn','弧长参数':' hú cháng cān shù','等差数列':' děng chā shù liè','醉山颓倒':' zuì shān tuí dǎo','陈力就列':' chén lì jiù liè','钻头就锁':' zuàn tóu jiù suǒ','怒发冲冠':' nù fà chōng guān','钻穴逾垣':' zuàn xué yú yuán','措置失当':' cuò zhì shī dàng','道尽途穷':' dào jìn tú qióng','道傍之筑':' dào bàng zhī zhù','称家有无':' chèn jiā yǒu wú','当头棒喝':' dāng tóu bàng hè','倒冠落佩':' dǎo guān luò pèi','一了百了':' yī liǎo bǎi liǎo','男性厌恶':' nán xìng yàn wù','作舍道边':' zuò shè dào biān','沙加缅度':' shā jiā miǎn duó','畏首畏尾':' wèi shǒ wèi wěi','悄无声息':' qiǎo wú shēng xī','扯纤拉烟':' chě qiàn lā yān','待时守分':' dài shí shǒu fèn','法国长棍':' fǎ guó cháng gùn','倒持手板':' dǎo chí shǒu bǎn','双重标准':' shuāng chóng biāo zhǔn','没完没了':' méi wán méi liǎo','春色撩人':' chūn sè liáo rén','一身两役':' yī shēn liǎng yì','浑身解数':' hún shēn xiè shù','游说团体':' yóu shuì tuán tǐ','雕肝琢膂':' diāo gān zhuó lǚ','刁斗森严':' diāo dǒu sēn yán','点石为金':' diǎn shí wéi jīn','吹叶嚼蕊':' chuī yè jiáo ruǐ','唇干口燥':' chún gān kǒu zào','春深似海':' chūn shēn sì hǎi','称心满意':' chèn xīn mǎn yì','电子文档':' diàn zǐ wén dàng','一言为重':' yī yán wéi zhòng','一笑了之':' yī xiào liǎo zhī','啜英咀华':' chuò yīng jǔ huá','测量工具':' cè liáng gōng jù','刁钻促狭':' diāo zuàn cù xiá','海盗行为':' hǎi dào xíng wéi','倒执手版':' dǎo zhí shǒu bǎn','倒街卧巷':' dǎo jiē wò xiàng','灯尽油干':' dēng jìn yóu gàn','泰山北斗':' tài shān běi dǒu','知疼着热':' zhī téng zháo rè','知人善任':' zhī rén shàn rèn','钻冰取火':' zuàn bīng qǔ huǒ','琴瑟失调':' qín sè shī tiáo','轻财好义':' qīng cái hào yì','总会计师':' zǒng kuài jì shī','反躬自省':' fǎn gōng zì xǐng','杼柚其空':' zhù zhóu qí kōng','鼎鼐调和':' dǐng nai tiáo hé','处高临深':' chǔ gāo lín shēn','不揣冒昧':' bù chuǎi mào mèi','盗嫂受金':' dào sǎo shòu jīn','钝学累功':' dùn xué lěi gōng','除患兴利':' chú huàn xīng lì','指山说磨':' zhǐ shān shuō mò','只身孤影':' zhī shēn gū yǐng','应有尽有':' yīng yǒu jìn yǒu','对薄公堂':' duì bù gōng táng','指树为姓':' zhǐ shù wéi xìng','短见薄识':' duǎn jiàn bó shí','弦鸣乐器':' xián míng yuè qì','走为上策':' zǒu wéi shàng cè','恶意中伤':' è yì zhòng shāng','超然独处':' chāo rán dú chǔ','殚诚毕虑':' dān chéng bì lǜ','巢居穴处':' cháo jū xué chǔ','番茄红素':' fān qié hóng sù','异曲同工':' yì qǔ tóng gōng','还珠买椟':' huán zhū mǎi dú','流行音乐':' liú xíng yīn yuè','虱胫虮肝':' shī jìng jī gān','催化反应':' cuī huà fǎn yìng','派拉蒙影':' pài lā měng yǐng','外强中干':' wài qiáng zhōng gān','心拙口夯':' xīn zhuō kǒu bèn','请自隗始':' qǐng zì wěi shǐ','寸长尺技':' cùn cháng chǐ jì','另辟蹊径':' lìng pì xī jìng','子夏悬鹑':' zǐ xià xuán chún','恶语中伤':' è yǔ zhòng shāng','倒廪倾囷':' dǎo lǐn qīng qūn','活神仙似':' huó shén xiān sì','心广体胖':' xīn guǎng tǐ pán','纵曲枉直':' zòng qǔ wǎng zhí','严刑逼供':' yán xíng bī gòng','燕昭市骏':' yān zhāo shì jùn','一针见血':' yī zhēn jiàn xiě','学生宿舍':' xué shēng sù shè','哼哈二将':' hēng hā èr jiàng','横祸飞灾':' hèng huò fēi zāi','求神问卜':' qiú shén wèn bǔ','经济困境':' jīng jì kùn jìng','察察为明':' chá chá wéi míng','横科暴敛':' hèng kē bào liǎn','什一奉献':' shí yī fèng xiàn','奉为圭臬':' fèng wéi guī niè','反动势力':' fǎn dòng shì li','寓意深长':' yù yì shēn cháng','人间佛教':' rén jiān fó jiào','缓发中子':' huǎn fā zhōng zǐ','印累绶若':' yìn léi shòu ruò','诘屈磝碻':' jié qū bìng zhòu','好勇斗狠':' hào yǒng dòu hěn','鹤长凫短':' hè cháng fú duǎn','鹤短凫长':' hè duǎn fú cháng','长眠不起':' cháng mián bù qǐ','人满为患':' rén mǎn wéi huàn','贝阙珠宫':' bèi què zhū gōng','矫国更俗':' jiǎo guó gēng sú','轩鹤冠猴':' xuān hè guàn hóu','薄寒中人':' bó hán zhòng rén','价格行情':' jià gé háng qíng','站不住脚':' zhàn bu zhù jiǎo','似水年华':' sì shuǐ nián huá','要价还价':' yào jià huán jià','似笑非笑':' sì xiào fēi xiào','求神拜佛':' qiú shén bài fó','稀里光当':' xī li guāng dāng','相机而动':' xiàng jī ér dòng','竭尽所能':' jié jìn suǒ néng','好为事端':' hào wéi shì duān','供不应求':' gōng bù yìng qiú','横倒竖歪':' héng dǎo shù wāi','胶柱调瑟':' jiāo zhù tiáo sè','悬首吴阙':' xuán shǒu wú què','矫情干誉':' jiǎo qíng gān yù','秀出班行':' xiù chū bān háng','长歌当哭':' cháng gē dàng kū','角巾东路':' jiǎo jīn dōng lù','长戟高门':' cháng jǐ gāo mén','长久之计':' cháng jiǔ zhī jì','悬鼓待椎':' xuán gǔ dài zhuī','宾主尽欢':' bīn zhǔ jìn huān','尽其所长':' jìn qí suǒ cháng','横灾飞祸':' hèng zāi fēi huò','引为鉴戒':' yǐn wéi jiàn jiè','长短不一':' cháng duǎn bù yī','相夫教子':' xiàng fū jiào zǐ','长驱深入':' cháng qū shēn rù','长驱直进':' cháng qū zhí jìn','淫言媟语':' yín yán liǎng yǔ','人民公仆':' rén mín gōng pú','目挑心招':' mù tiǎo xīn zhāo','尽美尽善':' jìn měi jìn shàn','兴妖作孽':' xīng yāo zuò niè','横征苛役':' hèng zhēng kē yì','浩气长存':' hào qì cháng cún','较德焯勤':' jiào dé zhuō qín','太古洋行':' tài gǔ yáng háng','树碑立传':' shù bēi lì zhuàn','横行逆施':' héng xíng nì shī','舍车保帅':' shě jū bǎo shuài','好生之德':' hào shēng zhī dé','长此以往':' cháng cǐ yǐ wǎng','绞尽脑汁':' jiǎo jìn nǎo zhī','黑白颠倒':' hēi bái diān dǎo','曲眉丰颊':' qǔ méi fēng jiá','揭箧担囊':' jiē qiè dān náng','相差不多':' xiāng chà bu duō','夹脚拖鞋':' jiá jiǎo tuō xié','人民银行':' rén mín yín háng','捋臂揎拳':' luō bì xuān quán','反动分子':' fǎn dòng fèn zǐ','紧急应变':' jǐn jí yìng biàn','桁杨刀锯':' háng yáng dāo jù','人车混行':' rén chē hún xíng','实际应用':' shí jì yìng yòng','河清云庆':' hé qīng yún qìng','长计远虑':' cháng jì yuǎn lǜ','家常豆腐':' jiā cháng dòu fu','因果报应':' yīn guǒ bào yìng','曲学诐行':' qǔ xué hǎo xíng','鞭辟向里':' biān bì xiàng lǐ','埙篪相和':' xūn chí xiāng hè','北门管钥':' běi mén guǎn yuè','卑宫菲食':' bēi gōng fěi shí','材薄质衰':' cái bó zhì shuāi','毁舟为杕':' huǐ zhōu wéi duò','还淳反素':' huán chún fǎn sù','抽丝剥茧':' chōu sī bāo jiǎn','呼天抢地':' hū tiān qiāng dì','众矢之的':' zhòng shǐ zhī dì','衣绣昼行':' yì xiù zhòu xíng','胡行乱为':' hú xíng luàn wéi','穷不失义':' qióng bù shī yì','燕骏千金':' yān jùn qiān jīn','简单地说':' jiǎn dān de shuō','鹄峙鸾停':' hú zhì luán tíng','瞬发中子':' shùn fā zhōng zǐ','见义当为':' jiàn yì dāng wéi','意义深长':' yì yì shēn cháng','言必有中':' yán bì yǒu zhòng','一了百当':' yī liǎo bǎi dàng','拓扑空间':' tuò pū kōng jiān','挑灯拨火':' tiǎo dēng bō huǒ','招人喜欢':' zhāo rén xǐ huan','婚姻调解':' hūn yīn tiáo jiě','棺材瓤子':' guān cai ráng zi','不相为谋':' bù xiāng wéi móu','眼见为实':' yǎn jiàn wéi shí','孤身只影':' gū shēn zhī yǐng','移动平台':' yí dòng píng tái','鞭长不及':' biān cháng bù jí','惨绿少年':' cǎn lǜ shào nián','以慎为键':' yǐ shèn wéi jiàn','表里为奸':' biǎo lǐ wéi jiān','相机而行':' xiàng jī ér xíng','燕处焚巢':' yàn chǔ fén cháo','燕处危巢':' yàn chǔ wēi cháo','累加总数':' lěi jiā zǒng shù','倾心尽力':' qīng xīn jìn lì','一朝之患':' yī zhāo zhī huàn','狐唱枭和':' hú chàng xiāo hé','桴鼓相应':' fú gǔ xiāng yìng','鸿篇巨著':' hóng piān jù zhù','红绳系足':' hóng shéng jì zú','红颜薄命':' hóng yán bó mìng','红寡妇鸟':' hóng guǎ fu niǎo','眼泪横流':' yǎn lèi hèng líu','变废为宝':' biàn fèi wéi bǎo','化鸱为凤':' huà chī wéi fèng','情至意尽':' qíng zhì yì jìn','冰山易倒':' bīng shān yì dǎo','击中要害':' jī zhòng yào hài','以攻为守':' yǐ gōng wéi shǒu','求过于供':' qiú guò yú gòng','秀发垂肩':' xìu fà chuí jiān','一口两匙':' yī kǒu liǎng chí','黄冠野服':' huáng guàn yě fú','俭不中礼':' jiǎn bù zhòng lǐ','言之过甚':' yán zhī guò shèn','夹心饼干':' jiā xīn bǐng gān','黄绵袄子':' huáng mián ǎo zǐ','科教兴国':' kē jiào xīng guó','别创一格':' bié chuàng yí gé','反兴奋剂':' fǎn xīng fèn jì','好整以暇':' hào zhěng yǐ xiá','佛朗机铳':' fó lǎng jī chòng','毫发不爽':' háo fà bù shuǎng','一哄而上':' yì hōng ér shàng','空气调节':' kōng qì tiáo jié','材高知深':' cái gāo zhì shēn','回山倒海':' huí shān dǎo hǎi','似懂非懂':' sì dǒng fēi dǒng','回天运斗':' huí tiān yùn dǒu','霍尔效应':' huò ěr xiào yìng','火尽灰冷':' huǒ jìn huī lěng','一长一短':' yī cháng yī duǎn','威慑力量':' wēi shè lì liang','屏声息气':' bǐng shēng xī qì','一长二短':' yī cháng èr duǎn','积微成著':' jī wēi chéng zhù','只言片语':' zhī yán piàn yǔ','穷于应付':' qióng yú yìng fù','咬姜呷醋':' yǎo jiāng xiā cù','衣被群生':' yì bèi qún shēng','扣壶长吟':' kòu hú cháng yín','屏退左右':' bǐng tuì zuǒ yòu','夜静更阑':' yè jìng gēng lán','礼乐崩坏':' lǐ yuè bēng huài','威化饼干':' wēi huà bǐng gān','咬血为盟':' yǎo xuè wéi méng','机关算尽':' jī guān suàn jìn','机关用尽':' jī guān yòng jìn','妖由人兴':' yāo yóu rén xīng','不差上下':' bù chā shàng xià','液晶电视':' yè jīng diàn shì','赍粮藉寇':' jī liáng jiè kòu','饥冻交切':' jī dòng jiāo qiē','彰善瘅恶':' zhāng shàn dàn è','摧刚为柔':' cuī gāng wéi róu','电子产品':' diàn zǐ chǎn pǐn','朝钟暮鼓':' zhāo zhōng mù gǔ','政治避难':' zhèng zhì bì nàn','舂容大雅':' chōng róng dà yá','朝衣东市':' zhāo yī dōng shì','电磁感应':' diàn cí gǎn yìng','重新开机':' chóng xīn kāi jī','热岛效应':' rè dǎo xiào yìng','随声附和':' suí shēng fù hè','朝生夕死':' zhāo shēng xī sǐ','重葩累藻':' chóng pā lèi zǎo','指导思想':' zhí dǎo sī xiǎng','缟纻之交':' gāo zhù zhī jiāo','各有所长':' gè yǒu suǒ cháng','百发百中':' bǎi fā bǎi zhòng','专业知识':' zhuān yè zhī shi','成佛作祖':' chéng fó zuò zǔ','鬼魅伎俩':' guǐ mèi jì liǎng','锋镝余生':' fēng dí yú shēng','重门击柝':' chóng mén jī tuò','槟榔西施':' bīng lang xī shī','公共汽车':' gōng gòng qì chē','凤只鸾孤':' fèng zhī luán gū','朝奏夕召':' zhāo zòu xī zhào','情深似海':' qíng shēn sì hǎi','电邮位置':' diàn yóu wèi zhi','朝种暮获':' zhāo zhǒng mù hù','缝衣浅带':' féng yī qiǎn dài','奉为至宝':' fèng wéi zhì bǎo','戳脊梁骨':' chuō jǐ liang gǔ','公共秩序':' gōng gòng zhì xù','燕雀处堂':' yàn què chǔ táng','朝升暮合':' zhāo shēng mù gě','放热反应':' fàng rè fǎn yìng','电子邮件':' diàn zǐ yóu jiàn','朝生暮死':' zhāo shēng mù sǐ','朝奏暮召':' zhāo zòu mù zhào','风流蕴藉':' fēng liú yùn jiè','百废待兴':' bǎi fèi dài xīng','靡然从风':' mǐ rán cóng fēng','烟熏火燎':' yān xūn huǒ liǎo','宽大为怀':' kuān dà wéi huái','鼓乐喧天':' gǔ yuè xuān tiān','畅所欲为':' chàng suǒ yù wéi','审时度势':' shěn shí duó shì','随机效应':' suí jī xiào yìng','重复语境':' chóng fù yǔ jìng','头童齿豁':' tóu tóng chǐ huò','行伍出身':' háng wǔ chū shēn','因缘为市':' yīn yuán wéi shì','没收财产':' mò shōu cái chǎn','应答如响':' yìng dá rú xiǎng','随机应变':' suí jī yìng biàn','尽善尽美':' jìn shàn jìn měi','长舌之妇':' cháng shé zhī fù','应用技术':' yìng yòng jì shù','离子交换':' lí zǐ jiāo huàn','抱子弄孙':' bào zǐ nòng sūn','随行就市':' suí háng jiù shì','长吁短气':' cháng xū duǎn qì','青林黑塞':' qīng lín hēi sài','葛莱美奖':' gě lái měi jiǎng','槛花笼鹤':' jiàn huā lóng hè','处世原则':' chǔ shì yuán zé','冠山戴粒':' guàn shān dài lì','倡条冶叶':' chāng tiáo yě yè','发言中肯':' fā yán zhòng kěn','纶巾羽扇':' guān jīn yǔ shàn','未卜先知':' wèi bǔ xiān zhī','长夜之饮':' cháng yè zhī yǐn','理性认识':' lǐ xìng rèn shi','事危累卵':' shì wēi lěi luǎn','重温旧业':' chóng wēn jiù yè','疾风劲草':' jí fēng jìng cǎo','霍乱杆菌':' huò luàn gǎn jūn','未竟之志':' wèi jìng zhī zhì','游闲公子':' yóu xián gōng zǐ','当行出色':' dāng háng chū sè','壳牌公司':' qiào pái gōng sī','公共厕所':' gōng gòng cè suǒ','过从甚密':' guò cóng shèn mì','历尽沧桑':' lì jìn cāng sāng','斩尽杀绝':' zhǎn jìn shā jué','玉质金相':' yù zhì jīn xiàng','膏唇贩舌':' gào chún fàn shé','詹言曲说':' zhān yán qǔ shuō','恶醉强酒':' wù zuì qiǎng jiǔ','崭露头角':' zhǎn lù tóu jiǎo','唱高调儿':' chàng gāo diào r','处世之道':' chǔ shì zhī dào','斩将刈旗':' zhǎn jiàng yì qí','沾沾自好':' zhān zhān zì hào','丹瑞大将':' dān ruì dà jiàng','请假回家':' qǐng jià huí jiā','长幼有序':' zhǎng yòu yǒu xù','情见势屈':' qíng xiàn shì qū','吃斋念佛':' chī zhāi niàn fó','电子网络':' diàn zǐ wǎng luò','手不释卷':' shǒu bù shì juàn','告老还家':' gào lǎo huán jiā','朝趁暮食':' zhāo chèn mù shí','差强人意':' chā qiáng rén yì','重规累矩':' chóng guī lèi jǔ','朝更暮改':' zhāo gèng mù gǎi','朝经暮史':' zhāo jīng mù shǐ','重迹屏气':' chóng jì bǐng qì','凫短鹤长':' fú duǎn hè cháng','牢靠妥当':' láo kào tuǒ dàng','冲冠怒发':' chōng guàn nù fà','佛眼相看':' fó yǎn xiāng kàn','高情逸兴':' gāo qíng yì xīng','佛性禅心':' fó xìng chán xīn','差动齿轮':' chā dòng chǐ lún','朝令暮改':' zhāo lìng mù gǎi','死海经卷':' sǐ hǎi jīng juàn','伏虎降龙':' fú hǔ xiáng lóng','干柴烈火':' gān chái liè huǒ','冲冠发怒':' chōng guàn fā nù','面南背北':' miàn nán bèi běi','勉强及格':' miǎn qiǎng jí gé','阿里山乡':' a lǐ shān xiāng','清静无为':' qīng jìng wú wéi','阿谀奉承':' ē yú fèng chéng','民事调解':' mín shì tiáo jiě','著称于世':' zhù chēng yú shì','专横跋扈':' zhuān hèng bá hù','飞灾横祸':' fēi zāi hèng huò','年少无知':' nián shào wú zhī','万别千差':' wàn bié qiān chā','泛应曲当':' fàn yīng qǔ dāng','甚感诧异':' shèn gǎn chà yì','眠花藉柳':' mián huā jiè liǔ','反应迟钝':' fǎn yìng chí dùn','返朴还真':' fǎn pǔ huán zhēn','返朴还淳':' fǎn pǔ huán chún','丧失殆尽':' sàng shī dài jìn','公共假期':' gōng gòng jià qī','重兴旗鼓':' chóng xīng qí gǔ','敷衍了事':' fū yǎn liǎo shì','正冠纳履':' zhèng guàn nà lǚ','整齐划一':' zhěng qí huá yī','杠杆原理':' gàng gǎn yuán lǐ','公共道德':' gōng gòng dào dé','充分发挥':' chōng fèn fā huī','电子文件':' diàn zǐ wén jiàn','重历旧游':' chóng lì jìu yóu','电子警察':' diàn zǐ jǐng chá','犯罪行为':' fàn zuì xíng wéi','敢为人先':' gǎn wéi rén xiān','凤子龙孙':' fèng zǐ lóng sūn','枕席还师':' zhěn xí huán shī','词频效应':' cí pín xiào yìng','风云之志':' fēng yún zhī zhì','电子层数':' diàn zǐ céng shù','世界银行':' shì jiè yín háng','非意相干':' fēi yì xiāng gān','费尽周折':' fèi jìn zhōu zhé','重熙累洽':' chóng xī lěi qià','横行霸道':' héng xíng bà dào','渊涓蠖濩':' yuān juān huò hù','百般刁难':' bǎi bān diāo nàn','抒情散文':' shū qíng sǎn wén','钦差大臣':' qīn chāi dà chén','趁水和泥':' chèn shuǐ huò ní','晨兴夜寐':' chén xīng yè mèi','玉尺量才':' yù chǐ liáng cái','处之泰然':' chǔ zhī tài rán','小缸缸儿':' xiǎo gāng gang r','审度时势':' shěn duó shí shì','扯篷拉纤':' chě péng lā qiàn','超今冠古':' chāo jīn guàn gǔ','书缺有间':' shū quē yǒu jiàn','诗书发冢':' shī shū fà zhǒng','免疫反应':' miǎn yì fǎn yìng','优游涵泳':' yōu yóu hán yǒng','磨砻镌切':' mó lóng juān qiē','成风尽垩':' chéng fēng jìn è','男孩乐队':' nán hái yuè duì','尽入彀中':' jìn rù gòu zhōng','词优效应':' cí yōu xiào yìng','重振旗鼓':' chóng zhèn qí gǔ','明珠弹雀':' míng zhū tán què','明月入怀':' míng yuè rù huái','乱臣贼子':' luàn chén zéi zǐ','煎炸食品':' jiān zhá shí pǐn','转忧为喜':' zhuǎn yōu wéi xǐ','小两口儿':' xiǎo liǎng kǒu r','薄养厚葬':' bó yǎng hòu zàng','正确处理':' zhèng què chǔ lǐ','应弦而倒':' yìng xián ér dǎo','称心快意':' chèn xīn kuài yì','深更半夜':' shēn gēng bàn yè','万古长新':' wàn gǔ cháng xīn','千了万当':' qiān le wàn dàng','甲壳动物':' jiǎ qiào dòng wù','谁人乐队':' shéi rén yuè duì','贡禹弹冠':' gòng yǔ tán guān','公子王孙':' gōng zǐ wáng sūn','尸居龙见':' shī jū lóng xiàn','鸾孤凤只':' luán gū fèng zhī','华夏银行':' huá xià yín háng','购销合同':' gòu xiāo hé tong','理性知识':' lǐ xìng zhī shi','绿林强盗':' lù lín qiáng dào','绷爬吊拷':' bēng pá diào kǎo','羽扇纶巾':' yǔ shàn guān jīn','难兄难弟':' nàn xiōng nàn dì','冤家对头':' yuān jia duì tóu','正人君子':' zhèng rén jūn zǐ','没颠没倒':' méi diān méi dǎo','成分分析':' chéng fèn fēn xī','鸾鹄停峙':' luán hú tíng zhì','扪参历井':' mén shēn lì jǐng','数往知来':' shǔ wǎng zhī lái','语笑喧哗':' yǔ xiào xuān huá','图穷匕见':' tú qióng bǐ xiàn','鸾鹄在庭':' luán hú zài tíng','重睹天日':' chóng dǔ tiān rì','抟沙嚼蜡':' tuán shā jiáo là','有两下子':' yǒu liǎng xià zǐ','电子商务':' diàn zǐ shāng wù','朱云折槛':' zhū yún shé jiàn','曾不惨然':' zeng bu chan ran','隔行扫描':' gé háng sǎo miáo','更姓改物':' gēng xìng gǎi wù','月没参横':' yuè mò shēn héng','乘间伺隙':' chéng jiān sì xì','用尽心机':' yòng jìn xīn jī','深恶痛绝':' shēn wù tòng jué','公共积累':' gōng gòng jī lěi','歃血为盟':' shà xuè wéi méng','颠倒干坤':' diān dǎo gàn kūn','长斋礼佛':' cháng zhāi lǐ fó','转祸为福':' zhuǎn huò wéi fú','欧阳予倩':' oū yáng yú qiàn','望闻问切':' wàng wén wèn qiē','颠唇簸嘴':' diān chún bò zuǐ','阶级成分':' jiē jí chéng fèn','国难当头':' guó nàn dāng tóu','远不间亲':' yuǎn bù jiàn qīn','男女老少':' nán nǚ lǎo shào','找不着北':' zhǎo bu zháo běi','子宫脱垂':' zǐ gōng tuō chuí','讨价还价':' tǎo jià huán jià','沦没丧亡':' lún mò sàng wáng','将伯之助':' qiāng bó zhī zhù','束缊请火':' shù yùn qǐng huǒ','消息来源':' xiāo xi lái yuán','从长计议':' cóng cháng jì yì','地方风味':' dì fāng fēng wèi','子宫后倾':' zǐ gōng hòu qīng','液晶显示':' yè jīng xiǎn shì','草草了事':' cǎo cǎo liǎo shì','感性认识':' gǎn xìng rèn shi','地狱变相':' dì yù biàn xiàng','更弦易辙':' gēng xián yì zhé','弓折刀尽':' gōng zhé dāo jìn','斫雕为朴':' zhuó diāo wéi pǔ','云兴霞蔚':' yún xīng xiá wèi','得心应手':' dé xīn yìng shǒu','随风倒舵':' suí fēng dǎo duò','未艾方兴':' wèi ài fāng xīng','贼子乱臣':' zéi zǐ luàn chén','随风倒柳':' suí fēng dǎo lǐu','音乐电视':' yīn yuè diàn shì','武装分子':' wǔ zhuāng fèn zǐ','转灾为福':' zhuǎn zāi wéi fú','贼臣乱子':' zéi chén luàn zǐ','阴差阳错':' yīn chā yáng cuò','世界冠军':' shì jiè guàn jūn','正负电子':' zhèng fù diàn zǐ','重蹈覆辙':' chóng dǎo fù zhé','正月初一':' zhēng yuè chū yī','搂头盖脸':' lōu tóu gài liǎn','间接宾语':' jiàn jiē bīn yǔ','现代音乐':' xiàn dài yīn yuè','阴错阳差':' yīn cuò yáng chā','拓跋魏':' tuò bá wèi','鹤嘴镐':' hè zuǐ hào','舔屁股':' tiǎn pì gu','苣荬菜':' qǔ mǎi cài','看热闹':' kàn rè nao','劳什子':' láo shí zǐ','容不得':' róng bu dé','月头儿':' yuè tou er','老油子':' lǎo yóu zǐ','芸苔子':' yún tái zǐ','禁不住':' jīn bú zhù','迫击炮':' pǎi jī pào','燕尾蝶':' yān wěi dié','练习曲':' liàn xí qǔ','真子集':' zhēn zǐ jí','曾都区':' zēng dū qū','拗不过':' niù bù guò','话篓子':' huà lǒu zǐ','看得过':' kàn de guò','雅诺什':' yǎ nuò shí','空壳子':' kōng ké zǐ','不对劲':' bú duì jìn','看不出':' kàn bu chū','了不得':' liǎo bù dé','老师傅':' lǎo shī fū','老大难':' lǎo dà nàn','豆角儿':' dòu jué ér','万柏林':' wàn bó lín','曾祖父':' zēng zǔ fù','让步地':' ràng bù de','纪录片':' jì lù piān','拓扑学':' tuò pū xué','办不到':' bàn bú dào','坐月子':' zuò yuè zǐ','参与制':' cān yù zhì','填塞物':' tián sè wù','粘乎乎':' nián hū hū','注射液':' zhù shè yè','虎而冠':' hǔ ér guàn','来得早':' lái de zǎo','圆舞曲':' yuán wǔ qǔ','六个月':' liù ge yuè','落不是':' luò bú shì','粘合剂':' nián hé jì','拦不住':' lán bú zhù','着劲儿':' zhuó jìn r','曾纪泽':' zēng jì zé','不对头':' bú duì tóu','保不住':' bǎo bú zhù','谈得来':' tán de lái','老鸨子':' lǎo bǎo zǐ','子弹带':' zǐ dàn dài','塔什干':' tǎ shí gàn','着色力':' zhuó sè lì','附着物':' fù zhuó wù','拐弯儿':' guǎi wān r','丑婆子':' chǒu pó zǐ','核子能':' hé zǐ néng','眼底下':' yǎn dǐ xia','节骨眼':' jiē gǔ yǎn','合得着':' hé de zháo','李隆基':' lǐ lōng jī','宿舍楼':' sù shè lóu','散腿裤':' sǎn tuǐ kù','厚薄规':' hòu bó guī','花骨朵':' huā gū duǒ','合不着':' hé bù zháo','鸡血石':' jī xiě shí','后处理':' hòu chǔ lǐ','冷负荷':' lěng fù hè','芝麻包':' zhī ma bāo','书馆儿':' shū guǎn r','结对子':' jié duì zǐ','近似解':' jìn sì jiě','万户侯':' wàn hù hòu','直发板':' zhí fà bǎn','四子王':' sì zǐ wáng','约维克':' yāo wéi kè','西洲曲':' xī zhōu qǔ','简帖儿':' jiǎn tiě r','坤角儿':' kūn jué ér','老莱子':' lǎo lái zǐ','红胡子':' hóng hú zǐ','博白县':' bó bái xiàn','累加器':' lěi jiā qì','曾祖母':' zēng zǔ mǔ','紫坪铺':' zǐ píng pū','兴安区':' xīng ān qū','迎头儿':' yíng tóu r','猪尾巴':' zhū wěi ba','处理品':' chǔ lǐ pǐn','子弟兵':' zǐ dì bīng','牡丹亭':' mǔ dan tíng','土著人':' tǔ zhù rén','懒骨头':' lǎn gǔ tou','粘糊糊':' nián hū hū','粘合机':' nián hé jī','柏辽兹':' bó liáo zī','脚丫子':' jiǎo yā zǐ','未处理':' wèi chǔ lǐ','犟劲儿':' jiàng jìn r','粘度计':' nián dù jì','爱好者':' ài hào zhě','不要紧':' bú yào jǐn','小弟弟':' xiǎo dì di','多任务':' duō rèn wu','外边儿':' wài bian r','较劲儿':' jiào jìn r','阿城区':' a chéng qū','知不道':' zhì bù dào','小娃娃':' xiǎo wá wa','薄伽丘':' bó jiā qīu','料头儿':' liào tóu r','小夜曲':' xiǎo yè qǔ','小伙儿':' xiǎo huǒ r','挂不住':' guà bú zhù','碌曲县':' lù qǔ xiàn','碎块儿':' suì kuài r','架不住':' jià bú zhù','吃不住':' chī bú zhù','大包干':' dà bāo gān','备不住':' bèi bú zhù','背不住':' bèi bú zhù','一溜烟':' yī liú yān','右边儿':' yòu bian r','催干剂':' cuī gān jì','不应期':' bù yìng qī','试手儿':' shì shǒu r','脑瓜子':' nǎo guā zǐ','背带裤':' bēi dài kù','吃得住':' chī de zhù','子模型':' zǐ mó xíng','大袋鼠':' dà dài shǔ','脑瓢儿':' nǎo piáo r','惹乱子':' rě luàn zǐ','鼻咽炎':' bí yān yán','跑神儿':' pǎo shén r','片子地':' piān zi dì','木头人':' mù tou rén','什叶派':' shí yè pài','药方儿':' yào fāng r','脑门子':' nǎo mén zǐ','刮舌子':' guā shé zǐ','小摊儿':' xiǎo tān r','史丹佛':' shǐ dān fó','大单于':' dà chán yú','身板儿':' shēn bǎn r','这下子':' zhè xià zǐ','皮桶子':' pí tǒng zǐ','脾切除':' pí qiē chú','经得起':' jīng de qǐ','女主角':' nǚ zhǔ jué','镚子儿':' bèng zǐ er','蹦高儿':' bèng gāo r','云头儿':' yún tou er','吃得来':' chī de lái','女人家':' nǚ rén jia','配给制':' pèi jǐ zhì','知识库':' zhī shi kù','配给品':' pèi jǐ pǐn','石榴子':' shí liu zǐ','介子推':' jiè zǐ tuī','看家戏':' kān jiā xì','小肚子':' xiǎo dǔ zi','石头记':' shí tou jì','派不是':' pài bú shì','排叉儿':' pái chà ér','鼻粘膜':' bí nián mó','捋袖子':' luō xìu zi','瓜子金':' guā zǐ jīn','莲都区':' lián dū qū','五斗柜':' wǔ dǒu guì','可的松':' kě dì sōng','挑头儿':' tiǎo tóu r','南蛮子':' nán mán zǐ','南瓜子':' nán guā zǐ','那些个':' nèi xiē gè','那么着':' nà me zhāo','愣劲儿':' lèng jìn r','小菜儿':' xiǎo cài r','对工儿':' duì gōng r','拉个手':' lā ge shǒu','小姑子':' xiǎo gū zǐ','犬夜叉':' quǎn yè chà','数不尽':' shù bu jìn','犯不着':' fàn bù zháo','一次性':' yí cì xìng','药师佛':' yào shī fó','拇指甲':' mǔ zhǐ jia','狗骨头':' gǒu gú tou','少不得':' shǎo bu dé','呼啦圈':' hū lā quān','排子车':' pǎi zǐ chē','出尖儿':' chū jiān r','小胡子':' xiǎo hú zǐ','走形儿':' zǒu xíng r','卷发器':' juǎn fà qì','笑呵呵':' xiào hē hē','趁早儿':' chèn zǎo r','高丽纸':' gāo lí zhǐ','名角儿':' míng jué r','处女作':' chǔ nǚ zuò','蒙古语':' měng gǔ yǔ','走样儿':' zǒu yàng r','起五更':' qǐ wǔ gēng','后发座':' hòu fà zuò','茶馆儿':' chá guǎn r','君子兰':' jūn zǐ lán','大咧咧':' dà liē liē','榛仁儿':' zhēn rén r','不尽根':' bù jìn gēn','空心儿':' kòng xīn r','克耶邦':' kè yē bāng','吧托女':' bā tuō nǔ:','不见得':' bú jiàn de','票友儿':' piào yǒu r','多得是':' duō de shì','花边儿':' huā biān r','音乐剧':' yīn yuè jù','脊髓炎':' jǐ suǐ yán','立合同':' lì hé tong','离子源':' lí zǐ yuán','走门子':' zǒu mén zǐ','逗闷子':' dòu mèn zǐ','离子能':' lí zǐ néng','瞎琢磨':' xiā zuó mo','乐都县':' lè dū xiàn','莱佛士':' lái fó shì','坊子区':' fāng zǐ qū','莫泊桑':' mò bó sāng','差错率':' chā cuò lǜ','孔夫子':' kǒng fū zǐ','大月氏':' dà ròu zhī','会计科':' kuài jì kē','理发馆':' lǐ fà guǎn','枪把儿':' qiāng bà r','阳离子':' yáng lí zǐ','榜葛剌':' bǎng gé là','会计课':' kuài jì kè','着色剂':' zhuó sè jì','坎肩儿':' kǎn jiān r','隐君子':' yǐn jūn zǐ','目的性':' mù dì xìng','吴堡县':' wú bǔ xiàn','大姐姐':' dà jiě jie','干旱土':' gān hàn tǔ','除不尽':' chú bù jìn','书记处':' shū ji chù','趵突泉':' bō tū quán','子公司':' zǐ gōng sī','斗门区':' dǒu mén qū','倒计时':' dǎo jì shí','有会子':' yǒu huì zǐ','大少爷':' dà shào yé','脏乎乎':' zāng hū hū','戳份儿':' chuō fèn r','窍门儿':' qiào mén r','亚粘土':' yà nián tǔ','药水儿':' yào shuǐ r','大不了':' dà bù liǎo','切割刀':' qiē gē dāo','超负荷':' chāo fù hè','栖霞市':' xī xiá shì','子午线':' zǐ wǔ xiàn','干燥炉':' gān zào lú','窝囊气':' wō nāng qì','瞧得起':' qiáo de qǐ','吃得开':' chī de kāi','大宛马':' dà yuān mǎ','切削力':' qiē xuē lì','君子国':' jūn zǐ guó','漂洗机':' piǎo xǐ jī','责任人':' zé rèn rén','质子数':' zhì zǐ shù','赔不是':' péi bú shì','脖颈儿':' bó gěng ér','吴兴区':' wú xīng qū','大家伙':' dà jiā huo','歌片儿':' gē piān er','捧角儿':' pěng jué r','柏青哥':' bó qīng gē','回弹力':' huí tán lì','血豆腐':' xiě dòu fǔ','干燥器':' gān zào qì','脯氨酸':' fǔ ān suān','散文家':' sǎn wén jiā','犯得着':' fàn de zháo','打哈欠':' dǎ hā qian','贺子珍':' hè zǐ zhēn','尿盆儿':' niào pén r','漂浮物':' piāo fú wù','子宫壁':' zǐ gōng bì','合同法':' hé tong fǎ','吃空额':' chī kòng é','红模子':' hóng mú zǐ','太子丹':' tài zǐ dān','氧分子':' yǎng fēn zǐ','贱骨头':' jiàn gú tou','番茄粉':' fān qié fěn','放包袱':' fàng bāo fú','书卷气':' shū juàn qì','几丁质':' jī dīng zhì','反应力':' fǎn yìng lì','反应炉':' fǎn yìng lú','反应器':' fǎn yìng qì','反应热':' fǎn yìng rè','反应物':' fǎn yìng wù','放印子':' fàng yìn zǐ','费工夫':' fèi gōng fu','曹不兴':' cáo bù xīng','变奏曲':' biàn zòu qǔ','分子病':' fēn zǐ bìng','分子键':' fēn zǐ jiàn','风荷载':' fēng hè zài','风流子':' fēng liú zǐ','姜子牙':' jiāng zǐ yá','音乐学':' yīn yuè xué','娘儿们':' niáng r men','李娃传':' lǐ wá zhuàn','着边儿':' zháo biān r','脊椎炎':' jǐ zhuī yán','蒙代尔':' mēng dài ěr','薄油层':' bó yóu céng','蒙古人':' měng gǔ rén','丰子恺':' fēng zǐ kǎi','差异性':' chā yì xìng','蔡甸区':' cài diàn qū','讲义气':' jiǎng yì qi','区字框':' qū zì kuàng','逆反应':' nì fǎn yìng','动载荷':' dòng zài hè','洞子货':' dòng zǐ huò','弹射出':' tán shè chū','豆腐羹':' dòu fu gēng','烫头发':' tàng tóu fa','已更新':' yǐ gēng xīn','翻斗车':' fān dǒu chē','要不了':' yào bù liǎo','舍身崖':' shè shēn yá','烂舌头':' làn shé tou','佛香阁':' fó xiāng gé','变样儿':' biàn yàng r','半吊子':' bàn diào zǐ','贾平凹':' jiǎ píng wā','资兴市':' zī xīng shì','佛光寺':' fó guāng sì','曾孙女':' zēng sūn nǚ','买东西':' mǎi dōng xi','佛手柑':' fó shǒu gān','爪哇国':' zhǎo wā guó','卖关子':' mài guān zǐ','猪仔包':' zhū zǎi bāo','副反应':' fù fǎn yìng','燕歌行':' yān gē xíng','变速杆':' biàn sù gǎn','蒙古包':' měng gǔ bāo','祭司长':' jì sī cháng','迷惑龙':' mí huo lóng','与会者':' yù huì zhě','痱子粉':' fèi zǐ fěn','佛蒙特':' fó méng tè','脊柱炎':' jǐ zhù yán','佛甲草':' fó jiǎ cǎo','包干儿':' bāo gān ér','南边儿':' nán bian r','娃娃兵':' wá wa bīng','忍得住':' rěn de zhù','包园儿':' bāo yuán r','佛出世':' fó chū shì','南海子':' nán hǎi zǐ','龈辅音':' yín fǔ yīn','黏糊糊':' nián hū hū','会厌炎':' huì yàn yán','摸不着':' mō bù zháo','快板儿':' kuài bǎn r','捎马子':' shāo mǎ zǐ','小苏打':' xiǎo sū dá','黑芝麻':' hēi zhī ma','负电子':' fù diàn zǐ','分子论':' fēn zǐ lùn','与会国':' yù huì guó','倒好儿':' dǎo hǎo ér','北边儿':' běi biān r','协奏曲':' xié zòu qǔ','新乐府':' xīn yuè fǔ','北碚区':' běi bèi qū','腿腕子':' tuǐ wàn zǐ','佛法僧':' fó fǎ sēng','草垫子':' cǎo diàn zǐ','薄烤饼':' bó kǎo bǐng','蒙古国':' měng gǔ guó','协调器':' xié tiáo qì','好事者':' hào shì zhě','修指甲':' xīu zhǐ jia','坏分子':' huài fèn zǐ','激将法':' jī jiàng fǎ','茄红素':' qié hóng sù','活塞杆':' huó sāi gǎn','架秧子':' jià yāng zǐ','娃娃生':' wá wa shēng','箭垛子':' jiàn duò zi','好家伙':' hǎo jiā huo','音乐家':' yīn yuè jiā','和面机':' huó miàn jī','负电荷':' fù diàn hè','子囊菌':' zǐ náng jūn','子程序':' zǐ chéng xù','华龙区':' huà lóng qū','兴凯湖':' xīng kǎi hú','剪切机':' jiǎn qiē jī','直贡呢':' zhí gòng ní','苦差事':' kǔ chāi shì','知识化':' zhī shi huà','俱舍宗':' jù shè zōng','回旋曲':' huí xuán qǔ','妃子笑':' fēi zǐ xiào','禁得住':' jīn de zhù','娃娃脸':' wá wa liǎn','这些个':' zhèi xiē gè','这么着':' zhè me zhāo','近似值':' jìn sì zhí','家雀儿':' jiā qiǎo ér','切换阀':' qiē huàn fá','小舅子':' xiǎo jiù zǐ','谐振子':' xié zhèn zǐ','室内乐':' shì nèi yuè','螺丝钻':' luó sī zuàn','蜚蠊科':' fěi lián kē','会计师':' kuài jì shī','蛋白石':' dàn bái shí','蚌埠市':' bèng bù shì','月氏人':' yuè zhī rén','间歇热':' jiàn xiē rè','翻筋斗':' fān jīn dǒu','处女航':' chǔ nǚ háng','认识论':' rèn shi lùn','宜兴市':' yí xīng shì','寒山子':' hán shān zǐ','虎爪派':' hǔ zhuǎ pài','宅度假':' zhái dù jià','烘干器':' hōng gān qì','不要脸':' bú yào liǎn','藏族人':' zàng zú rén','寒暑假':' hán shǔ jià','花点子':' huā diǎn zǐ','脱壳机':' tuō qiào jī','歪点子':' wāi diǎn zǐ','血淋淋':' xiě lín lín','顾颉刚':' gù xié gāng','干燥窑':' gān zào yáo','干燥室':' gān zào shì','旋木雀':' xuàn mù què','工尺谱':' gōng chě pǔ','会计学':' kuài jì xué','供佛花':' gòng fó huā','干扰者':' gān rǎo zhě','角斗士':' jué dòu shì','供给制':' gōng jǐ zhì','供给者':' gōng jǐ zhě','氟中毒':' fú zhòng dú','解痉剂':' xiè jìng jì','调酒器':' tiáo jǐu qì','眼不见':' yǎn bú jiàn','差一点':' chà yì diǎn','调色板':' tiáo sè bǎn','调节器':' tiáo jié qì','有时候':' yǒu shí hou','高挑儿':' gāo tiǎo ér','尥蹶子':' liào jué zǐ','尹潽善':' yǐn pǔ shàn','工夫茶':' gōng fu chá','钢琴曲':' gāng qín qǔ','干洗店':' gān xǐ diàn','感应力':' gǎn yìng lì','说不出':' shuō bu chū','屎壳郎':' shǐ ke làng','月收入':' yuè shōu rù','月子病':' yuè zǐ bìng','感应炉':' gǎn yìng lú','调味剂':' tiáo wèi jì','调制波':' tiáo zhì bō','被没收':' bèi mò shōu','小插曲':' xiǎo chā qǔ','动荷载':' dòng hè zài','参宿七':' shēn xìu qī','甚至于':' shèn zhì yú','原子论':' yuán zǐ lùn','厦门市':' xià mén shì','独唱曲':' dú chàng qǔ','更衣室':' gēng yī shì','热轧钢':' rè zhá gāng','耳咽管':' ěr yān guǎn','较真儿':' jiào zhēn r','软耳朵':' ruǎn ěr duo','军乐队':' jūn yuè duì','甲壳素':' jiǎ qiào sù','佛山市':' fó shān shì','轧钢机':' zhá gāng jī','弓弦儿':' gōng xián r','辣椒仔':' là jiāo zǎi','都察院':' dū chá yuàn','佛手瓜':' fó shǒu guā','原子堆':' yuán zǐ duī','留成儿':' líu chéng r','弹球盘':' tán qíu pán','狗仔队':' gǒu zǎi duì','逼供信':' bī gòng xìn','进行曲':' jìn xíng qǔ','锭子油':' dìng zǐ yóu','曲靖市':' qǔ jìng shì','动干戈':' dòng gān gē','冬瓜子':' dōng guā zǐ','一边倒':' yī biān dǎo','何应钦':' hé yìng qīn','西门町':' xī mén dīng','玄菟郡':' xuán tù jùn','西藏人':' xī zàng rén','西塞山':' xī sài shān','补给船':' bǔ jǐ chuán','刮削器':' guā xiāo qì','管扳子':' guǎn bān zǐ','过家伙':' guō jiā huo','不适当':' bù shì dàng','松巴哇':' sōng bā wā','尉迟恭':' yù chí gōng','鬼点子':' guǐ diǎn zǐ','畜牧场':' xù mù chǎng','软骨头':' ruǎn gú tou','独生子':' dú shēng zǐ','印子钱':' yìn zǐ qián','转矩臂':' zhuàn jǔ bì','瓦岗军':' wǎ gāng jūn','脱不了':' tuō bù liǎo','过得硬':' guò de yìng','差旅费':' chāi lǚ fèi','复兴社':' fù xīng shè','瓜子脸':' guā zǐ liǎn','人造草':' rén zào cǎo','虎跑泉':' hǔ páo quán','耳光子':' ěr guāng zǐ','伽罗华':' jiā luó huà','弦乐器':' xián yuè qì','人影儿':' rén yǐng ér','原子弹':' yuán zǐ dàn','脊索瘤':' jǐ suǒ liú','龈擦音':' yín cā yīn','肋膜炎':' lèi mó yán','高句丽':' gāo gōu lí','箭靶子':' jiàn bǎ zǐ','奇函数':' jī hán shù','水磨机':' shuǐ mò jī','奇偶性':' jī ǒu xìng','人尖儿':' rén jiān r','体己钱':' tī ji qián','打擂台':' dǎ lèi tái','牛肉干':' niú ròu gān','药引子':' yào yǐn zǐ','夹尾巴':' jiā wěi ba','高勾丽':' gāo gōu lí','贾似道':' jiǎ sì dào','伏都教':' fú dū jiào','脏兮兮':' zāng xī xī','夹当儿':' jiā dāng r','摇篮曲':' yáo lán qǔ','铜子儿':' tóng zǐ er','童子鸡':' tóng zǐ jī','节假日':' jié jià rì','佛得角':' fó dé jiǎo','数一数':' shǔ yī shù','小妮子':' xiǎo nī zǐ','大堡礁':' dà pù jiāo','干扰机':' gān rǎo jī','汉乐府':' hàn yuè fǔ','不到家':' bú dào jiā','伪君子':' wěi jūn zǐ','鱼秧子':' yú yāng zǐ','剃发令':' tì fà lìng','毛丫头':' máo yā tou','佛朗哥':' fó lǎng gē','小姨子':' xiǎo yí zǐ','斗地主':' dòu dì zhǔ','年头儿':' nián tóu r','年画儿':' nián huà r','鬼故事':' guǐ gù shi','佛教徒':' fó jiào tú','佛教语':' fó jiào yǔ','平埔族':' píng pǔ zú','打跟头':' dǎ gēn tou','狗仔式':' gǒu zǎi shì','使君子':' shǐ jūn zǐ','鲁子敬':' lǔ zǐ jìng','洋码子':' yáng mǎ zǐ','一般般':' yì bān bān','保得住':' bǎo de zhù','世家子':' shì jiā zǐ','再处理':' zài chǔ lǐ','玉米粥':' yù mǐ zhōu','是非题':' shì fēi tí','使绊子':' shǐ bàn zǐ','捞什子':' lāo shí zi','干扰素':' gān rǎo sù','得样儿':' de yàng ér','复兴区':' fù xīng qū','高分子':' gāo fèn zǐ','延误费':' yán wu fèi','卸载器':' xiè zǎi qì','亚原子':' yà yuán zǐ','乔答摩':' qiáo dā mó','倒座儿':' dǎo zuò ér','傍家儿':' bàng jiā r','五斗橱':' wǔ dǒu chú','压轴戏':' yā zhòu xì','喀什市':' kā shí shì','慢累积':' màn lěi jī','尉犁县':' yù lí xiàn','喇叭形':' lǎ ba xíng','喝倒彩':' hè dào cǎi','子系统':' zǐ xì tǒng','牡丹坊':' mǔ dan fāng','吹胡子':' chuī hú zǐ','闷子车':' mèn zǐ chē','闷头儿':' mèn tou er','懂门儿':' dǒng mén r','薄荷醇':' bò he chún','指事字':' zhǐ shì zì','无名子':' wú míng zǐ','傀儡戏':' kuǐ lěi xì','煤砟子':' méi zhǎ zǐ','煤烟子':' méi yān zǐ','武曲星':' wǔ qǔ xīng','六君子':' liù jūn zǐ','目的港':' mù dì gǎng','菜子油':' cài zǐ yóu','塞尔南':' sài ěr nán','泪人儿':' lèi rén ér','拖尾巴':' tuō wěi ba','线坯子':' xiàn pī zǐ','薄荷糖':' bò he táng','脖颈子':' bó gěng zi','补给线':' bú jǐ xiàn','好得很':' hǎo de hěn','果子酒':' guǒ zǐ jiǔ','马钱子':' mǎ qián zǐ','应答器':' yìng dá qì','拉大便':' là dà biàn','罗刹女':' luó chà nǚ','啃骨头':' kěn gú tou','煤黑子':' méi hēi zǐ','乱麻麻':' luàn mā mɑ','行业语':' háng yè yǔ','戏馆子':' xì guǎn zǐ','好得多':' hǎo de duō','喜剧片':' xǐ jù piān','出主意':' chū zhǔ yi','锄头雨':' chú tou yǔ','坏包儿':' huài bāo r','察合台':' chá gě tái','出门子':' chū mén zǐ','不是事':' bú shì shì','戏园子':' xì yuán zǐ','卜算子':' bǔ suàn zǐ','踝子骨':' huái zǐ gǔ','六环路':' lìu huán lù','拿不动':' ná bu dòng','溜溜儿':' liū liù ér','喉塞音':' hóu sè yīn','误差值':' wù chā zhí','对对子':' duì duì zǐ','对不住':' duì bú zhù','接头儿':' jiē tou er','反弹力':' fǎn tán lì','扩散剂':' kuò sǎn jì','八斗才':' bā dǒu cái','油炸机':' yóu zhá jī','小曲儿':' xiǎo qǔ ér','乳杆菌':' rǔ gǎn jūn','肉丸子':' ròu wán zǐ','印古什':' yìn gǔ shí','安公子':' ān gōng zǐ','抄靶子':' chāo bǎ zǐ','瓦楞子':' wǎ léng zǐ','卷地皮':' juàn dì pí','卸肩儿':' xiè jiān r','烟贩子':' yān fàn zǐ','作曲家':' zuò qǔ jiā','怪物似':' guài wù sì','京都府':' jīng dū fǔ','大轴戏':' dà zhòu xì','大舌头':' dà shé tou','原子核':' yuán zǐ hé','烟斗丝':' yān dǒu sī','任务书':' rèn wu shū','原子笔':' yuán zǐ bǐ','大兴区':' dà xīng qū','寻开心':' xín kāi xīn','人贩子':' rén fàn zǐ','认不是':' rèn bú shì','附着力':' fù zhuó lì','热应力':' rè yìng lì','找碴儿':' zhǎo chá r','房牙子':' fáng yá zǐ','干涉仪':' gān shè yí','大氧吧':' dà yǎng bā','了不起':' liǎo bù qǐ','托门子':' tuō mén zǐ','压轴子':' yā zhòu zǐ','摆阔气':' bǎi kuò qi','曲艺团':' qǔ yì tuán','参与者':' cān yù zhě','曲射炮':' qǔ shè pào','小女子':' xiǎo nǚ zǐ','担不是':' dān bú shì','有为法':' yǒu wéi fǎ','八爪鱼':' bā zhuǎ yú','接泊车':' jiē bó chē','掰腕子':' bāi wàn zǐ','戴假发':' dài jiǎ fà','作曲者':' zuò qǔ zhě','左边儿':' zuǒ bian r','反面儿':' fǎn miàn r','父子兵':' fù zǐ bīng','氢离子':' qīng lí zǐ','二愣子':' èr lèng zǐ','左撇子':' zuǒ piě zǐ','大轴子':' dà zhòu zǐ','古惑仔':' gǔ huò zǎi','拌和机':' bàn huò jī','干酪素':' gān lào sù','窃以为':' qiè yǐ wéi','干妹子':' gàn mèi zǐ','夫子庙':' fū zǐ miào','佛朗机':' fó lǎng jī','伛偻病':' yú lǚ bìng','德都县':' dé dū xiàn','乐府诗':' yuè fǔ shī','出月子':' chū yuè zǐ','女公子':' nǚ gōng zǐ','爵士乐':' jué shì yuè','调压器':' tiáo yā qì','出漏子':' chū lòu zǐ','吃得下':' chī de xià','片儿警':' piàn r jǐng','顺嘴儿':' shùn zuǐ r','掷骰子':' zhì tóu zǐ','预应力':' yù yìng lì','调速器':' tiáo sù qì','调色剂':' tiáo sè jì','头脸儿':' tóu liǎn r','分子式':' fèn zǐ shì','后边儿':' hòu bian r','弹拨乐':' tán bō yuè','调和漆':' tiáo hé qī','卸担子':' xiè dàn zi','汤婆子':' tāng pó zǐ','善男子':' shàn nán zǐ','择日子':' zhái rì zi','人为土':' rén wéi tǔ','弹子锁':' dàn zǐ suǒ','四公子':' sì gōng zǐ','好奇心':' hào qí xīn','盐坨子':' yán tuó zǐ','出岔子':' chū chà zǐ','堆垛机':' duī duò jī','饭馆儿':' fàn guǎn r','马尾辫':' mǎ yǐ biàn','弹花机':' tán huā jī','电驴子':' diàn lǘ zǐ','套马杆':' tào mǎ gǎn','套衫儿':' tào shān r','伽罗瓦':' jiā luó wà','干燥剂':' gān zào jì','干燥机':' gān zào jī','独不见':' dú bú jiàn','划不来':' huá bù lái','电喇叭':' diàn lǎ ba','奔头儿':' bèn tou er','马尾松':' mǎ yǐ sōng','打不通':' dǎ bu tōng','铜离子':' tóng lí zǐ','弹射器':' tán shè qì','爪哇岛':' zhǎo wā dǎo','划得来':' huá de lái','梭子蟹':' suō zǐ xiè','度假村':' dù jià cūn','锁子甲':' suǒ zǐ jiǎ','碎嘴子':' suì zuǐ zǐ','随大溜':' suí dà liù','度假者':' dù jià zhě','杜松子':' dù sōng zǐ','打呵欠':' dǎ hē qiàn','叫哥哥':' jiào gē ge','刨笔刀':' bào bǐ dāo','徐熙媛':' xú xī yuán','不失为':' bù shī wéi','打顿儿':' dǎ dùn r','葛法翁':' gě fǎ wēng','阿加维':' a jiā wéi','阿莱曼':' a lái màn','批处理':' pī chǔ lǐ','阿荣旗':' a róng qí','马勃菌':' mǎ bó jùn','发小儿':' fà xiǎo r','五味子':' wǔ wèi zǐ','开花儿':' kāi huā r','开都河':' kāi dū hé','鱼丸子':' yú wán zǐ','挨头子':' ái tóu zi','挨边儿':' āi biān r','挨板子':' ái bǎn zi','晕乎乎':' yùn hū hū','一下子':' yī xià zǐ','拨子弹':' bō zǐ tán','薄荷脑':' bò he nǎo','柏林寺':' bó lín sì','挎兜儿':' kuà dōu r','零杂儿':' líng zá r','颚龈音':' è yín yīn','阿伯丁':' a bó dīng','折刀儿':' zhé dāo r','鼻咽部':' bí yān bù','盐都区':' yán dū qū','拆烂污':' cā làn wū','阿曼湾':' a màn wān','背搭子':' bèi dā zǐ','折过儿':' zhē guò r','鱼肚白':' yú dǔ bái','二里头':' er lǐ tou','阿瑟镇':' a sè zhèn','剥皮机':' bāo pí jī','阿瑟县':' a sè xiàn','抱娃娃':' bào wá wa','阿尔山':' a ěr shān','阿洛菲':' a luò fēi','不自禁':' bù zì jīn','撒切尔':' sā qiē ěr','阿里郎':' a lǐ láng','鹍鸡曲':' kūn jī qǔ','扬子鳄':' yáng zǐ è','麦盖提':' mài gě tí','扳本儿':' bān běn r','丽佳娜':' lí jiā nà','阿兰文':' a lán wén','阿苏山':' a sū shān','找刺儿':' zhǎo cì r','杂件儿':' zá jiàn r','阿育王':' ā yù wáng','在那里':' zài nà li','挂钩儿':' guà gōu r','笔头儿':' bǐ tou er','不舍得':' bù shě de','二流子':' èr liú zǐ','希腊语':' xī là yǔ','预处理':' yù chǔ lǐ','安魂曲':' ān hún qǔ','斯宾塞':' sī bīn sè','暗楼子':' àn lóu zǐ','扑脸儿':' pū liǎn r','岔曲儿':' chà qǔ er','熬不住':' áo bú zhù','鼻咽癌':' bí yān ái','齐柏林':' qí bó lín','玻色子':' bō sè zǐ','虚粒子':' xū lì zǐ','玩艺儿':' wán yì r','核子力':' hé zǐ lì','拉勾儿':' lā gòu r','闭子集':' bì zǐ jí','密麻麻':' mì mā mɑ','马服子':' mǎ fú zǐ','蜡坨儿':' là tuó r','布娃娃':' bù wá wa','炮儿局':' pào r jú','子集合':' zǐ jí hé','撒播机':' sǎ bō jī','斯坦佛':' sī tǎn fó','阴离子':' yīn lí zǐ','魏都区':' wèi dū qū','阿多诺':' a duō nuò','门坎儿':' mén kǎn r','阿斯旺':' a sī wàng','拜把子':' bài bà zi','马塞卢':' mǎ sài lú','散座儿':' sǎn zuò r','阿拉善':' a lā shàn','亚曼牙':' yà màn yá','阿坝县':' a bà xiàn','马赛曲':' mǎ sài qǔ','阿坝州':' a bà zhōu','笔杆儿':' bǐ gǎn ér','阿拉丁':' a lā dīng','黑糊糊':' hēi hū hū','捋胳膊':' luō gē bo','马约卡':' mǎ yāo kǎ','捋虎须':' luō hǔ xū','抓子儿':' zhuā zǐ r','新都区':' xīn dū qū','余甘子':' yú gān zǐ','龈颚音':' yín è yīn','龈腭音':' yín è yīn','暗门子':' àn mén zǐ','熬头儿':' áo tou er','折子戏':' zhé zǐ xì','干巴巴':' gān bā bā','阿的平':' ā dì píng','半拉子':' bàn lǎ zǐ','武都区':' wǔ dū qū','喀喇沁':' kā lā qìn','枸杞子':' gǒu qǐ zǐ','臭子儿':' chòu zǐ r','金娃娃':' jīn wá wa','不在乎':' bù zài hu','果子露':' guǒ zǐ lù','太仆寺':' tài pú sì','金缕曲':' jīn lǚ qǔ','果子狸':' guǒ zǐ lí','福安市':' fú ān shì','镁离子':' měi lí zǐ','啦啦队':' lā lā duì','第四台':' dì sì tái','柏克郡':' bó kè jùn','笔杆子':' bǐ gǎn zi','乌拉草':' wù lɑ cǎo','杰佛兹':' jié fó zī','门弟子':' mén dì zǐ','煤核儿':' méi hú ér','启发式':' qǐ fà shì','三部曲':' sān bù qǔ','粒子束':' lì zǐ shù','单子叶':' dān zǐ yè','粒子流':' lì zǐ liú','满负荷':' mǎn fù hè','不含糊':' bù hán hu','大都会':' dà dū huì','买得起':' mǎi de qǐ','舍利子':' shè lì zǐ','耳刮子':' ěr guā zǐ','墨水儿':' mò shuǐ r','压不碎':' yā bu suì','耶和华':' yē hé huá','大文蛤':' dà wén gé','老婆子':' lǎo pó zǐ','芋头色':' yù tou sè','夹塞儿':' jiā sāi r','枕席儿':' zhěn xí r','夹肢窝':' gā zhī wō','舍利塔':' shè lì tǎ','不安分':' bù ān fèn','大都市':' dà dū shì','奇蹄类':' jī tí lèi','芥子气':' jiè zǐ qì','血糊糊':' xiě hū hū','花都区':' huā dū qū','奴儿干':' nú ér gān','果仁儿':' guǒ rén r','旧衣服':' jiù yī fu','大舅子':' dà jiù zǐ','酒嗉子':' jiǔ sù zǐ','临月儿':' lín yuè r','大袋子':' dà dài zi','大部分':' dà bù fèn','做伴儿':' zuò bàn r','马扎子':' mǎ zhá zǐ','阿罗约':' a luó yuē','戏报子':' xì bào zǐ','类似物':' lèi sì wù','借单儿':' jiè dān r','羞答答':' xiū dā dā','尧都区':' yáo dū qū','麻麻黑':' mā mɑ hēi','纹缕儿':' wén lǔ: r','麻雷子':' má léi zǐ','码垛机':' mǎ duò jī','梅西耶':' méi xī yē','哗啦啦':' huā lā lā','洗发膏':' xǐ fà gāo','罗锅儿':' luó guō r','嘴巴子':' zuǐ ba zi','红箍儿':' hóng gū r','纳匝肋':' nà zā lèi','稀释液':' xī shì yè','路倒儿':' lù dǎo er','喷嘴儿':' pēn zuǐ r','刘阿斗':' liú ā dǒu','绝门儿':' jué mén r','哈巴狗':' hǎ bā gǒu','撒拉铁':' sǎ lā tiě','百子图':' bǎi zǐ tú','类似于':' lèi sì yú','继子女':' jì zǐ nǔ:','抹不开':' mò bù kāi','一部分':' yī bù fen','五斗米':' wǔ dǒu mǐ','马尾藻':' mǎ yǐ zǎo','五倍子':' wǔ bèi zǐ','哥特式':' gē tè shì','闹肚子':' nào dǔ zi','秦都区':' qín dū qū','南歌子':' nán gē zǐ','哪门子':' nǎ mén zǐ','拿不住':' ná bú zhù','目的论':' mù dì lùn','抹得开':' mò de kāi','傻帽儿':' shǎ mào r','地窨子':' dì yìn zǐ','五大夫':' wǔ dài fū','磨粉机':' mò fěn jī','窝里反':' wō li fǎn','窝里斗':' wō li dòu','墨斗鱼':' mò dǒu yú','马奶子':' mǎ nǎi zǐ','老爷子':' lǎo yé zǐ','回单儿':' huí dān r','诸葛弩':' zhū gě nǔ','离子束':' lí zǐ shù','离子流':' lí zǐ liú','在一起':' zài yì qǐ','骨碌碌':' gū lù lù','薄一波':' bó yī bō','下一个':' xià yī ge','迂夫子':' yū fū zǐ','大剌剌':' dà là là','柏柏尔':' bò bò ěr','大肚子':' dà dǔ zi','自个儿':' zì gě ér','阿布贾':' a bù jiǎ','胡琴儿':' hú qín r','斗趣儿':' dòu qù r','夜盆儿':' yè pén r','可劲儿':' kě jìn r','遗腹子':' yí fù zǐ','一肚子':' yī dǔ zi','大苏打':' dà sū dá','大姨子':' dà yí zǐ','头箍儿':' tóu gū r','没谱儿':' méi pǔ r','大衣呢':' dà yī ní','刺儿话':' cì r huà','法耶德':' fǎ yē dé','洗发露':' xǐ fà lù','渔钩儿':' yú gōu r','地肤子':' dì fū zǐ','顾不得':' gù bu de','恶名儿':' è míng r','爱玉子':' ài yù zǐ','阿奎纳':' a kuí nà','阿图什':' a tú shí','惹不起':' rě bu qǐ','鸡子儿':' jī zǐ er','子午仪':' zǐ wǔ yí','奥米伽':' ào mǐ gā','苦不唧':' kǔ bu jī','苦活儿':' kǔ huó r','杜笃玛':' dù dǔ mǎ','畜牧业':' xù mù yè','不拉几':' bù lā jī','鼻洼子':' bí wā zǐ','柏拉图':' bó lā tú','塞席尔':' sè xí ěr','阿斯兰':' a sī lán','阿瑞斯':' a ruì sī','阿尔泰':' a ěr tài','目的地':' mù dì dì','耳挖子':' ěr wā zǐ','耶利米':' yē lì mǐ','耶弗他':' yē fú tā','阿森纳':' a sēn nà','阿森斯':' a sēn sī','老客儿':' lǎo kè r','吉娃娃':' jí wá wa','合辙儿':' hé zhé r','鱼钩儿':' yú gōu r','洗发乳':' xǐ fà rǔ','欧米伽':' ōu mǐ gā','一拨儿':' yī bō r','挨呲儿':' ái cī r','阿卡提':' a kǎ dī','阿克拉':' a kè lā','公因子':' gōng yīn zǐ','阿克苏':' a kè sū','阿巴斯':' a bā sī','阿伊努':' a yī nǔ','阿姆河':' a mǔ hé','八哥儿':' bā gē r','阿合奇':' a hé qí','阿萨姆':' a sà mǔ','自各儿':' zì gě r','阿拉尔':' a lā ěr','阿堵物':' ē dǔ wù','阿萨德':' a sà dé','阿衣奴':' a yī nǔ','阿玛尼':' a mǎ ní','大气儿':' dà qì r','阿鲁巴':' a lǔ bā','窝脖儿':' wō bó r','阿卢巴':' a lú bā','阿瓦提':' a wǎ tí','塔塔儿':' tǎ tǎ r','阿皮亚':' a pí yà','阿爸父':' a bà fù','阿拉瓦':' a lā wǎ','阿物儿':' ā wù r','洗发剂':' xǐ fà jì','伺服器':' sì fú qì','大姑子':' dà gū zǐ','扒头儿':' bā tou r','凹朴皮':' āo pò pí','那话儿':' nà huà r','刺儿李':' cì r lǐ','伊妹儿':' yī mèi r','几乎不':' jī hū bù','伍子胥':' wǔ zǐ xū','河西堡':' hé xī pù','邷么儿':' wǎ mó r','打屁股':' dǎ pì gu','扎鲁特':' zā lǔ tè','打趸儿':' dǎ dǔn r','一路哭':' yí lù kū','阿拉摩':' a lā mó','阿拉斯':' a lā sī','阿拉伯':' a lā bó','阿希姆':' a xī mǔ','阿提拉':' a tí lā','阿法尔':' a fǎ ěr','瓦都兹':' wǎ dū zī','热负荷':' rè fù hè','孤立子':' gū lì zǐ','纸马儿':' zhǐ mǎ r','拉肚子':' lā dǔ zi','贝壳儿':' bèi ké r','努嘴儿':' nǔ zuǐ r','孤哀子':' gū āi zǐ','热剌剌':' rè là là','娃娃鱼':' wá wa yú','姑爷爷':' gū yé ye','被窝儿':' bèi wō r','鼓子词':' gǔ zǐ cí','西耶那':' xī yē nà','努劲儿':' nǔ jìn r','提头儿':' tí tóu r','衣钩儿':' yī gōu r','破衣服':' pò yī fu','阿贝尔':' a bèi ěr','西子湖':' xī zǐ hú','提篮儿':' tí lán r','菩提子':' pú tí zǐ','呕吐物':' ǒu tù wù','氯离子':' lǜ lí zǐ','子不语':' zǐ bù yǔ','阿阇梨':' ā shé lí','嘎拉哈':' gā lā hà','阿閦佛':' a chù fó','负离子':' fù lí zǐ','佛骨塔':' fó gǔ tǎ','纹丝儿':' wén sī r','一对儿':' yī duì r','卡哇伊':' kǎ wā yī','子目录':' zǐ mù lù','六合区':' lù hé qū','不答理':' bù dā lǐ','书皮儿':' shū pí r','个头儿':' gè tóu r','子夜歌':' zǐ yè gē','帽箍儿':' mào gū r','葫芦科':' hú lu kē','赋格曲':' fù gé qǔ','歌曲集':' gē qǔ jí','比特币':' bǐ tè bì','护发素':' hù fà sù','护发乳':' hù fà rǔ','讨底儿':' tǎo dǐ r','尼泊尔':' ní bó ěr','屁眼儿':' pì yǎn r','替班儿':' tì bān r','咖喱鸡':' gā lí jī','替角儿':' tì jué r','土木堡':' tǔ mù pù','拉撒路':' lā sǎ lù','媳妇子':' xí fù zǐ','阿兰若':' ā lán rě','菟丝子':' tù sī zi','阿克陶':' a kè táo','箍节儿':' gū jie r','呼啦啦':' hū lā lā','阿马逊':' a mǎ xùn','雅尔塔':' yá ěr tǎ','笆篱子':' bā lí zǐ','阿阇黎':' ā shé lí','搭茬儿':' dā chá r','竹箍儿':' zhú gū r','栖息地':' qī xī dì','阿维拉':' a wéi lā','阿凡提':' a fán tí','阿克伦':' a kè lún','哥德堡':' gē dé pù','奇蹄目':' jī tí mù','阿依莎':' a yī shā','阿凡达':' a fán dá','奥塞梯':' aò sè tī','痰盂儿':' tán yú r','阿勒泰':' a lè tài','五子棋':' wǔ zǐ qí','阿初佛':' a chū fó','阿伊莎':' a yī shā','古希腊':' gǔ xī là','莫伯日':' mò bó rì','模糊集':' mó hu jí','哥们儿':' gē men r','马褡子':' mǎ dā zǐ','阿盖达':' a gài dá','土坎儿':' tǔ kǎn r','格子呢':' gé zi ní','离子膜':' lí zǐ mó','在那儿':' zài na r','锂离子':' lǐ lí zǐ','杂牌儿':' zá pái r','鸭子儿':' yā zǐ er','阿肯色':' a kěn sè','阿美族':' a měi zú','撒丫子':' sā yā zǐ','克耶族':' kè yē zú','四部曲':' sì bù qǔ','泥娃娃':' ní wá wa','克蕾儿':' kè lěi r','借字儿':' jiè zì r','阿赖耶':' ā lài yē','卧佛寺':' wò fó sì','钠离子':' nà lí zǐ','拿得起':' ná de qǐ','武把子':' wǔ bà zi','哪一个':' nǎ yī ge','乐呵呵':' lè hē hē','渔歌子':' yú gē zǐ','哈喇子':' hā lǎ zǐ','哈巴河':' hā bā hé','耙耳朵':' pā ěr duo','捆扎机':' kǔn zā jī','不均匀':' bù jūn yún','白芝麻':' bái zhī ma','云浮市':' yún fú shì','洋娃娃':' yáng wá wa','靠不住':' kào bú zhù','避难所':' bì nàn suǒ','干梅子':' gān méi zi','男子汉':' nán zǐ hàn','遇难者':' yù nàn zhě','子宫癌':' zǐ gōng ái','韩非子':' hán fēi zǐ','欧巴桑':' ōu ba sāng','靠得住':' kào de zhù','过得去':' guò děi qù','洗发水':' xǐ fà shuǐ','木子美':' mù zǐ měi','补给品':' bǔ jǐ pǐn','干儿子':' gān ér zi','续随子':' xù suí zǐ','对心儿':' duì xīn r','鸡内金':' jī nà jīn','打旋儿':' dǎ xuán r','打短儿':' dǎ duǎn r','对得起':' duì de qǐ','虚套子':' xū tào zǐ','波隆那':' bō lōng nà','雪佛莱':' xuě fó lái','对味儿':' duì wèi r','瘾君子':' yǐn jūn zǐ','牙龈炎':' yá yín yán','子午莲':' zǐ wǔ lián','一刀切':' yī dāo qiē','每个人':' měi ge rén','登徒子':' dēng tú zǐ','昆都仑':' kūn dū lún','洋画儿':' yáng huà r','没空儿':' méi kòng r','遛弯儿':' liù wān ér','做头发':' zuò tóu fà','革吉县':' gé jí xiàn','雪佛兰':' xuě fó lán','电子伏':' diàn zǐ fú','的士高':' dí shì gāo','河曲县':' hé qǔ xiàn','曲沃县':' qǔ wò xiàn','过不下':' guò bu xià','乐谱架':' yuè pǔ jià','日月晕':' rì yuè yùn','没准儿':' méi zhǔn r','白干儿':' bái gān ér','做什么':' zuò shí mǒ','白切鸡':' bái qiē jī','泊头市':' bó tóu shì','法隆寺':' fǎ lōng sì','对劲儿':' duì jìn r','针箍儿':' zhēn gū r','钓钩儿':' diào gōu r','处女膜':' chǔ nǚ mó','话把儿':' huà bà er','薄荷油':' bò he yóu','薄熙来':' bó xī lái','葛缕子':' gě lǔ: zi','积累率':' jī lěi lǜ','处理器':' chǔ lǐ qì','娃娃菜':' wá wa cài','打嘴巴':' dǎ zuǐ ba','娃娃车':' wá wa chē','扣眼儿':' kòu yǎn r','宜都市':' yí dū shì','早班儿':' zǎo bān r','狐媚子':' hú mèi zǐ','戳个儿':' chuō gè r','打不过':' dǎ bu guò','活局子':' huó jú zǐ','不由得':' bù yóu de','铁钩儿':' tiě gōu r','娃娃亲':' wá wa qīn','打摆子':' dǎ bǎi zǐ','跟屁股':' gēn pì gu','一路人':' yí lù rén','一路货':' yí lù huò','一溜儿':' yī liù ér','华达呢':' huá dá ní','俄勒冈':' e lè gāng','畜牧学':' xù mù xué','安德肋':' an dé lèi','蜗杆副':' wō gǎn fù','宝贝儿':' bǎo bèi r','宝葫芦':' bǎo hú lu','细伢子':' xì yá zǐ','野孩子':' yě hái zǐ','处女地':' chǔ nǚ dì','过去佛':' guò qù fó','哈什蚂':' ha shi mà','宝坻区':' bǎo dǐ qū','打把式':' dǎ bǎ shi','不舒服':' bù shū fu','朴子市':' pò zǐ shì','花子儿':' huā zǐ er','安南子':' ān nán zǐ','旱鸭子':' hàn yā zǐ','苏打粉':' sū dá fěn','里边儿':' lǐ bian r','子母弹':' zǐ mǔ dàn','孙武子':' sūn wǔ zǐ','孙媳夫':' sūn xí fu','木齿耙':' mù chǐ pá','孙女儿':' sūn nǔ: r','蔡李佛':' cài lǐ fó','子细胞':' zǐ xì bāo','牛仔布':' níu zǎi bù','氨哮素':' ān xiào sù','跑味儿':' pǎo wèi r','下边儿':' xià bian r','肖伯纳':' xiāo bó nà','脊柱裂':' jǐ zhù liè','不作为':' bù zuò wéi','处子秀':' chǔ zǐ xìu','胡椒子':' hú jiāo zǐ','背影儿':' bèi yǐng r','背包袱':' bēi bāo fú','背包客':' bēi bāo kè','不一定':' bù yí dìng','老骨头':' lǎo gú tou','不调和':' bù tiáo hé','蛋卷儿':' dàn juǎn r','老头儿':' lǎo tou er','耶诞节':' yē dàn jié','耶稣教':' yē sū jiào','耶烈万':' yē liè wàn','耳坠子':' ěr zhuì zǐ','离子键':' lí zǐ jiàn','不干涉':' bù gān shè','这边儿':' zhè biān r','混球儿':' hún qiú ér','消食儿':' xiāo shí r','独山子':' dú shān zǐ','沈河区':' shěn hé qū','处女座':' chǔ nǚ zuò','老毛子':' lǎo máo zǐ','混名儿':' hùn míng r','美发师':' měi fà shī','葡萄干':' pú táo gān','葵花子':' kuí huā zǐ','蒙古族':' měng gǔ zú','脊椎骨':' jǐ zhuī gǔ','有益处':' yǒu yì chu','罗圈儿':' luó quān r','翻篇儿':' fān piān r','袖筒儿':' xìu tǒng r','被誉为':' bèi yù wéi','翟理斯':' zhái lǐ sī','补给站':' bǔ jǐ zhàn','补给舰':' bǔ jǐ jiàn','有道理':' yǒu dào li','美智子':' měi zhì zǐ','罗姆酒':' luō mǔ jǐu','罗夫诺':' luō fū nuò','罗伯逊':' luō bó xùn','老处女':' lǎo chǔ nǚ','褪套儿':' tùn tào ér','要不是':' yào bú shì','绕弯子':' rào wān zǐ','要样儿':' yào yàng r','阿华田':' a huà tián','这会子':' zhè huì zǐ','有边儿':' yǒu biān r','增压机':' zēng yà jī','败家子':' bài jiā zǐ','牛仔裤':' niú zǎi kù','溜边儿':' līu biān r','洒狗血':' sǎ gǒu xiě','炸丸子':' zhá wán zǐ','死胡同':' sǐ hú tòng','这阵儿':' zhè zhèn r','死难者':' sǐ nàn zhě','滥套子':' làn tào zǐ','于都县':' yú dū xiàn','无患子':' wú huàn zǐ','无脊椎':' wú jǐ zhuī','是不是':' shì bú shì','济南市':' jǐ nán shì','酒馆儿':' jǐu guǎn r','男子单':' nán zǐ dān','狗崽子':' gǒu zǎi zǐ','狄更斯':' dí gēng sī','满剌加':' mǎn là jiā','死不了':' sǐ bù liǎo','死劲儿':' sǐ jìng er','酒令儿':' jǐu lìng r','牟平区':' mù píng qū','金龟子':' jīn guī zǐ','释迦佛':' shì jiā fó','牛脊肉':' níu jǐ ròu','汉堡包':' hàn pù bāo','热得快':' rè de kuài','狗腿子':' gǒu tuǐ zǐ','都安县':' dū an xiàn','理发院':' lǐ fà yuàn','增压器':' zēng yà qì','柞蚕丝':' zuò cán sī','都更案':' dū gēng àn','都柏林':' dōu bó lín','猜谜儿':' cāi mèi ér','嘴把式':' zuǐ bǎ shi','猜得透':' cāi de tòu','增压比':' zēng yà bǐ','支努干':' zhī nǔ gān','电子业':' diàn zǐ yè','玛曲县':' mǎ qǔ xiàn','理发厅':' lǐ fà tīng','猜不透':' cāi bu tòu','理发店':' lǐ fà diàn','逻辑学':' luó ji xué','理发员':' lǐ fà yuán','那倒是':' nà dào shi','贼骨头':' zéi gú tou','那时候':' nà shí hou','那曲县':' nǎ qū xiàn','玩儿坏':' wán r huài','部分值':' bù fèn zhí','浪卡子':' làng kǎ zǐ','一个样':' yī ge yàng','都匀市':' dū yún shì','滴溜儿':' dī liù ér','躲不起':' duǒ bu qǐ','老爷爷':' lǎo yé ye','洗发皂':' xǐ fà zào','浑球儿':' hún qíu r','缩砂密':' sù shā mì','毗耶娑':' pí yē suō','没劲儿':' méi jìn r','没门儿':' méi mén r','没溜儿':' méi lìu r','一个人':' yí ge rén','波尔干':' bō ěr gān','没奈何':' mò nài hé','没六儿':' méi lìu r','洗发粉':' xǐ fà fěn','炸子鸡':' zhá zǐ jī','一个劲':' yí gè jìn','弹力袜':' tán lì wà','弹力丝':' tán lì sī','海蛤蝓':' hǎi gé yú','涂尔干':' tú ěr gān','加的斯':' jiā dì sī','六安市':' lù ān shì','牙缝儿':' yá fèng r','腿肚子':' tuǐ dǔ zi','牡丹区':' mǔ dan qū','牡丹卡':' mǔ dan kǎ','加劲儿':' jiā jìn r','润发露':' rùn fà lù','色差仪':' sè chā yí','微粒子':' wēi lì zǐ','一水儿':' yī shuǐ r','哇沙比':' wā shā bǐ','哇沙米':' wā shā mǐ','一甲子':' yī jiǎ zǐ','眵目糊':' chī mu hū','器乐曲':' qì yuè qǔ','子大夫':' zǐ dài fū','兔崽子':' tù zǎi zǐ','吐谷浑':' tǔ yù hún','摆设儿':' bǎi she r','铺路石':' pū lù shí','破谜儿':' pò mèi ér','润发液':' rùn fà yè','呀诺达':' yā nuò dá','呆会儿':' dāi huì r','看得起':' kàn de qǐ','如来佛':' rú lái fó','禁得起':' jīn de qǐ','氨吖啶':' ān ā dìng','四君子':' sì jūn zǐ','丝挂子':' sī guà zǐ','刮胡子':' guā hú zǐ','剥皮器':' bāo pí qì','别客气':' bié kè qi','副书记':' fù shū ji','傻呵呵':' shǎ hē hē','占地儿':' zhàn dì r','碑座儿':' bēi zuò r','脑脊液':' nǎo jǐ yè','多目的':' duō mù dì','染发剂':' rǎn fà jì','夜宵儿':' yè xiāo r','柳子戏':' liǔ zǐ xì','脱衣服':' tuō yī fu','夜猫子':' yè māo zǐ','不可数':' bù kě shǔ','卷叶蛾':' juàn yè é','脑瓜儿':' nǎo guā r','大伯子':' dà bǎi zǐ','压根儿':' yà gēn ér','多佛尔':' duō fó ěr','耶酥会':' yē sū huì','拉呱儿':' lā guā er','老夫子':' lǎo fū zǐ','老伯伯':' lǎo bó bo','老佛爷':' lǎo fó yé','堵塞费':' dǔ sè fèi','老妈子':' lǎo mā zǐ','老帽儿':' lǎo mào r','喇叭口':' lǎ ba kǒu','耶稣会':' yē sū huì','不值得':' bù zhí de','胡燕妮':' hú yān nī','一家子':' yī jiā zǐ','乌拉圭':' wù lɑ guī','脱模机':' tuō mú jī','脱模器':' tuō mú qì','脱模剂':' tuō mú jì','武都市':' wǔ dū shì','孺子牛':' rú zǐ niú','拓扑图':' tuò pū tú','自以为':' zì yǐ wéi','独院儿':' dú yuàn r','乌干达':' wū gān dá','石磨机':' shí mò jī','无支祁':' wú zhī qí','多粒子':' duō lì zǐ','十八子':' shí bā zǐ','烟头儿':' yān tóu r','土粉子':' tǔ fěn zǐ','土狗子':' tǔ gǒu zǐ','熟道儿':' shú dào r','殷都区':' yīn dū qū','热处理':' rè chǔ lǐ','半分儿':' bàn fēn r','磨得开':' mó de kāi','禁不起':' jīn bù qǐ','奶嘴儿':' nǎi zuǐ r','碰磁儿':' pèng cí r','牌子曲':' pái zi qǔ','车份儿':' chē fèn r','西边儿':' xī biān r','古乐府':' gǔ yuè fǔ','打得好':' dǎ de hǎo','触技曲':' chù jì qǔ','记不住':' jì bu zhù','记号笔':' jì hao bǐ','打不倒':' dǎ bù dǎo','许廑父':' xǔ qín fù','来得及':' lái de jí','搁得住':' gé de zhù','搁不住':' gé bú zhù','认人儿':' rèn rén r','西门子':' xī mén zǐ','载伯德':' zǎi bó dé','来火儿':' lái huǒ r','骨朵儿':' gū duǒ er','惹麻烦':' rě má fan','高压脊':' gāo yā jǐ','佛诞日':' fó dàn rì','配对儿':' pèi duì r','猫眼儿':' māo yǎn r','买不起':' mǎi bu qǐ','费劲儿':' fèi jìn r','一刹那':' yī chà nà','后钩儿':' hòu gōu r','佛兰德':' fó lán dé','发疟子':' fā yào zǐ','得尔塔':' děi ěr tǎ','赶得及':' gǎn de jí','分子力':' fèn zǐ lì','希思罗':' xī sī luō','希腊文':' xī là wén','任一个':' rèn yī ge','都卜勒':' dōu bǔ lè','粪箕子':' fèn jī zǐ','都伯林':' dū bó lín','部落格':' bù luò gé','那维克':' nǎ wéi kè','软泥儿':' ruǎn ní r','起小兒':' qǐ xiǎo r','那曲市':' nà qǔ shì','布什尔':' bù shí ěr','都御使':' dū yù shǐ','待会儿':' dāi huì r','迦叶佛':' jiā yè fó','弹涂鱼':' tán tú yú','一竿子':' yī gān zǐ','曲麻莱':' qǔ má lái','独奏曲':' dú zòu qǔ','度假区':' dù jià qū','耳掴子':' ěr guó zǐ','刀把儿':' dāo bà er','费米子':' fèi mǐ zǐ','石鼓区':' dàn gǔ qū','歌仔戏':' gē zǎi xì','男孩儿':' nán hái r','玩儿完':' wán r wán','卡脖子':' qiǎ bó zi','班辈儿':' bān bèi r','印把子':' yìn bà zi','理发师':' lǐ fà shī','男子气':' nán zǐ qì','欧柏林':' oū bó lín','子母扣':' zǐ mǔ kòu','字帖儿':' zì tiě er','番禺区':' pān yú qū','反粒子':' fǎn lì zǐ','直发器':' zhí fà qì','取灯儿':' qǔ dēng r','武侯祠':' wǔ hòu cí','咖喱粉':' gā lí fěn','一揽子':' yī lǎn zǐ','辟支佛':' pì zhī fó','和得来':' hé de lái','和散那':' hé sǎn nà','和稀泥':' huò xī ní','石子儿':' shí zǐ er','石河子':' shí hé zǐ','泡沫剂':' pāo mò jì','白班儿':' bái bān r','吉卜赛':' jí bǔ sài','佛舍利':' fó shè lì','差速器':' chā sù qì','以此为':' yǐ cǐ wéi','富家子':' fù jiā zǐ','使劲儿':' shǐ jìn r','暾欲谷':' tūn yù gǔ','大师傅':' dà shī fū','高拨子':' gāo bō zǐ','牙花子':' yá huā zǐ','钙离子':' gài lí zǐ','咖喱饭':' gā lí fàn','以斯帖':' yǐ sī tiě','浮头儿':' fú tou er','克分子':' kè fèn zǐ','合得来':' hé de lái','叭啦狗':' bā lā gǒu','可不是':' kě bú shì','白麻子':' bái má zǐ','切割器':' qiē gē qì','切割机':' qiē gē jī','可数集':' kě shǔ jí','史密斯':' shǐ mì sī','瘾头儿':' yǐn tóu r','尽义务':' jìn yì wù','子弟书':' zǐ dì shū','卢塞恩':' lú sài ēn','内比都':' nèi bǐ dū','畜产品':' xù chǎn pǐn','受得了':' shòu de liǎo','百分号':' bǎi fēn háo','沈丘县':' shěn qīu xiàn','弹着点':' dàn zhuó diǎn','长筒袜':' cháng tǒng wà','美容觉':' měi róng jiào','霰粒肿':' xiàn lì zhǒng','线桄子':' xiàn guàng zi','拖累症':' tuō lěi zhèng','冷轧钢':' lěng zhá gāng','再加上':' zài jiā shang','长蛇座':' cháng shé zuò','罗甸县':' luó diàn xiàn','翟志刚':' zhái zhì gāng','番茄酱':' fān qié jiàng','中子源':' zhōng zǐ yuán','沈从文':' shěn cóng wén','沈国放':' shěn guó fàng','应景诗':' yìng jǐng shī','上齿龈':' shàng chǐ yín','豆豉酱':' dòu chǐ jiàng','当世冠':' dāng shì guàn','白相人':' bái xiàng rén','绍兴酒':' shào xīng jiǔ','请病假':' qǐng bìng jià','轴对称':' zhóu duì chèn','性偏好':' xìng piān hào','长统袜':' cháng tǒng wà','相扑手':' xiàng pū shǒu','公仔面':' gōng zǎi miàn','喜相逢':' xǐ xiàng féng','绍兴市':' shào xīng shì','豁免权':' huò miǎn quán','校正子':' jiào zhèng zǐ','拓荒者':' tuò huāng zhě','铜管乐':' tóng guǎn yuè','酸中毒':' suān zhòng dú','病假条':' bìng jià tiáo','中子星':' zhōng zǐ xīng','都昌县':' dū chāng xiàn','最前面':' zuì qián mian','取景框':' qǔ jǐng kuàng','香泡树':' xiāng pāo shù','链反应':' liàn fǎn yìng','缝衣匠':' féng yī jiàng','佛跳墙':' fó tiào qiáng','长野县':' cháng yě xiàn','快中子':' kuài zhōng zǐ','凉州曲':' liáng zhōu qǔ','请假条':' qǐng jià tiáo','缝纫工':' féng rèn gōng','紧绷绷':' jǐn bēng bēng','长臂猿':' cháng bì yuán','性行为':' xìng xíng wéi','拉长脸':' lā cháng liǎn','亲家公':' qìng jiā gōng','转车台':' zhuàn chē tái','乡人子':' xiāng rén zǐ','冠军赛':' guàn jūn sài','担担面':' dàn dɑn miàn','非对称':' fēi duì chèn','炸油饼':' zhá yóu bǐng','遇难船':' yù nàn chuán','处分权':' chǔ fèn quán','行得通':' xíng de tōng','逮捕证':' dài bǔ zhèng','短不了':' duǎn bù liǎo','音乐厅':' yīn yuè tīng','转轴儿':' zhuàn zhóu r','炸薯条':' zhá shǔ tiáo','血中毒':' xuè zhòng dú','炸薯片':' zhá shǔ piàn','转铃儿':' zhuàn líng r','曲阳县':' qǔ yáng xiàn','曲周县':' qǔ zhōu xiàn','运货员':' yùn huò yuán','行列式':' háng liè shì','猪仔馆':' zhū zǎi guǎn','操纵杆':' cāo zòng gǎn','张掖市':' zhāng yè shì','江干区':' jiāng gān qū','弹跳板':' tán tiào bǎn','调药刀':' tiáo yào dāo','朝鲜族':' cháo xiǎn zú','结婚证':' jiē hūn zhèng','分散相':' fēn sàn xiàng','钦天监':' qīn tiān jiàn','敲竹杠':' qiāo zhū gàng','怪念头':' guài niàn tou','长颈鹿':' cháng jǐng lù','相片儿':' xiàng piān er','海兴县':' hǎi xīng xiàn','交响曲':' jiāo xiǎng qǔ','沈葆祯':' shěn bǎo zhēn','海螵蛸':' hǎi piāo xiāo','走为上':' zǒu wéi shàng','超对称':' chāo duì chèn','酌处权':' zhuó chǔ quán','负效应':' fù xiào yìng','照相簿':' zhào xiàng bù','溜溜转':' liū liū zhuàn','不相称':' bù xiāng chèn','酆都城':' fēng dū chéng','涡阳县':' guō yáng xiàn','钻石婚':' zuàn shí hūn','调节板':' tiáo jié bǎn','丰都县':' fēng dū xiàn','宝生佛':' bǎo shēng fó','更年期':' gēng nián qī','韩湘子':' hán xiāng zǐ','弧线长':' hú xiàn cháng','张国焘':' zhāng guó tāo','张柏芝':' zhāng bó zhī','沈阳市':' shěn yáng shì','相似性':' xiāng sì xìng','扫帚星':' sào zhǒu xīng','切换键':' qiē huàn jiàn','三重奏':' sān chóng zòu','放大率':' fàng dà shuài','中毒性':' zhòng dú xìng','三重市':' sān chóng shì','子宫腔':' zǐ gōng qiāng','中爪哇':' zhōng zhǎo wā','白蛇传':' bái shé zhuàn','伽南香':' qié nán xiāng','排行榜':' pái háng bǎng','辉长岩':' huī cháng yán','弹簧板':' tán huáng bǎn','中洋脊':' zhōng yáng jǐ','飞将军':' fēi jiàng jūn','风切变':' fēng qiē biàn','轧钢条':' zhá gāng tiáo','将进酒':' qiāng jìn jiǔ','增温层':' zēng wēn céng','车头相':' chē tóu xiàng','粘滞性':' nián zhì xìng','弹性销':' tán xìng xiāo','孪生子':' luán shēng zǐ','相位差':' xiàng wèi chā','廊坊市':' láng fáng shì','精校本':' jīng jiào běn','管弦乐':' guǎn xián yuè','命中率':' mìng zhòng lǜ','数得上':' shǔ děi shàng','复选框':' fù xuǎn kuàng','灰蒙蒙':' huī mēng méng','小便斗':' xiǎo biàn dǒu','供应品':' gōng yìng pǐn','黑糁糁':' hēi shēn shēn','间谍网':' jiàn dié wǎng','切平面':' qiē píng miàn','内省性':' nèi xǐng xìng','同字框':' tóng zì kuàng','三框栏':' sān kuàng lán','传记性':' zhuàn jì xìng','间接税':' jiàn jiē shuì','铅中毒':' qiān zhòng dú','丧葬费':' sāng zàng fèi','强的松':' qiáng dí sōng','载畜量':' zǎi chù liàng','迎新会':' yíng xīn kuài','乔冠华':' qiáo guān huà','挑大梁':' tiǎo dà liáng','转一趟':' zhuàn yī tàng','哑终端':' yā zhōng duān','椎间盘':' zhuī jiān pán','开小差':' kāi xiǎo chāi','切空间':' qiē kōng jiān','闹嚷嚷':' nào rāng rɑng','称多县':' chèn duō xiàn','眼干症':' yǎn gān zhèng','碰头会':' pèng tóu kuài','弹簧刀':' tán huáng dāo','电子枪':' diàn zǐ qiāng','旁切圆':' páng qiē yuán','膀胱癌':' páng guāng ái','咸兴市':' xián xīng shì','光电子':' guāng diàn zǐ','吹管乐':' chuī guǎn yuè','洋中脊':' yáng zhōng jǐ','称之为':' chēng zhī wéi','挑逗性':' tiǎo dòu xìng','挑战书':' tiǎo zhàn shū','标准差':' biāo zhǔn chā','弦切角':' xián qiē jiǎo','挑战者':' tiǎo zhàn zhě','复兴乡':' fù xīng xiāng','弄明白':' nòng míng bai','空白点':' kòng bái diǎn','唐三藏':' táng sān zàng','转速表':' zhuàn sù biǎo','调节表':' tiáo jié biǎo','福兴乡':' fú xīng xiāng','能量子':' néng liàng zǐ','短波长':' duǎn bō cháng','电子秤':' diàn zǐ chèng','流行性':' liú xíng xìng','扁担星':' biǎn dàn xīng','干事长':' gàn shi zhǎng','假芫茜':' jiǎ yuán qiàn','商都县':' shāng dū xiàn','空调车':' kōng tiáo chē','粘土砖':' nián tǔ zhuān','退行性':' tuì xíng xìng','刀削面':' dāo xiāo miàn','娘子关':' niáng zǐ guān','调节税':' tiáo jié shuì','强迫性':' qiǎng pò xìng','传记片':' zhuàn jì piàn','适应性':' shì yìng xìng','弹簧锁':' tán huáng suǒ','着眼点':' zhuó yǎn diǎn','应战书':' yìng zhàn shū','电转儿':' diàn zhuàn ér','砷中毒':' shēn zhòng dú','二重性':' èr chóng xìng','运动员':' yùn dòng yuán','瞭望台':' liào wàng tái','蒙蒙黑':' mēng mēng hēi','进行性':' jìn xíng xìng','知更鸟':' zhī gēng niǎo','弹簧门':' tán huáng mén','串门子':' chuàn mén zǐ','九华山':' jiǔ huà shān','犍为县':' qián wèi xiàn','磁效应':' cí xiào yìng','曾金燕':' zēng jīn yàn','利眠宁':' lì mián nìng','光杆儿':' guāng gǎn ér','还原剂':' huán yuán jì','佛坪县':' fó píng xiàn','中微子':' zhòng wēi zǐ','重孙子':' chóng sūn zi','都江堰':' dū jiāng yàn','小太太':' xiǎo tài tai','说不着':' shuō bù zháo','折杨柳':' shé yáng liǔ','更新世':' gēng xīn shì','曾孝谷':' zēng xiào gǔ','载客量':' zǎi kè liàng','康有为':' kāng yǒu wéi','儿童片':' ér tóng piān','复兴党':' fù xīng dǎng','怔神儿':' zhēng shén r','说得着':' shuō de zháo','沈北新':' shěn běi xīn','洋漂族':' yáng piāo zú','都庞岭':' dū páng lǐng','重孙女':' chóng sūn nǚ','更新版':' gēng xīn bǎn','干鲜果':' gān xiān guǒ','当间儿':' dāng jiàn ér','民乐县':' mín yuè xiàn','调味汁':' tiáo wèi zhī','重复节':' chóng fù jié','调味品':' tiáo wèi pǐn','干燥管':' gān zào guǎn','纯阳子':' chún yáng zǐ','朝歌镇':' zhāo gē zhèn','转字锁':' zhuàn zì suǒ','纯音乐':' chún yīn yuè','贡嘎县':' gòng gá xiàn','干燥瓶':' gān zào píng','天仙子':' tiān xiān zǐ','广安门':' guǎng ān mén','大行星':' dà háng xīng','滑行道':' huá háng dào','泰兴市':' tài xīng shì','广安市':' guǎng ān shì','转腰子':' zhuàn yāo zi','干扰源':' gān rǎo yuán','难为情':' nán wéi qíng','吹奏乐':' chuī zòu yuè','弦乐队':' xián yuè duì','分子量':' fèn zǐ liàng','咽喉痛':' yān hóu tòng','转差率':' zhuǎn chā lǜ','对称美':' duì chèn měi','佳丽酿':' jiā lì niáng','重估后':' chóng gū hòu','采血针':' cǎi xiě zhēn','肺栓塞':' fèi shuān sè','考试卷':' kǎo shì juàn','小瘪三':' xiǎo biē sān','空格键':' kòng gé jiàn','羊痒疫':' yáng yǎng yì','肋条肉':' lèi tiáo ròu','美差事':' měi chāi shì','长葛市':' cháng gě shì','累进税':' lěi jìn shuì','长草区':' cháng cǎo qū','长舌妇':' cháng shé fù','曲颈甑':' qǔ jǐng zèng','外行话':' wài háng huà','相国寺':' xiàng guó sì','阿莲乡':' a lián xiāng','藏经阁':' zàng jīng gé','老来少':' lǎo lái shào','沧浪客':' cāng láng kè','病秧子':' bìng yāng zǐ','数不上':' shǔ bù shàng','浪荡子':' làng dàng zǐ','涂浆台':' tú jiàng tái','降魔杵':' xiáng mó chǔ','老朋友':' lǎo péng you','中庶子':' zhōng shù zǐ','种植业':' zhòng zhí yè','轻音乐':' qīng yīn yuè','测量值':' cè liáng zhí','灾难片':' zāi nàn piàn','灾难性':' zāi nàn xìng','马槟榔':' mǎ bīng lang','重眼皮':' chóng yǎn pí','谁知道':' shéi zhī dào','切向力':' qiē xiàng lì','诸葛亮':' zhū gě liàng','孔子庙':' kǒng zǐ miào','空调机':' kōng tiáo jī','免不了':' miǎn bù liǎo','测量学':' cè liáng xué','壁效应':' bì xiào yìng','种植土':' zhòng zhí tǔ','黑钻石':' hēi zuàn shí','全武行':' quán wǔ háng','空调器':' kōng tiáo qì','中子流':' zhōng zǐ liú','挑花眼':' tiǎo huā yǎn','柳毅传':' lǐu yì zhuàn','柬埔寨':' jián pǔ zhài','拉家常':' lá jiā cháng','听不见':' tīng bu jiàn','听得懂':' tīng de dǒng','甲壳类':' jiǎ qiào lèi','冠军杯':' guàn jūn bēi','软龈音':' ruǎn yín yīn','晒骆驼':' shài luò tuo','调节池':' tiáo jié chí','顶呱呱':' dǐng guā guā','螺桨毂':' luó jiǎng gū','行家话':' háng jiā huà','典当业':' diǎn dàng yè','挑衅者':' tiǎo xìn zhě','点电荷':' diǎn diàn hè','量子论':' liàng zǐ lùn','电荷泵':' diàn hè bèng','航行图':' háng xíng tú','中子数':' zhōng zǐ shù','这年头':' zhè nián tou','朝鲜语':' cháo xiǎn yǔ','速调管':' sù tiáo guǎn','重头戏':' chóng tóu xì','难民营':' nàn mín yíng','正角儿':' zhèng jué er','宁都县':' níng dū xiàn','实际上':' shí jì shang','随想曲':' suí xiǎng qǔ','管乐队':' guǎn yuè duì','反应池':' fǎn yìng chí','还魂纸':' huán hún zhǐ','伊甸园':' yī diàn yuán','电子管':' diàn zǐ guǎn','原子尘':' yuán zǐ chén','应名儿':' yìng míng ér','水仙子':' shuǐ xiān zǐ','延长器':' yán cháng qì','江都市':' jiāng dū shì','调节者':' tiáo jié zhě','谈朋友':' tán péng you','虞应龙':' yú yìng lóng','中子弹':' zhōng zǐ dàn','司天监':' sī tiān jiàn','调酒师':' tiáo jǐu shī','十三省':' shí sān xǐng','量子化':' liàng zǐ huà','调解人':' tiáo jiě rén','出风头':' chū fēng tou','冰凝器':' bīng níng qì','蟹爪兰':' xiè zhuǎ lán','电子表':' diàn zǐ biǎo','蚌山区':' bèng shān qū','串处理':' chuàn chǔ lǐ','钻孔机':' zuàn kǒng jī','曾繁仁':' zēng fán rén','泌阳县':' bì yáng xiàn','原子团':' yuán zǐ tuán','怪叔叔':' guài shū shu','电熨斗':' diàn yùn dǒu','调解书':' tiáo jiě shū','音乐院':' yīn yuè yuàn','沂蒙山':' yí měng shān','潭子乡':' tán zǐ xiāng','曲松县':' qǔ sōng xiàn','放寒假':' fàng hán jià','中乐透':' zhòng lè tòu','海参崴':' hǎi shēn wēi','有年头':' yǒu nián tou','剪应力':' jiǎn yìng lì','曲柄钻':' qū bǐng zuàn','前齿龈':' qián chǐ yín','氢原子':' qīng yuán zǐ','赵子龙':' zhào zǐ lóng','分权制':' fèn quán zhì','跟不上':' gēn bu shàng','少奶奶':' shào nǎi nɑi','弹钢琴':' tán gāng qín','大黄素':' dài huáng sù','供应科':' gōng yìng kē','这程子':' zhè chéng zǐ','忘不了':' wàng bù liǎo','放暑假':' fàng shǔ jià','电子层':' diàn zǐ céng','灵雀寺':' líng qiǎo sì','照片儿':' zhào piān er','情急了':' qíng jí liǎo','元真子':' yuán zhēn zǐ','弹棉花':' tán mián huā','公共课':' gōng gòng kè','跟得上':' gēn de shàng','有弹性':' yǒu tán xìng','曾国藩':' zēng guó fān','切成丝':' qiē chéng sī','缝合线':' féng hé xiàn','少不了':' shào bù liǎo','想不到':' xiǎng bú dào','反应慢':' fǎn yìng màn','车行道':' chē háng dào','曲水县':' qǔ shuǐ xiàn','香子兰':' xiāng zǐ lán','软着陆':' ruǎn zhuó lù','姑娘家':' gū niáng jiā','鼓囊囊':' gǔ nāng nɑng','什邡市':' shí fāng shì','崆峒区':' kōng tóng qū','电子战':' diàn zǐ zhàn','漂流者':' piāo líu zhě','澎湖县':' péng hú xiàn','微中子':' wēi zhōng zǐ','望都县':' wàng dū xiàn','氧原子':' yǎng yuán zǐ','想得开':' xiǎng de kāi','佛冈县':' fó gāng xiàn','使兴奋':' shǐ xīng fèn','说不了':' shuō bù liǎo','飞行家':' fēi háng jia','尖沙咀':' jiān shā zuǐ','银行券':' yín háng juàn','爱漂亮':' ài piào liang','著作郎':' zhù zuò láng','灯笼椒':' dēng long jiāo','曾庆红':' zēng qìng hóng','强迫症':' qiǎng pò zhèng','转轮王':' zhuàn lún wáng','张僧繇':' zhāng sēng yóu','兜率宫':' dōu shuài gōng','延长县':' yán cháng xiàn','延长线':' yán cháng xiàn','兜率天':' dōu shuài tiān','连接框':' lián jiē kuàng','眼镜框':' yǎn jìng kuàng','轧钢厂':' zhá gāng chǎng','中圈套':' zhòng quān tào','身分证':' shēn fèn zhèng','长公主':' cháng gōng zhǔ','长岛县':' cháng dǎo xiàn','村上隆':' cūn shàng lōng','命令行':' mìng lìng háng','着重号':' zhuó zhòng hào','娘家姓':' niáng jia xìng','长城卡':' cháng chéng kǎ','娘娘腔':' niáng niang qiāng','小旋风':' xiǎo xuàn fēng','长兴岛':' cháng xīng dǎo','重庆市':' chóng qìng shì','小公共':' xiǎo gōng gòng','长相思':' zhǎng xiàng sī','统称为':' tǒng chēng wéi','长镜头':' cháng jìng tóu','谷梁传':' gǔ liáng zhuàn','脏躁症':' zāng zào zhèng','种植园':' zhòng zhí yuán','绷子床':' bēng zi chuáng','应用性':' yìng yòng xìng','码长城':' mǎ cháng chéng','农场主':' nóng cháng zhǔ','门边框':' mén biān kuàng','三重县':' sān chóng xiàn','切分音':' qiē fēn yīn','两边倒':' liǎng biān dǎo','供应站':' gòng yīng zhàn','粮食厅':' liáng shi tīng','鹿角霜':' lù jiǎo shuāng','蛮漂亮':' mán piào liang','粘着性':' zhān zhuó xìng','众生相':' zhòng shēng xiàng','谢长廷':' xiè cháng tíng','照相术':' zhào xiàng shù','照相纸':' zhào xiàng zhǐ','照相版':' zhào xiàng bǎn','工伤假':' gōng shāng jià','供应舰':' gōng yìng jiàn','兴山县':' xīng shān xiàn','兴城市':' xīng chéng shì','长白县':' cháng bái xiàn','桑螵蛸':' sāng piāo xiāo','应用层':' yìng yòng céng','轰隆隆':' hōng lōng lóng','藏经洞':' zàng jīng dòng','瞭望哨':' liào wàng shào','香獐子':' xiāng zhāng zǐ','龈脓肿':' yín nóng zhǒng','闪长岩':' shǎn cháng yán','吃空饷':' chī kòng xiǎng','乱哄哄':' luàn hǒng hǒng','切成块':' qiē chéng kuài','乾清宫':' qián qīng gōng','王舍城':' wáng shè chéng','星相学':' xīng xiàng xué','少年宫':' shào nián gōng','少年行':' shào nián xíng','手相学':' shǒu xiàng xué','半长轴':' bàn cháng zhóu','清劲风':' qīng jìng fēng','二重唱':' èr chóng chàng','陈省身':' chén xǐng shēn','沉甸甸':' chén diàn diàn','青囊经':' qīng náng jīng','双折射':' shuāng zhē shè','双子宫':' shuāng zǐ gōng','定兴县':' dìng xīng xiàn','黄萎病':' huáng wěi bìng','天长市':' tiān cháng shì','审判长':' shěn pàn cháng','兴中会':' xīng zhōng huì','长寿菜':' cháng shòu cài','兴隆县':' xīng lóng xiàn','杓球场':' sháo qíu chǎng','检察长':' jiǎn chá cháng','间断性':' jiàn duàn xìng','茄萣乡':' qié dìng xiāng','江城子':' jiāng chéng zǐ','旋风脚':' xuàn fēng jiǎo','撑得慌':' chēng de huāng','航行灯':' háng xíng dēng','重阳节':' chóng yáng jié','蒜茸钳':' suàn róng qián','星相术':' xīng xiàng shù','星相师':' xīng xiàng shī','行情表':' háng qíng biǎo','应召站':' yìng zhào zhàn','广成子':' guǎng chéng zǐ','光反应':' guāng fǎn yìng','衡量制':' héng liang zhì','宽甸县':' kuān diàn xiàn','萧万长':' xiāo wàn cháng','九重霄':' jiǔ chóng xiāo','还原糖':' huán yuán táng','长白山':' cháng bái shān','长白镇':' cháng bái zhèn','弹簧管':' tán huáng guǎn','长顺县':' cháng shùn xiàn','长城站':' cháng chéng zhàn','长滨乡':' cháng bīn xiāng','长治乡':' cháng zhì xiāng','长角羊':' cháng jiǎo yáng','长汀县':' cháng tīng xiàn','长毛象':' cháng máo xiàng','长明灯':' cháng míng dēng','长颈龙':' cháng jǐng lóng','长丰县':' cháng fēng xiàn','长颈瓶':' cháng jǐng píng','膀胱镜':' páng guāng jìng','白晃晃':' bái huàng huǎng','长兴县':' cháng xīng xiàn','旧框框':' jiù kuàng kuang','扛长工':' káng cháng gōng','金晃晃':' jīn huàng huǎng','绷场面':' bēng chǎng miàn','长方形':' cháng fāng xíng','兴冲冲':' xīng chōng chōng','应声虫':' yìng shēng chóng','重定向':' chóng dìng xiàng','长寿面':' cháng shòu miàn','双生子':' shuāng shēng zǐ','长绒棉':' cháng róng mián','长生果':' cháng shēng guǒ','油晃晃':' yóu huàng huǎng','公平秤':' gōng píng chèng','重甸甸':' zhòng diàn diàn','卷轴装':' juàn zhóu zhuāng','中郎将':' zhōng láng jiàng','元长乡':' yuán cháng xiāng','弹簧床':' tán huáng chuáng','旋风装':' xuàn fēng zhuāng','花生浆':' huā shēng jiàng','两重天':' liǎng chóng tiān','老框框':' lǎo kuàng kuàng','肖像权':' xiāo xiàng quán','照相馆':' zhào xiàng guǎn','左丞相':' zuǒ chéng xiàng','楞怔怔':' léng zhèng zhèng','穷酸相':' qíong suān xiàng','中奖者':' zhòng jiǎng zhě','范长江':' fàn cháng jiāng','两重性':' liǎng chóng xìng','蒙蒙亮':' méng mēng liàng','创伤后':' chuāng shāng hòu','相空间':' xiàng kōng jiān','相平面':' xiàng píng miàn','相对象':' xiàng duì xiàng','右丞相':' yòu chéng xiàng','长生殿':' cháng shēng diàn','长生天':' cháng shēng tiān','调整环':' tiáo zhěng huán','工段长':' gōng duàn cháng','相位表':' xiàng wèi biǎo','脑中风':' nǎo zhòng fēng','公羊传':' gōng yáng zhuàn','中间件':' zhōng jiān jiàn','相电流':' xiàng diàn liú','长命锁':' cháng mìng suǒ','长长的':' cháng cháng de','长沙县':' cháng shā xiàn','长蛇阵':' cháng shé zhèn','罗盛教':' luó chéng jiào','膀胱炎':' páng guāng yán','多重性':' duō chóng xìng','长泰县':' cháng tài xiàn','长海县':' cháng hǎi xiàn','正长石':' zhèng cháng shí','长春市':' cháng chūn shì','交响乐':' jiāo xiǎng yuè','相适应':' xiāng shì yìng','中都城':' zhōng dū chéng','长统靴':' cháng tǒng xuē','长治县':' cháng zhì xiàn','长筒靴':' cháng tǒng xuē','长毛绒':' cháng máo róng','响应值':' xiǎng yìng zhí','长流水':' cháng liú shuǐ','中标者':' zhòng biāo zhě','中长跑':' zhōng cháng pǎo','弹簧秤':' tán huáng chèng','还乡团':' huán xiāng tuán','川党参':' chuān dǎng shēn','长岭县':' cháng lǐng xiàn','长宁县':' cháng níng xiàn','长垣县':' cháng yuán xiàn','重正化':' chóng zhèng huà','长庚星':' cháng gēng xīng','转动轴':' zhuàn dòng zhóu','转动件':' zhuàn dòng jiàn','长城牌':' cháng chéng pái','川滇藏':' chuān diān zàng','少壮派':' shào zhuàng pài','前首相':' qián shǒu xiàng','正仓院':' zhēng cāng yuàn','正当性':' zhèng dàng xìng','敲丧钟':' qiāo sāng zhōng','上将军':' shàng jiàng jūn','朝鲜筝':' cháo xiǎn zhēng','上半晌':' shàng bàn shǎng','团团转':' tuán tuán zhuàn','供应商':' gōng yìng shāng','弓长岭':' gōng cháng lǐng','切向量':' qiē xiàng liàng','厚生相':' hòu shēng xiàng','中甸县':' zhōng diàn xiàn','哮喘病':' xiào chuǎn bìng','弹簧钢':' tán huáng gāng','海监船':' hǎi jiàn chuán','犯得上':' fàn děi shàng','量油尺':' liáng yóu chǐ'};exports.default=DICTIONARY;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var DICTIONARY={'一场空':' yī cháng kōng','星相图':' xīng xiàng tú','金山屯':' jīn shān zhūn','藏红花':' zàng hóng huā','钻井队':' zuàn jǐng duì','红娘子':' hóng niáng zǐ','量尺寸':' liáng chǐ cùn','量角器':' liáng jiǎo qì','未命名':' wèi mìng míng','行香子':' xíng xiāng zǐ','横切面':' héng qiē miàn','世界上':' shì jiè shang','钉书针':' dìng shū zhēn','性兴奋':' xìng xīng fèn','动画片':' dòng huà piān','子长县':' zǐ cháng xiàn','闹哄哄':' nào hōng hǒng','石头城':' shí tou chéng','双子座':' shuāng zǐ zuò','正电荷':' zhèng diàn hè','保险杠':' bǎo xiǎn gàng','正规化':' zhèng guī huā','荐头店':' jiàn tou diàn','冲击钻':' chōng jī zuàn','冗长度':' rǒng cháng dù','照相机':' zhào xiàng jī','三重门':' sān chóng mén','寻甸县':' xún diàn xiàn','朝鲜人':' cháo xiǎn rén','应力场':' yìng lì chǎng','枕头风':' zhěn tou fēng','朝鲜文':' cháo xiǎn wén','着陆场':' zhuó lù chǎng','黄埔港':' huáng pǔ gǎng','面包片':' miàn bāo piān','还原焰':' huán yuán yàn','还原酶':' huán yuán méi','毛茸茸':' máo róng róng','幻想曲':' huàn xiǎng qǔ','始兴县':' shǐ xīng xiàn','戳脊梁':' chuō jǐ liang','朝阳门':' zhāo yáng mén','光散射':' guāng sǎn shè','首相府':' shǒu xiàng fǔ','重覆性':' chóng fù xìng','冲孔机':' chòng kǒng jī','着火点':' zháo huǒ diǎn','扇面琴':' shān miàn qín','朴正熙':' piáo zhèng xī','重身子':' chóng shēn zi','供应者':' gōng yìng zhě','沈葆桢':' shěn bǎo zhēn','黑旋风':' hēi xuàn fēng','少女峰':' shào nǔ: fēng','宝兴县':' bǎo xīng xiàn','不正当':' bù zhèng dàng','公冶长':' gōng yě cháng','散兵线':' sǎn bīng xiàn','校正器':' jiào zhèng qì','小数点':' xiǎo shǔ diǎn','间歇泉':' jiàn xiē quán','衣冠冢':' yì guān zhǒng','对话框':' duì huà kuàng','供应室':' gōng yìng shì','对称轴':' duì chèn zhóu','南朝鲜':' nán cháo xiǎn','致良知':' zhì liáng zhī','纵切面':' zòng qiē miàn','角斗场':' jué dòu chǎng','南北长':' nán běi cháng','协调员':' xié tiáo yuán','李长春':' lǐ cháng chūn','对称性':' duì chèn xìng','万圣节':' wàn shèng jiē','摔跟头':' shuāi gēn tou','关卡税':' guān qiǎ shuì','钱串子':' qián chuàn zǐ','见世面':' xiàn shì miàn','总长度':' zǒng cháng dù','曾国荃':' zēng guó quán','少年犯':' shào nián fàn','汞中毒':' gǒng zhòng dú','够得上':' gòu děi shàng','昌都县':' chāng dū xiàn','东兴市':' dōng xīng shì','有粘性':' yǒu nián xìng','交白卷':' jiāo bái juàn','小脏鬼':' xiǎo zāng guǐ','钻牛角':' zuàn niú jiǎo','见识浅':' jiàn shi qiǎn','三连冠':' sān lián guàn','创可贴':' chuāng kě tiē','想倒美':' xiǎng dǎo měi','东三省':' dōng sān xǐng','碱中毒':' jiǎn zhòng dú','撞运气':' zhuàng yùn qi','印相纸':' yìn xiàng zhǐ','教学片':' jiào xué piān','公切线':' gōng qiē xiàn','订书钉':' dìng shū dīng','晕血症':' yùn xuè zhèng','占星术':' zhān xīng shù','打长工':' dǎ cháng gōng','占星师':' zhān xīng shī','散兵坑':' sǎn bīng kēng','占星家':' zhān xīng jiā','占星学':' zhān xīng xué','兴隆台':' xīng lóng tái','北朝鲜':' běi cháo xiǎn','兴奋性':' xīng fèn xìng','弹簧销':' tán huáng xiāo','九转丹':' jiǔ zhuàn dān','炸酱面':' zhá jiàng miàn','生还者':' shēng huán zhě','黄长烨':' huáng cháng yè','霰弹枪':' xiàn dàn qiāng','荥经县':' yíng jīng xiàn','枞阳县':' zōng yáng xiàn','水浒传':' shuǐ hǔ zhuàn','重婚罪':' chóng hūn zuì','校书郎':' jiào shū láng','长沙湾':' cháng shā wān','长子县':' cháng zǐ xiàn','卷层云':' juàn céng yún','四重唱':' sì chóng chàng','肠杆菌':' cháng gǎn jūn','兴国县':' xīng guó xiàn','正安县':' zhēng an xiàn','长春子':' cháng chūn zǐ','干燥箱':' gān zào xiāng','感应电':' gǎn yìng diàn','调停者':' tiáo tíng zhě','施甸县':' shī diàn xiàn','种牛痘':' zhòng niú dòu','长宁区':' cháng níng qū','空白表':' kòng bái biǎo','沧浪亭':' cāng láng tíng','黄克强':' huáng kè jiàng','游说团':' yóu shuì tuán','甲壳虫':' jiǎ qiào chóng','青少年':' qīng shào nián','氧效应':' yǎng xiào yìng','双曲面':' shuāng qǔ miàn','檀香扇':' tán xiāng shàn','青藏线':' qīng zàng xiàn','教书匠':' jiāo shū jiàng','薯莨绸':' shǔ liáng chóu','狂想曲':' kuáng xiǎng qǔ','洪洞县':' hóng tóng xiàn','田长霖':' tián cháng lín','永兴县':' yǒng xīng xiàn','颈椎病':' jǐng zhuī bìng','灭虫宁':' miè chóng nìng','电转盘':' diàn zhuàn pán','混水墙':' hún shuǐ qiáng','适应症':' shì yìng zhèng','侍应生':' shì yìng shēng','调整到':' tiáo zhěng dào','钻井工':' zuàn jǐng gōng','光波长':' guāng bō cháng','光感应':' guāng gǎn yìng','测量船':' cè liáng chuán','清算行':' qīng suàn háng','出洋相':' chū yáng xiàng','小娘子':' xiǎo niáng zǐ','长短句':' cháng duǎn jù','长武县':' cháng wǔ xiàn','长沙市':' cháng shā shì','新兴县':' xīn xīng xiàn','漂流瓶':' piāo liú píng','感应圈':' gǎn yìng quān','斜长石':' xié cháng shí','说得上':' shuō de shàng','相应物':' xiāng yìng wù','用得上':' yòng de shàng','甩脸子':' shuǎi liǎn zǐ','长清区':' cháng qīng qū','天台山':' tiān tāi shān','卷叶虫':' juàn yè chóng','原子量':' yuán zǐ liàng','长方体':' cháng fāng tǐ','救难船':' jiù nàn chuán','男傧相':' nán bīn xiàng','兴海县':' xīng hǎi xiàn','止疼片':' zhǐ téng piān','原子钟':' yuán zǐ zhōng','干燥症':' gān zào zhèng','相似形':' xiāng sì xíng','卷筒纸':' juàn tǒng zhǐ','天台宗':' tiān tāi zōng','长洲区':' cháng zhōu qū','漂白水':' piǎo bái shuǐ','电荷量':' diàn hè liàng','方框图':' fāng kuàng tú','扬子江':' yáng zǐ jiāng','兴仁县':' xīng rén xiàn','林甸县':' lín diàn xiàn','长寿区':' cháng shòu qū','长乐宫':' cháng lè gōng','烹调术':' pēng tiáo shù','长期性':' cháng qī xìng','赶得上':' gǎn děi shàng','调味料':' tiáo wèi liào','太行山':' tài háng shān','换挡杆':' huàn dǎng gǎn','兴文县':' xīng wén xiàn','长须鲸':' cháng xū jīng','兴平市':' xīng píng shì','长治市':' cháng zhì shì','金刚钻':' jīn gāng zuàn','空调室':' kōng tiáo shì','曾荫权':' zēng yìn quán','兴宁市':' xīng níng shì','换档杆':' huàn dàng gǎn','丹参酮':' dān shēn tóng','一年生':' yì nián shēng','种植者':' zhòng zhí zhě','瓶塞钻':' píng sāi zuàn','自转轴':' zì zhuàn zhóu','大城市':' dài chéng shì','白娘子':' bái niáng zǐ','应用文':' yìng yòng wén','热效应':' rè xiào yìng','露馅儿':' lòu xiàn ér','易卜生':' yì bǔ shēng','银行业':' yín háng yè','船夫曲':' chuán fū qǔ','受难日':' shòu nàn rì','面条儿':' miàn tiáo r','银行卡':' yín háng kǎ','集电杆':' jí diàn gǎn','电子琴':' diàn zǐ qín','油炸鬼':' yóu zhá guǐ','风信子':' fēng xìn zǐ','不值当':' bù zhí dàng','露马脚':' lòu mǎ jiǎo','半彪子':' bàn biāo zǐ','黄埔区':' huáng pǔ qū','不在行':' bù zài háng','不着家':' bù zháo jiā','快点儿':' kuài diǎn r','香胰子':' xiāng yí zǐ','粘膜炎':' nián mó yán','亲家母':' qìng jiā mǔ','怎么着':' zěn me zhāo','香薄荷':' xiāng bò he','都兰县':' dū lán xiàn','长距离':' cháng jù lí','应力值':' yìng lì zhí','露一手':' lòu yī shǒu','斗六市':' dǒu lìu shì','麻麻亮':' mā mɑ liàng','面人儿':' miàn rén ér','拗口令':' ào kǒu lìng','散文诗':' sǎn wén shī','电子眼':' diàn zǐ yǎn','金铃子':' jīn líng zǐ','冲压机':' chòng yā jī','野颠茄':' yě diān qié','鹿谷乡':' lù gǔ xiāng','出疹子':' chū zhěn zǐ','闹别扭':' nào biè niǔ','反电子':' fǎn diàn zǐ','处理权':' chǔ lǐ quán','干着急':' gān zháo jí','丽水市':' lí shuǐ shì','杂和面':' zá huo miàn','量子沫':' liàng zǐ mò','鸭绿江':' yā lù jiāng','战斗部':' zhàn dǒu bù','金国汗':' jīn guó hán','处理掉':' chǔ lǐ diào','应景儿':' yìng jǐng r','什刹海':' shí chà hǎi','重离子':' zhòng lí zǐ','重复法':' chóng fù fǎ','穿衣服':' chuān yī fu','雪佛龙':' xuě fó lóng','所得税':' suǒ de shuì','黄陂区':' huáng pí qū','戳得住':' chuō de zhù','阴电子':' yīn diàn zǐ','搬舌头':' bān shé tou','擂台赛':' lèi tái sài','齿龈炎':' chǐ yín yán','迎宾曲':' yíng bīn qǔ','放得下':' fàng de xià','采桑子':' cǎi sāng zǐ','硬骨头':' yìng gú tou','草甸子':' cǎo diàn zǐ','两头儿':' liǎng tóu r','测量机':' cè liáng jī','摆擂台':' bǎi lèi tái','测量器':' cè liáng qì','插杠子':' chā gàng zi','占卜者':' zhān bǔ zhě','亨格洛':' hēng gé luò','曲别针':' qǔ bié zhēn','刹那间':' chà nà jiān','韛拐子':' bài guǎi zǐ','摇滚乐':' yáo gǔn yuè','掺沙子':' chān shā zi','敞开儿':' chǎng kāi r','碾磙子':' niǎn gǔn zǐ','调侃儿':' tiáo kǎn ér','笑脸儿':' xiào liǎn r','煤斗车':' méi dǒu chē','梅干菜':' méi gān cài','三班倒':' sān bān dǎo','三毛猫':' sān máo māo','管乐器':' guǎn yuè qì','无名帖':' wú míng tiě','三拗汤':' sān ào tāng','筋斗云':' jīn dǒu yún','蔡侯纸':' cài hòu zhǐ','古典乐':' gǔ diǎn yuè','数来宝':' shǔ lái bǎo','当家子':' dāng jiā zǐ','微电子':' wēi diàn zǐ','择不开':' zhái bù kāi','开拓者':' kāi tuò zhě','扫把星':' sào bǎ xīng','孢子囊':' bāo zǐ náng','傍角儿':' bàng jué ér','德兴市':' dé xīng shì','到了儿':' dào liǎo er','捣练子':' dǎo liàn zǐ','不粘锅':' bù nián guō','报纸夹':' bào zhǐ jiá','长鼻目':' cháng bí mù','子母钟':' zǐ mǔ zhōng','找不到':' zhǎo bu dào','大龙湫':' dà lóng qiū','电子云':' diàn zǐ yún','抽嘴巴':' chōu zuǐ ba','切片机':' qiē piàn jī','押运员':' yā yùn yuán','抱佛脚':' bào fó jiǎo','出大差':' chū dà chāi','大娘子':' dà niáng zǐ','新兴区':' xīn xīng qū','打折票':' dǎ shé piào','蚰蜒草':' yóu dàn cǎo','折跟头':' zhē gēn tou','打麻将':' dǎ má jiàng','新都桥':' xīn dū qiáo','感应器':' gǎn yìng qì','打工仔':' dǎ gōng zǎi','做功夫':' zuò gōng fu','类似点':' lèi sì diǎn','南长区':' nán cháng qū','阳电子':' yáng diàn zǐ','牡丹乡':' mǔ dan xiāng','花朝节':' huā zhāo jié','知识性':' zhī shi xìng','知识面':' zhī shi miàn','颅测量':' lú cè liáng','背带裙':' bēi dài qún','阿房宫':' ē páng gōng','指甲刀':' zhǐ jia dāo','数不清':' shǔ bù qīng','避难权':' bì nàn quán','电子流':' diàn zǐ liú','铺面房':' pū miàn fáng','兵油子':' bīng yóu zǐ','挨时间':' ái shí jiān','摽劲儿':' biào jìn er','卷铺盖':' juǎn pū gài','数不着':' shǔ bù zháo','复兴门':' fù xīng mén','电子门':' diàn zǐ mén','闵行区':' mǐn háng qū','曲江区':' qǔ jiāng qū','颠儿面':' diān r miàn','电子论':' diàn zǐ lùn','悲切切':' bēi qiè qiē','切面机':' qiē miàn jī','二重根':' èr chóng gēn','阳电荷':' yáng diàn hè','电子式':' diàn zǐ shì','苯中毒':' běn zhòng dú','撑得住':' chēng de zhù','磨工病':' mò gōng bìng','文冠果':' wén guàn guǒ','碰钉子':' pèng dìng zǐ','未见得':' wèi jiàn de','牛仔衫':' niú zǎi shān','扎囊县':' zā náng xiàn','女强人':' nǚ qiǎng rén','看不懂':' kàn bu dǒng','扫帚菜':' sào zhǒu cài','女舍监':' nǔ: shè jiān','吃得消':' chī de xiāo','好朋友':' hǎo péng you','钱串儿':' qián chuàn r','隆子县':' lóng zǐ xiàn','龙门刨':' lóng mén bào','剪切板':' jiǎn qiē bǎn','阳曲县':' yáng qǔ xiàn','呱呱叫':' guā guā jiào','吃枪子':' chī qiāng zǐ','三娘子':' sān niáng zǐ','表蒙子':' biǎo méng zǐ','间接费':' jiàn jiē fèi','乱弹琴':' luàn tán qín','博兴县':' bó xīng xiàn','女傧相':' nǚ bīn xiàng','番茄汁':' fān qié zhī','银行学':' yín háng xué','过家家':' guō jiā jiā','韦应物':' wéi yìng wù','车前子':' chē qián zǐ','电子书':' diàn zǐ shū','吃不了':' chī bù liǎo','吃干饭':' chī gān fàn','高丽参':' gāo lí shēn','吃馆子':' chī guǎn zǐ','陈子昂':' chén zǐ áng','赤松子':' chì sōng zǐ','发型师':' fà xíng shī','手腕子':' shǒu wàn zǐ','人缘儿':' rén yuán ér','齿龈音':' chǐ yín yīn','反间计':' fǎn jiàn jì','惠更斯':' huì gēng sī','磁测量':' cí cè liáng','搞不懂':' gǎo bu dǒng','扎猛子':' zhā měng zǐ','长安区':' cháng ān qū','暗适应':' àn shì yìng','电子狗':' diàn zǐ gǒu','打晃儿':' dǎ huàng er','大还丹':' dà huán dān','电子束':' diàn zǐ shù','旁边儿':' páng biān r','仙方儿':' xiān fāng r','高低杠':' gāo dī gàng','贼忒忒':' zéi tuī tuī','打长途':' dǎ cháng tú','电子学':' diàn zǐ xué','肠阻塞':' cháng zǔ sè','重活儿':' zhòng huó r','高丽朝':' gāo lí cháo','间隔号':' jiàn gé hào','音乐节':' yīn yuè jié','原子束':' yuán zǐ shù','叫花子':' jiào huā zǐ','顶尖儿':' dǐng jiān r','鼻梁子':' bí liáng zǐ','嫡长子':' dí zhǎng zǐ','避风头':' bì fēng tou','低转速':' dī zhuàn sù','五虎将':' wǔ hǔ jiàng','音乐会':' yīn yuè huì','标识符':' biāo zhì fú','顺手儿':' shùn shǒu r','一块肉':' yí kuài ròu','原子价':' yuán zǐ jià','原子时':' yuán zǐ shí','澄泥砚':' dèng ní yàn','五苓散':' wǔ líng sǎn','笨家伙':' bèn jiā huo','八行书':' bā háng shū','反知识':' fǎn zhī shi','捅娄子':' tǒng lóu zǐ','有分寸':' yǒu fēn cun','标识码':' biāo zhì mǎ','鱼子酱':' yú zǐ jiàng','不干净':' bù gān jìng','反诘问':' fǎn jié wèn','镇得住':' zhèn de zhù','称得起':' chēng de qǐ','早知道':' zǎo zhī dao','催眠曲':' cuī mián qǔ','童子军':' tóng zǐ jūn','倒春寒':' dǎo chūn hán','小家子':' xiǎo jiā zǐ','东边儿':' dōng biān r','功夫球':' gōng fu qíu','东阿县':' dōng ē xiàn','小崽子':' xiǎo zǎi zǐ','受委屈':' shòu wěi qu','钻门子':' zuàn mén zǐ','石头人':' shí tou rén','乌什县':' wū shí xiàn','解调器':' jiě tiáo qì','兴宾区':' xīng bīn qū','兴义市':' xīng yì shì','乌良哈':' wū liáng hǎ','石榴汁':' shí liu zhī','校验器':' jiào yàn qì','烘干机':' hōng gān jī','连轧机':' lián zhá jī','倒霉蛋':' dǎo méi dàn','刽子手':' guì zǐ shǒu','扩散板':' kuò sǎn bǎn','老爷岭':' lǎo ye lǐng','烘笼儿':' hōng lóng r','浪漫曲':' làng màn qǔ','翻跟头':' fān gēn tou','翻跟斗':' fān gēn dǒu','老家伙':' lǎo jiā huo','雕刻刀':' diāo kè dāo','什件儿':' shí jiàn ér','水泡子':' shuǐ pāo zi','脚腕子':' jiǎo wàn zǐ','翘拇指':' qiáo mǔ zhǐ','天可汗':' tiān kè hán','九曲桥':' jiǔ qǔ qiáo','调节剂':' tiáo jié jì','质子泵':' zhì zǐ bèng','小妹子':' xiǎo mèi zǐ','探亲假':' tàn qīn jià','腮帮子':' sāi bāng zǐ','调节阀':' tiáo jié fá','太子港':' tài zǐ gǎng','分子筛':' fèn zǐ shāi','夫妻相':' fū qī xiàng','挑担子':' tiāo dàn zi','够得着':' gòu de zháo','校对机':' jiào duì jī','间奏曲':' jiàn zòu qǔ','逍遥子':' xiāo yáo zǐ','洛子峰':' luò zǐ fēng','花旗参':' huā qí shēn','没什么':' méi shén me','弹性体':' tán xìng tǐ','波带片':' bō dài piān','不对称':' bù duì chèn','燃灯佛':' rán dēng fó','芫花素':' yuán huā sù','说不到':' shuō bú dào','江西腊':' jiāng xī là','芝麻饼':' zhī ma bǐng','奏鸣曲':' zòu míng qǔ','嚼裹儿':' jiáo guǒ ér','香附子':' xiāng fù zǐ','口角炎':' kǒu jué yán','调皮鬼':' tiáo pí guǐ','压倒性':' yā dǎo xìng','柔佛州':' róu fó zhōu','脊梁骨':' jǐ liáng gǔ','耍骨头':' shuǎ gú tou','不倒翁':' bù dǎo wēng','开卷机':' kāi juàn jī','看家狗':' kān jiā gǒu','刘少奇':' liú shào qí','耍笔杆':' shuǎ bǐ gǎn','筒子楼':' tǒng zǐ lóu','看门狗':' kān mén gǒu','澎湖岛':' péng hú dǎo','树行子':' shù hàng zi','胡涂虫':' hú tu chóng','背黑锅':' bēi hēi guō','多菲什':' duō fēi shí','倒胃口':' dǎo wèi kǒu','相思子':' xiāng sī zǐ','不中意':' bù zhòng yì','济宁市':' jǐ níng shì','肋间肌':' lèi jiān jī','相思曲':' xiāng sī qǔ','听不到':' tīng bu dào','数得着':' shǔ de zháo','童子痨':' tóng zǐ láo','空白符':' kòng bái fú','女神蛤':' nǔ: shén gé','铺盖卷':' pū gài juǎn','看花眼':' kān huā yǎn','剪头发':' jiǎn tóu fa','不划算':' bù huá suàn','比不上':' bǐ bù shǎng','罄身儿':' qìng shēn r','无为县':' wú wéi xiàn','升压器':' shēng yà qì','嫌麻烦':' xián má fan','再发见':' zài fā xiàn','先君子':' xiān jūn zǐ','冷处理':' lěng chǔ lǐ','沈尹默':' shěn yǐn mò','核反应':' hé fǎn yìng','包干制':' bāo gān zhì','热干面':' rè gān miàn','核门槛':' hé mén jiàn','室间隔':' shì jiàn gé','理发匠':' lǐ fà jiàng','漂白剂':' piǎo bái jì','不协调':' bù xié tiáo','上钩儿':' shàng gōu r','总书记':' zǒng shū ji','刘涓子':' líu juān zǐ','氧乙炔':' yǎng yǐ quē','前奏曲':' qián zòu qǔ','会计室':' kuài jì shì','钟子期':' zhōng zǐ qī','够不着':' gòu bù zháo','漏斗云':' lòu dǒu yún','抗倒伏':' kàng dǎo fú','前边儿':' qián bian r','剪切力':' jiǎn qiē lì','甩负荷':' shuǎi fù hè','没得说':' méi de shuō','小器作':' xiǎo qì zuō','章子怡':' zhāng zǐ yí','消闲儿':' xiāo xián r','罗唝曲':' luó gòng qǔ','那程子':' nà chéng zǐ','脑梗塞':' nǎo gěng sè','缝纫机':' féng rèn jī','烧茄子':' shāo qié zi','知识界':' zhī shi jiè','沈钧儒':' shěn jūn rú','海陆空':' hǎi lù kòng','农家子':' nóng jiā zǐ','太子参':' tài zǐ shēn','哀伤地':' āi shāng de','咽鼓管':' yān gǔ guǎn','咽峡炎':' yān xiá yán','罗刹国':' luó chà guó','淋溶土':' lìn róng tǔ','炮筒子':' pào tǒng zǐ','咔哒声':' kǎ da shēng','短打扮':' duǎn dǎ ban','乐学者':' yuè xué zhě','牛头刨':' niú tóu bào','片儿会':' piān er huì','淋球菌':' lìn qíu jūn','眼见得':' yǎn jiàn de','漂白液':' piǎo bái yè','漂泊者':' piāo bó zhě','太过分':' tài guò fèn','出乱子':' chū luàn zǐ','三都县':' sān dū xiàn','系列片':' xì liè piān','漂流物':' piāo liú wù','切削液':' qiē xiāo yè','一面倒':' yī miàn dǎo','伤和气':' shāng hé qi','抹灰层':' mò huī céng','叫化子':' jiào huā zi','积累性':' jī lěi xìng','穆棱市':' mù líng shì','窝囊废':' wō nāng fèi','做工夫':' zuò gōng fu','麻纤维':' mā xiān wéi','男人家':' nán rén jia','上一个':' shàng yī ge','量热器':' liáng rè qì','绮想曲':' qǐ xiǎng qǔ','发横财':' fā hèng cái','看不见':' kàn bú jiàn','栽跟头':' zāi gēn tou','四方台':' sì fāng tái','经不住':' jīng bu zhù','发现号':' fā xiàn háo','主合同':' zhǔ hé tong','桌面儿':' zhuō miàn r','扎线带':' zā xiàn dài','切削机':' qiē xiāo jī','旅行家':' lǚ háng jia','鹿角菜':' lù jiǎo cài','假招子':' jiǎ zhāo zǐ','露头角':' lù tóu jiǎo','卿大夫':' qīng dài fū','漂流木':' piāo liú mù','真是的':' zhēn shi de','调频器':' tiáo pín qì','枯萎病':' kū wěi bìng','国子监':' guó zǐ jiàn','说什么':' shuō shí mǒ','胃粘膜':' wèi nián mó','台面呢':' tái miàn ní','小叔子':' xiǎo shū zǐ','决明子':' jué míng zǐ','兴奋剂':' xīng fèn jì','说得来':' shuō de lái','尽全力':' jìn quán lì','尽人事':' jìn rén shì','天老爷':' tiān lǎo ye','金樱子':' jīn yīng zǐ','用得着':' yòng de zháo','切肉刀':' qiē ròu dāo','水磨沟':' shuǐ mò gōu','弹跳力':' tán tiào lì','调制器':' tiáo zhì qì','调音器':' tiáo yīn qì','调谐器':' tiáo xié qì','知制诰':' zhī zhì gào','调温器':' tiáo wēn qì','小石子':' xiǎo shí zǐ','太子党':' tài zǐ dǎng','自适应':' zì shì yìng','大麦町':' dà mài tǐng','柞丝绸':' zuò sī chóu','小人儿':' xiǎo rén er','京油子':' jīng yóu zǐ','说头儿':' shuō tou er','粘土岩':' nián tǔ yán','踏莎行':' tà suō xíng','酸处理':' suān chǔ lǐ','看门人':' kān mén rén','弹劾权':' tán hé quán','碳原子':' tàn yuán zǐ','磁感应':' cí gǎn yìng','秒差距':' miǎo chā jù','淮南子':' huái nán zǐ','酸奶子':' suān nǎi zǐ','福清市':' fú qīng shì','闹乱子':' nào luàn zǐ','私生子':' sī shēng zǐ','脑萎缩':' nǎo wěi suō','枪杆儿':' qiāng gǎn r','内应力':' nèi yìng lì','馊点子':' sōu diǎn zǐ','水处理':' shuǐ chǔ lǐ','福鼎市':' fú dǐng shì','尽可能':' jìn kě néng','福泉市':' fú quán shì','磨坊主':' mò fáng zhǔ','别着急':' bié zháo jí','福州市':' fú zhōu shì','水饺儿':' shuǐ jiǎo r','槐荫区':' huái yìn qū','文曲星':' wén qǔ xīng','票贩子':' piào fàn zǐ','粘结剂':' nián jié jì','转速比':' zhuàn sù bǐ','粘结力':' nián jié lì','狮子乡':' shī zǐ xiāng','余干县':' yú gān xiàn','栽种机':' zāi zhòng jī','背饥荒':' bēi jī huāng','整脊学':' zhěng jǐ xué','纠结点':' jīu jiē diǎn','两三个':' liǎng sān ge','桦甸市':' huà diàn shì','嚼舌头':' jiáo shé tou','盘杠子':' pán gàng zi','恐吓信':' kǒng hè xìn','内切球':' nèi qiē qíu','粮食局':' liáng shi jú','二人转':' èr rén zhuàn','千佛山':' qiān fó shān','应急灯':' yìng jí dēng','嚼舌根':' jiáo shé gēn','斗南镇':' dǒu nán zhèn','反斜杠':' fǎn xié gàng','切削刃':' qiē xiāo rèn','西洋参':' xī yáng shēn','偏差值':' piān chā zhí','藏青色':' zàng qīng sè','喘不过':' chuǎn bu guò','反应锅':' fǎn yìng guō','乐清市':' yuè qīng shì','鲁甸县':' lǔ diàn xiàn','横爬行':' héng pá xíng','亚平宁':' yà píng nìng','土党参':' tǔ dǎng shēn','良家子':' liáng jiā zǐ','畹町市':' wǎn dīng shì','金曲奖':' jīn qǔ jiǎng','蒙松雨':' mēng sōng yǔ','单房差':' dān fáng chā','星宿海':' xīng xiù hǎi','命名法':' mìng míng fǎ','反间谍':' fǎn jiàn dié','鲗鱼涌':' zéi yú chōng','五通神':' wǔ tòng shén','无穷尽':' wú qióng jìn','行为学':' xíng wéi xué','时间差':' shí jiān chā','量体温':' liáng tǐ wēn','切削面':' qiē xuē miàn','切削角':' qiē xuē jiǎo','缅甸语':' miǎn diàn yǔ','小胡同':' xiǎo hú tòng','钻井机':' zuàn jǐng jī','定冠词':' dìng guàn cí','竹扫帚':' zhú sào zhou','八重奏':' bā chóng zòu','煎炸油':' jiān zhá yóu','睡午觉':' shuì wǔ jiào','彭丽媛':' péng lì yuán','王世子':' wáng shì zǐ','皮划艇':' pí huá tǐng','门框子':' mén kuàng zi','应变力':' yìng biàn lì','前处理':' qián chǔ lǐ','黄葛树':' huáng gě shù','伸舌头':' shēn shé tou','均方差':' jūn fāng chā','莲花落':' lián huā lào','军乐团':' jūn yuè tuán','子洲县':' zǐ zhōu xiàn','控制杆':' kòng zhì gǎn','反应堆':' fǎn yìng duī','龙兴寺':' lóng xīng sì','的确良':' dí què liáng','召陵区':' shào líng qū','反应式':' fǎn yìng shì','出差费':' chū chāi fèi','烘干窑':' hōng gān yáo','指甲剪':' zhǐ jia jiǎn','三只手':' sān zhī shǒu','烘干室':' hōng gān shì','蔺相如':' lìn xiàng rú','命名日':' mìng míng rì','陪产假':' péi chǎn jià','两着儿':' liǎng zhāo r','片儿汤':' piān er tāng','鹿角胶':' lù jiǎo jiāo','无将牌':' wú jiàng pái','槟榔屿':' bīng láng yǔ','切换到':' qiē huàn dào','闪亮儿':' shǎn liàng r','两下子':' liǎng xià zǐ','应试者':' yìng shì zhě','均匀性':' jūn yún xìng','华兴会':' huá xīng huì','兴教寺':' xīng jiào sì','繁峙县':' fán shì xiàn','黏涎子':' nián xián zǐ','缝针迹':' féng zhēn jì','元好问':' yuán hào wèn','回流泵':' huí liú bèng','子宫环':' zǐ gōng huán','绷弓子':' bēng gōng zi','增压泵':' zēng yà bèng','蒙嘉慧':' měng jiā huì','北斗星':' běi dǒu xīng','枪子儿':' qiāng zǐ er','姬松茸':' jī sōng róng','当回事':' dàng huí shì','射流泵':' shè liú bèng','黄药子':' huáng yào zǐ','真番郡':' zhēn pān jùn','山岗子':' shān gāng zǐ','冲盹儿':' chòng dǔn er','酶反应':' méi fǎn yìng','银行家':' yín háng jiā','麻将牌':' má jiàng pái','算不了':' suàn bù liǎo','总干事':' zǒng gàn shi','汇出行':' huì chū háng','行道树':' háng dào shù','振兴区':' zhèn xīng qū','北斗镇':' běi dǒu zhèn','影片儿':' yǐng piān er','司天台':' sī tiān tāi','圆石头':' yuán shí tou','成都市':' chéng dū shì','成方儿':' chéng fāng r','雄配子':' xíong pèi zǐ','总供给':' zǒng gōng jǐ','十天干':' shí tiān gān','受不了':' shòu bù liǎo','冲劲儿':' chòng jìn er','朴槿惠':' piáo jǐn huì','千佛洞':' qiān fó dòng','燕麦粥':' yān mài zhōu','娃娃装':' wá wa zhuāng','山桐子':' shān tóng zǐ','嘉荫县':' jiā yìn xiàn','自感应':' zì gǎn yìng','王尽美':' wáng jìn měi','子弹箱':' zǐ dàn xiāng','著作权':' zhù zuò quán','爪尖儿':' zhuǎ jiān er','少女风':' shào nǚ fēng','五行阵':' wǔ háng zhèn','马生角':' mǎ shēng jué','横筋斗':' héng jīn dǒu','可行性':' kě xíng xìng','黏着语':' nián zhuó yǔ','开拓性':' kāi tuò xìng','不着调':' bù zháo diào','童子尿':' tóng zǐ niào','两个月':' liǎng ge yuè','穷骨头':' qióng gú tou','李公朴':' lǐ gōng piáo','子宫颈':' zǐ gōng jǐng','数九天':' shǔ jǐu tiān','粘性力':' nián xìng lì','皇太子':' huáng tài zǐ','装糊涂':' zhuāng hú tu','瞎忙活':' xiā máng huo','协调人':' xié tiáo rén','李重茂':' lǐ chóng mào','李昌镐':' lǐ chāng hào','拍卖行':' pāi mài háng','手指头':' shǒu zhí tou','子宫炎':' zǐ gōng yán','长袍儿':' cháng páo er','长途车':' cháng tú chē','嘉兴市':' jiā xīng shì','协方差':' xié fāng chā','绿茸茸':' lǜ róng róng','给事中':' jǐ shì zhōng','粘着力':' zhān zhuó lì','上大夫':' shàng dài fū','管不着':' guǎn bu zháo','落埋怨':' lào mán yuàn','随风倒':' suí fēng dǎo','黏着力':' nián zhuó lì','粘胶液':' nián jiāo yè','脊神经':' jǐ shén jīng','甚高频':' shèn gāo pín','着陆点':' zhuó lù diǎn','汽缸盖':' qì gāng gài','套口供':' tào kǒu gòng','硬着陆':' yìng zhuó lù','粘性土':' nián xìng tǔ','一点点':' yì diǎn diǎn','脚蹬子':' jiǎo dēng zǐ','转载机':' zhuǎn zǎi jī','列女传':' liè nǚ zhuàn','色达县':' shǎi dá xiàn','打孔钻':' dǎ kǒng zuàn','大长今':' dà cháng jīn','脑栓塞':' nǎo shuān sè','娘子军':' niáng zǐ jūn','失忆症':' shī yì zhèng','钌铞儿':' liào diào ér','抓功夫':' zhuā gōng fu','主属性':' zhǔ shǔ xìng','间谍罪':' jiàn dié zuì','看不中':' kàn bu zhōng','校勘学':' jiào kān xué','东兴区':' dōng xīng qū','绿营兵':' lù yíng bīng','失身分':' shī shēn fèn','打水漂':' dǎ shuǐ piāo','塞上曲':' sāi shàng qǔ','占地方':' zhàn dì fang','抗干扰':' kàng gān rǎo','接插件':' jiē chā jiàn','校准仪':' jiào zhǔn yí','校准器':' jiào zhǔn qì','舟曲县':' zhōu qǔ xiàn','小家伙':' xiǎo jiā huo','大黄鱼':' dài huáng yú','脚指头':' jiǎo zhǐ tou','钻空子':' zuān kòng zi','量子态':' liàng zǐ tài','找不着':' zhǎo bu zháo','转弯子':' zhuàn wān zi','搓麻将':' cuō má jiàng','效应器':' xiào yìng qì','大藏经':' dà zàng jīng','枕头套':' zhěn tou tào','兴山区':' xīng shān qū','中大夫':' zhōng dài fū','搬楦头':' bān xuàn tou','泼脏水':' pō zāng shuǐ','兴宁区':' xīng níng qū','脑卒中':' nǎo cù zhòng','受难者':' shòu nàn zhě','进给量':' jìn jǐ liàng','粘合胶':' nián hé jiāo','切断机':' qiē duàn jī','科教片':' kē jiào piān','榴霰弹':' liú xiàn dàn','垣曲县':' yuán qǔ xiàn','兴庆区':' xīng qìng qū','小王子':' xiǎo wáng zǐ','看得中':' kàn de zhòng','兴业县':' xīng yè xiàn','吊膀子':' diào bàng zi','果子酱':' guǒ zǐ jiàng','二重奏':' èr chóng zòu','卷心菜':' juàn xīn cài','内切圆':' nèi qiē yuán','看上去':' kàn shang qu','珲春市':' hún chūn shì','招待会':' zhāo dāi huì','柏林墙':' bó lín qiáng','兴安县':' xīng ān xiàn','长恨歌':' cháng hèn gē','枪杆子':' qiāng gǎn zi','省劲儿':' shěng jìn r','兴安盟':' xīng ān méng','四重奏':' sì chóng zòu','天晓得':' tiān xiǎo de','兴化市':' xīng huà shì','兴和县':' xīng hé xiàn','脚趾头':' jiǎo zhǐ tou','脚指甲':' jiǎo zhǐ jia','上边儿':' shàng bian r','大将军':' dà jiàng jūn','长乐市':' cháng lè shì','乾安县':' qián ān xiàn','漂白粉':' piǎo bái fěn','应聘者':' yìng pìn zhě','缝衣针':' féng yī zhēn','原子能':' yuán zǐ néng','不相干':' bù xiāng gān','萧子显':' xiāo zǐ xiǎn','人参果':' rén shēn guǒ','还魂丹':' huán hún dān','新干县':' xīn gān xiàn','切菜板':' qiē cài bǎn','用不着':' yòng bù zháo','生闷气':' shēng mēn qì','载驳船':' zǎi bó chuán','行李卷':' xíng lǐ juàn','生查子':' shēng zhā zǐ','星子县':' xīng zǐ xiàn','双子叶':' shuāng zǐ yè','用不了':' yòng bù liǎo','文化圈':' wén huà juàn','孔丛子':' kǒng cóng zǐ','生发油':' shēng fà yóu','看守所':' kān shǒu suǒ','多水分':' duō shuǐ fèn','子空间':' zǐ kōng jiān','薄瑞光':' bó ruì guāng','校验位':' jiào yàn wèi','子宫内':' zǐ gōng nèi','应变仪':' yìng biàn yí','夜行性':' yè xíng xìng','子宫瘤':' zǐ gōng liú','新娘子':' xīn niáng zǐ','长安街':' cháng ān jiē','乾隆帝':' qián lóng dì','京片子':' jīng piān zi','照片子':' zhào piān zi','林家翘':' lín jiā qiáo','抽空机':' chōu kòng jī','华罗庚':' huà luó gēng','指定值':' zhǐ dìng zhí','南乡子':' nán xiāng zǐ','抽冷子':' chōu lěng zǐ','量子数':' liàng zǐ shù','冷脸子':' lěng liǎn zǐ','倒下':' dǎo xià','奇零':' jī líng','军乐':' jūn yuè','菌伞':' jùn sǎn','倒坍':' dǎo tān','华佗':' huà tuó','脊线':' jǐ xiàn','伽蓝':' qié lán','棘爪':' jí zhuǎ','华为':' huá wéi','着意':' zhuó yì','闭卷':' bì juàn','莲子':' lián zǐ','妹妹':' mèi mei','菌盖':' jùn gài','好学':' hào xué','子房':' zǐ fáng','杓子':' sháo zi','有处':' yǒu chǔ','肢势':' zhī shì','变子':' biàn zǐ','臣子':' chén zǐ','骄子':' jiāo zǐ','发指':' fà zhǐ','卷末':' juàn mò','大宛':' dà yuān','度假':' dù jià','居丧':' jū sāng','缏子':' biàn zǐ','莎草':' suō cǎo','小纪':' xiǎo jǐ','脱脱':' tuì tuì','本处':' běn chǔ','着急':' zháo jí','隽秀':' jùn xiù','柄子':' bǐng zǐ','二舍':' èr shè','杏子':' xìng zǐ','着地':' zháo dì','夹被':' jiá bèi','倒灶':' dǎo zào','胶子':' jiāo zǐ','关子':' guān zǐ','脚本':' jué běn','着力':' zhuó lì','著作':' zhù zuò','直切':' zhí qiē','华视':' huà shì','姐姐':' jiě jie','村舍':' cūn shè','着法':' zhāo fǎ','朴硝':' pò xiāo','临难':' lín nàn','间隙':' jiàn xì','萹蓄':' biān xù','笑呀':' xiào yā','落价':' lào jià','好斗':' hào dòu','蒙覆':' měng fù','着墨':' zhuó mò','九难':' jiǔ nàn','兵子':' bīng zǐ','智识':' zhì shí','临帖':' lín tiè','座子':' zuò zǐ','剪发':' jiǎn fà','子宫':' zǐ gōng','灶头':' zào tou','大兴':' dà xīng','着色':' zhuó sè','茶匙':' chá chí','茅舍':' máo shè','阿城':' a chéng','着笔':' zhuó bǐ','挑拨':' tiǎo bō','着棋':' zhuó qí','剥除':' bāo chú','庶几':' shù jī','倒反':' dǎo fǎn','间隔':' jiàn gé','兴革':' xīng gé','兴波':' xīng bō','卷次':' juàn cì','究诘':' jiū jié','舍下':' shè xià','悲咽':' bēi yān','华陀':' huà tuó','莲都':' lián dū','给养':' jǐ yǎng','庶子':' shù zǐ','落魄':' luò tuò','落难':' luò nàn','继兴':' jì xīng','脖颈':' bó gěng','菸斗':' yān dǒu','落藉':' luò jiè','子产':' zǐ chǎn','家舍':' jiā shè','背着':' bēi zhe','蔚为':' wèi wéi','子洲':' zǐ zhōu','发鬓':' fà bìn','家什':' jiā shí','灶火':' zào huō','萎蕤':' wěi ruí','藏历':' zàng lì','削皮':' xiāo pí','萎缩':' wěi suō','小曲':' xiǎo qǔ','倒是':' dǎo shì','自省':' zì xǐng','挑拔':' tiǎo bá','腱子':' jiàn zǐ','臣仆':' chén pú','子层':' zǐ céng','卷第':' juàn dì','著书':' zhù shū','家累':' jiā lěi','芥兰':' gài lán','行卜':' xíng bǔ','条几':' tiáo jī','丧礼':' sāng lǐ','答讪':' dā shàn','摇杆':' yáo gǎn','策应':' cè yìng','门斗':' mén dǒu','蒙医':' měng yī','筋斗':' jīn dǒu','嗔喝':' chēn hè','乱子':' luàn zǐ','丧仪':' sāng yí','哗然':' huá rán','团子':' tuán zǐ','红曲':' hóng qǔ','杆菌':' gǎn jūn','蹊径':' xī jìng','啴啴':' tān tān','抡才':' lún cái','读为':' dú wéi','引得':' yǐn de','丧服':' sāng fú','猛子':' měng zǐ','栽倒':' zāi dǎo','卖解':' mài xiè','粘合':' nián hé','粘土':' nián tǔ','粘度':' nián dù','粘液':' nián yè','都下':' dū xià','兜子':' dōu zǐ','五通':' wǔ tòng','斗子':' dǒu zi','梵呗':' fàn bài','管子':' guǎn zǐ','篼子':' dōu zǐ','算子':' suàn zǐ','搜查':' sōu zhā','答卷':' dá juàn','恶寒':' wù hán','答应':' dā yìng','备查':' bèi zhā','伞菌':' sǎn jùn','蒙族':' měng zú','乾安':' qián ān','喽喽':' lou lou','牤子':' māng zǐ','龈音':' yín yīn','梗塞':' gěng sè','糊弄':' hù nòng','嘉荫':' jiā yìn','罗罗':' luō luō','多得':' duō de','桑耶':' sāng yē','家伙':' jiā huo','笔供':' bǐ gòng','隆子':' lóng zǐ','粘附':' nián fù','攮子':' nǎng zǐ','式子':' shì zǐ','难友':' nàn yǒu','秦桧':' qín huì','难属':' nàn shǔ','难舍':' nán shè','俭薄':' jiǎn bó','秧子':' yāng zǐ','稍息':' shào xī','精子':' jīng zǐ','八行':' bā háng','累累':' lěi lěi','论著':' lùn zhù','引子':' yǐn zǐ','漏尽':' lòu jìn','拢子':' lǒng zǐ','龙子':' lóng zǐ','累进':' lěi jìn','桔槔':' jié gāo','揭载':' jiē zǎi','论处':' lùn chǔ','嗜好':' shì hào','粘膜':' nián mó','墩子':' dūn zǐ','粘米':' nián mǐ','砘子':' dùn zǐ','抹脸':' mā liǎn','难民':' nàn mín','假藉':' jiǎ jiè','粘糊':' nián hū','粘聚':' nián jù','论难':' lùn nàn','做为':' zuò wéi','都头':' dū tóu','校核':' jiào hé','兴义':' xīng yì','舌头':' shé tou','不当':' bù dàng','诘难':' jié nán','阿房':' ē páng','兴起':' xīng qǐ','几近':' jī jìn','揭帖':' jiē tiě','兴许':' xīng xǔ','几至':' jī zhì','酵子':' jiào zǐ','舍友':' shè yǒu','苦差':' kǔ chāi','子丑':' zǐ chǒu','几微':' jī wēi','奏帖':' zòu tiě','着衣':' zhuó yī','著述':' zhù shù','婊子':' biǎo zǐ','间日':' jiàn rì','叫子':' jiào zǐ','婚假':' hūn jià','苦参':' kǔ shēn','倒数':' dào shǔ','法帖':' fǎ tiè','幸得':' xìng de','至为':' zhì wéi','发噱':' fā xué','行都':' xíng dū','奇羡':' jī xiàn','倒败':' dǎo bài','倒休':' dǎo xiū','舟曲':' zhōu qǔ','着魔':' zháo mó','只眼':' zhī yǎn','兴发':' xīng fā','别别':' biè biè','压蔓':' yā wàn','子京':' zǐ jīng','臧否':' zāng pǐ','娇子':' jiāo zǐ','庇荫':' bì yìn','交子':' jiāo zǐ','间色':' jiàn sè','嫌恶':' xián wù','停泊':' tíng bó','厨子':' chú zǐ','脊令':' jí líng','幡子':' fān zǐ','梵刹':' fàn chà','没什':' méi shí','筛子':' shāi zǐ','没乱':' mò luàn','傀儡':' kuǐ lěi','菲薄':' fěi bó','干与':' gān yù','脊椎':' jǐ zhuī','痘子':' dòu zǐ','弹劾':' tán hé','斗渠':' dǒu qú','弹力':' tán lì','没顶':' mò dǐng','了局':' liǎo jú','都试':' dū shì','附着':' fù zhuó','单于':' chán yú','倒蛋':' dǎo dàn','凡子':' fán zǐ','若干':' ruò gān','兴德':' xīng dé','女红':' nǚ gōng','着迷':' zháo mí','阑干':' lán gān','苗子':' miáo zǐ','栟榈':' bīng lǘ','般游':' pán yóu','挑起':' tiǎo qǐ','藏医':' zàng yī','仓卒':' cāng cù','间杂':' jiàn zá','芥蓝':' gài lán','五更':' wǔ gēng','奠都':' diàn dū','藏戏':' zàng xì','浇薄':' jiāo bó','色子':' shǎi zǐ','干吗':' gàn má','奔头':' bèn tóu','奏乐':' zòu yuè','脾脏':' pí zāng','探子':' tàn zǐ','晕乎':' yūn hu','瓦舍':' wǎ shè','挨宰':' ái zǎi','微曲':' wēi qǔ','不究':' bù jiù','幽咽':' yōu yè','挨克':' ái kēi','瘪子':' biě zǐ','制曲':' zhì qǔ','假日':' jià rì','别子':' bié zǐ','剥取':' bāo qǔ','一到':' yí dào','韦曲':' wéi qǔ','不处':' bù chǔ','不倒':' bù dǎo','拾级':' shè jí','议处':' yì chǔ','佛号':' fó hào','子惠':' zǐ huì','补假':' bǔ jià','寓舍':' yù shè','仔仔':' zǐ zǎi','不价':' bù jie','挨斗':' ái dòu','鼻血':' bí xiě','鬓发':' bìn fà','拉呱':' lā guā','外子':' wài zǐ','企划':' qǐ huá','吐泻':' tù xiè','蟹子':' xiè zǐ','杈子':' chā zǐ','凯撒':' kǎi sǎ','系留':' jì liú','汊子':' chà zǐ','扎紧':' zā jǐn','些子':' xiē zǐ','拮据':' jié jū','捏脊':' niē jǐ','舍得':' shè de','挨揍':' ái zòu','贝子':' bèi zǐ','褙子':' bèi zǐ','倒戈':' dǎo gē','一撇':' yī piě','背子':' bēi zi','不是':' bú shì','干洗':' gān xǐ','假期':' jià qī','锛子':' bēn zǐ','与人':' yú rén','压载':' yā zǎi','屋舍':' wū shè','隽誉':' jùn yù','散记':' sǎn jì','簪子':' zān zǐ','于思':' yú sāi','散发':' sàn fà','隐没':' yǐn mò','雅什':' yǎ shí','雅乐':' yǎ yuè','门子':' mén zǐ','倒爷':' dǎo yé','斗大':' dǒu dà','由得':' yóu de','佛门':' fó mén','不住':' bú zhù','作曲':' zuò qǔ','投子':' tóu zǐ','佛陀':' fó tuó','有得':' yǒu de','作揖':' zuō yī','不到':' bú dào','铺设':' pū shè','作死':' zuō sǐ','佛龛':' fó kān','晏子':' yàn zǐ','陪都':' péi dū','子金':' zǐ jīn','倒卧':' dǎo wò','阿扁':' a biǎn','发式':' fà shì','帵子':' wān zǐ','拂士':' bì shì','阿胶':' ē jiāo','数伏':' shǔ fú','阇梨':' shé lí','阇黎':' shé lí','阻难':' zǔ nàn','阿亨':' a hēng','子都':' zǐ dōu','哪些':' něi xiē','除子':' chú zǐ','眼子':' yǎn zǐ','子衿':' zǐ jīn','阿明':' a míng','雁子':' yàn zǐ','阿盟':' a méng','阿莲':' a lián','文蛤':' wén gé','烟子':' yān zǐ','檐子':' yán zǐ','散体':' sǎn tǐ','押头':' yā tou','假发':' jiǎ fà','云子':' yún zǐ','崽子':' zǎi zǐ','北曲':' běi qǔ','保子':' bǎo zǐ','一只':' yì zhī','崴子':' wēi zǐ','不遂':' bù suí','一匙':' yī chí','只如':' zhī rú','扫把':' sào bǎ','子书':' zǐ shū','八斗':' bā dǒu','安处':' ān chǔ','折子':' zhé zǐ','哲子':' zhé zǐ','撒门':' sǎ mén','载负':' zǎi fù','臆度':' yì duó','侉子':' kuǎ zǐ','为底':' wéi dǐ','似雪':' sì xuě','一干':' yī gān','魏都':' wèi dū','自处':' zì chǔ','折翼':' shé yì','例假':' lì jià','值得':' zhí de','宝子':' bǎo zǐ','鲍耶':' bào yē','熬菜':' āo cài','提溜':' dī liū','插曲':' chā qǔ','采邑':' cài yì','掖门':' yè mén','八舍':' bā shè','稗子':' bài zǐ','百子':' bǎi zǐ','铁耙':' tiě pá','败子':' bài zǐ','没药':' mò yào','质的':' zhì dì','为力':' wéi lì','一化':' yī huā','伺候':' cì hou','湾泊':' wān bó','版子':' bǎn zǐ','绊子':' bàn zǐ','西乐':' xī yuè','为乐':' wéi lè','半子':' bàn zǐ','颉利':' xié lì','柈子':' bàn zǐ','剥壳':' bāo ké','魔难':' mó nàn','鹄候':' hú hòu','查理':' zhā lǐ','拓跋':' tuò bá','一舍':' yī shè','拜佛':' bài fó','不为':' bù wéi','主仆':' zhǔ pú','拗口':' ào kǒu','羞恶':' xiū wù','分子':' fèn zǐ','崴泥':' wēi ní','拖沓':' tuō tà','杂处':' zá chǔ','彩子':' cǎi zǐ','许处':' xǔ chǔ','菜子':' cài zǐ','佚失':' yì shī','拓扑':' tuò pū','穇子':' cǎn zǐ','不会':' bú huì','拶子':' zǎn zǐ','征辟':' zhǐ bì','槽子':' cáo zǐ','艚子':' cáo zǐ','拉杆':' lā gǎn','差可':' chā kě','拓拔':' tuò bá','发菜':' fà cài','下都':' xià dū','乐舞':' yuè wǔ','着哩':' zhe lǐ','下得':' xià de','盐都':' yán dū','麇集':' qún jí','丽致':' lí zhì','摩莎':' mó suō','暗查':' àn zhā','鼻咽':' bí yān','之子':' zhī zǐ','齱齵':' zōu yú','倒把':' dǎo bǎ','挨延':' ái yán','不对':' bú duì','子畜':' zǐ chù','龟兹':' qiū cí','吐血':' tù xiě','假子':' jiǎ zǐ','阿顺':' ē shùn','倒序':' dǎo xù','丹佛':' dān fó','欸乃':' ǎi nǎi','哀切':' āi qiē','自好':' zì hào','干枯':' gān kū','环子':' huán zǐ','不菲':' bù fěi','休得':' xiū de','乐户':' yuè hù','担荷':' dān hè','乜嘢':' niè yě','人子':' rén zǐ','摆子':' bǎi zǐ','仆人':' pú rén','子月':' zǐ yuè','怎得':' zěn de','不要':' bú yào','饮马':' yìn mǎ','推子':' tuī zǐ','瓦刀':' wà dāo','心曲':' xīn qǔ','乙炔':' yǐ quē','囤聚':' tún jù','帷子':' wéi zǐ','干儿':' gān ér','以为':' yǐ wéi','问卜':' wèn bǔ','乐歌':' yuè gē','贼子':' zéi zǐ','倒塌':' dǎo tā','干渴':' gān kě','托子':' tuō zǐ','砟子':' zhǎ zǐ','委蛇':' wēi yí','译著':' yì zhù','露富':' lòu fù','俟候':' sì hòu','脱模':' tuō mú','逾分':' yú fèn','屯堡':' tún pù','露底':' lòu dǐ','什叶':' shí yè','摊薄':' tān bó','介子':' jiè zǐ','鞋子':' xié zǐ','乳晕':' rǔ yùn','贴子':' tiē zǐ','围子':' wéi zǐ','幼子':' yòu zǐ','渣子':' zhā zǐ','芯子':' xìn zǐ','倒伏':' dǎo fú','文曲':' wén qǔ','子侄':' zǐ zhí','闻得':' wén de','余处':' yú chǔ','兀鹫':' wū jiù','不禁':' bù jīn','五斗':' wǔ dǒu','枸橼':' jǔ yuán','枝蔓':' zhī wàn','边子':' biān zǐ','天呀':' tiān yā','兴复':' xīng fù','擘画':' bò huà','擘划':' bò huà','直指':' zhí zhǐ','尽瘁':' jìn cuì','回煞':' huí shà','落拓':' luò tuò','头发':' tóu fà','营子':' yíng zǐ','颓靡':' tuí mǐ','壅塞':' yōng sè','指头':' zhǐ tou','拉倒':' lā dǎo','抿子':' mǐn zǐ','剥脱':' bāo tuō','镚子':' bèng zǐ','卷叶':' juàn yè','绢子':' juàn zǐ','獾子':' huān zǐ','绷瓷':' bèng cí','兴福':' xīng fú','尽好':' jìn hǎo','只鸡':' zhī jī','尽美':' jìn měi','倒槽':' dǎo cáo','兴业':' xīng yè','缨子':' yīng zǐ','比兴':' bǐ xīng','架式':' jià shi','擦干':' cā gān','阏氏':' yān zhī','挎斗':' kuà dǒu','回弹':' huí tán','净得':' jìng de','倒楣':' dǎo méi','擘开':' bò kāi','只在':' zhī zài','尽然':' jìn rán','尽人':' jìn rén','颇为':' pō wéi','杏脯':' xìng fǔ','兴安':' xīng ān','兴和':' xīng hé','天子':' tiān zǐ','天哪':' tiān na','致知':' zhì zhī','头儿':' tou er','优子':' yōu zǐ','只此':' zhī cǐ','一撮':' yī zuǒ','子男':' zǐ nán','凿子':' záo zǐ','旅舍':' lǚ shè','下子':' xià zǐ','主薄':' zhǔ bù','旄期':' mào qī','旄倪':' mào ní','新都':' xīn dū','隽语':' jùn yǔ','散曲':' sǎn qǔ','干涸':' gān hé','发带':' fà dài','干衣':' gān yī','子道':' zǐ dào','子口':' zǐ kǒu','驮子':' duò zǐ','宛似':' wǎn sì','只字':' zhī zì','类似':' lèi sì','使得':' shǐ de','食肆':' shí sì','倒闭':' dǎo bì','熨帖':' yù tiē','来得':' lái de','何干':' hé gān','日头':' rì tou','饿莩':' è piǎo','佛学':' fó xué','支子':' zhī zǐ','昧没':' mèi mò','投得':' tóu de','金发':' jīn fà','饮子':' yǐn zǐ','铺排':' pū pái','铺摆':' pū bǎi','铺摊':' pū tan','铺盖':' pū gài','佛家':' fó jiā','鹞子':' yào zǐ','夏子':' xià zǐ','倒替':' dǎo tì','入肉':' rù ròu','入月':' rù yuè','铺轨':' pū guǐ','学佛':' xué fó','与闻':' yù wén','斗笠':' dǒu lì','倒毙':' dǎo bì','镏子':' liù zǐ','何处':' hé chǔ','錾子':' zàn zǐ','扑倒':' pū dǎo','余切':' yú qiē','信佛':' xìn fó','一宿':' yī xiǔ','高丽':' gāo lí','不尽':' bù jìn','圩子':' wéi zǐ','催吐':' cuī tù','油子':' yóu zǐ','腿子':' tuǐ zǐ','釉子':' yòu zǐ','击倒':' jī dǎo','担搁':' dān ge','直得':' zhí de','推磨':' tuī mò','面儿':' miàn r','鸡肋':' jī lèi','倒地':' dǎo dì','难得':' nán de','信子':' xìn zǐ','散居':' sǎn jū','荫庇':' yìn bì','雹子':' báo zǐ','人儿':' rén ér','一带':' yí dài','散剂':' sǎn jì','心子':' xīn zǐ','干涩':' gān sè','余干':' yú gān','茓子':' xué zǐ','馓子':' sǎn zǐ','驳倒':' bó dǎo','吁求':' yù qiú','丫头':' yā tou','担子':' dàn zi','驼子':' tuó zǐ','丫杈':' yā chà','骨朵':' gū duǒ','骨殖':' gǔ shi','踅子':' xué zǐ','雪子':' xuě zǐ','苇子':' wěi zǐ','摇把':' yáo bà','骨头':' gú tou','骰子':' tóu zǐ','佛书':' fó shū','新曲':' xīn qǔ','丸子':' wán zǐ','一般':' yì bān','什器':' shí qì','褪去':' tùn qù','掸子':' dǎn zǐ','微子':' wēi zǐ','着陆':' zhuó lù','循分':' xún fèn','嗡子':' wēng zǐ','修为':' xiū wéi','不甚':' bù shèn','过淋':' guò lìn','锅伙':' guō huo','行业':' háng yè','朝露':' zhāo lù','朝雨':' zhāo yǔ','卜算':' bǔ suàn','行语':' háng yǔ','蜾蠃':' guǒ luǒ','归处':' guī chǔ','真子':' zhēn zǐ','国难':' guó nàn','拖斗':' tuō dǒu','宁可':' nìng kě','葛洪':' gě hóng','木栅':' mù shān','宁都':' níng dū','羞臊':' xiū sào','月晕':' yuè yùn','好高':' hào gāo','蝳蝐':' dài mào','蠡县':' lǐ xiàn','才尽':' cái jìn','不省':' bù xǐng','糕干':' gāo gān','子精':' zǐ jīng','代为':' dài wéi','酸曲':' suān qǔ','待会':' dāi huì','待查':' dài zhā','多子':' duō zǐ','一通':' yī tòng','属文':' zhǔ wén','里弄':' lǐ lòng','一天':' yì tiān','认为':' rèn wéi','篙头':' gāo tou','诘问':' jié wèn','膏油':' gào yóu','认识':' rèn shi','帮子':' bāng zǐ','高知':' gāo zhì','起哄':' qǐ hòng','贞子':' zhēn zǐ','供物':' gòng wù','询查':' xún zhā','畜产':' xù chǎn','血晕':' xiě yùn','拜倒':' bài dǎo','告假':' gào jià','隔扇':' gé shān','丹墀':' dan chi','数落':' shǔ luò','斗六':' dǒu lìu','干薪':' gān xīn','选曲':' xuǎn qǔ','要晕':' yāo yūn','要好':' yāo hǎo','行距':' háng jù','圩镇':' xū zhèn','裁处':' cái chǔ','不调':' bù tiáo','交恶':' jiāo wù','衣冠':' yì guān','调戏':' tiáo xì','真似':' zhēn sì','衣着':' yī zhuó','畜养':' xù yǎng','挂斗':' guà dǒu','朝气':' zhāo qì','拚贴':' pīn tiē','乖子':' guāi zǐ','乖剌':' guāi là','怪得':' guài de','裁切':' cái qiē','瓜蔓':' guā wàn','鼓角':' gǔ jiǎo','要挟':' yāo xié','杭育':' háng yō','丙子':' bǐng zǐ','蚂螂':' mā láng','行伍':' háng wǔ','螺杆':' luó gǎn','砧子':' zhēn zǐ','振子':' zhèn zǐ','蝇子':' yíng zǐ','行子':' háng zǐ','虾干':' xiā gān','贵处':' guì chǔ','数数':' shǔ shù','固着':' gù zhuó','折实':' shé shí','敛巴':' liǎn ba','褪下':' tùn xià','巡查':' xún zhā','折折':' shé shé','折损':' shé sǔn','西藏':' xī zàng','干肉':' gān ròu','应募':' yìng mù','朝夕':' zhāo xī','要塞':' yào sài','咕隆':' gū lōng','恫吓':' dòng hè','打颤':' dǎ zhàn','朝歌':' zhāo gē','磅礴':' páng bó','锁匙':' suǒ chí','铺陈':' pū chén','得令':' de lìng','摧折':' cuī shé','晕倒':' yūn dǎo','倒飞':' dǎo fēi','倒翻':' dǎo fān','倒跌':' dǎo diē','折本':' shé běn','骑缝':' qí féng','倒错':' dǎo cuò','错处':' cuò chǔ','占课':' zhān kè','念佛':' niàn fó','任人':' rèn rén','曲松':' qǔ sōng','倒板':' dǎo bǎn','抖搂':' dǒu lōu','皋陶':' gāo yáo','挡子':' dǎng zǐ','荡子':' dàng zǐ','当子':' dāng zǐ','山脊':' shān jǐ','齿数':' chǐ shǔ','锥子':' zhuī zǐ','当户':' dàng hù','昏倒':' hūn dǎo','干旱':' gān hàn','打更':' dǎ gēng','汗国':' hán guó','打烊':' dǎ yàng','旋子':' xuán zǐ','旦角':' dàn jué','戳子':' chuō zǐ','镇咳':' zhèn ké','锁钥':' suǒ yuè','铺平':' pū píng','所为':' suǒ wéi','录供':' lù gòng','铺炕':' pū kàng','爪机':' zhuǎ jī','曾思':' zēng sī','手把':' shǒu bà','明子':' míng zǐ','曾父':' zēng fù','铺衬':' pū chèn','偏曲':' piān qǔ','铺面':' pū miàn','铺首':' pū shǒu','都灵':' dū líng','之至':' zhī zhì','单处':' dān chǔ','一着':' yī zhāo','择席':' zhái xí','闷雷':' mēn léi','暑假':' shǔ jià','晓得':' xiǎo de','使尽':' shǐ jìn','仙子':' xiān zǐ','仔肩':' zī jiān','晕血':' yùn xuè','晕池':' yùn chí','晕染':' yùn rǎn','恶相':' è xiàng','义兴':' yì xīng','方子':' fāng zǐ','晕车':' yùn chē','曲周':' qǔ zhōu','大藏':' dà zàng','大轴':' dà zhòu','恐吓':' kǒng hè','配角':' pèi jué','配载':' pèi zǎi','瘅疟':' dàn nüè','酬和':' chóu hè','酷肖':' kù xiāo','暴晒':' pù shài','大卷':' dà juàn','当得':' dāng de','彻查':' chè zhā','倒还':' dǎo hái','倒回':' dǎo huí','那些':' nèi xiē','得兼':' de jiān','仿似':' fǎng sì','的当':' dí dàng','倒着':' dǎo zhe','遗少':' yí shào','倒好':' dǎo hǎo','德兴':' dé xīng','主角':' zhǔ jué','令狐':' líng hú','刀切':' dāo qiē','已甚':' yǐ shèn','必应':' bì yìng','折煞':' shé shà','忖度':' cǔn duó','倒社':' dǎo shè','存查':' cún zhā','月分':' yuè fèn','邻舍':' lín shè','山子':' shān zǐ','投奔':' tóu bèn','裁度':' cái duó','谷坊':' gǔ fáng','扯臊':' chě sào','角斗':' jué dòu','干粪':' gān fèn','干裂':' gān liè','少府':' shào fǔ','草舍':' cǎo shè','贡嘎':' gòng gá','咽音':' yān yīn','查报':' zhā bào','查查':' zhā zhā','市担':' shì dàn','佛经':' fó jīng','查察':' zhā chá','差价':' chā jià','质难':' zhì nàn','角逐':' jué zhú','角子':' jiǎo zǐ','缝衣':' féng yī','赢得':' yíng de','少妇':' shào fù','锋镝':' fēng dí','插接':' chā jiē','折到':' shé dào','查勤':' zhā qín','分值':' fèn zhí','差别':' chā bié','调速':' tiáo sù','查下':' zhā xià','调理':' tiáo lǐ','差错':' chā cuò','拖累':' tuō lěi','丰都':' fēng dū','豁然':' huò rán','夫差':' fū chāi','作乐':' zuò yuè','轧空':' gá kōng','压轴':' yā zhòu','屏气':' bǐng qì','干咳':' gān hāi','调皮':' tiáo pí','调资':' tiáo zī','干花':' gān huā','干耗':' gān hào','佝瞀':' kòu mào','严处':' yán chǔ','调拨':' tiáo bō','掺合':' chān he','干犯':' gān fàn','有为':' yǒu wéi','作为':' zuò wéi','调色':' tiáo sè','解廌':' xiè zhì','查数':' zhā shù','赚得':' zuàn de','豆豉':' dòu chǐ','跟斗':' gēn dǒu','尤为':' yóu wéi','斗胆':' dǒu dǎn','见得':' jiàn de','学舍':' xué shè','干亲':' gān qīn','招子':' zhāo zǐ','干人':' gān rén','月氏':' ròu zhī','屏息':' bǐng xī','给水':' jǐ shuǐ','才分':' cái fèn','解数':' xiè shù','供案':' gòng àn','更移':' gēng yí','罩子':' zhào zǐ','更易':' gēng yì','玄子':' xuán zǐ','尿泡':' suī pào','镟子':' xuàn zǐ','轩子':' xuān zǐ','哽塞':' gěng sè','尿脬':' suī pāo','供佛':' gòng fó','资兴':' zī xīng','服丧':' fú sāng','猫腰':' máo yāo','郢都':' yǐng dū','封子':' fēng zǐ','风子':' fēng zǐ','曾祖':' zēng zǔ','曾朴':' zēng pǔ','拌和':' bàn huò','佛堂':' fó táng','佛说':' fó shuō','佛手':' fó shǒu','眼泡':' yǎn pāo','蜂子':' fēng zǐ','少女':' shào nǚ','折过':' zhē guò','斗门':' dǒu mén','少爷':' shào yé','参错':' cēn cuò','曾子':' zēng zǐ','拗陷':' ào xiàn','佛殿':' fó diàn','则甚':' zé shèn','来头':' lái tou','佛灯':' fó dēng','视为':' shì wéi','狗舍':' gǒu shè','豉油':' chǐ yóu','豆佉':' dòu qiā','好施':' hào shī','数九':' shǔ jiǔ','子网':' zǐ wǎng','蕃衍':' fán yǎn','指甲':' zhǐ jia','最差':' zuì chā','子贡':' zǐ gòng','化为':' huà wéi','画帖':' huà tiè','兴替':' xīng tì','薄命':' bó mìng','只道':' zhī dào','薄情':' bó qíng','薄晓':' bó xiǎo','告倒':' gào dǎo','孔子':' kǒng zǐ','不兴':' bù xīng','形似':' xíng sì','薄明':' bó míng','薄幸':' bó xìng','最为':' zuì wéi','寒舍':' hán shè','藏独':' zàng dú','会计':' kuài jì','孱头':' càn tou','蕃茄':' fān qié','孝子':' xiào zǐ','数出':' shǔ chū','本分':' běn fèn','寒假':' hán jià','薄产':' bó chǎn','薄田':' bó tián','鹄望':' hú wàng','压卷':' yā juàn','调和':' tiáo hé','调剂':' tiáo jì','枝杈':' zhī chà','薄酬':' bó chóu','间壁':' jiàn bì','不着':' bù zháo','优游':' yōu yóu','孟子':' mèng zǐ','藉口':' jiè kǒu','互见':' hù xiàn','藉着':' jiè zhe','末了':' mò liǎo','侯氏':' hòu shì','藏掖':' cáng yè','藏族':' zàng zú','侯家':' hòu jiā','押当':' yā dàng','藉由':' jiè yóu','和药':' huò yào','刚子':' gāng zǐ','拐子':' guǎi zǐ','分划':' fēn huá','不见':' bú jiàn','宫掖':' gōng yè','官子':' guān zǐ','横逆':' hèng nì','宜兴':' yí xīng','处事':' chǔ shì','应物':' yìng wù','处分':' chǔ fèn','处在':' chǔ zài','处世':' chǔ shì','要求':' yāo qiú','不更':' bù gēng','望都':' wàng dū','差数':' chā shù','差池':' chā chí','曾都':' zēng dū','谢帖':' xiè tiě','变得':' biàn de','盐分':' yán fèn','烟杆':' yān gǎn','差役':' chāi yì','复还':' fù huán','差迟':' chā chí','开衩':' kāi chà','采血':' cǎi xiě','供词':' gòng cí','拶指':' zǎn zhǐ','害臊':' hài sào','处暑':' chǔ shǔ','处决':' chǔ jué','处治':' chǔ zhì','开拓':' kāi tuò','木椆':' mù zhòu','处置':' chǔ zhì','处处':' chǔ chù','号啕':' háo táo','供给':' gōng jǐ','蚌埠':' bèng bù','蕴藉':' yùn jiè','密缝':' mì féng','处男':' chǔ nán','红子':' hóng zǐ','开杆':' kāi gǎn','缸子':' gāng zǐ','黑煞':' hēi shà','藏语':' zàng yǔ','拾芥':' shí jiè','岗子':' gǎng zǐ','干哕':' gān yuě','干嚎':' gān háo','吵子':' chǎo zǐ','晨曲':' chén qǔ','干饭':' gān fàn','了如':' liǎo rú','查探':' zhā tàn','肖似':' xiào sì','耳片':' ěr piān','噱头':' xué tou','伴乐':' bàn yuè','翘企':' qiáo qǐ','推杆':' tuī gǎn','推度':' tuī duó','了悟':' liǎo wù','四更':' sì gēng','燎祭':' liào jì','查看':' zhā kàn','推倒':' tuī dǎo','掰扯':' bāi che','下处':' xià chǔ','网吧':' wǎng bā','绵子':' mián zǐ','绵薄':' mián bó','编曲':' biān qǔ','缜发':' zhěn fà','缝合':' féng hé','缝补':' féng bǔ','职分':' zhí fèn','查处':' chá chǔ','脸子':' liǎn zǐ','背头':' bēi tóu','靠头':' kào tou','课卷':' kè juàn','消得':' xiāo de','胡同':' hú tòng','外头':' wài tou','被难':' bèi nàn','胡芫':' hú yuán','看门':' kān mén','有分':' yǒu fèn','剀切':' kǎi qiē','耍子':' shuǎ zǐ','坑子':' kēng zǐ','背包':' bēi bāo','肖恩':' xiāo ēn','款曲':' kuǎn qǔ','耗尽':' hào jìn','下载':' xià zǎi','垫子':' diàn zǐ','会稽':' kuài jī','坠子':' zhuì zǐ','倒茬':' dǎo chá','胄子':' zhòu zǐ','倒台':' dǎo tái','绿营':' lù yíng','案卷':' àn juàn','可曾':' kě zēng','轴子':' zhóu zǐ','扳倒':' bān dǎo','执拗':' zhí niù','掖庭':' yè tíng','基甸':' jī diàn','半宿':' bàn xiǔ','累加':' lěi jiā','弦子':' xián zǐ','累世':' lěi shì','圆子':' yuán zǐ','冷子':' lěng zǐ','绷子':' bēng zǐ','楞子':' léng zǐ','探查':' tàn zhā','事假':' shì jià','下切':' xià qiē','下帖':' xià tiě','下头':' xià tou','棱子':' léng zǐ','地壳':' dì qiào','立卷':' lì juàn','坊子':' fāng zǐ','朱干':' zhū gān','仙佛':' xiān fó','累时':' lěi shí','埂子':' gěng zǐ','嚼蜡':' jiáo là','绫子':' líng zǐ','龙脊':' lóng jǐ','摆划':' bǎi huá','铣削':' xǐ xiāo','西兴':' xī xīng','提防':' dī fáng','吓倒':' xià dǎo','绊倒':' bàn dǎo','绝倒':' jué dǎo','流尽':' liú jìn','令子':' lìng zǐ','灵子':' líng zǐ','垣曲':' yuán qǔ','严查':' yán zhā','嚼子':' jiáo zǐ','结实':' jiē shi','馅子':' xiàn zǐ','纤夫':' qiàn fū','繁峙':' fán shì','罗嗦':' luō suo','游散':' yóu sǎn','擂主':' lèi zhǔ','累月':' lěi yuè','肘子':' zhǒu zǐ','不了':' bù liǎo','背篓':' bēi lǒu','罗刹':' luó chà','端子':' duān zǐ','椎骨':' zhuī gǔ','邮折':' yóu shé','搪塞':' táng sè','缪缪':' miù miù','名子':' míng zǐ','猪仔':' zhū zǎi','散诞':' sǎn dàn','鸣镝':' míng dí','童子':' tóng zǐ','竭尽':' jié jìn','喉咽':' hóu yān','空地':' kòng dì','端的':' duān dì','一点':' yì diǎn','暗杠':' àn gàng','命薄':' mìng bó','空儿':' kòng ér','散话':' sǎn huà','猪只':' zhū zhī','哽咽':' gěng yè','空子':' kòng zi','阳曲':' yáng qǔ','磨削':' mó xiāo','著者':' zhù zhě','哪边':' nǎ bian','摒弃':' bìng qì','碾子':' niǎn zǐ','龟裂':' jūn liè','难胞':' nàn bāo','榛子':' zhēn zǐ','僮仆':' tóng pú','干馏':' gān liú','能子':' néng zǐ','尽早':' jìn zǎo','问难':' wèn nàn','硙硙':' wèi wèi','捻子':' niǎn zǐ','磨坊':' mò fáng','喝令':' hè lìng','散碎':' sǎn suì','福兴':' fú xīng','神佛':' shén fó','杠夫':' gàng fū','齿龈':' chǐ yín','散粉':' sǎn fěn','散职':' sǎn zhí','呢绒':' ní róng','龈炎':' yín yán','隔行':' gé háng','杠子':' gàng zi','挨冻':' ái dòng','空隙':' kòng xì','卷发':' juǎn fà','了得':' liǎo de','窥度':' kuī duó','蝤蛑':' yóu móu','翻倒':' fān dǎo','蚬子':' xiǎn zǐ','线子':' xiàn zǐ','倒头':' dǎo tóu','了无':' liǎo wú','翘曲':' qiáo qū','报帖':' bào tiě','唠唠':' lào lào','栅格':' shān gé','倒霉':' dǎo méi','报载':' bào zǎi','半折':' bàn shé','场儿':' chǎng r','翘足':' qiáo zú','二更':' èr gēng','了不':' liǎo bù','累代':' lěi dài','考查':' kǎo zhā','背带':' bēi dài','倒班':' dǎo bān','拉纤':' lā qiàn','磈磊':' kuǐ lěi','搭挡':' dā dàng','棒喝':' bàng hè','空余':' kòng yú','楦子':' xuàn zǐ','抹面':' mò miàn','啜泣':' chuò qì','抹角':' mò jiǎo','窝囊':' wō nāng','搭当':' dā dàng','问倒':' wèn dǎo','碑拓':' bēi tuò','嗳酸':' ǎi suān','唠扯':' lào chě','塞外':' sài wài','宝刹':' bǎo chà','周内':' zhōu nà','掖垣':' yè yuán','狼子':' láng zǐ','琅邪':' láng yá','落架':' lào jià','倒运':' dǎo yùn','倒卖':' dǎo mài','栅极':' shān jí','灾煞':' zāi shà','困处':' kùn chǔ','舟子':' zhōu zǐ','均匀':' jūn yún','曾波':' zēng bō','腰折':' yāo shé','辟雍':' bì yōng','更夫':' gēng fū','一朝':' yī zhāo','更鼓':' gēng gǔ','轻薄':' qīng bó','轻子':' qīng zǐ','佛山':' fó shān','发兴':' fā xīng','轩掖':' xuān yè','软呢':' ruǎn ní','也曾':' yě zēng','都统':' dū tǒng','发蒙':' fā mēng','新干':' xīn gān','发还':' fā huán','更递':' gēng dì','佛典':' fó diǎn','更衣':' gēng yī','掖县':' yè xiàn','抽咽':' chōu yè','叶心':' xié xīn','厦门':' xià mén','佛坪':' fó píng','伊甸':' yī diàn','断发':' duàn fà','得神':' de shén','别扭':' biè niǔ','跪倒':' guì dǎo','跂望':' qì wàng','非为':' fēi wéi','跌倒':' diē dǎo','吠舍':' fèi shè','飞掠':' fēi lüě','干支':' gān zhī','干涉':' gān shè','跟头':' gēn tou','朝暮':' zhāo mù','佛冈':' fó gāng','断喝':' duàn hè','庚子':' gēng zǐ','京都':' jīng dū','更次':' gēng cì','何曾':' hé zēng','建都':' jiàn dū','一刬':' yī chàn','多难':' duō nàn','更替':' gēng tì','辗轧':' zhǎn yà','住舍':' zhù shè','锻模':' duàn mú','干休':' gān xiū','曲水':' qǔ shuǐ','干扰':' gān rǎo','什菜':' shí cài','从子':' cóng zǐ','刺痒':' cì yáng','处士':' chǔ shì','刺参':' cì shēn','慰藉':' wèi jiè','憎恶':' zēng wù','懂得':' dǒng de','应付':' yìng fù','应力':' yìng lì','应和':' yìng hè','愚氓':' yú méng','什锦':' shí jǐn','铺垫':' pū diàn','铺展':' pū zhǎn','旋木':' xuàn mù','链子':' liàn zǐ','铲子':' chǎn zǐ','扒手':' pá shǒu','镯子':' zhuó zǐ','铁杆':' tiě gǎn','人为':' rén wéi','扎囊':' zā náng','打哄':' dǎ hǒng','粗朴':' cū piáo','攒盒':' cuán hé','应急':' yìng jí','懮虑':' yōu lù:','应敌':' yìng dí','隐处':' yǐn chǔ','批卷':' pī juàn','出倒':' chū dǎo','挓挲':' zhā shā','应答':' yìng dá','稠糊':' chóu hū','应得':' yīng de','钉耙':' dīng pá','亹亹':' wěi wěi','钎子':' qiān zǐ','攒集':' cuán jí','懒散':' lǎn sǎn','星子':' xīng zǐ','销子':' xiāo zǐ','锄头':' chú tou','应举':' yìng jǔ','轧车':' zhá chē','出塞':' chū sài','阴处':' yīn chǔ','攒聚':' cuán jù','照得':' zhào de','调合':' tiáo hé','趼子':' jiǎn zǐ','干挠':' gān náo','蔚县':' yù xiàn','逃难':' táo nàn','逃奔':' táo bèn','弹纠':' tán jīu','洞子':' dòng zǐ','弹指':' tán zhǐ','弹斥':' tán chì','移行':' yí háng','弹球':' tán qíu','弹琴':' tán qín','曲面':' qǔ miàn','造血':' zào xiě','斗室':' dǒu shì','弹射':' tán shè','甸子':' diàn zǐ','店子':' diàn zǐ','一了':' yī liǎo','还礼':' huán lǐ','戥子':' děng zǐ','镫子':' dèng zǐ','等子':' děng zǐ','休假':' xiū jià','折箩':' zhē luó','还击':' huán jī','等得':' děng de','斗车':' dǒu chē','斗酒':' dǒu jiǔ','的真':' dí zhēn','锭子':' dìng zǐ','藏獒':' zàng áo','环伺':' huán sì','丁子':' dīng zǐ','顶子':' dǐng zǐ','定子':' dìng zǐ','曲靖':' qǔ jìng','逼供':' bī gòng','定都':' dìng dū','曲阳':' qǔ yáng','弥缝':' mí féng','吊子':' diào zǐ','弹奏':' tán zòu','曲调':' qǔ diào','以还':' yǐ huán','彷似':' fǎng sì','过分':' guò fèn','过过':' guò guo','后燕':' hòu yān','一哄':' yí hòng','弹花':' tán huā','逢俉':' féng wú','弹出':' tán chū','弹回':' tán huí','得能':' de néng','得用':' de yòng','洋落':' yáng là','佛性':' fó xìng','杨子':' yáng zǐ','阳子':' yáng zǐ','斤斗':' jīn dǒu','羊子':' yáng zǐ','几丁':' jī dīng','躲难':' duǒ nàn','躯壳':' qū qiào','产子':' chǎn zǐ','佛教':' fó jiào','车斗':' chē dǒu','轧制':' zhá zhì','折头':' zhé tou','轧辊':' zhá gǔn','翻斗':' fān dǒu','几谏':' jī jiàn','翻查':' fān zhā','腰杆':' yāo gǎn','要切':' yào qiē','掺杂':' chān zá','枋子':' fāng zǐ','分处':' fēn chǔ','分出':' fèn chū','仰给':' yǎng jǐ','踺子':' jiàn zǐ','更卒':' gēng zú','的应':' de yìng','电磨':' diàn mò','得幸':' de xìng','得性':' de xìng','得行':' de xíng','得请':' de qǐng','癫子':' diān zǐ','还席':' huán xí','复兴':' fù xīng','后头':' hòu tou','遛弯':' liù wān','颠仆':' diān pú','遭难':' zāo nàn','得算':' de suàn','电发':' diàn fà','迁都':' qiān dū','一卷':' yī juàn','折耗':' shé hào','一觉':' yī jiào','得着':' de zháo','得亏':' děi kuī','骶椎':' dǐ zhuī','邀约':' yāo yuē','还俗':' huán sú','得当':' dé dàng','多哇':' duō wā','呼号':' hū háo','干邑':' gān yì','系泊':' jì bó','给予':' jǐ yǔ','丝柏':' sī bó','继子':' jì zǐ','子墨':' zǐ mò','子母':' zǐ mǔ','字模':' zì mú','合子':' hé zǐ','南无':' nā mó','次子':' cì zǐ','子么':' zǐ mǒ','取得':' qǔ de','耶西':' yē xī','耶鲁':' yē lǔ','吧嗒':' bā dā','歌曲':' gē qǔ','吧女':' bā nǚ','畜牧':' xù mù','吧唧':' bā jī','脊骨':' jǐ gǔ','图子':' tú zǐ','可恶':' kě wù','欧泊':' ōu bó','博得':' bó de','般若':' bō rě','呵责':' hē zé','呼喝':' hū hè','卜骨':' bǔ gǔ','咖哩':' kā li','腻子':' nì zǐ','子午':' zǐ wǔ','核儿':' hú ér','子鸡':' zǐ jī','曲率':' qǔ lǜ','核子':' hé zǐ','痦子':' wù zǐ','弃子':' qì zǐ','疙疸':' gē da','耙子':' pá zǐ','组曲':' zǔ qǔ','耳子':' ěr zǐ','耶稣':' yē sū','七子':' qī zǐ','疑似':' yí sì','仆射':' pú yè','古都':' gǔ dū','棋子':' qí zǐ','虎子':' hǔ zǐ','泰阿':' tài ē','淤塞':' yū sè','蟢子':' xǐ zǐ','太阿':' tài ē','秃子':' tū zǐ','踏踏':' tā tà','一起':' yì qǐ','乐子':' lè zǐ','码子':' mǎ zǐ','虮子':' jǐ zǐ','磨叽':' mò ji','矮子':' ǎi zǐ','一路':' yí lù','屉子':' tì zǐ','辱没':' rǔ mò','乳女':' rǔ nǚ','木模':' mù mú','哇哇':' wā wā','租子':' zū zǐ','苏打':' sū dá','仆役':' pú yì','法子':' fǎ zǐ','模似':' mó sì','仆仆':' pú pú','一意':' yī yì','脯子':' pú zǐ','吴子':' wú zǐ','一度':' yí dù','耶酥':' yē sū','歌子':' gē zǐ','卜居':' bǔ jū','栖宿':' qī sù','吐沫':' tù mò','吐蕃':' tǔ bō','子期':' zǐ qī','杜塞':' dù sè','肚子':' dǔ zi','吖嗪':' ā qín','子奇':' zǐ qí','吟哦':' yín é','胡佛':' hú fó','七个':' qī ge','七佛':' qī fó','脉脉':' mò mò','百色':' bó sè','模子':' mú zǐ','剂子':' jì zǐ','薄雾':' bó wù','子叶':' zǐ yè','以撒':' yǐ sǎ','鞑子':' dá zǐ','子女':' zǐ nǚ','一似':' yī sì','子弟':' zǐ dì','子目':' zǐ mù','子粒':' zǐ lì','子细':' zǐ xì','德都':' dé dū','子路':' zǐ lù','搭子':' dā zǐ','达子':' dá zǐ','磨墨':' mó mò','于都':' yú dū','篦子':' bì zǐ','子婿':' zǐ xù','簿子':' bù zǐ','呢子':' ní zǐ','味儿':' wèi r','訾议':' zǐ yì','得地':' de dì','子夜':' zǐ yè','簸箕':' bò ji','估衣':' gù yī','复辟':' fù bì','孤子':' gū zǐ','昳丽':' yì lì','嘀哒':' dī dā','伢子':' yá zǐ','樀樀':' dí dí','伯伯':' bó bo','的卢':' dì lú','伯都':' bó dū','季子':' jì zǐ','子域':' zǐ yù','移易':' yí yì','得得':' de de','移译':' yí yì','婆子':' pó zǐ','答答':' dā dā','嫡子':' dí zǐ','咿呀':' yī yā','大佛':' dà fó','子句':' zǐ jù','子嗣':' zǐ sì','子虚':' zǐ xū','武都':' wǔ dū','呼吁':' hū yù','热呼':' rè hu','模具':' mú jù','爷爷':' yé ye','父子':' fù zǐ','箕子':' jī zǐ','案子':' àn zǐ','貔子':' pí zǐ','卒子':' zú zǐ','撒子':' sā zǐ','披发':' pī fà','舞曲':' wǔ qǔ','蔚蔚':' yù yù','熬稃':' āo fū','六安':' lù ān','子堤':' zǐ dī','牙子':' yá zǐ','呵护':' hē hù','卜辞':' bǔ cí','模糊':' mó hu','狸子':' lí zǐ','服服':' fú fu','坯子':' pī zǐ','子羽':' zǐ yǔ','呵呵':' hē hē','糊糊':' hū hū','独子':' dú zǐ','呵喝':' hē hè','子鱼':' zǐ yú','目的':' mù dì','梨子':' lí zǐ','自给':' zì jǐ','呢呢':' ní ní','仆妇':' pú fù','自个':' zì gě','糢糊':' mó hu','卧佛':' wò fó','胆儿':' dǎn r','泼剌':' pō là','理发':' lǐ fà','吽牙':' ōu yá','子息':' zǐ xī','粒子':' lì zǐ','卜课':' bǔ kè','米芾':' mǐ fú','玛曲':' mǎ qǔ','劲儿':' jìn r','子兮':' zǐ xī','末子':' mò zǐ','牟尼':' mù ní','得度':' de dù','好古':' hào gǔ','日晕':' rì yùn','卜甲':' bǔ jiǎ','儒艮':' rú gèn','子代':' zǐ dài','子民':' zǐ mín','孕吐':' yùn tù','浑似':' hún sì','印子':' yìn zǐ','侯波':' hòu bō','半打':' bàn dá','娄子':' lóu zǐ','嗒然':' tà rán','阘懦':' tà nuò','他处':' tā chǔ','索子':' suǒ zǐ','居处':' jū chǔ','锁子':' suǒ zǐ','划拉':' huá lā','尾子':' wěi zǐ','穗子':' suì zǐ','购得':' gòu de','子鼠':' zǐ shǔ','三曲':' sān qǔ','枸橘':' gōu jú','撒施':' sǎ shī','三个':' sān ge','会子':' huì zǐ','卡子':' qiǎ zi','若夫':' ruò fú','子孙':' zǐ sūn','子规':' zǐ guī','乳臭':' rǔ xiù','会得':' huì de','撒花':' sǎ huā','子群':' zǐ qún','卜问':' bǔ wèn','子弹':' zǐ dàn','子时':' zǐ shí','子爵':' zǐ jué','子实':' zǐ shí','镬子':' huò zǐ','子音':' zǐ yīn','卜筮':' bǔ shì','色晕':' sè yùn','豁子':' huō zǐ','卜卦':' bǔ guà','狗脊':' gǒu jǐ','给回':' jǐ huí','字帖':' zì tiè','歌呗':' gē bài','切勿':' qiē wù','屯子':' tún zǐ','属意':' zhǔ yì','划子':' huá zǐ','膏泽':' gào zé','体查':' tǐ zhā','切尼':' qiē ní','膏子':' gāo zǐ','篙子':' gāo zǐ','圪节':' gē jiē','切割':' qiē gē','割切':' gē qiē','陶子':' táo zǐ','切牙':' qiē yá','切腹':' qiē fù','贪得':' tān de','蛤仔':' gé zǎi','羔子':' gāo zǐ','学子':' xué zǐ','呱唧':' guā jī','寻的':' xún dì','岔子':' chà zǐ','昆曲':' kūn qǔ','俗乐':' sú yuè','刹那':' chà nà','沟子':' gōu zǐ','列子':' liè zǐ','刨子':' bào zǐ','贾祸':' gǔ huò','锢露':' gù lòu','肆掠':' sì lüě','贾人':' gǔ rén','鼓乐':' gǔ yuè','削发':' xuē fà','呱嗒':' guā dā','干租':' gān zū','剥皮':' bāo pí','狗子':' gǒu zǐ','呱哒':' guā dā','胎发':' tāi fà','柑子':' gān zǐ','干子':' gàn zǐ','出落':' chū là','切入':' qiē rù','甘子':' gān zǐ','秆子':' gǎn zǐ','耠子':' huō zǐ','季肋':' jì lèi','漯河':' tà hé','俗曲':' sú qǔ','哈达':' hǎ dá','去得':' qù de','哈迪':' hǎ dí','砝码':' fǎ mǎ','碌曲':' lù qǔ','薄荷':' bò he','兀自':' wū zì','西子':' xī zǐ','西打':' xī dá','四子':' sì zǐ','哥哥':' gē ge','李子':' lǐ zǐ','栖息':' qī xī','曲裾':' qǔ jū','抹子':' mǒ zǐ','秘鲁':' bì lǔ','莫邪':' mò yé','无似':' wú sì','刻薄':' kè bó','筢子':' pá zǐ','秕子':' bǐ zǐ','哎呀':' āi yā','窝子':' wō zǐ','衲子':' nà zǐ','破的':' pò dì','里脊':' lǐ jǐ','曲谱':' qǔ pǔ','剃发':' tì fà','补给':' bǔ jǐ','泥古':' nì gǔ','那得':' nà de','蝲蛄':' là gǔ','虾蟆':' há ma','科克':' kē kè','衣子':' yī zǐ','哇啦':' wā lā','瓦剌':' wǎ là','蛤蛎':' gé lì','稀薄':' xī bó','蛤蜊':' gé lí','哈佛':' hā fó','泥子':' nì zǐ','木子':' mù zǐ','屈子':' qū zǐ','喔喔':' wō wō','曲剧':' qǔ jù','覆没':' fù mò','博白':' bó bái','俗子':' sú zǐ','苏子':' sū zǐ','盖儿':' gài r','怒喝':' nù hè','朴子':' pò zǐ','葛摩':' gě mó','瓯子':' ōu zǐ','撒布':' sǎ bù','子安':' zǐ ān','子部':' zǐ bù','即为':' jí wéi','怒发':' nù fà','子曰':' zǐ yuē','杉木':' shā mù','任子':' rèn zǐ','痧子':' shā zǐ','厚薄':' hòu bó','胡为':' hú wéi','极处':' jí chǔ','卑鄙':' bēi bǐ','半拉':' bàn lǎ','厚朴':' hòu pò','素子':' sù zǐ','啪啦':' pā lā','曲度':' qǔ dù','扒鸡':' pá jī','万俟':' mò qí','曲辞':' qǔ cí','咖喱':' gā lí','菥蓂':' xī mì','筏子':' fá zǐ','答理':' dā lǐ','母子':' mǔ zǐ','磨子':' mò zǐ','薄礼':' bó lǐ','派司':' pā sī','薄暮':' bó mù','嗉子':' sù zǐ','薄暗':' bó àn','薄技':' bó jì','孺子':' rú zǐ','不义':' bú yì','入子':' rù zǐ','哀子':' āi zǐ','薄地':' bó dì','激子':' jī zǐ','薄利':' bó lì','袄子':' ǎo zǐ','得按':' de àn','的子':' de zǐ','蒿子':' hāo zǐ','兀秃':' wū tū','里子':' lǐ zǐ','武曲':' wǔ qǔ','没入':' mò rù','没地':' mò dì','偶遇':' ǒu yù','辈儿':' bèi r','辟谷':' bì gǔ','於菟':' wū tú','辣子':' là zǐ','迤逦':' yǐ lǐ','离子':' lí zǐ','跛子':' bǒ zǐ','迪吧':' dí bā','逆子':' nì zǐ','吗哪':' mǎ nǎ','曲艺':' qǔ yì','曲目':' qǔ mù','曲沃':' qǔ wò','呜咽':' wū yè','那曲':' nǎ qū','那末':' nà me','息子':' xī zǐ','凫茈':' fú zǐ','那麽':' nà me','玉佛':' yù fó','须发':' xū fà','砬子':' lá zǐ','郁塞':' yù sè','拉忽':' lǎ hū','鱼子':' yú zǐ','鱼肚':' yú dǔ','魣鱼':' yú yú','鮨科':' qí kē','撒督':' sǎ dū','撒播':' sǎ bō','摩挲':' mā sā','鸭子':' yā zǐ','塞责':' sè zé','鹄的':' gǔ dì','伛偻':' yǔ lǚ','鹿谷':' lù gǔ','墨子':' mò zǐ','麻力':' má li','摸吧':' mō bā','口哦':' kǒu ò','摩撒':' mā sa','嗣子':' sì zǐ','迷糊':' mí hu','胡子':' hú zǐ','闭塞':' bì sè','麻秸':' má jí','都督':' dū du','鏊子':' ào zǐ','恶嗪':' ě qín','日没':' rì mò','恶心':' ě xīn','西曲':' xī qǔ','嗳气':' ài qì','嗳腐':' ài fǔ','栖栖':' xī xī','坷拉':' kē lā','阻塞':' zǔ sè','垆坶':' lú mù','阿丹':' a dān','阿来':' a lái','阿伦':' a lún','阿斗':' ā dǒu','阿森':' a sēn','碧波':' bì bō','阿诺':' a nuò','咋呀':' zǎ yā','杂沓':' zá tà','靡丽':' mǐ lì','麻麻':' mā mɑ','语域':' yǔ yù','起子':' qǐ zǐ','觑糊':' qù hu','博兴':' bó xīng','无得':' wú de','靺鞨':' mò hé','记得':' jì de','冒顿':' mò dú','莫得':' mò de','哑子':' yǎ zǐ','语塞':' yǔ sè','靡靡':' mǐ mǐ','跂訾':' qǐ zǐ','喜子':' xǐ zǐ','於乎':' wū hū','谱子':' pǔ zǐ','谱曲':' pǔ qǔ','谜子':' mí zǐ','负荷':' fù hè','沵迤':' mǐ yǐ','乌拉':' wù lɑ','贾客':' gǔ kè','须子':' xū zǐ','浴佛':' yù fó','附和':' fù hè','阿比':' ē bǐ','阿附':' ē fù','啊哟':' ā yō','嗯啊':' ng ā','抹额':' mò é','理儿':' lǐ r','阿谀':' ē yú','阿苏':' a sū','皮儿':' pí r','阿里':' a lǐ','阿瑟':' a sè','啊呀':' ā yā','塔扎':' tǎ zā','玉子':' yù zǐ','驴子':' lǘ zǐ','堵塞':' dǔ sè','拨子':' bō zǐ','余裕':' yú yù','体己':' tī ji','拨刺':' bō cī','发屋':' fà wū','雨子':' yǔ zǐ','曾姓':' zēng xìng','姓曾':' xìng zēng','乐得':' lè de','巴阿':' bā a','腌臜':' ā zā','囮子':' é zǐ','阿佤':' a wǎ','肚儿':' dǔ r','阿耶':' ā yē','阿堵':' ē dǔ','哦呀':' ò yā','尜儿':' gá r','啊哈':' ā hā','呃呃':' e e','挨饿':' ái è','吖吖':' ā ā㐀','阿的':' ā dì','末儿':' mò r','壳儿':' ké r','阿坝':' a bà','阿巴':' a bā','阿卡':' a kǎ','地儿':' dì r','便宜':' pián yí','子儿':' zǐ r','都德':' dū dé','地堡':' dì pù','锞子':' kè zǐ','八子':' bā zǐ','安子':' ān zǐ','鞍子':' ān zǐ','庵子':' ān zǐ','埯子':' ǎn zǐ','坷垃':' kē lā','吧吧':' bā bā','欲得':' yù de','揦子':' lá zǐ','坝子':' bà zǐ','咔叽':' kǎ jī','搭拉':' dā la','掖咕':' yē gu','夜曲':' yè qǔ','具足':' jù zú','举子':' jǔ zǐ','巨子':' jù zǐ','沮洳':' jù rù','居积':' jū jī','巨贾':' jù gǔ','巴子':' bā zǐ','发丝':' fà sī','嗳哟':' ài yō','壳子':' ké zǐ','故都':' gù dū','俚曲':' lǐ qǔ','露茜':' lù xī','革吉':' gé jí','靶子':' bǎ zǐ','礼佛':' lǐ fó','摊儿':' tān r','丽都':' lì dū','驹子':' jū zǐ','预卜':' yù bǔ','坯模':' pī mú','挨罚':' ái fá','播撒':' bō sǎ','乐呵':' lè hē','马子':' mǎ zǐ','马尾':' mǎ yǐ','坨儿':' tuó r','余吾':' yú wú','剌剌':' là là','发髻':' fà jì','棵子':' kē zǐ','系子':' xì zǐ','集子':' jí zǐ','俟机':' sì jī','扶掖':' fú yè','佛牙':' fó yá','佛祖':' fó zǔ','佛骨':' fó gǔ','佛偈':' fó jì','局子':' jú zǐ','箅子':' bì zǐ','得色':' de sè','鹄立':' hú lì','扒犁':' pá li','希腊':' xī là','穄子':' jì zǐ','鸡子':' jī zǐ','机子':' jī zǐ','妮子':' nī zǐ','戏曲':' xì qǔ','戏子':' xì zǐ','戊子':' wù zǐ','妻子':' qī zǐ','籍没':' jí mò','把儿':' bà er','佛爷':' fó yé','帕子':' pà zǐ','刺啦':' cī lā','几乎':' jī hū','丫子':' yā zǐ','哑哑':' yā yā','呀呀':' yā yā','葛麻':' gě má','几率':' jī lǜ','佛历':' fó lì','佛理':' fó lǐ','几案':' jī àn','几希':' jī xī','姁姁':' xū xū','帝都':' dì dū','虚子':' xū zǐ','股子':' gǔ zǐ','姑子':' gū zǐ','汩没':' gǔ mò','毂辘':' gū lù','骨碌':' gū lù','佛法':' fó fǎ','佛力':' fó lì','带儿':' dài r','古佛':' gǔ fó','词曲':' cí qǔ','嘎子':' gǎ zǐ','呼啦':' hū lā','餔子':' bū zǐ','夫子':' fū zǐ','奇偶':' jī ǒu','奇技':' qí jì','套儿':' tào r','女仆':' nǚ pú','女子':' nǚ zǐ','奴仆':' nú pú','堡子':' bǔ zi','婀娜':' ē nuó','补子':' bǔ zǐ','仡仡':' yì yì','一曲':' yī qǔ','子集':' zǐ jí','的卡':' dí kǎ','得理':' de lǐ','得气':' de qì','得死':' de sǐ','壶子':' hú zǐ','得也':' de yě','瓠子':' hù zǐ','布子':' bù zǐ','披靡':' pī mǐ','翼子':' yì zǐ','把子':' bà zi','胰子':' yí zǐ','义子':' yì zǐ','呲牙':' zī yá','粗呢':' cū ní','瘄子':' cù zǐ','爱子':' ài zǐ','娃子':' wá zǐ','娃娃':' wá wa','恶煞':' è shà','抹布':' mā bù','拘泥':' jū nì','挨骂':' ái mà','挨挤':' ái jǐ','挨打':' ái dǎ','大都':' dà dū','大雅':' dà yá','趵趵':' bō bō','卜卜':' bǔ bǔ','不敷':' bù fū','不落':' bù là','部曲':' bù qǔ','巨擘':' jù bò','桴子':' fú zǐ','噶嗒':' gá tà','页子':' yè zǐ','呕气':' òu qì','婢仆':' bì pú','挨批':' ái pī','婢子':' bì zǐ','不子':' bù zǐ','哈呀':' hā yā','厄难':' è nàn','哈巴':' hǎ bā','衣被':' yì pī','耶耶':' yē yē','铺砌':' pū qì','二曲':' èr qǔ','也似':' yě sì','耶律':' yē lǜ','寄与':' jì yú','饵子':' ěr zǐ','野葛':' yě gě','也得':' yě de','发际':' fà jì','发妻':' fà qī','佛塔':' fó tǎ','卤子':' lǔ zǐ','铺叙':' pū xù','发乳':' fà rǔ','酷似':' kù sì','曲子':' qǔ zi','锯子':' jù zǐ','鹿子':' lù zǐ','乙巳':' yǐ sì','嘀嗒':' dī dā','曲奇':' qǔ qí','鄙薄':' bǐ bó','五子':' wǔ zǐ','杌子':' wù zǐ','医卜':' yī bǔ','细发':' xì fà','暗堡':' àn pù','嘎啦':' gā lā','铺路':' pū lù','呕吐':' ǒu tù','昵比':' nì bì','喜得':' xǐ de','钜子':' jù zǐ','钩儿':' gōu r','锔子':' jū zǐ','铺子':' pù zǐ','法曲':' fǎ qǔ','佛寺':' fó sì','麸子':' fū zǐ','屈曲':' qū qǔ','寄子':' jì zǐ','都邑':' dū yì','犊子':' dú zǐ','一发':' yī fà','徒裼':' tú xī','几米':' jī mǐ','几欲':' jī yù','佛母':' fó mǔ','佛曲':' fó qǔ','屋脊':' wū jǐ','一得':' yī de','佛土':' fó tǔ','阁子':' gé zǐ','佛子':' fó zǐ','哥子':' gē zǐ','差额':' chā é','佛语':' fó yǔ','夫夫':' fú fū','差讹':' chā é','附子':' fù zǐ','浮子':' fú zǐ','都司':' dū sī','意得':' yì de','序曲':' xù qǔ','诃子':' hē zǐ','尉犁':' yù lí','垡子':' fá zǐ','须得':' xū de','圩日':' xū rì','弟子':' dì zǐ','伽马':' gā mǎ','役畜':' yì xù','伺服':' sì fú','宜都':' yí dū','伺机':' sì jī','度曲':' dù qǔ','伺隙':' sì xì','似乎':' sì hū','禾子':' hé zǐ','一个':' yí gè','似核':' sì hé','弟弟':' dì di','何似':' hé sì','鹤发':' hè fà','独得':' dú de','都护':' dū hù','毫子':' háo zǐ','石堤':' shí dī','弹子':' dàn zǐ','尽责':' jìn zé','白子':' bái zǐ','发难':' fā nàn','发帖':' fā tiě','发卡':' fà qiǎ','瘫子':' tān zǐ','癖好':' pǐ hào','瘸子':' qué zǐ','疟子':' yào zǐ','白佛':' bái fó','热帖':' rè tiě','橱子':' chú zǐ','煞气':' shà qì','混子':' hùn zǐ','淫靡':' yín mǐ','沦没':' lún mò','淡薄':' dàn bó','淡泊':' dàn bó','浸没':' jìn mò','海子':' hǎi zǐ','活泛':' huó fá','活佛':' huó fó','瘤子':' liú zǐ','白发':' bái fà','活似':' huó sì','历尽':' lì jìn','甲子':' jiǎ zǐ','瓤儿':' ráng r','瓜子':' guā zǐ','痱子':' fèi zǐ','琢磨':' zuó mo','独处':' dú chǔ','犹子':' yóu zǐ','历数':' lì shǔ','狍子':' páo zǐ','牢子':' láo zǐ','白鹄':' bái hú','牙龈':' yá yín','爆肚':' bào dǔ','武侯':' wǔ hòu','死难':' sǐ nàn','瘊子':' hóu zǐ','尽意':' jìn yì','尽力':' jìn lì','的确':' dí què','的士':' dí shì','槟子':' bīn zǐ','淹没':' yān mò','泡子':' pāo zǐ','男子':' nán zǐ','绦子':' tāo zǐ','沤肥':' òu féi','滚子':' gǔn zǐ','毛发':' máo fà','脊柱':' jǐ zhù','尽速':' jìn sù','直发':' zhí fà','绿林':' lù lín','絮叨':' xù dáo','给事':' jǐ shì','结发':' jié fà','济南':' jǐ nán','结壳':' jiē ké','结扎':' jié zā','结巴':' jiē bā','结子':' jié zǐ','栽子':' zāi zǐ','组分':' zǔ fèn','累积':' lěi jī','纰缪':' pī miù','纽子':' niǔ zǐ','纳什':' nà shí','澹泊':' dàn bó','炸鸡':' zhá jī','泡吧':' pào bā','无处':' wú chǔ','泊车':' bó chē','泊位':' bó wèi','河叉':' hé chà','沙拉':' shā là','没落':' mò luò','殷都':' yīn dū','渡假':' dù jià','湮没':' yān mò','无尽':' wú jìn','炸鱼':' zhá yú','无为':' wú wéi','无干':' wú gān','乌什':' wū shí','比才':' bì cái','为期':' wéi qī','毛厕':' máo si','测度':' cè duó','毛肚':' máo dǔ','为伍':' wéi wǔ','毫发':' háo fà','止咳':' zhǐ ké','留都':' liú dū','约塔':' yāo tǎ','部分':' bù fèn','责难':' zé nàn','近似':' jìn sì','这麽':' zhè me','配给':' pèi jǐ','配子':' pèi zǐ','都兰':' dū lán','都市':' dū shì','都尉':' dū wèi','都匀':' dū yún','那知':' nǎ zhī','贴吧':' tiē bā','这末':' zhè me','那是':' nà shi','避难':' bì nàn','遗著':' yí zhù','递解':' dì jiè','违拗':' wéi ào','过得':' guò de','游子':' yóu zǐ','遇难':' yù nàn','逮捕':' dài bǔ','踅摸':' xué mo','贲临':' bì lín','蚶子':' hān zǐ','载入':' zǎi rù','东阿':' dōng ē','旧都':' jiù dū','花呢':' huā ní','脊索':' jǐ suǒ','虺蜥':' huǐ xī','蛙鞋':' wā xié','轗轲':' kǎn kě','载荷':' zài hè','载籍':' zǎi jí','轧机':' zhá jī','卖卜':' mài bǔ','蹦儿':' bèng r','踶跂':' dì zhī','踏查':' tà zhā','辟邪':' bì xié','踏实':' tā shi','跂坐':' qì zuò','书脊':' shū jǐ','走子':' zǒu zǐ','赤子':' chì zǐ','质子':' zhì zǐ','逻辑':' luó ji','贩子':' fàn zǐ','番禺':' pān yú','试液':' shì yè','谜儿':' mèi ér','诸葛':' zhū gě','诸子':' zhū zǐ','论语':' lún yǔ','替角':' tì jué','觉得':' jué de','误差':' wù chā','认得':' rèn de','月子':' yuè zǐ','记载':' jì zǎi','誉为':' yù wéi','记为':' jì wéi','解法':' xiè fǎ','角色':' jué sè','角抵':' jué dǐ','诱掖':' yòu yè','酒吧':' jiǔ bā','柔佛':' róu fó','脂麻':' zhī ma','款儿':' kuǎn r','识得':' shí de','豁达':' huò dá','豆皀':' dòu bī','衣甲':' yì jiǎ','核查':' hé zhā','要末':' yào me','要击':' yāo jī','要得':' yào de','要子':' yào zǐ','褶子':' zhě zǐ','里头':' lǐ tou','袒裼':' tǎn xī','袍子':' páo zǐ','服事':' fú shi','蛮子':' mán zǐ','角力':' jué lì','蚕薄':' cán bó','蚕子':' cán zǐ','蝎子':' xiē zǐ','蚂蚱':' mà zhà','蜗杆':' wō gǎn','虾子':' xiā zǐ','蛤蚧':' gé jiè','血塞':' xuè sè','貌似':' mào sì','亲子':' qīn zǐ','梅子':' méi zǐ','粪耙':' fèn pá','舍弟':' shè dì','打擂':' dǎ lèi','打折':' dǎ shé','车仆':' chē pú','车毂':' chē gū','打杈':' dǎ chà','扳子':' bān zǐ','批假':' pī jià','扒窃':' pá qiè','大落':' dà luō','滀仕':' xù shì','闷热':' mēn rè','扒糕':' pá gāo','大尽':' dà jìn','大哗':' dà huá','大斗':' dà dǒu','答茬':' dā chá','瘩背':' dá bèi','锉子':' cuò zǐ','处子':' chǔ zǐ','矬子':' cuó zǐ','恶少':' è shào','爱好':' ài hào','打倒':' dǎ dǎo','扒灰':' pá huī','刺溜':' cī liū','弹拨':' tán bō','地煞':' dì shà','低徊':' dī huí','底处':' dǐ chǔ','微薄':' wēi bó','得使':' de shǐ','得这':' de zhè','得月':' de yuè','得位':' de wèi','堤围':' dī wéi','悉数':' xī shǔ','处和':' chǔ hé','大溜':' dà liù','懒得':' lǎn de','戒子':' jiè zǐ','戽斗':' hù dǒu','所得':' suǒ de','匙子':' chí zi','痴子':' chī zǐ','才子':' cái zǐ','扎染':' zā rǎn','扒搂':' bā lōu','猝倒':' cù dǎo','恺弟':' kǎi tì','得时':' de shí','杆儿':' gǎn ér','菲仪':' fěi yí','佛心':' fó xīn','佛珠':' fó zhū','干呕':' gān ǒu','干没':' gān mò','干礼':' gān lǐ','干季':' gān jì','干急':' gān jí','干股':' gān gǔ','佛印':' fó yìn','干戈':' gān gē','巨著':' jù zhù','干碍':' gān ài','附识':' fù zhì','附载':' fù zǎi','差异':' chā yì','差距':' chā jù','赴难':' fù nàn','拂过':' bì guò','佛座':' fó zuò','干巴':' gān bā','帖子':' tiě zǐ','飞子':' fēi zǐ','恺撒':' kǎi sǎ','佛界':' fó jiè','憨子':' hān zǐ','雏子':' chú zǐ','情儿':' qíng r','押解':' yā jiè','豆秸':' dòu jí','弹压':' tán yā','佛事':' fó shì','佛人':' fó rén','佛老':' fó lǎo','佛化':' fó huà','榧子':' fěi zǐ','佛国':' fó guó','佛宝':' fó bǎo','巴斗':' bā dǒu','布什':' bù shí','佛头':' fó tóu','师傅':' shī fū','纷沓':' fēn tà','幔子':' màn zǐ','分得':' fēn de','干系':' gān xì','复查':' fù zhā','得要':' de yào','栀子':' zhī zǐ','破处':' pò chǔ','枣子':' zǎo zǐ','砣子':' tuó zǐ','砌末':' qiè mò','砂子':' shā zǐ','矸子':' gān zǐ','乐器':' yuè qì','乐府':' yuè fǔ','乐律':' yuè lǜ','瞽阇':' gǔ shé','盘曲':' pán qǔ','乐谱':' yuè pǔ','乐迷':' yuè mí','眸子':' móu zǐ','看护':' kān hù','看押':' kān yā','看似':' kàn sì','楼子':' lóu zǐ','模板':' mú bǎn','乐曲':' yuè qǔ','笔杆':' bǐ gǎn','答白':' dā bái','查核':' zhā hé','磨烦':' mò fán','柚木':' yóu mù','累计':' lěi jì','梭子':' suō zǐ','缉查':' jī zhā','罹难':' lí nàn','胳臂':' gē bei','胞子':' bāo zǐ','背逆':' bēi nì','背负':' bēi fù','背脊':' bèi jǐ','肋骨':' lèi gǔ','肉脯':' ròu fǔ','续假':' xù jià','柞栎':' zuò lì','查缉':' zhā jī','耗子':' hào zǐ','栅子':' zhà zǐ','老姥':' lǎo mǔ','翅子':' chì zǐ','美发':' měi fà','美的':' měi dí','碟子':' dié zǐ','笆斗':' bā dǒu','得很':' de hěn','恰似':' qià sì','倒阁':' dǎo gé','倒底':' dǎo dǐ','得靠':' de kào','到得':' dào de','急难':' jí nàn','蛋子':' dàn zǐ','恁么':' rèn me','赕佛':' dǎn fó','恨恶':' hèn wù','待得':' dài de','必得':' bì děi','答允':' dā yǔn','刀把':' dāo bà','大说':' dà yuè','得来':' de lái','得数':' de shù','弹牙':' tán yá','弹词':' tán cí','弯子':' wān zǐ','铫子':' yáo zǐ','影儿':' yǐng r','叨咕':' dáo gu','倒牙':' dǎo yá','竿子':' gān zǐ','科斗':' kē dǒu','窥伺':' kuī sì','窑子':' yáo zǐ','桠杈':' yā chà','楔子':' xiē zǐ','空额':' kòng é','极为':' jí wéi','磨叨':' mò dāo','积累':' jī lěi','稚子':' zhì zǐ','秦都':' qín dū','私处':' sī chǔ','出没':' chū mò','祝发':' zhù fà','磨难':' mó nàn','磨碎':' mò suì','磨盘':' mò pán','稻子':' dào zǐ','杆塔':' gǎn tǎ','晕糊':' yūn hu','普查':' pǔ zhā','得对':' de duì','道子':' dào zǐ','舍利':' shè lì','般乐':' pán lè','是得':' shì de','单个':' dān ge','门把':' mén bà','媒子':' méi zǐ','哪吒':' né zhā','宓妃':' fú fēi','糜子':' méi zǐ','煤核':' méi hú','没得':' méi de','男仆':' nán pú','毛子':' máo zǐ','南曲':' nán qǔ','闷气':' mēn qì','哪个':' něi gè','毛呢':' máo ní','难挨':' nán ái','秘钥':' mì yuè','柰子':' nài zǐ','咪唑':' mǐ zuò','喝道':' hè dào','喝彩':' hè cǎi','喜帖':' xǐ tiě','喜好':' xǐ hào','难弟':' nàn dì','潘子':' pān zǐ','喀嚓':' kā chā','礼帖':' lǐ tiě','报子':' bào zǐ','尧都':' yáo dū','淋滤':' lìn lǜ','呢喃':' ní nán','力尽':' lì jìn','呵叱':' hē chì','地处':' dì chǔ','地窨':' dì yìn','呵斥':' hē chì','咳痰':' ké tán','呵禁':' hē jìn','礼乐':' lǐ yuè','在乎':' zài hu','土著':' tǔ zhù','国都':' guó dū','囤积':' tún jī','因子':' yīn zǐ','回鹘':' huí hú','坋粒':' fèn lì','陂陀':' pō tuó','泯没':' mǐn mò','喀什':' kā shí','锚泊':' máo bó','哇噻':' wā sāi','嗑药':' kè yào','吗啡':' mǎ fēi','哇塞':' wā sāi','嫚骂':' màn mà','臬兀':' niè wū','哇靠':' wā kào','单薄':' dān bó','满子':' mǎn zǐ','单曲':' dān qǔ','抹澡':' mā zǎo','牛肚':' niú dǔ','系带':' jì dài','吸血':' xī xiě','老区':' lǎo ōu','褯子':' jiè zǐ','节子':' jiē zǐ','疖子':' jiē zǐ','芥子':' jiè zǐ','曲池':' qǔ chí','进给':' jìn jǐ','马扎':' mǎ zhá','马仔':' mǎ zǎi','啦呱':' lā gua','嘴子':' zuǐ zǐ','缪斯':' miù sī','磨粉':' mò fěn','没世':' mò shì','喝采':' hè cǎi','路卡':' lù qiǎ','南子':' nán zǐ','呢帽':' ní mào','庐舍':' lú shè','啪嚓':' pā chā','唠嗑':' lào kè','哀号':' āi háo','哗啦':' huā lā','怒号':' nù háo','牛子':' niú zǐ','掠地':' lüě dì','妞子':' niū zǐ','落发':' luò fà','哀乐':' āi yuè','麻杆':' má gǎn','马杆':' mǎ gǎn','内子':' nèi zǐ','酦醅':' pō pēi','累次':' lěi cì','诘责':' jié zé','贵子':' guì zǐ','忍得':' rěn de','扞格':' hàn gé','黍子':' shǔ zǐ','寻死':' xín sǐ','竖子':' shù zǐ','树子':' shù zǐ','割舍':' gē shè','尉迟':' yù chí','划破':' huá pò','桂子':' guì zǐ','喝问':' hè wèn','射干':' yè gān','辊子':' gǔn zǐ','喊呀':' hǎn yā','劈叉':' pǐ chà','磙子':' gǔn zǐ','释子':' shì zǐ','世子':' shì zǐ','国子':' guó zǐ','馃子':' guǒ zǐ','石子':' shí zǐ','对子':' duì zǐ','射的':' shè dì','哈什':' hà shí','识记':' zhì jì','宿舍':' sù shè','宿分':' sù fèn','家子':' jiā zǐ','家姑':' jiā gū','害得':' hài de','和诗':' hè shī','何为':' hé wéi','学摸':' xué mo','荷载':' hè zǎi','包扎':' bāo zā','包袱':' bāo fú','化子':' huā zi','区处':' qū chǔ','折辱':' shé rǔ','黑子':' hēi zǐ','很子':' hěn zǐ','安分':' ān fèn','孽子':' niè zǐ','食邑':' shí yì','什物':' shí wù','累及':' lěi jí','胚子':' pēi zǐ','篓子':' lǒu zǐ','漏子':' lòu zǐ','干谒':' gān yè','陆处':' lù chǔ','炮子':' pào zǐ','炮格':' páo gé','咯嚓':' gē chā','咱家':' zá jiā','咳嗽':' ké sòu','虏掠':' lǔ lüě','绺子':' liǔ zǐ','檩子':' lǐn zǐ','回纥':' huí hé','朴刀':' pō dāo','坨子':' tuó zǐ','埋没':' mái mò','檑木':' lèi mù','肋木':' lèi mù','肋膜':' lèi mó','坎子':' kǎn zǐ','配曲':' pèi qǔ','溜子':' liū zǐ','海曲':' hǎi qǔ','和牌':' hú pái','宝坻':' bǎo dǐ','力拓':' lì tuò','热轧':' rè zhá','抹灰':' mò huī','厌恶':' yàn wù','膍胵':' pí zhì','僻处':' pì chǔ','咔嚓':' kā chā','芘芣':' pí fǒu','噶厦':' gá xià','喷撒':' pēn sǎ','六子':' liù zǐ','遛马':' liù mǎ','披散':' pī sǎn','咋舌':' zé shé','六路':' liù lù','六个':' liù ge','咋呼':' zhā hū','和洽':' hé qià','吓唬':' xià hu','喷薄':' pēn bó','喷子':' pēn zǐ','街子':' jiē zǐ','失意':' shī yì','芋头':' yù tou','华发':' huá fà','落泊':' luò bó','落得':' luò de','落子':' lào zǐ','落下':' là xià','李悝':' lǐ kuī','李适':' lǐ kuò','萎叶':' wěi yè','菹醢':' zū hǎi','菲姬':' fěi jī','菌子':' jùn zi','葛优':' gě yōu','莞尔':' wǎn ěr','草耙':' cǎo pá','荀子':' xún zǐ','萎靡':' wěi mǐ','茶几':' chá jī','荤粥':' xūn yù','蔫儿':' niān r','号子':' hào zǐ','木杆':' mù gǎn','处罚':' chǔ fá','著录':' zhù lù','干热':' gān rè','处死':' chǔ sǐ','克尽':' kè jìn','多咱':' duō zá','看得':' kàn de','多佛':' duō fó','靠泊':' kào bó','客舍':' kè shè','靠得':' kào de','尻子':' kāo zǐ','科处':' kē chǔ','刻划':' kè huá','且夫':' qiě fú','谩骂':' màn mà','壬子':' rén zǐ','可数':' kě shǔ','坷坎':' kē kǎn','可汗':' kè hán','叱呵':' chì hē','叱喝':' chì hè','德干':' dé gān','士子':' shì zǐ','铐子':' kào zǐ','赶圩':' gǎn xū','处理':' chǔ lǐ','处于':' chǔ yú','可塞':' kě sài','枚卜':' méi bǔ','腕子':' wàn zǐ','脱发':' tuō fà','染发':' rǎn fà','脊髓':' jǐ suǐ','脊背':' jǐ bèi','脊肋':' jǐ lèi','柏林':' bó lín','茅厕':' máo si','果脯':' guǒ fǔ','茄子':' qié zi','臊子':' sào zǐ','范蠡':' fàn lǐ','苦难':' kǔ nàn','苦处':' kǔ chǔ','花都':' huā dū','花蛤':' huā gé','束发':' shù fà','杯葛':' bēi gě','果子':' guǒ zǐ','花子':' huā zǐ','芍陂':' què pí','腰子':' yāo zǐ','枝子':' zhī zǐ','处女':' chǔ nǚ','蕃庑':' fán wú','木头':' mù tou','朱子':' zhū zǐ','兰若':' lán rě','藉以':' jiè yǐ','薄酒':' bó jiǔ','薄海':' bó hǎi','薄待':' bó dài','薄弱':' bó ruò','薄厚':' bó hòu','芜累':' wú lěi','未卜':' wèi bǔ','臊气':' sào qì','亏得':' kuī de','茬子':' chá zǐ','茄科':' qié kē','与会':' yù huì','枯干':' kū gān','枯萎':' kū wěi','舀子':' yǎo zǐ','自尽':' zì jìn','柏悦':' bó yuè','卧倒':' wò dǎo','咯血':' kǎ xiě','蹶子':' jué zǐ','夹克':' jiá kè','威吓':' wēi hè','鸡舍':' jī shè','妗子':' jìn zǐ','急煞':' jí shà','妹子':' mèi zǐ','参差':' cēn cī','群子':' qún zǐ','委靡':' wěi mǐ','极尽':' jí jìn','姥爷':' lǎo ye','厌薄':' yàn bó','夺得':' duó de','热和':' rè huo','脊檩':' jǐ lǐn','奥什':' aò shí','夹布':' jiá bù','家仆':' jiā pú','好恶':' hào wù','夹衣':' jiá yī','好客':' hào kè','好奇':' hào qí','好哇':' hǎo wā','妃子':' fēi zǐ','套曲':' tào qǔ','参与':' cān yù','天儿':' tiān r','夹袄':' jiá ǎo','奇数':' jī shù','叉子':' chā zǐ','杰子':' jié zǐ','套子':' tào zǐ','太子':' tài zǐ','太仆':' tài pú','禁曲':' jìn qǔ','禁子':' jìn zǐ','曲包':' qǔ bāo','古刹':' gǔ chà','大难':' dà nàn','大只':' dà zhī','九曲':' jiǔ qǔ','球子':' qiú zǐ','舅子':' jiù zǐ','秋子':' qiū zǐ','九子':' jiǔ zǐ','叔子':' shū zǐ','大为':' dà wéi','金铺':' jīn pū','屈折':' qū shé','曲坛':' qǔ tán','橛子':' jué zǐ','含糊':' hán hu','吧台':' bā tái','癞子':' lài zǐ','赖子':' lài zǐ','来子':' lái zǐ','吧托':' bā tuō','塔刹':' tǎ chà','塌实':' tā shi','落儿':' lào ér','老佛':' lǎo fó','老仆':' lǎo pú','吞没':' tūn mò','吸尽':' xī jìn','君子':' jūn zǐ','句读':' jù dòu','咳血':' ké xuè','吆喝':' yāo he','琴曲':' qín qǔ','只得':' zhǐ de','切末':' qiē mò','倔巴':' juè bā','夥计':' huǒ ji','莱塞':' lái sè','起解':' qǐ jiè','好似':' hǎo sì','塞音':' sè yīn','奶子':' nǎi zǐ','曲式':' qǔ shì','曲牌':' qǔ pái','好色':' hào sè','络子':' lào zi','柜柳':' jǔ liǔ','大夫':' dài fū','七煞':' qī shà','塞语':' sài yǔ','吖啶':' ā dìng','胯子':' kuà zǐ','合为':' hé wéi','墨斗':' mò dǒu','盔子':' kuī zǐ','凄咽':' qī yān','压倒':' yā dǎo','压板':' yà bǎn','卡壳':' qiǎ ké','名儿':' míng r','压根':' yà gēn','合著':' hé zhù','卡具':' qiǎ jù','乾图':' qián tú','曾家':' zēng jiā','拓殖':' tuò zhí','吊丧':' diào sāng','转悠':' zhuàn yōu','建行':' jiàn háng','左强':' zuǒ jiàng','膻中':' dàn zhōng','弄脏':' nòng zāng','单姓':' shàn xìng','长心':' cháng xīn','长信':' cháng xìn','淳朴':' chún piáo','沉着':' chén zhuó','长棍':' cháng gùn','划桨':' huá jiǎng','弄堂':' lòng táng','量杯':' liáng bēi','列传':' liè zhuàn','扮相':' bàn xiàng','凝冰':' níng bīng','碘酊':' diǎn dǐng','切成':' qiē chéng','轰隆':' hōng lōng','重印':' chóng yìn','扁舟':' piān zhōu','扇动':' shān dòng','应用':' yìng yòng','短供':' duǎn gòng','成为':' chéng wéi','还原':' huán yuán','成分':' chéng fèn','转筋':' zhuàn jīn','转纽':' zhuàn nǐu','重数':' chóng shù','长夏':' cháng xià','重头':' chóng tóu','还债':' huán zhài','炸酱':' zhá jiàng','顺应':' shùn yìng','糖色':' táng shǎi','长刀':' cháng dāo','铺床':' pū chuáng','戴上':' dài shang','当行':' dāng háng','转台':' zhuàn tái','还愿':' huán yuàn','延长':' yán cháng','折秤':' shé chèng','当差':' dāng chāi','长头':' cháng tóu','中邪':' zhòng xié','镗孔':' táng kǒng','应诏':' yìng zhào','叨光':' tāo guāng','颈椎':' jǐng zhuī','投中':' tóu zhòng','转游':' zhuàn you','重九':' chóng jiǔ','应变':' yìng biàn','张角':' zhāng jué','长街':' cháng jiē','转门':' zhuàn mén','张华':' zhāng huà','跳行':' tiào háng','转差':' zhuǎn chā','好尚':' hào shàng','多重':' duō chóng','种瓜':' zhòng guā','槟榔':' bīng láng','槟州':' bīng zhōu','检校':' jiǎn jiào','俏销':' qiào xiāo','看场':' kān chǎng','胸闷':' xīong mēn','强嘴':' jiàng zuǐ','靓仔':' liàng zǎi','量规':' liáng guī','应景':' yìng jǐng','重又':' chóng yòu','应手':' yìng shǒu','重回':' chóng huí','折衷':' shé zhōng','应战':' yìng zhàn','重围':' chóng wéi','悠长':' yōu cháng','靓妹':' liàng mèi','嘴长':' zuǐ cháng','转载':' zhuǎn zǎi','长杰':' cháng jié','重修':' chóng xiū','应诊':' yìng zhěn','惩处':' chéng chǔ','重写':' chóng xiě','应点':' yìng diǎn','转轮':' zhuàn lún','长存':' cháng cún','应酬':' yìng chóu','长排':' cháng pái','更换':' gēng huàn','还清':' huán qīng','酬应':' chóu yìng','横行':' héng xíng','长干':' cháng gàn','更动':' gēng dòng','重孙':' chóng sūn','永兴':' yǒng xīng','长幼':' cháng yòu','点着':' diǎn zháo','兜率':' dōu shuài','长随':' cháng suí','弹唱':' tán chàng','饮场':' yìn chǎng','重拾':' chóng shí','张拓':' zhāng tuò','天应':' tiān yìng','重开':' chóng kāi','重弹':' chóng tán','荥经':' yíng jīng','运转':' yùn zhuàn','分量':' fèn liàng','重获':' chóng huò','重犯':' chóng fàn','越长':' yuè cháng','重构':' chóng gòu','道长':' dào cháng','沧浪':' cāng láng','鼎兴':' dǐng xīng','慢长':' màn cháng','长活':' cháng huó','长尾':' cháng wěi','懂行':' dǒng háng','分相':' fēn xiàng','刨程':' bào chéng','长眼':' cháng yǎn','重文':' chóng wén','长恨':' cháng hèn','往还':' wǎng huán','重新':' chóng xīn','滇藏':' diān zàng','听差':' tīng chāi','长话':' cháng huà','春兴':' chūn xīng','追还':' zhuī huán','应召':' yìng zhào','应从':' yìng cóng','更名':' gēng míng','重奏':' chóng zòu','重婚':' chóng hūn','扎挣':' zhá zhēng','切中':' qiè zhòng','重楼':' chóng lóu','酩酊':' mǐng dǐng','影片':' yǐng piān','通红':' tòng hóng','调调':' tiáo diào','晃悠':' huàng yōu','别传':' bié zhuàn','长蛇':' cháng shé','重查':' chóng chá','斋供':' zhāi gòng','重叠':' chóng dié','连翘':' lián qiáo','天监':' tiān jiàn','彷徉':' páng yáng','晕场':' yùn chǎng','投降':' tóu xiáng','斗转':' dǒu zhuǎn','强求':' qiǎng qiú','重来':' chóng lái','转文':' zhuǎi wén','长牌':' cháng pái','重拍':' chóng pāi','还手':' huán shǒu','划船':' huá chuán','重瓣':' chóng bàn','长褂':' cháng guà','攒动':' cuán dòng','钻钻':' zuàn zuàn','刁横':' diāo hèng','调卷':' diào juàn','切向':' qiē xiàng','重演':' chóng yǎn','侧棱':' zhāi léng','寸长':' cùn cháng','江干':' jiāng gān','定更':' dìng gēng','顶杠':' dǐng gàng','晾干':' liàng gān','东渐':' dōng jiān','重温':' chóng wēn','想头':' xiǎng tou','长跪':' cháng guì','晕船':' yùn chuán','重制':' chóng zhì','找着':' zhǎo zháo','啜茗':' chuò míng','洋壳':' yáng qiào','运将':' yùn jiàng','弹簧':' tán huáng','种痘':' zhòng dòu','小差':' xiǎo chāi','重返':' chóng fǎn','鲜见':' xiǎn jiàn','奉还':' fèng huán','缴卷':' jiǎo juàn','航行':' háng xíng','嚼用':' jiáo yòng','当真':' dàng zhēn','松茸':' sōng róng','应援':' yìng yuán','当天':' dàng tiān','散光':' sǎn guāng','摇晃':' yáo huàng','求降':' qiú xiáng','闷声':' mēn shēng','蒙哄':' méng hǒng','丧棒':' sāng bàng','尨茸':' méng róng','屯邅':' zhūn zhān','丧乱':' sāng luàn','乾陵':' qián líng','凶煞':' xiōng shà','棕绷':' zōng bēng','丧葬':' sāng zàng','疏率':' shū shuài','船只':' chuán zhī','矫情':' jiáo qíng','痴长':' chī cháng','兴荣':' xīng róng','兴旺':' xīng wàng','兴建':' xīng jiàn','兴平':' xīng píng','受禅':' shòu shàn','兴山':' xīng shān','兴宁':' xīng níng','兴兵':' xīng bīng','兴亡':' xīng wáng','金相':' jīn xiàng','校点':' jiào diǎn','清供':' qīng gòng','大黄':' dài huáng','便了':' biàn liǎo','兴隆':' xīng lóng','奠定':' diàn dìng','芳甸':' fāng diàn','将佐':' jiàng zuǒ','交差':' jiāo chāi','套种':' tào zhòng','校雠':' jiào chóu','降妖':' xiáng yāo','传略':' zhuàn lüè','央行':' yāng háng','农行':' nóng háng','秤杆':' chèng gǎn','党参':' dǎng shēn','僮族':' zhuàng zú','为政':' wéi zhèng','枪杆':' qiāng gǎn','禅让':' shàn ràng','内传':' nèi zhuàn','傧相':' bīn xiàng','难兄':' nàn xiōng','社长':' shè cháng','单县':' shàn xiàn','矿难':' kuàng nàn','转来':' zhuàn lái','转为':' zhuǎn wéi','哄劝':' hǒng quàn','碾坊':' niǎn fáng','杠荡':' gàng dàng','男相':' nán xiàng','乾隆':' qián lóng','位相':' wèi xiàng','状子':' zhuàng zǐ','黑框':' hēi kuàng','瞭哨':' liào shào','椆苕':' diào tiáo','粘稠':' nián chóu','穷尽':' qióng jìn','彭彭':' bāng bāng','传赞':' zhuàn zàn','棚圈':' péng juàn','喷香':' pèn xiāng','充分':' chōng fèn','筵上':' yán shǎng','瞭望':' liào wàng','粘粘':' nián nián','粘性':' nián xìng','了了':' liǎo liǎo','援藏':' yuán zàng','乐章':' yuè zhāng','单相':' dān xiàng','睡着':' shuì zháo','睡觉':' shuì jiào','笼罩':' lǒng zhào','笼统':' lǒng tǒng','笼槛':' lóng jiàn','命名':' mìng míng','简朴':' jiǎn piáo','万乘':' wàn shèng','兴县':' xīng xiàn','种牛':' zhòng niú','翘棱':' qiáo lēng','脑涨':' nǎo zhàng','强人':' qiǎng rén','校样':' jiào yàng','翘首':' qiáo shǒu','校准':' jiào zhǔn','校监':' xiào jiàn','乾乾':' qián qián','浅浅':' jiān jiān','乾明':' qián míng','乡侯':' xiāng hòu','召陵':' shào líng','乾龙':' qián lóng','翘望':' qiáo wàng','直率':' zhí shuài','吊卷':' diào juàn','吊杠':' diào gàng','干姜':' gān jiāng','同行':' tóng háng','相位':' xiàng wèi','校订':' jiào dìng','倔强':' jué jiàng','卷首':' juàn shǒu','卷面':' juàn miàn','强切':' qiáng qiē','圈养':' juàn yǎng','强颜':' qiǎng yán','外传':' wài zhuàn','背筐':' bēi kuāng','倒相':' dào xiàng','尽忠':' jìn zhōng','中舍':' zhōng shè','肖邦':' xiāo bāng','康乾':' kāng qián','肖扬':' xiāo yáng','症结':' zhēng jié','卷帘':' juàn lián','长直':' cháng zhí','振兴':' zhèn xīng','九转':' jiǔ zhuàn','种菜':' zhòng cài','胶粘':' jiāo nián','削面':' xiāo miàn','够戗':' gòu qiàng','小卷':' xiǎo juàn','大城':' dài chéng','卷卷':' juàn juàn','上头':' shàng tou','乾元':' qián yuán','画框':' huà kuàng','甚浓':' shèn nóng','东兴':' dōng xīng','乐正':' yuè zhèng','将尉':' jiàng wèi','好强':' hào qiáng','草率':' cǎo shuài','著称':' zhù chēng','兴邦':' xīng bāng','挑弄':' tiǎo nòng','着手':' zhuó shǒu','着忙':' zháo máng','兵差':' bīng chāi','并州':' bīng zhōu','正切':' zhèng qiē','阮元':' ruǎn yuán','挑战':' tiǎo zhàn','掸邦':' shàn bāng','绕梁':' rǎo liáng','穰穰':' rǎng rǎng','倒帐':' dǎo zhàng','公差':' gōng chāi','用间':' yòng jiàn','将门':' jiàng mén','摒挡':' bìng dàng','强留':' qiǎng liú','老将':' lǎo jiàng','声乐':' shēng yuè','垦种':' kěn zhòng','横杠':' héng gàng','相切':' xiāng qiē','垫圈':' diàn juàn','考量':' kǎo liáng','掉色':' diào shǎi','吃相':' chī xiàng','倒账':' dǎo zhàng','刨光':' bào guāng','琅孉':' láng huān','公共':' gōng gòng','填空':' tián kòng','兼差':' jiān chāi','挑明':' tiǎo míng','挑灯':' tiǎo dēng','好胜':' hào shèng','见年':' xiàn nián','家种':' jiā zhòng','参茸':' shēn róng','冰凝':' bīng níng','减削':' jiǎn xiāo','重蹈':' chóng dǎo','都长':' dōu cháng','空调':' kōng tiáo','应约':' yìng yuē','解款':' jiè kuǎn','兴尽':' xìng jìn','占卦':' zhān guà','受到':' shòu dào','林甸':' lín diàn','枕藉':' zhěn jiè','兴海':' xīng hǎi','兴头':' xìng tou','轻载':' qīng zǎi','松菌':' sōng jùn','失当':' shī dàng','邓拓':' dèng tuò','病倒':' bìng dǎo','当是':' dàng shì','清切':' qīng qiē','兴学':' xīng xué','口供':' kǒu gòng','散工':' sǎn gōng','反应':' fǎn yìng','天台':' tiān tāi','频数':' pín shuò','兴宾':' xīng bīn','解送':' jiè sòng','藏民':' zàng mín','畹町':' wǎn dīng','兴文':' xīng wén','酌处':' zhuó chǔ','只缘':' zhī yuán','解差':' jiè chāi','配称':' pèi chèn','尽欢':' jìn huān','太监':' tài jiàn','兴师':' xīng shī','思量':' sī liang','干冰':' gān bīng','兴办':' xīng bàn','钦差':' qīn chāi','反间':' fǎn jiàn','柞绸':' zuò chóu','校注':' jiào zhù','消褪':' xiāo tùn','反省':' fǎn xǐng','受尽':' shòu jìn','病假':' bìng jià','失调':' shī tiáo','失着':' shī zhāo','天分':' tiān fèn','倒产':' dǎo chǎn','挨整':' ái zhěng','中得':' zhōng de','般桓':' pán huán','浇头':' jiāo tou','兴化':' xīng huà','嚼头':' jiáo tóu','当晚':' dàng wǎn','兴仁':' xīng rén','天干':' tiān gān','受难':' shòu nàn','清隽':' qīng jùn','圈舍':' juàn shè','遒劲':' qiú jìng','诱供':' yòu gòng','抗折':' kàng shé','小斗':' xiǎo dǒu','暖和':' nuǎn huo','炔烃':' quē tīng','倒扁':' dǎo biǎn','外行':' wài háng','好动':' hào dòng','尽孝':' jìn xiào','颠倒':' diān dǎo','尽让':' jìn ràng','兴国':' xīng guó','娇娜':' jiāo nuó','自转':' zì zhuàn','惊倒':' jīng dǎo','搅和':' jiǎo huo','晒干':' shài gān','切断':' qiē duàn','教给':' jiāo gěi','焦干':' jiāo gān','脚杆':' jiǎo gǎn','茎杆':' jīng gǎn','校改':' jiào gǎi','长日':' cháng rì','校书':' jiào shū','情切':' qíng qiē','切线':' qiē xiàn','酬酢':' chóu zuò','当月':' dàng yuè','切片':' qiē piàn','受累':' shòu lěi','兴奋':' xīng fèn','浪头':' làng tou','长度':' cháng dù','躺倒':' tǎng dǎo','切痛':' qiē tòng','精尽':' jīng jìn','切块':' qiē kuài','大将':' dà jiàng','救应':' jiù yìng','切用':' qiē yòng','重估':' chóng gū','倒垂':' dǎo chuí','藏蓝':' zàng lán','挺杆':' tǐng gǎn','仔兽':' zǎi shòu','发怔':' fā zhèng','切变':' qiē biàn','子姜':' zǐ jiāng','登载':' dēng zǎi','念头':' niàn tou','零散':' líng sǎn','执著':' zhí zhuó','舰只':' jiàn zhī','奔命':' bèn mìng','奔丧':' bēn sāng','醒豁':' xǐng huò','当做':' dàng zuò','切换':' qiē huàn','丑角':' chǒu jué','九钻':' jiǔ zuàn','大王':' dài wáng','自传':' zì zhuàn','蒙牛':' měng níu','箭杆':' jiàn gǎn','丧尸':' sāng shī','咆哮':' páo xiào','筠连':' jūn lián','为甚':' wéi shèn','皮相':' pí xiàng','重播':' chóng bō','刁难':' diāo nàn','答腔':' dā qiāng','曾华':' zēng huá','色长':' sè cháng','丧尽':' sàng jìn','黄陂':' huáng pō','劈账':' pǐ zhàng','办差':' bàn chāi','考卷':' kǎo juàn','叨教':' tāo jiào','都昌':' dū chāng','同处':' tóng chǔ','叩应':' kòu yìng','公仔':' gōng zǎi','款新':' kuǎn xīn','倒换':' dǎo huàn','小舍':' xiǎo shè','卷丹':' juàn dān','倒动':' dǎo dòng','倒吊':' dǎo diào','重午':' chóng wǔ','小尽':' xiǎo jìn','腰椎':' yāo zhuī','恰当':' qià dàng','卷柏':' juàn bǎi','卷包':' juàn bāo','白卷':' bái juàn','栏栅':' lán shān','夺冠':' duó guàn','圈肥':' juàn féi','公假':' gōng jià','卷柜':' juàn guì','臂长':' bì cháng','重合':' chóng hé','海参':' hǎi shēn','悄然':' qiǎo rán','重启':' chóng qǐ','大率':' dà shuài','耩子':' jiǎng zǐ','松散':' sōng sǎn','搅混':' jiǎo gǔn','色相':' sè xiàng','挑衅':' tiǎo xìn','释卷':' shì juàn','当作':' dàng zuò','精舍':' jīng shè','子将':' zǐ jiāng','膙子':' jiǎng zǐ','芫花':' yuán huā','枕头':' zhěn tou','倒风':' dǎo fēng','都城':' dū chéng','重塑':' chóng sù','脑杓':' nǎo sháo','卷缩':' juàn suō','海兴':' hǎi xīng','只手':' zhī shǒu','切手':' qiē shǒu','卷头':' juàn tóu','颉颃':' xié háng','杯筊':' bēi jiǎo','卷尾':' juàn wěi','花着':' huā zhāo','朘削':' juān xuē','亭侯':' tíng hòu','嘉应':' jiā yìng','重担':' zhòng dàn','轮种':' lún zhòng','转位':' zhuàn wèi','朝朝':' zhāo zhāo','浆纸':' jiàng zhǐ','幸甚':' xìng shèn','手缝':' shǒu féng','长假':' cháng jià','乐声':' yuè shēng','长坂':' cháng bǎn','长眉':' cháng méi','调弦':' tiáo xián','更深':' gēng shēn','趁兴':' chèn xīng','台长':' tái cháng','钟乐':' zhōng yuè','晨兴':' chén xīng','伄儅':' diào dāng','长云':' cháng yún','沈莹':' shěn yíng','城阙':' chéng què','刚劲':' gāng jìng','漂荡':' piāo dàng','倒箱':' dǎo xiāng','涨满':' zhàng mǎn','盛满':' chéng mǎn','干将':' gàn jiàng','皇子':' huáng zǐ','抄查':' chāo zhā','恶创':' è chuāng','肯綮':' kěn qìng','二重':' èr chóng','曲种':' qǔ zhǒng','切当':' qiē dāng','好战':' hào zhàn','摆晃':' bǎi huàng','轮转':' lún zhuàn','性行':' xìng xíng','轩槛':' xuān jiàn','长叹':' cháng tàn','手钻':' shǒu zuàn','手卷':' shǒu juàn','倒想':' dǎo xiǎng','重出':' chóng chū','漂洋':' piāo yáng','长沙':' cháng shā','重版':' chóng bǎn','长醉':' cháng zuì','占梦':' zhān mèng','长流':' cháng liú','柬帖':' jiǎn tiě','盛载':' shèng zǎi','久长':' jiǔ cháng','音长':' yīn cháng','长毛':' cháng máo','削尖':' xiāo jiān','旋工':' xuàn gōng','趁空':' chèn kòng','长多':' cháng duō','衰萎':' shuāi wěi','风钻':' fēng zuàn','长林':' cháng lín','长车':' cháng chē','长材':' cháng cái','当票':' dàng piào','戎行':' róng háng','长休':' cháng xiū','长岛':' cháng dǎo','重插':' chóng chā','重造':' chóng zào','重述':' chóng shù','重迭':' chóng dié','浅鲜':' qiǎn xiǎn','中肯':' zhòng kěn','漫长':' màn cháng','海相':' hǎi xiàng','称身':' chèn shēn','称愿':' chèn yuàn','份量':' fèn liang','漂零':' piāo líng','钻井':' zuàn jǐng','盛饭':' chéng fàn','长音':' cháng yīn','长吟':' cháng yín','太冲':' tài chòng','称手':' chèn shǒu','摊场':' tān cháng','长门':' cháng mén','廊坊':' láng fáng','刷卷':' shuā juàn','长俊':' cháng jùn','铜钿':' tóng tián','长才':' cháng cái','长久':' cháng jiǔ','明了':' míng liǎo','耍横':' shuǎ hèng','蹭蹬':' cèng dèng','长列':' cháng liè','脊梁':' jǐ liáng','菌柄':' jùn bǐng','咳喘':' ké chuǎn','曲张':' qǔ zhāng','尽性':' jìn xìng','今朝':' jīn zhāo','家雀':' jiā qiǎo','好氧':' hào yǎng','大仓':' tài cāng','留空':' liú kòng','盅子':' zhōng zǐ','介壳':' jiè qiào','侧歪':' zhāi wāi','台钻':' tái zuàn','草甸':' cǎo diàn','晕针':' yùn zhēn','空载':' kōng zǎi','内蒙':' nèi měng','诱哄':' yòu hòng','荷重':' hè zhòng','横祸':' hèng huò','衷曲':' zhōng qǔ','尽情':' jìn qíng','倒卷':' dǎo juàn','被卷':' bèi juàn','倒弄':' dǎo nòng','再兴':' zài xīng','长驱':' cháng qū','盛器':' chéng qì','宝钻':' bǎo zuàn','相如':' xiàng rú','挑檐':' tiǎo yán','课长':' kè cháng','茸毛':' róng máo','渐染':' jiān rǎn','挑花':' tiǎo huā','像似':' xiàng sì','内行':' nèi háng','倒算':' dǎo suàn','参校':' cān jiào','曲中':' qǔ zhōng','查拳':' zhā quán','外应':' wài yìng','内哄':' nèi hòng','倒剪':' dǎo jiǎn','监本':' jiàn běn','确当':' què dàng','背榜':' bēi bǎng','茄萣':' qié dìng','倒嗓':' dǎo sǎng','勘校':' kān jiào','啁啾':' zhōu jiū','重提':' chóng tí','乾坤':' qián kūn','筐子':' kuāng zǐ','销号':' xiāo hào','惬当':' qiè dàng','倒手':' dǎo shǒu','俏头':' qiào tou','情分':' qíng fèn','开兴':' kāi xīng','螣蛇':' téng shé','禀帖':' bǐng tiě','群氓':' qún méng','腔子':' qiāng zǐ','参薯':' shēn shǔ','横财':' hèng cái','尽兴':' jìn xìng','能耐':' néng nài','欢势':' huān shi','扫帚':' sào zhǒu','切削':' qiē xiāo','佳兴':' jiā xīng','油坊':' yóu fáng','冰瀑':' bīng bào','重沓':' chóng tà','槛车':' jiàn chē','小侯':' xiǎo hòu','栟茶':' bīng chá','圣子':' shèng zǐ','抢地':' qiāng dì','切面':' qiē miàn','横暴':' hèng bào','场圃':' cháng pǔ','画卷':' huà juàn','甲壳':' jiǎ qiào','款识':' kuǎn zhì','摒绝':' bìng jué','曲梁':' qǔ liáng','挑逗':' tiǎo dòu','重子':' zhòng zǐ','邮差':' yóu chāi','柴火':' chái huō','长得':' zhǎng de','脱壳':' tuō qiào','斋舍':' zhāi shè','重屋':' chóng wū','冰斗':' bīng dǒu','长路':' cháng lù','患难':' huàn nàn','柴门':' zhài mén','空闲':' kòng xián','摔倒':' shuāi dǎo','属望':' zhǔ wàng','说项':' shuì xiàng','冲调':' chōng tiáo','挑中':' tiāo zhòng','手长':' shǒu cháng','收降':' shōu xiáng','创口':' chuāng kǒu','涨红':' zhàng hóng','率性':' shuài xìng','前传':' qián zhuàn','水相':' shuǐ xiàng','准将':' zhǔn jiàng','天相':' tiān xiàng','刨床':' bào chuáng','率真':' shuài zhēn','真率':' zhēn shuài','周长':' zhōu cháng','评传':' píng zhuàn','相面':' xiàng miàn','真相':' zhēn xiàng','相间':' xiāng jiàn','相称':' xiāng chèn','相片':' xiàng piān','调光':' tiáo guāng','深长':' shēn cháng','相角':' xiàng jiǎo','少成':' shào chéng','胸椎':' xiōng zhuī','长洲':' cháng zhōu','少长':' shào zhǎng','营长':' yíng cháng','参商':' shēn shāng','沈翔':' shěn xiáng','照相':' zhào xiàng','少相':' shào xiāng','勉强':' miǎn qiǎng','商参':' shāng shēn','天将':' tiān jiàng','公转':' gōng zhuàn','猛将':' měng jiàng','牵强':' qiān qiǎng','晒场':' shài cháng','山长':' shān cháng','片长':' piàn cháng','率先':' shuài xiān','冗长':' rǒng cháng','通长':' tōng cháng','洋相':' yáng xiàng','相应':' xiāng yìng','命中':' mìng zhòng','小将':' xiǎo jiàng','重审':' chóng shěn','健将':' jiàn jiàng','中标':' zhòng biāo','招降':' zhāo xiáng','调整':' tiáo zhěng','杆状':' gǎn zhuàng','变相':' biàn xiàng','悄声':' qiǎo shēng','川藏':' chuān zàng','峥巆':' zhēng yíng','诚朴':' chéng piáo','王长':' wáng cháng','倒床':' dǎo chuáng','疯长':' fēng cháng','贤相':' xián xiàng','丑相':' chǒu xiàng','战将':' zhàn jiàng','贯串':' guàn chuàn','怪相':' guài xiàng','冯生':' píng shēng','重样':' chóng yàng','重洋':' chóng yáng','戗面':' qiàng miàn','全长':' quán cháng','偿还':' cháng huán','请降':' qǐng xiáng','幢幡':' zhuàng fān','戆直':' zhuàng zhí','睡相':' shuì xiàng','元长':' yuán cháng','偏长':' piān cháng','相公':' xiàng gōng','乾光':' qián guāng','瘦长':' shòu cháng','受降':' shòu xiáng','卿相':' qīng xiàng','强笑':' qiǎng xiào','当成':' dàng chéng','劝降':' quàn xiáng','生还':' shēng huán','正着':' zhèng zháo','率领':' shuài lǐng','名将':' míng jiàng','清长':' qīng cháng','遣将':' qiǎn jiàng','千乘':' qiān shèng','纤绳':' qiàn shéng','中觉':' zhōng jiào','骁将':' xiāo jiàng','重申':' chóng shēn','长顺':' cháng shùn','长虹':' cháng hóng','长痛':' cháng tòng','厂甸':' chǎng diàn','首相':' shǒu xiàng','长柄':' cháng bǐng','长兴':' cháng xīng','长天':' cháng tiān','长龙':' cháng lóng','长工':' cháng gōng','长岭':' cháng lǐng','挣钱':' zhèng qián','长勺':' cháng sháo','长钉':' cháng dìng','长远':' cháng yuǎn','承应':' chéng yìng','长身':' cháng shēn','长丰':' cháng fēng','长风':' cháng fēng','长方':' cháng fāng','长山':' cháng shān','长籼':' cháng xiān','长亭':' cháng tíng','长松':' cháng sōng','囊膪':' nāng chuài','长命':' cháng mìng','长庚':' cháng gēng','亭长':' tíng cháng','长桥':' cháng qiáo','干爽':' gān shuǎng','长青':' cháng qīng','长庆':' cháng qìng','掂量':' diān liang','长年':' cháng nián','长陵':' cháng líng','撞倒':' zhuàng dǎo','长春':' cháng chūn','兵长':' bīng cháng','长康':' cháng kāng','长卷':' cháng juàn','长鸣':' cháng míng','长剑':' cháng jiàn','长廊':' cháng láng','长拳':' cháng quán','长条':' cháng tiáo','长宁':' cháng níng','长衫':' cháng shān','长凳':' cháng dèng','囊揣':' nāng chuài','膀胱':' páng guāng','将令':' jiàng lìng','场院':' cháng yuàn','校正':' jiào zhèng','长调':' cháng diào','兴城':' xīng chéng','天长':' tiān cháng','警长':' jǐng cháng','兴衰':' xīng shuāi','监生':' jiàn shēng','间种':' jiàn zhòng','将校':' jiàng xiào','盟长':' méng cháng','兴盛':' xīng shèng','芒种':' máng zhòng','色钟':' shǎi zhōng','色盅':' shǎi zhōng','脸相':' liǎn xiàng','空转':' kōng zhuàn','耕种':' gēng zhòng','校场':' jiào chǎng','箱笼':' xiāng lǒng','降龙':' xiáng lóng','绵长':' mián cháng','丧荒':' sāng huāng','上供':' shàng gòng','经传':' jīng zhuàn','终了':' zhōng liǎo','上当':' shàng dàng','粮行':' liáng háng','粘虫':' nián chóng','统率':' tǒng shuài','了账':' liǎo zhàng','倘佯':' cháng yáng','周正':' zhōu zhēng','仙长':' xiān cháng','绷簧':' bēng huáng','丧钟':' sāng zhōng','连中':' lián zhòng','莨绸':' liáng chóu','纤长':' xiān cháng','偏将':' piān jiàng','商行':' shāng háng','商汤':' shāng tāng','唱片':' chàng piān','种田':' zhòng tián','哮喘':' xiào chuǎn','专差':' zhuān chāi','重现':' chóng xiàn','晃荡':' huàng dàng','长效':' cháng xiào','上将':' shàng jiàng','中枪':' zhòng qiāng','相像':' xiāng xiàng','相向':' xiāng xiàng','双杠':' shuāng gàng','相声':' xiàng sheng','长枪':' cháng qiāng','相框':' xiàng kuàng','上声':' shǎng shēng','中伤':' zhòng shāng','中将':' zhōng jiàng','踉蹡':' liàng qiāng','穿上':' chuān shang','长生':' cháng shēng','降将':' xiáng jiàng','长相':' zhǎng xiàng','丈量':' zhàng liáng','长长':' cháng cháng','晃晃':' huàng huǎng','黄裳':' huáng cháng','凶相':' xiōng xiàng','相长':' xiāng cháng','踉跄':' liàng qiàng','中奖':' zhòng jiǎng','强将':' qiáng jiàng','长征':' cháng zhēng','长城':' cháng chéng','铛铛':' chēng chēng','乡长':' xiāng cháng','泷水':' shuāng shuǐ','重重':' chóng chóng','钻床':' zuàn chuáng','量程':' liáng chéng','正传':' zhèng zhuàn','乘胜':' chéng shèng','正长':' zhèng cháng','跄踉':' qiàng liàng','挣揣':' zhèng chuài','种粮':' zhòng liáng','绷床':' bēng chuáng','丞相':' chéng xiàng','着装':' zhuó zhuāng','着床':' zhuó chuáng','政争':' zhèng zhēng','中长':' zhōng cháng','框框':' kuàng kuàng','长江':' cháng jiāng','相中':' xiāng zhòng','强抢':' qiáng qiǎng','长成':' cháng chéng','长帅':' cháng shuài','将将':' qiāng qiāng','强征':' qiǎng zhēng','窘相':' jiǒng xiàng','揣想':' chuǎi xiǎng','汤汤':' shāng shāng','上相':' shàng xiàng','亮相':' liàng xiàng','少壮':' shào zhuàng','重光':' chóng guāng','怔怔':' zhèng zhèng','将相':' jiàng xiàng','怔忪':' zhēng zhōng','创伤':' chuāng shāng','装相':' zhuāng xiàng','靓装':' liàng zhuāng','窗框':' chuāng kuàng','冲床':' chòng chuáng','双重':' shuāng chóng','闯将':' chuǎng jiàng','重创':' zhòng chuāng','鲁甸':' lǔ diàn','称量':' chēng liáng','镗床':' táng chuáng','跄跄':' qiàng qiàng','良将':' liáng jiàng','抢种':' qiǎng zhòng','掌相':' zhǎng xiàng','长程':' cháng chéng','更爽':' gēng shuǎng','长虫':' cháng chóng','长川':' cháng chuān','商量':' shāng liáng','倡狂':' chāng kuáng','两重':' liǎng chóng','将帅':' jiàng shuài','场长':' cháng zhǎng','创面':' chuāng miàn','创兴':' chuàng xīng','专长':' zhuān cháng','供状':' gòng zhuàng','相率':' xiāng shuài','重整':' chóng zhěng','创痛':' chuāng tòng','征传':' zhēng zhuàn','生相':' shēng xiàng','重唱':' chóng chàng','旋床':' xuàn chuáng','重逢':' chóng féng','晃动':' huàng dòng','串供':' chuàn gòng','中签':' zhòng qiān','较长':' jiào cháng','点种':' diǎn zhòng','转行':' zhuǎn háng','连长':' lián cháng','鼎铛':' dǐng chēng','中风':' zhòng fēng','短长':' duǎn cháng','彷徨':' páng huáng','中选':' zhòng xuǎn','端量':' duān liáng','强劲':' qiáng jìng','更张':' gēng zhāng','强横':' qiáng hèng','伸长':' shēn cháng','帐棚':' zhàng peng','扬场':' yáng cháng','扬长':' yáng cháng','中招':' zhòng zhāo','长钱':' cháng qián','边长':' biān cháng','更生':' gēng shēng','轻率':' qīng shuài','选中':' xuǎn zhòng','重庆':' chóng qìng','重编':' chóng biān','春种':' chūn zhòng','重访':' chóng fǎng','重评':' chóng píng','小传':' xiǎo zhuàn','重算':' chóng suàn','折床':' shé chuáng','重建':' chóng jiàn','重影':' chóng yǐng','少将':' shào jiàng','中兴':' zhōng xīng','更香':' gēng xiāng','工长':' gōng cháng','重映':' chóng yìng','巷弄':' xiàng lòng','赚哄':' zhuàn hǒng','转圈':' zhuàn quān','闲晃':' xián huàng','更正':' gēng zhèng','转动':' zhuàn dòng','辗转':' zhǎn zhuǎn','身长':' shēn cháng','中甸':' zhōng diàn','挣断':' zhèng duàn','行长':' háng zhǎng','着想':' zhuó xiǎng','重阳':' chóng yáng','应征':' yìng zhēng','重霄':' chóng xiāo','行商':' háng shāng','将官':' jiàng guān','将领':' jiàng lǐng','专横':' zhuān hèng','衡量':' héng liáng','光栅':' guāng shān','乘间':' chéng jiàn','揣情':' chuǎi qíng','表率':' biǎo shuài','量瓶':' liáng píng','星相':' xīng xiàng','量身':' liáng shēn','创痕':' chuāng hén','量表':' liáng biǎo','供称':' gòng chēng','量筒':' liáng tǒng','悬揣':' xuán chuǎi','手相':' shǒu xiàng','正朔':' zhēng shuò','还乡':' huán xiāng','凶横':' xiōng hèng','方框':' fāng kuàng','边框':' biān kuàng','还账':' huán zhàng','重茧':' chóng jiǎn','重趼':' chóng jiǎn','冲孔':' chòng kǒng','重山':' chóng shān','着重':' zhuó zhòng','兴昌':' xīng chāng','重瞳':' zhòng tóng','挣命':' zhèng mìng','黄钻':' huáng zuàn','重行':' chóng xíng','着凉':' zháo liáng','雄劲':' xióng jìng','着慌':' zháo huāng','成行':' chéng háng','重圆':' chóng yuán','镇长':' zhèn cháng','镜框':' jìng kuàng','重放':' chóng fàng','藏象':' zàng xiàng','长红':' cháng hóng','长平':' cháng píng','桩子':' zhuāng zǐ','爪蟾':' zhuǎ chán','射中':' shè zhòng','专著':' zhuān zhù','调焦':' tiáo jiāo','滚转':' gǔn zhuàn','过长':' guò cháng','行情':' háng qíng','应典':' yìng diǎn','交卷':' jiāo juàn','朝鲜':' cháo xiǎn','少康':' shào kāng','行当':' háng dāng','杓棒':' sháo bàng','炸两':' zhá liǎng','烧着':' shāo zháo','长队':' cháng duì','长靴':' cháng xuē','远兴':' yuǎn xīng','贫相':' pín xiàng','招供':' zhāo gòng','长矛':' cháng máo','中弹':' zhòng dàn','加上':' jiā shang','中彩':' zhòng cǎi','曹长':' cáo cháng','香干':' xiāng gān','长裙':' cháng qún','交还':' jiāo huán','沈朴':' shěn piáo','供桌':' gòng zhuō','沈明':' shěn míng','沈梦':' shěn mèng','长诗':' cháng shī','沈欢':' shěn huān','沈静':' shěn jìng','变更':' biàn gēng','将士':' jiàng shì','差遣':' chāi qiǎn','为生':' wéi shēng','长谈':' cháng tán','劲吹':' jìng chuī','沈健':' shěn jiàn','观塘':' guàn táng','财相':' cái xiàng','将牌':' jiàng pái','归降':' guī xiáng','少小':' shào xiǎo','光杆':' guāng gǎn','长白':' cháng bái','升斗':' shēng dǒu','工行':' gōng háng','调养':' tiáo yǎng','干重':' gān zhòng','调羹':' tiáo gēng','调准':' tiáo zhǔn','调档':' tiáo dàng','左传':' zuǒ zhuàn','劲风':' jìng fēng','调料':' tiáo liào','长至':' cháng zhì','调教':' tiáo jiào','生角':' shēng jué','调停':' tiáo tíng','调挡':' tiáo dǎng','烹调':' pēng tiáo','调情':' tiáo qíng','调弄':' tiáo nòng','工坊':' gōng fáng','佣钱':' yòng qián','曾巩':' zēng gǒng','劲挺':' jìng tǐng','调控':' tiáo kòng','长舌':' cháng shé','旋风':' xuàn fēng','长男':' cháng nán','扛鼎':' gāng dǐng','广乐':' guǎng yuè','朝阳':' zhāo yáng','广为':' guǎng wéi','行间':' háng jiān','光晕':' guāng yùn','冲劲':' chòng jìn','为重':' wéi zhòng','拓荒':' tuò huāng','撬杠':' qiào gàng','杠房':' gàng fáng','属相':' shǔ xiàng','杠杠':' gàng gàng','岭巆':' lǐng yíng','差商':' chā shāng','干城':' gān chéng','钻攻':' zuàn gōng','崆峒':' kōng tóng','会长':' huì cháng','馕嗓':' nǎng sǎng','钻工':' zuàn gōng','馕糠':' nǎng kāng','沈宏':' shěn hóng','撩乱':' liáo luàn','省方':' xǐng fāng','楞楞':' lèng lèng','相貌':' xiàng mào','框架':' kuàng jià','经卷':' jīng juàn','白镪':' bái qiǎng','邻长':' lín cháng','萎黄':' wěi huáng','了断':' liǎo duàn','倥偬':' kǒng zǒng','缥囊':' piǎo náng','坦率':' tǎn shuài','靓白':' liàng bái','相国':' xiàng guó','相士':' xiàng shì','纤手':' qiàn shǒu','百中':' bǎi zhòng','缥渺':' piǎo miǎo','挣脱':' zhèng tuō','夏种':' xià zhòng','相干':' xiāng gān','白相':' bái xiàng','蛣蜣':' jié qiāng','桁杨':' háng yáng','钌铞':' liào diào','挣扎':' zhēng zhá','种植':' zhòng zhí','穹肋':' qíong lèi','抓差':' zhuā chāi','拽文':' zhuài wén','哮鸣':' xiào míng','称钱':' chèn qián','咸兴':' xián xīng','称为':' chēng wéi','种花':' zhòng huā','种树':' zhòng shù','杠铃':' gàng líng','倥侗':' kōng tóng','了当':' liǎo dàng','粘缠':' nián chán','缝缀':' féng zhuì','接种':' jiē zhòng','缅甸':' miǎn diàn','两肋':' liǎng lèi','相纸':' xiàng zhǐ','栽种':' zāi zhòng','网杓':' wǎng sháo','相处':' xiāng chǔ','相架':' xiàng jià','下乘':' xià shèng','加长':' jiā cháng','沈航':' shěn háng','龙兴':' lóng xīng','隆兴':' lóng xīng','桑葚':' sāng shèn','插上':' chā shang','绍兴':' shào xīng','正旦':' zhēng dàn','干娘':' gān niáng','伙种':' huǒ zhòng','世相':' shì xiàng','深更':' shēn gēng','枞阳':' zōng yáng','应龙':' yìng lóng','沈荡':' shěn dàng','长跑':' cháng pǎo','供奉':' gòng fèng','沈红':' shěn hóng','长石':' cháng shí','供应':' gōng yìng','拙朴':' zhuō piáo','长逝':' cháng shì','舍长':' shè cháng','儱侗':' lǒng tǒng','雕琢':' diāo zhuó','杆秤':' gǎn chèng','精当':' jīng dàng','平巷':' píng hàng','换行':' huàn háng','揣度':' chuǎi duó','云裳':' yún cháng','看相':' kàn xiàng','诱降':' yòu xiáng','评卷':' píng juàn','三重':' sān chóng','漂漂':' piāo piāo','粘着':' nián zhuó','吵吵':' chāo chao','粘胶':' nián jiāo','主将':' zhǔ jiàng','掺水':' chān shuǐ','纯朴':' chún piáo','嚷嚷':' rāng rɑng','灵应':' líng yìng','败将':' bài jiàng','眄眄':' miàn miàn','绗缝':' háng féng','看中':' kàn zhòng','拱券':' gǒng xuàn','身着':' shēn zhuó','长寿':' cháng shòu','挑动':' tiǎo dòng','悍将':' hàn jiàng','行款':' háng kuǎn','着边':' zhuó biān','片名':' piān míng','账载':' zhàng zǎi','行帮':' háng bāng','长班':' cháng bān','年少':' nián shào','宽甸':' kuān diàn','上分':' shàng fèn','共工':' gòng gōng','脏病':' zāng bìng','阆苑':' làng yuàn','南长':' nán cháng','宰相':' zǎi xiàng','宫观':' gōng guàn','正月':' zhēng yuè','飞转':' fēi zhuàn','便便':' pián pián','便嬛':' pián xuān','走相':' zǒu xiàng','卷轴':' juàn zhóu','蟏蛸':' xiāo shāo','沈阳':' shěn yáng','正处':' zhèng chǔ','蒙山':' měng shān','唪经':' běng jīng','螵蛸':' piāo xiāo','原卷':' yuán juàn','赚头':' zhuàn tou','应身':' yìng shēn','炒更':' chǎo gēng','婵媛':' chán yuán','宁愿':' nìng yuàn','哄骗':' hǒng piàn','上切':' shàng qiē','实相':' shí xiàng','钐镰':' shàn lián','善卷':' shàn juàn','卷宗':' juàn zōng','蜀相':' shǔ xiàng','露相':' lòu xiàng','定兴':' dìng xīng','豁亮':' huò liàng','审校':' shěn jiào','封禅':' fēng shàn','兴行':' xīng xíng','长滨':' cháng bīn','定当':' dìng dàng','长编':' cháng biān','长眠':' cháng mián','饼铛':' bǐng chēng','抢风':' qiāng fēng','长圆':' cháng yuán','长汀':' cháng tīng','响应':' xiǎng yìng','昌兴':' chāng xīng','长行':' cháng xíng','长荣':' cháng róng','长垣':' cháng yuán','长缨':' cháng yīng','长清':' cháng qīng','抽中':' chōu zhòng','散装':' sǎn zhuāng','长斋':' cháng zhāi','黄漂':' huáng piāo','黄兴':' huáng xīng','应承':' yìng chéng','长篇':' cháng piān','长空':' cháng kōng','长漂':' cháng piāo','院长':' yuàn cháng','长片':' cháng piàn','和熊':' huó xióng','脏脏':' zāng zāng','茸茸':' róng róng','长烟':' cháng yān','门框':' mén kuàng','蚌山':' bèng shān','帑藏':' tǎng zàng','山岗':' shān gāng','挣开':' zhèng kāi','中暑':' zhòng shǔ','曾参':' zēng shēn','扇风':' shān fēng','长短':' cháng duǎn','应天':' yìng tiān','长治':' cháng zhì','效应':' xiào yìng','长线':' cháng xiàn','攘场':' rǎng cháng','长笑':' cháng xiào','长啸':' cháng xiào','长性':' cháng xìng','点将':' diǎn jiàng','擅长':' shàn cháng','脏水':' zāng shuǐ','话长':' huà cháng','长袍':' cháng páo','诈降':' zhà xiáng','沈园':' shěn yuán','诸将':' zhū jiàng','劲峭':' jìng qiào','肇兴':' zhào xīng','屏营':' bīng yíng','沈勇':' shěn yǒng','照片':' zhào piān','月相':' yuè xiàng','深省':' shēn xǐng','卖相':' mài xiàng','史乘':' shǐ shèng','调笑':' tiáo xiào','藏羚':' zàng líng','洋行':' yáng háng','闲空':' xián kòng','薯莨':' shǔ liáng','兴坏':' xīng huài','电钻':' diàn zuàn','三率':' sān shuài','便溺':' biàn niào','苍劲':' cāng jìng','试种':' shì zhòng','照应':' zhào yìng','长海':' cháng hǎi','供暖':' gòng nuǎn','拖长':' tuō cháng','长袖':' cháng xiù','更行':' gēng xíng','诸相':' zhū xiàng','更更':' gēng gēng','棽棽':' chēn chēn','少间':' shǎo jiàn','撩动':' liáo dòng','供款':' gòng kuǎn','少校':' shào xiào','应供':' yìng gòng','典当':' diǎn dàng','少年':' shào nián','识相':' shí xiàng','长处':' cháng chù','更定':' gēng dìng','更变':' gēng biàn','身著':' shēn zhuó','详尽':' xiáng jìn','沈周':' shěn zhōu','长号':' cháng hào','骄横':' jiāo hèng','盖上':' gài shang','干粮':' gān liáng','乾县':' qián xiàn','兴庆':' xīng qìng','划伤':' huá shāng','兴能':' xīng néng','嬛嬛':' xuān xuān','荫凉':' yìn liáng','间苗':' jiàn miáo','还钱':' huán qián','还童':' huán tóng','本相':' běn xiàng','三乘':' sān shèng','还阳':' huán yáng','保长':' bǎo cháng','拖拽':' tuō zhuài','应选':' yìng xuǎn','青藏':' qīng zàng','羊圈':' yáng juàn','惊醒':' jīng xǐng','间断':' jiàn duàn','占星':' zhān xīng','兴讼':' xīng sòng','猜中':' cāi zhòng','修长':' xiū cháng','剿说':' chāo shuō','荐椎':' jiàn zhuī','兴工':' xīng gōng','脏乱':' zāng luàn','骗供':' piàn gòng','蓬茸':' péng róng','率然':' shuài rán','哄弄':' hǒng nòng','官差':' guān chāi','干证':' gān zhèng','守更':' shǒu gēng','守丧':' shǒu sāng','飞将':' fēi jiàng','哄哄':' hǒng hǒng','哗众':' huá zhòng','晃着':' huàng zhe','黄晕':' huáng yùn','率直':' shuài zhí','蒜茸':' suàn róng','兴贤':' xīng xián','藏青':' zàng qīng','蒙茸':' méng róng','长泰':' cháng tài','狭长':' xiá cháng','萧乾':' xiāo qián','曾加':' zēng jiā','双子':' shuāng zǐ','作甚':' zuò shèn','便人':' pián rén','黉舍':' hóng shè','藤蔓':' téng wàn','宿将':' sù jiàng','归省':' guī xǐng','虎将':' hǔ jiàng','长河':' cháng hé','横事':' hèng shì','归还':' guī huán','未了':' wèi liǎo','长戟':' cháng jǐ','混行':' hún xíng','横蛮':' hèng mán','道藏':' dào zàng','道行':' dào héng','道观':' dào guàn','铜臭':' tóng xiù','官倒':' guān dǎo','兴修':' xīng xiū','僧舍':' sēng shè','干癣':' gān xuǎn','型芯':' xíng xìn','数念':' shǔ niàn','适应':' shì yìng','拼攒':' pīn cuán','雀子':' qiāo zǐ','卸载':' xiè zǎi','乐坛':' yuè tán','散尽':' sàn jìn','诮呵':' qiào hē','却倒':' què dǎo','攒簇':' cuán cù','外切':' wài qiē','干脆':' gān cuì','尽头':' jìn tóu','煞有':' shà yǒu','担懮':' dān yōu','漂浮':' piāo fú','为头':' wéi tóu','为着':' wéi zhe','石拓':' shí tuò','子痫':' zǐ xián','尽言':' jìn yán','椎体':' zhuī tǐ','曲工':' qǔ gōng','片子':' piān zi','为难':' wéi nán','部将':' bù jiàng','处境':' chǔ jìng','牛舍':' niú shè','挑唆':' tiǎo suō','兴运':' xīng yùn','藓苔':' xiǎn tāi','哄逗':' hǒng dòu','拧紧':' nǐng jǐn','本色':' běn shǎi','桑干':' sāng gān','沈括':' shěn kuò','倒仓':' dǎo cāng','行处':' xíng chǔ','散件':' sǎn jiàn','守分':' shǒu fèn','着处':' zhuó chù','娘子':' niáng zǐ','挑嘴':' tiǎo zuǐ','着落':' zhuó luò','散乱':' sǎn luàn','着花':' zhuó huā','关卡':' guān qiǎ','倒噍':' dǎo jiào','着眼':' zhuó yǎn','着然':' zhuó rán','初更':' chū gēng','宅舍':' zhái shè','室町':' shì tǐng','开卷':' kāi juàn','宏拓':' hóng tuò','干瘦':' gān shòu','煞星':' shà xīng','干净':' gān jìng','改行':' gǎi háng','特长':' tè cháng','未曾':' wèi zēng','应心':' yìng xīn','家当':' jiā dàng','兴筑':' xīng zhù','放假':' fàng jià','择菜':' zhái cài','闲散':' xián sǎn','宫阙':' gōng què','开钻':' kāi zuàn','牵累':' qiān lěi','拽步':' zhuài bù','供认':' gòng rèn','长揖':' cháng yī','处方':' chǔ fāng','霓裳':' ní cháng','为数':' wéi shù','泌阳':' bì yáng','长德':' cháng dé','焙干':' bèi gān','散架':' sǎn jià','浅子':' qiǎn zǐ','试帖':' shì tiě','当夜':' dàng yè','劲拔':' jìng bá','当机':' dàng jī','沈复':' shěn fù','偏得':' piān de','肆应':' sì yìng','非分':' fēi fèn','漂洗':' piǎo xǐ','班什':' bān shí','杀掠':' shā lüě','劲旅':' jìng lǚ','牛饮':' niú yìn','发型':' fà xíng','切切':' qiē qiē','漂泊':' piāo bó','干酪':' gān lào','让子':' ràng zǐ','宁子':' níng zǐ','园子':' yuán zǐ','尽饱':' jìn bǎo','球差':' qíu chā','铜子':' tóng zǐ','飘泊':' piāo bó','教课':' jiāo kè','没收':' mò shōu','歪货':' wǎi huò','子桑':' zǐ sāng','拗劲':' niù jìn','为什':' wèi shí','劲急':' jìng jí','款子':' kuǎn zǐ','签子':' qiān zǐ','一更':' yī gēng','盘倒':' pán dǎo','钻具':' zuàn jù','阘茸':' tà róng','衫子':' shān zǐ','嗒丧':' tà sàng','敢为':' gǎn wéi','扦子':' qiān zǐ','司钻':' sī zuàn','为是':' wéi shì','卷须':' juàn xū','危难':' wēi nàn','散文':' sǎn wén','子弦':' zǐ xián','叶韵':' xié yùn','劫难':' jié nàn','唯唯':' wěi wěi','沈河':' shěn hé','非得':' fēi děi','漂砾':' piāo lì','柞蚕':' zuò cán','瞳子':' tóng zǐ','散板':' sǎn bǎn','泄露':' xiè lòu','瓦隆':' wǎ lōng','难倒':' nán dǎo','高头':' gāo tou','可调':' kě tiáo','尽致':' jìn zhì','公仆':' gōng pú','篷子':' péng zǐ','芟荑':' shān yí','泊松':' bó sōng','魏巍':' wèi wēi','披卷':' pī juàn','悄寂':' qiǎo jì','厅子':' tīng zǐ','劲卒':' jìng zú','瓤子':' ráng zǐ','浅薄':' qiǎn bó','分外':' fèn wài','顺子':' shùn zǐ','分叉':' fēn chà','卵子':' luǎn zǐ','马蹬':' mǎ dèng','檃栝':' yǐn kuò','申曲':' shēn qǔ','子星':' zǐ xīng','劲敌':' jìng dí','浮漂':' fú piāo','切除':' qiē chú','调气':' tiáo qì','乐师':' yuè shī','阙下':' què xià','崴嵬':' wēi wéi','石作':' shí zuō','施为':' shī wéi','璧还':' bì huán','曲静':' qǔ jìng','时为':' shí wéi','叱吒':' chì zhà','着火':' zháo huǒ','甚且':' shèn qiě','分内':' fèn nèi','长句':' cháng jù','儒将':' rú jiàng','入相':' rù xiàng','兴家':' xīng jiā','等衰':' děng cuī','本行':' běn háng','武将':' wǔ jiàng','伎俩':' jì liǎng','深知':' shēn zhì','蒙难':' méng nàn','长局':' cháng jú','黄柏':' huáng bò','的证':' dí zhèng','索还':' suǒ huán','折缝':' zhé féng','间谍':' jiàn dié','蔓菁':' mán jīng','划水':' huá shuǐ','子长':' zǐ cháng','还嘴':' huán zuǐ','划行':' huá xíng','花朝':' huā zhāo','黄发':' huáng fà','微调':' wēi tiáo','随兴':' suí xīng','冷轧':' lěng zhá','侯刚':' hòu gāng','藏文':' zàng wén','三省':' sān xǐng','得中':' dé zhòng','间或':' jiàn huò','藏人':' zàng rén','犍为':' qián wéi','电镐':' diàn hào','间作':' jiàn zuò','混蒙':' hùn mēng','澄沙':' dèng shā','击中':' jī zhòng','混熟':' hùn shóu','拓边':' tuò biān','步长':' bù cháng','脏弹':' zāng dàn','还口':' huán kǒu','肮脏':' āng zāng','还给':' huán gěi','还珠':' huán zhū','还贷':' huán dài','软肋':' ruǎn lèi','蕉萃':' qiáo cuì','不揣':' bù chuǎi','一唱':' yí chàng','调训':' tiáo xùn','干冷':' gān lěng','干连':' gān lián','露丑':' lòu chǒu','弄混':' nòng hún','调摄':' tiáo shè','十行':' shí háng','一长':' yī cháng','诗行':' shī háng','干甚':' gàn shèn','转塔':' zhuàn tǎ','佣金':' yòng jīn','露面':' lòu miàn','转子':' zhuàn zǐ','调试':' tiáo shì','干柴':' gān chái','厂子':' chǎng zǐ','广安':' guǎng ān','劲射':' jìng shè','中子':' zhōng zǐ','长椅':' cháng yǐ','漂染':' piǎo rǎn','劲草':' jìng cǎo','还书':' huán shū','等为':' děng wéi','颠茄':' diān qié','还本':' huán běn','间歇':' jiàn xiē','还丹':' huán dān','奖掖':' jiǎng yè','划算':' huá suàn','还家':' huán jiā','蔡甸':' cài diàn','划拳':' huá quán','软和':' ruǎn huo','劲直':' jìng zhí','供花':' gòng huā','舍间':' shè jiān','供职':' gòng zhí','调解':' tiáo jiě','转去':' zhuàn qù','烘干':' hōng gān','作兴':' zuò xīng','调节':' tiáo jié','诗卷':' shī juàn','劲烈':' jìng liè','卜征':' bǔ zhēng','适当':' shì dàng','激将':' jī jiàng','系绳':' jì shéng','深信':' shēn xìn','甚微':' shèn wēi','着数':' zhāo shù','落炕':' lào kàng','原处':' yuán chǔ','妥当':' tuǒ dàng','沈约':' shěn yuē','落枕':' lào zhěn','用尽':' yòng jìn','只见':' zhī jiàn','卷帙':' juàn zhì','用处':' yòng chǔ','长丽':' cháng lì','田舍':' tián shè','公石':' gōng dàn','长利':' cháng lì','妄为':' wàng wéi','公斗':' gōng dǒu','菲酌':' fěi zhuó','刀削':' dāo xiāo','华龙':' huà lóng','边塞':' biān sài','长机':' cháng jī','太甚':' tài shèn','脏煤':' zāng méi','着紧':' zháo jǐn','正意':' zhēng yì','和弄':' huò nòng','豁朗':' huò lǎng','还魂':' huán hún','绘卷':' huì juàn','指缝':' zhǐ féng','王著':' wáng zhù','杏干':' xìng gān','边卡':' biān qiǎ','体长':' tǐ cháng','阅卷':' yuè juàn','净尽':' jìng jìn','火燎':' huǒ liǎo','脏话':' zāng huà','兴废':' xīng fèi','教书':' jiāo shū','昏蒙':' hūn mēng','浑朴':' hún piáo','卵泡':' luǎn pāo','同好':' tóng hào','级长':' jí cháng','倒嚼':' dǎo jiào','便难':' biàn nàn','干笑':' gān xiào','狼头':' láng tou','混浊':' hún zhuó','兴叹':' xīng tàn','塞翁':' sài wēng','只从':' zhī cóng','值当':' zhí dàng','季相':' jì xiàng','间接':' jiàn jiē','划艇':' huá tǐng','干等':' gān děng','地转':' dì zhuàn','攀供':' pān gòng','画供':' huà gòng','还价':' huán jià','信差':' xìn chāi','估量':' gū liang','弱冠':' ruò guàn','沈丘':' shěn qīu','画片':' huà piān','拓宽':' tuò kuān','间奏':' jiàn zòu','户长':' hù cháng','曲江':' qǔ jiāng','落色':' lào shǎi','始兴':' shǐ xīng','产假':' chǎn jià','甚或':' shèn huò','淋病':' lìn bìng','关塞':' guān sài','甚为':' shèn wéi','着恼':' zhuó nǎo','甚至':' shèn zhì','着实':' zhuó shí','倒找':' dǎo zhǎo','原著':' yuán zhù','著名':' zhù míng','黄子':' huáng zǐ','长理':' cháng lǐ','生子':' shēng zǐ','正安':' zhēng an','生发':' shēng fà','正子':' zhèng zǐ','散兵':' sǎn bīng','产仔':' chǎn zǎi','甜头':' tián tou','孱弱':' chán ruò','蒙文':' měng wén','蹄髈':' tí pǎng','盔头':' kuī tou','请帖':' qǐng tiě','切屑':' qiē xiè','流血':' liú xiě','凳子':' dèng zǐ','童仆':' tóng pú','无爪':' wú zhuǎ','切杆':' qiē gān','四通':' sì tòng','免得':' miǎn de','北碚':' běi bèi','算得':' suàn de','萎败':' wěi bài','父丧':' fù sāng','段子':' duàn zǐ','发丧':' fā sāng','燕国':' yān guó','稽首':' qǐ shǒu','鸿鹄':' hóng hú','颤栗':' zhàn lì','叨扰':' tāo rǎo','痛恶':' tòng wù','殉难':' xùn nàn','干杯':' gān bēi','漂儿':' piāo ér','调级':' tiáo jí','颈子':' jǐng zǐ','烟斗':' yān dǒu','看头':' kàn tou','婉娩':' wǎn wǎn','脏字':' zāng zì','天得':' tiān de','天都':' tiān dū','疹子':' zhěn zǐ','姘头':' pīn tou','切磋':' qiē cuō','青子':' qīng zǐ','为然':' wéi rán','无间':' wú jiàn','乐队':' yuè duì','切刀':' qiē dāo','面糊':' miàn hù','干透':' gān tòu','乐音':' yuè yīn','眯缝':' mī féng','马圈':' mǎ juàn','调护':' tiáo hù','馒头':' mán tou','切分':' qiē fēn','汪子':' wāng zǐ','狗血':' gǒu xiě','呵欠':' hē qiàn','三舍':' sān shè','卜宅':' bǔ zhái','犁靬':' lí jiān','舍亲':' shè qīn','舍人':' shè rén','显得':' xiǎn de','半分':' bàn fēn','鱼漂':' yú piāo','干号':' gān háo','天姥':' tiān mǔ','准的':' zhǔn dì','袷袢':' qiā pàn','散人':' sǎn rén','望子':' wàng zǐ','汇差':' huì chā','四行':' sì háng','混蛋':' hún dàn','寺观':' sì guàn','名曲':' míng qǔ','午觉':' wǔ jiào','模样':' mú yàng','白术':' bái zhú','恰切':' qià qiē','烫发':' tàng fà','蒜子':' suàn zǐ','乐感':' yuè gǎn','分为':' fēn wéi','露背':' lòu bèi','北斗':' běi dǒu','丝杠':' sī gàng','甚的':' shèn de','鸡枞':' jī zōng','切至':' qiē zhì','子真':' zǐ zhēn','三倒':' sān dǎo','列为':' liè wéi','乾德':' qián dé','混球':' hún qíu','天雨':' tiān yù','沈博':' shěn bó','干草':' gān cǎo','殆尽':' dài jìn','犂靬':' lí jiān','十干':' shí gān','舌苔':' shé tāi','燕麦':' yān mài','一定':' yí dìng','子平':' zǐ píng','面的':' miàn dí','刨齿':' bào chǐ','丽水':' lí shuǐ','仆从':' pú cóng','勘查':' kān zhā','爪子':' zhuǎ zǐ','梃子':' tǐng zǐ','瀑流':' bào liú','切开':' qiē kāi','吸着':' xī zhuó','调幅':' tiáo fú','首都':' shǒu dū','子埝':' zǐ niàn','乐池':' yuè chí','泥守':' nì shǒu','吴兴':' wú xīng','难为':' nán wéi','特调':' tè tiáo','子婴':' zǐ yīng','电锯':' diàn jū','撩拨':' liáo bō','渺子':' miǎo zǐ','沈毅':' shěn yì','神怡':' shēn yí','刨刀':' bào dāo','档子':' dàng zǐ','非难':' fēi nàn','脏土':' zāng tǔ','笋干':' sǔn gān','牛只':' níu zhī','没空':' méi kòng','神子':' shén zǐ','颓萎':' tuí wěi','特供':' tè gòng','切花':' qiē huā','听子':' tīng zǐ','煞是':' shà shì','毋宁':' wú nìng','干爹':' gān diē','满处':' mǎn chǔ','难弹':' nán tán','切碎':' qiē suì','欺哄':' qī hǒng','煞白':' shà bái','刷子':' shuā zǐ','发廊':' fà láng','教子':' jiào zǐ','左肋':' zuǒ lèi','所处':' suǒ chǔ','沈懿':' shěn yì','撇嘴':' piě zuǐ','骠骑':' piào qí','眼晕':' yǎn yùn','盘诘':' pán jié','脏污':' zāng wū','毒爪':' dú zhuǎ','沉没':' chén mò','发小':' fà xiǎo','勃兴':' bó xīng','铜模':' tóng mú','切糕':' qiē gāo','呼应':' hū yìng','干燥':' gān zào','片儿':' piān er','反诘':' fǎn jié','当铺':' dàng pù','干瘪':' gān biě','盘查':' pán zhā','馆子':' guǎn zǐ','肉干':' ròu gān','半载':' bàn zǎi','少艾':' shào ài','卓子':' zhuó zǐ','说得':' shuō de','杉篙':' shā gāo','直奔':' zhí bèn','母丧':' mǔ sāng','萎落':' wěi luò','看家':' kān jiā','干货':' gān huò','甚于':' shèn yú','沈玉':' shěn yù','元子':' yuán zǐ','电荷':' diàn hè','猵狙':' piàn jū','流干':' líu gān','馏分':' liú fèn','钻机':' zuàn jī','王子':' wáng zǐ','子乔':' zǐ qiáo','泡货':' pāo huò','篇子':' piān zǐ','澹台':' tán tái','晕高':' yùn gāo','无着':' wú zhuó','素朴':' sù piáo','沦为':' lún wéi','雅片':' yā piàn','眄睨':' miàn nì','萎顿':' wěi dùn','为止':' wéi zhǐ','海难':' hǎi nàn','离间':' lí jiàn','浪子':' làng zǐ','牟平':' mù píng','牙冠':' yá guàn','养子':' yǎng zǐ','犬子':' quǎn zǐ','风靡':' fēng mǐ','元曲':' yuán qǔ','为学':' wéi xué','露出':' lòu chū','为主':' wéi zhǔ','砚台':' yàn tāi','排叉':' pái chà','碇泊':' dìng bó','尽是':' jìn shì','瘫倒':' tān dǎo','树杈':' shù chà','散射':' sǎn shè','劈柴':' pǐ chái','咽炎':' yān yán','灾难':' zāi nàn','扑棱':' pū lēng','为人':' wéi rén','湾仔':' wān zǎi','漂移':' piāo yí','铜佛':' tóng fó','透切':' tòu qiē','散漫':' sǎn màn','帖文':' tiě wén','海蜇':' hǎi zhé','甚巨':' shèn jù','为文':' wéi wén','调息':' tiáo xī','原子':' yuán zǐ','帖学':' tiè xué','咧咧':' liē liē','石头':' shí tou','扑扇':' pū shān','为下':' wéi xià','为时':' wéi shí','槵子':' huàn zǐ','一样':' yí yàng','散沙':' sǎn shā','尽职':' jìn zhí','钻塔':' zuàn tǎ','苕溪':' tiáo xī','垸子':' yuàn zǐ','尽心':' jìn xīn','萎谢':' wěi xiè','点子':' diǎn zǐ','咽峡':' yān xiá','炮制':' páo zhì','山曲':' shān qǔ','露白':' lòu bái','松子':' sōng zǐ','排车':' pǎi chē','云为':' yún wéi','澎湖':' péng hú','牛仔':' niú zǎi','炮烙':' páo luò','干尸':' gān shī','略为':' lüè wéi','划切':' huá qiè','排难':' pái nàn','任丘':' rén qiū','咽头':' yān tóu','宋子':' sòng zǐ','露怯':' lòu qiè','冠词':' guàn cí','择刺':' zhái cì','配乐':' pèi yuè','碑帖':' bēi tiè','咽喉':' yān hóu','气钻':' qì zuàn','俶傥':' tì tǎng','冠子':' guàn zi','刊载':' kān zǎi','尽数':' jìn shù','鬈发':' quán fà','苫布':' shàn bù','洋脊':' yáng jǐ','散列':' sǎn liè','拥塞':' yōng sè','划过':' huá guò','济宁':' jǐ níng','剿袭':' chāo xí','冠以':' guàn yǐ','自供':' zì gòng','划痕':' huá hén','散匪':' sǎn fěi','牙行':' yá háng','腿杆':' tuǐ gǎn','留难':' liú nàn','隐潭':' yǐn tán','探杆':' tàn gǎn','甚么':' shèn me','洗马':' xiǎn mǎ','由头':' yóu tou','干菜':' gān cài','瘪三':' biē sān','干果':' gān guǒ','滑倒':' huá dǎo','神似':' shén sì','包干':' bāo gān','卜占':' bǔ zhān','难处':' nán chǔ','洪佛':' hóng fó','溶没':' róng mò','猜度':' cāi duó','佻薄':' tiāo bó','樵子':' qiáo zǐ','古朴':' gǔ piáo','梢子':' shāo zǐ','田子':' tián zǐ','发辫':' fà biàn','撇号':' piě hào','发脚':' fà jiǎo','一块':' yí kuài','禽舍':' qín shè','起更':' qǐ gēng','死当':' sǐ dàng','瘦子':' shòu zǐ','省悟':' xǐng wù','标的':' biāo dì','分散':' fēn sǎn','调达':' tiáo dá','盼头':' pàn tou','泰斗':' tài dǒu','口角':' kǒu jué','撩惹':' liáo rě','筒子':' tǒng zǐ','鱼卷':' yú juàn','子明':' zǐ míng','爪哇':' zhǎo wā','混和':' hùn huò','御苑':' yù yuàn','熨斗':' yùn dǒu','万石':' wàn dàn','若为':' ruò wéi','桶子':' tǒng zǐ','发卷':' fā juàn','朴雅':' piáo yǎ','图卷':' tú juàn','泥泞':' ní nìng','挼搓':' ruó cuō','子囊':' zǐ náng','占卜':' zhān bǔ','发钗':' fà chāi','切口':' qiē kǒu','番茄':' fān qié','俞穴':' shù xué','收得':' shōu de','潜没':' qián mò','擂台':' lèi tái','毡子':' zhān zǐ','电子':' diàn zǐ','油炸':' yóu zhá','甚而':' shèn ér','公子':' gōng zǐ','藤子':' téng zǐ','唼喋':' shà zhá','民乐':' mín yuè','漏斗':' lòu dǒu','判处':' pàn chǔ','改为':' gǎi wéi','横死':' hèng sǐ','甚钜':' shèn jù','音乐':' yīn yuè','调序':' tiáo xù','沤凼':' òu dàng','食菌':' shí jùn','曲蟮':' qǔ shàn','攘辟':' rǎng bì','子陵':' zǐ líng','唐子':' táng zǐ','子棉':' zǐ mián','鮟鱇':' ān kāng','少子':' shǎo zǐ','鹿茸':' lù róng','调测':' tiáo cè','沈墨':' shěn mò','爪儿':' zhuǎ ér','鹿角':' lù jiǎo','玉琢':' yù zhuó','似曾':' sì céng','堂子':' táng zǐ','切韵':' qiē yùn','为害':' wéi hài','塞北':' sài běi','干贝':' gān bèi','切人':' qiē rén','吁请':' yù qǐng','原曲':' yuán qǔ','桐子':' tóng zǐ','死劲':' sǐ jìng','尽皆':' jìn jiē','炸糕':' zhá gāo','食甚':' shí shèn','刹时':' chà shí','请假':' qǐng jià','有间':' yǒu jiàn','乾嘉':' qián jiā','千石':' qiān dàn','撒种':' sǎ zhǒng','技俩':' jì liǎng','雹霰':' báo xiàn','攒射':' cuán shè','抱朴':' bào piáo','阔少':' kuò shào','排行':' pái háng','栓塞':' shuān sè','报丧':' bào sāng','来还':' lái huán','校勘':' jiào kān','敌将':' dí jiàng','降魔':' xiáng mó','横折':' héng shé','相马':' xiàng mǎ','老少':' lǎo shào','横切':' héng qiē','爱将':' ài jiàng','千载':' qiān zǎi','时兴':' shí xīng','重荷':' zhòng hè','校对':' jiào duì','感应':' gǎn yìng','橡子':' xiàng zǐ','翻供':' fān gòng','橙子':' chéng zǐ','什邡':' shí fāng','干潮':' gān cháo','王舍':' wáng shè','捞着':' lāo zháo','桦甸':' huà diàn','报应':' bào yìng','乐工':' yuè gōng','倒腾':' dǎo téng','相和':' xiāng hè','翘盼':' qiáo pàn','相得':' xiāng de','翘楚':' qiáo chǔ','翘材':' qiáo cái','找头':' zhǎo tou','重组':' chóng zǔ','校舍':' xiào shè','重聚':' chóng jù','吊斗':' diào dǒu','相里':' xiàng lǐ','稖头':' bàng tou','绷带':' bēng dài','乾道':' qián dào','长嘶':' cháng sī','分当':' fèn dāng','名帖':' míng tiě','坤甸':' kūn diàn','吹擂':' chuī lèi','执着':' zhí zhuó','累卵':' léi luǎn','重复':' chóng fù','累年':' lěi nián','慌得':' huāng de','应卯':' yìng mǎo','参宿':' shēn xìu','重覆':' chóng fù','埋怨':' mán yuàn','分行':' fēn háng','肋条':' lèi tiáo','校阅':' jiào yuè','名为':' míng wéi','校验':' jiào yàn','名著':' míng zhù','天阙':' tiān què','瞎蒙':' xiā mēng','在行':' zài háng','攒眉':' cuán méi','霰弹':' xiàn dàn','施甸':' shī diàn','相似':' xiāng sì','乐段':' yuè duàn','重译':' chóng yì','名角':' míng jué','相图':' xiàng tú','里长':' lǐ cháng','乞降':' qǐ xiáng','罐头':' guàn tou','罄尽':' qìng jìn','绷紧':' bēng jǐn','长崎':' cháng qí','串子':' chuàn zǐ','挣得':' zhèng dé','相册':' xiàng cè','应分':' yīng fèn','应制':' yìng zhì','系上':' jì shang','绕腾':' rào teng','鞅牛':' yǎng níu','竹杠':' zhú gàng','有甚':' yǒu shèn','乱弹':' luàn tán','添头':' tiān tou','缘分':' yuán fèn','量具':' liáng jù','缝絍':' féng rèn','缝纫':' féng rèn','量子':' liàng zǐ','应对':' yìng duì','两都':' liǎng dū','泰兴':' tài xīng','编著':' biān zhù','处身':' chǔ shēn','因应':' yīn yìng','缝制':' féng zhì','线杆':' xiàn gǎn','紧绷':' jǐn bēng','应市':' yìng shì','春假':' chūn jià','梁子':' liáng zǐ','两得':' liǎng de','相扑':' xiàng pū','星宿':' xīng xiù','长图':' cháng tú','累坠':' léi zhuì','应报':' yìng bào','接应':' jiē yìng','桔梗':' jié gěng','了解':' liǎo jiě','框子':' kuàng zi','应接':' yìng jiē','应时':' yìng shí','调处':' tiáo chǔ','量测':' liáng cè','长安':' cháng ān','量计':' liáng jì','省察':' xǐng chá','愁煞':' chóu shà','上去':' shǎng qù','相机':' xiàng jī','猪圈':' zhū juàn','嚼舌':' jiáo shé','省得':' shěng de','星斗':' xīng dǒu','量度':' liáng dù','量器':' liáng qì','连杆':' lián gǎn','总得':' zǒng děi','处斩':' chǔ zhǎn','处刑':' chǔ xíng','为名':' wéi míng','应邀':' yìng yāo','看守':' kān shǒu','龙仔':' lóng zǎi','省亲':' xǐng qīn','作践':' zuó jiàn','抽干':' chōu gān','眄睐':' miàn lài','六行':' liù háng','应考':' yìng kǎo','应聘':' yìng pìn','上个':' shàng ge','案称':' àn chèng','遛鸟':' liù niǎo','吓声':' hè shēng','子城':' zǐ chéng','磟碡':' liù zhóu','细长':' xì cháng','应试':' yìng shì','吹干':' chuī gān','冲子':' chòng zi','应诺':' yìng nuò','龙湫':' lóng qiū','拧开':' nǐng kāi','钓杆':' diào gǎn','省视':' xǐng shì','应运':' yìng yùn','路长':' lù cháng','周处':' zhōu chǔ','为命':' wéi mìng','萎蔫':' wěi niān','应门':' yìng mén','纳降':' nà xiáng','应验':' yìng yàn','字长':' zì cháng','撂倒':' liào dǎo','干煸':' gān biān','为情':' wéi qíng','换帖':' huàn tiě','累赘':' léi zhuì','红晕':' hóng yùn','晕圈':' yùn quān','铅山':' yán shān','嘲哳':' zhāo zhā','银行':' yín háng','哗变':' huá biàn','哗笑':' huá xiào','糨糊':' jiàng hù','评弹':' píng tán','挑担':' tiāo dàn','锤头':' chuí tou','凭藉':' píng jiè','框图':' kuàng tú','乐清':' yuè qīng','背债':' bēi zhài','房舍':' fáng shè','粗率':' cū shuài','了然':' liǎo rán','扁担':' biǎn dàn','长女':' cháng nǚ','搋子':' chuāi zǐ','笼络':' lǒng luò','泡桐':' pāo tóng','揣测':' chuǎi cè','单杠':' dān gàng','曾云':' zēng yún','糨子':' jiàng zǐ','了结':' liǎo jié','作弄':' zuō nòng','掠阵':' lüě zhèn','扣应':' kòu yìng','著实':' zhuó shí','纶巾':' guān jīn','长子':' zhǎng zǐ','梗咽':' gěng yān','光子':' guāng zǐ','掺假':' chān jiǎ','铣铁':' xiǎn tiě','降服':' xiáng fú','槐荫':' huái yìn','内省':' nèi xǐng','车削':' chē xiāo','内应':' nèi yìng','调治':' tiáo zhì','打量':' dǎ liang','枪子':' qiāng zǐ','假条':' jià tiáo','散养':' sǎn yǎng','乐经':' yuè jīng','引吭':' yǐn háng','粘滞':' nián zhì','篇什':' piān shí','粘滑':' nián huá','中牟':' zhōng mù','困觉':' kùn jiào','漫卷':' màn juàn','铺张':' pū zhāng','为善':' wéi shàn','呛咕':' qiāng gu','偏差':' piān chā','成都':' chéng dū','泡面':' pāo miàn','禾场':' hé cháng','镐京':' hào jīng','顶杆':' dǐng gǎn','乐团':' yuè tuán','和面':' huó miàn','竺乾':' zhú qián','唤头':' huàn tou','铁杠':' tiě gàng','长吁':' cháng xū','兆头':' zhào tou','黾勉':' mǐn miǎn','劈成':' pǐ chéng','丧假':' sāng jià','安广':' ān guǎng','手弹':' shǒu tán','蒙事':' mēng shì','长须':' cháng xū','三藏':' sān zàng','顺差':' shùn chā','更漏':' gēng lòu','瞒哄':' mán hǒng','了却':' liǎo què','了事':' liǎo shì','筊杯':' jiǎo bēi','裨将':' pí jiàng','销假':' xiāo jià','揣摩':' chuǎi mó','粘菌':' nián jūn','麻将':' má jiàng','冲模':' chòng mú','掷色':' zhì shǎi','粘结':' nián jié','波长':' bō cháng','雅相':' yǎ xiàng','易传':' yì zhuàn','黄埔':' huáng pǔ','嘉兴':' jiā xīng','调琴':' tiáo qín','章子':' zhāng zǐ','瞓觉':' xùn jiào','三通':' sān tòng','录相':' lù xiàng','知了':' zhī liǎo','降伏':' xiáng fú','丧事':' sāng shì','准头':' zhǔn tou','喧哗':' xuān huá','三更':' sān gēng','哨卡':' shào qiǎ','出丧':' chū sāng','罗甸':' luó diàn','榠楂':' míng chá','南甸':' nán diàn','长衣':' cháng yī','杠头':' gàng tóu','摒除':' bìng chú','商贾':' shāng gǔ','立传':' lì zhuàn','传记':' zhuàn jì','陡削':' dǒu xiāo','长夜':' cháng yè','充塞':' chōng sè','钻卡':' zuàn qiǎ','抨弹':' pēng tán','棚舍':' péng shè','呈子':' chéng zǐ','蛏子':' chēng zǐ','散见':' sǎn jiàn','昌都':' chāng dū','椽子':' chuán zǐ','干俸':' gān fèng','啜饮':' chuò yǐn','只身':' zhī shēn','钻戒':' zuàn jiè','称多':' chèn duō','楞严':' lèng yán','空白':' kòng bái','吹弹':' chuī tán','乾造':' qián zào','成佛':' chéng fó','看管':' kān guǎn','倾尽':' qīng jìn','羽裳':' yǔ cháng','唱喏':' chàng rě','唱和':' chàng hè','空缺':' kòng quē','空暇':' kòng xiá','称心':' chèn xīn','阳萎':' yáng wěi','咳呛':' ké qiàng','木强':' mù jiàng','唱曲':' chàng qǔ','为性':' wéi xìng','空匮':' kòng kuì','调休':' tiáo xiū','榔头':' láng tou','称职':' chèn zhí','打中':' dǎ zhòng','窨井':' yìn jǐng','问卷':' wèn juàn','碌碡':' liù zhou','僬侥':' jiāo yáo','长足':' cháng zú','随行':' suí háng','文卷':' wén juàn','哄瞒':' hǒng mán','牛鞅':' niú yàng','破相':' pò xiàng','能为':' néng wéi','冲压':' chòng yā','榜笞':' bàng chī','难侨':' nàn qiáo','牛圈':' niú juàn','打场':' dǎ cháng','页框':' yè kuàng','摔打':' shuāi dá','沙参':' shā shēn','允当':' yǔn dàng','钻石':' zuàn shí','为真':' wéi zhēn','钻头':' zuàn tóu','禅位':' shàn wèi','尾椎':' wěi zhuī','潮差':' cháo chā','杠杆':' gàng gǎn','为限':' wéi xiàn','禁用':' jīn yòng','倾倒':' qīng dǎo','空难':' kōng nàn','商都':' shāng dū','治丧':' zhì sāng','搀和':' chān huo','种地':' zhòng dì','程子':' chéng zǐ','女将':' nǚ jiàng','碎钻':' suì zuàn','福相':' fú xiàng','禁受':' jīn shòu','出差':' chū chāi','龈病':' yín bìng','弄口':' lòng kǒu','撤差':' chè chāi','杠刀':' gàng dāo','碰倒':' pèng dǎo','搂钱':' lōu qián','人参':' rén shēn','朝来':' zhāo lái','齿更':' chǐ gēng','朝晖':' zhāo huī','颀长':' qí cháng','美差':' měi chāi','为患':' wéi huàn','冗散':' rǒng sǎn','长武':' cháng wǔ','税卡':' shuì qiǎ','雁行':' yàn háng','作坊':' zuō fang','露馅':' lòu xiàn','为准':' wéi zhǔn','削球':' xiāo qiú','载明':' zǎi míng','载湉':' zǎi tián','苍术':' cāng zhú','偷空':' tōu kòng','财会':' cái kuài','作料':' zuó liào','长乐':' cháng lè','长笛':' cháng dí','拓展':' tuò zhǎn','中脊':' zhōng jǐ','变为':' biàn wéi','更番':' gēng fān','漂白':' piǎo bái','漂流':' piāo liú','钻穴':' zuàn xué','差派':' chāi pài','斗篷':' dǒu péng','长波':' cháng bō','年载':' nián zǎi','风头':' fēng tou','支行':' zhī háng','刷白':' shuà bái','年假':' nián jià','副相':' fù xiàng','跟差':' gēn chāi','潦倒':' liáo dǎo','中毒':' zhòng dú','斜杠':' xié gàng','掺和':' chān huo','潦草':' liáo cǎo','废卷':' fèi juàn','数算':' shǔ suàn','溃脓':' huì nóng','数说':' shǔ shuō','澎湃':' péng pài','跂想':' qǐ xiǎng','身分':' shēn fèn','身为':' shēn wéi','身处':' shēn chǔ','佛像':' fó xiàng','议长':' yì cháng','舒卷':' shū juàn','连累':' lián lěi','更迭':' gēng dié','漂游':' piāo yóu','善处':' shàn chǔ','转速':' zhuàn sù','应化':' yìng huà','氹仔':' dàng zǎi','将棋':' jiàng qí','行话':' háng huà','冻干':' dòng gān','行号':' háng háo','掩卷':' yǎn juàn','将伯':' qiāng bó','稍为':' shāo wéi','滚杠':' gǔn gàng','连载':' lián zǎi','长骨':' cháng gǔ','幛子':' zhàng zǐ','行市':' háng shì','行家':' háng jiā','宝藏':' bǎo zàng','刨冰':' bào bīng','钻饰':' zuàn shì','前咽':' qián yān','豁免':' huò miǎn','抽斗':' chōu dǒu','质朴':' zhì piáo','较著':' jiào zhù','佛光':' fó guāng','收载':' shōu zǎi','查边':' zhā biān','炳著':' bǐng zhù','收假':' shōu jià','中意':' zhòng yì','水分':' shuǐ fèn','漂雷':' piāo léi','较为':' jiào wéi','前燕':' qián yān','岑参':' cén shēn','加冠':' jiā guàn','比量':' bǐ liáng','饼干':' bǐng gān','拉长':' lā cháng','养分':' yǎng fèn','曾孙':' zēng sūn','长策':' cháng cè','钻台':' zuàn tái','放倒':' fàng dǎo','炮炼':' páo liàn','少奶':' shào nǎi','生得':' shēng de','馕糟':' nǎng zāo','山查':' shān zhā','高挑':' gāo tiǎo','煞神':' shà shén','更改':' gēng gǎi','巡更':' xún gēng','长葛':' cháng gě','壳牌':' qiào pái','屏除':' bǐng chú','高着':' gāo zhāo','高更':' gāo gēng','屏退':' bǐng tuì','张掖':' zhāng yè','新款':' xīn kuǎn','满拧':' mǎn nǐng','该应':' gāi yìng','动弹':' dòng tan','抬杠':' tái gàng','转距':' zhuàn jù','长辞':' cháng cí','胜子':' shèng zǐ','弧长':' hú cháng','撩逗':' liáo dòu','刺中':' cì zhòng','差使':' chāi shǐ','调驯':' tiáo xùn','是甚':' shì shèn','调谐':' tiáo xié','为首':' wéi shǒu','竹行':' zhú háng','抹胸':' mò xiōng','调音':' tiáo yīn','调酒':' tiáo jǐu','露风':' lòu fēng','差事':' chāi shì','乘舆':' shèng yú','调适':' tiáo shì','该着':' gāi zháo','更楼':' gēng lóu','园舍':' yuán shè','调谑':' tiáo xuè','调频':' tiáo pín','更为':' gèng wéi','感兴':' gǎn xīng','调嘴':' tiáo zuǐ','朝云':' zhāo yún','调唆':' tiáo suō','调味':' tiáo wèi','轧钢':' zhá gāng','剥啄':' bāo zhuó','支应':' zhī yìng','漫应':' màn yìng','差人':' chāi rén','剪切':' jiǎn qiē','书卷':' shū juàn','长牙':' cháng yá','赎当':' shú dàng','率意':' shuài yì','洋镐':' yáng hào','风斗':' fēng dǒu','查照':' zhā zhào','查检':' zhā jiǎn','长物':' cháng wù','风镐':' fēng hào','丰镐':' fēng hào','栓子':' shuān zǐ','查岗':' zhā gǎng','更阑':' gēng lán','支差':' zhī chāi','抽查':' chōu zhā','前头':' qián tou','料斗':' liào dǒu','钻修':' zuàn xiū','调协':' tiáo xié','漂摇':' piāo yáo','调匀':' tiáo yún','调制':' tiáo zhì','调价':' tiáo jià','调侃':' tiáo kǎn','转椅':' zhuàn yǐ','敦朴':' dūn piáo','更新':' gēng xīn','崩倒':' bēng dǎo','引着':' yǐn zháo','转炉':' zhuàn lú','转矩':' zhuàn jǔ','朝霞':' zhāo xiá','斗筲':' dǒu shāo','圜丘':' yuán qiū','弦乐':' xián yuè','煎炸':' jiān zhá','转磨':' zhuàn mò','烟卷':' yān juàn','撩开':' liáo kāi','谁知':' shéi zhī','甚者':' shèn zhě','应给':' yìng gěi','行列':' háng liè','粉坊':' fěn fáng','弹跳':' tán tiào','尿样':' suī yàng','访查':' fǎng zhā','更老':' gēng lǎo','胜似':' shèng sì','强子':' qiáng zǐ','勤朴':' qín piáo','轘裂':' huàn liè','匀称':' yún chèn','记传':' jì zhuàn','勾当':' gòu dàng','中举':' zhòng jǔ','转鼓':' zhuàn gǔ','裁缝':' cái féng','斗柄':' dǒu bǐng','有朝':' yǒu zhāo','折受':' shé shòu','供品':' gòng pǐn','北漂':' běi piāo','要功':' yāo gōng','显著':' xiǎn zhù','退税':' tuì shuì','残卷':' cán juàn','羹匙':' gēng chí','新兴':' xīn xīng','长途':' cháng tú','折腾':' zhē téng','辩难':' biàn nàn','神煞':' shén shà','农舍':' nóng shè','攻难':' gōng nàn','解元':' jiè yuán','撩人':' liáo rén','供事':' gòng shì','更始':' gēng shǐ','少尉':' shào wèi','强迫':' qiǎng pò','沈心':' shěn xīn','中计':' zhòng jì','庚帖':' gēng tiě','沈云':' shěn yún','试卷':' shì juàn','说什':' shuō shí','靓女':' liàng nǚ','督率':' dū shuài','雪糁':' xuě shēn','评为':' píng wéi','强似':' qiáng sì','褪色':' tuì shǎi','固相':' gù xiàng','并处':' bìng chǔ','香几':' xiāng jī','神乐':' shén yuè','燕京':' yān jīng','句芒':' gōu máng','沈洁':' shěn jié','折行':' shé xíng','够着':' gòu zháo','甚佳':' shèn jiā','显豁':' xiǎn huò','折减':' shé jiǎn','长斧':' cháng fǔ','折干':' shé qián','殷红':' yān hóng','长于':' cháng yú','沈俊':' shěn jùn','华山':' huà shān','争得':' zhēng de','切点':' qiē diǎn','回佣':' huí yòng','丹参':' dān shēn','回还':' huí huán','回应':' huí yìng','返还':' fǎn huán','有空':' yǒu kòng','悬瀑':' xuán bào','长野':' cháng yě','燕山':' yān shān','退色':' tuì shǎi','斗方':' dǒu fāng','数点':' shǔ diǎn','退还':' tuì huán','拙著':' zhuō zhù','长达':' cháng dá','燕赵':' yān zhào','共处':' gòng chǔ','世行':' shì háng','沈敏':' shěn mǐn','补种':' bǔ zhòng','更代':' gēng dài','钻杆':' zuàn gǎn','追查':' zhuī zhā','沈涵':' shěn hán','长裤':' cháng kù','强逼':' qiǎng bī','长法':' cháng fǎ','长袜':' cháng wà','亲家':' qìng jia','供果':' gòng guǒ','斗拱':' dǒu gǒng','解调':' jiě tiáo','豪横':' háo hèng','行头':' xíng tou','行辈':' háng bèi','桄子':' guàng zǐ','礃子':' zhǎng zǐ','长歌':' cháng gē','宝兴':' bǎo xīng','好还':' hǎo huán','游说':' yóu shuì','应是':' yìng shì','号叫':' háo jiào','汤匙':' tāng chí','宁肯':' nìng kěn','嚎丧':' háo sāng','蝃蝥':' zhuō máo','清查':' qīng zhā','蜚蠊':' fěi lián','木框':' mù kuàng','片头':' piān tóu','寒伧':' hán chen','蜕壳':' tuì qiào','好闲':' hào xián','掌子':' zhǎng zǐ','数清':' shǔ qīng','杖子':' zhàng zǐ','对称':' duì chèn','国丧':' guó sāng','过甚':' guò shèn','行为':' xíng wéi','血钻':' xuè zuàn','长发':' cháng fà','通什':' tōng shí','中魔':' zhòng mó','折钱':' shé qián','冠带':' guàn dài','对应':' duì yìng','露脸':' lòu liǎn','弹性':' tán xìng','冠绝':' guàn jué','露苗':' lòu miáo','馆舍':' guǎn shè','这些':' zhèi xiē','管乐':' guǎn yuè','行货':' háng huò','朝珠':' cháo zhū','染坊':' rǎn fáng','舍监':' shè jiān','雕刀':' diāo dāo','钻凿':' zuàn záo','拳头':' quán tou','风干':' fēng gān','行会':' háng huì','长股':' cháng gǔ','审查':' shěn zhā','卒中':' cù zhòng','卓著':' zhuó zhù','凋萎':' diāo wěi','獐子':' zhāng zǐ','昭著':' zhāo zhù','刮削':' guā xiāo','袅娜':' niǎo nuó','讨还':' tǎo huán','冠军':' guàn jūn','甚是':' shèn shì','应会':' yìng huì','工尺':' gōng chě','计量':' jì liáng','供饭':' gòng fàn','煮熟':' zhǔ shóu','强拉':' qiǎng lā','长期':' cháng qī','供稿':' gòng gǎo','来朝':' lái zhāo','审处':' shěn chǔ','行规':' háng guī','行道':' háng dào','测量':' cè liáng','号丧':' háo sāng','正脊':' zhèng jǐ','拶刑':' zǎn xíng','刁斗':' diāo dǒu','宝应':' bǎo yìng','协调':' xié tiáo','审度':' shěn duó','圩场':' xū cháng','闭上':' bì shang','蛮横':' mán hèng','苫盖':' shàn gài','上齐':' shàng jì','寒颤':' hán zhàn','江都':' jiāng dū','靓丽':' liàng lì','涡阳':' guō yáng','巷道':' hàng dào','障子':' zhàng zǐ','螲蟷':' dié dāng','长鼓':' cháng gǔ','糷':' làn','糹':' sī','糶':' tiào','糵':' niè','糴':' dí','糳':' zuò','糲':' lì','糺':' jiū','糸':' mì','糫':' huán','糱':' niè','糰':' tuán','糯':' nuò','糮':' xiàn','糭':' zòng','糬':' shu','糨':' jiàng','糪':' bò','糩':' kuài','糼':' gōng','糧':' liáng','系':' xì','紑':' fóu','糽':' zhěng','紋':' wén','糥':' nuò','純':' chún','紓':' shū','紒':' jì','紕':' pī','紐':' niǔ','紏':' tǒu','紎':' zī','納':' nà','紌':' qiú','紊':' wěn','糾':' jiū','紉':' rèn','紈':' wán','紇':' hé','紆':' yū','紅':' hóng','約':' yuē','紃':' xún','紂':' zhòu','紁':' chà','紀':' jì','糿':' yòu','糦':' xī','粹':' cuì','糤':' sǎn','粿':' guǒ','糈':' xǔ','糇':' hóu','糆':' miàn','糅':' róu','糄':' biǎn','糃':' táng','粳':' jīng','糂':' sǎn','糁':' sǎn','糀':' hua','精':' jīng','糊':' hú','粽':' zòng','粼':' lín','粻':' zhāng','粺':' bài','粴':' lǐ','粸':' qí','粷':' jú','粶':' lù','粵':' yuè','紗':' shā','糉':' zòng','糋':' jiàn','糣':' sǎn','糘':' jia','糢':' mó','糡':' jiàng','糠':' kāng','糟':' zāo','糞':' fèn','糝':' sǎn','糜':' mí','糛':' táng','糚':' zhuāng','糙':' cāo','糗':' qiǔ','糌':' zān','糖':' táng','糕':' gāo','糔':' xiǔ','糓':' gǔ','糒':' bèi','糑':' nuò','糐':' fū','糏':' xiè','糎':' lí','糍':' cí','紖':' zhèn','絶':' jué','紘':' hóng','絙':' huán','絣':' bēng','絢':' xuàn','絡':' luò','絠':' gǎi','絟':' quán','絞':' jiǎo','絝':' kù','絜':' jié','絛':' tāo','絚':' gēng','絘':' cì','絥':' fú','絗':' hú','絖':' kuàng','絕':' jué','絔':' bǎi','絓':' guà','絒':' chóu','絑':' zhū','結':' jié','絏':' xiè','絎':' háng','絤':' xiàn','給':' gěi','経':' jīng','絳':' jiàng','絼':' zhěn','粱':' liáng','絻':' miǎn','絽':' lǚ','絺':' chī','絹':' juàn','絸':' jiǎn','絷':' zhí','絵':' huì','絴':' xiáng','絲':' sī','絧':' dòng','統':' tǒng','絰':' dié','絯':' gāi','絮':' xù','絭':' juàn','絬':' xiè','絫':' lěi','絪':' yīn','絩':' tiào','絨':' róng','絍':' rèn','絋':' kuang','紙':' zhǐ','紥':' zā','累':' lèi','紮':' zā','紭':' hóng','紬':' chóu','紫':' zǐ','紪':' cǐ','紩':' zhì','紨':' fū','紧':' jǐn','紦':' ba','紤':' jiǔ','紱':' fú','紣':' cuì','索':' suǒ','紡':' fǎng','素':' sù','紟':' jīn','紞':' dǎn','紝':' rèn','紜':' yún','紛':' fēn','級':' jí','細':' xì','紲':' xiè','絊':' zuì','紿':' dài','絉':' shù','絈':' mò','絇':' qú','絆':' bàn','絅':' jiōng','組':' zǔ','絃':' xián','終':' zhōng','絁':' shī','絀':' chù','紾':' zhěn','紳':' shēn','紽':' tuó','紼':' fú','紻':' yǎng','紺':' gàn','紹':' shào','紸':' zhù','紷':' líng','紶':' qū','紵':' zhù','紴':' bō','粲':' càn','篭':' lóng','粰':' fú','簢':' mǐn','簬':' lù','簫':' xiāo','簪':' zān','簩':' láo','簨':' sǔn','簧':' huáng','簦':' dēng','簥':' jiāo','簤':' dài','簣':' kuì','簡':' jiǎn','簮':' zān','簠':' fǔ','簟':' diàn','簞':' dān','簝':' liáo','簜':' dàng','簛':' shāi','簚':' mì','簙':' bó','簘':' xiāo','簗':' liang','簭':' shì','簯':' qi','簕':' lè','簼':' lóng','籆':' yuè','籅':' yú','籄':' kuì','籃':' lán','籂':' shi','籁':' lài','籀':' zhòu','簿':' bù','簾':' lián','簽':' qiān','簻':' zhuā','簰':' pái','簺':' sài','簹':' dāng','簸':' bǒ','簷':' yán','簶':' lù','簵':' dù','簴':' jù','簳':' gǎn','簲':' pái','簱':' qi','簖':' duàn','簔':' suō','籈':' zhēn','篮':' lán','篸':' cǎn','篷':' péng','篶':' yān','篵':' cōng','篴':' dí','篳':' bì','篲':' huì','篱':' lí','篰':' bù','篯':' jiān','篬':' qiāng','篺':' pí','篫':' zhù','篪':' chí','篩':' shāi','篨':' chú','篧':' zhuó','篦':' bì','篥':' lì','篣':' péng','絿':' qiú','篤':' dǔ','篹':' zhuàn','篻':' piǎo','簓':' diao','簈':' píng','簒':' cuàn','簑':' suō','簐':' niǎn','簏':' lù','簎':' cè','簍':' lǒu','簌':' sù','簋':' guǐ','簊':' jī','簉':' zào','簇':' cù','篼':' dōu','簆':' kòu','簅':' chǎn','簄':' hù','簃':' yí','簂':' guì','簁':' shāi','簀':' zé','篿':' tuán','篾':' miè','篽':' yù','籇':' háo','籉':' tái','粯':' xiàn','粊':' bì','粔':' jù','粓':' gān','粒':' lì','粑':' bā','粐':' hu','粏':' tai','粎':' chǐ','粍':' zhé','粌':' yin','粋':' cuì','粉':' fěn','粖':' mò','粈':' rǒu','粇':' kāng','粆':' shā','粅':' wù','粄':' bǎn','粃':' bǐ','粂':' zhai','粁':' qiān','粀':' zhang','籿':' cùn','粕':' pò','粗':' cū','籽':' zǐ','粤':' yuè','粮':' liáng','粭':' he','粬':' qū','粫':' ér','粪':' fèn','粩':' lao','粨':' bǎi','粧':' zhuāng','粦':' lín','粥':' zhōu','粣':' cè','粘':' zhān','粢':' zī','粡':' tóng','粠':' hóng','粟':' sù','粞':' xī','粝':' lì','粜':' tiào','粛':' sù','粚':' lí','粙':' zhòu','籾':' ní','籼':' xiān','籊':' tì','籖':' qian','籠':' lóng','籟':' lài','籞':' yù','籝':' yíng','籜':' tuò','籛':' jiǎn','籚':' lú','籙':' lù','籘':' téng','籗':' zhuó','籕':' zhòu','籢':' lián','籔':' sǒu','籓':' fān','籒':' zhòu','籑':' zhuàn','籐':' téng','籏':' qi','籎':' yi','籍':' jí','籌':' chóu','籋':' niè','籡':' qie','籣':' lán','类':' lèi','籰':' yuè','籺':' hé','籹':' nǚ','籸':' shēn','籷':' zhé','籶':' shēn','籵':' fán','籴':' dí','米':' mǐ','籲':' yù','籱':' zhuó','籯':' yíng','籤':' qiān','籮':' luó','籭':' sī','籬':' lí','籫':' zuǎn','籪':' duàn','籩':' biān','籨':' lián','籧':' qú','籦':' zhōng','籥':' yuè','絾':' chéng','缍':' duǒ','綀':' shū','纑':' lú','纛':' dào','纚':' lí','纙':' luò','纘':' zuǎn','纗':' zuī','纖':' xiān','纕':' rǎng','纔':' cái','纓':' yīng','纒':' chán','纐':' jiao','纝':' léi','纏':' chán','纎':' xiān','纍':' léi','續':' xù','纋':' yōu','纊':' kuàng','纉':' zuǎn','纈':' xié','纇':' lèi','纆':' mò','纜':' lǎn','纞':' liàn','纄':' péng','纫':' rèn','纵':' zòng','纴':' rèn','纳':' nà','纲':' gāng','纱':' shā','纰':' pī','纯':' chún','纮':' hóng','纭':' yún','纬':' wěi','纪':' jì','纟':' sī','纩':' kuàng','纨':' wán','级':' jí','约':' yuē','纥':' gē','纤':' xiān','纣':' zhòu','红':' hóng','纡':' yū','纠':' jiū','纅':' yào','纃':' qí','纷':' fēn','繝':' jiàn','繧':' yun','繦':' qiǎng','繥':' xī','繤':' zuǎn','繣':' huà','繢':' huì','繡':' xiù','繠':' ruǐ','繟':' chǎn','繞':' rào','繜':' zūn','繩':' shéng','繛':' chuò','繚':' liáo','繙':' fān','繘':' yù','繗':' lín','繖':' sǎn','繕':' shàn','織':' zhī','繓':' zuǒ','繒':' zēng','繨':' da','繪':' huì','纂':' zuǎn','繷':' nǒng','纁':' xūn','纀':' pú','繿':' lán','繾':' qiǎn','繽':' bīn','繼':' jì','繻':' xū','繺':' shǎi','繹':' yì','繸':' suì','繶':' yì','繫':' xì','繵':' dàn','繴':' bì','繳':' jiǎo','繲':' xiè','繱':' cōng','繰':' zǎo','繯':' huán','繮':' jiāng','繭':' jiǎn','繬':' sè','纶':' lún','纸':' zhǐ','繐':' suì','绹':' táo','缃':' xiāng','缂':' kè','缁':' zī','缀':' zhuì','绿':' lǜ','绾':' wǎn','绽':' zhàn','综':' zōng','绻':' quǎn','绺':' liǔ','绸':' chóu','缅':' miǎn','绷':' běng','绶':' shòu','绵':' mián','维':' wéi','绳':' shéng','绲':' gǔn','绱':' shàng','绰':' chuò','绯':' fēi','绮':' qǐ','缄':' jiān','缆':' lǎn','绬':' yīng','缔':' dì','缝':' fèng','篡':' cuàn','缜':' zhěn','缛':' rù','缚':' fù','缙':' jìn','缘':' yuán','缗':' mín','编':' biān'};exports.default=DICTIONARY;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var DICTIONARY={'缕':' lǚ','缓':' huǎn','缇':' tí','缒':' zhuì','缑':' gōu','缐':' xiàn','缏':' biàn','缎':' duàn','缌':' sī','缋':' huì','缊':' yūn','缉':' jī','缈':' miǎo','续':' xù','绫':' líng','纹':' wén','绅':' shēn','经':' jīng','绎':' yì','绍':' shào','绌':' chù','绋':' fú','绊':' bàn','绉':' zhòu','终':' zhōng','织':' zhī','细':' xì','组':' zǔ','绑':' bǎng','练':' liàn','绂':' fú','绁':' xiè','绀':' gàn','线':' xiàn','纾':' shū','纽':' niǔ','纼':' zhèn','纻':' zhù','纺':' fǎng','绐':' dài','绒':' róng','绪':' xù','统':' tǒng','绩':' jī','绨':' tí','继':' jì','绦':' tāo','绥':' suí','绤':' xì','绣':' xiù','绢':' juàn','绡':' xiāo','绠':' gěng','绞':' jiǎo','结':' jié','绝':' jué','络':' luò','绛':' jiàng','绚':' xuàn','给':' gěi','绘':' huì','绗':' háng','绖':' dié','绕':' rào','绔':' kù','繑':' qiāo','繏':' xuàn','綁':' bǎng','緁':' qiè','緋':' fēi','緊':' jǐn','緉':' liǎng','緈':' xìng','緇':' zī','緆':' xī','緅':' zōu','緄':' gǔn','緃':' zōng','緂':' tián','緀':' qī','緍':' mín','綿':' mián','綾':' líng','綽':' chuò','綼':' bì','綻':' zhàn','綺':' qǐ','綹':' liǔ','綸':' lún','綷':' cuì','綶':' guǒ','緌':' ruí','緎':' yù','綴':' zhuì','緛':' ruǎn','緥':' bǎo','緤':' xiè','緣':' yuán','緢':' miáo','緡':' mín','締':' dì','緟':' chóng','緞':' duàn','緝':' jī','緜':' mián','線':' xiàn','総':' zǒng','緙':' kè','緘':' jiān','緗':' xiāng','緖':' xù','緕':' qi','緔':' shàng','緓':' yīng','緒':' xù','緑':' lǜ','緐':' fán','綵':' cǎi','綳':' bēng','緧':' qiū','綍':' fú','綗':' jiǒng','綖':' yán','綕':' zhī','綔':' hù','經':' jīng','綒':' fū','綑':' kǔn','綐':' duì','綏':' suī','綎':' tīng','綌':' xì','継':' jì','綋':' hóng','綊':' xié','綉':' tòu','綈':' tí','綇':' xiǔ','綆':' gěng','綅':' qīn','綄':' huán','綃':' xiāo','綂':' tǒng','綘':' féng','続':' xu','網':' wǎng','綧':' zhǔn','綱':' gāng','綰':' wǎn','綯':' táo','綮':' qǐ','維':' wéi','綬':' shòu','綫':' xiàn','綪':' qiàn','綩':' wǎn','綨':' qí','綦':' qí','綛':' ren','綥':' qí','綤':' shào','綣':' quǎn','綢':' chóu','綡':' liáng','綠':' lǜ','綟':' lì','綞':' duǒ','綝':' chēn','綜':' zōng','緦':' sī','編':' biān','繎':' rán','縩':' cài','縳':' juàn','縲':' léi','縱':' zòng','縰':' xǐ','縯':' yǎn','縮':' suō','縭':' lí','縬':' cù','縫':' fèng','縪':' bì','縨':' huang','縵':' màn','縧':' tāo','縦':' zòng','縥':' zhěn','縤':' sù','縣':' xiàn','縢':' téng','縡':' zài','縠':' hú','縟':' rù','縞':' gǎo','縴':' qiàn','縶':' zhí','縜':' yún','繃':' běng','繍':' xiù','繌':' sha','繋':' jì','繊':' xian','繉':' hún','繈':' qiǎng','繇':' yáo','繆':' móu','繅':' sāo','繄':' yī','繂':' lǜ','縷':' lǚ','繁':' fán','繀':' suì','縿':' shān','績':' jī','總':' zǒng','縼':' xuàn','縻':' mí','縺':' lián','縹':' piǎo','縸':' mù','縝':' chēn','縛':' fù','緩':' huǎn','緵':' zōng','緿':' dài','緾':' chán','緽':' chēng','緼':' yùn','緻':' zhì','緺':' guā','緹':' tí','緸':' yīn','緷':' yùn','緶':' biàn','練':' liàn','縁':' yuán','緳':' xié','緲':' miǎo','緱':' gōu','緰':' tóu','緯':' wěi','緮':' fù','緭':' wèi','緬':' miǎn','緫':' cōng','緪':' gēng','縀':' xiá','縂':' zǒng','縚':' tāo','縏':' pán','縙':' róng','縘':' xī','縗':' cuī','縖':' xiá','縕':' yūn','縔':' shuǎng','縓':' quán','縒':' cī','縑':' jiān','縐':' zhòu','縎':' gǔ','縃':' xū','縍':' bāng','縌':' nì','縋':' zhuì','縊':' yì','縉':' jìn','縈':' yíng','縇':' xuān','縆':' gēng','縅':' wei','縄':' ying','篢':' lǒng','磀':' é','篠':' xiǎo','禱':' dǎo','离':' lí','禺':' yú','禹':' yǔ','禸':' róu','禷':' lèi','禶':' zàn','禵':' tí','禴':' yuè','禳':' ráng','禲':' lì','禰':' mí','禽':' qín','禯':' nóng','禮':' lǐ','禭':' suì','禬':' guì','禫':' dàn','禪':' chán','禩':' sì','禨':' jī','禧':' xǐ','禦':' yù','禼':' xiè','禾':' hé','禤':' xuān','秋':' qiū','秕':' bǐ','秔':' jīng','秓':' zhī','秒':' miǎo','科':' kē','秐':' yún','秏':' hào','秎':' fèn','种':' zhǒng','秌':' qiū','秊':' nián','禿':' tū','秉':' bǐng','秈':' xiān','秇':' yì','秆':' gǎn','秅':' chá','秄':' zǐ','秃':' tū','秂':' rén','私':' sī','秀':' xiù','禥':' qí','禣':' fu','秗':' yù','祽':' zuì','禇':' zhě','禆':' bēi','禅':' chán','禄':' lù','禃':' zhí','禂':' dǎo','禁':' jìn','禀':' bǐng','祿':' lù','祾':' líng','祼':' guàn','禉':' yǒu','祻':' gù','祺':' qí','祹':' táo','祸':' huò','祷':' dǎo','祶':' dì','祵':' kǔn','祴':' gāi','祳':' shèn','祲':' jìn','禈':' huī','禊':' xì','禢':' tà','禗':' sī','禡':' mà','禠':' sī','禟':' táng','禞':' gào','禝':' jí','禜':' yǒng','禛':' zhēn','禚':' zhuó','禙':' bei','禘':' dì','禖':' méi','禋':' yīn','禕':' yī','禔':' zhī','禓':' yáng','禒':' xiǎn','禑':' wú','禐':' yuàn','福':' fú','禎':' zhēn','禍':' huò','禌':' zī','秖':' zhī','秘':' mì','祰':' gào','稙':' zhī','稣':' sū','稢':' yù','稡':' zuì','稠':' chóu','稟':' bǐng','稞':' kē','稝':' péng','稜':' léng','稛':' kǔn','稚':' zhì','稘':' jī','稥':' xiāng','稗':' bài','稖':' bàng','稕':' zhùn','稔':' rěn','稓':' zuó','稒':' gù','稑':' lù','稐':' lǔn','稏':' yà','税':' shuì','稤':' lüè','稦':' yī','稌':' tú','稳':' wěn','稽':' jī','稼':' jià','稻':' dào','稺':' zhì','稹':' zhěn','稸':' xù','稷':' jì','稶':' yù','稵':' zī','稴':' xián','稲':' dào','稧':' xì','稱':' chēng','稰':' xǔ','稯':' zōng','種':' zhǒng','稭':' jiē','稬':' nuò','稫':' pì','稪':' fú','稩':' jì','稨':' biǎn','稍':' shāo','程':' chéng','秙':' kù','秥':' nián','积':' jī','秮':' huó','秭':' zǐ','秬':' jù','秫':' shú','秪':' zhī','秩':' zhì','秨':' zuó','秧':' yāng','秦':' qín','秤':' chèng','秱':' tóng','秣':' mò','秢':' líng','秡':' bó','秠':' pī','租':' zū','秞':' yóu','秝':' lì','秜':' ní','秛':' pī','秚':' bàn','称':' chēng','秲':' zhì','稊':' tí','秿':' fù','稉':' jīng','稈':' gǎn','稇':' kǔn','稆':' lǚ','稅':' shuì','稄':' xùn','稃':' fū','稂':' láng','稁':' kǎo','稀':' xī','秾':' nóng','秳':' huó','秽':' huì','秼':' zhū','移':' yí','秺':' dù','秹':' rěn','秸':' jiē','秷':' zhì','秶':' zī','秵':' yīn','秴':' hé','祱':' shuì','祯':' zhēn','稿':' gǎo','磠':' lǔ','磪':' cuī','磩':' qì','磨':' mó','磧':' qì','磦':' biāo','磥':' lěi','磤':' yǐn','磣':' chěn','磢':' chuǎng','磡':' kàn','磟':' liù','磬':' qìng','磞':' pēng','磝':' áo','磜':' qì','磛':' chán','磚':' zhuān','磙':' gǔn','磘':' qìng','磗':' zhuān','磖':' lá','磕':' kē','磫':' zōng','磭':' chuò','磓':' duī','磺':' huáng','礄':' qiáo','礃':' zhǎng','礂':' xi','礁':' jiāo','礀':' jian','磿':' lì','磾':' dī','磽':' qiāo','磼':' zá','磻':' pán','磹':' tán','磮':' lun','磸':' dìng','磷':' lín','磶':' xì','磵':' jiàn','磴':' dèng','磳':' zēng','磲':' qú','磱':' láo','磰':' shàn','磯':' jī','磔':' zhé','磒':' yǔn','礆':' jiǎn','碫':' duàn','碵':' tian','碴':' chá','碳':' tàn','碲':' dì','碱':' jiǎn','碰':' pèng','碯':' nǎo','碮':' tí','碭':' dàng','碬':' xiá','碪':' zhēn','碷':' dun','碩':' shuò','碨':' wèi','碧':' bì','碦':' kè','碥':' biǎn','碤':' yīng','碣':' jié','碢':' tuó','碡':' dú','缟':' gǎo','碶':' qì','碸':' fēng','磑':' wéi','磆':' huá','磐':' pán','磏':' lián','磎':' xī','磍':' xiá','磌':' tián','磋':' cuō','磊':' lěi','磉':' sǎng','磈':' wěi','磇':' pī','磅':' bàng','碹':' xuàn','磄':' táng','磃':' sī','磂':' liú','磁':' cí','碿':' sù','碾':' niǎn','碽':' gōng','碼':' mǎ','碻':' què','確':' què','礅':' dūn','礇':' yù','祮':' gào','祉':' zhǐ','祓':' fú','祒':' tiáo','祑':' zhì','祐':' yòu','祏':' shí','祎':' yī','祍':' rèn','祌':' zhòng','祋':' duì','祊':' bēng','祈':' qí','祕':' mì','祇':' qí','祆':' xiān','祅':' yāo','祄':' xiè','祃':' mà','祂':' tā','祁':' qí','祀':' sì','礿':' yuè','社':' shè','祔':' fù','祖':' zǔ','礼':' lǐ','祣':' lǚ','祭':' jì','祬':' zhī','祫':' xiá','祪':' guǐ','祩':' zhù','票':' piào','祧':' tiāo','祦':' wú','祥':' xiáng','祤':' yǔ','祢':' mí','祗':' zhī','祡':' chái','祠':' cí','祟':' suì','神':' shén','祝':' zhù','祜':' hù','祛':' qū','祚':' zuò','祙':' mèi','祘':' suàn','礽':' réng','礻':' shì','礈':' zhuì','礔':' pī','礞':' méng','礝':' ruǎn','礜':' yù','礛':' jiān','礚':' kē','礙':' ài','礘':' è','礗':' pīn','礖':' yù','礕':' pī','礓':' jiāng','礠':' cí','礒':' yǐ','礑':' dàng','礐':' què','礏':' yè','礎':' chǔ','礍':' kě','礌':' léi','礋':' zé','礊':' kè','礉':' hé','礟':' pào','礡':' bó','示':' shì','礯':' yīng','礹':' yán','礸':' zǎn','礷':' lán','礶':' guàn','礵':' shuāng','礴':' bó','礳':' mò','礲':' lóng','礱':' lóng','礰':' lì','礮':' pào','礢':' yang','礭':' què','礬':' fán','礫':' lì','礪':' lì','礩':' zhì','礨':' lěi','礧':' léi','礦':' kuàng','礥':' xián','礤':' cǎ','礣':' mà','稾':' gǎo','穀':' gǔ','篟':' qiàn','筒':' tǒng','筜':' dāng','筛':' shāi','筚':' bì','筙':' lái','筘':' kòu','筗':' zhòng','策':' cè','筕':' háng','答':' dá','筓':' jī','筑':' zhù','筞':' cè','筐':' kuāng','筏':' fá','筎':' rú','筍':' sǔn','筌':' quán','筋':' jīn','筊':' xiáo','等':' děng','筈':' kuò','筇':' qióng','筝':' zhēng','筟':' fū','筅':' xiǎn','筬':' chéng','筶':' gào','筵':' yán','筴':' cè','筳':' tíng','筲':' shāo','筱':' xiǎo','筰':' zuó','筯':' zhù','筮':' shì','筭':' suàn','筫':' zhì','筠':' yún','筪':' xiá','筩':' tóng','筨':' hán','筧':' jiǎn','筦':' guǎn','筥':' jǔ','筤':' láng','筣':' lí','筢':' pá','筡':' tú','筆':' bǐ','筄':' yào','筸':' gān','笞':' chī','笨':' bèn','笧':' cè','符':' fú','笥':' sì','笤':' tiáo','笣':' bāo','笢':' mǐn','笡':' qiè','笠':' lì','笟':' gū','笝':' nà','笪':' dá','笜':' zhú','笛':' dí','笚':' dā','笙':' shēng','笘':' shān','笗':' dōng','笖':' yǐ','笕':' jiǎn','笔':' bǐ','笓':' bì','笩':' pèi','笫':' zǐ','筃':' yīn','笸':' pǒ','筂':' chí','筁':' qū','筀':' guì','笿':' luò','笾':' biān','笽':' min','笼':' lóng','笻':' qióng','笺':' jiān','笹':' ti','笷':' mǎo','第':' dì','笶':' shǐ','笵':' fàn','笴':' gǎn','笳':' jiā','笲':' fán','笱':' gǒu','笰':' fú','笯':' nú','笮':' zé','笭':' líng','筷':' kuài','筹':' chóu','笑':' xiào','箺':' chūn','範':' fàn','篃':' mèi','篂':' xīng','篁':' huáng','節':' jié','箿':' jí','箾':' shuò','箽':' dǒng','箼':' wū','箻':' lǜ','箹':' yuē','篆':' zhuàn','箸':' zhù','箷':' yí','箶':' hú','箵':' xīng','箴':' zhēn','箳':' píng','箲':' xiǎn','箱':' xiāng','箰':' sǔn','箯':' biān','篅':' chuán','篇':' piān','箭':' jiàn','篔':' yún','篞':' niè','篝':' gōu','篜':' zhēng','篛':' ruò','篚':' fěi','篙':' gāo','篘':' chōu','篗':' yuè','篖':' táng','篕':' hé','篓':' lǒu','篈':' fēng','篒':' shi','篑':' kuì','篐':' gu','篏':' qiàn','篎':' miǎo','篍':' qiū','篌':' hóu','篋':' qiè','篊':' huáng','築':' zhú','箮':' xuān','箬':' ruò','筺':' kuang','箆':' bì','箐':' qìng','箏':' zhēng','箎':' chí','箍':' gū','箌':' dào','箋':' jiān','箊':' yū','箉':' guǎi','箈':' tái','箇':' gè','箅':' bì','箒':' zhǒu','箄':' bǐ','箃':' zōu','箂':' lái','箁':' póu','简':' jiǎn','筿':' xiǎo','签':' qiān','筽':' o','筼':' yún','筻':' gàng','箑':' shà','箓':' lù','箫':' xiāo','箠':' chuí','箪':' dān','箩':' luó','箨':' tuò','箧':' qiè','箦':' zé','箥':' bǒ','箤':' zú','箣':' cè','箢':' yuān','管':' guǎn','箟':' jùn','箔':' bó','箞':' qiān','箝':' qián','箜':' kōng','箛':' gū','箚':' zhá','箙':' fú','箘':' jùn','算':' suàn','箖':' lín','箕':' jī','笒':' cén','笐':' háng','穁':' róng','突':' tū','窋':' zhú','窊':' wā','窉':' bǐng','窈':' yǎo','窇':' báo','窆':' biǎn','窅':' yǎo','窄':' zhǎi','窃':' qiè','窂':' láo','窀':' zhūn','窍':' qiào','穿':' chuān','穾':' yào','穽':' jǐng','穼':' shēn','穻':' yū','空':' kōng','穹':' qióng','穸':' xī','穷':' qióng','究':' jiū','窌':' jiào','窎':' diào','穴':' xué','窛':' kòu','窥':' kuī','窤':' guān','窣':' sū','窢':' xū','窡':' zhuó','窠':' kē','窟':' kū','窞':' dàn','窝':' wō','窜':' cuàn','窚':' chéng','窏':' wū','窙':' xiāo','窘':' jiǒng','窗':' chuāng','窖':' jiào','窕':' tiǎo','窔':' yào','窓':' chuāng','窒':' zhì','窑':' yáo','窐':' guī','穵':' wā','穳':' cuán','窧':' zhuo','積':' jī','穗':' suì','穖':' jǐ','穕':' qiè','穔':' huáng','穓':' yì','穒':' hè','穑':' sè','穐':' qiū','穏':' wěn','穎':' yǐng','穌':' sū','穙':' pú','穋':' lù','穊':' jì','穉':' zhì','穈':' méi','穇':' cǎn','穆':' mù','穅':' kāng','穄':' jì','穃':' rong','穂':' suì','穘':' xiāo','穚':' jiāo','穲':' lí','穧':' jì','穱':' zhuō','穰':' ráng','穯':' se','穮':' biāo','穭':' lǚ','穬':' kuàng','穫':' huò','穪':' chēng','穩':' wěn','穨':' tuí','穦':' pīn','穛':' zhuō','穥':' yù','穤':' nuò','穣':' ráng','穢':' huì','穡':' sè','穠':' nóng','穟':' suì','穞':' lǚ','穝':' zui','穜':' zhǒng','窦':' dòu','窨':' xūn','笏':' hù','竪':' shù','竴':' cūn','竳':' dēng','竲':' céng','竱':' zhuǎn','竰':' sháo','端':' duān','竮':' pīng','竭':' jié','竬':' qǔ','竫':' jìng','竩':' yì','競':' jìng','竨':' diào','竧':' jìng','竦':' sǒng','童':' tóng','竤':' hóng','竣':' jùn','竢':' sì','竡':' bai','章':' zhāng','竟':' jìng','竵':' wāi','竷':' kǎn','竝':' bìng','笄':' jī','笎':' yuán','笍':' zhuì','笌':' yá','笋':' sǔn','笊':' zhào','笉':' qǐn','笈':' jí','笇':' suàn','笆':' bā','笅':' xiáo','笃':' dǔ','竸':' jìng','笂':' wan','笁':' zhú','笀':' máng','竿':' gān','竾':' chí','竽':' yú','竼':' péng','竻':' lè','竺':' zhú','竹':' zhú','竞':' jìng','竜':' lóng','窩':' wō','窵':' diào','窿':' lóng','窾':' kuǎn','窽':' kuan','窼':' zhāo','窻':' chuāng','窺':' kuī','窹':' wù','窸':' xī','窷':' liào','窶':' jù','窴':' tián','竁':' cuì','窳':' yǔ','窲':' cháo','窱':' tiǎo','窰':' yáo','窯':' yáo','窮':' qióng','窭':' jù','窬':' yú','窫':' yà','窪':' wā','竀':' chēng','竂':' piáo','竛':' líng','竐':' chù','竚':' zhù','站':' zhàn','竘':' qǔ','竗':' miào','竖':' shù','竕':' fen','竔':' sheng','竓':' hao','竒':' qí','竑':' hóng','竏':' qian','竃':' zào','竎':' fù','竍':' shi','竌':' chù','立':' lì','竊':' qiè','竉':' lǒng','竈':' zào','竇':' dòu','竆':' qióng','竅':' qiào','竄':' cuàn','缞':' cuī','蕠':' rú','缠':' chán','荲':' lí','荼':' tú','荻':' dí','荺':' yǔn','荹':' bù','荸':' bí','荷':' hé','荶':' yín','荵':' rěn','荴':' fū','荳':' dòu','荱':' wěi','荾':' suī','荰':' dù','药':' yào','荮':' zhòu','荭':' hóng','荬':' mǎi','荫':' yīn','荪':' sūn','荩':' jìn','荨':' xún','荧':' yíng','荽':' suī','荿':' chéng','荥':' xíng','莌':' tuō','莖':' jīng','莕':' xìng','莔':' méng','莓':' méi','莒':' jǔ','莑':' péng','莐':' chén','莏':' suō','莎':' shā','莍':' qiú','莋':' zuó','莀':' chén','莊':' zhuāng','莉':' lì','莈':' mò','莇':' zhù','莆':' pú','莅':' lì','莄':' gěng','莃':' xī','莂':' bié','莁':' wú','荦':' luò','荤':' hūn','莘':' shēn','茾':' qiān','荈':' chuǎn','荇':' xìng','荆':' jīng','荅':' dā','荄':' gāi','荃':' quán','荂':' fū','荁':' huán','荀':' xún','茿':' zhú','茽':' zhòng','荊':' jīng','茼':' tóng','茻':' mǎng','茺':' chōng','茹':' rú','茸':' rōng','茷':' fá','茶':' chá','茵':' yīn','茴':' huí','茳':' jiāng','草':' cǎo','荋':' ér','荣':' róng','荘':' zhuāng','荢':' yu','荡':' dàng','荠':' jì','荟':' huì','荞':' qiáo','荝':' zé','荜':' bì','荛':' ráo','荚':' jiá','荙':' dá','荗':' shù','荌':' àn','荖':' lǎo','荕':' jīn','荔':' lì','荓':' píng','荒':' huāng','荑':' tí','荐':' jiàn','荏':' rěn','荎':' chí','荍':' qiáo','莗':' chē','莙':' jūn','茱':' zhū','菚':' zhàn','菤':' juǎn','菣':' qìn','菢':' bào','菡':' hàn','菠':' bō','菟':' tú','菞':' lí','菝':' bá','菜':' cài','菛':' mén','菙':' chuí','菦':' qín','菘':' sōng','菗':' chóu','菖':' chāng','菕':' lún','菔':' fú','菓':' guǒ','菒':' gǎo','菑':' zāi','菐':' pú','菏':' hé','菥':' xī','菧':' dǐ','菍':' niè','菴':' ān','菾':' tián','菽':' shū','菼':' tǎn','菻':' lǐn','菺':' jiān','菹':' jū','菸':' yān','菷':' zhǒu','菶':' běng','菵':' wǎng','菳':' qín','菨':' jiē','菲':' fēi','菱':' líng','菰':' gū','華':' huá','菮':' gēng','菭':' tái','菬':' qiáo','菫':' jǐn','菪':' dàng','菩':' pú','菎':' kūn','菌':' jūn','莚':' yán','莦':' shāo','莰':' kǎn','莯':' mù','莮':' nán','莭':' jié','莬':' wèn','莫':' mò','莪':' é','莩':' fú','莨':' làng','莧':' xiàn','莥':' niǔ','莲':' lián','莤':' sù','莣':' wáng','莢':' jiá','莡':' cuò','莠':' yǒu','莟':' hàn','莞':' guǎn','莝':' cuò','莜':' yóu','莛':' tíng','莱':' lái','莳':' shí','菋':' wèi','菀':' wǎn','菊':' jú','菉':' lù','菈':' lā','菇':' gū','菆':' zōu','菅':' jiān','菄':' dōng','菃':' qú','菂':' dì','菁':' jīng','莿':' cì','莴':' wō','莾':' mǎng','莽':' mǎng','莼':' chún','莻':' gòng','莺':' yīng','莹':' yíng','莸':' yóu','获':' huò','莶':' xiān','莵':' tu','茲':' zī','茰':' yú','萀':' hǔ','芢':' rén','芬':' fēn','芫':' yán','芪':' qí','芩':' qín','芨':' jī','芧':' xù','芦':' lú','芥':' jiè','芤':' kōu','芣':' fú','芡':' qiàn','芮':' ruì','芠':' wén','芟':' shān','芞':' qì','芝':' zhī','芜':' wú','芛':' wěi','芚':' tún','芙':' fú','芘':' pí','芗':' xiāng','芭':' bā','芯':' xīn','芕':' suī','芼':' mào','苆':' qie','苅':' yì','苄':' biàn','苃':' yǒu','苂':' yín','苁':' cōng','苀':' háng','芿':' rèng','芾':' fèi','芽':' yá','芻':' chú','芰':' jì','芺':' ǎo','芹':' qín','芸':' yún','芷':' zhǐ','芶':' gǒu','芵':' jué','芴':' wù','芳':' fāng','芲':' huā','花':' huā','芖':' zhì','芔':' huì','苈':' lì','艮':' gěn','艸':' cǎo','艷':' yàn','艶':' yàn','艵':' pīng','艴':' fú','艳':' yàn','色':' sè','艱':' jiān','艰':' jiān','良':' liáng','艭':' shuāng','艺':' yì','艬':' chán','艫':' lú','艪':' lǔ','艩':' qí','艨':' méng','艧':' huò','艦':' jiàn','艥':' jí','艤':' yǐ','艣':' lǔ','艹':' cao','艻':' lè','芓':' zì','芈':' mǐ','芒':' máng','芑':' qǐ','芐':' hù','芏':' dù','芎':' qiōng','芍':' sháo','芌':' yù','芋':' yù','芊':' qiān','芉':' gān','芇':' mián','艼':' tīng','芆':' chāi','芅':' yì','芄':' wán','芃':' péng','节':' jié','芁':' jiāo','芀':' tiáo','艿':' nǎi','艾':' ài','艽':' jiāo','苇':' wěi','苉':' pǐ','茯':' fú','茊':' zī','茔':' yíng','茓':' xué','茒':' yuán','茑':' niǎo','茐':' cong','茏':' lóng','茎':' jīng','茍':' jì','茌':' chí','茋':' dǐ','茉':' mò','茖':' gé','茈':' cí','茇':' bá','茆':' máo','茅':' máo','茄':' jiā','范':' fàn','茂':' mào','茁':' zhuó','茀':' fú','苿':' wèi','茕':' qióng','茗':' míng','苽':' gū','茤':' jì','茮':' jiāo','茭':' jiāo','茬':' chá','茫':' máng','茪':' guāng','茩':' gòu','茨':' cí','茧':' jiǎn','茦':' cì','茥':' guī','茣':' wú','茘':' lì','茢':' liè','茡':' zì','茠':' hāo','茟':' yù','茞':' chén','茝':' chǎi','茜':' qiàn','茛':' gèn','茚':' yìn','茙':' róng','苾':' bì','苼':' shēng','苊':' è','苖':' dí','苠':' mín','苟':' gǒu','苞':' bāo','苝':' bèi','苜':' mù','苛':' kē','苚':' yòng','苙':' lì','苘':' qǐng','苗':' miáo','苕':' sháo','苢':' yǐ','苔':' tái','苓':' líng','苒':' rǎn','苑':' yuàn','苐':' tí','苏':' sū','苎':' zhù','苍':' cāng','苌':' cháng','苋':' xiàn','苡':' yǐ','苣':' jù','苻':' fú','苰':' hóng','苺':' méi','苹':' píng','苸':' hū','苷':' gān','苶':' nié','苵':' dié','苴':' jū','苳':' dōng','苲':' zhǎ','英':' yīng','苯':' běn','苤':' piě','苮':' xiān','苭':' yǎo','苬':' xiú','苫':' shān','苪':' bǐng','苩':' bó','苨':' nǐ','苧':' níng','苦':' kǔ','若':' ruò','菿':' dào','萁':' qí','艡':' dāng','蔒':' xūn','蔜':' áo','蔛':' hú','蔚':' wèi','蔙':' xuàn','蔘':' shēn','蔗':' zhè','蔖':' cuó','蔕':' dì','蔔':' bó','蔓':' màn','蔑':' miè','蔞':' lóu','蔐':' dí','蔏':' shāng','蔎':' shè','蔍':' lù','蔌':' sù','蔋':' dí','蔊':' hǎn','蔉':' gǔn','蔈':' biāo','蔇':' jì','蔝':' mǐ','蔟':' cù','蔅':' yán','蔬':' shū','蔶':' ze','蔵':' zāng','蔴':' má','蔳':' qiàn','蔲':' kòu','蔱':' shā','蔰':' hù','蔯':' chén','蔮':' guó','蔭':' yīn','蔫':' niān','蔠':' zhōng','蔪':' jiàn','蔩':' yín','蔨':' juàn','蔧':' huì','蔦':' niǎo','蔥':' cōng','蔤':' mì','蔣':' jiǎng','蔢':' pó','蔡':' cài','蔆':' líng','蔄':' màn','蔸':' dōu','蓞':' dàn','蓨':' tiáo','蓧':' diào','蓦':' mò','蓥':' yíng','蓤':' ling','蓣':' yù','蓢':' lǎng','蓡':' shēn','蓠':' lí','蓟':' jì','蓝':' lán','蓪':' tōng','蓜':' pei','蓛':' cè','蓚':' tiáo','蓙':' zuo','蓘':' gǔn','蓗':' zǒng','蓖':' bì','蓕':' guì','蓔':' yǎo','蓓':' bèi','蓩':' mǎo','蓫':' chù','蔃':' qiáng','蓸':' cáo','蔂':' léi','蔁':' zhāng','蔀':' bù','蓿':' xu','蓾':' lǔ','蓽':' bì','蓼':' liǎo','蓻':' zí','蓺':' yì','蓹':' yù','蓷':' tuī','蓬':' péng','蓶':' wéi','蓵':' jié','蓴':' chún','蓳':' jǐn','蓲':' qiū','蓱':' píng','蓰':' xǐ','蓯':' cōng','蓮':' lián','蓭':' ān','蔷':' qiáng','蔹':' liǎn','蓑':' suō','蕺':' jí','薄':' báo','薃':' hào','薂':' xí','薁':' yù','薀':' yùn','蕿':' xuān','蕾':' lěi','蕽':' nóng','蕼':' sì','蕻':' hóng','蕹':' wèng','薆':' ài','蕸':' xiá','蕷':' yù','蕶':' líng','蕵':' sūn','蕴':' yùn','蕳':' jiān','蕲':' qí','蕱':' shao','蕰':' wēn','蕯':' lóng','薅':' hāo','薇':' wēi','蕭':' xiāo','薔':' qiáng','薞':' sūn','薝':' zhān','薜':' bì','薛':' xuē','薚':' tāng','薙':' tì','薘':' dá','薗':' yuán','薖':' kē','薕':' lián','薓':' shēn','薈':' huì','薒':' càn','薑':' jiāng','薐':' léng','薏':' yì','薎':' miè','薍':' wàn','薌':' xiāng','薋':' cí','薊':' jì','薉':' huì','蕮':' xì','蕬':' sī','蔺':' lìn','蕆':' chǎn','蕐':' huá','蕏':' chú','蕎':' qiáo','蕍':' yú','蕌':' lěi','蕋':' ruǐ','蕊':' ruǐ','蕉':' jiāo','蕈':' xùn','蕇':' diǎn','蕅':' ǒu','蕒':' mǎi','蕄':' méng','蕃':' fān','蕂':' shèng','蕁':' qián','蕀':' jí','蔿':' wěi','蔾':' lí','蔽':' bì','蔼':' ǎi','蔻':' kòu','蕑':' jiān','蕓':' yún','蕫':' dǒng','碟':' dié','蕪':' wú','蕩':' dàng','蕨':' jué','蕧':' fù','蕦':' xū','蕥':' yǎ','蕤':' ruí','蕣':' shùn','蕢':' kuì','蕡':' fén','蕟':' fà','蕔':' bāo','蕞':' zuì','蕝':' jué','蕜':' fěi','蕛':' tí','蕚':' è','蕙':' huì','蕘':' ráo','蕗':' lù','蕖':' qú','蕕':' yóu','蓒':' xuān','蓐':' rù','萂':' hé','葂':' miǎn','葌':' jiān','葋':' qú','葊':' ān','葉':' yè','葈':' xǐ','葇':' róu','葆':' bǎo','葅':' zū','葄':' zuò','葃':' zuò','葁':' jiāng','葎':' lǜ','葀':' kuò','萿':' kuò','萾':' yíng','落':' luò','萼':' è','萻':' ān','萺':' mào','萹':' biǎn','萸':' yú','萷':' xiāo','葍':' fú','葏':' jīng','萵':' wō','葜':' qiā','葦':' wěi','葥':' jiàn','葤':' zhòu','董':' dǒng','葢':' gài','葡':' pú','葠':' shēn','葟':' huáng','葞':' mǐ','葝':' qíng','葛':' gé','葐':' pén','葚':' rèn','葙':' xiāng','葘':' zī','著':' zhe','葖':' tū','葕':' yàn','葔':' hóu','葓':' hóng','葒':' hóng','葑':' fēng','萶':' chǔn','萴':' cè','葨':' wēi','萎':' wēi','萘':' nài','萗':' cè','萖':' wǎn','萕':' qí','萔':' tiáo','萓':' yí','萒':' yǎn','萑':' huán','萐':' shà','萏':' dàn','萍':' píng','萚':' tuò','萌':' méng','萋':' qī','萊':' lái','萉':' fèi','萈':' huán','萇':' cháng','萆':' bì','萅':' chūn','萄':' táo','萃':' cuì','萙':' zhen','萛':' jiū','萳':' nǎn','萨':' sà','萲':' xuān','萱':' xuān','萰':' liàn','萯':' fù','萮':' yú','萭':' yǔ','萬':' wàn','萫':' xiàng','萪':' kē','萩':' qiū','萧':' xiāo','萜':' tiē','萦':' yíng','营':' yíng','萤':' yíng','萣':' dìng','萢':' pao','萡':' bo','萠':' méng','萟':' yi','萞':' bi','萝':' luó','葧':' bó','葩':' pā','蓏':' luǒ','蒪':' pò','蒴':' shuò','蒳':' nà','蒲':' pú','蒱':' pú','蒰':' pán','蒯':' kuǎi','蒮':' yù','蒭':' chú','蒬':' yuān','蒫':' cuó','蒩':' zū','蒶':' fén','蒨':' qiàn','蒧':' diǎn','蒦':' huò','蒥':' liú','蒤':' tú','蒣':' xú','蒢':' chú','蒡':' bàng','蒠':' xī','蒟':' jǔ','蒵':' xí','蒷':' yún','蒝':' yuán','蓄':' xù','蓎':' táng','蓍':' shī','蓌':' cuò','蓋':' gài','蓊':' wěng','蓉':' róng','蓈':' láng','蓇':' gǔ','蓆':' xí','蓅':' liú','蓃':' sōu','蒸':' zhēng','蓂':' míng','蓁':' zhēn','蓀':' sūn','蒿':' hāo','蒾':' mí','蒽':' ēn','蒼':' cāng','蒻':' ruò','蒺':' jí','蒹':' jiān','蒞':' lì','蒜':' suàn','葪':' jì','葶':' tíng','蒀':' yūn','葿':' méi','葾':' yuān','葽':' yāo','葼':' zōng','葻':' lán','葺':' qì','葹':' shī','葸':' xǐ','葷':' hūn','葵':' kuí','蒂':' dì','葴':' zhēn','葳':' wēi','葲':' quán','葱':' cōng','葰':' suī','葯':' yào','葮':' duàn','葭':' jiā','葬':' zàng','葫':' hú','蒁':' shù','蒃':' zhuàn','蒛':' quē','蒐':' sōu','蒚':' lì','蒙':' méng','蒘':' rú','蒗':' làng','蒖':' zhēn','蒕':' yūn','蒔':' shí','蒓':' chún','蒒':' shī','蒑':' yìn','蒏':' you','蒄':' guān','蒎':' pài','蒍':' wěi','蒌':' lóu','蒋':' jiǎng','蒊':' huā','蒉':' kuì','蒈':' kǎi','蒇':' chǎn','蒆':' xuē','蒅':' ran','艢':' qiáng','艠':' deng','缡':' lí','耱':' mò','耻':' chǐ','耺':' yún','耹':' qín','耸':' sǒng','耷':' dā','耶':' yé','耵':' dīng','耴':' yì','耳':' ěr','耲':' huái','耰':' yōu','耽':' dān','耯':' huò','耮':' lào','耭':' jī','耬':' lóu','耫':' zhá','耪':' pǎng','耩':' jiǎng','耨':' nòu','耧':' lóu','耦':' ǒu','耼':' dān','耾':' hóng','耤':' jí','聋':' lóng','聕':' hào','联':' lián','聓':' xu','聒':' guā','聑':' tiē','聐':' yà','聏':' ér','聎':' tiāo','聍':' níng','职':' zhí','聊':' liáo','耿':' gěng','聉':' wà','聈':' yǒu','聇':' zhēng','聆':' líng','聅':' chè','聄':' zhěn','聃':' dān','聂':' niè','聁':' pàn','聀':' zhí','耥':' tāng','耣':' lǔn','聗':' liè','翽':' huì','耇':' gǒu','耆':' qí','者':' zhě','耄':' mào','考':' kǎo','耂':' lǎo','老':' lǎo','耀':' yào','翿':' dào','翾':' xuān','翼':' yì','耉':' gǒu','翻':' fān','翺':' áo','翹':' qiào','翸':' pěn','翷':' lín','翶':' ao','翵':' hóu','翴':' lián','翳':' yì','翲':' piāo','耈':' gǒu','耊':' diè','耢':' lào','耗':' hào','耡':' chú','耠':' huō','耟':' jù','耞':' jiā','耝':' qù','耜':' sì','耛':' yí','耚':' pī','耙':' bà','耘':' yún','耖':' chào','耋':' dié','耕':' gēng','耔':' zǐ','耓':' tīng','耒':' lěi','耑':' duān','耐':' nài','耏':' nài','耎':' ruǎn','耍':' shuǎ','而':' ér','聖':' shèng','聘':' pìn','翰':' hàn','肙':' yuàn','肣':' hán','肢':' zhī','股':' gǔ','肠':' cháng','肟':' wò','肞':' chā','肝':' gān','肜':' róng','肛':' gāng','肚':' dù','肘':' zhǒu','肥':' féi','肗':' rǔ','肖':' xiào','肕':' rèn','肔':' yǐ','肓':' huāng','肒':' huàn','肑':' bó','肐':' gē','肏':' cào','肎':' kěn','肤':' fū','肦':' fén','肌':' jī','肳':' wěn','肽':' tài','肼':' jǐng','肻':' kěn','肺':' fèi','肹':' xī','肸':' xī','肷':' qiǎn','肶':' pí','肵':' qí','肴':' yáo','育':' yù','肧':' pēi','肱':' gōng','肰':' rán','肯':' kěn','肮':' āng','肭':' nà','肬':' yóu','肫':' zhūn','肪':' fáng','肩':' jiān','肨':' pàng','肍':' qiú','肋':' lē','聙':' jīng','聥':' jǔ','聯':' lián','聮':' lián','聭':' kuì','聬':' wěng','聫':' lián','聪':' cōng','聩':' kuì','聨':' lian','聧':' kuī','聦':' cōng','聤':' tíng','聱':' áo','聣':' ní','聢':' ding','聡':' cōng','聠':' pīng','聟':' xù','聞':' wén','聝':' guó','聜':' dǐ','聛':' bǐ','聚':' jù','聰':' cōng','聲':' shēng','肊':' yì','聿':' yù','肉':' ròu','肈':' zhào','肇':' zhào','肆':' sì','肅':' sù','肄':' yì','肃':' sù','肂':' sì','肁':' zhào','肀':' yù','聾':' lóng','聳':' sǒng','聽':' tīng','聼':' tīng','聻':' nǐ','聺':' qié','聹':' níng','聸':' dān','職':' zhí','聶':' niè','聵':' kuì','聴':' tīng','翱':' áo','翯':' hè','肿':' zhǒng','罡':' gāng','罫':' guà','罪':' zuì','罩':' zhào','罨':' yǎn','罧':' shèn','罦':' fú','罥':' juàn','罤':' tí','罣':' guà','罢':' bà','罠':' mín','罭':' yù','罟':' gǔ','罞':' máo','罝':' jū','罜':' zhǔ','罛':' gū','罚':' fá','罙':' mí','罘':' fú','罗':' luó','罖':' luó','罬':' zhuó','置':' zhì','罔':' wǎng','罻':' wèi','羅':' luó','羄':' zhào','羃':' mì','羂':' juàn','羁':' jī','羀':' liǔ','罿':' chōng','罾':' zēng','罽':' jì','罼':' bì','罺':' cháo','罯':' ǎn','罹':' lí','罸':' fá','罷':' bà','罶':' liǔ','罵':' mà','罴':' pí','罳':' sī','署':' shǔ','罱':' lǎn','罰':' fá','罕':' hǎn','罓':' gāng','羇':' jī','缭':' liáo','缷':' xiè','缶':' fǒu','缵':' zuǎn','缴':' jiǎo','缳':' huán','缲':' qiāo','缱':' qiǎn','缰':' jiāng','缯':' zēng','缮':' shàn','缬':' xié','缹':' fǒu','缫':' sāo','缪':' móu','缩':' suō','缨':' yīng','缧':' léi','缦':' màn','缥':' piāo','缤':' bīn','缣':' jiān','缢':' yì','缸':' gāng','缺':' quē','罒':' wǎng','罇':' zūn','网':' wǎng','罐':' guàn','罏':' lú','罎':' tán','罍':' léi','罌':' yīng','罋':' wèng','罊':' qì','罉':' cang','罈':' tán','罆':' guàn','缻':' fǒu','罅':' xià','罄':' qìng','罃':' yīng','罂':' yīng','罁':' gāng','罀':' zhao','缿':' xiàng','缾':' píng','缽':' bō','缼':' qi','羆':' pí','羈':' jī','翮':' hé','翉':' běn','翓':' xié','習':' xí','翑':' qú','翐':' zhì','翏':' liù','翎':' líng','翍':' pī','翌':' yì','翋':' lā','翊':' yì','翈':' xiá','翕':' xī','翇':' fú','翆':' cuì','翅':' chì','翄':' chì','翃':' hóng','翂':' fēn','翁':' wēng','翀':' chōng','羿':' yì','羾':' gòng','翔':' xiáng','翖':' xì','羼':' chàn','翣':' shà','翭':' hóu','翬':' huī','翫':' wán','翪':' zōng','翩':' piān','翨':' chì','翧':' xuān','翦':' jiǎn','翥':' zhù','翤':' chì','翢':' dào','翗':' ké','翡':' fěi','翠':' cuì','翟':' dí','翞':' jiāng','翝':' hóng','翜':' shà','翛':' xiāo','翚':' huī','翙':' huì','翘':' qiào','羽':' yǔ','羻':' qiàng','羉':' luán','羕':' yàng','羟':' qiǎng','羞':' xiū','羝':' dī','羜':' zhù','羛':' yì','羚':' líng','羙':' gāo','羘':' zāng','羗':' qiāng','羖':' gǔ','羔':' gāo','羡':' xiàn','羓':' bā','羒':' fén','羑':' yǒu','羐':' yǒu','羏':' yáng','美':' měi','羍':' dá','羌':' qiāng','羋':' mǐ','羊':' yáng','羠':' yí','羢':' róng','羺':' nóu','羯':' jié','羹':' gēng','羸':' léi','羷':' liǎn','羶':' shān','羵':' fén','羴':' shān','羳':' fán','羲':' xī','羱':' yuán','羰':' tāng','羮':' gēng','羣':' qún','羭':' yú','羬':' qián','羫':' qiāng','羪':' yang','義':' yì','羨':' xiàn','羧':' suō','羦':' huán','羥':' qiǎng','群':' qún','肾':' shèn','胀':' zhàng','艟':' chōng','臒':' wò','臜':' zā','臛':' huò','臚':' lú','臙':' yān','臘':' là','臗':' kuān','臖':' xìng','臕':' biāo','臔':' xiàn','臓':' zàng','臑':' nào','臞':' qú','臐':' xūn','臏':' bìn','臎':' cuì','臍':' qí','臌':' gǔ','臋':' tún','臊':' sāo','臉':' liǎn','臈':' là','臇':' juǎn','臝':' luǒ','臟':' zàng','臅':' chù','臬':' niè','臶':' jiàn','臵':' gé','致':' zhì','至':' zhì','臲':' niè','臱':' mián','臰':' chòu','臯':' gāo','臮':' jì','臭':' chòu','臫':' jiǎo','臠':' luán','自':' zì','臩':' guǎng','臨':' lín','臧':' zāng','臦':' guàng','臥':' wò','臤':' qiān','臣':' chén','臢':' zā','臡':' ní','臆':' yì','臄':' jué','臸':' zhī','膞':' zhuān','膨':' péng','膧':' tóng','膦':' lìn','膥':' chūn','膤':' xue','膣':' zhì','膢':' lǘ','膡':' yìng','膠':' jiāo','膟':' lǜ','膝':' xī','膪':' chuài','膜':' mó','膛':' táng','膚':' fū','膙':' jiǎng','膘':' biāo','膗':' chuái','膖':' pāng','膕':' guó','膔':' lù','膓':' cháng','膩':' nì','膫':' liáo','臃':' yōng','膸':' suǐ','臂':' bì','臁':' lián','臀':' tún','膿':' nóng','膾':' kuài','膽':' dǎn','膼':' zhuā','膻':' shān','膺':' yīng','膹':' fèn','膷':' xiāng','膬':' cuì','膶':' rùn','膵':' cuì','膴':' hū','膳':' shàn','膲':' jiāo','膱':' zhí','膰':' fán','膯':' tēng','膮':' xiāo','膭':' guī','臷':' dié','臹':' xiū','膑':' bìn','舺':' xiá','艄':' shāo','艃':' lí','艂':' féng','艁':' zào','艀':' fú','舿':' kua','舾':' xī','舽':' páng','舼':' qióng','舻':' lú','船':' chuán','艆':' láng','舸':' gě','舷':' xián','舶':' bó','舵':' duò','舴':' zé','舳':' zhú','舲':' líng','舱':' cāng','舰':' jiàn','舯':' zhōng','艅':' yú','艇':' tǐng','舭':' bǐ','艔':' dou','艞':' yào','艝':' xue','艜':' dài','艛':' lóu','艚':' cáo','艙':' cāng','艘':' sōu','艗':' yì','艖':' chā','艕':' bàng','艓':' dié','艈':' yù','艒':' mù','艑':' biàn','艐':' kè','艏':' shǒu','艎':' huáng','艍':' jū','艌':' niàn','艋':' měng','艊':' bó','艉':' wěi','舮':' lu','般':' bān','臺':' tái','舆':' yú','舐':' shì','舏':' jiǔ','舎':' she','舍':' shě','舌':' shé','舋':' xìn','舊':' jiù','舉':' jǔ','興':' xìng','與':' yǔ','舅':' jiù','舒':' shū','舄':' xì','舃':' xì','舂':' chōng','舁':' yú','舀':' yǎo','臿':' chā','臾':' yú','臽':' xiàn','臼':' jiù','臻':' zhēn','舑':' tān','舓':' shì','舫':' fǎng','舠':' dāo','航':' háng','舩':' chuán','舨':' bǎn','舧':' fán','舦':' tài','舥':' pā','舤':' fan','舣':' yǐ','舢':' shān','舡':' chuán','舟':' zhōu','舔':' tiǎn','舞':' wǔ','舝':' xiá','舜':' shùn','舛':' chuǎn','舚':' tiàn','舙':' huà','舘':' guǎn','舗':' pù','舖':' pù','舕':' tàn','膒':' óu','膐':' lǚ','胁':' xié','脁':' tiǎo','脋':' xie','脊':' jí','脉':' mài','脈':' mài','脇':' xié','脆':' cuì','脅':' xié','脄':' méi','脃':' cuì','脂':' zhī','脀':' chéng','脍':' kuài','胿':' guī','胾':' zì','能':' néng','胼':' pián','胻':' héng','胺':' àn','胹':' ér','胸':' xiōng','胷':' xiōng','胶':' jiāo','脌':' nin','脎':' sà','胴':' dòng','脛':' jìng','脥':' qiǎn','脤':' shèn','脣':' chún','脢':' méi','脡':' tǐng','脠':' shān','脟':' liè','脞':' cuǒ','脝':' hēng','脜':' yǒu','脚':' jiǎo','脏':' zàng','脙':' xiū','脘':' wǎn','脗':' wěn','脖':' bó','脕':' wàn','脔':' luán','脓':' nóng','脒':' mǐ','脑':' nǎo','脐':' qí','胵':' chī','胳':' gē','脧':' juān','胍':' guā','胗':' zhēn','胖':' pàng','胕':' fǔ','胔':' zì','胓':' píng','胒':' nì','胑':' zhī','胐':' kū','胏':' zǐ','胎':' tāi','背':' bèi','胙':' zuò','胋':' tián','胊':' qú','胉':' bó','胈':' bá','胇':' fèi','胆':' dǎn','胅':' dié','胄':' zhòu','胃':' wèi','胂':' shèn','胘':' xián','胚':' pēi','胲':' hǎi','胧':' lóng','胱':' guāng','胰':' yí','胯':' kuà','胮':' pāng','胭':' yān','胬':' nǔ','胫':' jìng','胪':' lú','胩':' kǎ','胨':' dòng','胦':' yāng','胛':' jiǎ','胥':' xū','胤':' yìn','胣':' chǐ','胢':' kē','胡':' hú','胠':' qū','胟':' mǔ','胞':' bāo','胝':' zhī','胜':' shèng','脦':' de','脨':' cù','膏':' gāo','腪':' yùn','腴':' yú','腳':' jiǎo','腲':' wěi','腱':' jiàn','腰':' yāo','腯':' tú','腮':' sāi','腭':' è','腬':' ròu','腫':' zhǒng','腩':' nǎn','腶':' duàn','腨':' shuàn','腧':' shù','腦':' nǎo','腥':' xīng','腤':' ān','腣':' dì','腢':' ǒu','腡':' luó','腠':' còu','腟':' chì','腵':' jiā','腷':' bì','腝':' ní','膄':' sòu','膎':' xié','膍':' pí','膌':' jí','膋':' liáo','膊':' bó','膉':' yì','膈':' gé','膇':' zhuì','膆':' sù','膅':' táng','膃':' wà','腸':' cháng','膂':' lǚ','膁':' qiǎn','膀':' bǎng','腿':' tuǐ','腾':' téng','腽':' wà','腼':' miǎn','腻':' nì','腺':' xiàn','腹':' fù','腞':' zhuàn','腜':' měi','脩':' xiū','脵':' gǔ','脿':' biāo','脾':' pí','脽':' shuí','脼':' liǎng','脻':' jiē','脺':' cuì','脹':' zhàng','脸':' liǎn','脷':' lì','脶':' luó','脴':' pǐ','腁':' pián','脳':' nao','脲':' niào','脱':' tuō','脰':' dòu','脯':' pú','脮':' něi','脭':' chéng','脬':' pāo','脫':' tuō','脪':' xìn','腀':' lún','腂':' lěi','腛':' wò','腐':' fǔ','腚':' dìng','腙':' zōng','腘':' guó','腗':' pí','腖':' dòng','腕':' wàn','腔':' qiāng','腓':' féi','腒':' jū','腑':' fǔ','腏':' chuò','腃':' kuì','腎':' shèn','腍':' rèn','腌':' yān','腋':' yè','腊':' là','腉':' nái','腈':' jīng','腇':' něi','腆':' tiǎn','腅':' dàn','腄':' chuí','碠':' dìng','牗':' you','碞':' yán','濧':' duì','濱':' bīn','濰':' wéi','濯':' zhuó','濮':' pú','濭':' ǎi','濬':' jùn','濫':' làn','濪':' jìng','濩':' huò','濨':' cí','濦':' yǐn','濳':' qián','濥':' yǐn','濤':' tāo','濣':' wò','濢':' cuì','濡':' rú','濠':' háo','濟':' jì','濞':' bì','濝':' qí','濜':' jìn','濲':' gǔ','濴':' yíng','濚':' yíng','瀁':' yàng','瀋':' shěn','瀊':' pán','瀉':' xiè','瀈':' huī','瀇':' wǎng','瀆':' dú','瀅':' yíng','瀄':' zhì','瀃':' sì','瀂':' lǔ','瀀':' yōu','濵':' bin','濿':' lì','濾':' lǜ','濽':' zàn','濼':' luò','濻':' wěi','濺':' jiàn','濹':' me','濸':' cang','濷':' fèi','濶':' kuò','濛':' méng','濙':' yíng','瀍':' chán','澳':' ào','澽':' jù','澼':' pì','澻':' suì','澺':' yì','澹':' dàn','澸':' dǎn','澷':' màn','澶':' chán','澵':' zhēn','澴':' huán','澲':' yè','澿':' qín','澱':' diàn','澰':' liàn','澯':' càn','澮':' huì','澭':' yōng','澬':' zī','澫':' wàn','澪':' líng','澩':' xué','澨':' shì','澾':' tà','激':' jī','濘':' nìng','濍':' sōng','濗':' mì','濖':' shù','濕':' shī','濔':' mǐ','濓':' lián','濒':' bīn','濑':' lài','濐':' zhǔ','濏':' sè','濎':' dǐng','濌':' tà','濁':' zhuó','濋':' chǔ','濊':' huì','濉':' suī','濈':' jí','濇':' sè','濆':' fén','濅':' jìn','濄':' guō','濃':' nóng','濂':' lián','瀌':' biāo','瀎':' mò','澦':' yù','灏':' hào','灙':' dǎng','灘':' tān','灗':' shàn','灖':' mǐ','灕':' lí','灔':' yàn','灓':' luán','灒':' zàn','灑':' sǎ','灐':' ying','灎':' yàn','灛':' chǎn','灍':' què','灌':' guàn','灋':' fǎ','灊':' qián','灉':' yōng','灈':' qú','灇':' cóng','灆':' lán','灅':' lěi','灄':' shè','灚':' jiǎo','灜':' ying','灂':' zhuó','灩':' yàn','灳':' hui','灲':' xiāo','灱':' xiāo','灰':' huī','灯':' dēng','灮':' guāng','灭':' miè','灬':' biāo','火':' huǒ','灪':' yù','灨':' gàn','灝':' hào','灧':' yàn','灦':' xiǎn','灥':' xún','灤':' luán','灣':' wān','灢':' nǎng','灡':' lán','灠':' lǎn','灟':' zhú','灞':' bà','灃':' fēng','灁':' yuān','瀏':' liú','瀛':' yíng','瀥':' xuè','瀤':' huái','瀣':' xiè','瀢':' wěi','瀡':' suǐ','瀠':' yíng','瀟':' xiāo','瀞':' jìng','瀝':' lì','瀜':' róng','瀚':' hàn','瀧':' lóng','瀙':' qìn','瀘':' lú','瀗':' xiàn','瀖':' huò','瀕':' bīn','瀔':' gǔ','瀓':' chéng','瀒':' sè','瀑':' pù','瀐':' jiān','瀦':' zhū','瀨':' lài','灀':' shuàng','瀵':' fèn','瀿':' fán','瀾':' lán','瀽':' jiǎn','瀼':' ráng','瀻':' dài','瀺':' chán','瀹':' yuè','瀸':' jiān','瀷':' yì','瀶':' lín','瀴':' yíng','瀩':' duì','瀳':' jiàn','瀲':' liàn','瀱':' jì','瀰':' mí','瀯':' yíng','瀮':' ling','瀭':' shu','瀬':' lài','瀫':' hú','瀪':' fán','澧':' lǐ','澥':' xiè','灵':' líng','漗':' cōng','漡':' shāng','漠':' mò','漟':' táng','漞':' mì','漝':' xí','漜':' yě','漛':' téng','漚':' ōu','漙':' tuán','漘':' chún','漖':' jiào','漣':' lián','漕':' cáo','演':' yǎn','漓':' lí','漒':' qiáng','漑':' gài','漐':' zhí','漏':' lòu','漎':' cóng','漍':' guó','漌':' jǐn','漢':' hàn','漤':' lǎn','漊':' lóu','漱':' shù','漻':' liáo','漺':' shuǎng','漹':' yān','漸':' jiàn','漷':' huǒ','漶':' huàn','漵':' xù','漴':' zhuàng','漳':' zhāng','漲':' zhǎng','漰':' pēng','漥':' wā','漯':' luò','漮':' kāng','漭':' mǎng','漬':' zì','漫':' màn','漪':' yī','漩':' xuán','漨':' féng','漧':' gān','漦':' chí','漋':' lóng','漉':' lù','漽':' tí','滣':' chún','滭':' bì','滬':' hù','滫':' xiǔ','滪':' yù','滩':' tān','滨':' bīn','滧':' xiao','滦':' luán','滥':' làn','滤':' lǜ','滢':' yíng','滯':' zhì','满':' mǎn','滠':' shè','滟':' yàn','滞':' zhì','滝':' lóng','滜':' gāo','滛':' yín','滚':' gǔn','滙':' huì','滘':' jiào','滮':' biāo','滰':' jiàng','漈':' jì','滽':' yōng','漇':' xǐ','漆':' qī','漅':' cháo','漄':' yá','漃':' jì','漂':' piào','漁':' yú','漀':' qǐng','滿':' mǎn','滾':' gǔn','滼':' fàn','滱':' kòu','滻':' chǎn','滺':' yōu','滹':' hū','滸':' hǔ','滷':' lǔ','滶':' áo','滵':' mì','滴':' dī','滳':' shāng','滲':' shèn','漼':' cuǐ','漾':' yàng','澤':' zé','潿':' wéi','澉':' gǎn','澈':' chè','澇':' lào','澆':' jiāo','澅':' huà','澄':' chéng','澃':' jiǒng','澂':' chéng','澁':' sè','澀':' sè','潾':' lín','澋':' hòng','潽':' pū','潼':' tóng','潻':' shǔ','潺':' chán','潹':' chán','潸':' shān','潷':' bì','潶':' hēi','潵':' sǎ','潴':' zhū','澊':' cūn','澌':' sī','潲':' shào','澙':' xì','澣':' huàn','澢':' dāng','澡':' zǎo','澠':' miǎn','澟':' lǐn','澞':' yú','澝':' ning','澜':' lán','澛':' lǔ','澚':' yu','澘':' shān','澍':' shù','澗':' jiàn','澖':' xián','澕':' hé','澔':' hào','澓':' fú','澒':' hòng','澑':' liù','澐':' yún','澏':' hán','澎':' pēng','潳':' tú','潱':' yē','漿':' jiāng','潋':' liàn','潕':' wǔ','潔':' jié','潓':' huì','潒':' dàng','潑':' pō','潐':' jiào','潏':' yù','潎':' pì','潍':' wéi','潌':' zhì','潊':' xù','潗':' jí','潉':' kun','潈':' zong','潇':' xiāo','潆':' yíng','潅':' guàn','潄':' shù','潃':' xún','潂':' hóng','潁':' yǐng','潀':' cóng','潖':' pá','潘':' pān','潰':' kuì','潥':' sù','潯':' xún','潮':' cháo','潭':' tán','潬':' shàn','潫':' wān','潪':' zhè','潩':' yì','潨':' cóng','潧':' zhēn','潦':' lǎo','潤':' rùn','潙':' wéi','潣':' mǐn','潢':' huáng','潡':' dùn','潠':' xùn','潟':' xì','潞':' lù','潝':' xī','潜':' qián','潛':' qián','潚':' sù','灴':' hōng','灶':' zào','滖':' suī','熉':' yún','熓':' wǔ','熒':' yíng','熑':' lián','熐':' mì','熏':' xūn','熎':' yào','熍':' qiong','熌':' shǎn','熋':' nái','熊':' xióng','熈':' xī','熕':' gōng','熇':' hè','熆':' hé','熅':' yùn','熄':' xī','熃':' wù','熂':' xì','熁':' xié','熀':' huǎng','煿':' bó','煾':' ēn','熔':' róng','熖':' yan','煼':' chǎo','熣':' suī','熭':' wèi','熬':' áo','熫':' zhì','熪':' yí','熩':' hù','熨':' yùn','熧':' zōng','熦':' jué','熥':' tēng','熤':' yì','熢':' péng','熗':' qiàng','熡':' lóu','熠':' yì','熟':' shú','熞':' jiān','熝':' lù','熜':' cōng','熛':' biāo','熚':' bì','熙':' xī','熘':' liū','煽':' shān','煻':' táng','熯':' hàn','煕':' xī','煟':' wèi','煞':' shā','煝':' mèi','煜':' yù','煛':' jiǒng','煚':' jiǒng','煙':' yān','煘':' chán','煗':' nuǎn','煖':' nuǎn','煔':' shǎn','煡':' xìn','煓':' tuān','煒':' wěi','煑':' zhǔ','煐':' yīng','煏':' bì','煎':' jiān','煍':' jiǎo','煌':' huáng','煋':' xīng','煊':' xuān','煠':' zhá','煢':' qióng','煺':' tuì','煯':' jiē','煹':' gòu','煸':' biān','煷':' liang','煶':' shi','煵':' xiā','煴':' yūn','煳':' hú','煲':' bāo','煱':' guā','煰':' gào','煮':' zhǔ','煣':' róu','煭':' liè','煬':' yáng','煫':' suì','煪':' qiú','煩':' fán','煨':' wēi','照':' zhào','煦':' xù','煥':' huàn','煤':' méi','熮':' liǔ','熰':' ōu','煈':' fèng','燱':' yì','燻':' xūn','燺':' kǎo','燹':' xiǎn','燸':' rú','燷':' lán','燶':' nóng','燵':' da','燴':' huì','燳':' zhào','燲':' xié','燰':' wēi','燽':' chóu','燯':' líng','燮':' xiè','燭':' zhú','燬':' huǐ','燫':' lián','燪':' cōng','燩':' què','燨':' xī','燧':' suì','燦':' càn','燼':' jìn','燾':' dào','燤':' tài','爋':' xùn','爕':' xiè','爔':' xī','爓':' yàn','爒':' liǎo','爑':' jué','爐':' lú','爏':' lì','爎':' liao','爍':' shuò','爌':' kuàng','爊':' āo','燿':' yào','爉':' là','爈':' lǜ','爇':' ruò','爆':' bào','爅':' mò','爄':' lì','爃':' róng','爂':' biāo','爁':' làn','爀':' hè','燥':' zào','燣':' lán','熱':' rè','熽':' xiào','燇':' jùn','燆':' qiāo','燅':' xián','燄':' yàn','燃':' rán','燂':' tán','燁':' yè','燀':' chǎn','熿':' huáng','熾':' chì','熼':' yì','燉':' dùn','熻':' xī','熺':' xī','熹':' xī','熸':' jiān','熷':' zēng','熶':' cuàn','熵':' shāng','熴':' kun','熳':' màn','熲':' jiǒng','燈':' dēng','燊':' shēn','燢':' xué','燗':' làn','燡':' yì','燠':' yù','營':' yíng','燞':' jiǎo','燝':' jing','燜':' mèn','燛':' jǐng','燚':' yì','燙':' tàng','燘':' měi','燖':' xún','燋':' jiāo','燕':' yàn','燔':' fán','燓':' fēn','燒':' shāo','燑':' tóng','燐':' lín','燏':' yù','燎':' liáo','燍':' sī','燌':' fén','煉':' liàn','煇':' huī','灷':' zhuàn','炷':' zhù','烁':' shuò','烀':' hū','炿':' zhou','炾':' huǎng','炽':' chì','炼':' liàn','炻':' shí','為':' wèi','点':' diǎn','炸':' zhà','炶':' hān','烃':' tīng','炵':' tōng','炴':' yǎng','炳':' bǐng','炲':' tái','炱':' tái','炰':' páo','炯':' jiǒng','炮':' pào','炭':' tàn','炬':' jù','烂':' làn','烄':' jiǎo','炪':' zhuō','烑':' yáo','烛':' zhú','烚':' xiá','烙':' lào','烘':' hōng','烗':' kài','烖':' zāi','烕':' miè','烔':' tóng','烓':' wēi','烒':' shì','烐':' zhōu','烅':' xù','烏':' wū','烎':' yín','烍':' xiǎn','烌':' xiū','烋':' xiū','烊':' yáng','烉':' huàn','烈':' liè','烇':' quǎn','烆':' héng','炫':' xuàn','炩':' lìng','烝':' zhēng','炃':' fén','炍':' pàn','炌':' kài','炋':' pī','炊':' chuī','炉':' lú','炈':' yì','炇':' pò','炆':' wén','炅':' jiǒng','炄':' niǔ','炂':' zhōng','炏':' kài','炁':' qì','炀':' yáng','灿':' càn','灾':' zāi','災':' zāi','灼':' zhuó','灻':' chì','灺':' xiè','灹':' zhà','灸':' jiǔ','炎':' yán','炐':' pàng','炨':' duò','炝':' qiàng','炧':' xiè','炦':' bá','炥':' fú','炤':' zhào','炣':' kě','炢':' zhú','炡':' zhēng','炠':' xiá','炟':' dá','炞':' bian','炜':' wěi','炑':' mù','炛':' guāng','炚':' guāng','炙':' zhì','炘':' xīn','炗':' guāng','炖':' dùn','炕':' kàng','炔':' guì','炓':' liào','炒':' chǎo','烜':' xuǎn','烞':' pò','煆':' xiā','無':' wú','焫':' ruò','焪':' qióng','焩':' píng','焨':' fèng','焧':' cōng','焦':' jiāo','焥':' wò','焤':' fǔ','焣':' chǎo','焢':' hōng','焠':' cuì','焭':' qióng','焟':' xī','焞':' tūn','焝':' hùn','焜':' kūn','焛':' lìn','焚':' fén','焙':' bèi','焘':' dào','焗':' jú','焖':' mèn','焬':' xī','焮':' xìn','焔':' yàn','焻':' chàng','煅':' duàn','煄':' zhǒng','煃':' kuǐ','煂':' hè','煁':' chén','煀':' wei','焿':' gēng','焾':' niǎn','焽':' xiǒng','焼':' shāo','焺':' shēng','焯':' chāo','焹':' wang','焸':' xiòng','焷':' pí','然':' rán','焵':' gàng','焴':' yù','焳':' jué','焲':' yì','焱':' yàn','焰':' yàn','焕':' huàn','焓':' hán','烟':' yān','烬':' jìn','烶':' tǐng','烵':' zhuó','烴':' tīng','烳':' pǔ','烲':' xiè','烱':' jiǒng','烰':' fú','烯':' xī','烮':' lie','热':' rè','烫':' tàng','烸':' hǎi','烩':' huì','烨':' yè','烧':' shāo','烦':' fán','烥':' chen','烤':' kǎo','烣':' huī','烢':' chè','烡':' guāng','烠':' huí','烷':' wán','烹':' pēng','焒':' lü','焇':' xiāo','焑':' yān','焐':' wù','焏':' jí','焎':' xiè','焍':' dì','焌':' jùn','焋':' zhuàng','焊':' hàn','焉':' yān','焈':' xī','焆':' juān','烺':' lǎng','焅':' kù','焄':' xūn','焃':' hè','焂':' shū','焁':' xī','焀':' hú','烿':' róng','烾':' chì','烽':' fēng','烼':' xù','烻':' yàn','滗':' bì','滕':' téng','爗':' yè','沦':' lún','沰':' tuō','沯':' zǎn','沮':' jǔ','沭':' shù','沬':' mèi','沫':' mò','沪':' hù','沩':' wéi','沨':' fēng','沧':' cāng','沥':' lì','沲':' tuó','沤':' ōu','沣':' fēng','沢':' zé','没':' méi','沠':' liú','沟':' gōu','沞':' zā','沝':' zhuǐ','沜':' pàn','沛':' pèi','沱':' tuó','河':' hé','沙':' shā','泀':' sī','泊':' pō','泉':' quán','泈':' zhōng','泇':' jiā','泆':' yì','泅':' qiú','泄':' xiè','泃':' jū','泂':' jiǒng','況':' kuàng','沿':' yán','沴':' lì','沾':' zhān','沽':' gū','沼':' zhǎo','治':' zhì','沺':' tián','油':' yóu','沸':' fèi','沷':' fā','沶':' yí','沵':' mǐ','沚':' zhǐ','沘':' bǐ','泌':' mì','汲':' jí','汼':' niú','汻':' hǔ','決':' jué','汹':' xiōng','汸':' fāng','汷':' zhōng','汶':' wèn','汵':' gàn','汴':' biàn','汳':' biàn','汱':' quǎn','汾':' fén','汰':' tài','汯':' hóng','汮':' jūn','汭':' ruì','汬':' jǐng','汫':' jǐng','汪':' wāng','汩':' gǔ','汨':' mì','汧':' qiān','汽':' qì','汿':' xù','沗':' pāng','沌':' dùn','沖':' chōng','沕':' mì','沔':' miǎn','沓':' dá','沒':' méi','沑':' nǜ','沐':' mù','沏':' qī','沎':' huò','沍':' hù','沋':' yóu','沀':' xù','沊':' dàn','沉':' chén','沈':' chén','沇':' yǎn','沆':' hàng','沅':' yuán','沄':' yún','沃':' wò','沂':' yí','沁':' qìn','泋':' huì','泍':' bēn','汥':' zhī','洎':' jì','洘':' kǎo','洗':' xǐ','洖':' wú','洕':' yìn','洔':' zhǐ','洓':' sè','洒':' sǎ','洑':' fú','洐':' xíng','洏':' ér','洍':' sì','洚':' jiàng','洌':' liè','洋':' yáng','洊':' jiàn','洉':' hòu','洈':' wéi','洇':' yīn','洆':' chéng','洅':' zài','洄':' huí','洃':' huī','洙':' zhū','洛':' luò','洁':' jié','洨':' xiáo','洲':' zhōu','洱':' ěr','洰':' jù','洯':' qiè','洮':' táo','洭':' kuāng','洬':' sù','洫':' xù','洪':' hóng','洩':' xiè','洧':' wěi','洜':' luò','洦':' pò','津':' jīn','洤':' quán','洣':' mǐ','洢':' yī','洡':' lèi','洠':' móu','洟':' tì','洞':' dòng','洝':' àn','洂':' yì','洀':' pán','泎':' zé','泚':' cǐ','泤':' sì','泣':' qì','波':' bō','泡':' pào','泠':' líng','泟':' chēng','泞':' nìng','泝':' sù','泜':' zhī','泛':' fàn','泙':' píng','泦':' jú','泘':' hū','泗':' sì','泖':' mǎo','法':' fǎ','泔':' gān','泓':' hóng','泒':' gū','泑':' yōu','泐':' lè','泏':' zhú','泥':' ní','泧':' sà','泿':' yín','泴':' guàn','泾':' jīng','泽':' zé','泼':' pō','泻':' xiè','泺':' luò','泹':' dàn','泸':' lú','泷':' lóng','泶':' xué','泵':' bèng','泳':' yǒng','注':' zhù','泲':' jǐ','泱':' yāng','泰':' tài','泯':' mǐn','泮':' pàn','泭':' fú','泬':' jué','泫':' xuàn','泪':' lèi','泩':' shēng','汦':' zhǐ','汤':' tāng','洴':' píng','毖':' bì','毠':' jiā','毟':' lie','毞':' pí','毝':' cǎi','毜':' háo','毛':' máo','毚':' chán','毙':' bì','毘':' pí','毗':' pí','毕':' bì','毢':' sāi','比':' bǐ','毓':' yù','毒':' dú','毑':' jiě','毐':' ǎi','每':' měi','毎':' měi','母':' mǔ','毌':' guàn','毋':' wú','毡':' zhān','毣':' mù','毉':' yī','毰':' péi','毺':' yū','毹':' shū','毸':' sāi','毷':' mào','毶':' san','毵':' sān','毴':' bī','毳':' cuì','毲':' duō','毱':' jú','毯':' tǎn','毤':' tuò','毮':' shā','毭':' dòu','毬':' qiú','毫':' háo','毪':' mú','毩':' jú','毨':' xiǎn','毧':' róng','毦':' ěr','毥':' xún','毊':' xiāo','毈':' duàn','毼':' hé','殢':' tì','殬':' dù','殫':' dān','殪':' yì','殩':' cuàn','殨':' huì','殧':' jiù','殦':' diāo','殥':' yín','殤':' shāng','殣':' jìn','殡':' bìn','殮':' liàn','殠':' chòu','殟':' wēn','殞':' yǔn','殝':' zhēn','殜':' dié','殛':' jí','殚':' dān','殙':' hūn','殘':' cán','殗':' yè','殭':' jiāng','殯':' bìn','毇':' huǐ','殼':' ké','毆':' ōu','毅':' yì','毄':' jī','毃':' qiāo','毂':' gǔ','毁':' huǐ','毀':' huǐ','殿':' diàn','殾':' xùn','殽':' xiáo','殻':' qiào','殰':' dú','殺':' shā','殹':' yì','殸':' qìng','殷':' yīn','殶':' zhù','段':' duàn','殴':' ōu','殳':' shū','殲':' jiān','殱':' jian','毻':' tuò','毽':' jiàn','汣':' jiu','氾':' fàn','汈':' diāo','汇':' huì','汆':' cuān','汅':' miǎn','汄':' zè','汃':' bīn','求':' qiú','汁':' zhī','汀':' tīng','氿':' guǐ','氽':' tǔn','汊':' chà','氼':' nì','氻':' lè','氺':' shui','氹':' dàng','永':' yǒng','氷':' bīng','氶':' zhěng','氵':' shui','水':' shuǐ','氳':' yūn','汉':' hàn','汋':' zhuó','氱':' yǎng','汘':' qiān','汢':' tu','污':' wū','池':' chí','江':' jiāng','汞':' gǒng','汝':' rǔ','汜':' sì','汛':' xùn','汚':' wū','汙':' wū','汗':' hàn','汌':' chuàn','汖':' pìn','汕':' shàn','汔':' qì','汓':' qiú','汒':' máng','汑':' tuō','汐':' xī','汏':' dà','汎':' fàn','汍':' wán','氲':' yūn','氰':' qíng','毾':' tà','氊':' zhān','气':' qì','氓':' máng','氒':' jué','民':' mín','氐':' dī','氏':' shì','氎':' dié','氍':' qú','氌':' lǔ','氋':' méng','氉':' sào','氖':' nǎi','氈':' zhān','氇':' lu','氆':' pǔ','氅':' chǎng','氄':' rǒng','氃':' tóng','氂':' máo','氁':' mú','氀':' lǘ','毿':' sān','氕':' piē','気':' qì','氯':' lǜ','氤':' yīn','氮':' dàn','氭':' dōng','氬':' yà','氫':' qīng','氪':' kè','氩':' yà','氨':' ān','氧':' yǎng','氦':' hài','氥':' xī','氣':' qì','氘':' dāo','氢':' qīng','氡':' dōng','氠':' shēn','氟':' fú','氞':' bin','氝':' nèi','氜':' yáng','氛':' fēn','氚':' chuān','氙':' xiān','洳':' rù','洵':' xún','滔':' tāo','湇':' qì','湑':' xū','湐':' mò','湏':' huì','湎':' miǎn','湍':' tuān','湌':' cān','湋':' wéi','湊':' còu','湉':' tián','湈':' méi','湆':' qì','湓':' pén','湅':' liàn','湄':' méi','湃':' pài','湂':' è','湁':' chì','湀':' guǐ','渿':' nài','渾':' hún','渽':' zāi','渼':' měi','湒':' jí','湔':' jiān','渺':' miǎo','湡':' yú','湫':' jiǎo','湪':' tuàn','湩':' dòng','湨':' jú','湧':' yǒng','湦':' shēng','湥':' tū','湤':' shī','湣':' mǐn','湢':' bì','湠':' tàn','湕':' jiǎn','湟':' huáng','湞':' chēng','湝':' jiē','湜':' shí','湛':' zhàn','湚':' yìn','湙':' yì','湘':' xiāng','湗':' fèng','湖':' hú','渻':' shěng','渹':' hōng','湭':' qiú','渓':' xi','渝':' yú','渜':' nuǎn','減':' jiǎn','渚':' zhǔ','渙':' huàn','渘':' róu','渗':' shèn','渖':' shěn','渕':' yuān','渔':' yú','渒':' pì','渟':' tíng','渑':' miǎn','渐':' jiàn','渏':' qi','渎':' dú','渍':' zì','渌':' lù','渋':' se','渊':' yuān','渉':' shè','済':' jì','渞':' qiú','渠':' qú','游':' yóu','渭':' wèi','渷':' yǎn','渶':' yīng','渵':' máo','渴':' kě','渳':' mǐ','渲':' xuàn','渱':' hóng','渰':' yǎn','港':' gǎng','渮':' hé','測':' cè','渡':' dù','渫':' xiè','渪':' rú','温':' wēn','渨':' wēi','渧':' dì','渦':' wō','渥':' wò','渤':' bó','渣':' zhā','渢':' fán','湬':' jiǎo','湮':' yān','渆':' yuān','溯':' sù','溹':' suò','溸':' sù','溷':' hùn','溶':' róng','溵':' yīn','溴':' xiù','溳':' yún','溲':' sōu','溱':' qín','溰':' ái','溮':' shī','溻':' tā','溭':' zé','溬':' qiāng','溫':' wēn','溪':' xī','溩':' wù','溨':' cái','溧':' lì','溦':' wēi','溥':' pǔ','溤':' mǎ','溺':' nì','溼':' shī','溢':' yì','滉':' huàng','滓':' zǐ','滒':' gē','滑':' huá','滐':' jié','滏':' fǔ','滎':' xíng','滍':' zhì','滌':' dí','滋':' zī','滊':' xì','滈':' hào','溽':' rù','滇':' diān','滆':' gé','滅':' miè','滄':' cāng','滃':' wēng','滂':' pāng','滁':' chú','滀':' chù','溿':' pàn','溾':' āi','溣':' lùn','溡':' shí','湯':' tāng','湻':' chún','溅':' jiàn','溄':' feng','溃':' kuì','溂':' la','溁':' yíng','満':' mǎn','湿':' shī','湾':' wān','湽':' zī','湼':' niè','湺':' yán','溇':' lóu','湹':' chán','湸':' liàng','湷':' zhuāng','湶':' quán','湵':' yǒu','湴':' bàn','湳':' nǎn','湲':' yuán','湱':' huò','湰':' lóng','溆':' xù','溈':' wéi','溠':' zhà','溕':' mèng','溟':' míng','溞':' sāo','溝':' gōu','溜':' liū','溛':' wā','溚':' tǎ','溙':' tài','溘':' kè','溗':' chéng','準':' zhǔn','溔':' yǎo','溉':' gài','溓':' lián','溒':' yuán','溑':' suǒ','源':' yuán','溏':' táng','溎':' yàn','溍':' jìn','溌':' pō','溋':' yíng','溊':' xia','渇':' kě','清':' qīng','洶':' xiōng','浶':' láo','涀':' xiàn','浿':' pèi','浾':' chēng','浽':' suī','浼':' měi','浻':' jiǒng','浺':' chōng','浹':' jiā','浸':' jìn','海':' hǎi','浵':' tóng','涂':' tú','浴':' yù','浳':' yì','浲':' féng','浱':' chún','浰':' liàn','浯':' wú','浮':' fú','浭':' gēng','浬':' lǐ','浫':' hǎn','涁':' shèn','涃':' kùn','浩':' hào','涐':' é','涚':' shuì','涙':' lèi','涘':' sì','涗':' shuì','涖':' lì','涕':' tì','涔':' cén','涓':' juān','涒':' tūn','涑':' sù','涏':' tǐng','涄':' pīng','涎':' xián','涍':' xiào','涌':' yǒng','涋':' tū','涊':' niǎn','涉':' shè','消':' xiāo','涇':' jīng','涆':' hàn','涅':' niè','浪':' làng','浨':' lǎn','涜':' dú','浂':' yì','浌':' fá','测':' cè','浊':' zhuó','浉':' shī','浈':' zhēn','浇':' jiāo','浆':' jiāng','浅':' qiǎn','浄':' jìng','浃':' jiā','流':' liú','济':' jì','浀':' qū','洿':' wū','派':' pài','洽':' qià','洼':' wā','活':' huó','洺':' míng','洹':' huán','洸':' guāng','洷':' zhì','浍':' huì','浏':' liú','浧':' yǐng','浜':' bāng','浦':' pǔ','浥':' yì','浤':' hóng','浣':' huàn','浢':' dòu','浡':' bó','浠':' xī','浟':' yóu','浞':' zhuó','浝':' máng','浛':' hán','浐':' chǎn','浚':' jùn','浙':' zhè','浘':' wěi','浗':' qiú','浖':' liè','浕':' jìn','浔':' xún','浓':' nóng','浒':' hǔ','浑':' hún','涛':' tāo','涝':' lào','渄':' fēi','淟':' tiǎn','淩':' líng','淨':' jìng','淧':' mì','淦':' gàn','淥':' lù','淤':' yū','淣':' ní','淢':' yù','淡':' dàn','淠':' pì','淞':' sōng','淫':' yín','淝':' féi','淜':' píng','淛':' zhè','淚':' lèi','淙':' cóng','淘':' táo','淗':' jú','淖':' nào','淕':' lù','淔':' zhí','淪':' lún','淬':' cuì','淒':' qī','淹':' yān','渃':' ruò','渂':' wèn','渁':' yuān','渀':' bèn','淿':' mì','淾':' yǐn','淽':' zhǐ','淼':' miǎo','添':' tiān','淺':' qiǎn','淸':' qīng','淭':' qú','混':' hùn','淶':' lái','淵':' yuān','淴':' hū','淳':' chún','淲':' biāo','深':' shēn','淰':' niǎn','淯':' yù','淮':' huái','淓':' fāng','淑':' shū','涞':' lái','涪':' fú','涴':' wò','涳':' kōng','液':' yè','涱':' zhàng','涰':' chuò','涯':' yá','涮':' shuàn','涭':' shòu','涬':' xìng','涫':' guàn','涩':' sè','涶':' tuō','涨':' zhǎng','涧':' jiàn','润':' rùn','涥':' heng','涤':' dí','涣':' huàn','涢':' yún','涡':' wō','涠':' wéi','涟':' lián','涵':' hán','涷':' dōng','淐':' chāng','淅':' xī','淏':' hào','淎':' pěng','淍':' zhōu','淌':' tǎng','淋':' lín','淊':' yān','淉':' guǒ','淈':' gǔ','淇':' qí','淆':' xiáo','淄':' zī','涸':' hé','淃':' juàn','淂':' dé','淁':' qiè','淀':' diàn','涿':' zhuō','涾':' tà','涽':' hūn','涼':' liáng','涻':' shè','涺':' jū','涹':' wō','爖':' lóng','爘':' can','碝':' ruǎn','癯':' qú','癹':' bá','癸':' guǐ','癷':' bō','癶':' bō','癵':' luán','癴':' luán','癳':' luǒ','癲':' diān','癱':' tān','癰':' yōng','癮':' yǐn','登':' dēng','癭':' yǐng','癬':' xuǎn','癫':' diān','癪':' jī','癩':' lài','癨':' huò','癧':' lì','癦':' me','癥':' zhēng','癤':' jiē','発':' fā','發':' fā','癢':' yǎng','皉':' cǐ','皓':' hào','皒':' é','皑':' ái','皐':' gāo','皏':' pěng','䴘':' tī','皍':' jí','皌':' mò','皋':' gāo','皊':' líng','皈':' guī','白':' bái','皇':' huáng','皆':' jiē','皅':' pā','的':' de','皃':' mào','皂':' zào','皁':' zào','皀':' jí','癿':' qié','百':' bǎi','癣':' xuǎn','癡':' chī','皕':' bì','瘻':' lòu','癅':' liú','癄':' qiáo','癃':' lóng','療':' liáo','癁':' fú','癀':' huáng','瘿':' yǐng','瘾':' yǐn','瘽':' qín','瘼':' mò','瘺':' lòu','癇':' xián','瘹':' diào','瘸':' qué','瘷':' sè','瘶':' sòu','瘵':' zhài','瘴':' zhàng','瘳':' chōu','瘲':' zòng','瘱':' yì','瘰':' luǒ','癆':' láo','癈':' fèi','癠':' jì','癕':' yōng','癟':' biě','癞':' lài','癝':' lǐn','癜':' diàn','癛':' lǐn','癚':' dàn','癙':' shǔ','癘':' lì','癗':' lěi','癖':' pǐ','癔':' yì','癉':' dān','癓':' wéi','癒':' yù','癑':' nòng','癐':' guì','癏':' guān','癎':' xián','癍':' bān','癌':' ái','癋':' hè','癊':' yìn','皔':' hàn','皖':' wǎn','瘮':' shèn','盗':' dào','盡':' jǐn','盠':' lí','盟':' méng','盞':' zhǎn','盝':' lù','盜':' dào','盛':' shèng','盚':' qiú','盙':' fǔ','盘':' pán','盖':' gài','監':' jiān','盕':' fàn','盔':' kuī','盓':' yū','盒':' hé','监':' jiān','盐':' yán','盏':' zhǎn','盎':' àng','盍':' hé','盌':' wǎn','盢':' xù','盤':' pán','益':' yì','盱':' xū','盻':' xì','盺':' xīn','盹':' dǔn','相':' xiāng','盷':' tián','盶':' yuǎn','盵':' qì','直':' zhí','盳':' wàng','盲':' máng','盰':' gàn','盥':' guàn','盯':' dīng','目':' mù','盭':' lì','盬':' gǔ','盫':' ān','盪':' dàng','盩':' zhōu','盨':' xǔ','盧':' lú','盦':' ān','盋':' bō','盉':' hé','皗':' chóu','皣':' yè','皭':' jiào','皬':' hé','皫':' piǎo','皪':' lì','皩':' huàng','皨':' xīng','皧':' ài','皦':' jiǎo','皥':' hào','皤':' pó','皢':' xiǎo','皯':' gǎn','皡':' hào','皠':' cuǐ','皟':' zé','皞':' hào','皝':' huàng','皜':' hào','皛':' xiǎo','皚':' ái','皙':' xī','皘':' qiàn','皮':' pí','皰':' pào','盈':' yíng','皽':' zhāo','盇':' hé','盆':' pén','盅':' zhōng','盄':' zhāo','盃':' bēi','盂':' yú','盁':' yíng','盀':' qǐ','皿':' mǐn','皾':' dú','皼':' gǔ','皱':' zhòu','皻':' zhā','皺':' zhòu','皹':' jūn','皸':' jūn','皷':' gǔ','皶':' zhā','皵':' què','皴':' cūn','皳':' qiú','皲':' jūn','瘯':' cù','瘭':' biāo','盽':' fēng','疟':' nüè','疩':' cuì','疨':' xiā','疧':' qí','疦':' jué','疥':' jiè','疤':' bā','疣':' yóu','疢':' chèn','疡':' yáng','疠':' lì','疞':' xū','疫':' yì','疝':' shàn','疜':' xià','疛':' zhǒu','疚':' jiù','疙':' gē','疘':' gāng','疗':' liáo','疖':' jiē','疕':' bǐ','疔':' dīng','疪':' bì','疬':' lì','疒':' nè','疹':' zhěn','痃':' xuán','痂':' jiā','痁':' shān','痀':' jū','疿':' fèi','疾':' jí','疽':' jū','疼':' téng','疻':' zhǐ','疺':' fá','疸':' dǎn','疭':' zòng','疷':' zhī','疶':' xuē','疵':' cī','疴':' kē','疳':' gān','疲':' pí','疱':' pào','疰':' zhù','疯':' fēng','疮':' chuāng','疓':' nǎi','疑':' yí','病':' bìng','畫':' huà','畵':' huà','畴':' chóu','畳':' dié','畲':' shē','畱':' liú','異':' yì','畯':' jùn','畮':' mǔ','畭':' yú','畬':' shē','番':' fān','畷':' zhuì','畩':' yi','畨':' pān','畧':' lüè','畦':' qí','略':' lüè','畤':' zhì','畣':' dá','畢':' bì','畡':' gāi','畠':' tián','當':' dāng','畸':' jī','疐':' zhì','疅':' jiāng','疏':' shū','疎':' shū','疍':' dàn','疌':' jié','疋':' pǐ','疊':' dié','疉':' dié','疈':' pì','疇':' chóu','疆':' jiāng','疄':' lìn','畹':' wǎn','疃':' tuǎn','疂':' die','疁':' liú','疀':' chā','畿':' jī','畾':' léi','畽':' tǔn','畼':' chàng','畻':' chéng','畺':' jiāng','痄':' zhà','痆':' niè','瘬':' zhàng','瘇':' zhǒng','瘑':' guō','瘐':' yǔ','瘏':' tú','瘎':' chén','瘍':' yáng','瘌':' là','瘋':' fēng','瘊':' hóu','瘉':' yù','瘈':' chì','瘆':' shèn','瘓':' huàn','瘅':' dān','瘄':' cù','瘃':' zhú','瘂':' yǎ','瘁':' cuì','瘀':' yū','痿':' wěi','痾':' ē','痽':' duī','痼':' gù','瘒':' wén','瘔':' kù','痺':' bì','瘡':' chuāng','瘫':' tān','瘪':' biě','瘩':' da','瘨':' diān','瘧':' nüè','瘦':' shòu','瘥':' chài','瘤':' liú','瘣':' huì','瘢':' bān','瘠':' jí','瘕':' jiǎ','瘟':' wēn','瘞':' yì','瘝':' guān','瘜':' xī','瘛':' chì','瘚':' jué','瘙':' sào','瘘':' lòu','瘗':' yì','瘖':' yīn','痻':' mín','痹':' bì','症':' zhèng','痓':' chì','痝':' máng','痜':' tū','痛':' tòng','痚':' xiāo','痙':' jìng','痘':' dòu','痗':' mèi','痖':' yǎ','痕':' hén','痔':' zhì','痒':' yǎng','痟':' xiāo','痑':' tān','痐':' huí','痏':' wěi','痎':' jiē','痍':' yí','痌':' tōng','痋':' téng','痊':' quán','痉':' jìng','痈':' yōng','痞':' pǐ','痠':' suān','痸':' chì','痭':' bēng','痷':' ān','痶':' tiǎn','痵':' jì','痴':' chī','痳':' lín','痲':' má','痱':' fèi','痰':' tán','痯':' guǎn','痮':' zhàng','痬':' yì','痡':' fū','痫':' xián','痪':' huàn','痩':' shòu','痨':' láo','痧':' shā','痦':' wù','痥':' duó','痤':' cuó','痣':' zhì','痢':' lì','盼':' pàn','盾':' dùn','畞':' mǔ','砐':' è','砚':' yàn','砙':' pān','砘':' dùn','砗':' chē','砖':' zhuān','砕':' suì','研':' yán','砓':' zhé','砒':' pī','砑':' yà','砏':' bīn','砜':' fēng','砎':' jiè','砍':' kǎn','砌':' qì','砋':' zhǐ','砊':' kāng','砉':' huò','砈':' ě','砇':' mín','砆':' fū','砅':' lì','砛':' jin','砝':' fá','砃':' dān','砪':' mǔ','破':' pò','砳':' lè','砲':' pào','砱':' líng','砰':' pēng','砯':' pīng','砮':' nǔ','砭':' biān','砬':' lá','砫':' zhù','砩':' fú','砞':' mò','砨':' è','砧':' zhēn','砦':' zhài','砥':' dǐ','砤':' tuó','砣':' tuó','砢':' kē','砡':' yù','砠':' jū','砟':' zhǎ','砄':' jué','砂':' shā','砶':' pò','矜':' jīn','矦':' hóu','知':' zhī','矤':' shěn','矣':' yǐ','矢':' shǐ','矡':' jué','矠':' zé','矟':' shuò','矞':' yù','矝':' lín','矛':' máo','矨':' yǐng','矚':' zhǔ','矙':' kàn','矘':' tǎng','矗':' chù','矖':' xǐ','矕':' mǎn','矔':' guàn','矓':' lóng','矒':' méng','矑':' lú','矧':' shěn','矩':' jǔ','码':' mǎ','矶':' jī','砀':' dàng','矿':' kuàng','矾':' fán','矽':' xì','矼':' gāng','矻':' kū','矺':' zhé','矹':' wù','矸':' gān','矷':' zǐ','矵':' qì','矪':' zhōu','矴':' dìng','石':' shí','矲':' bà','矱':' yuē','矰':' zēng','矯':' jiǎo','矮':' ǎi','短':' duǎn','矬':' cuó','矫':' jiǎo','砵':' bō','砷':' shēn','矏':' mián','硸':' nüè','碂':' zòng','碁':' qí','碀':' chéng','硿':' kōng','硾':' zhuì','硽':' yān','硼':' péng','硻':' kēng','硺':' zhuó','硹':' sōng','硷':' jiǎn','碄':' lín','硶':' chěn','硵':' lǔ','硴':' hua','硳':' chì','硲':' yù','硱':' kǔn','硰':' shā','硯':' yàn','确':' què','硭':' máng','碃':' qìng','碅':' jūn','硫':' liú','碒':' yín','碜':' chěn','碛':' qì','碚':' bèi','碙':' náo','碘':' diǎn','碗':' wǎn','碖':' lǔn','碕':' qí','碔':' wǔ','碓':' duì','碑':' bēi','碆':' bō','碐':' léng','碏':' què','碎':' suì','碍':' ài','碌':' lù','碋':' hè','碊':' jiān','碉':' diāo','碈':' mín','碇':' dìng','硬':' yìng','硪':' wò','砸':' zá','硄':' kuāng','硎':' xíng','硍':' xiàn','硌':' gè','硋':' ài','硊':' wěi','硉':' lù','硈':' qià','硇':' náo','硆':' è','硅':' guī','硃':' zhū','硐':' dòng','硂':' quán','硁':' kēng','础':' chǔ','砿':' kuang','砾':' lì','砽':' yong','砼':' tóng','砻':' lóng','砺':' lì','砹':' ài','硏':' yán','硑':' pēng','硩':' chè','硞':' què','硨':' chē','硧':' yǒng','硦':' luò','硥':' mǎng','硤':' xiá','硣':' xiāo','硢':' yú','硡':' hōng','硠':' láng','硟':' chàn','硝':' xiāo','硒':' xī','硜':' kēng','硛':' yì','硚':' qiáo','硙':' wéi','硘':' qing','硗':' qiāo','硖':' xiá','硕':' shuò','硔':' hóng','硓':' lao','矐':' huò','矎':' xuān','盿':' mín','眿':' mò','睉':' cuó','睈':' chěng','睇':' dì','睆':' huàn','睅':' hàn','睄':' shào','睃':' suō','睂':' méi','睁':' zhēng','着':' zhe','眾':' zhòng','睋':' é','眽':' mò','眼':' yǎn','眻':' yáng','眺':' tiào','眹':' zhèn','眸':' móu','眷':' juàn','眶':' kuàng','眵':' chī','眴':' xuàn','睊':' juàn','睌':' mǎn','眲':' nè','睙':' liè','督':' dū','睢':' suī','睡':' shuì','睠':' juàn','睟':' suì','睞':' lài','睝':' lí','睜':' zhēng','睛':' jīng','睚':' yá','睘':' qióng','睍':' xiàn','睗':' shì','睖':' lèng','睕':' wǎn','睔':' gùn','睓':' tiǎn','睒':' shǎn','睑':' jiǎn','睐':' lài','睏':' kùn','睎':' xī','眳':' míng','眱':' dì','睥':' pì','看':' kàn','眕':' zhěn','眔':' dà','眓':' huò','眒':' shēn','眑':' yǎo','眐':' zhēng','眏':' yāng','眎':' shì','眍':' kōu','県':' xiàn','眊':' mào','眗':' jū','眉':' méi','眈':' dān','眇':' miǎo','眆':' fǎng','眅':' pān','眄':' miǎn','眃':' yún','眂':' shì','省':' shěng','眀':' míng','眖':' kuàng','眘':' shèn','眰':' diè','眥':' zì','眯':' mī','眮':' tóng','眭':' suī','眬':' lóng','眫':' mǐ','眪':' bǐng','眩':' xuàn','眨':' zhǎ','眧':' chǎo','眦':' zì','眤':' nì','眙':' yí','眣':' dié','眢':' yuān','眡':' shì','眠':' mián','真':' zhēn','眞':' zhēn','眝':' zhù','眜':' mò','眛':' mèi','眚':' shěng','睤':' bì','睦':' mù','矍':' jué','瞨':' pú','瞲':' xù','瞱':' yè','瞰':' kàn','瞯':' xián','瞮':' chè','瞭':' liǎo','瞬':' shùn','瞫':' shěn','瞪':' dèng','瞩':' zhǔ','瞧':' qiáo','瞴':' móu','瞦':' xī','瞥':' piē','瞤':' rún','瞣':' huan','瞢':' méng','瞡':' guǐ','瞠':' chēng','瞟':' piǎo','瞞':' mán','瞝':' chī','瞳':' tóng','瞵':' lín','瞛':' cōng','矂':' sào','矌':' kuàng','矋':' lì','矊':' mián','矉':' pín','矈':' mián','矇':' méng','矆':' huò','矅':' yào','矄':' xūn','矃':' nǐng','矁':' chǒu','瞶':' guì','矀':' méi','瞿':' qú','瞾':' zhào','瞽':' gǔ','瞼':' jiǎn','瞻':' zhān','瞺':' huì','瞹':' ài','瞸':' yè','瞷':' jiàn','瞜':' lōu','瞚':' shùn','睧':' hūn','睳':' huī','睽':' kuí','睼':' tiàn','睻':' xuān','睺':' hóu','睹':' dǔ','睸':' mèi','睷':' jiān','睶':' chǔn','睵':' zāi','睴':' gùn','睲':' xǐng','睿':' ruì','睱':' xià','睰':' mà','睯':' hūn','睮':' yú','睭':' zhǒu','睬':' cǎi','睫':' jié','睪':' yì','睩':' lù','睨':' nì','睾':' gāo','瞀':' mào','瞙':' mò','瞎':' xiā','瞘':' kōu','瞗':' diāo','瞖':' yì','瞕':' zhàng','瞔':' zé','瞓':' shuì','瞒':' mán','瞑':' míng','瞐':' mò','瞏':' qióng','瞍':' sǒu','瞁':' xù','瞌':' kē','瞋':' chēn','瞊':' dàng','瞉':' kòu','瞈':' wěng','瞇':' mī','瞆':' kuì','瞅':' chǒu','瞄':' miáo','瞃':' wò','瞂':' fá','畟':' cè','畝':' mǔ','爙':' rǎng','猩':' xīng','猳':' jiā','猲':' xiē','猱':' náo','猰':' yà','猯':' tuān','献':' xiàn','猭':' chuān','猬':' wèi','猫':' māo','猪':' zhū','猨':' yuán','猵':' biān','猧':' wō','猦':' fēng','猥':' wěi','猤':' guì','猣':' zōng','猢':' hú','猡':' luó','猠':' diǎn','猟':' lie','猞':' shē','猴':' hóu','猶':' yóu','猜':' cāi','獃':' dāi','獍':' jìng','獌':' màn','獋':' háo','獊':' cāng','獉':' zhēn','獈':' yì','獇':' qiang','獆':' háo','獅':' shī','獄':' yù','獂':' yuán','猷':' yóu','獁':' mà','獀':' sōu','猿':' yuán','猾':' huá','猽':' míng','猼':' bó','猻':' sūn','猺':' yáo','猹':' chá','猸':' méi','猝':' cù','猛':' měng','獏':' mò','狵':' máng','狿':' yán','狾':' zhì','狽':' bèi','狼':' láng','狻':' suān','狺':' yín','狹':' xiá','狸':' lí','狷':' juàn','狶':' xī','狴':' bì','猁':' lì','狳':' yú','狲':' sūn','狱':' yù','狰':' zhēng','狯':' kuài','狮':' shī','狭':' xiá','独':' dú','狫':' lǎo','狪':' tóng','猀':' shā','猂':' hàn','猚':' yá','猏':' jiān','猙':' zhēng','猘':' zhì','猗':' yī','猖':' chāng','猕':' mí','猔':' zòng','猓':' guǒ','猒':' yān','猑':' kūn','猐':' qiāng','猎':' liè','猃':' xiǎn','猍':' lái','猌':' yìn','猋':' biāo','猊':' ní','猉':' qí','猈':' bài','猇':' xiāo','猆':' fēi','猅':' pái','猄':' jīng','獎':' jiǎng','獐':' zhāng','狨':' róng','玑':' jī','玛':' mǎ','玚':' chàng','玙':' yú','玘':' qǐ','玗':' yú','玖':' jiǔ','玕':' gān','玔':' chuàn','玓':' dì','玒':' hóng','玐':' bā','玝':' wǔ','玏':' lè','玎':' dīng','玍':' gǎ','玌':' qiú','王':' wáng','玊':' sù','玉':' yù','玈':' lú','率':' lǜ','玆':' zī','玜':' gōng','玞':' fū','玄':' xuán','玫':' méi','玵':' án','玴':' yì','玳':' dài','玲':' líng','玱':' qiāng','现':' xiàn','环':' huán','玮':' wěi','玭':' pín','玬':' dǎn','玪':' jiān','玟':' wén','玩':' wán','玨':' jué','玧':' mén','玦':' jué','玥':' yuè','玤':' bàng','玣':' biàn','玢':' bīn','玡':' yá','玠':' jiè','玅':' miào','玃':' jué','獑':' chán','獝':' xù','獧':' juàn','獦':' gé','獥':' jiào','獤':' dūn','獣':' shou','獢':' xiāo','獡':' shuò','獠':' liáo','獟':' yào','獞':' tóng','獜':' lín','獩':' huì','獛':' pú','獚':' huáng','獙':' bì','獘':' bì','獗':' jué','獖':' bèn','獕':' cuī','獔':' háo','獓':' áo','獒':' áo','獨':' dú','獪':' kuài','玂':' qí','獷':' guǎng','玁':' xiǎn','玀':' luó','獿':' nǎo','獾':' huān','獽':' ráng','獼':' mí','獻':' xiàn','獺':' tǎ','獹':' lú','獸':' shòu','獶':' nǎo','獫':' xiǎn','獵':' liè','獴':' měng','獳':' nòu','獲':' huò','獱':' pín','獰':' níng','獯':' xūn','獮':' xiǎn','獭':' tǎ','獬':' xiè','狩':' shòu','狧':' tà','玷':' diàn','牙':' yá','牣':' rèn','牢':' láo','牡':' mǔ','牠':' tā','牟':' móu','牞':' jiū','牝':' pìn','牜':' niu','牛':' niú','牚':' chēng','牘':' dú','牥':' fāng','薠':' fán','牖':' yǒu','牕':' chuāng','牔':' bó','牓':' bǎng','牒':' dié','牑':' biān','牐':' zhá','牏':' yú','牎':' chuāng','牤':' māng','牦':' máo','牌':' pái','牳':' mǔ','牽':' qiān','牼':' kēng','牻':' máng','牺':' xī','特':' tè','牸':' zì','牷':' quán','牶':' quàn','牵':' qiān','牴':' dǐ','牲':' shēng','牧':' mù','牱':' gē','牰':' yòu','牯':' gǔ','牮':' jiàn','牭':' sì','牬':' bèi','牫':' gē','牪':' yàn','物':' wù','牨':' gāng','牍':' dú','牋':' jiān','牿':' gù','爥':' zhú','爯':' chēng','爮':' páo','爭':' zhēng','爬':' pá','爫':' zhao','爪':' zhǎo','爩':' yù','爨':' cuàn','爧':' líng','爦':' lǎn','爤':' làn','爱':' ài','爣':' tǎng','爢':' mí','爡':' chè','爠':' ju','爟':' guàn','爞':' chóng','爝':' jué','爜':' cóng','爛':' làn','爚':' yuè','爰':' yuán','爲':' wèi','牊':' cháo','爿':' pán','牉':' pàn','版':' bǎn','片':' piàn','牆':' qiáng','牅':' yóng','牄':' qiāng','牃':' dié','牂':' zāng','牁':' kē','牀':' chuáng','爾':' ěr','爳':' han','爽':' shuǎng','爼':' zǔ','爻':' yáo','爺':' yé','爹':' diē','爸':' bà','爷':' yé','父':' fù','爵':' jué','爴':' jué','牾':' wǔ','犀':' xī','狦':' shān','狁':' yǔn','狋':' yí','狊':' jú','狉':' pī','狈':' bèi','狇':' mù','狆':' zhòng','狅':' qīng','狄':' dí','狃':' niǔ','狂':' kuáng','狀':' zhuàng','狍':' páo','犿':' huān','犾':' yín','犽':' yà','犼':' hǒu','犻':' bó','犺':' kàng','犹':' yóu','犸':' mà','犷':' guǎng','状':' zhuàng','狌':' shēng','狎':' xiá','犴':' àn','狛':' bó','狥':' xùn','狤':' jí','狣':' zhào','狢':' hé','狡':' jiǎo','狠':' hěn','狟':' huán','狞':' níng','狝':' xiǎn','狜':' kǔ','狚':' dàn','狏':' tuó','狙':' jū','狘':' xuè','狗':' gǒu','狖':' yòu','狕':' yǎo','狔':' nǐ','狓':' pí','狒':' fèi','狑':' líng','狐':' hú','犵':' gē','犳':' zhuó','犁':' lí','犍':' jiān','犗':' jiè','犖':' luò','犕':' bèi','犔':' xì','犓':' chú','犒':' kào','犑':' jú','犐':' kē','犏':' piān','犎':' fēng','犌':' jiā','犙':' sān','犋':' jù','犊':' dú','犉':' chún','犈':' quán','犇':' bēn','犆':' zhí','犅':' gāng','犄':' jī','犃':' pǒu','犂':' lí','犘':' má','犚':' wèi','犲':' cái','犧':' xī','犱':' jǐ','犰':' qiú','犯':' fàn','犮':' bá','犭':' quǎn','犬':' quǎn','犫':' chōu','犪':' kuí','犩':' wéi','犨':' chōu','犦':' bó','犛':' máo','犥':' piāo','犤':' pái','犣':' liè','犢':' dú','犡':' lì','犠':' xi','犟':' jiàng','犞':' qiao','犝':' tóng','犜':' dūn','玶':' píng','玸':' fú','畜':' chù','瓊':' qióng','瓔':' yīng','瓓':' làn','瓒':' zàn','瓑':' lì','瓐':' lú','瓏':' lóng','瓎':' là','瓍':' suí','瓌':' guī','瓋':' tì','瓉':' zàn','瓖':' xiāng','瓈':' lí','瓇':' róu','瓆':' zhì','瓅':' lì','瓄':' dú','瓃':' léi','瓂':' gài','瓁':' wò','瓀':' ruǎn','璿':' xuán','瓕':' mí','瓗':' qióng','璽':' xǐ','瓤':' ráng','瓯':' ōu','瓮':' wèng','瓭':' dǎn','瓬':' fǎng','瓫':' pén','瓪':' bǎn','瓩':' qiān','瓨':' xiáng','瓦':' wǎ','瓥':' lì','瓣':' bàn','瓘':' guàn','瓢':' piáo','瓡':' zhí','瓠':' hù','瓟':' bó','瓞':' dié','瓝':' bó','瓜':' guā','瓛':' huán','瓚':' zàn','瓙':' dào','璾':' zī','璼':' lán','瓳':' hú','璖':' qú','璠':' fán','璟':' jǐng','璞':' pú','璝':' guī','璜':' huáng','璛':' sù','璚':' qióng','璙':' liáo','璘':' lín','璗':' dàng','璕':' xún','璢':' liú','璔':' zēng','璓':' xiù','璒':' dēng','璑':' wú','璐':' lù','璏':' wèi','璎':' yīng','璍':' hua','璌':' yín','璋':' zhāng','璡':' jìn','璣':' jī','璻':' zuǐ','環':' huán','璺':' wèn','璹':' shú','璸':' bīn','璷':' lú','璶':' jìn','璵':' yú','璴':' chu','璳':' tián','璲':' suì','璱':' sè','璯':' huì','璤':' hui','璮':' tǎn','璭':' gùn','璬':' jiǎo','璫':' dāng','璪':' zǎo','璩':' qú','璨':' càn','璧':' bì','璦':' ài','璥':' jǐng','瓲':' wa','瓴':' líng','璉':' liǎn','男':' nán','畁':' qí','畀':' bì','甿':' méng','甾':' zāi','甽':' zhèn','甼':' tǐng','画':' huà','町':' tīng','甹':' pīng','甸':' diān','甶':' fú','畃':' xún','电':' diàn','甴':' zhá','申':' shēn','甲':' jiǎ','由':' yóu','田':' tián','甯':' níng','甮':' fèng','甭':' béng','甬':' yǒng','畂':' liù','畄':' liú','甪':' lù','畑':' tián','畛':' zhěn','畚':' běn','留':' liú','畘':' nán','畗':' dá','畖':' wā','畕':' jiāng','畔':' pàn','畓':' duō','畒':' mǔ','畐':' fú','畅':' chàng','畏':' wèi','畎':' quǎn','畍':' jiè','界':' jiè','畋':' tián','畊':' gēng','畉':' fú','畈':' fàn','畇':' yún','畆':' mǔ','甫':' fǔ','甩':' shuǎi','瓵':' yí','甂':' biān','甍':' méng','甌':' ōu','甋':' dì','甊':' lǒu','甉':' xián','甈':' qì','甇':' yīng','甆':' cí','甄':' zhēn','甃':' zhòu','甁':' píng','甏':' bèng','甀':' zhuì','瓿':' bù','瓾':' měng','瓽':' dàng','瓻':' chī','瓺':' cháng','瓹':' juān','瓸':' bǎi','瓷':' cí','瓶':' píng','甎':' zhuān','甐':' lìn','用':' yòng','甝':' hán','甧':' shēn','甦':' sū','甥':' shēng','甤':' ruí','産':' chǎn','產':' chǎn','甡':' shēn','甠':' qíng','生':' shēng','甞':' cháng','甜':' tián','甑':' zèng','甛':' tián','甚':' shén','甙':' dài','甘':' gān','甗':' yǎn','甖':' yīng','甕':' wèng','甔':' dān','甓':' pì','甒':' wǔ','璊':' mén','璈':' áo','玹':' xuán','珹':' chéng','球':' qiú','琂':' yán','琁':' xuán','琀':' hán','珿':' chù','現':' xiàn','珽':' tǐng','珼':' bèi','珻':' méi','珺':' jùn','珸':' wú','琅':' láng','珷':' wǔ','珶':' dì','珵':' chéng','珴':' é','珳':' wén','珲':' huī','珱':' ying','珰':' dāng','珯':' lao','珮':' pèi','琄':' xuàn','理':' lǐ','珬':' xù','琓':' wán','琝':' wén','琜':' lái','琛':' chēn','琚':' jū','琙':' yù','琘':' mín','琗':' sè','琖':' zhǎn','琕':' pín','琔':' diàn','琒':' feng','琇':' xiù','琑':' suo','琐':' suǒ','琏':' liǎn','琎':' jìn','琍':' lí','琌':' líng','琋':' xī','琊':' yá','琉':' liú','琈':' fú','班':' bān','珫':' chōng','琟':' wéi','珅':' shēn','珏':' jué','珎':' zhēn','珍':' zhēn','珌':' bì','珋':' liǔ','珊':' shān','珉':' mín','珈':' jiā','珇':' zǔ','珆':' yí','珄':' shēng','珑':' lóng','珃':' rǎn','珂':' kē','珁':' cí','珀':' pò','玿':' sháo','玾':' jiǎ','玽':' gǒu','玼':' cǐ','玻':' bō','玺':' xǐ','珐':' fà','珒':' jīn','珪':' guī','珟':' sù','珩':' háng','珨':' xiá','珧':' yáo','珦':' xiàng','珥':' ěr','珤':' bǎo','珣':' xún','珢':' yín','珡':' qín','珠':' zhū','珞':' luò','珓':' jiào','珝':' xǔ','珜':' yáng','珛':' xiù','珚':' yān','珙':' gǒng','珘':' zhōu','珗':' xiān','珖':' guàng','珕':' lì','珔':' jiàn','琞':' shèng','琠':' tiǎn','璇':' xuán','瑢':' róng','瑬':' liú','瑫':' tāo','瑪':' mǎ','瑩':' yíng','瑨':' jìn','瑧':' zhēn','瑦':' wǔ','瑥':' wēn','瑤':' yáo','瑣':' suǒ','瑡':' shī','瑮':' lì','瑠':' liú','瑟':' sè','瑞':' ruì','瑝':' huáng','瑜':' yú','瑛':' yīng','瑚':' hú','瑙':' nǎo','瑘':' yá','瑗':' yuàn','瑭':' táng','瑯':' láng','瑕':' xiá','瑼':' zhuān','璆':' qiú','璅':' suǒ','璄':' yǐng','璃':' lí','璂':' qí','璁':' cōng','璀':' cuǐ','瑿':' yī','瑾':' jǐn','瑽':' cōng','瑻':' kūn','瑰':' guī','瑺':' cháng','瑹':' shū','瑸':' bīn','瑷':' ài','瑶':' yáo','瑵':' zhǎo','瑴':' jué','瑳':' cuō','瑲':' qiāng','瑱':' zhèn','瑖':' duàn','瑔':' quán','琡':' chù','琭':' lù','琷':' què','琶':' pá','琵':' pí','琴':' qín','琳':' lín','琲':' bèi','琱':' diāo','琰':' yǎn','琯':' guǎn','琮':' cóng','琬':' wǎn','琹':' qín','琫':' běng','琪':' qí','琩':' chāng','琨':' kūn','琧':' è','琦':' qí','琥':' hǔ','琤':' chēng','琣':' běng','琢':' zuó','琸':' zhuó','琺':' fà','瑓':' liàn','瑈':' róu','瑒':' chàng','瑑':' zhuàn','瑐':' jiǎn','瑏':' chuān','瑎':' xié','瑍':' huàn','瑌':' ruǎn','瑋':' wěi','瑊':' jiān','瑉':' mín','瑇':' dài','琻':' jin','瑆':' xīng','瑅':' tí','瑄':' xuān','瑃':' chūn','瑂':' méi','瑁':' mào','瑀':' yǔ','琿':' hún','琾':' jiè','琽':' dǔ','琼':' qióng','薟':' xiān','询':' xún','薡':' dǐng','雷':' léi','霁':' jì','需':' xū','雿':' diào','雾':' wù','雽':' hù','雼':' dàng','電':' diàn','雺':' wù','雹':' báo','雸':' án','零':' líng','霃':' chén','雵':' yāng','雴':' chì','雳':' lì','雲':' yún','雱':' pāng','雰':' fēn','雯':' wén','雮':' mù','雭':' sè','雬':' fǒu','霂':' mù','霄':' xiāo','雪':' xuě','霑':' zhān','霛':' líng','霚':' wù','霙':' yīng','霘':' dòng','霗':' ling','霖':' lín','霕':' tún','霔':' zhù','霓':' ní','霒':' yīn','霐':' hóng','霅':' zhà','霏':' fēi','霎':' shà','霍':' huò','霌':' zhōu','霋':' qī','霊':' líng','霉':' méi','霈':' pèi','震':' zhèn','霆':' tíng','雫':' nǎ','雩':' yú','霝':' líng','雃':' qiān','雍':' yōng','雌':' cí','雋':' juàn','雊':' gòu','雉':' zhì','雈':' huán','雇':' gù','集':' jí','雅':' yǎ','雄':' xióng','雂':' qín','雏':' chú','雁':' yàn','雀':' què','隿':' yì','难':' nán','隽':' juàn','隼':' sǔn','隻':' zhī','隺':' hú','隹':' zhuī','隸':' lì','雎':' jū','雐':' hū','雨':' yǔ','雝':' yōng','雧':' jí','雦':' jí','雥':' zá','雤':' xué','難':' nán','離':' lí','雡':' liù','雠':' chóu','雟':' xī','雞':' jī','雜':' zá','雑':' zá','雛':' chú','雚':' guàn','雙':' shuāng','雘':' wò','雗':' hàn','雖':' suī','雕':' diāo','雔':' chóu','雓':' yú','雒':' luò','霜':' shuāng','霞':' xiá','隶':' lì','靟':' fēi','革':' gé','靨':' yè','靧':' huì','靦':' tiǎn','靥':' yè','靤':' bào','靣':' miàn','面':' miàn','靡':' mí','靠':' kào','非':' fēi','靫':' chá','靝':' tiān','靜':' jìng','靛':' diàn','靚':' jìng','静':' jìng','靘':' qìng','靗':' chēng','靖':' jìng','靕':' zhēn','靔':' tiān','靪':' dīng','靬':' qián','青':' qīng','靹':' nà','鞃':' hóng','鞂':' jiá','鞁':' bèi','鞀':' táo','靿':' yào','靾':' yì','靽':' bàn','靼':' dá','靻':' zǔ','靺':' mò','靸':' sǎ','靭':' rèn','靷':' yǐn','靶':' bǎ','靵':' niǔ','靴':' xuē','靳':' jìn','靲':' qín','靱':' rèn','靰':' wù','靯':' dù','靮':' dí','靓':' jìng','靑':' qīng','霟':' hóng','霫':' xí','霵':' jí','霴':' dài','霳':' lóng','露':' lù','霱':' yù','霰':' sǎn','霯':' tèng','霮':' dàn','霭':' ǎi','霬':' yì','霪':' yín','霷':' yáng','霩':' kuò','霨':' wèi','霧':' wù','霦':' bīn','霥':' mèng','霤':' liù','霣':' yǔn','霢':' mài','霡':' mài','霠':' yīn','霶':' pāng','霸':' bà','靐':' bìng','靅':' fèi','靏':' hè','靎':' hè','靍':' he','靌':' bǎo','靋':' lì','靊':' fēng','靉':' ài','靈':' líng','靇':' lóng','靆':' dài','靄':' ǎi','霹':' pī','靃':' huò','靂':' lì','靁':' léi','靀':' méng','霿':' méng','霾':' mái','霽':' jì','霼':' xì','霻':' fēng','霺':' wéi','隷':' lì','隵':' xī','鞅':' yāng','阧':' dǒu','阱':' jǐng','阰':' pí','阯':' zhǐ','阮':' ruǎn','阭':' yǔn','阬':' kēng','阫':' péi','阪':' bǎn','阩':' shēng','阨':' è','阦':' yáng','阳':' yáng','阥':' yīn','阤':' zhì','阣':' gài','阢':' wù','阡':' qiān','阠':' xìn','队':' duì','阞':' lè','阝':' fù','阜':' fù','防':' fáng','阴':' yīn','阚':' hǎn','陁':' tuó','陋':' lòu','陊':' duò','陉':' xíng','陈':' chén','陇':' lǒng','陆':' lù','际':' jì','附':' fù','陃':' bǐng','陂':' bēi','陀':' tuó','阵':' zhèn','阿':' ā','阾':' lǐng','阽':' diàn','阼':' zuò','阻':' zǔ','阺':' dǐ','阹':' qū','阸':' è','阷':' chēng','阶':' jiē','阛':' huán','阙':' quē','降':' jiàng','闳':' hóng','闽':' mǐn','闼':' tà','闻':' wén','闺':' guī','闹':' nào','闸':' zhá','闷':' mèn','闶':' kāng','闵':' mǐn','间':' jiān','闲':' xián','闿':' kǎi','闱':' wéi','闰':' rùn','闯':' chuǎng','问':' wèn','闭':' bì','闬':' hàn','闫':' yàn','闪':' shǎn','闩':' shuān','门':' mén','闾':' lǘ','阀':' fá','阘':' dá','阍':' hūn','阗':' tián','阖':' hé','阕':' què','阔':' kuò','阓':' huì','阒':' qù','阑':' lán','阐':' chǎn','阏':' è','阎':' yán','阌':' wén','阁':' gé','阋':' xì','阊':' chāng','阉':' yān','阈':' yù','阇':' dū','阆':' láng','阅':' yuè','阄':' jiū','阃':' kǔn','阂':' hé','陌':' mò','陎':' shū','隴':' lǒng','随':' suí','隙':' xì','隘':' ài','隗':' kuí','隖':' wù','隕':' yǔn','隔':' gé','隓':' huī','隒':' yǎn','隑':' gài','隐':' yǐn','階':' jiē','際':' jì','隍':' huáng','隌':' ǎn','隋':' suí','隊':' duì','隉':' niè','隈':' wēi','隇':' wēi','隆':' lóng','隅':' yú','隄':' dī','隚':' táng','障':' zhàng','隂':' yīn','隩':' ào','隳':' huī','隲':' é','隱':' yǐn','隰':' xí','隯':' dǎo','隮':' jī','隭':' ér','隬':' nǐ','隫':' fén','險':' xiǎn','隨':' suí','隝':' dǎo','隧':' suì','隦':' jiǎo','隥':' dèng','隤':' tuí','隣':' lín','隢':' rǎo','隡':' sa','隠':' yǐn','隟':' xì','隞':' áo','隃':' shù','隁':' yàn','陏':' duò','陛':' bì','陥':' xiàn','除':' chú','陣':' zhèn','院':' yuàn','陡':' dǒu','陠':' pū','陟':' zhì','陞':' shēng','陝':' shǎn','陜':' xiá','陚':' fù','陧':' niè','陙':' chún','陘':' xíng','陗':' qiào','陖':' jùn','陕':' shǎn','陔':' gāi','陓':' yū','陒':' guǐ','陑':' ér','限':' xiàn','陦':' dao','陨':' yǔn','隀':' chóng','陵':' líng','陿':' xiá','陾':' réng','陽':' yáng','陼':' zhǔ','陻':' yīn','険':' xiǎn','陹':' shēng','陸':' lù','陷':' xiàn','陶':' táo','陴':' pí','险':' xiǎn','陳':' chén','陲':' chuí','陱':' jū','陰':' yīn','陯':' lún','陮':' duì','陭':' yì','陬':' zōu','陫':' fèi','陪':' péi','鞄':' páo','鞆':' bing','闦':' wén','题':' tí','颢':' hào','颡':' sǎng','颠':' diān','颟':' mān','颞':' niè','额':' é','颜':' yán','颛':' zhuān','颚':' è','颙':' yóng','颗':' kē','颤':' chàn','颖':' yǐng','颕':' yǐng','颔':' hàn','颓':' tuí','颒':' huì','频':' pín','颐':' yí','颏':' kē','颎':' jiǒng','颍':' yǐng','颣':' lèi','颥':' rú','颋':' tǐng','颲':' liè','颼':' sōu','颻':' yáo','颺':' yáng','颹':' wěi','颸':' sī','颷':' biāo','颶':' jù','颵':' shāo','颴':' xuàn','颳':' guā','颱':' tái','颦':' pín','颰':' bá','颯':' sà','颮':' biāo','颭':' zhǎn','颬':' xiā','颫':' fú','颪':' gua','颩':' biāo','風':' fēng','颧':' quán','颌':' hé','颊':' jiá','颾':' sōu','顤':' yáo','顮':' bīn','顭':' méng','顬':' rú','顫':' chàn','顪':' huì','顩':' yǎn','顨':' xùn','顧':' gù','顦':' qiáo','顥':' hào','顣':' cù','顰':' pín','顢':' mán','顡':' wài','顠':' piǎo','顟':' láo','類':' lèi','顝':' kuī','顜':' jiǎng','顛':' diān','顚':' diān','顙':' sǎng','顯':' xiǎn','顱':' lú','颉':' jié','顾':' gù','颈':' jǐng','颇':' pō','领':' lǐng','颅':' lú','预':' yù','颃':' háng','颂':' sòng','颁':' bān','颀':' qí','顿':' dùn','顽':' wán','顲':' lǎn','顼':' xū','须':' xū','顺':' shùn','项':' xiàng','顸':' hān','顷':' qǐng','顶':' dǐng','页':' yè','顴':' quán','顳':' niè','颽':' kǎi','颿':' fān','顗':' yǐ','餀':' hài','養':' yǎng','餉':' xiǎng','餈':' cí','餇':' tóng','餆':' yáo','餅':' bǐng','餄':' jiá','餃':' jiǎo','餂':' tiǎn','餁':' rèn','飿':' duò','餌':' ěr','飾':' shì','飽':' bǎo','飼':' sì','飻':' tiè','飺':' cí','飹':' liǔ','飸':' tāo','飷':' jiě','飶':' bì','飵':' zuò','餋':' juàn','餍':' yàn','飳':' tǒu','餚':' yáo','餤':' tán','餣':' yè','餢':' bù','餡':' xiàn','餠':' bǐng','餟':' zhuì','餞':' jiàn','餝':' shì','餜':' guǒ','餛':' hún','餙':' shì','餎':' le','餘':' yú','餗':' sù','餖':' dòu','餕':' jùn','餔':' bù','餓':' è','餒':' něi','餑':' bō','餐':' cān','餏':' xī','飴':' yí','飲':' yǐn','飀':' liú','飌':' fēng','飖':' yáo','飕':' sōu','飔':' sī','飓':' jù','飒':' sà','飑':' biāo','飐':' zhǎn','飏':' yáng','风':' fēng','飍':' xiū','飋':' sè','飘':' piāo','飊':' biao','飉':' liáo','飈':' biāo','飇':' biāo','飆':' biāo','飅':' liú','飄':' piāo','飃':' piāo','飂':' liù','飁':' xí','飗':' liú','飙':' biāo','飱':' sūn','飦':' zhān','飰':' fàn','飯':' fàn','飮':' yǐn','飭':' chì','飬':' juàn','飫':' yù','飪':' rèn','飩':' tún','飨':' xiǎng','飧':' sūn','飥':' tuō','飚':' biāo','飤':' sì','飣':' dìng','飢':' jī','飡':' cān','飠':' shí','食':' shí','飞':' fēi','飝':' fēi','飜':' fān','飛':' fēi','願':' yuàn','顖':' xìn','鞇':' yīn','韇':' dú','韑':' wěi','韐':' gé','韏':' quàn','韎':' mèi','韍':' fú','韌':' rèn','韋':' wéi','韊':' lán','韉':' jiān','韈':' wà','韆':' qiān','韓':' hán','韅':' xiǎn','韄':' hù','韃':' dá','韂':' chàn','韁':' jiāng','韀':' jiān','鞿':' jī','鞾':' xuē','鞽':' qiáo','鞼':' guì','韒':' qiào','韔':' chàng','鞺':' tāng','韡':' wěi','韫':' yùn','韪':' wěi','韩':' hán','韨':' fú','韧':' rèn','韦':' wéi','韥':' dú','韤':' wà','韣':' dú','韢':' suì','韠':' bì','韕':' kuo','韟':' gāo','韞':' yùn','韝':' gōu','韜':' tāo','韛':' bài','韚':' gé','韙':' wěi','韘':' shè','韗':' yùn','韖':' rǒu','鞻':' lóu','鞹':' kuò','韭':' jiǔ','鞓':' tīng','鞝':' shàng','鞜':' tà','鞛':' běng','鞚':' kòng','鞙':' xuàn','鞘':' qiào','鞗':' tiáo','鞖':' suī','鞕':' yìng','鞔':' mán','鞒':' qiáo','鞟':' kuò','鞑':' dá','鞐':' qia','鞏':' gǒng','鞎':' hén','鞍':' ān','鞌':' ān','鞋':' xié','鞊':' jié','鞉':' táo','鞈':' gé','鞞':' bǐng','鞠':' jū','鞸':' bì','鞭':' biān','鞷':' gé','鞶':' pán','鞵':' xié','鞴':' bèi','鞳':' tà','鞲':' gōu','鞱':' tāo','鞰':' wēn','鞯':' jiān','鞮':' dī','鞬':' jiān','鞡':' la','鞫':' jū','鞪':' mù','鞩':' xiào','鞨':' hé','鞧':' qiū','鞦':' qiū','鞥':' ēng','鞤':' bāng','鞣':' róu','鞢':' xiè','韬':' tāo','韮':' jiǔ','顕':' xiǎn','頰':' jiá','頺':' tuí','頹':' tuí','頸':' jǐng','頷':' hàn','頶':' hú','頵':' yūn','頴':' yǐng','頳':' chēng','頲':' tǐng','頱':' luō','頯':' kuí','頼':' lài','頮':' huì','頭':' tóu','頬':' jiá','頫':' fǔ','頪':' lèi','頩':' pīng','頨':' yǔ','頧':' duǐ','頦':' hái','頥':' shěn','頻':' pín','頽':' tuí','頣':' shěn','顊':' yí','顔':' yán','顓':' zhuān','顒':' yóng','顑':' kǎn','顐':' wèn','顏':' yán','顎':' è','額':' é','題':' tí','顋':' sāi','顉':' qīn','頾':' zī','顈':' xuǎn','顇':' cuì','顆':' kē','顅':' qiān','顄':' hàn','顃':' tán','顂':' lài','顁':' dìng','顀':' chuí','頿':' zī','頤':' yí','頢':' kuò','韯':' xiān','韻':' yùn','項':' xiàng','頄':' kuí','頃':' qǐng','頂':' dǐng','頁':' yè','頀':' hù','響':' xiǎng','韾':' yīn','韽':' ān','韼':' péng','韺':' yīng','頇':' hān','韹':' huáng','韸':' péng','韷':' lè','韶':' sháo','韵':' yùn','韴':' zá','音':' yīn','韲':' jī','韱':' xiān','韰':' xiè','順':' shùn','須':' xū','頡':' xié','頖':' pàn','頠':' wěi','頟':' é','頞':' è','頝':' qiāo','頜':' hé','頛':' lèi','頚':' jǐng','頙':' chè','領':' lǐng','頗':' pō','頕':' dān','頉':' yí','頔':' dí','頓':' dùn','頒':' bān','頑':' wán','預':' yù','頏':' háng','頎':' qí','頍':' kuǐ','頌':' sòng','頋':' ě','頊':' xū','闧':' tā','闥':' tà','餦':' zhāng','鎶':' gē','鏀':' lǔ','鎿':' ná','鎾':' wen','鎽':' feng','鎼':' xià','鎻':' suǒ','鎺':' zu','鎹':' song','鎸':' juān','鎷':' mǎ','鎵':' jiā','鏂':' ōu','鎴':' xí','鎳':' niè','鎲':' tǎng','鎱':' yuán','鎰':' yì','鎯':' láng','鎮':' zhèn','鎭':' zhèn','鎬':' hào','鎫':' wàn','鏁':' suǒ','鏃':' zú','鎩':' shā','鏐':' liú','鏚':' qī','鏙':' cuī','鏘':' qiāng','鏗':' kēng','鏖':' áo','鏕':' lù','鏔':' yí','鏓':' zǒng','鏒':' sǎn','鏑':' dí','鏏':' wèi','鏄':' tuán','鏎':' bì','鏍':' luó','鏌':' mò','鏋':' mǎn','鏊':' ào','鏉':' shòu','鏈':' liàn','鏇':' xuàn','鏆':' guàn','鏅':' xiū','鎪':' sōu','鎨':' sǔn','鏜':' tāng','鎂':' měi','鎌':' lián','鎋':' xiá','鎊':' bàng','鎉':' dá','鎈':' suǒ','鎇':' méi','鎆':' qian','鎅':' jiè','鎄':' āi','鎃':' pài','鎁':' yé','鎎':' kài','鎀':' xiū','鍿':' zī','鍾':' zhōng','鍽':' biān','鍼':' zhēn','鍻':' jié','鍺':' duǒ','鍹':' xuān','鍸':' hú','鍷':' kuí','鎍':' suǒ','鎏':' liú','鎧':' kǎi','鎜':' pán','鎦':' liú','鎥':' tiáo','鎤':' huàng','鎣':' yíng','鎢':' wū','鎡':' zī','鎠':' gāng','鎟':' sǎng','鎞':' bī','鎝':' dā','鎛':' bó','鎐':' yáo','鎚':' chuí','鎙':' shuò','鎘':' lì','鎗':' qiāng','鎖':' suǒ','鎕':' táng','鎔':' róng','鎓':' wēng','鎒':' nòu','鎑':' yè','鏛':' cháng','鏝':' màn','鍵':' jiàn','鐞':' nòu','鐨':' fèi','鐧':' jiān','鐦':' kāi','鐥':' shàn','鐤':' dǐng','鐣':' zhang','鐢':' fán','鐡':' tiě','鐠':' pǔ','鐟':' zān','鐝':' jué','鐪':' lǔ','鐜':' duī','鐛':' yìng','鐚':' yā','鐙':' dèng','鐘':' zhōng','鐗':' jiǎn','鐖':' jī','鐕':' zān','鐔':' xín','鐓':' duì','鐩':' suì','鐫':' juān','鐑':' qiè','鐸':' duó','鑂':' xùn','鑁':' zōng','鑀':' ài','鐿':' yì','鐾':' bèi','鐽':' dá','鐼':' fén','鐻':' jù','鐺':' dāng','鐹':' guǒ','鐷':' yè','鐬':' huì','鐶':' huán','鐵':' tiě','鐴':' bì','鐳':' léi','鐲':' zhuó','鐱':' jiàn','鐰':' qiāo','鐯':' zhuó','鐮':' lián','鐭':' yù','鐒':' láo','鐐':' liáo','鏞':' yōng','鏪':' cáo','鏴':' lù','鏳':' chēng','鏲':' qian','鏱':' zhang','鏰':' bèng','鏯':' shuang','鏮':' kāng','鏭':' xī','鏬':' xià','鏫':' lí','鏩':' jiàn','鏶':' jí','鏨':' zàn','鏧':' lóng','鏦':' cōng','鏥':' xiù','鏤':' lòu','鏣':' shù','鏢':' biāo','鏡':' jìng','鏠':' fēng','鏟':' chǎn','鏵':' huá','鏷':' pú','鐏':' zūn','鐄':' huáng','鐎':' jiāo','鐍':' jué','鐌':' xiàng','鐋':' tāng','鐊':' yáng','鐉':' quān','鐈':' qiáo','鐇':' fán','鐆':' suì','鐅':' piě','鐃':' náo','鏸':' huì','鐂':' liù','鐁':' sī','鐀':' kuì','鏿':' chēng','鏾':' sǎn','鏽':' xiù','鏼':' sè','鏻':' lín','鏺':' pō','鏹':' qiǎng','鍶':' sōng','鍴':' duān','鑄':' zhù','鋦':' jū','鋰':' lǐ','鋯':' gào','鋮':' chéng','鋭':' ruì','鋬':' pàn','鋫':' lí','鋪':' pù','鋩':' máng','鋨':' tiě','鋧':' xiàn','鋥':' zèng','鋲':' bing','鋤':' chú','鋣':' yé','鋢':' lüè','鋡':' hán','鋠':' shèn','鋟':' qǐn','鋞':' xíng','鋝':' lüè','鋜':' zhuó','鋛':' gǒng','鋱':' tè','鋳':' zhù','鋙':' yǔ','錀':' lún','錊':' zuì','錉':' mín','錈':' juǎn','錇':' póu','錆':' qiāng','錅':' lí','錄':' lù','錃':' bēi','錂':' líng','錁':' guǒ','鋿':' cháng','鋴':' zhen','鋾':' táo','鋽':' diào','鋼':' gāng','鋻':' jiàn','鋺':' yuǎn','鋹':' chǎng','鋸':' jù','鋷':' zuì','鋶':' liǔ','鋵':' tū','鋚':' tiáo','鋘':' huá','錌':' àn','銲':' hàn','銼':' cuò','銻':' tí','銺':' zàng','銹':' xiù','銸':' zhé','銷':' xiāo','銶':' qiú','銵':' kēng','銴':' shì','銳':' ruì','銱':' diào','銾':' hòng','銰':' āi','銯':' si','銮':' luán','銭':' qián','銬':' kào','銫':' sè','銪':' yǒu','銩':' diū','銨':' ǎn','銧':' guāng','銽':' guā','銿':' zhōng','鋗':' xuān','鋌':' dìng','鋖':' sī','鋕':' zhì','鋔':' wǎn','鋓':' chān','鋒':' fēng','鋑':' cuān','鋐':' hóng','鋏':' jiá','鋎':' hàn','鋍':' bó','鋋':' chán','鋀':' tōu','鋊':' yù','鋉':' sù','鋈':' wù','鋇':' bèi','鋆':' yún','鋅':' xīn','鋄':' wǎn','鋃':' láng','鋂':' méi','鋁':' lǚ','錋':' péng','錍':' pī','鍳':' jiàn','鍎':' tú','鍘':' zhá','鍗':' tí','鍖':' chěn','鍕':' jūn','鍔':' è','鍓':' jí','鍒':' róu','鍑':' fù','鍐':' zōng','鍏':' wéi','鍍':' dù','鍚':' yáng','鍌':' xiǎn','鍋':' guō','鍊':' liàn','鍉':' dī','鍈':' yīng','鍇':' kǎi','鍆':' mén','鍅':' fa','鍄':' liàng','鍃':' huō','鍙':' hù','鍛':' duàn','鍁':' xiān','鍨':' kuí','鍲':' mín','鍱':' yè','鍰':' huán','鍯':' cōng','鍮':' tōu','鍭':' hóu','鍬':' qiāo','鍫':' qiāo','鍪':' móu','鍩':' tiǎn','鍧':' hōng','鍜':' xiá','鍦':' shī','鍥':' qiè','鍤':' chā','鍣':' zhāo','鍢':' fù','鍡':' wěi','鍠':' huáng','鍟':' xīng','鍞':' kēng','鍝':' yú','鍂':' piān','鍀':' dé','錎':' xiàn','錚':' zhēng','錤':' jī','錣':' zhuì','錢':' qián','錡':' qí','錠':' dìng','錟':' tán','錞':' chún','錝':' zòng','錜':' niè','錛':' bēn','錙':' zī','錦':' jǐn','錘':' chuí','錗':' nèi','錖':' dú','錕':' kūn','錔':' tà','錓':' kōng','錒':' kē','錑':' lèi','錐':' zhuī','錏':' yā','錥':' yù','錧':' guǎn','錿':' hu','錴':' lù','錾':' zàn','錽':' wàn','錼':' nài','錻':' wu','錺':' fang','錹':' kěn','錸':' lái','錷':' gá','錶':' biǎo','錵':' huā','錳':' měng','錨':' máo','録':' lù','錱':' zhēn','錰':' shù','錯':' cuò','錮':' gù','錭':' táo','錬':' liàn','錫':' xī','錪':' tiǎn','錩':' chāng','鑃':' diào','鑅':' héng','闤':' huán','镗':' tāng','镡':' chán','镠':' liú','镟':' xuàn','镞':' zú','镝':' dī','镜':' jìng','镛':' yōng','镚':' bèng','镙':' luó','镘':' màn','镖':' biāo','镣':' liào','镕':' róng','镔':' bīn','镓':' jiā','镒':' yì','镑':' bàng','镐':' gǎo','镏':' liú','镎':' ná','镍':' niè','镌':' juān','镢':' jué','镤':' pú','镊':' niè','镱':' yì','镻':' dié','镺':' ǎo','镹':' jiǔ','镸':' cháng','長':' zhǎng','镶':' xiāng','镵':' chán','镴':' là','镳':' biāo','镲':' chǎ','镰':' lián','镥':' lǔ','镯':' zhuó','镮':' huán','镭':' léi','镬':' huò','镫':' dèng','镪':' qiāng','镩':' cuān','镨':' pǔ','镧':' lán','镦':' duì','镋':' tǎng','镉':' gé','镽':' liǎo','锣':' luó','锭':' dìng','锬':' tán','锫':' péi','锪':' huō','锩':' juǎn','锨':' xiān','锧':' zhì','锦':' jǐn','锥':' zhuī','锤':' chuí','锢':' gù','锯':' jù','锡':' xī','锠':' chāng','锟':' kūn','锞':' kè','锝':' dé','锜':' qí','锛':' bēn','锚':' máo','错':' cuò','锘':' nuò','键':' jiàn','锰':' měng','镈':' bó','锽':' huáng','镇':' zhèn','镆':' mò','镅':' méi','镄':' fèi','镃':' zī','镂':' lòu','镁':' měi','镀':' dù','锿':' āi','锾':' huán','锼':' sōu','锱':' zī','锻':' duàn','锺':' zhōng','锹':' qiāo','锸':' chā','锷':' è','锶':' sī','锵':' qiāng','锴':' kǎi','锳':' yīng','锲':' qiè','镼':' qū','镾':' mí','锖':' qiāng','閿':' wén','闉':' yīn','闈':' wéi','闇':' àn','闆':' bǎn','闅':' wén','闄':' yǎo','闃':' qù','闂':' hòng','闁':' bāo','闀':' xiàng','閾':' yù','闋':' què','閽':' hūn','閼':' è','閻':' yán','閺':' wén','閹':' yān','閸':' kǔn','閷':' shài','閶':' chāng','閵':' lìn','閴':' qù','闊':' kuò','闌':' lán','閲':' yuè','闙':' qǐ','闣':' dàng','闢':' pì','闡':' chǎn','闠':' huì','闟':' xì','闞':' kàn','闝':' piáo','關':' guān','闛':' táng','闚':' kuī','闘':' dòu','闍':' dū','闗':' guān','闖':' chuǎng','闕':' què','闔':' hé','闓':' kǎi','闒':' tà','闑':' niè','闐':' tián','闏':' fēng','闎':' quan','閳':' chǎn','閱':' yuè','长':' zhǎng','開':' kāi','閕':' xiā','閔':' mǐn','間':' jiān','閒':' xián','閑':' xián','閐':' sàn','閏':' rùn','閎':' hóng','閍':' bēng','閌':' kàng','閊':' shan','閗':' dòu','閉':' bì','閈':' hàn','閇':' bì','閆':' yán','閅':' mén','閄':' huò','閃':' shǎn','閂':' shuān','閁':' mà','門':' mén','閖':' shui','閘':' zhá','閰':' jú','閥':' fá','閯':' shà','閮':' tíng','閭':' lǘ','閬':' làng','閫':' kǔn','閪':' sē','閩':' mǐn','閨':' guī','閧':' hòng','閦':' chù','閤':' gé','閙':' nào','閣':' gé','関':' guān','閡':' ài','閠':' rùn','閟':' bì','閞':' biàn','閝':' líng','閜':' xiǎ','閛':' pēng','閚':' zhān','锗':' zhě','锕':' ā','鑆':' zhuì','钆':' gá','钐':' shān','钏':' chuàn','钎':' qiān','钍':' tǔ','钌':' liǎo','钋':' pō','钊':' zhāo','钉':' dīng','针':' zhēn','钇':' yǐ','钅':' jīn','钒':' fán','钄':' lán','钃':' shǔ','钂':' tǎng','钁':' jué','钀':' niè','鑿':' záo','鑾':' luán','鑽':' zuān','鑼':' luó','鑻':' pàn','钑':' jí','钓':' diào','鑹':' cuān','钠':' nà','钪':' kàng','钩':' gōu','钨':' wū','钧':' jūn','钦':' qīn','钥':' yào','钤':' qián','钣':' bǎn','钢':' gāng','钡':' bèi','钟':' zhōng','钔':' mén','钞':' chāo','钝':' dùn','钜':' jù','钛':' tài','钚':' bù','钙':' gài','钘':' xíng','钗':' chāi','钖':' yáng','钕':' nǚ','鑺':' qú','鑸':' lěi','钬':' huǒ','鑒':' jiàn','鑜':' shǎng','鑛':' kuàng','鑚':' zuàn','鑙':' jī','鑘':' léi','鑗':' lí','鑖':' miè','鑕':' zhì','鑔':' chǎ','鑓':' qian','鑑':' jiàn','鑞':' là','鑐':' xū','鑏':' níng','鑎':' kuì','鑍':' yīng','鑌':' bīn','鑋':' qīng','鑊':' huò','鑉':' hé','鑈':' niè','鑇':' jī','鑝':' péng','鑟':' dú','鑷':' niè','鑬':' jiàn','鑶':' cáng','鑵':' guàn','鑴':' xī','鑳':' jiàn','鑲':' xiāng','鑱':' chán','鑰':' yào','鑯':' jiān','鑮':' bó','鑭':' làn','鑫':' xīn','鑠':' shuò','鑪':' lú','鑩':' è','鑨':' lóng','鑧':' kuan','鑦':' xian','鑥':' lǔ','鑤':' bào','鑣':' biāo','鑢':' lǜ','鑡':' chuò','钫':' fāng','钭':' tǒu','锔':' jū','铯':' sè','铹':' láo','铸':' zhù','铷':' rú','银':' yín','铵':' ǎn','铴':' tāng','铳':' chòng','铲':' chǎn','铱':' yī','铰':' jiǎo','铮':' zhēng','铻':' wú','铭':' míng','铬':' gè','铫':' diào','铪':' hā','铩':' shā','铨':' quán','铧':' huá','铦':' xiān','铥':' diū','铤':' dìng','铺':' pù','铼':' lái','铢':' zhū','锉':' cuò','锓':' qǐn','锒':' láng','锑':' tī','锐':' ruì','锏':' jiǎn','锎':' kāi','锍':' liǔ','锌':' xīn','锋':' fēng','锊':' lüè','锈':' xiù','铽':' tè','锇':' é','锆':' gào','锅':' guō','锄':' chú','锃':' zèng','锂':' lǐ','锁':' suǒ','销':' xiāo','铿':' kēng','链':' liàn','铣':' xǐ','铡':' zhá','钮':' niǔ','钺':' yuè','铄':' shuò','铃':' líng','铂':' bó','铁':' tiě','铀':' yóu','钿':' diàn','钾':' jiǎ','钽':' tǎn','钼':' mù','钻':' zuān','钹':' bó','铆':' mǎo','钸':' bù','钷':' pǒ','钶':' ē','钵':' bō','钴':' gǔ','钳':' qián','钲':' zhēng','钱':' qián','钰':' yù','钯':' bǎ','铅':' qiān','铇':' bào','铠':' kǎi','铕':' yǒu','铟':' yīn','铞':' diào','铝':' lǚ','铜':' tóng','铛':' dāng','铚':' zhì','铙':' náo','铘':' yé','铗':' jiá','铖':' chéng','铔':' yà','铈':' shì','铓':' máng','铒':' ěr','铑':' lǎo','铐':' kào','铏':' xíng','铎':' duó','铍':' pī','铌':' ní','铋':' bì','铊':' tā','铉':' xuàn','餥':' fēi','餧':' wèi','銥':' yī','鵹':' lí','鶃':' yì','鶂':' yì','鶁':' jīng','鶀':' qí','鵿':' shēng','鵾':' kūn','鵽':' duò','鵼':' kōng','鵻':' zhuī','鵺':' yè','鵸':' qí','鶅':' zī','鵷':' yuān','鵶':' yā','鵵':' tù','鵴':' jú','鵳':' jiān','鵲':' què','鵱':' lù','鵰':' diāo','鵯':' bēi','鵮':' qiān','鶄':' jīng','鶆':' lái','鵬':' péng','鶓':' miáo','鶝':' fú','鶜':' máo','鶛':' jiē','鶚':' è','鶙':' tí','鶘':' hú','鶗':' tí','鶖':' qiū','鶕':' ān','鶔':' róu','鶒':' chì','鶇':' dōng','鶑':' yīng','鶐':' shù','鶏':' jī','鶎':' zun','鶍':' yi','鶌':' jué','鶋':' jū','鶊':' gēng','鶉':' chún','鶈':' qī','鵭':' qín','鵫':' zhuó','鶟':' tú','鵅':' luò','鵏':' bǔ','鵎':' tuǒ','鵍':' huān','鵌':' tú','鵋':' jì','鵊':' jiá','鵉':' luán','鵈':' e','鵇':' nian','鵆':' heng','鵄':' zhī','鵑':' juān','鵃':' zhōu','鵂':' xiū','鵁':' jiāo','鵀':' rén','鴿':' gē','鴾':' móu','鴽':' rú','鴼':' luò','鴻':' hóng','鴺':' tí','鵐':' wú','鵒':' yù','鵪':' ān','鵟':' kuáng','鵩':' fú','鵨':' shū','鵧':' pí','鵦':' lù','鵥':' pan','鵤':' jiao','鵣':' lài','鵢':' shēn','鵡':' wǔ','鵠':' hú','鵞':' é','鵓':' bó','鵝':' é','鵜':' tí','鵛':' jīng','鵚':' tū','鵙':' jú','鵘':' jùn','鵗':' xī','鵖':' bī','鵕':' xùn','鵔':' jùn','鶞':' chūn','鶠':' yǎn','鴸':' zhū','鷡':' wú','鷫':' sù','鷪':' yīng','鷩':' bì','鷨':' huá','鷧':' yì','鷦':' jiāo','鷥':' sī','鷤':' tí','鷣':' yín','鷢':' jué','鷠':' yú','鷭':' fán','鷟':' zhuó','鷞':' shuāng','鷝':' bì','鷜':' lǘ','鷛':' yōng','鷚':' liù','鷙':' zhì','鷘':' chì','鷗':' ōu','鷖':' yī','鷬':' huáng','鷮':' jiāo','鷔':' áo','鷻':' tuán','鸅':' zé','鸄':' jī','鸃':' yí','鸂':' xī','鸁':' luó','鸀':' chǔ','鷿':' pì','鷾':' yì','鷽':' xué','鷼':' xián','鷺':' lù','鷯':' liáo','鷹':' yīng','鷸':' yù','鷷':' zūn','鷶':' mǎi','鷵':' tú','鷴':' xián','鷳':' xián','鷲':' jiù','鷱':' gāo','鷰':' yàn','鷕':' yǎo','鷓':' zhè','鶡':' hé','鶭':' fǎng','鶷':' xiá','鶶':' táng','鶵':' chú','鶴':' hè','鶳':' shī','鶲':' wēng','鶱':' xiān','鶰':' yuán','鶯':' yīng','鶮':' hè','鶬':' cāng','鶹':' liú','鶫':' dong','鶪':' jú','鶩':' wù','鶨':' chuàn','鶧':' yīng','鶦':' hú','鶥':' méi','鶤':' kūn','鶣':' piān','鶢':' yuán','鶸':' ruò','鶺':' jí','鷒':' tuán','鷇':' kòu','鷑':' jí','鷐':' chén','鷏':' tián','鷎':' gāo','鷍':' jiāo','鷌':' mǎ','鷋':' tú','鷊':' yì','鷉':' tī','鷈':' tī','鷆':' tián','鶻':' gú','鷅':' lì','鷄':' jī','鷃':' yàn','鷂':' yào','鷁':' yì','鷀':' cí','鶿':' cí','鶾':' hàn','鶽':' sǔn','鶼':' jiān','鴹':' yáng','鴷':' liè','鸇':' zhān','鲩':' huàn','鲳':' chāng','鲲':' kūn','鲱':' fēi','鲰':' zōu','鲯':' qí','鲮':' líng','鲭':' qīng','鲬':' yǒng','鲫':' jì','鲪':' jūn','鲨':' shā','鲵':' ní','鲧':' gǔn','鲦':' tiáo','鲥':' shí','鲤':' lǐ','鲣':' jiān','鲢':' lián'};exports.default=DICTIONARY;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var DICTIONARY={'鲡':' lí','鲠':' gěng','鲟':' xún','鲞':' xiǎng','鲴':' gù','鲶':' nián','鲜':' xiān','鳃':' sāi','鳍':' qí','鳌':' áo','鳋':' sāo','鳊':' biān','鳉':' jiāng','鳈':' quán','鳇':' huáng','鳆':' fù','鳅':' qiū','鳄':' è','鳂':' wēi','鲷':' diāo','鳁':' wēn','鳀':' tí','鲿':' cháng','鲾':' bī','鲽':' dié','鲼':' fèn','鲻':' zī','鲺':' shī','鲹':' shēn','鲸':' jīng','鲝':' zhǎ','鲛':' jiāo','鳏':' guān','鱵':' zhēn','鱿':' yóu','鱾':' jǐ','鱽':' dāo','鱼':' yú','鱻':' xiān','鱺':' lí','鱹':' guàn','鱸':' lú','鱷':' è','鱶':' xiǎng','鱴':' miè','鲁':' lǔ','鱳':' lì','鱲':' liè','鱱':' lì','鱰':' shu','鱯':' hù','鱮':' xù','鱭':' jì','鱬':' rú','鱫':' ai','鱪':' shu','鲀':' tún','鲂':' fáng','鲚':' jì','鲏':' pí','鲙':' kuài','鲘':' hòu','鲗':' zéi','鲖':' tóng','鲕':' ér','鲔':' wěi','鲓':' kǎo','鲒':' jié','鲑':' guī','鲐':' tái','鲎':' hòu','鲃':' bā','鲍':' bào','鲌':' bà','鲋':' fù','鲊':' zhǎ','鲉':' yóu','鲈':' lú','鲇':' nián','鲆':' píng','鲅':' bà','鲄':' hé','鳎':' tǎ','鳐':' yáo','鴶':' jiá','鴑':' rú','鴛':' yuān','鴚':' gē','鴙':' zhì','鴘':' biǎn','鴗':' lì','鴖':' mín','鴕':' tuó','鴔':' fú','鴓':' miè','鴒':' líng','鴐':' gē','鴝':' qú','鴏':' dài','鴎':' ōu','鴍':' wén','鴌':' fèng','鴋':' fāng','鴊':' zhèng','鴉':' yā','鴈':' yàn','鴇':' bǎo','鴆':' zhèn','鴜':' cí','鴞':' xiāo','鴄':' pǐ','鴫':' tian','鴵':' xiāo','鴴':' héng','鴳':' yàn','鴲':' zhī','鴱':' ài','鴰':' guā','鴯':' ér','鴮':' wū','鴭':' duī','鴬':' yīng','鴪':' yù','鴟':' chī','鴩':' tiě','鴨':' yā','鴧':' ròng','鴦':' yāng','鴥':' yù','鴤':' dōng','鴣':' gū','鴢':' yǎo','鴡':' jū','鴠':' dàn','鴅':' huān','鴃':' jué','鳑':' páng','鳝':' shàn','鳧':' fú','鳦':' yǐ','鳥':' niǎo','鳤':' guǎn','鳣':' zhān','鳢':' lǐ','鳡':' gǎn','鳠':' hù','鳟':' zūn','鳞':' lín','鳜':' guì','鳩':' jiū','鳛':' xí','鳚':' wèi','鳙':' yōng','鳘':' mǐn','鳗':' mán','鳖':' biē','鳕':' xuě','鳔':' biào','鳓':' lè','鳒':' jiān','鳨':' lì','鳪':' bú','鴂':' jué','鳷':' zhī','鴁':' yāo','鴀':' fǒu','鳿':' yù','鳾':' shī','鳽':' jiān','鳼':' wén','鳻':' bān','鳺':' fū','鳹':' qín','鳸':' hù','鳶':' yuān','鳫':' yàn','鳵':' bǎo','鳴':' míng','鳳':' fèng','鳲':' shī','鳱':' gān','鳰':' ru','鳯':' fèng','鳮':' jī','鳭':' diāo','鳬':' fǔ','鸆':' yú','鸈':' yè','鱨':' cháng','鼚':' chāng','鼤':' wén','鼣':' fèi','鼢':' fén','鼡':' shǔ','鼠':' shǔ','鼟':' tēng','鼞':' tāng','鼝':' yuān','鼜':' qì','鼛':' gāo','鼙':' pí','鼦':' diāo','鼘':' yuān','鼗':' táo','鼖':' fén','鼕':' dōng','鼔':' gǔ','鼓':' gǔ','鼒':' zī','鼑':' dǐng','鼐':' nài','鼏':' mì','鼥':' bá','鼧':' tuó','鼍':' tuó','鼴':' yǎn','鼾':' hān','鼽':' qiú','鼼':' yǎo','鼻':' bí','鼺':' léi','鼹':' yǎn','鼸':' xiàn','鼷':' xī','鼶':' sī','鼵':' tū','鼳':' jú','鼨':' zhōng','鼲':' hún','鼱':' jīng','鼰':' niàn','鼯':' wú','鼮':' tíng','鼭':' shí','鼬':' yòu','鼫':' shí','鼪':' shēng','鼩':' qú','鼎':' dǐng','鼌':' cháo','齀':' wù','黦':' yuè','黰':' zhěn','黯':' àn','黮':' dǎn','黭':' yǎn','黬':' yán','黫':' yān','黪':' cǎn','黩':' dú','黨':' dǎng','黧':' lí','黥':' qíng','黲':' cǎn','黤':' yǎn','黣':' měi','黢':' qū','黡':' yǎn','黠':' xiá','黟':' yī','點':' diǎn','黝':' yǒu','黜':' chù','黛':' dài','黱':' dài','黳':' yī','鼋':' yuán','鼀':' cù','鼊':' bì','鼉':' tuó','鼈':' biē','鼇':' áo','鼆':' méng','鼅':' zhī','鼄':' zhū','鼃':' wā','鼂':' cháo','鼁':' qù','黿':' yuán','黴':' méi','黾':' miǎn','黽':' miǎn','黼':' fǔ','黻':' fú','黺':' fěn','黹':' zhǐ','黸':' lú','黷':' dú','黶':' yǎn','黵':' zhǎn','鼿':' wù','齁':' hōu','黙':' mò','龂':' yín','龌':' wò','龋':' qǔ','龊':' chuò','龉':' yǔ','龈':' kěn','龇':' zī','龆':' tiáo','龅':' bāo','龄':' líng','龃':' jǔ','龁':' hé','龎':' páng','龀':' chèn','齿':' chǐ','齾':' yà','齽':' jìn','齼':' chǔ','齻':' diān','齺':' zōu','齹':' cī','齸':' yì','齷':' wò','龍':' lóng','龏':' gōng','齵':' óu','龜':' guī','鿃':' shǎn','龥':' yù','龤':' xié','龣':' jué','龢':' hé','龡':' chuì','龠':' yuè','龟':' guī','龞':' biē','龝':' qiū','龛':' kān','龐':' páng','龚':' gōng','龙':' lóng','龘':' dá','龗':' líng','龖':' dá','龕':' kān','龔':' gōng','龓':' lǒng','龒':' lóng','龑':' yǎn','齶':' è','齴':' yǎn','齂':' xiè','齎':' jī','齘':' xiè','齗':' yín','齖':' yá','齕':' hé','齔':' chèn','齓':' chèn','齒':' chǐ','齑':' jī','齐':' qí','齏':' jī','齍':' zī','齚':' zé','齌':' jì','齋':' zhāi','齊':' qí','齉':' nàng','齈':' nòng','齇':' zhā','齆':' wèng','齅':' xiù','齄':' zhā','齃':' è','齙':' bāo','齛':' xiè','齳':' yǔn','齨':' jiù','齲':' qǔ','齱':' zōu','齰':' zé','齯':' ní','齮':' yǐ','齭':' chǔ','齬':' yǔ','齫':' kǔn','齪':' chuò','齩':' yǎo','齧':' niè','齜':' chái','齦':' kěn','齥':' xiè','齤':' quán','齣':' chū','齢':' líng','齡':' líng','齠':' tiáo','齟':' jǔ','齞':' yǎn','齝':' chī','黚':' qián','默':' mò','鸉':' yáng','鹉':' wǔ','鹓':' yuān','鹒':' gēng','鹑':' chún','鹐':' qiān','鹏':' péng','鹎':' bēi','鹍':' kūn','鹌':' ān','鹋':' miáo','鹊':' què','鹈':' tí','鹕':' hú','鹇':' xián','鹆':' yù','鹅':' é','鹄':' gǔ','鹃':' juān','鹂':' lí','鹁':' bó','鹀':' wú','鸿':' hóng','鸾':' luán','鹔':' sù','鹖':' hé','鸼':' zhōu','鹣':' jiān','鹭':' lù','鹬':' yù','鹫':' jiù','鹪':' jiāo','鹩':' liáo','鹨':' liù','鹧':' zhè','鹦':' yīng','鹥':' yī','鹤':' hè','鹢':' yì','鹗':' è','鹡':' jí','鹠':' liú','鹟':' wēng','鹞':' yào','鹝':' yì','鹜':' wù','鹛':' méi','鹚':' cí','鹙':' qiū','鹘':' gǔ','鸽':' gē','鸻':' héng','鹯':' zhān','鸕':' lú','鸟':' niǎo','鸞':' luán','鸝':' lí','鸜':' qú','鸛':' guàn','鸚':' yīng','鸙':' yuè','鸘':' shuāng','鸗':' lóng','鸖':' hè','鸔':' bào','鸡':' jī','鸓':' lěi','鸒':' yù','鸑':' yuè','鸐':' dí','鸏':' méng','鸎':' yīng','鸍':' mí','鸌':' hù','鸋':' níng','鸊':' pì','鸠':' jiū','鸢':' yuān','鸺':' xiū','鸯':' yāng','鸹':' guā','鸸':' ér','鸷':' zhì','鸶':' sī','鸵':' tuó','鸴':' xué','鸳':' yuān','鸲':' qú','鸱':' chī','鸰':' líng','鸮':' xiāo','鸣':' míng','鸭':' yā','鸬':' lú','鸫':' dōng','鸪':' gū','鸩':' zhèn','鸨':' bǎo','鸧':' cāng','鸦':' yā','鸥':' ōu','鸤':' shī','鹮':' huán','鹰':' yīng','黗':' tūn','麲':' xiàn','麼':' me','麻':' má','麺':' miàn','麹':' qū','麸':' fū','麷':' fēng','麶':' chi','麵':' miàn','麴':' qū','麳':' lái','麱':' fū','麾':' huī','麰':' móu','麯':' qū','麮':' qù','麭':' pào','麬':' fū','麫':' miǎn','麪':' miàn','麩':' fū','麨':' chǎo','麧':' hé','麽':' mó','麿':' mo','麥':' mài','黌':' hóng','黖':' xì','黕':' dǎn','黔':' qián','黓':' yì','黒':' hēi','黑':' hēi','黐':' chī','黏':' nián','黎':' lí','黍':' shǔ','黋':' kuàng','黀':' zōu','黊':' huà','黉':' hóng','黈':' tǒu','黇':' tiān','黆':' guāng','黅':' jīn','黄':' huáng','黃':' huáng','黂':' fén','黁':' nún','麦':' mài','麤':' cū','鹱':' hù','鹽':' yán','麇':' jūn','麆':' zhù','麅':' páo','麄':' cū','麃':' páo','麂':' jǐ','麁':' cū','麀':' yōu','鹿':' lù','鹾':' cuó','鹼':' jiǎn','麉':' jiān','鹻':' jiǎn','鹺':' cuó','鹹':' xián','鹸':' jiǎn','鹷':' líng','鹶':' jīn','鹵':' lǔ','鹴':' shuāng','鹳':' guàn','鹲':' méng','麈':' zhǔ','麊':' mí','麣':' yán','麘':' xiāng','麢':' líng','麡':' qí','麠':' jīng','麟':' lín','麞':' zhāng','麝':' shè','麜':' lì','麛':' mí','麚':' jiā','麙':' xián','麗':' lì','麋':' mí','麖':' jīng','麕':' jūn','麔':' jiù','麓':' lù','麒':' qí','麑':' ní','麐':' lín','麏':' jūn','麎':' chén','麍':' liú','麌':' yǔ','鱩':' lei','鱧':' lǐ','館':' guǎn','騸':' shàn','驂':' cān','驁':' ào','驀':' mò','騿':' zhāng','騾':' luó','騽':' xí','騼':' lù','騻':' shuāng','騺':' zhì','騹':' lí','騷':' sāo','驄':' cōng','騶':' zōu','騵':' yuán','騴':' yàn','騳':' dú','騲':' cǎo','騱':' xí','騰':' téng','騯':' péng','騮':' liú','騭':' zhì','驃':' biāo','驅':' qū','騫':' qiān','驒':' tuó','驜':' yè','驛':' yì','驚':' jīng','驙':' zhān','驘':' luó','驗':' yàn','驖':' tiě','驕':' jiāo','驔':' diàn','驓':' céng','驑':' liú','驆':' bì','驐':' dūn','驏':' zhàn','驎':' lín','驍':' xiāo','驌':' sù','驋':' bō','驊':' huá','驉':' xū','驈':' yù','驇':' zhì','騬':' chéng','騪':' sōu','驞':' pīn','騄':' lù','騎':' qí','騍':' kè','騌':' zōng','騋':' lái','騊':' táo','騉':' kūn','騈':' pián','騇':' shè','騆':' zhōu','騅':' zhuī','騃':' ái','騐':' yàn','騂':' xīng','騁':' chěng','騀':' ě','駿':' jùn','駾':' tuì','駽':' xuān','駼':' tú','駻':' hàn','駺':' láng','駹':' máng','騏':' qí','騑':' fēi','騩':' guī','騞':' huō','騨':' tuó','騧':' guā','騦':' sī','騥':' róu','騤':' kuí','騣':' zōng','騢':' xiá','騡':' quán','騠':' tí','騟':' yú','騝':' qián','騒':' sāo','騜':' huáng','騛':' fēi','騚':' qián','騙':' piàn','騘':' cōng','騗':' piàn','騖':' wù','騕':' yǎo','騔':' gé','験':' yǎn','驝':' tuō','驟':' zhòu','駷':' sǒng','骠':' biāo','骪':' wěi','骩':' wěi','骨':' gǔ','骧':' xiāng','骦':' shuāng','骥':' jì','骤':' zhòu','骣':' chǎn','骢':' cōng','骡':' luó','骟':' shàn','骬':' yú','骞':' qiān','骝':' liú','骜':' ào','骛':' wù','骚':' sāo','骙':' kuí','骘':' zhì','骗':' piàn','骖':' cān','骕':' sù','骫':' wěi','骭':' gàn','骓':' zhuī','骺':' hóu','髄':' suǐ','髃':' yú','髂':' qià','髁':' kē','髀':' bì','骿':' pián','骾':' gěng','骽':' tuǐ','骼':' gé','骻':' kuà','骹':' qiāo','骮':' yì','骸':' hái','骷':' kū','骶':' dǐ','骵':' tǐ','骴':' cī','骳':' bèi','骲':' bào','骱':' jiè','骰':' tóu','骯':' āng','骔':' zōng','骒':' kè','驠':' yàn','马':' mǎ','驶':' shǐ','驵':' zǎng','驴':' lǘ','驳':' bó','驲':' rì','驱':' qū','驰':' chí','驯':' xún','驮':' tuó','驭':' yù','驫':' biāo','驸':' fù','驪':' lí','驩':' huān','驨':' xí','驧':' jú','驦':' shuāng','驥':' jì','驤':' xiāng','驣':' téng','驢':' lǘ','驡':' lóng','驷':' sì','驹':' jū','骑':' qí','骆':' luò','骐':' qí','骏':' jùn','骎':' qīn','骍':' xīng','验':' yàn','骋':' chěng','骊':' lí','骉':' biāo','骈':' pián','骇':' hài','骅':' huá','驺':' zōu','骄':' jiāo','骃':' yīn','骂':' mà','骁':' xiāo','骀':' dài','驿':' yì','驾':' jià','驽':' nú','驼':' tuó','驻':' zhù','駸':' qīn','駶':' jú','髆':' bó','饨':' tún','饲':' sì','饱':' bǎo','饰':' shì','饯':' jiàn','饮':' yǐn','饭':' fàn','饬':' chì','饫':' yù','饪':' rèn','饩':' xì','饧':' táng','饴':' yí','饦':' tuō','饥':' jī','饤':' dìng','饣':' shí','饢':' náng','饡':' zàn','饠':' luó','饟':' xiǎng','饞':' chán','饝':' mó','饳':' duò','饵':' ěr','饛':' méng','馂':' jùn','馌':' yè','馋':' chán','馊':' sōu','馉':' gǔ','馈':' kuì','馇':' chā','馆':' guǎn','馅':' xiàn','馄':' hún','馃':' guǒ','馁':' něi','饶':' ráo','馀':' yú','饿':' è','饾':' dòu','饽':' bō','饼':' bǐng','饻':' xī','饺':' jiǎo','饹':' le','饸':' hé','饷':' xiǎng','饜':' yàn','饚':' hài','馎':' bó','餴':' fēn','餾':' liù','餽':' kuì','餼':' xì','餻':' gāo','餺':' bó','餹':' táng','餸':' sòng','餷':' chā','餶':' gǔ','餵':' wèi','餳':' táng','饀':' táo','餲':' ài','餱':' hóu','餰':' jiān','餯':' huì','餮':' tiè','餭':' huáng','餬':' hú','餫':' yùn','餪':' nuǎn','餩':' è','餿':' sōu','饁':' yè','饙':' fēn','饎':' chì','饘':' zhān','饗':' xiǎng','饖':' wèi','饕':' tāo','饔':' yōng','饓':' chēng','饒':' ráo','饑':' jī','饐':' yì','饏':' dàn','饍':' shàn','饂':' yún','饌':' zhuàn','饋':' kuì','饊':' sǎn','饉':' jǐn','饈':' xiū','饇':' yù','饆':' bì','饅':' mán','饄':' táng','饃':' mó','馍':' mó','馏':' liú','駵':' liú','駐':' zhù','駚':' yǎng','駙':' fù','駘':' tái','駗':' zhěn','駖':' líng','駕':' jià','駔':' zǎng','駓':' pī','駒':' jū','駑':' nú','駏':' jù','駜':' bì','駎':' zhòu','駍':' péi','駌':' yuān','駋':' zhāo','駊':' pǒ','駉':' jiōng','駈':' qū','駇':' wén','駆':' qū','駅':' yì','駛':' shǐ','駝':' tuó','駃':' jué','駪':' shēn','駴':' xiè','駳':' dàn','駲':' zhou','駱':' luò','駰':' yīn','駯':' zhū','駮':' bó','駭':' hài','駬':' ěr','駫':' jiōng','駩':' quān','駞':' tuó','駨':' xūn','駧':' dòng','駦':' téng','駥':' róng','駤':' zhì','駣':' táo','駢':' pián','駡':' mà','駠':' liú','駟':' sì','駄':' tuó','駂':' bǎo','馐':' xiū','馜':' nǐ','馦':' xiān','馥':' fù','馤':' ài','馣':' ān','馢':' jiān','馡':' fēi','馠':' hān','馟':' tú','馞':' bó','馝':' bì','馛':' bó','馨':' xīn','馚':' fén','香':' xiāng','馘':' guó','馗':' kuí','首':' shǒu','馕':' náng','馔':' zhuàn','馓':' sǎn','馒':' mán','馑':' jǐn','馧':' yūn','馩':' fén','駁':' bó','馶':' zhī','駀':' yóu','馿':' lǘ','馾':' dàn','馽':' zhí','馼':' wén','馻':' yǔn','馺':' sà','馹':' rì','馸':' xìn','馷':' pèi','馵':' zhù','馪':' pīn','馴':' xún','馳':' chí','馲':' zhé','馱':' tuó','馰':' dí','馯':' hàn','馮':' féng','馭':' yù','馬':' mǎ','馫':' xīn','髅':' lóu','髇':' xiāo','鱦':' yìng','鯙':' chún','鯣':' yì','鯢':' ní','鯡':' fèi','鯠':' lái','鯟':' dōng','鯞':' zhǒu','鯝':' gù','鯜':' qiè','鯛':' diāo','鯚':' jì','鯘':' něi','鯥':' lù','鯗':' xiǎng','鯖':' zhēng','鯕':' qí','鯔':' zī','鯓':' ní','鯒':' yǒng','鯑':' xi','鯐':' zou','鯏':' li','鯎':' cheng','鯤':' kūn','鯦':' jiù','鯌':' kào','鯳':' di','鯽':' zéi','鯼':' zōng','鯻':' là','鯺':' zhū','鯹':' xīng','鯸':' hóu','鯷':' tí','鯶':' hǔn','鯵':' shēn','鯴':' shī','鯲':' yu','鯧':' chāng','鯱':' hu','鯰':' nián','鯯':' zhì','鯮':' zōng','鯭':' měng','鯬':' lí','鯫':' zōu','鯪':' líng','鯩':' lún','鯨':' jīng','鯍':' méng','鯋':' shā','鯿':' biān','鮥':' luò','鮯':' gé','鮮':' xiān','鮭':' guī','鮬':' kū','鮫':' jiāo','鮪':' wěi','鮩':' bìng','鮨':' yì','鮧':' tǐ','鮦':' tóng','鮤':' liè','鮱':' lao','鮣':' yìn','鮢':' zhū','鮡':' zhào','鮠':' wéi','鮟':' àn','鮞':' ér','鮝':' xiǎng','鮜':' hòu','鮛':' shū','鮚':' jié','鮰':' huí','鮲':' fu','鯊':' shā','鮿':' zhé','鯉':' lǐ','鯈':' tiáo','鯇':' huàn','鯆':' pū','鯅':' shān','鯄':' qiú','鯃':' wú','鯂':' su','鯁':' gěng','鯀':' gǔn','鮾':' něi','鮳':' kào','鮽':' yú','鮼':' qīn','鮻':' suō','鮺':' zhǎ','鮹':' shāo','鮸':' miǎn','鮷':' tí','鮶':' jūn','鮵':' duó','鮴':' xiu','鯾':' biān','鰀':' huàn','鮘':' dai','鱁':' zhú','鱋':' qū','鱊':' yù','鱉':' biē','鱈':' xuě','鱇':' kāng','鱆':' zhāng','鱅':' yōng','鱄':' zhuān','鱃':' xiū','鱂':' jiāng','鱀':' jì','鱍':' bō','鰿':' jì','鰾':' biào','鰽':' qiú','鰼':' xí','鰻':' mán','鰺':' shēn','鰹':' jiān','鰸':' qū','鰷':' tiáo','鰶':' jì','鱌':' xiàng','鱎':' jiǎo','鰴':' huī','鱛':' zeng','鱥':' guì','鱤':' gǎn','鱣':' zhān','鱢':' sāo','鱡':' zéi','鱠':' kuài','鱟':' hòu','鱞':' guān','鱝':' fèn','鱜':' xiang','鱚':' xǐ','鱏':' xún','鱙':' miáo','鱘':' xún','鱗':' lín','鱖':' guì','鱕':' fān','鱔':' shàn','鱓':' shàn','鱒':' zūn','鱑':' huáng','鱐':' sù','鰵':' mǐn','鰳':' lè','鰁':' quán','鰍':' qiū','鰗':' hú','鰖':' tuǒ','鰕':' xiā','鰔':' gǎn','鰓':' sāi','鰒':' fù','鰑':' yáng','鰐':' è','鰏':' bī','鰎':' jiǎn','鰌':' qiū','鰙':' ruò','鰋':' yǎn','鰊':' liàn','鰉':' huáng','鰈':' dié','鰇':' róu','鰆':' chūn','鰅':' yú','鰄':' wēi','鰃':' wēi','鰂':' zéi','鰘':' shi','鰚':' xuan','鰲':' áo','鰧':' téng','鰱':' lián','鰰':' shen','鰯':' ruò','鰮':' wēn','鰭':' qí','鰬':' qián','鰫':' yóng','鰪':' é','鰩':' yáo','鰨':' tǎ','鰦':' zī','鰛':' wēn','鰥':' guān','鰤':' shī','鰣':' shí','鰢':' mǎ','鰡':' liú','鰠':' sāo','鰟':' fáng','鰞':' wū','鰝':' hào','鰜':' qiàn','鮙':' tà','鮗':' dong','髈':' bǎng','鬈':' quán','鬒':' zhěn','鬑':' lián','鬐':' qí','鬏':' jiū','鬎':' là','鬍':' hú','鬌':' tuǒ','鬋':' jiǎn','鬊':' shùn','鬉':' zōng','鬇':' zhēng','鬔':' péng','鬆':' sōng','鬅':' péng','鬄':' dí','鬃':' zōng','鬂':' bìn','鬁':' lì','鬀':' tì','髿':' suō','髾':' shāo','髽':' zhuā','鬓':' bìn','鬕':' mà','髻':' jì','鬢':' bìn','鬬':' dòu','鬫':' hǎn','鬪':' dòu','鬩':' xì','鬨':' hòng','鬧':' nào','鬦':' dòu','鬥':' dòu','鬤':' ráng','鬣':' liè','鬡':' níng','鬖':' sān','鬠':' kuò','鬟':' huán','鬞':' náng','鬝':' qiān','鬜':' qiān','鬛':' liè','鬚':' xū','鬙':' sēng','鬘':' mán','鬗':' mán','髼':' péng','髺':' kuò','鬮':' jiū','體':' tǐ','髞':' sào','髝':' láo','髜':' qiǎo','髛':' kāo','髚':' qiào','髙':' gāo','高':' gāo','髗':' lú','髖':' kuān','髕':' bìn','髓':' suǐ','髠':' kūn','髒':' zāng','髑':' dú','髐':' xiāo','髏':' lóu','髎':' liáo','髍':' mó','髌':' bìn','髋':' kuān','髊':' cī','髉':' bó','髟':' biāo','髡':' kūn','髹':' xiū','髮':' fà','髸':' gōng','髷':' qū','髶':' róng','髵':' ér','髴':' fú','髳':' máo','髲':' bì','髱':' bào','髰':' tì','髯':' rán','髭':' zī','髢':' dí','髬':' pī','髫':' tiáo','髪':' fà','髩':' bìn','髨':' kūn','髧':' dàn','髦':' máo','髥':' rán','髤':' xiū','髣':' fǎng','鬭':' dòu','鬯':' chàng','鮖':' shi','魱':' hú','魻':' xiá','魺':' hé','魹':' mo','魸':' pian','魷':' yóu','魶':' nà','魵':' fén','魴':' fáng','魳':' zā','魲':' lú','魰':' wén','魽':' hán','魯':' lǔ','魮':' pí','魭':' yuán','魬':' bǎn','魫':' shěn','魪':' jiè','魩':' mò','魨':' tún','魧':' háng','魦':' shā','魼':' qū','魾':' pī','魤':' é','鮋':' yóu','鮕':' gū','鮔':' jù','鮓':' zhǎ','鮒':' fù','鮑':' bào','鮐':' tái','鮏':' xīng','鮎':' nián','鮍':' pī','鮌':' gǔn','鮊':' bà','魿':' líng','鮉':' diāo','鮈':' jū','鮇':' wèi','鮆':' cǐ','鮅':' bì','鮄':' fú','鮃':' píng','鮂':' qiú','鮁':' bō','鮀':' tuó','魥':' è','魣':' xù','鬰':' yù','鬼':' guǐ','魆':' xū','魅':' mèi','魄':' pò','魃':' bá','魂':' hún','魁':' kuí','魀':' gà','鬿':' qí','鬾':' jì','鬽':' mèi','鬻':' yù','魈':' xiāo','鬺':' shāng','鬹':' guī','鬸':' liù','鬷':' zōng','鬶':' guī','鬵':' qín','鬴':' fǔ','鬳':' yàn','鬲':' gé','鬱':' yù','魇':' yǎn','魉':' liǎng','魢':' jǐ','魗':' chǒu','魡':' diào','魠':' tuō','魟':' hóng','魞':' ba','魝':' jié','魜':' rén','魛':' dāo','魚':' yú','魙':' zhān','魘':' yǎn','魖':' xū','魊':' yù','魕':' jǐ','魔':' mó','魓':' bì','魒':' piāo','魑':' chī','魐':' gān','魏':' wèi','魎':' liǎng','魍':' wǎng','魌':' qī','魋':' tuí','銦':' yīn','銤':' mǐ','薢':' xiè','觳':' hú','觽':' xī','觼':' jué','觻':' lì','觺':' yí','觹':' xī','觸':' chù','觷':' xué','觶':' zhì','觵':' gōng','觴':' shāng','觲':' xīng','觿':' xī','觱':' bì','觰':' zhā','觯':' zhì','觮':' lù','觭':' jī','觬':' ní','觫':' sù','觪':' xīng','觩':' qiú','觨':' hùn','觾':' yàn','言':' yán','触':' chù','訍':' chài','託':' tuō','訖':' qì','訕':' shàn','訔':' yín','訓':' xùn','訒':' rèn','訑':' yí','訐':' jié','訏':' xū','討':' tǎo','訌':' hòng','訁':' yán','訋':' diào','訊':' xùn','訉':' fān','計':' jì','訇':' hōng','訆':' jiào','訅':' qiú','訄':' qiú','訃':' fù','訂':' dìng','觧':' jiě','觥':' gōng','訙':' xùn','覿':' dí','觉':' jué','览':' lǎn','觇':' chān','视':' shì','觅':' mì','规':' guī','觃':' yàn','观':' guān','见':' jiàn','觀':' guān','覾':' shěn','觋':' xí','覽':' lǎn','覼':' luó','覻':' qū','覺':' jué','覹':' wéi','覸':' jiān','覷':' qù','覶':' luó','覵':' jiàn','覴':' dēng','觊':' jì','觌':' dí','觤':' guǐ','觙':' jí','解':' jiě','觢':' shì','觡':' gé','觠':' quán','觟':' huà','觞':' shāng','觝':' dǐ','觜':' zī','觛':' dàn','觚':' gū','觘':' chào','觍':' tiǎn','觗':' zhì','觖':' jué','觕':' cū','觔':' jīn','觓':' qiú','角':' jiǎo','觑':' qù','觐':' jìn','觏':' gòu','觎':' yú','記':' jì','訚':' yín','覲':' jìn','詛':' zǔ','詥':' hé','詤':' huǎng','詣':' yì','詢':' xún','詡':' xǔ','詠':' yǒng','詟':' zhé','詞':' cí','詝':' zhǔ','詜':' tāo','詚':' dá','詧':' chá','詙':' bá','詘':' qū','詗':' xiòng','詖':' bì','評':' píng','詔':' zhào','詓':' qǔ','詒':' yí','詑':' yí','詐':' zhà','試':' shì','詨':' xiào','詎':' jù','詵':' shēn','詿':' guà','詾':' xiōng','詽':' yán','詼':' huī','詻':' è','詺':' mìng','詹':' zhān','詸':' mí','詷':' tóng','詶':' zhòu','詴':' wēi','詩':' shī','詳':' xiáng','該':' gāi','話':' huà','詰':' jié','詯':' huì','詮':' quán','詭':' guǐ','詬':' gòu','詫':' chà','詪':' hěn','詏':' yào','詍':' yì','訛':' é','訧':' yóu','許':' xǔ','訰':' zhùn','訯':' sǎ','訮':' xiān','設':' shè','訬':' chāo','訫':' xìn','訪':' fǎng','訩':' xiōng','訨':' zhǐ','訦':' chén','訳':' yì','訥':' nè','訤':' xiáo','訣':' jué','訢':' xīn','訡':' yín','訠':' shěn','訟':' sòng','訞':' yāo','訝':' yà','訜':' fēn','訲':' yì','訴':' sù','詌':' gàn','詁':' gǔ','詋':' zhòu','詊':' pàn','詉':' náo','詈':' lì','詇':' yàng','詆':' dǐ','詅':' líng','詄':' dié','詃':' jiǎn','詂':' fù','詀':' zhān','訵':' chī','訿':' zǐ','訾':' zī','訽':' gòu','証':' zhèng','註':' zhù','診':' zhěn','訹':' xù','訸':' hé','訷':' shēn','訶':' hē','観':' guān','覱':' zhàn','誁':' bìng','褣':' róng','褭':' niǎo','褬':' sǎng','褫':' chǐ','褪':' tuì','褩':' bān','褨':' suǒ','褧':' jiǒng','褦':' nài','褥':' rù','褤':' yuàn','褢':' huái','褯':' jiè','褡':' dā','褠':' gōu','褟':' tā','褞':' yǔn','褝':' dān','褜':' pao','褛':' lǚ','褚':' chǔ','褙':' bèi','褘':' huī','褮':' yīng','褰':' qiān','褖':' tuàn','褽':' wèi','襇':' jiǎn','襆':' fú','襅':' bi','襄':' xiāng','襃':' bāo','襂':' sēn','襁':' qiǎng','襀':' jī','褿':' cáo','褾':' biǎo','褼':' xiān','褱':' huái','褻':' xiè','褺':' diē','褹':' yì','褸':' lǚ','褷':' shī','褶':' zhě','褵':' lí','褴':' lán','褳':' lián','褲':' kù','褗':' yǎn','褕':' yú','襉':' jiǎn','裯':' chóu','裹':' guǒ','裸':' luǒ','裷':' yuān','裶':' fēi','裵':' péi','裴':' péi','裳':' shang','裲':' liǎng','裱':' biǎo','裰':' duō','裮':' chāng','裻':' dú','裭':' chǐ','裬':' líng','裫':' yuàn','裪':' táo','裩':' kūn','裨':' bì','裧':' chān','裦':' fóu','裥':' jiǎn','裤':' kù','裺':' yǎn','裼':' tì','褔':' fù','褉':' xiè','褓':' bǎo','褒':' bāo','褑':' yuàn','褐':' hè','褏':' xiù','褎':' xiù','褍':' duān','褌':' kūn','褋':' dié','褊':' biǎn','褈':' chóng','製':' zhì','複':' fù','褆':' tí','褅':' tì','褄':' qi','褃':' kèn','褂':' guà','褁':' zhí','褀':' jì','裿':' yǐ','裾':' jū','襈':' zhuàn','襊':' cuì','覰':' qū','見':' jiàn','覕':' miè','覔':' mì','覓':' mì','覒':' mào','覑':' piǎn','覐':' jué','規':' guī','覎':' yàn','覍':' biàn','覌':' guān','覊':' jī','覗':' sì','覉':' jī','覈':' hé','覇':' bà','覆':' fù','覅':' fiào','覄':' fu','覃':' tán','覂':' fěng','要':' yào','覀':' xī','視':' shì','覘':' chān','襾':' yà','覥':' tiǎn','覯':' gòu','覮':' yíng','覭':' míng','覬':' jì','覫':' pǎng','親':' qīn','覩':' dǔ','覨':' è','覧':' lǎn','覦':' yú','覤':' xì','覙':' luó','覣':' wēi','覢':' shǎn','覡':' xí','覠':' jūn','覟':' zhì','覞':' yào','覝':' lián','覜':' tiào','覛':' mì','覚':' jué','西':' xī','襽':' lan','襋':' jí','襗':' zé','襡':' shǔ','襠':' dāng','襟':' jīn','襞':' bì','襝':' liǎn','襜':' chān','襛':' nóng','襚':' suì','襙':' cào','襘':' guì','襖':' ǎo','襣':' bì','襕':' lán','襔':' mǎn','襓':' ráo','襒':' bié','襑':' xín','襐':' xiàng','襏':' bó','襎':' fán','襍':' zá','襌':' dān','襢':' tǎn','襤':' lán','襼':' yì','襱':' lóng','襻':' pàn','襺':' jiǎn','襹':' shī','襸':' zàn','襷':' ju','襶':' dài','襵':' zhě','襴':' lán','襳':' xiān','襲':' xí','襰':' lài','襥':' pú','襯':' chèn','襮':' bó','襭':' xié','襬':' bǎi','襫':' shì','襪':' wà','襩':' shǔ','襨':' dùi','襧':' zhǐ','襦':' rú','誀':' èr','誂':' tiǎo','裢':' lián','讔':' yǐn','讞':' yàn','讝':' zhán','讜':' dǎng','讛':' yì','讚':' zàn','讙':' huān','讘':' niè','讗':' xié','讖':' chèn','讕':' lán','讓':' ràng','讠':' yán','讒':' chán','讑':' yào','讐':' chóu','讏':' wèi','讎':' chóu','讍':' è','讌':' yàn','讋':' zhé','變':' biàn','讉':' yí','讟':' dú','计':' jì','讇':' chǎn','议':' yì','许':' xǔ','讷':' nè','讶':' yà','讵':' jù','讴':' ōu','讳':' huì','讲':' jiǎng','讱':' rèn','记':' jì','讯':' xùn','训':' xùn','订':' dìng','讬':' tuō','讫':' qì','讪':' shàn','让':' ràng','讨':' tǎo','讧':' hòng','讦':' jié','讥':' jī','认':' rèn','讣':' fù','讈':' lì','讆':' wèi','论':' lùn','譠':' tán','譪':' ài','譩':' yī','譨':' náng','譧':' zhàn','警':' jǐng','譥':' jiào','譤':' jī','譣':' xiǎn','譢':' suì','譡':' dǎng','譟':' zào','譬':' pì','譞':' xuān','譝':' shéng','譜':' pǔ','譛':' zèn','譚':' tán','譙':' qiào','識':' shí','譗':' zhá','譖':' zèn','譕':' wú','譫':' zhān','譭':' huǐ','讅':' shěn','譺':' ài','讄':' lěi','讃':' zàn','讂':' xuàn','讁':' zhé','讀':' dú','譿':' huì','譾':' jiǎn','譽':' yù','譼':' jiàn','譻':' yīng','譹':' háo','譮':' huà','譸':' zhōu','護':' hù','譶':' tà','譵':' zhuì','譴':' qiǎn','譳':' nòu','譲':' ràng','譱':' shàn','議':' yì','譯':' yì','讹':' é','讻':' xiōng','譓':' huì','诼':' zhuó','谆':' zhūn','谅':' liàng','谄':' chǎn','调':' diào','谂':' shěn','谁':' shuí','谀':' yú','诿':' wěi','课':' kè','诽':' fěi','读':' dú','谈':' tán','诺':' nuò','诹':' zōu','诸':' zhū','请':' qǐng','诶':' éi','诵':' sòng','说':' shuō','诳':' kuáng','诲':' huì','诱':' yòu','谇':' suì','谉':' shěn','误':' wù','谖':' xuān','谠':' dǎng','谟':' mó','谞':' xū','谝':' piǎn','谜':' mí','谛':' dì','谚':' yàn','谙':' ān','谘':' zī','谗':' chán','谕':' yù','谊':' yì','谔':' è','谓':' wèi','谒':' yè','谑':' xuè','谐':' xié','谏':' jiàn','谎':' huǎng','谍':' dié','谌':' chén','谋':' móu','诰':' gào','诮':' qiào','讼':' sòng','诈':' zhà','诒':' yí','译':' yì','诐':' bì','诏':' zhào','诎':' qū','词':' cí','诌':' zhōu','诋':' dǐ','诊':' zhěn','诉':' sù','诇':' xiòng','诔':' lěi','识':' shí','诅':' zǔ','评':' píng','诃':' hē','诂':' gǔ','证':' zhèng','诀':' jué','访':' fǎng','设':' shè','讽':' fěng','诓':' kuāng','试':' shì','语':' yǔ','殕':' fǒu','诬':' wū','诫':' jiè','诪':' zhōu','诩':' xǔ','诨':' hùn','诧':' chà','详':' xiáng','该':' gāi','诤':' zhēng','诣':' yì','诡':' guǐ','诖':' guà','诠':' quán','诟':' gòu','诞':' dàn','话':' huà','诜':' shēn','诛':' zhū','诚':' chéng','诙':' huī','诘':' jí','诗':' shī','譔':' zhuàn','譒':' bò','誃':' yí','諃':' chēn','諍':' zhèng','諌':' dǒng','請':' qǐng','諊':' jú','諉':' wěi','諈':' zhuì','談':' tán','諆':' qī','諅':' jì','諄':' zhūn','諂':' chǎn','諏':' zōu','諁':' zhuó','諀':' pǐ','調':' diào','誾':' yín','誽':' nì','誼':' yì','誻':' tà','誺':' chī','誹':' fěi','誸':' xián','諎':' zé','諐':' qiān','誶':' suì','諝':' xū','諧':' xié','諦':' dì','諥':' zhòng','諤':' è','諣':' huà','諢':' hùn','諡':' shì','諠':' xuān','諟':' shì','諞':' piǎn','諜':' dié','諑':' zhuó','諛':' yú','諚':' pián','諙':' huài','諘':' biǎo','諗':' shěn','論':' lùn','諕':' háo','諔':' chù','諓':' jiàn','諒':' liàng','誷':' wǎng','誵':' xiáo','諩':' pǔ','誏':' lǎng','誙':' kēng','誘':' yòu','誗':' chán','誖':' bèi','誕':' dàn','誔':' tǐng','誓':' shì','誒':' éi','誑':' kuáng','誐':' é','誎':' cù','誛':' qīn','認':' rèn','誌':' zhì','誋':' jì','誊':' téng','誉':' yù','誈':' wú','誇':' kuā','誆':' kuāng','誅':' zhū','誄':' lěi','誚':' qiào','誜':' shuà','誴':' cóng','誩':' jìng','誳':' qū','課':' kè','誱':' jié','誰':' shuí','誯':' chàng','誮':' hua','読':' dú','説':' shuō','誫':' zhèn','說':' shuō','誨':' huì','誝':' ān','誧':' bū','誦':' sòng','誥':' gào','誤':' wù','誣':' wū','誢':' xiàn','誡':' jiè','誠':' chéng','誟':' xiào','語':' yǔ','諨':' fú','諪':' tíng','譑':' jiǎo','謬':' miù','謶':' zhuó','謵':' xí','謴':' gùn','謳':' ōu','謲':' càn','謱':' lóu','謰':' lián','謯':' jiē','謮':' zé','謭':' jiǎn','謫':' zhé','謸':' áo','謪':' shāng','謩':' mò','謨':' mó','謧':' lí','謦':' qìng','謥':' còng','謤':' biāo','謣':' yú','謢':' zhi','謡':' yáo','謷':' áo','謹':' jǐn','謟':' tāo','譆':' xī','譐':' zǔn','譏':' jī','譎':' jué','譍':' yīng','譌':' é','譋':' lán','譊':' náo','證':' zhèng','譈':' duì','譇':' zhā','譅':' sè','謺':' zhé','譄':' zēng','譃':' xū','譂':' chǎn','譁':' huá','譀':' hàn','謿':' cháo','謾':' mán','謽':' jiàng','謼':' hū','謻':' yí','謠':' yáo','謞':' hè','諫':' jiàn','諷':' fěng','謁':' yè','謀':' móu','諿':' qī','諾':' nuò','諽':' gé','諼':' xuān','諻':' huáng','諺':' yàn','諹':' yáng','諸':' zhū','諶':' chén','謃':' xing','諵':' nán','諴':' xián','諳':' ān','諲':' yīn','諱':' huì','諰':' xǐ','諯':' zhuān','諮':' zī','諭':' yù','諬':' qǐ','謂':' wèi','謄':' téng','謝':' xiè','謒':' qiāng','謜':' yuán','講':' jiǎng','謚':' shì','謙':' qiān','謘':' chí','謗':' bàng','謖':' sù','謕':' tí','謔':' xuè','謓':' chēn','謑':' xǐ','謅':' zhōu','謐':' mì','謏':' xiǎo','謎':' mí','謍':' yíng','謌':' gē','謋':' huò','謊':' huǎng','謉':' kuì','謈':' pó','謇':' jiǎn','謆':' shàn','裣':' liǎn','裡':' lǐ','谢':' xiè','蚲':' píng','蚼':' gǒu','蚻':' zhá','蚺':' rán','蚹':' fù','蚸':' lì','蚷':' jù','蚶':' hān','蚵':' hé','蚴':' yòu','蚳':' chí','蚱':' zhà','蚾':' pí','蚰':' yóu','蚯':' qiū','蚮':' tè','蚭':' ní','蚬':' xiǎn','蚫':' bào','蚪':' dǒu','蚩':' chī','蚨':' fú','蚧':' jiè','蚽':' pí','蚿':' xián','蚥':' fù','蛌':' gǔ','蛖':' máng','蛕':' huí','蛔':' huí','蛓':' cì','蛒':' gé','蛑':' móu','蛐':' qū','蛏':' chēng','蛎':' lì','蛍':' yíng','蛋':' dàn','蛀':' zhù','蛊':' gǔ','蛉':' líng','蛈':' tiě','蛇':' shé','蛆':' qū','蛅':' zhān','蛄':' gū','蛃':' bǐng','蛂':' bié','蛁':' diāo','蚦':' rán','蚤':' zǎo','蛘':' yáng','虾':' xiā','蚈':' qiān','蚇':' chǐ','蚆':' bā','蚅':' è','蚄':' fāng','蚃':' xiàng','蚂':' mǎ','蚁':' yǐ','蚀':' shí','虿':' chài','虽':' suī','蚊':' wén','虼':' gè','虻':' méng','虺':' huī','虹':' hóng','虸':' zǐ','虷':' hán','虶':' yū','虵':' shé','虴':' zhé','虳':' jué','蚉':' wén','蚋':' ruì','蚣':' gōng','蚘':' huí','蚢':' háng','蚡':' fén','蚠':' fén','蚟':' wáng','蚞':' mù','蚝':' háo','蚜':' yá','蚛':' zhòng','蚚':' qí','蚙':' qín','蚗':' jué','蚌':' bàng','蚖':' yuán','蚕':' cán','蚔':' qí','蚓':' yǐn','蚒':' tóng','蚑':' qí','蚐':' jūn','蚏':' yuè','蚎':' yuè','蚍':' pí','蛗':' fù','蛙':' wā','虱':' shī','蜚':' fēi','蜤':' sī','蜣':' qiāng','蜢':' měng','蜡':' là','蜠':' jùn','蜟':' yù','蜞':' qí','蜝':' qí','蜜':' mì','蜛':' jū','蜙':' sōng','蜦':' lún','蜘':' zhī','蜗':' wō','蜖':' huí','蜕':' tuì','蜔':' diàn','蜓':' tíng','蜒':' yán','蜑':' dàn','蜐':' jié','蜏':' yǒu','蜥':' xī','蜧':' lì','蜍':' chú','蜴':' yì','蜾':' guǒ','蜽':' liǎng','蜼':' wèi','蜻':' qīng','蜺':' ní','蜹':' ruì','蜸':' qiǎn','蜷':' quán','蜶':' suò','蜵':' yuān','蜳':' dūn','蜨':' dié','蜲':' wēi','蜱':' pí','蜰':' féi','蜯':' bàng','蜮':' yù','蜭':' hàn','蜬':' hán','蜫':' kūn','蜪':' táo','蜩':' tiáo','蜎':' yuān','蜌':' bì','蛚':' liè','蛦':' yí','蛰':' zhé','蛯':' lao','蛮':' mán','蛭':' zhì','蛬':' qióng','蛫':' guǐ','蛪':' qiè','蛩':' qióng','蛨':' mò','蛧':' wǎng','蛥':' shé','蛲':' náo','蛤':' há','蛣':' qī','蛢':' píng','蛡':' yì','蛠':' lì','蛟':' jiāo','蛞':' kuò','蛝':' xián','蛜':' yī','蛛':' zhū','蛱':' jiá','蛳':' sī','蜋':' láng','蜀':' shǔ','蜊':' lí','蜉':' fú','蜈':' wú','蜇':' zhē','蜆':' xiàn','蜅':' fǔ','蜄':' shèn','蜃':' shèn','蜂':' fēng','蜁':' xuán','蛿':' hàn','蛴':' qí','蛾':' é','蛽':' bài','蛼':' chē','蛻':' tuì','蛺':' jiá','蛹':' yǒng','蛸':' shāo','蛷':' qiú','蛶':' jiè','蛵':' xīng','虲':' xiā','虰':' dīng','蝀':' dōng','藢':' zhǐ','藬':' tuī','藫':' tán','藪':' sǒu','藩':' fān','藨':' biāo','藧':' huàn','藦':' mò','藥':' yào','藤':' téng','藣':' bēi','藡':' dí','藮':' qiáo','藠':' jiào','藟':' lěi','藞':' lǎ','藝':' yì','藜':' lí','藛':' xiě','藚':' xù','藙':' yì','藘':' lǘ','藗':' sù','藭':' qióng','藯':' wèi','藕':' ǒu','藼':' xuān','蘆':' lú','蘅':' héng','蘄':' qí','蘃':' ruǐ','蘂':' ruǐ','蘁':' wù','蘀':' tuò','藿':' huò','藾':' lài','藽':' qìn','藻':' zǎo','藰':' liú','藺':' lìn','藹':' ǎi','藸':' chú','藷':' shǔ','藶':' lì','藵':' bao','藴':' yùn','藳':' gǎo','藲':' ou','藱':' huì','藖':' xián','藔':' liáo','蘈':' tuí','薮':' sǒu','薸':' piáo','薷':' rú','薶':' mái','薵':' chóu','薴':' níng','薳':' wěi','薲':' pín','薱':' duì','薰':' xūn','薯':' shǔ','薭':' bai','薺':' jì','薬':' yào','薫':' xūn','薪':' xīn','薩':' sà','薨':' hōng','薧':' hāo','薦':' jiàn','薥':' shǔ','薤':' xiè','薣':' gǔ','薹':' tái','薻':' zǎo','藓':' xiǎn','藈':' kuí','藒':' qiè','藑':' qióng','藐':' miǎo','藏':' cáng','藎':' jìn','藍':' lán','藌':' mì','藋':' diào','藊':' biǎn','藉':' jí','藇':' xù','薼':' chén','藆':' jiǎn','藅':' fá','藄':' qí','藃':' xiāo','藂':' cóng','藁':' gǎo','藀':' yíng','薿':' nǐ','薾':' ěr','薽':' zhēn','蘇':' sū','蘉':' méng','虯':' qiú','虊':' luán','虔':' qián','虓':' xiāo','虒':' sī','虑':' lǜ','虐':' nüè','虏':' lǔ','虎':' hǔ','虍':' hū','虌':' biē','虋':' mén','虉':' yì','虖':' hū','虈':' xiāo','虇':' quǎn','虆':' léi','虅':' teng','虄':' sà','虃':' jiān','虂':' lù','虁':' kuí','虀':' jī','蘿':' luó','處':' chù','虗':' xū','蘽':' lěi','虤':' yán','虮':' jǐ','虭':' diāo','虬':' qiú','虫':' chóng','虪':' shù','虩':' xì','虨':' bīn','虧':' kuī','虦':' zhàn','虥':' zhàn','虣':' bào','虘':' cuó','虢':' guó','虡':' jù','虠':' jiāo','號':' hào','虞':' yú','虝':' hǔ','虜':' lǔ','虛':' xū','虚':' xū','虙':' fú','蘾':' huài','蘼':' mí','蘊':' yùn','蘖':' niè','蘠':' qiáng','蘟':' yǐn','蘞':' liǎn','蘝':' liàn','蘜':' jú','蘛':' yú','蘚':' xiǎn','蘙':' yì','蘘':' ráng','蘗':' bò','蘕':' feng','蘢':' lóng','蘔':' jiōng','蘓':' sū','蘒':' qiu','蘑':' mó','蘐':' xuān','蘏':' jiōng','蘎':' jì','蘍':' xūn','蘌':' yǔ','蘋':' píng','蘡':' yīng','蘣':' tǒu','蘻':' jì','蘰':' man','蘺':' lí','蘹':' huái','蘸':' zhàn','蘷':' kuí','蘶':' wèi','蘵':' zhī','蘴':' fēng','蘳':' huī','蘲':' léi','蘱':' lèi','蘯':' dàng','蘤':' wěi','蘮':' jì','蘭':' lán','蘬':' kuī','蘫':' hàn','蘪':' méi','蘩':' fán','蘨':' yáo','蘧':' qú','蘦':' líng','蘥':' yuè','蜿':' wān','蝁':' è','裠':' qún','術':' shù','衝':' chōng','衜':' dào','衛':' wèi','衚':' hú','衙':' yá','衘':' xián','街':' jiē','衖':' xiàng','衕':' tòng','衔':' xián','衒':' xuàn','衟':' dào','衑':' líng','衐':' qu','衏':' yuàn','衎':' kàn','衍':' yǎn','行':' xíng','衋':' xì','衊':' miè','衉':' kā','衈':' èr','衞':' wèi','衠':' zhūn','衆':' zhòng','衭':' fū','衷':' zhōng','衶':' zhòng','衵':' yì','衴':' dǎn','衳':' zhōng','衲':' nà','衱':' jié','衰':' shuāi','衯':' fēn','衮':' gǔn','衬':' chèn','衡':' héng','衫':' shān','衪':' yí','衩':' chǎ','表':' biǎo','衧':' yú','衦':' gǎn','补':' bǔ','衤':' yī','衣':' yī','衢':' qú','衇':' mài','衅':' xìn','衹':' zhǐ','蠟':' là','蠩':' zhū','蠨':' xiāo','蠧':' dù','蠦':' lú','蠥':' niè','蠤':' qiū','蠣':' lì','蠢':' chǔn','蠡':' lí','蠠':' mǐn','蠞':' jié','蠫':' lì','蠝':' léi','蠜':' fán','蠛':' miè','蠚':' hē','蠙':' pín','蠘':' jié','蠗':' zhuó','蠖':' huò','蠕':' rú','蠔':' háo','蠪':' lóng','蠬':' lóng','衄':' nǜ','蠹':' dù','衃':' pēi','衂':' niù','衁':' huāng','血':' xuè','蠿':' zhuō','蠾':' zhú','蠽':' jié','蠼':' qú','蠻':' mán','蠺':' cán','蠸':' quán','蠭':' fēng','蠷':' qú','蠶':' cán','蠵':' xī','蠴':' shu','蠳':' yīng','蠲':' juān','蠱':' gǔ','蠰':' náng','蠯':' bèng','蠮':' yē','衸':' jiè','衺':' xié','蠒':' jiǎn','袻':' ér','装':' zhuāng','裄':' xing','裃':' ka','裂':' liè','裁':' cái','裀':' yīn','袿':' guī','袾':' zhū','袽':' rú','袼':' gē','袺':' jié','裇':' xū','袹':' bó','袸':' jiàn','袷':' jiá','袶':' jiàng','袵':' rèn','袴':' kù','袳':' chǐ','袲':' chǐ','袱':' fú','袰':' bō','裆':' dāng','裈':' kūn','袮':' ni','裕':' yù','裟':' shā','裞':' shuì','裝':' zhuāng','補':' bǔ','裛':' yì','裚':' jì','裙':' qún','裘':' qiú','裗':' liú','裖':' zhěn','裔':' yì','裉':' kèn','裓':' gé','裒':' póu','裑':' shēn','裐':' juān','裏':' lǐ','裎':' chéng','裍':' kǔn','裌':' jiá','裋':' shù','裊':' niǎo','袯':' bó','袭':' xí','衻':' rán','袇':' rán','袑':' shào','袐':' bì','袏':' zuò','袎':' yào','袍':' páo','袌':' bào','袋':' dài','袊':' lǐng','袉':' tuó','袈':' jiā','袆':' huī','袓':' jù','袅':' niǎo','袄':' ǎo','袃':' chài','袂':' mèi','袁':' yuán','袀':' jūn','衿':' jīn','衾':' qīn','衽':' rèn','衼':' zhī','袒':' tǎn','袔':' hè','袬':' gǔn','袡':' rán','被':' bèi','袪':' qū','袩':' zhé','袨':' xuàn','袧':' gōu','袦':' nà','袥':' tuō','袤':' mào','袣':' yì','袢':' pàn','袠':' zhì','袕':' xué','袟':' zhì','袞':' gǔn','袝':' fù','袜':' wà','袛':' dī','袚':' bō','袙':' pà','袘':' yí','袗':' zhěn','袖':' xiù','蠓':' měng','蠑':' róng','蝂':' bǎn','螂':' láng','螌':' bān','螋':' sōu','螊':' lián','螉':' wēng','螈':' yuán','螇':' xī','螆':' cì','螅':' xī','螄':' sī','螃':' páng','螁':' ban','螎':' róng','螀':' jiāng','蝿':' yíng','蝾':' róng','蝽':' chūn','蝼':' lóu','蝻':' nǎn','蝺':' qǔ','蝹':' yūn','蝸':' wō','蝷':' lì','融':' róng','螏':' jí','蝵':' qiū','螜':' hú','螦':' sao','螥':' cāng','螤':' zhōng','螣':' tè','螢':' yíng','螡':' wén','螠':' yì','螟':' míng','螞':' mǎ','螝':' guī','螛':' hé','螐':' wū','螚':' nài','螙':' dù','螘':' yǐ','螗':' táng','螖':' huá','螕':' bī','螔':' yí','螓':' qín','螒':' hàn','螑':' xiù','蝶':' dié','蝴':' hú','螨':' mǎn','蝎':' xiē','蝘':' yǎn','蝗':' huáng','蝖':' xuān','蝕':' shí','蝔':' jiē','蝓':' yú','蝒':' mián','蝑':' xū','蝐':' mào','蝏':' tíng','蝍':' jié','蝚':' róu','蝌':' kē','蝋':' là','蝊':' dìng','蝉':' chán','蝈':' guō','蝇':' yíng','蝆':' yǎng','蝅':' cán','蝄':' wǎng','蝃':' dì','蝙':' biān','蝛':' wēi','蝳':' dú','蝨':' shī','蝲':' là','蝱':' méng','蝰':' kuí','蝯':' yuán','蝮':' fù','蝭':' tí','蝬':' zōng','蝫':' zhū','蝪':' tāng','蝩':' chóng','蝧':' yīng','蝜':' fù','蝦':' xiā','蝥':' máo','蝤':' qiú','蝣':' yóu','蝢':' xié','蝡':' rú','蝠':' fú','蝟':' wèi','蝞':' mèi','蝝':' yuán','螧':' qi','螩':' tiao','蠐':' qí','蟫':' yín','蟵':' chu','蟴':' sī','蟳':' xún','蟲':' chóng','蟱':' wú','蟰':' xiāo','蟯':' náo','蟮':' shàn','蟭':' jiāo','蟬':' chán','蟪':' huì','蟷':' dāng','蟩':' jué','蟨':' jué','蟧':' láo','蟦':' féi','蟥':' huáng','蟤':' zhuān','蟣':' jǐ','蟢':' xǐ','蟡':' guǐ','蟠':' pán','蟶':' chēng','蟸':' lǐ','蟞':' biē','蠅':' yíng','蠏':' xiè','蠎':' mǎng','蠍':' xiē','蠌':' zé','蠋':' zhú','蠊':' lián','蠉':' xuān','蠈':' zéi','蠇':' lì','蠆':' chài','蠄':' qín','蟹':' xiè','蠃':' luǒ','蠂':' shè','蠁':' xiǎng','蠀':' cī','蟿':' qì','蟾':' chán','蟽':' dá','蟼':' jǐng','蟻':' yǐ','蟺':' shàn','蟟':' liáo','蟝':' qú','螪':' shāng','螶':' qú','蟀':' shuài','螿':' jiāng','螾':' yǐn','螽':' zhōng','螼':' qǐn','螻':' lóu','螺':' luó','螹':' jiàn','螸':' yú','螷':' pí','螵':' piāo','蟂':' xiāo','螴':' chén','螳':' táng','螲':' zhì','螱':' wèi','螰':' lù','螯':' áo','螮':' dì','螭':' chī','螬':' cáo','螫':' shì','蟁':' wén','蟃':' wàn','蟜':' jiǎo','蟑':' zhāng','蟛':' péng','蟚':' péng','蟙':' zhí','蟘':' tè','蟗':' qiū','蟖':' sī','蟕':' zuī','蟔':' mò','蟓':' xiàng','蟒':' mǎng','蟐':' chang','蟄':' zhé','蟏':' xiāo','蟎':' mǎn','蟍':' lí','蟌':' cōng','蟋':' xī','蟊':' máo','蟉':' liú','蟈':' guō','蟇':' má','蟆':' má','蟅':' zhè','谡':' sù','谣':' yáo','銣':' rú','遵':' zūn','避':' bì','遾':' shì','遽':' jù','遼':' liáo','遻':' wù','遺':' yí','遹':' yù','選':' xuǎn','遷':' qiān','遶':' rào','遴':' lín','邁':' mài','遳':' cuō','遲':' chí','遱':' lóu','遰':' dì','遯':' dùn','遮':' zhē','遭':' zāo','遬':' sù','遫':' chì','遪':' cà','邀':' yāo','邂':' xiè','遨':' áo','邏':' luó','邙':' máng','邘':' yú','邗':' hán','邖':' shān','邕':' yōng','邔':' qǐ','邓':' dèng','邒':' tíng','邑':' yì','邐':' lǐ','邎':' yáo','邃':' suì','邍':' yuán','邌':' lí','邋':' lā','邊':' biān','邉':' biān','邈':' miǎo','邇':' ěr','邆':' téng','邅':' zhān','還':' hái','適':' shì','遧':' zhāng','邛':' qióng','遁':' dùn','運':' yùn','遊':' yóu','遉':' zhēn','遈':' shí','遇':' yù','遆':' tí','遅':' chí','遄':' chuán','遃':' yǎn','遂':' suì','遀':' suí','遍':' biàn','逿':' dàng','逾':' yú','逽':' nuò','逼':' bī','逻':' luó','逺':' yuǎn','逹':' dá','逸':' yì','逷':' tì','逶':' wēi','遌':' è','過':' guò','遦':' guàn','遛':' liú','遥':' yáo','遤':' ma','遣':' qiǎn','遢':' tà','遡':' sù','遠':' yuǎn','遟':' chí','遞':' dì','遝':' tà','遜':' xùn','遚':' chòu','遏':' è','遙':' yáo','遘':' gòu','遗':' yí','遖':' nan','違':' wéi','達':' dá','道':' dào','遒':' qiú','遑':' huáng','遐':' xiá','邚':' rú','邜':' wan','逴':' chuō','郝':' hǎo','郧':' yún','郦':' lì','郥':' bèi','郤':' xì','郣':' bó','郢':' yǐng','郡':' jùn','郠':' gěng','郟':' jiá','郞':' láng','郜':' gào','郩':' xiáo','郛':' fú','郚':' wú','郙':' fǔ','郘':' lǘ','郗':' xī','郖':' dòu','郕':' chéng','郔':' yán','郓':' yùn','郒':' lang','部':' bù','郪':' qī','郐':' kuài','郷':' xiāng','鄁':' bèi','鄀':' ruò','郿':' méi','郾':' yǎn','都':' dōu','郼':' yī','郻':' qiāo','郺':' yōng','郹':' jú','郸':' dān','郶':' bù','郫':' pí','郵':' yóu','郴':' chēn','郳':' ní','郲':' lái','郱':' píng','郰':' zōu','郯':' tán','郮':' zhōu','郭':' guō','郬':' qīng','郑':' zhèng','郏':' jiá','邝':' kuàng','邩':' huǒ','邳':' pī','邲':' bì','邱':' qiū','邰':' tái','邯':' hán','邮':' yóu','邭':' jù','邬':' wū','邫':' bāng','邪':' xié','邨':' cūn','邵':' shào','邧':' yuán','邦':' bāng','邥':' shěn','邤':' xīn','那':' nà','邢':' xíng','邡':' fāng','邠':' bīn','邟':' kàng','邞':' fū','邴':' bǐng','邶':' bèi','郎':' láng','郃':' hé','郍':' nuó','郌':' guī','郋':' xí','郊':' jiāo','郉':' xíng','郈':' hòu','郇':' huán','郆':' jí','郅':' zhì','郄':' qiè','郂':' gāi','邷':' wǎ','郁':' yù','郀':' kū','邿':' shī','邾':' zhū','邽':' guī','邼':' kuāng','邻':' lín','邺':' yè','邹':' zōu','邸':' dǐ','逵':' kuí','逳':' yù','鄃':' shū','辥':' xuē','辯':' biàn','辮':' biàn','辭':' cí','辬':' bān','辫':' biàn','辪':' xuē','辩':' biàn','辨':' biàn','辧':' biàn','辦':' bàn','辤':' cí','辱':' rǔ','辣':' là','辢':' là','辡':' biàn','辠':' zuì','辟':' pì','辞':' cí','辝':' cí','辜':' gū','辛':' xīn','辚':' lín','辰':' chén','農':' nóng','辘':' lù','辿':' chān','迉':' qī','迈':' mài','过':' guò','迆':' yí','迅':' xùn','迄':' qì','迃':' yū','迂':' yū','迁':' qiān','迀':' gān','达':' dá','辳':' nóng','辽':' liáo','込':' ru','辻':' shí','辺':' biān','边':' biān','辸':' réng','辷':' yi','辶':' chuò','辵':' chuò','辴':' chǎn','辙':' zhé','辗':' niǎn','迋':' wàng','轱':' gū','轻':' qīng','轺':' yáo','轹':' lì','轸':' zhěn','轷':' hū','轶':' yì','轵':' zhǐ','轴':' zhóu','轳':' lú','轲':' kē','轰':' hōng','载':' zài','软':' ruǎn','轮':' lún','轭':' è','转':' zhuǎn','轫':' rèn','轪':' dài','轩':' xuān','轨':' guǐ','轧':' yà','车':' chē','轼':' shì','轾':' zhì','辖':' xiá','辋':' wǎng','辕':' yuán','辔':' pèi','输':' shū','辒':' wēn','辑':' jí','辐':' fú','辏':' còu','辎':' zī','辍':' chuò','辌':' liáng','辊':' gǔn','轿':' jiào','辉':' huī','辈':' bèi','辇':' niǎn','辆':' liàng','辅':' fǔ','辄':' zhé','较':' jiào','辂':' lù','辁':' quán','辀':' zhōu','迊':' zā','迌':' tù','進':' jìn','逍':' xiāo','逗':' dòu','逖':' tì','逕':' jìng','途':' tú','逓':' dì','递':' dì','逑':' qiú','逐':' zhú','透':' tòu','逎':' qiú','逌':' yōu','這':' zhè','逋':' bū','逊':' xùn','选':' xuǎn','逈':' jiǒng','逇':' dùn','逆':' nì','逅':' hòu','逄':' páng','逃':' táo','适':' shì','逘':' yǐ','通':' tōng','退':' tuì','逧':' gu','週':' zhōu','逰':' yóu','逯':' lù','逮':' dǎi','逭':' huàn','逬':' bèng','逫':' jué','逪':' cuò','逩':' bèn','逨':' lái','逦':' lǐ','逛':' guàng','逥':' huí','逤':' suò','連':' lián','逢':' féng','逡':' qūn','造':' zào','速':' sù','逞':' chěng','逝':' shì','逜':' wù','送':' sòng','迿':' xùn','迍':' zhūn','这':' zhè','迣':' zhì','迢':' tiáo','迡':' nì','迠':' chè','迟':' chí','连':' lián','违':' wéi','远':' yuǎn','进':' jìn','迚':' zhong','还':' hái','迥':' jiǒng','迗':' é','迖':' dá','迕':' wù','返':' fǎn','迓':' yà','迒':' háng','近':' jìn','运':' yùn','迏':' tì','迎':' yíng','迤':' yí','迦':' jiā','迾':' liè','迳':' jìng','追':' zhuī','迼':' jié','迻':' yí','迺':' nǎi','迹':' jī','迸':' bèng','迷':' mí','迶':' yòu','迵':' dòng','迴':' huí','迲':' qu','迧':' chén','迱':' tuó','述':' shù','迯':' táo','迮':' zé','迭':' dié','迬':' zhù','迫':' pò','迪':' dí','迩':' ěr','迨':' dài','鄂':' è','鄄':' juàn','轤':' lú','鈖':' fēn','鈠':' yì','鈟':' shī','鈞':' jūn','鈝':' yín','鈜':' hóng','鈛':' guō','鈚':' pī','鈙':' qín','鈘':' jǐ','鈗':' yǔn','鈕':' niǔ','鈢':' xǐ','鈔':' chāo','鈓':' rén','鈒':' sà','鈑':' bǎn','鈐':' qián','鈏':' yǐn','鈎':' gōu','鈍':' dùn','鈌':' jué','鈋':' é','鈡':' zhōng','鈣':' gài','鈉':' nà','鈰':' shì','鈺':' yù','鈹':' pī','鈸':' bó','鈷':' gǔ','鈶':' sì','鈵':' bǐng','鈴':' líng','鈳':' kē','鈲':' gū','鈱':' mín','鈯':' tú','鈤':' rì','鈮':' nǐ','鈭':' zī','鈬':' duó','鈫':' wen','鈪':' è','鈩':' lu','鈨':' yuan','鈧':' kàng','鈦':' tài','鈥':' huǒ','鈊':' xīn','鈈':' pī','鈼':' zuó','釢':' nǎi','釬':' hàn','釫':' huá','釪':' huá','釩':' fǎn','釨':' zǐ','釧':' chuàn','釦':' kòu','釥':' qiǎo','釤':' shàn','釣':' diào','釡':' fǔ','釮':' qí','釠':' luàn','釟':' bā','釞':' zhí','針':' zhēn','釜':' fǔ','釛':' bā','釚':' qiú','釙':' pò','釘':' dīng','釗':' zhāo','釭':' gāng','釯':' máng','鈇':' fū','釼':' jiàn','鈆':' qiān','鈅':' yuè','鈄':' dǒu','鈃':' xíng','鈂':' chén','鈁':' fāng','鈀':' bǎ','釿':' jīn','釾':' yé','釽':' pì','釻':' qiu','釰':' rì','釺':' qiān','釹':' nǚ','釸':' xī','釷':' tǔ','釶':' shī','釵':' chāi','釴':' yì','釳':' xì','釲':' sì','釱':' dì','鈻':' sì','鈽':' bū','釕':' liǎo','鉾':' móu','銈':' jī','銇':' lèi','銆':' mò','銅':' tóng','銄':' xiǎng','銃':' chòng','銂':' zhōu','銁':' jūn','銀':' yín','鉿':' jiā','鉽':' shì','銊':' xù','鉼':' bǐng','鉻':' luò','鉺':' èr','鉹':' chǐ','鉸':' jiǎo','鉷':' hóng','鉶':' xíng','鉵':' tóng','鉴':' jiàn','鉳':' běi','銉':' yù','銋':' rén','鉱':' kuàng','銘':' míng','銢':' pǐ','銡':' jí','銠':' lǎo','銟':' chā','銞':' jūn','銝':' xiū','銜':' xián','銛':' xiān','銚':' yáo','銙':' kuǎ','銗':' xiàng','銌':' zùn','銖':' zhū','銕':' tiě','銔':' pī','銓':' quán','銒':' xíng','銑':' xiǎn','銐':' chì','銏':' shàn','銎':' qióng','銍':' zhì','鉲':' kǎ','鉰':' sī','鈾':' yóu','鉊':' zhāo','鉔':' zā','鉓':' chì','鉒':' zhù','鉑':' bó','鉐':' shí','鉏':' chú','鉎':' shēng','鉍':' bì','鉌':' hé','鉋':' bào','鉉':' xuàn','鉖':' tóng','鉈':' shī','鉇':' shī','鉆':' chān','鉅':' jù','鉄':' zhí','鉃':' shì','鉂':' shǐ','鉁':' zhēn','鉀':' jiǎ','鈿':' tián','鉕':' pō','鉗':' qián','鉯':' yǐ','鉤':' gōu','鉮':' huán','鉭':' tǎn','鉬':' mù','鉫':' jiā','鉪':' dì','鉩':' xǐ','鉨':' xǐ','鉧':' mǔ','鉦':' zhēng','鉥':' shù','鉣':' jié','鉘':' fú','鉢':' bō','鉡':' bàn','鉠':' yāng','鉟':' pī','鉞':' yuè','鉝':' lì','鉜':' fú','鉛':' qiān','鉚':' liǔ','鉙':' zhǎi','釖':' dāo','釔':' yǐ','鄅':' yǔ','酅':' xī','酏':' yǐ','酎':' zhòu','配':' pèi','酌':' zhuó','酋':' qiú','酊':' dīng','酉':' yǒu','酈':' lì','酇':' zàn','酆':' fēng','酄':' huān','酑':' yú','酃':' líng','酂':' cuó','酁':' chán','酀':' yàn','鄿':' jī','鄾':' yōu','鄽':' chán','鄼':' zàn','鄻':' liǎn','鄺':' kuàng','酐':' gān','酒':' jiǔ','鄸':' méng','酟':' tiān','酩':' mǐng','酨':' zài','酧':' chóu','酦':' fā','酥':' sū','酤':' gū','酣':' hān','酢':' cù','酡':' tuó','酠':' qiǎ','酞':' tài','酓':' yǎn','酝':' yùn','酜':' fu','酛':' yuan','酚':' fēn','酙':' zhēn','酘':' dòu','酗':' xù','酖':' zhèn','酕':' máo','酔':' zuì','鄹':' zōu','鄷':' fēng','酫':' chuò','鄑':' zī','鄛':' cháo','鄚':' mào','鄙':' bǐ','鄘':' yōng','鄗':' hào','鄖':' yún','鄕':' xiāng','鄔':' wū','鄓':' yè','鄒':' zōu','鄐':' chù','鄝':' liǎo','鄏':' rǔ','鄎':' xī','鄍':' míng','鄌':' táng','鄋':' sōu','鄊':' xiāng','鄉':' xiāng','鄈':' kuí','鄇':' hóu','鄆':' yùn','鄜':' fū','鄞':' yín','鄶':' kuài','鄫':' zēng','鄵':' cào','鄴':' yè','鄳':' méng','鄲':' dān','鄱':' pó','鄰':' lín','鄯':' shàn','鄮':' mào','鄭':' zhèng','鄬':' wéi','鄪':' bì','鄟':' zhuān','鄩':' xún','鄨':' bì','鄧':' dèng','鄦':' xǔ','鄥':' qiāo','鄤':' màn','鄣':' zhāng','鄢':' yān','鄡':' qiāo','鄠':' hù','酪':' lào','酬':' chóu','釓':' qiú','醮':' jiào','醸':' niàng','醷':' yì','醶':' yàn','醵':' jù','醴':' lǐ','醳':' yì','醲':' nóng','醱':' fā','醰':' tán','醯':' xī','醭':' bú','醺':' xūn','醬':' jiàng','醫':' yī','醪':' láo','醩':' zāo','醨':' lí','醧':' yù','醦':' chěn','醥':' piǎo','醤':' jiàng','醣':' táng','醹':' rú','醻':' chóu','醡':' zhà','釈':' shì','釒':' jīn','金':' jīn','釐':' lí','量':' liàng','野':' yě','重':' zhòng','里':' lǐ','釋':' shì','释':' shì','釉':' yòu','采':' cǎi','醼':' yàn','釆':' biàn','釅':' yàn','釄':' mí','釃':' shāi','釂':' jiào','釁':' xìn','釀':' niàng','醿':' mí','醾':' mí','醽':' líng','醢':' hǎi','醠':' àng','酭':' yòu','酹':' lèi','醃':' yān','醂':' lǎn','醁':' lù','醀':' wéi','酿':' niàng','酾':' shāi','酽':' yàn','酼':' hǎi','酻':' zuì','酺':' pú','酸':' suān','醅':' pēi','酷':' kù','酶':' méi','酵':' jiào','酴':' tú','酳':' yìn','酲':' chéng','酱':' jiàng','酰':' xiān','酯':' zhǐ','酮':' tóng','醄':' táo','醆':' zhǎn','醟':' yòng','醔':' qiú','醞':' yùn','醝':' cuō','醜':' chǒu','醛':' quán','醚':' mí','醙':' sōu','醘':' kē','醗':' pò','醖':' yùn','醕':' chún','醓':' tǎn','醇':' chún','醒':' xǐng','醑':' xǔ','醐':' hú','醏':' dū','醎':' xián','醍':' tí','醌':' kūn','醋':' cù','醊':' zhuì','醉':' zuì','醈':' tán','轥':' lìn','轣':' lì','谤':' bàng','贴':' tiē','贾':' jiǎ','贽':' zhì','贼':' zéi','贻':' yí','贺':' hè','费':' fèi','贸':' mào','贷':' dài','贶':' kuàng','贵':' guì','贳':' shì','赀':' zī','贲':' bēn','贱':' jiàn','贰':' èr','贯':' guàn','贮':' zhù','购':' gòu','贬':' biǎn','贫':' pín','贪':' tān','贩':' fàn','贿':' huì','赁':' lìn','货':' huò','赎':' shú','赘':' zhuì','赗':' fèng','赖':' lài','赕':' dǎn','赔':' péi','赓':' gēng','赒':' zhōu','赑':' bì','赐':' cì','赏':' shǎng','赍':' jī','赂':' lù','赌':' dǔ','赋':' fù','赊':' shē','赉':' lài','赈':' zhèn','赇':' qiú','赆':' jìn','赅':' gāi','资':' zī','赃':' zāng','质':' zhì','账':' zhàng','赚':' zhuàn','贀':' yì','贊':' zàn','贉':' dàn','贈':' zèng','贇':' yūn','贆':' biāo','贅':' zhuì','贄':' zhì','贃':' wàn','贂':' chěn','贁':' bài','賿':' liáo','贌':' pu','賾':' zé','賽':' sài','購':' gòu','賻':' fù','賺':' zhuàn','賹':' yì','賸':' shèng','賷':' jī','賶':' càng','賵':' fèng','贋':' yàn','贍':' shàn','败':' bài','贚':' lòng','贤':' xián','责':' zé','财':' cái','贡':' gòng','贠':' yuán','负':' fù','贞':' zhēn','贝':' bèi','贜':' zāng','贛':' gàn','贙':' xuàn','贎':' wàn','贘':' shǎng','贗':' yàn','贖':' shú','贕':' dú','贔':' bì','贓':' zāng','贒':' xián','贑':' gàn','贐':' jìn','贏':' yíng','赙':' fù','赛':' sài','賳':' zāi','趜':' jú','趦':' zī','趥':' qiū','趤':' dàng','趣':' qù','趢':' lù','趡':' cuǐ','趠':' chuò','趟':' tàng','趞':' què','趝':' jiàn','趛':' yǐn','趨':' qū','趚':' sù','趙':' zhào','趘':' xí','趗':' cù','趖':' suō','趕':' gǎn','趔':' liè','趓':' duǒ','趒':' tiáo','趑':' zī','趧':' tí','趩':' chì','趏':' guā','趶':' kù','跀':' yuè','趿':' tā','趾':' zhǐ','趽':' fàng','趼':' jiǎn','趻':' chěn','趺':' fū','趹':' jué','趸':' dǔn','趷':' kē','趵':' bào','趪':' huáng','趴':' pā','足':' zú','趲':' zǎn','趱':' zǎn','趰':' ěr','趯':' tì','趮':' zào','趭':' jiào','趬':' qiāo','趫':' qiáo','趐':' xuè','趎':' chú','赜':' zé','赨':' tóng','赲':' lì','赱':' zǒu','走':' zǒu','赯':' táng','赮':' xiá','赭':' zhě','赬':' chēng','赫':' hè','赪':' chēng','赩':' xì','赧':' nǎn','赴':' fù','赦':' shè','赥':' xī','赤':' chì','赣':' gàn','赢':' yíng','赡':' shàn','赠':' zèng','赟':' yūn','赞':' zàn','赝':' yàn','赳':' jiū','赵':' zhào','趍':' chí','趂':' chèn','趌':' jí','趋':' qū','越':' yuè','趉':' jué','趈':' zhān','趇':' xì','趆':' dī','超':' chāo','趄':' jū','趃':' dié','趁':' chèn','赶':' gǎn','趀':' cī','赿':' chí','赾':' qǐn','赽':' jué','赼':' cī','赻':' xiǎn','赺':' yǐn','赹':' qióng','赸':' shàn','起':' qǐ','賴':' lài','賲':' bǎo','跂':' qí','豤':' kěn','豮':' fén','豭':' jiā','豬':' zhū','豫':' yù','豪':' háo','豩':' bīn','豨':' xī','豧':' fū','豦':' jù','豥':' gāi','豣':' jiān','豰':' bó','豢':' huàn','象':' xiàng','豠':' chú','豟':' è','豞':' hòu','豝':' bā','豜':' jiān','豛':' yì','豚':' tún','豙':' yì','豯':' xī','豱':' wēn','豗':' huī','豾':' pī','貈':' hé','貇':' kūn','貆':' huán','貅':' xiū','貄':' sì','貃':' mò','貂':' diāo','貁':' yòu','貀':' nà','豿':' gǒu','豽':' nà','豲':' huán','豼':' pí','豻':' àn','豺':' chái','豹':' bào','豸':' zhì','豷':' yì','豶':' fén','豵':' zōng','豴':' dí','豳':' bīn','豘':' tún','豖':' chù','貊':' mò','谰':' lán','谺':' xiā','谹':' hóng','谸':' qiān','谷':' gǔ','谶':' chèn','谵':' zhān','谴':' qiǎn','谳':' yàn','谲':' jué','谱':' pǔ','谯':' qiáo','谼':' hóng','谮':' zèn','谭':' tán','谬':' miù','谫':' jiǎn','谪':' zhé','谩':' mán','谨':' jǐn','谧':' mì','谦':' qiān','谥':' shì','谻':' jí','谽':' hān','豕':' shǐ','豊':' lǐ','豔':' yàn','豓':' yàn','豒':' zhì','豑':' zhì','豐':' fēng','豏':' xiàn','豎':' shù','豍':' bī','豌':' wān','豋':' dēng','豉':' shì','谾':' hōng','豈':' qǐ','豇':' jiāng','豆':' dòu','豅':' lóng','豄':' dú','豃':' hǎn','豂':' liáo','豁':' huō','豀':' xī','谿':' xī','貉':' háo','貋':' hàn','賱':' yǔn','賌':' gài','賖':' shē','賕':' qiú','賔':' bīn','賓':' bīn','賒':' shē','賑':' zhèn','賐':' xùn','賏':' yīng','賎':' jiàn','賍':' zāng','賋':' jiǎo','賘':' zāng','賊':' zéi','賉':' xù','賈':' jiǎ','資':' zī','賆':' pián','賅':' gāi','賄':' huì','賃':' lìn','賂':' lù','賁':' bì','賗':' chuàn','賙':' zhōu','貿':' mào','賦':' fù','賰':' chǔn','賯':' xiōng','賮':' jìn','賭':' dǔ','賬':' zhàng','賫':' jī','質':' zhì','賩':' cóng','賨':' cóng','賧':' tàn','賥':' suì','賚':' lài','賤':' jiàn','賣':' mài','賢':' xián','賡':' gēng','賠':' péi','賟':' tiǎn','賞':' shǎng','賝':' chēn','賜':' cì','賛':' zàn','賀':' hè','貾':' chí','貌':' mào','貘':' mò','貢':' gòng','財':' cái','負':' fù','貟':' yuán','貞':' zhēn','貝':' bèi','貜':' jué','貛':' huān','貚':' tán','貙':' chū','貗':' jù','貤':' yí','貖':' è','貕':' xī','貔':' pí','貓':' māo','貒':' tuān','貑':' jiā','貐':' yǔ','貏':' bǐ','貎':' ní','貍':' lí','貣':' tè','貥':' háng','貽':' yí','貲':' zī','貼':' tiē','費':' fèi','貺':' kuàng','貹':' shèng','貸':' dài','買':' mǎi','貶':' biǎn','貵':' piǎn','貴':' guì','貳':' èr','貱':' bì','貦':' wàn','貰':' shì','貯':' zhù','貮':' èr','貭':' zhí','責':' zé','貫':' guàn','貪':' tān','販':' fàn','貨':' huò','貧':' pín','跁':' bà','跃':' yuè','轢':' lì','軕':' shān','軟':' ruǎn','軞':' máo','軝':' qí','軜':' nà','軛':' è','軚':' dài','軙':' chén','軘':' tún','軗':' shū','軖':' kuáng','軔':' rèn','軡':' qián','軓':' fàn','軒':' xuān','軑':' dài','軐':' xìn','軏':' yuè','軎':' wèi','軍':' jūn','軌':' guǐ','軋':' yà','車':' chē','軠':' rèn','転':' zhuǎn','軈':' ying','軯':' pēng','軹':' zhǐ','軸':' zhóu','軷':' bá','軶':' è','軵':' rǒng','軴':' zhù','軳':' páo','軲':' gū','軱':' gū','軰':' bèi','軮':' yǎng','軣':' hōng','軭':' kuāng','軬':' fàn','軫':' zhěn','軪':' āo','軩':' dài','軨':' líng','軧':' dǐ','軦':' kuàng','軥':' qú','軤':' hū','軉':' yù','軇':' dào','軻':' kē','躡':' niè','身':' shēn','躪':' lìn','躩':' jué','躨':' kuí','躧':' xǐ','躦':' cuó','躥':' cuān','躤':' jiè','躣':' qú','躢':' tà','躠':' sǎ','躭':' dān','躟':' ráng','躞':' xiè','躝':' lán','躜':' zuān','躛':' wèi','躚':' xiān','躙':' lìn','躘':' lóng','躗':' wèi','躖':' duàn','躬':' gōng','躮':' fen','軆':' tǐ','躻':' kong','軅':' yan','軄':' zhí','軃':' duǒ','軂':' lào','軁':' lóu','軀':' qū','躿':' kāng','躾':' mei','躽':' yǎn','躼':' lào','躺':' tǎng','躯':' qū','躹':' jú','躸':' jī','躷':' ǎi','躶':' luǒ','躵':' ren','躴':' láng','躳':' gōng','躲':' duǒ','躱':' duǒ','躰':' tǐ','軺':' yáo','軼':' yì','躔':' chán','輽':' bèn','轇':' jiāo','轆':' lù','轅':' yuán','轄':' xiá','轃':' zhēn','轂':' gǔ','轁':' tāo','轀':' wēn','輿':' yú','輾':' zhǎn','輼':' wēn','轉':' zhuǎn','輻':' fú','輺':' zī','輹':' fù','輸':' shū','輷':' hōng','輶':' yóu','輵':' gé','輴':' chūn','輳':' còu','輲':' chuán','轈':' cháo','轊':' wèi','輰':' yáng','轗':' kǎn','轡':' pèi','轠':' léi','轟':' hōng','轞':' jiàn','轝':' yù','轜':' ér','轛':' zhuì','轚':' jí','轙':' yǐ','轘':' huán','轖':' sè','轋':' hún','轕':' gé','轔':' lín','轓':' fān','轒':' fén','轑':' lǎo','轐':' bú','轏':' zhàn','轎':' jiào','轍':' zhé','轌':' xue','輱':' xián','輯':' jí','軽':' zhì','載':' zài','輓':' wǎn','輒':' zhé','輑':' yǐn','輐':' wàn','輏':' yóu','輎':' shāo','輍':' yù','輌':' liàng','輋':' shē','輊':' zhì','輈':' zhōu','輕':' qīng','輇':' quán','輆':' kǎi','輅':' hé','輄':' guāng','較':' jiào','輂':' jú','輁':' gǒng','輀':' ér','軿':' píng','軾':' shì','輔':' fǔ','輖':' zhōu','輮':' róu','輣':' péng','輭':' ruǎn','輬':' liáng','輫':' pái','輪':' lún','輩':' bèi','輨':' guǎn','輧':' píng','輦':' niǎn','輥':' gǔn','輤':' qiàn','輢':' yǐ','輗':' ní','輡':' kǎn','輠':' guǒ','輟':' chuò','輞':' wǎng','輝':' huī','輜':' zī','輛':' liàng','輚':' zhàn','輙':' zhé','輘':' léng','躕':' chú','躓':' zhì','跄':' qiāng','踄':' bù','踎':' móu','踍':' qiāo','踌':' chóu','踋':' jiǎo','踊':' yǒng','踉':' liáng','踈':' shū','踇':' mǔ','踆':' cūn','踅':' xué','踃':' xiāo','踐':' jiàn','踂':' niè','踁':' jìng','踀':' chù','跿':' tú','跾':' shū','跽':' jì','跼':' jú','跻':' jī','跺':' duò','跹':' xiān','踏':' tà','踑':' qí','跷':' qiāo','踞':' jù','踨':' zōng','踧':' cù','踦':' yǐ','踥':' qiè','踤':' zú','踣':' bó','踢':' tī','踡':' quán','踠':' wǎn','踟':' chí','踝':' huái','踒':' wō','踜':' lèng','踛':' lù','踚':' lún','踙':' jū','踘':' jū','踗':' niè','踖':' jí','踕':' jié','踔':' chuō','踓':' wěi','跸':' bì','跶':' tà','踪':' zōng','跐':' cī','跚':' shān','跙':' jù','跘':' pán','跗':' fū','跖':' zhí','跕':' diǎn','跔':' jū','跓':' zhù','跒':' qiǎ','跑':' pǎo','跏':' jiā','跜':' ní','跎':' tuó','跍':' kū','跌':' diē','跋':' bá','跊':' mèi','跉':' líng','跈':' niǎn','跇':' yì','跆':' tái','跅':' tuò','跛':' bǒ','距':' jù','践':' jiàn','跪':' guì','跴':' cǎi','跳':' tiào','跲':' jiá','跱':' zhì','跰':' pián','路':' lù','跮':' chì','跭':' xiáng','跬':' kuǐ','跫':' qióng','跩':' zhuǎi','跞':' lì','跨':' kuà','跧':' quán','跦':' zhū','跥':' duò','跤':' jiāo','跣':' xiǎn','跢':' duò','跡':' jī','跠':' yí','跟':' gēn','踩':' cǎi','踫':' pèng','躒':' lì','蹭':' cèng','蹷':' jué','蹶':' jué','蹵':' cù','蹴':' cù','蹳':' bō','蹲':' dūn','蹱':' zhōng','蹰':' chú','蹯':' fán','蹮':' xiān','蹬':' dēng','蹹':' tá','蹫':' jú','蹪':' tuí','蹩':' bié','蹨':' niǎn','蹧':' zāo','蹦':' bèng','蹥':' lián','蹤':' zōng','蹣':' pán','蹢':' dí','蹸':' lìn','蹺':' qiāo','蹠':' zhí','躇':' chú','躑':' zhí','躐':' liè','躏':' lìn','躎':' niǎn','躍':' yuè','躌':' wǔ','躋':' jī','躊':' chóu','躉':' dǔn','躈':' qiào','躆':' jù','蹻':' juē','躅':' zhú','躄':' bì','躃':' bì','躂':' dá','躁':' zào','躀':' kuàng','蹿':' cuān','蹾':' dūn','蹽':' liāo','蹼':' pǔ','蹡':' qiāng','蹟':' jī','踬':' zhì','踸':' chěn','蹂':' róu','蹁':' pián','蹀':' dié','踿':' zú','踾':' fú','踽':' jǔ','踼':' táng','踻':' guā','踺':' jiàn','踹':' chuài','踷':' zhǎ','蹄':' tí','踶':' dì','踵':' zhǒng','踴':' yǒng','踳':' chuǎn','踲':' dùn','踱':' duó','踰':' yú','踯':' zhí','踮':' diǎn','踭':' zhēng','蹃':' nuò','蹅':' chǎ','蹞':' kuǐ','蹓':' liū','蹝':' xǐ','蹜':' sù','蹛':' dài','蹚':' tāng','蹙':' cù','蹘':' liáo','蹗':' lù','蹖':' chōng','蹕':' bì','蹔':' zàn','蹒':' pán','蹆':' tuǐ','蹑':' niè','蹐':' jí','蹏':' tí','蹎':' diān','蹍':' niǎn','蹌':' qiāng','蹋':' tà','蹊':' qī','蹉':' cuō','蹈':' dǎo','蹇':' jiǎn','殖':' zhí','敒':' shēn','殔':' yì','䠑':' kuǐ','䠜':' róng','䠛':' yáo','䠚':' wà','䠙':' páng','䠘':' pì','䠗':' qiù','䠕':' cāi','䠔':' suì','䠓':' qiū','䠒':' hú','䠐':' qù','䠞':' cù','䠏':' jì','䠎':' wò','䠍':' xiā','䠋':' bì','䠊':' fèi','䠉':' huàn','䠈':' tú','䠇':' jué','䠆':' cháng','䠅':' kǔn','䠝':' xūn','䠟':' dié','䠃':' liǎng','䠬':' dèng','䠶':' shè','䠵':' fù','䠴':' zhěn','䠳':' chēn','䠲':' líng','䠱':' zhú','䠰':' quán','䠯':' yuè','䠮':' téng','䠭':' lái','䠫':' zòu','䠠':' chì','䠪':' duàn','䠩':' guì','䠨':' chàn','䠧':' chú','䠦':' zhè','䠥':' bié','䠤':' duǒ','䠣':' xuǎn','䠢':' mèng','䠡':' cuó','䠄':' tiǎn','䠂':' chú','䠸':' kuā','䟗':' shì','䟡':' zhī','䟠':' yuè','䟟':' cù','䟞':' chú','䟝':' tòu','䟜':' nà','䟛':' bó','䟚':' qí','䟙':' qiè','䟘':' hàng','䟖':' tàng','䟣':' chù','䟕':' chà','䟔':' fù','䟓':' chēng','䟒':' quán','䟑':' yuè','䟐':' lì','䟏':' lì','䟍':' biān','䟌':' jí','䟋':' zhǎn','䟢':' chén','䟤':' bì','䠀':' tāng','䟴':' zhèn','䟿':' lù','䟾':' zhuó','䟼':' wǔ','䟻':' dù','䟺':' bèi','䟹':' liè','䟸':' kuí','䟷':' chì','䟶':' zuò','䟵':' qiú','䟰':' jiǎn','䟥':' méng','䟯':' kuò','䟮':' fú','䟭':' tiáo','䟬':' qiù','䟫':' chēng','䟪':' fěng','䟩':' liě','䟨':' mín','䟧':' tián','䟦':' bá','䠷':' tiǎo','䠹':' ái','䟉':' zhú','䡿':' líng','䢋':' jì','䢊':' yóu','䢉':' nóng','䢈':' chén','䢇':' rǒng','䢅':' chén','䢄':' xǐ','䢃':' yì','䢁':' yuè','䢀':' qì','䡾':' niè','䢍':' fǎng','䡽':' zuān','䡼':' líng','䡻':' mín','䡺':' wèi','䡹':' zhì','䡷':' kài','䡶':' bèi','䡵':' suì','䡴':' chōng','䡳':' sī','䢌':' bó','䢐':' cú','䡱':' zhuǎn','䢟':' yóu','䢩':' yù','䢨':' cōng','䢧':' liào','䢦':' shuài','䢥':' yán','䢤':' shù','䢣':' yáo','䢢':' càng','䢡':' yè','䢠':' sòng','䢞':' shù','䢑':' dǐ','䢝':' yà','䢛':' jiǒng','䢚':' gēng','䢙':' bài','䢗':' qū','䢖':' yù','䢕':' xù','䢔':' hé','䢓':' yú','䢒':' jiāo','䡲':' chán','䡰':' kēng','䠻':' qióng','䡈':' jué','䡒':' tián','䡑':' mín','䡐':' tuó','䡏':' hóng','䡎':' lú','䡍':' fú','䡌':' hóng','䡋':' qí','䡊':' fǎn','䡉':' kǎng','䡇':' yuè','䡔':' qǐ','䡆':' róng','䡅':' chūn','䡃':' lì','䡂':' jiū','䡁':' lǒng','䡀':' zhǎn','䠿':' wài','䠾':' shǎn','䠽':' hái','䠼':' shù','䡓':' juàn','䡕':' zhěng','䡯':' cōng','䡣':' hūn','䡭':' xiū','䡬':' màn','䡫':' péng','䡪':' shàn','䡩':' kēng','䡨':' chà','䡧':' wū','䡦':' sǎng','䡥':' róng','䡤':' zhū','䡢':' biàn','䡖':' qìng','䡡':' xié','䡟':' pì','䡞':' jú','䡝':' yuān','䡜':' lù','䡛':' yìn','䡚':' mào','䡙':' láng','䡘':' tián','䡗':' gǒng','䟊':' qú','䟈':' zhí','䢫':' suí','䜮':' liáo','䜺':' chǎi','䜹':' shù','䜸':' měi','䜷':' qīn','䜶':' xiáng','䜵':' chǐ','䜴':' chù','䜲':' liè','䜱':' mǎn','䜯':' jú','䜭':' jùn','䜼':' gú','䜬':' sǒng','䜫':' jiāng','䜪':' qiú','䜩':' yàn','䜧':' nǎo','䜣':' xīn','䜢':' xiǎn','䜡':' yù','䜠':' chè','䜟':' chén','䜻':' chǐ','䜽':' yú','䜝':' tuǎn','䝎':' tuān','䝚':' ní','䝙':' chū','䝘':' yì','䝖':' zhǎo','䝕':' zhé','䝓':' liè','䝒':' zhù','䝑':' chōng','䝐':' wéi','䝏':' lóu','䝍':' jùn','䜾':' yīn','䝌':' jué','䝋':' zòng','䝊':' shà','䝈':' è','䝅':' huī','䝄':' shuāng','䝃':' zhé','䝂':' shù','䝁':' láo','䝀':' liú','䜞':' jì','䜜':' wèi','䝜':' suān','䛵':' shòu','䛿':' gé','䛾':' sù','䛽':' zhǎ','䛼':' huǐ','䛻':' yòu','䛺':' jiè','䛹':' càn','䛸':' chè','䛷':' wǎn','䛶':' lěi','䛴':' jī','䜁':' xì','䛳':' yàn','䛲':' mán','䛱':' tí','䛰':' hùn','䛯':' jù','䛮':' jiù','䛭':' xìng','䛬':' táo','䛫':' zhāng','䛪':' qióng','䜀':' nǎo','䜃':' duī','䜛':' chán','䜐':' huī','䜚':' tà','䜙':' án','䜘':' jǐng','䜗':' xìn','䜖':' tàn','䜕':' mài','䜔':' suí','䜓':' shè','䜒':' ào','䜑':' wù','䜏':' tuō','䜄':' chí','䜎':' láo','䜍':' liáo','䜌':' luán','䜋':' huì','䜊':' zāo','䜉':' chī','䜈':' chāo','䜇':' gǔn','䜆':' zhé','䜅':' wéi','䝛':' bō','䝝':' yǐ','䟇':' jī','䞡':' tǎn','䞫':' yǔn','䞪':' jiàng','䞩':' è','䞨':' guǐ','䞧':' hòu','䞦':' hé','䞥':' yòu','䞤':' qú','䞣':' chě','䞢':' zuó','䞠':' zhī','䞭':' cūn','䞟':' pò','䞞':' fú','䞝':' yù','䞜':' fù','䞛':' yān','䞚':' qí','䞙':' zá','䞘':' jí','䞗':' cāi','䞖':' shǔ','䞬':' tòu','䞮':' tū','䞔':' wěi','䞼':' chuǐ','䟆':' bì','䟅':' jiàn','䟄':' qì','䟃':' cān','䟂':' mán','䟁':' xiáo','䟀':' cāi','䞿':' qiān','䞾':' chí','䞽':' suǒ','䞻':' yǒng','䞯':' fù','䞺':' chūn','䞹':' huáng','䞸':' fù','䞷':' jué','䞶':' tāng','䞵':' juě','䞴':' zhāo','䞳':' bó','䞱':' hú','䞰':' zuó','䞕':' rú','䞓':' chēng','䝞':' hào','䝪':' shǔ','䝵':' bù','䝳':' cán','䝲':' jìn','䝱':' xié','䝰':' zhì','䝯':' yì','䝮':' xuàn','䝭':' gòu','䝬':' zhù','䝫':' zuó','䝩':' zhèn','䝷':' zhī','䝨':' xián','䝧':' mín','䝦':' zhōng','䝥':' háo','䝤':' lǎo','䝣':' qú','䝢':' màn','䝡':' màn','䝠':' huán','䝟':' yà','䝶':' liáng','䝸':' jì','䞒':' dòng','䞅':' yí','䞑':' hóng','䞐':' chǔn','䞍':' qíng','䞌':' shé','䞋':' chèn','䞊':' xùn','䞉':' shèng','䞈':' guì','䞇':' dié','䞆':' suǒ','䞄':' biào','䝹':' wǎn','䞃':' zhì','䞂':' ruǎn','䞁':' yàn','䞀':' hòu','䝿':' guì','䝾':' fù','䝽':' ài','䝼':' jìng','䝻':' jū','䝺':' guàn','䢪':' bó','䢭':' yàn','䛨':' xìn','䧡':' yōng','䧮':' xiàn','䧬':' bīn','䧫':' háo','䧪':' chè','䧨':' yè','䧧':' yǐ','䧦':' wéi','䧥':' huì','䧤':' pú','䧢':' qū','䧠':' shuàn','䧰':' hùn','䧟':' xiàn','䧞':' mà','䧝':' chī','䧜':' táng','䧛':' bàng','䧚':' hào','䧙':' líng','䧘':' zhuàn','䧗':' bì','䧖':' jiàn','䧯':' chán','䧲':' hàn','䧔':' niàn','䨂':' qiū','䨏':' cí','䨎':' hóng','䨍':' yǐng','䨌':' báo','䨋':' nüè','䨊':' yuān','䨈':' bīn','䨆':' bí','䨅':' liáo','䨄':' yàn','䨁':' wù','䧳':' cí','䨀':' dí','䧿':' què','䧽':' cuǐ','䧼':' hú','䧺':' xióng','䧹':' yīng','䧷':' róu','䧶':' kuí','䧵':' qí','䧴':' zhī','䧕':' chéng','䧓':' zhōu','䨑':' tí','䦥':' xián','䦱':' wěi','䦯':' zhì','䦮':' chǔn','䦭':' hāng','䦬':' què','䦫':' yīng','䦪':' yà','䦨':' lán','䦧':' qié','䦦':' qín','䦤':' chuài','䦳':' xiàng','䦣':' fù','䦢':' kuò','䦡':' huán','䦠':' dū','䦟':' wěn','䦞':' rùn','䦝':' huō','䦜':' wú','䦛':' zhèng','䦚':' kuà','䦲':' yán','䦴':' yì','䧒':' lái','䧄':' gè','䧑':' dī','䧎':' xuàn','䧍':' xì','䧌':' suī','䧋':' xiǎn','䧊':' kū','䧉':' lǐ','䧇':' yī','䧆':' hóng','䧅':' yí','䧃':' tián','䦵':' nǐ','䧂':' dào','䧁':' xǔ','䦾':' yuán','䦽':' xù','䦼':' jué','䦻':' zǐ','䦺':' dīng','䦹':' shí','䦷':' chuài','䦶':' zhèng','䨐':' qià','䨒':' yù','䦘':' xiàn','䩗':' bà','䩢':' zhì','䩡':' jiá','䩟':' yí','䩞':' tié','䩝':' páo','䩜':' zhòu','䩛':' bì','䩚':' dì','䩙':' xuàn','䩘':' dì','䩕':' áng','䩤':' xié','䩔':' duò','䩓':' qí','䩒':' yú','䩑':' hóng','䩐':' hū','䩏':' miè','䩍':' liǎo','䩌':' qiáo','䩋':' mǒ','䩊':' wǎn','䩣':' tú','䩥':' dàn','䩈':' huì','䩳':' sōu','䩽':' yū','䩼':' féng','䩻':' bà','䩺':' wēng','䩹':' é','䩸':' róng','䩷':' bāng','䩶':' chǎn','䩵':' yùn','䩴':' hú','䩲':' dū','䩦':' tiáo','䩱':' shù','䩰':' xuàn','䩯':' jí','䩮':' lù','䩬':' běng','䩫':' liǎng','䩪':' guǎn','䩩':' yuǎn','䩨':' chàng','䩧':' xiè','䩉':' fǔ','䩇':' zhān','䨓':' léi','䨠':' ǎi','䨫':' mài','䨪':' mái','䨩':' líng','䨨':' zhuī','䨦':' pāng','䨥':' huò','䨤':' dí','䨣':' gé','䨢':' dàn','䨡':' hán','䨟':' wā','䨭':' xiāo','䨞':' yǔ','䨝':' qīng','䨜':' bēng','䨛':' sè','䨚':' hū','䨙':' cén','䨘':' xiàn','䨗':' fú','䨖':' jì','䨔':' báo','䨬':' lián','䨮':' xuě','䩆':' zhǎn','䨻':' bèng','䩅':' zhǎn','䩄':' miǎn','䩃':' shì','䩂':' xiān','䩁':' fēi','䩀':' bèi','䨿':' zá','䨾':' fèi','䨽':' fěi','䨼':' hù','䨺':' duì','䨯':' zhèn','䨹':' shū','䨸':' yǐn','䨷':' xiàn','䨶':' yǔn','䨵':' dàn','䨴':' duì','䨳':' xì','䨲':' nóu','䨱':' fù','䨰':' pò','䦙':' sì','䦗':' xù','䢮':' lèi','䣷':' zhū','䤂':' méi','䤁':' cén','䣿':' yū','䣾':' mì','䣽':' zhī','䣼':' liáng','䣻':' hān','䣺':' juān','䣹':' fá','䣸':' rǎn','䣶':' huó','䤄':' miǎn','䣵':' èr','䣴':' xù','䣲':' fàn','䣱':' xù','䣰':' jù','䣯':' cú','䣮':' pò','䣭':' tài','䣬':' zǎi','䣫':' lí','䤃':' yīn','䤅':' tú','䣩':' chún','䤔':' jiàn','䤞':' yǔn','䤝':' yìng','䤜':' dùn','䤛':' qiú','䤚':' lǐ','䤙':' lì','䤘':' chǎn','䤗':' gǎn','䤖':' bào','䤕':' xuè','䤓':' méng','䤆':' kuí','䤒':' jì','䤑':' wàng','䤐':' jǐn','䤏':' pǐ','䤎':' jú','䤍':' mí','䤌':' qiāng','䤋':' yù','䤊':' róng','䤉':' mì','䣪':' pò','䣨':' chún','䤠':' zhǐ','䢽':' xiàng','䣈':' hàng','䣇':' qiú','䣆':' xíng','䣅':' chén','䣄':' tú','䣂':' lěi','䣁':' yǔ','䣀':' guǐ','䢿':' ān','䢾':' xiǎn','䢼':' gōng','䣋':' cǎi','䢻':' chén','䢺':' chū','䢹':' jǔ','䢸':' jū','䢵':' yún','䢳':' jǐ','䢲':' yuè','䢱':' dú','䢰':' tī','䢯':' lín','䣊':' dǎng','䣌':' dǐ','䣧':' yì','䣜':' cuó','䣦':' lèi','䣥':' bǐ','䣤':' jué','䣣':' dǎng','䣢':' jí','䣡':' yí','䣠':' jié','䣟':' cán','䣞':' è','䣝':' tú','䣛':' qī','䣍':' yǎn','䣚':' lóu','䣙':' péi','䣘':' táng','䣖':' mǎ','䣕':' mǎ','䣔':' suǒ','䣓':' lí','䣑':' chán','䣐':' yīng','䣎':' zī','䤟':' chén','䤡':' rǎn','䦖':' xié','䥨':' lǜ','䥲':' ōu','䥱':' xiě','䥰':' méng','䥯':' bēi','䥮':' zhú','䥭':' zhèng','䥬':' bó','䥫':' tiě','䥪':' xiǎn','䥩':' wéi','䥧':' huán','䥵':' xiǎo','䥥':' lián','䥤':' báo','䥣':' záo','䥢':' lóng','䥡':' yè','䥟':' yè','䥞':' jiǎo','䥝':' áo','䥜':' jiàn','䥛':' jiē','䥳':' yōu','䥶':' lì','䥘':' cù','䦋':' áo','䦕':' pēng','䦔':' tǎn','䦓':' zhān','䦒':' dàng','䦑':' xuè','䦐':' tǐng','䦏':' xiè','䦎':' guǎn','䦍':' wù','䦌':' chù','䦊':' niǎo','䥷':' zhá','䦈':' jiē','䦇':' jì','䦆':' jué','䦅':' shàn','䦃':' zhuō','䦂':' shàn','䥾':' xiě','䥽':' pō','䥺':' yé','䥸':' mí','䥙':' suì','䥗':' kuǎn','䤣':' lüè','䤯':' xíng','䤹':' sōu','䤸':' zuàn','䤷':' yǎn','䤶':' yè','䤵':' fèi','䤴':' hán','䤳':' yè','䤲':' chì','䤱':' shì','䤰':' yíng','䤮':' shè','䤻':' duò','䤭':' shì','䤬':' shā','䤫':' chán','䤪':' duǒ','䤩':' chá','䤨':' pì','䤧':' huì','䤦':' yuè','䤥':' guǐ','䤤':' kāi','䤺':' jīn','䤼':' xiàn','䥖':' tián','䥋':' pēng','䥕':' piě','䥔':' sù','䥓':' qī','䥒':' jiàng','䥑':' wàn','䥐':' móu','䥏':' yǔ','䥎':' chún','䥍':' zhì','䥌':' zhèng','䥉':' yuān','䤽':' guān','䥈':' mǔ','䥇':' shàn','䥆':' jǐn','䥅':' qiàn','䥄':' cù','䥃':' yuè','䥂':' mèng','䥁':' hán','䥀':' chǎn','䤿':' qiè','䤾':' tāo','䛩':' wù','䛧':' mí','䩿':' fén','䑶':' qiàn','䒃':' cào','䒂':' jiǎng','䒁':' xí','䒀':' bù','䑿':' sù','䑽':' tà','䑼':' zhōu','䑻':' yóu','䑹':' sōu','䑸':' zōng','䑵':' mù','䒅':' téng','䑴':' qí','䑳':' lún','䑲':' zhào','䑱':' wǎn','䑰':' bù','䑯':' dì','䑭':' dì','䑬':' tāo','䑫':' bēng','䑪':' è','䒄':' fù','䒆':' chè','䑧':' fú','䒓':' kǎi','䒟':' dān','䒞':' chén','䒝':' xiáo','䒜':' niú','䒛':' huàn','䒚':' shǎo','䒗':' qì','䒖':' xìn','䒕':' xiǎo','䒔':' bài','䒒':' tiáo','䒇':' fù','䒑':' cǎo','䒐':' méng','䒏':' sēng','䒎':' mǎng','䒍':' pǎng','䒌':' mìng','䒋':' yǎng','䒊':' xī','䒉':' wǔ','䒈':' fèi','䑨':' duò','䑦':' gōu','䒡':' yǐn','䐼':' xì','䑆':' yǎng','䑅':' méng','䑄':' pì','䑃':' méng','䑂':' ǎi','䑁':' wù','䑀':' pì','䐿':' ào','䐾':' duó','䐽':' mán','䐻':' gū','䑈':' bó','䐺':' tàn','䐹':' sōu','䐸':' huò','䐷':' dān','䐶':' zān','䐵':' gōng','䐴':' guì','䐳':' yú','䐲':' zhé','䐱':' zhài','䑇':' zhì','䑉':' yíng','䑥':' è','䑘':' cuó','䑤':' jìn','䑣':' chēn','䑠':' liǎo','䑟':' huáng','䑞':' shùn','䑝':' jiǎ','䑜':' tà','䑛':' chǐ','䑚':' tián','䑙':' tān','䑗':' dàng','䑊':' wéi','䑕':' shǔ','䑔':' fèi','䑓':' tái','䑑':' pú','䑐':' zhěn','䑏':' quán','䑎':' chǎn','䑍':' yān','䑌':' lán','䑋':' rǎng','䒠':' fēng','䒢':' áng','䐯':' léi','䓭':' chà','䓷':' xìng','䓶':' lài','䓵':' fū','䓴':' ruǎn','䓳':' hěn','䓲':' ruì','䓱':' chái','䓰':' yīn','䓯':' dú','䓮':' mào','䓫':' qí','䓹':' yì','䓨':' yīng','䓧':' cì','䓦':' diǎn','䓥':' là','䓤':' hū','䓣':' liǎng','䓢':' gù','䓡':' zhī','䓠':' tà','䓟':' zhōu','䓸':' jiān','䓺':' měi','䓝':' mèng','䔉':' lì','䔕':' pú','䔔':' jìng','䔓':' xǔ','䔒':' bèi','䔑':' xié','䔐':' jiān','䔏':' chòu','䔎':' sù','䔋':' suō','䔊':' bīng','䔈':' gòng','䓼':' máng','䔇':' qǐ','䔆':' lí','䔅':' gē','䔄':' yáo','䔃':' zǔ','䔂':' zǐ','䔁':' lì','䓿':' hàn','䓾':' suō','䓽':' jì','䓞':' lì','䓜':' zhī','䒣':' rǎn','䒲':' chà','䒽':' wǎng','䒼':' qū','䒻':' qǐ','䒺':' jǐn','䒹':' lèi','䒸':' xuè','䒷':' guā','䒵':' hào','䒴':' yǒu','䒳':' duǒ','䒰':' kuāng','䒿':' liáo','䒭':' děng','䒬':' mò','䒫':' dài','䒪':' biàn','䒩':' hé','䒨':' shǐ','䒧':' qū','䒦':' fàn','䒥':' mán','䒤':' rì','䒾':' yī','䓂':' yán','䓛':' qū','䓏':' fū','䓚':' qū','䓙':' kuā','䓘':' gāo','䓗':' cōng','䓖':' qióng','䓕':' tuǒ','䓓':' chóu','䓒':' kuǎi','䓑':' píng','䓐':' chún','䓎':' chuò','䓃':' yì','䓍':' hǎn','䓌':' zhì','䓋':' zhī','䓊':' wú','䓉':' yé','䓈':' yì','䓇':' xì','䓆':' zhé','䓅':' qí','䓄':' yín','䐰':' xiū','䐮':' chǎn','䔗':' xiáng','䎚':' guàn','䎧':' bàng','䎦':' yǎn','䎤':' jú','䎣':' sì','䎢':' qǐ','䎡':' ruǎn','䎠':' ér','䎟':' ér','䎝':' chú','䎜':' hūn','䎙':' pīn','䎩':' zī','䎘':' sù','䎗':' qiáo','䎖':' zēng','䎕':' hōng','䎔':' fū','䎓':' tà','䎒':' zhǎn','䎑':' lù','䎐':' chǎo','䎏':' hán','䎨':' yè','䎪':' nè','䎌':' chù','䎷':' zhù','䏁':' zǎi','䏀':' là','䎿':' qiú','䎾':' gǔn','䎽':' wén','䎼':' lù','䎻':' zhòu','䎺':' zhì','䎹':' wén','䎸':' wù','䎶':' èr','䎫':' chuàng','䎵':' bì','䎴':' gēng','䎳':' wà','䎲':' zhé','䎱':' bà','䎰':' zuó','䎯':' hàn','䎮':' tì','䎭':' cāo','䎬':' bà','䎎':' nà','䎋':' kào','䏃':' mián','䍡':' lù','䍬':' pēng','䍫':' tuó','䍪':' wà','䍩':' yǎng','䍨':' pō','䍦':' lí','䍥':' lì','䍤':' jǐ','䍣':' léi','䍢':' wú','䍠':' lí','䍯':' guǐ','䍟':' zòng','䍞':' yù','䍝':' tà','䍜':' zhào','䍛':' gù','䍚':' làng','䍙':' méi','䍘':' mí','䍗':' xuàn','䍖':' fú','䍮':' zhào','䍱':' xú','䎊':' luò','䍿':' huáng','䎉':' xù','䎈':' yì','䎇':' zhōu','䎆':' liào','䎅':' pò','䎄':' xiāo','䎃':' rǎn','䎂':' bǎo','䎁':' hú','䎀':' xuè','䍾':' yǎn','䍲':' nái','䍽':' lì','䍼':' zān','䍻':' xuàn','䍺':' huàn','䍸':' bó','䍷':' wěi','䍶':' dōng','䍵':' zhēng','䍴':' wěi','䍳':' què','䏂':' sǒu','䏄':' dǐ','䐭':' zhì','䐈':' zhí','䐒':' zhā','䐑':' zhé','䐐':' qiū','䐏':' chǔn','䐎':' dī','䐍':' chù','䐌':' tiǎn','䐋':' cōng','䐊':' kūn','䐉':' zì','䐇':' wěn','䐔':' bǐn','䐆':' cǎi','䐅':' xī','䐄':' xiàn','䐃':' jùn','䐂':' lù','䐁':' zhuó','䐀':' jì','䏿':' qǐ','䏽':' bù','䏼':' cán','䐓':' róu','䐕':' jí','䏺':' pāng','䐢':' zhù','䐬':' cáo','䐫':' cōng','䐪':' fàn','䐩':' gāi','䐨':' gǔ','䐧':' kào','䐦':' kē','䐥':' wěng','䐤':' chāi','䐣':' sǔn','䐡':' qí','䐖':' xī','䐠':' huǎng','䐟':' xiǎng','䐞':' ruò','䐝':' suò','䐜':' chēn','䐛':' dā','䐚':' jī','䐙':' gé','䐘':' jué','䐗':' zhū','䏻':' néng','䏹':' xiàn','䏅':' qì','䏑':' dì','䏛':' chǔn','䏚':' chǎo','䏙':' tǎn','䏘':' pì','䏗':' gài','䏖':' zhèn','䏕':' rèn','䏔':' niǔ','䏓':' guǎn','䏒':' piàn','䏐':' jué','䏝':' zhuān','䏏':' xū','䏎':' féng','䏍':' yuàn','䏌':' qì','䏋':' sù','䏊':' lóng','䏉':' shī','䏈':' lián','䏇':' piào','䏆':' cáo','䏜':' hē','䏞':' mò','䏸':' yú','䏬':' móu','䏷':' hàn','䏶':' bì','䏵':' měng','䏴':' shào','䏳':' zhè','䏲':' dié','䏱':' jú','䏰':' rùn','䏯':' zhì','䏮':' xí','䏫':' xiū','䏟':' bié','䏪':' èr','䏩':' xī','䏨':' huǐ','䏧':' nà','䏦':' guā','䏤':' sì','䏣':' jué','䏢':' bǐ','䏡':' shì','䏠':' qì','䔖':' líng','䔘':' zuò','䛦':' sòng','䙉':' xún','䙕':' zǒng','䙔':' ōu','䙓':' bǎi','䙒':' xù','䙑':' cuī','䙐':' kè','䙏':' bó','䙎':' xié','䙌':' kuì','䙊':' xiè','䙈':' hóu','䙘':' chǔ','䙇':' ruán','䙆':' kuì','䙅':' yāo','䙄':' qì','䙃':' duò','䙁':' cán','䙀':' běng','䘿':' jué','䘾':' guǎn','䘽':' ní','䙗':' tì','䙙':' chí','䘻':' yù','䙦':' méng','䙵':' xī','䙳':' biāo','䙱':' dú','䙰':' lí','䙯':' cù','䙮':' guàn','䙬':' yìng','䙪':' lóng','䙩':' méng','䙨':' guǒ','䙥':' líng','䙚':' niǎo','䙤':' duǒ','䙣':' sà','䙢':' zèng','䙡':' kuì','䙠':' jué','䙟':' wéi','䙞':' dēng','䙝':' xiè','䙜':' féng','䙛':' guàn','䘼':' wǎn','䘺':' zhàn','䙸':' dé','䘋':' jiān','䘕':' háng','䘔':' kā','䘓':' kàn','䘒':' zuī','䘑':' mài','䘐':' nǜ','䘏':' xù','䘎':' wān','䘍':' chài','䘌':' nì','䘊':' miè','䘙':' wèi','䘉':' cán','䘈':' lì','䘇':' wén','䘆':' xiǎn','䘅':' nái','䘄':' zhù','䘃':' mò','䘁':' gé','䘀':' fù','䗿':' níng','䘘':' yù','䘚':' zhú','䘹':' zuì','䘫':' nòu','䘸':' yì','䘷':' biē','䘶':' hān','䘵':' lù','䘳':' jīn','䘱':' yù','䘰':' shān','䘮':' sāng','䘭':' zhì','䘬':' róng','䘪':' chōng','䘝':' yì','䘩':' xún','䘨':' jiǎo','䘦':' ní','䘥':' xiá','䘤':' shù','䘣':' zǐ','䘢':' zhǔ','䘡':' bǐ','䘠':' fú','䘟':' diāo','䙷':' dé','䙹':' xiàn','䗽':' wèi','䛀':' fǎn','䛊':' xī','䛉':' miàn','䛈':' shì','䛇':' yuǎn','䛆':' zhòu','䛅':' xiá','䛄':' yuǎn','䛃':' wàn','䛂':' yāo','䛁':' nán','䚿':' yìn','䛌':' táo','䚾':' nín','䚽':' hào','䚼':' nǜ','䚻':' yáo','䚺':' yáo','䚹':' pǐ','䚸':' xiè','䚷':' yī','䚶':' tiān','䚵':' tǒu','䛋':' jì','䛍':' fèi','䚳':' zhì','䛛':' huì','䛥':' xī','䛤':' cù','䛣':' pīng','䛢':' tū','䛡':' huà','䛠':' dòu','䛟':' jiá','䛞':' hàn','䛝':' náo','䛜':' xùn','䛚':' lüè','䛎':' xuè','䛙':' xù','䛘':' rén','䛗':' zhǐ','䛖':' è','䛕':' yù','䛔':' ná','䛒':' biàn','䛑':' mì','䛐':' cí','䛏':' ní','䚴':' wà','䚲':' shàn','䙺':' lián','䚉':' qì','䚕':' lì','䚔':' bīn','䚓':' niǎn','䚒':' chuáng','䚑':' mái','䚐':' jí','䚏':' lìn','䚍':' qì','䚋':' yùn','䚊':' jiǎn','䚈':' juàn','䚗':' gāng','䚇':' shěng','䚆':' yǐng','䚅':' lài','䚄':' lù','䚃':' yóu','䚂':' hè','䙿':' wèi','䙾':' shī','䙽':' xié','䙼':' shào','䚖':' líng','䚘':' chéng','䚱':' xìn','䚦':' zhì','䚰':' pǐ','䚯':' tǎo','䚮':' réng','䚭':' xuān','䚬':' lín','䚫':' xí','䚪':' guān','䚩':' jiǎo','䚨':' fèi','䚧':' liú','䚥':' nuò','䚙':' xuān','䚣':' tí','䚢':' chè','䚡':' sāi','䚠':' hùn','䚟':' dǎi','䚞':' dǎi','䚝':' zú','䚜':' bī','䚛':' hú','䚚':' xiǎn','䗾':' xiǎn','䗼':' xūn','䔙':' diào','䕤':' jī','䕯':' piáo','䕮':' jú','䕭':' qián','䕫':' kuí','䕪':' zé','䕩':' lǎo','䕨':' téng','䕧':' xiào','䕦':' yíng','䕥':' nǐ','䕣':' hé','䕱':' tóu','䕢':' zhǎ','䕡':' lǘ','䕠':' fèi','䕟':' xīng','䕞':' làng','䕝':' chēng','䕛':' jiá','䕚':' kuì','䕙':' jié','䕘':' líng','䕰':' fán','䕲':' lǐn','䕕':' màn','䕿':' hàn','䖋':' nüè','䖊':' yì','䖈':' nüè','䖇':' yù','䖆':' niàng','䖅':' líng','䖄':' rán','䖃':' yuè','䖂':' luán','䖁':' yì','䕾':' yín','䕳':' mí','䕽':' zhú','䕼':' rán','䕻':' lì','䕺':' cóng','䕹':' zá','䕸':' jiē','䕷':' mí','䕶':' hù','䕵':' xié','䕴':' zhuó','䕗':' bì','䕔':' xián','䖍':' qián','䔧':' lí','䔴':' cè','䔳':' rán','䔲':' dēng','䔱':' yī','䔰':' fù','䔯':' kù','䔮':' sī','䔭':' nìng','䔬':' yì','䔪':' shuǎng','䔤':' pā','䔷':' qín','䔣':' lí','䔢':' huá','䔡':' yú','䔠':' shǎo','䔟':' yí','䔞':' lǜ','䔝':' zhāi','䔜':' nán','䔛':' qǐng','䔚':' chún','䔶':' tí','䔸':' biǎo','䕓':' chá','䕇':' huì','䕒':' jiā','䕑':' jùn','䕏':' é','䕎':' fú','䕍':' yì','䕌':' zhì','䕋':' táng','䕊':' tán','䕉':' zé','䕈':' xiè','䕆':' dòu','䔹':' suì','䕅':' sǎo','䕃':' yìn','䕁':' fěi','䕀':' kuǎn','䔿':' zǔn','䔾':' qì','䔽':' ài','䔼':' sè','䔻':' dūn','䔺':' wéi','䖌':' yì','䖎':' xiá','䗻':' jié','䗒':' bìng','䗜':' liú','䗛':' xiū','䗚':' bó','䗙':' hán','䗘':' gé','䗗':' jī','䗖':' dì','䗕':' wǎn','䗔':' hóu','䗓':' cōng','䗑':' yì','䗞':' cán','䗐':' shī','䗏':' sōu','䗎':' yān','䗍':' lǐ','䗌':' xīng','䗋':' móu','䗊':' tàn','䗉':' chāng','䗈':' méng','䗇':' jú','䗝':' cán','䗟':' yì','䗅':' cháng','䗯':' jìn','䗺':' yǎn','䗹':' cì','䗸':' yōng','䗷':' yì','䗶':' là','䗵':' jiāng','䗴':' tíng','䗲':' lìn','䗱':' pú','䗰':' guàn','䗮':' shuǎng','䗠':' xuán','䗫':' má','䗪':' zhè','䗩':' qī','䗨':' yú','䗧':' kāng','䗥':' zōng','䗤':' yóng','䗣':' hàn','䗢':' zǎo','䗡':' yán','䗆':' guǎn','䗄':' fǔ','䖏':' chǔ','䖛':' suǒ','䖥':' lí','䖤':' wǎn','䖣':' zǎo','䖢':' miáo','䖡':' nǜ','䖠':' yuán','䖟':' mǎng','䖞':' zhǒu','䖝':' chóng','䖜':' yín','䖚':' wū','䖧':' nà','䖙':' tī','䖘':' tú','䖗':' yán','䖖':' xiá','䖕':' zǔ','䖔':' kǎn','䖓':' nà','䖒':' xī','䖑':' mì','䖐':' yín','䖦':' qū','䖨':' shí','䗃':' zhàn','䖷':' xī','䗂':' hǔ','䗁':' jì','䗀':' chēng','䖿':' lí','䖽':' lí','䖼':' jué','䖻':' yóu','䖺':' tiáo','䖹':' yáng','䖸':' é','䖶':' huī','䖩':' bì','䖵':' kūn','䖴':' yáo','䖳':' zhà','䖲':' xún','䖱':' kuāng','䖰':' pài','䖯':' kuí','䖮':' xiǎng','䖭':' juàn','䖫':' bàng','䖪':' zī','䩾':' zhè','䪀':' guǎn','䍔':' gōng','佗':' tuó','佡':' xiān','你':' nǐ','佟':' tóng','佞':' nìng','佝':' gōu','作':' zuò','佛':' fú','佚':' yì','余':' yú','佘':' shé','佖':' bì','佣':' yōng','何':' hé','佔':' zhàn','体':' tǐ','佒':' yǎng','佑':' yòu','佐':' zuǒ','住':' zhù','低':' dī','位':' wèi','佌':' cǐ','佢':' qú','佤':' wǎ','佊':' bǐ','佱':' fǎ','佻':' tiāo','佺':' quán','佹':' guǐ','佸':' huó','佷':' hěn','佶':' jí','併':' bìng','佴':' èr','佳':' jiā','佲':' mǐng','佰':' bǎi','佥':' qiān','佯':' yáng','佮':' gé','佭':' xiáng','佬':' lǎo','佫':' hè','佪':' huí','佩':' pèi','佨':' bao','佧':' kǎ','佦':' shi','佋':' zhāo','佉':' qū','佽':' cì','伣':' xiàn','伭':' xián','伬':' ze','伫':' zhù','伪':' wěi','伩':' xìn','伨':' xùn','伧':' cāng','伦':' lún','伥':' chāng','伤':' shāng','伢':' yá','伯':' bó','伡':' chē','传':' chuán','伟':' wěi','伞':' sǎn','伝':' chuán','伜':' cuì','伛':' yǔ','会':' huì','伙':' huǒ','优':' yōu','伮':' nǔ','估':' gū','佈':' bù','伽':' jiā','佇':' zhù','但':' dàn','佅':' mài','佄':' hān','佃':' diàn','佂':' zhēng','佁':' yǐ','佀':' sì','伿':' yì','伾':' pī','似':' shì','伱':' nǐ','伻':' bēng','伺':' cì','伹':' qū','伸':' shēn','伷':' zhòu','伶':' líng','伵':' xù','伴':' bàn','伳':' xiè','伲':' nì','佼':' jiǎo','佾':' yì','伖':' tǎng','便':' biàn','俉':' wǔ','俈':' kù','俇':' guàng','俆':' xú','俅':' qiú','俄':' é','促':' cù','係':' xì','俁':' yǔ','俀':' tuǐ','侾':' xiāo','俋':' yì','侽':' nán','侼':' bó','侻':' tuì','侺':' shèn','侹':' tǐng','侸':' shù','侷':' jú','侶':' lǚ','侵':' qīn','侴':' chǒu','俊':' jùn','俌':' fǔ','侲':' zhèn','俙':' xī','俣':' yǔ','俢':' xiū','信':' xìn','俠':' xiá','俟':' qí','俞':' yú','保':' bǎo','俜':' pīng','俛':' fǔ','俚':' lǐ','俘':' fú','俍':' liáng','俗':' sú','俖':' pěi','俕':' sàn','俔':' qiàn','俓':' jìng','俒':' hùn','俑':' yǒng','俐':' lì','俏':' qiào','俎':' zǔ','侳':' zuò','侱':' chěng','使':' shǐ','例':' lì','侕':' ér','侔':' móu','侓':' lù','侒':' ān','侑':' yòu','侐':' xù','侏':' zhū','侎':' mǐ','侍':' shì','侌':' yīn','侊':' guāng','侗':' dòng','侉':' kuǎ','侈':' chǐ','侇':' yí','來':' lái','侅':' gāi','侄':' zhí','侃':' kǎn','侂':' tuō','侁':' shēn','侀':' xíng','侖':' lún','侘':' chà','侰':' jiǒng','侥':' jiǎo','侯':' hóu','侮':' wǔ','侭':' jǐn','侬':' nóng','侫':' nìng','侪':' chái','侩':' kuài','侨':' qiáo','侧':' cè','侦':' zhēn','侤':' ta','侙':' chī','侣':' lǚ','侢':' zài','価':' sì','侠':' xiá','侟':' cún','侞':' rú','依':' yī','侜':' zhōu','供':' gōng','侚':' xùn','众':' zhòng','伕':' fū','俥':' chē','亇':' ma','云':' yún','亐':' yú','亏':' kuī','于':' yú','亍':' chù','二':' èr','事':' shì','亊':' shì','争':' zhēng','予':' yǔ','了':' le','亓':' qí','亅':' jué','亄':' yì','亃':' lǐn','亂':' luàn','亁':' gān','亀':' guī','乿':' zhì','乾':' gān','乽':' zhě','乼':' cui','互':' hù','五':' wǔ','乺':' suǒ','亡':' wáng','享':' xiǎng','亪':' ye','亩':' mǔ','亨':' hēng','产':' chǎn','亦':' yì','亥':' hài','交':' jiāo','亣':' tà','亢':' kàng','亠':' tóu','井':' jǐng','亟':' jí','亞':' yà','亝':' qí','亜':' yà','些':' xiē','亚':' yà','亙':' gèn','亘':' gèn','亗':' suì','亖':' sì','乻':' yú','乹':' gān','亭':' tíng','乓':' pāng','九':' jiǔ','乜':' miē','乛':' ya','乚':' yǐn','乙':' yǐ','乘':' chéng','乗':' chéng','乖':' guāi','乕':' hǔ','乔':' qiáo','乒':' pīng','也':' yě','乑':' yín','乐':' lè','乏':' fá','乎':' hū','乍':' zhà','乌':' wū','之':' zhī','乊':' yī','义':' yì','么':' me','乞':' qǐ','习':' xí','乸':' nǎ','乭':' shí','乷':' shā','乶':' fǔ','乵':' yǎn','乴':' xué','乳':' rǔ','乲':' zī','乱':' luàn','买':' mǎi','乯':' hū','乮':' mǎo','乬':' jù','乡':' xiāng','乫':' jiā','乪':' náng','乩':' jī','乨':' shǐ','乧':' dou','书':' shū','乥':' hù','乤':' xià','乣':' jiǔ','乢':' gài','京':' jīng','亮':' liàng','伔':' dǎn','仯':' chào','仹':' fēng','仸':' yǎo','价':' jià','件':' jiàn','仵':' wǔ','仴':' wò','仳':' pǐ','仲':' zhòng','仱':' qián','仰':' yǎng','仮':' jiǎ','任':' rèn','仭':' rèn','们':' men','仫':' mù','仪':' yí','仩':' shang','仨':' sā','仧':' cháng','仦':' chào','以':' yǐ','令':' lìng','仺':' cāng','仼':' wáng','仢':' bó','伉':' kàng','伓':' pī','伒':' jìn','休':' xiū','伐':' fá','伏':' fú','伎':' jì','伍':' wǔ','伌':' ài','伋':' jí','伊':' yī','伈':' xǐn','份':' fèn','伇':' yì','伆':' wù','伅':' dùn','伄':' diào','伃':' yú','伂':' pèi','企':' qǐ','伀':' zhōng','仿':' fǎng','仾':' dī','代':' dài','仡':' gē','亯':' xiǎng','亻':' rén','仅':' jǐn','仄':' zè','仃':' dīng','仂':' lè','仁':' rén','什':' shén','亿':' yì','亾':' wáng','亽':' ji','亼':' jí','人':' rén','仇':' chóu','亹':' mén','亸':' duǒ','亷':' lián','亶':' dǎn','亵':' xiè','亴':' yòu','亳':' bó','亲':' qīn','亱':' yè','亰':' jīng','仆':' pū','仈':' bā','仠':' gǎn','仕':' shì','仟':' qiān','仞':' rèn','仝':' tóng','仜':' hóng','仛':' tuō','仚':' xiān','仙':' xiān','付':' fù','仗':' zhàng','他':' tā','仔':' zǐ','仉':' zhǎng','仓':' cāng','仒':' bīng','仑':' lún','仐':' sǎn','仏':' fó','从':' cóng','仍':' réng','仌':' bīng','介':' jiè','今':' jīn','俤':' dì','俦':' chóu','乆':' jiǔ','僸':' jìn','儂':' nóng','儁':' jùn','儀':' yí','僿':' sài','僾':' ài','僽':' zhòu','僼':' fēng','僻':' pì','僺':' qiào','價':' jià','僷':' yè','億':' yì','僶':' mǐn','僵':' jiāng','僴':' xiàn','僳':' sù','僲':' xian','僱':' gù','僰':' bó','僯':' lìn','僮':' tóng','僭':' jiàn','儃':' chán','儅':' dàng','僫':' è','儒':' rú','儜':' níng','儛':' wǔ','儚':' méng','儙':' qiàn','儘':' jǐn','儗':' nǐ','儖':' lán','儕':' chái','儔':' chóu','儓':' tái','儑':' án','儆':' jǐng','儐':' bīn','儏':' can','儎':' zài','儍':' shǎ','儌':' jiǎo','儋':' dān','儊':' chù','儉':' jiǎn','儈':' kuài','儇':' xuān','僬':' jiāo','僪':' jú','儞':' nǐ','僄':' piào','僎':' zhuàn','働':' dòng','僌':' yíng','僋':' tàn','僊':' xiān','僉':' qiān','僈':' mán','僇':' lù','僆':' liàn','僅':' jǐn','僃':' bèi','僐':' shàn','僂':' lóu','僁':' xiè','僀':' dì','傿':' yàn','傾':' qīng','傽':' zhāng','傼':' hàn','傻':' shǎ','傺':' chì','傹':' jìng','像':' xiàng','僑':' qiáo','僩':' xiàn','僞':' wěi','僨':' fèn','僧':' sēng','僦':' jiù','僥':' jiǎo','僤':' dàn','僣':' tiě','僢':' chuǎn','僡':' huì','僠':' bō','僟':' jī','僝':' chán','僒':' jiǒng','僜':' chēng','僛':' qī','僚':' liáo','僙':' guāng','僘':' chǎng','僗':' láo','僖':' xī','僕':' pú','僔':' zǔn','僓':' tuǐ','儝':' qióng','償':' cháng','傷':' shāng','兢':' jīng','公':' gōng','八':' bā','兪':' yú','兩':' liǎng','全':' quán','內':' nèi','兦':' wáng','入':' rù','兤':' huáng','兣':' lǐ','兠':' dōu','兮':' xī','兟':' shēn','兞':' máo','兝':' fēn','兜':' dōu','兛':' qiān','党':' dǎng','兘':' shǐ','兗':' yǎn','兖':' yǎn','兕':' sì','六':' liù','兯':' han','兓':' jīn','兼':' jiān','円':' yuán','内':' nèi','冄':' rǎn','冃':' mào','冂':' jiōng','冁':' chǎn','冀':' jì','兿':' yì','兾':' jì','兽':' shòu','养':' yǎng','兰':' lán','兺':' fēn','兹':' zī','典':' diǎn','具':' jù','其':' qí','兵':' bīng','兴':' xìng','关':' guān','兲':' tiān','共':' gòng','兔':' tù','兒':' ér','儠':' liè','儬':' chèn','儶':' huì','儵':' shū','儴':' ráng','儳':' chán','儲':' chǔ','儱':' lǒng','儰':' wěi','儯':' téng','儮':' lì','儭':' chèn','儫':' háo','儸':' luó','優':' yōu','儩':' sì','儨':' zhí','儧':' zǎn','儦':' biāo','儥':' yù','儤':' bào','儣':' kuǎng','儢':' lǚ','儡':' lěi','儷':' lì','儹':' zǎn','兑':' duì','兆':' zhào','児':' ér','兏':' cháng','兎':' tù','免':' miǎn','兌':' duì','克':' kè','兊':' duì','光':' guāng','先':' xiān','兇':' xiōng','充':' chōng','儺':' nuó','兄':' xiōng','元':' yuán','兂':' zān','允':' yǔn','兀':' wù','儿':' ér','儾':' nàng','儽':' léi','儼':' yǎn','儻':' tǎng','傸':' chuǎng','傶':' zú','俧':' zhi','倧':' zōng','倱':' hùn','倰':' lèng','倯':' sōng','倮':' luǒ','倭':' wō','倬':' zhuō','倫':' lún','倪':' ní','倩':' qiàn','倨':' jù','倦':' juàn','倳':' zì','倥':' kōng','値':' zhí','倣':' fǎng','倢':' jié','倡':' chàng','倠':' suī','借':' jiè','倞':' jìng','倝':' gàn','倜':' tì','倲':' dōng','倴':' bèn','倚':' yǐ','偁':' chēng','偋':' bìng','偊':' yǔ','偉':' wěi','偈':' jì','假':' jiǎ','偆':' chǔn','偅':' zhòng','偄':' ruǎn','偃':' yǎn','偂':' jiān','偀':' yīng','倵':' wǔ','倿':' qie','倾':' qīng','倽':' shà','值':' zhí','倻':' yē','债':' zhài','倹':' jiǎn','倸':' cǎi','倷':' nǎi','倶':' jù','倛':' qī','候':' hòu','偍':' tí','俳':' pái','俽':' xīn','俼':' yù','俻':' bèi','俺':' ǎn','俹':' yà','俸':' fèng','俷':' fèi','俶':' chù','俵':' biào','俴':' jiàn','俲':' xiào','俿':' hǔ','俱':' jù','俰':' huò','俯':' fǔ','修':' xiū','俭':' jiǎn','俬':' sī','俫':' lái','俪':' lì','俩':' liǎ','俨':' yǎn','俾':' bǐ','倀':' chāng','倘':' tǎng','倍':' bèi','倗':' péng','倖':' xìng','倕':' chuí','倔':' jué','倓':' tán','倒':' dào','們':' men','倐':' shū','倏':' shū','倎':' tiǎn','倌':' guān','倁':' zhī','個':' gè','倊':' zòng','倉':' cāng','倈':' lái','倇':' wǎn','倆':' liǎ','倅':' cuì','倄':' yáo','倃':' jiù','倂':' bìng','偌':' ruò','偎':' wēi','債':' zhài','傐':' hào','傚':' xiào','備':' bèi','傘':' sǎn','傗':' chù','傖':' cāng','傕':' jué','傔':' qiàn','傓':' shàn','傒':' xī','傑':' jié','傏':' táng','傜':' yáo','傎':' diān','傍':' bàng','傌':' mà','傋':' jiǎng','傊':' yùn','傉':' nù','傈':' lì','傇':' rǒng','傆':' yuàn','傅':' fù','傛':' yǒng','傝':' tàn','傃':' sù','傪':' cān','傴':' yǔ','傳':' chuán','傲':' ào','傱':' sǒng','傰':' bēng','傯':' zǒng','傮':' zāo','傭':' yōng','催':' cuī','傫':' lěi','傩':' nuó','傞':' suō','储':' chǔ','傧':' bīn','傦':' gu','傥':' tǎng','傤':' zài','傣':' dǎi','傢':' jiā','傡':' bìng','傠':' fā','傟':' yǎng','傄':' xiā','傂':' zhì','偏':' piān','偛':' chā','健':' jiàn','偤':' yóu','偣':' yān','偢':' chǒu','偡':' zhàn','偠':' yǎo','偟':' huáng','偞':' xiè','偝':' bèi','停':' tíng','做':' zuò','偧':' zhā','偙':' dì','偘':' kǎn','偗':' shěng','偖':' chě','偕':' xié','偔':' è','偓':' wò','偒':' tǎng','偑':' fēng','偐':' yàn','偦':' xǔ','偨':' cī','傁':' sǒu','偶':' ǒu','傀':' guī','偿':' cháng','偾':' fèn','偽':' wěi','偼':' jié','偻':' lóu','偺':' zá','偹':' bèi','偸':' tōu','偷':' tōu','偵':' zhēn','偩':' fù','側':' cè','偳':' duān','偲':' cāi','偱':' xún','偰':' xiè','偯':' yǐ','偮':' jí','偭':' miǎn','偬':' zǒng','偫':' zhì','偪':' bī','乇':' tuō','久':' jiǔ','䪁':' bǔ','䮩':' gú','䮳':' fán','䮲':' huáng','䮱':' zhú','䮰':' zhé','䮯':' ào','䮮':' mài','䮭':' mì','䮬':' mò','䮫':' lóu','䮪':' chéng','䮨':' zǎi','䮵':' tóng','䮧':' hàn','䮥':' lì','䮤':' hé','䮢':' zhá','䮡':' bì','䮠':' bī','䮟':' sōu','䮞':' chǔn','䮝':' hún','䮜':' zhá','䮴':' dèng','䮷':' dú','䮚':' lèng','䯅':' niè','䯏':' guā','䯎':' gàn','䯍':' líng','䯌':' kāo','䯋':' bó','䯊':' qià','䯉':' wā','䯈':' wán','䯇':' kū','䯆':' yì','䯄':' guā','䮸':' wò','䯂':' shēn','䯁':' luó','䯀':' niè','䮿':' jiǎn','䮾':' lóng','䮽':' biāo','䮼':' lín','䮻':' chì','䮺':' jì','䮹':' wèi','䮛':' fù','䮙':' yù','䯑':' kuāng','䭮':' fú','䭸':' bǎo','䭷':' máo','䭶':' qí','䭵':' fán','䭴':' huán','䭳':' wèi','䭲':' yǐ','䭱':' bié','䭰':' bèng','䭯':' bó','䭭':' shǒu','䭺':' ǎng','䭬':' qǐ','䭫':' qǐ','䭪':' liáng','䭩':' mó','䭨':' shuì','䭧':' mǐ','䭦':' bō','䭥':' xuè','䭤':' qiǎn','䭣':' cí','䭹':' áng','䭻':' fù','䮘':' ér','䮋':' lì','䮗':' àn','䮖':' chāng','䮕':' zhuó','䮔':' zuī','䮓':' zhuō','䮒':' pū','䮑':' lèi','䮏':' wú','䮎':' xì','䮍':' niǎo','䮊':' yí','䭼':' qí','䮉':' lú','䮈':' chí','䮇':' yù','䮄':' xuán','䮂':' bá','䮁':' pián','䮀':' bó','䭿':' yì','䭾':' tuó','䭽':' qún','䯐':' hái','䯒':' héng','䭡':' èn','䰘':' liú','䰢':' xìng','䰡':' chì','䰠':' shén','䰟':' hún','䰞':' zhǔ','䰝':' zèng','䰜':' lì','䰛':' lì','䰚':' wén','䰙':' yǐ','䰖':' zuǎn','䰤':' dōng','䰕':' lú','䰔':' pán','䰓':' mián','䰒':' méng','䰐':' lán','䰏':' jì','䰎':' kuì','䰍':' cì','䰌':' zǒng','䰋':' mán','䰣':' wǎng','䰥':' huò','䰉':' pán','䰴':' qì','䰿':' tuó','䰾':' bā','䰽':' bèi','䰼':' qín','䰻':' yú','䰺':' jiè','䰹':' zé','䰸':' gōng','䰷':' bàng','䰵':' zī','䰲':' yà','䰦':' pǐ','䰱':' líng','䰰':' rú','䰯':' yì','䰭':' nòu','䰬':' jú','䰫':' chāo','䰪':' mèi','䰩':' chě','䰨':' mèi','䰧':' hū','䰊':' bó','䰈':' cuó','䯓':' kuī','䯟':' duì','䯪':' kǎo','䯨':' qiāo','䯧':' qǐng','䯦':' mà','䯥':' àn','䯤':' kuài','䯣':' kuì','䯢':' mó','䯡':' jiàn','䯠':' ǎo','䯞':' kuā','䯬':' duǒ','䯝':' suǐ','䯜':' tì','䯛':' wàn','䯚':' yǎo','䯙':' pò','䯘':' huàn','䯗':' bì','䯖':' láng','䯕':' tīng','䯔':' zé','䯫':' hào','䯭':' xiān','䰇':' qí','䯺':' kuò','䰆':' róu','䰄':' sāi','䰃':' péng','䰂':' cài','䰁':' fèi','䰀':' wǒ','䯿':' zú','䯾':' tiáo','䯽':' póu','䯼':' dí','䯹':' xiān','䯮':' nái','䯸':' cì','䯷':' sōng','䯶':' mán','䯵':' niè','䯴':' cháng','䯳':' sōng','䯲':' pā','䯱':' pī','䯰':' jiè','䯯':' suō','䭢':' níng','䭠':' jiǎn','䱁':' qiáo','䫇':' rán','䫑':' yī','䫐':' lín','䫏':' qī','䫎':' zhuō','䫍':' fǔ','䫌':' pǐ','䫋':' wēi','䫊':' péi','䫉':' mào','䫈':' chěn','䫆':' chéng','䫓':' wú','䫅':' sàn','䫄':' chuà','䫃':' chún','䫂':' duǒ','䫁':' bì','䫀':' gěn','䪿':' shěng','䪾':' zhěn','䪽':' hào','䪼':' zhuō','䫒':' mén','䫔':' qì','䪺':' gé','䫡':' yán','䫬':' zhěn','䫫':' lóu','䫪':' shuǎng','䫩':' sǎn','䫨':' ào','䫦':' gé','䫥':' kuǐ','䫤':' míng','䫣':' xí','䫢':' sī','䫠':' pī','䫕':' dié','䫟':' hùn','䫞':' qiāo','䫝':' fǔ','䫜':' āo','䫛':' hóu','䫚':' guā','䫙':' sǎng','䫘':' hé','䫗':' xiá','䫖':' chěn','䪻':' biàn','䪹':' bāi','䫮':' chán','䪍':' lán','䪗':' xiá','䪖':' pò','䪕':' jú','䪔':' bǔ','䪓':' diē','䪒':' zhù','䪑':' tuó','䪐':' bì','䪏':' nà','䪎':' suī','䪌':' zhàn','䪙':' pò','䪋':' wèi','䪊':' lóng','䪉':' liè','䪈':' qiàn','䪇':' bó','䪆':' tǐ','䪅':' dú','䪄':' huáng','䪃':' dūn','䪂':' gé','䪘':' wěi','䪚':' dā','䪸':' mín','䪭':' ruǎn','䪷':' hòu','䪶':' jū','䪵':' yǎ','䪴':' zhěn','䪳':' yǔn','䪲':' kūn','䪱':' gǎi','䪰':' yī','䪯':' yīng','䪮':' chǒu','䪬':' bó','䪛':' fān','䪫':' jīng','䪩':' yín','䪨':' báo','䪧':' chí','䪦':' hóng','䪥':' xiè','䪤':' fán','䪞':' zá','䪝':' hù','䪜':' chān','䫭':' huì','䫰':' lìn','䭟':' yè','䬷':' shě','䭂':' yì','䭁':' zhì','䭀':' xùn','䬿':' wěi','䬾':' tí','䬽':' shuì','䬼':' yuàn','䬻':' jiàn','䬺':' yàng','䬹':' zhì','䬶':' èn','䭄':' shì','䬵':' gāi','䬴':' mò','䬳':' bǎn','䬲':' gōu','䬱':' bèn','䬰':' shào','䬯':' nián','䬮':' yí','䬬':' yǐng','䬫':' tí','䭃':' rěn','䭅':' hú','䬨':' jiù','䭓':' èn','䭞':' yì','䭝':' kuài','䭛':' dàn','䭚':' chuáng','䭙':' jǐn','䭘':' yǐng','䭗':' yǐng','䭖':' zhù','䭕':' zǎn','䭔':' duī','䭒':' xī','䭆':' nè','䭑':' lián','䭐':' yàng','䭎':' yè','䭍':' hú','䭌':' hú','䭋':' bǎo','䭊':' yǐng','䭉':' suǐ','䭈':' jiàn','䭇':' yē','䬪':' bó','䬧':' yuán','䫱':' ná','䫽':' pāo','䬇':' yuàn','䬆':' lì','䬅':' lì','䬄':' xù','䬃':' sà','䬂':' xuè','䬁':' yí','䬀':' yǒu','䫿':' chāo','䫾':' bī','䫼':' xuè','䬉':' huò','䫻':' yù','䫺':' hóng','䫹':' hóng','䫸':' chāo','䫷':' è','䫶':' fán','䫵':' mián','䫴':' jìn','䫳':' dú','䫲':' hàn','䬈':' duì','䬊':' shà','䬦':' dòu','䬗':' yáng','䬥':' yì','䬤':' zàn','䬣':' xì','䬡':' zhù','䬟':' liú','䬞':' táo','䬝':' héng','䬛':' bì','䬙':' yáo','䬘':' xiāo','䬖':' héng','䬋':' léng','䬕':' xiāng','䬔':' yú','䬓':' àn','䬒':' sōu','䬑':' wèi','䬐':' ruí','䬏':' bù','䬎':' guó','䬍':' hū','䬌':' pōu','䱀':' yāng','䱂':' yǒu','乄':' wu','䵩':' lí','䵳':' wèi','䵲':' qiāo','䵱':' xì','䵰':' shāng','䵯':' tuǎn','䵮':' yàng','䵭':' zhè','䵬':' tà','䵫':' xūn','䵪':' gùn','䵨':' máng','䵵':' chuā','䵧':' zài','䵦':' xiè','䵥':' yù','䵤':' jiǎn','䵣':' dá','䵢':' mèi','䵡':' jiǎn','䵠':' dí','䵟':' gǎn','䵞':' jìng','䵴':' yìng','䵶':' qú','䵜':' nǒng','䶄':' píng','䶎':' hē','䶍':' dì','䶌':' pào','䶋':' xī','䶊':' nǜ','䶉':' liú','䶈':' bó','䶇':' zhòu','䶆':' zhuī','䶅':' hé','䶃':' hán','䵷':' wā','䶂':' zhuó','䶁':' tà','䶀':' tà','䵿':' tiè','䵾':' fú','䵽':' cà','䵼':' shāng','䵻':' gǔ','䵺':' tǐng','䵹':' zhī','䵝':' yì','䵛':' qiàn','䶐':' wài','䴴':' tiè','䴾':' cuó','䴽':' pí','䴼':' chàn','䴻':' lí','䴺':' bù','䴹':' guǒ','䴸':' fū','䴷':' hún','䴶':' péng','䴵':' bǐng','䴳':' huá','䵀':' suǒ','䴲':' mò','䴱':' tuō','䴰':' shú','䴯':' hū','䴮':' shàn','䴭':' cái','䴬':' yì','䴫':' líng','䴪':' lù','䴩':' piáo','䴿':' méng','䵁':' qiàng','䵚':' tǎo','䵏':' lǎo','䵙':' zhā','䵘':' shài','䵗':' bó','䵖':' qiàn','䵕':' jù','䵔':' dǒng','䵓':' lí','䵒':' nì','䵑':' nì','䵐':' chǎn','䵎':' tuān','䵂':' zhí','䵌':' xiān','䵋':' wěi','䵊':' tuān','䵉':' tóu','䵈':' kù','䵇':' xiàn','䵆':' méng','䵅':' áo','䵄':' bí','䵃':' kuàng','䶏':' tì','䶑':' tì','䴦':' yín','丟':' diū','丩':' jiū','丨':' gǔn','丧':' sàng','並':' bìng','严':' yán','两':' liǎng','丣':' yǒu','丢':' diū','両':' liǎng','丠':' qiū','丞':' chéng','丫':' yā','丝':' sī','东':' dōng','丛':' cóng','业':' yè','丙':' bǐng','丘':' qiū','丗':' shì','世':' shì','丕':' pī','且':' qiě','个':' gè','丬':' qiáng','丒':' chǒu','丹':' dān','乃':' nǎi','乂':' yì','乁':' yí','乀':' fú','丿':' piě','举':' jǔ','丽':' lì','丼':' jǐng','主':' zhǔ','为':' wèi','丸':' wán','中':' zhōng','丷':' ha','丶':' zhǔ','丵':' zhuó','临':' lín','丳':' chǎn','串':' chuàn','丱':' guàn','丰':' fēng','丯':' jiè','丮':' jǐ','专':' zhuān','丑':' chǒu','䶒':' qí','䶞':' qí','䶨':' zhān','䶧':' yǎo','䶦':' zé','䶥':' zhā','䶤':' huá','䶣':' ái','䶢':' jiān','䶡':' shí','䶠':' jiǎn','䶟':' xiàn','䶝':' qià','䶪':' chà','䶜':' gǔ','䶛':' là','䶚':' qǔ','䶙':' jù','䶘':' lì','䶗':' kè','䶖':' jìn','䶕':' bà','䶔':' chí','䶓':' jì','䶩':' jì','䶫':' yàn','丐':' gài','丅':' xià','丏':' miǎn','与':' yǔ','不':' bù','丌':' jī','下':' xià','上':' shàng','三':' sān','丈':' zhàng','万':' wàn','丆':' hǎn','丄':' shàng','䶬':' jiān','七':' qī','丂':' kǎo','丁':' dīng','一':' yī','䶵':' chí','䶳':' yuè','䶲':' nán','䶱':' tóng','䶰':' jiāo','䶮':' yǎn','䴧':' wēi','䴥':' jiā','䱃':' zhì','䲊':' duò','䲔':' qíng','䲓':' yǎn','䲒':' xiè','䲑':' yí','䲐':' lǔ','䲏':' láo','䲎':' něi','䲍':' téng','䲌':' kuǎn','䲋':' cén','䲉':' sī','䲖':' chóu','䲆':' sū','䲅':' guī','䲄':' mín','䲃':' zǎo','䲂':' xuán','䲁':' wèi','䲀':' zhì','䱿':' chàn','䱾':' lóu','䱼':' zhǎn','䲕':' pū','䲗':' xián','䱺':' hái','䲧':' dù','䲴':' zhèn','䲳':' háng','䲲':' gōng','䲱':' fǎng','䲰':' yùn','䲯':' jí','䲮':' yuán','䲬':' qí','䲪':' xì','䲨':' hóng','䲦':' dài','䲘':' guǎn','䲣':' yú','䲢':' téng','䲡':' qiū','䲠':' chūn','䲟':' yìn','䲞':' lì','䲜':' yè','䲛':' méng','䲚':' lài','䲙':' jié','䱻':' huá','䱹':' zhǎ','䲸':' jiè','䱏':' tǒu','䱙':' shū','䱘':' lí','䱗':' cān','䱖':' liú','䱕':' móu','䱔':' tiáo','䱓':' tíng','䱒':' yè','䱑':' xué','䱐':' fū','䱎':' gèng','䱛':' huò','䱍':' gèng','䱌':' yí','䱋':' gǒng','䱊':' mǐ','䱉':' shàn','䱈':' qí','䱇':' shàn','䱆':' shéng','䱅':' mò','䱄':' jiè','䱚':' lù','䱜':' cuò','䱸':' sōu','䱭':' gèng','䱷':' yú','䱶':' láng','䱵':' wēng','䱴':' gèng','䱳':' zhān','䱲':' yuán','䱱':' tí','䱰':' zhòng','䱯':' mú','䱮':' é','䱬':' xū','䱝':' pái','䱫':' là','䱨':' là','䱥':' zhì','䱤':' xiàn','䱣':' zú','䱢':' zhēng','䱡':' jú','䱠':' zhàn','䱟':' jù','䱞':' liú','䲵':' què','䲹':' pí','䴤':' shēng','䳾':' dēng','䴈':' ǎo'};exports.default=DICTIONARY;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var DICTIONARY={'䴇':' líng','䴆':' pú','䴅':' fén','䴄':' shùn','䴃':' náo','䴂':' xiàng','䴁':' yù','䴀':' tóng','䳿':' rán','䳽':' hè','䴊':' yí','䳻':' cán','䳺':' yàn','䳹':' kòu','䳸':' má','䳷':' cóng','䳶':' xī','䳵':' chì','䳴':' tà','䳳':' xù','䳲':' zhèn','䴉':' huán','䴋':' huán','䳰':' bǎo','䴙':' pì','䴣':' hū','䴢':' mí','䴡':' lì','䴠':' yǎo','䴟':' huán','䴞':' dí','䴝':' chuài','䴜':' wāi','䴛':' xiāo','䴚':' gǎng','䴗':' jú','䴌':' méng','䴖':' jīng','䴕':' liè','䴔':' jiāo','䴓':' shī','䴒':' líng','䴑':' dié','䴐':' bǎo','䴏':' yàn','䴎':' lěi','䴍':' yīng','䳱':' wù','䳯':' chóng','䲺':' gàn','䳆':' bái','䳑':' yǒu','䳐':' cì','䳏':' guì','䳎':' jiù','䳍':' gōng','䳋':' tóng','䳊':' bá','䳉':' dàn','䳈':' bǎo','䳇':' wǔ','䳅':' zhǐ','䳓':' lǎo','䳄':' cí','䳃':' wǎn','䳂':' diāo','䳁':' bó','䳀':' dié','䲿':' cí','䲾':' qiǎo','䲽':' shí','䲼':' shēng','䲻':' xuán','䳒':' yuán','䳔':' jú','䳮':' mò','䳢':' qí','䳭':' jí','䳬':' è','䳫':' kuí','䳪':' juàn','䳩':' yāo','䳨':' huáng','䳧':' hóu','䳦':' xuān','䳤':' biē','䳣':' yuán','䳡':' yàn','䳕':' fú','䳠':' shuì','䳟':' míng','䳞':' běng','䳝':' pǒu','䳜':' tú','䳛':' yàn','䳚':' kàn','䳙':' xǐng','䳘':' é','䳗':' é','䳖':' niè','䍕':' dī','䍓':' hù','冈':' gāng','㥍':' jì','㥛':' jí','㥚':' yú','㥖':' cōng','㥕':' lián','㥔':' yù','㥓':' qī','㥒':' cǎi','㥐':' yuàn','㥏':' tiǎn','㥎':' lái','㥌':' jú','㥝':' mǐ','㥋':' yī','㥊':' péng','㥉':' chè','㥈':' dié','㥇':' cán','㥆':' tuì','㥅':' shòu','㥄':' líng','㥃':' mèn','㥂':' tè','㥜':' wèi','㥞':' suì','㥀':' zhí','㥭':' tài','㥷':' yè','㥶':' sè','㥵':' hùn','㥴':' yí','㥳':' yuán','㥲':' chēn','㥱':' fěi','㥰':' sāo','㥯':' yǐn','㥮':' zhòu','㥬':' páng','㥟':' xié','㥪':' lóu','㥩':' duǒ','㥨':' shuì','㥧':' shùn','㥦':' qiè','㥥':' yú','㥣':' huì','㥢':' qiú','㥡':' chì','㥠':' xū','㥁':' dé','㤿':' yān','㥹':' fěn','㤓':' bèn','㤟':' kǒng','㤞':' chà','㤝':' chōng','㤜':' jué','㤛':' nín','㤚':' háng','㤘':' zhòu','㤖':' zhù','㤕':' chù','㤔':' fù','㤒':' gāo','㤡':' lì','㤑':' yòu','㤐':' chān','㤏':' tóng','㤎':' gē','㤍':' qiāo','㤌':' gān','㤋':' fēn','㤊':' xiào','㤉':' qiā','㤈':' qìn','㤠':' liè','㤢':' yù','㤾':' sàn','㤱':' fù','㤽':' chóu','㤺':' huǎng','㤹':' qiú','㤸':' xì','㤷':' hān','㤶':' máng','㤵':' cí','㤴':' chè','㤳':' běi','㤲':' qiè','㤰':' zuò','㤤':' yú','㤯':' jiǒng','㤮':' guàng','㤬':' huì','㤫':' dé','㤪':' yuàn','㤩':' kè','㤨':' gǒng','㤧':' hóu','㤦':' lì','㤥':' hài','㥸':' mǐn','㥺':' hé','㤆':' fàn','㧁':' qù','㧋':' xuǎn','㧊':' pō','㧉':' gài','㧈':' yǐn','㧇':' mǎo','㧆':' jīn','㧅':' mù','㧄':' qiǎn','㧃':' shōu','㧂':' tián','㧀':' jí','㧍':' fǎng','㦿':' qiǎn','㦾':' yí','㦽':' yù','㦼':' shuàng','㦻':' xí','㦺':' rù','㦹':' yáng','㦸':' jǐ','㦷':' yǒng','㦶':' dié','㧌':' mào','㧎':' yá','㦴':' gé','㧜':' liè','㧪':' guǐ','㧩':' pèi','㧨':' qiú','㧦':' xuàn','㧥':' xiǎn','㧤':' chòng','㧣':' zhū','㧢':' yīn','㧡':' hài','㧟':' kuǎi','㧚':' wǎ','㧏':' gāng','㧙':' bì','㧘':' zì','㧗':' zǐ','㧖':' è','㧕':' liǔ','㧔':' guài','㧓':' guā','㧒':' yù','㧑':' huī','㧐':' sǒng','㦵':' zhū','㦱':' wǒ','㥼':' yìn','㦉':' yì','㦓':' xiàn','㦒':' lí','㦑':' xiàn','㦐':' nì','㦏':' sǔn','㦎':' huò','㦍':' è','㦌':' hū','㦋':' zhā','㦊':' huá','㦇':' lù','㦕':' lóng','㦆':' hū','㦅':' diē','㦄':' má','㦃':' chǎn','㦂':' cháng','㦁':' lián','㦀':' féng','㥿':' ào','㥾':' nì','㥽':' cè','㦔':' yàn','㦖':' mèn','㦰':' jiān','㦥':' xuān','㦯':' huò','㦮':' qián','㦭':' líng','㦬':' luǒ','㦫':' zā','㦪':' xiè','㦩':' yǐn','㦨':' lán','㦧':' cǎn','㦦':' xì','㦤':' yì','㦗':' jīn','㦣':' wèi','㦢':' jié','㦡':' lè','㦟':' mái','㦞':' chóu','㦝':' miǎo','㦜':' huò','㦛':' yǔ','㦚':' biǎn','㦘':' jī','㤇':' ǎo','㤅':' ài','㧬':' gǒng','㡕':' yīng','㡟':' zāo','㡞':' lóu','㡝':' fèng','㡜':' xiè','㡛':' máng','㡚':' gōu','㡙':' bī','㡘':' lián','㡗':' tí','㡖':' chuáng','㡔':' wù','㡡':' chú','㡓':' kūn','㡒':' zhūn','㡑':' qiāo','㡏':' shù','㡌':' mào','㡋':' yé','㡊':' qià','㡉':' xián','㡈':' wèn','㡇':' zhé','㡠':' zhèng','㡢':' màn','㡄':' xún','㡱':' jiǔ','㡻':' liào','㡺':' dàn','㡹':' jū','㡸':' zhà','㡷':' běn','㡶':' zhǐ','㡵':' líng','㡴':' lā','㡳':' zhǐ','㡲':' huán','㡰':' yǔ','㡣':' lóng','㡯':' zhái','㡮':' jí','㡭':' jì','㡫':' yì','㡪':' nié','㡩':' luán','㡨':' jiān','㡧':' zhèng','㡦':' pīn','㡥':' yìn','㡅':' nuǒ','㡃':' huāng','㡽':' zhào','㠕':' wěi','㠠':' lú','㠟':' lí','㠝':' cuán','㠜':' nì','㠛':' wò','㠚':' duì','㠙':' háo','㠘':' yǔ','㠗':' ào','㠖':' yǐ','㠔':' bài','㠢':' huái','㠓':' méng','㠒':' biǎo','㠑':' zuì','㠐':' jiào','㠏':' huá','㠎':' jí','㠍':' jí','㠌':' qī','㠋':' è','㠊':' qū','㠡':' niǎo','㠣':' lì','㡂':' lì','㠶':' fán','㡁':' kuǎ','㡀':' bì','㠿':' zī','㠾':' yuān','㠽':' tóng','㠼':' sī','㠺':' shā','㠹':' jiè','㠸':' kù','㠷':' gé','㠵':' huāng','㠥':' lǜ','㠴':' rèn','㠲':' bǐ','㠱':' jì','㠯':' yǐ','㠮':' pēng','㠭':' zhǎn','㠪':' jù','㠨':' yù','㠧':' mǐ','㠦':' fēng','㡼':' yì','㡾':' xiàn','㤄':' pèi','㣑':' róng','㣟':' xì','㣞':' duó','㣝':' sōng','㣜':' xíng','㣛':' tà','㣚':' tǒng','㣙':' dí','㣔':' dīng','㣓':' càn','㣒':' cèng','㣐':' biàn','㣢':' tí','㣏':' jìng','㣎':' mù','㣍':' tái','㣌':' shàn','㣈':' sì','㣇':' yì','㣆':' mí','㣅':' zàn','㣄':' qú','㣃':' yǔ','㣠':' tāo','㣣':' shàn','㣁':' bèi','㣵':' tà','㤃':' fáng','㤂':' jí','㤁':' miǎn','㣿':' zhuó','㣾':' chà','㣽':' shù','㣼':' rěn','㣻':' yì','㣷':' nìng','㣶':' zhān','㣲':' wéi','㣤':' jiàn','㣱':' zé','㣰':' xiè','㣯':' xiè','㣭':' zōng','㣬':' qì','㣫':' zhǒng','㣪':' huǎn','㣧':' yìn','㣦':' wēi','㣥':' zhì','㣂':' è','㣀':' zhèn','㡿':' chì','㢍':' yǐng','㢙':' qín','㢘':' lián','㢗':' qiào','㢖':' pān','㢔':' zǒng','㢓':' yǎo','㢒':' chá','㢑':' tuí','㢏':' tóu','㢎':' zhé','㢋':' chǐ','㢛':' yàn','㢊':' ǎi','㢉':' chá','㢈':' tuí','㢆':' chán','㢅':' lòng','㢄':' dòu','㢃':' láng','㢂':' yǎn','㢁':' chǐ','㢀':' cì','㢚':' lǔ','㢜':' kàng','㢾':' juàn','㢯':' diāo','㢽':' ěr','㢼':' biè','㢻':' ruì','㢺':' xián','㢸':' bì','㢶':' bì','㢵':' xié','㢳':' lú','㢲':' xùn','㢰':' bì','㢮':' chí','㢝':' sū','㢬':' hóng','㢩':' dì','㢨':' hàn','㢧':' juàn','㢥':' dòng','㢣':' jìng','㢡':' jiǎng','㢠':' jiǒng','㢟':' chān','㢞':' yì','㧫':' ér','㧭':' qióng','㠈':' rùn','㬭':' jiào','㬸':' tiāo','㬶':' hào','㬵':' xiáo','㬴':' hǒng','㬳':' wǔ','㬲':' tiān','㬱':' tì','㬰':' yú','㬯':' liè','㬮':' nàn','㬬':' jù','㬻':' huāng','㬫':' yàn','㬪':' dié','㬩':' huì','㬧':' bó','㬦':' yuè','㬥':' pù','㬤':' qī','㬣':' duì','㬡':' líng','㬠':' shài','㬹':' zhēng','㬼':' fù','㬞':' hè','㭒':' sì','㭞':' liè','㭝':' qiú','㭜':' róng','㭛':' pài','㭚':' lǚ','㭙':' zhé','㭘':' gé','㭕':' qū','㭔':' lú','㭓':' biàn','㭑':' mèi','㬿':' tūn','㭏':' wěi','㭎':' gāng','㭌':' móu','㭋':' bàng','㭉':' huá','㭈':' jué','㭇':' yuàn','㭄':' xìn','㭂':' jiǎo','㭁':' réng','㬟':' fēn','㬝':' céng','㭠':' xiǎn','㫯':' mào','㫻':' kùn','㫹':' shù','㫸':' jiē','㫷':' jī','㫶':' zhǒu','㫵':' fēi','㫳':' chén','㫲':' bèi','㫱':' nǎn','㫰':' làng','㫫':' xiǎn','㫽':' lù','㫨':' ān','㫧':' bào','㫦':' tāo','㫥':' mǐng','㫤':' chǎng','㫢':' qù','㫟':' yán','㫝':' dī','㫜':' tǎn','㫛':' guàng','㫼':' dié','㬂':' yú','㬜':' jìn','㬏':' lì','㬛':' xī','㬚':' chè','㬙':' wěi','㬘':' sù','㬗':' xiàn','㬕':' yáng','㬔':' háo','㬓':' piào','㬒':' mǎng','㬐':' jìn','㬎':' xiǎn','㬃':' tái','㬍':' bó','㬌':' jìng','㬋':' hóu','㬊':' huàn','㬉':' nuǎn','㬈':' wēn','㬇':' huàn','㬆':' mǐn','㬅':' màn','㬄':' chàn','㭟':' gǒng','㭡':' xì','㫙':' fú','㮰':' pí','㮾':' lǎng','㮺':' běn','㮹':' zhǐ','㮸':' sòng','㮷':' jī','㮶':' shuò','㮵':' zhān','㮳':' zhèn','㮲':' chōu','㮱':' shēn','㮯':' hún','㯀':' xuàn','㮮':' jié','㮭':' xián','㮬':' wēng','㮫':' hé','㮪':' qióng','㮩':' xī','㮨':' jì','㮧':' wū','㮦':' suǒ','㮥':' bèn','㮿':' bì','㯁':' péi','㮢':' hóu','㯏':' gǔ','㯛':' hú','㯚':' tā','㯙':' zhé','㯘':' kuǎn','㯗':' xián','㯖':' dé','㯕':' xī','㯔':' cuì','㯓':' tà','㯐':' fǎng','㯎':' nèn','㯂':' dài','㯍':' jiǎng','㯌':' chuán','㯋':' jiǒng','㯊':' hén','㯉':' huò','㯈':' sù','㯇':' bì','㯆':' chǎn','㯅':' pí','㯄':' zhī','㮣':' gài','㮡':' guàn','㭢':' xīn','㭲':' jí','㮀':' hán','㭿':' áng','㭾':' jué','㭽':' dǐ','㭼':' tà','㭻':' táng','㭺':' yǎn','㭹':' xián','㭸':' tú','㭴':' jiān','㭱':' hé','㮂':' jú','㭰':' zuī','㭯':' zhé','㭮':' zuò','㭭':' bā','㭬':' zhuó','㭫':' cuó','㭪':' fū','㭩':' liè','㭨':' xié','㭤':' niǎo','㮁':' xiáo','㮃':' wēi','㮟':' niǎn','㮔':' chòng','㮞':' jié','㮝':' hé','㮜':' zāng','㮛':' chí','㮚':' lì','㮙':' è','㮘':' máo','㮗':' qín','㮖':' jiá','㮕':' ruǎn','㮓':' gèn','㮄':' bǎng','㮒':' yān','㮑':' chā','㮐':' shěng','㮏':' nài','㮌':' mián','㮋':' yǒu','㮈':' nài','㮇':' tiàn','㮆':' niè','㮅':' zhuī','㫚':' hū','㫘':' mì','㧮':' hū','㨱':' yáo','㨻':' cán','㨺':' miǎn','㨹':' huì','㨸':' mà','㨷':' jìn','㨶':' dǎo','㨵':' jiǎn','㨴':' jiàn','㨳':' guǐ','㨲':' cè','㨰':' gǔn','㨽':' pì','㨯':' huò','㨮':' dōu','㨭':' hù','㨫':' lǎn','㨪':' huàng','㨩':' jié','㨨':' chōu','㨧':' bèn','㨦':' sǒng','㨥':' nà','㨼':' lüè','㨾':' yàng','㨢':' pī','㩍':' cè','㩚':' méng','㩙':' sāi','㩘':' nǐ','㩗':' xí','㩖':' qiáng','㩔':' tún','㩓':' huǐ','㩒':' qín','㩐':' dèn','㩎':' yè','㩌':' fèi','㨿':' jù','㩋':' xiāo','㩊':' xuān','㩉':' dá','㩈':' yǔn','㩇':' huò','㩆':' jiù','㩄':' shāi','㩃':' qiān','㩁':' què','㩀':' jù','㨤':' huì','㨡':' hún','㩜':' lǎn','㧺':' tà','㨅':' nèi','㨄':' zhōu','㨃':' duǐ','㨂':' dǒng','㨁':' zhì','㨀':' bǐng','㧾':' hū','㧽':' gù','㧼':' biào','㧻':' zhuó','㧹':' tè','㨇':' pó','㧸':' pēng','㧷':' tùn','㧶':' kēng','㧵':' póu','㧴':' wǒ','㧳':' zhuò','㧲':' sǎn','㧱':' chèn','㧰':' lì','㧯':' lǎo','㨆':' lǐn','㨈':' jǐ','㨠':' mì','㨕':' yíng','㨟':' hāi','㨞':' sù','㨝':' xiē','㨜':' qián','㨛':' shǎn','㨚':' xún','㨙':' xié','㨘':' xǐng','㨗':' jié','㨖':' zhì','㨔':' hàn','㨉':' mín','㨓':' láo','㨒':' kuī','㨑':' zōng','㨐':' bǔ','㨏':' tān','㨎':' rú','㨍':' bāng','㨌':' gòu','㨋':' chě','㨊':' wěi','㩛':' tuán','㩝':' háo','㫗':' hòu','㪦':' yìn','㪱':' huàn','㪯':' chá','㪮':' líng','㪭':' lú','㪬':' chuō','㪫':' ruì','㪪':' sà','㪩':' sù','㪨':' shàn','㪧':' xī','㪥':' zhā','㪵':' bàn','㪤':' bì','㪣':' xiāo','㪢':' shǎo','㪡':' kài','㪠':' qiān','㪞':' mào','㪝':' liàn','㪜':' chuǎi','㪛':' zhěn','㪚':' sàn','㪴':' jiá','㪶':' hú','㪘':' liǎn','㫄':' páng','㫔':' gèn','㫓':' qǐ','㫒':' gǒng','㫑':' zhǐ','㫐':' yǎo','㫏':' yǎo','㫎':' huī','㫍':' yóu','㫊':' yǐ','㫅':' chá','㫃':' yǎn','㪷':' dǒu','㫂':' zhù','㫁':' duàn','㫀':' dǐng','㪿':' zhé','㪾':' luò','㪽':' suǒ','㪼':' kě','㪻':' juàn','㪺':' jū','㪹':' lǒu','㪙':' kě','㪗':' tǒu','㩞':' cì','㩮':' qián','㩸':' dié','㩷':' qiān','㩶':' niè','㩵':' è','㩴':' jú','㩳':' sǒng','㩲':' kǔn','㩱':' jué','㩰':' jiǎo','㩯':' pó','㩭':' bó','㩻':' qī','㩪':' xié','㩩':' qǐng','㩨':' huì','㩧':' bó','㩦':' xié','㩤':' fū','㩢':' miè','㩡':' luǒ','㩠':' āo','㩟':' zhài','㩹':' dié','㩼':' zhī','㪖':' lù','㪋':' hàn','㪕':' diào','㪔':' sàn','㪓':' chuái','㪒':' ní','㪑':' yè','㪐':' lù','㪏':' bǐ','㪎':' shǎn','㪍':' bó','㪌':' tǒng','㪊':' qún','㩽':' qí','㪉':' hé','㪈':' guì','㪇':' xiàn','㪆':' dǐ','㪄':' fú','㪃':' hé','㪂':' kū','㪁':' qín','㪀':' yú','㩿':' kū','㩾':' zhuì','㠉':' tóng','㠇':' jiù','㯝':' lù','㕯':' nè','㕺':' xiāo','㕹':' fá','㕸':' lì','㕷':' huà','㕶':' ň','㕵':' guó','㕴':' chén','㕲':' huá','㕱':' yóu','㕰':' xuè','㕮':' fǔ','㕽':' sì','㕭':' āo','㕬':' gōng','㕫':' fǎng','㕪':' dǎn','㕩':' pàng','㕨':' fàn','㕧':' xī','㕦':' huà','㕥':' shēn','㕤':' qiú','㕻':' pǒu','㖀':' lè','㕢':' gài','㖔':' tǔn','㖣':' tòu','㖢':' qí','㖡':' yè','㖠':' nuò','㖟':' shòu','㖞':' wāi','㖘':' zhēn','㖗':' yín','㖖':' niè','㖕':' niè','㖓':' hóng','㖁':' lìn','㖒':' tí','㖑':' xiè','㖐':' wěi','㖏':' niè','㖊':' xún','㖇':' ér','㖆':' qú','㖅':' xù','㖃':' hǒu','㖂':' yì','㕣':' yǎn','㕡':' hé','㖥':' jùn','㔴':' yì','㔿':' zòu','㔾':' xiān','㔽':' yào','㔼':' sǔn','㔺':' shì','㔹':' lè','㔸':' tī','㔷':' lòu','㔶':' gòng','㔵':' xuǎn','㔳':' guǐ','㕂':' yín','㔱':' yǔ','㔰':' héng','㔯':' xuán','㔮':' nuó','㔭':' chè','㔪':' lǔ','㔩':' è','㔨':' bèi','㔧':' lǜ','㔦':' yǎng','㕁':' què','㕃':' xī','㕠':' shuāng','㕑':' chú','㕟':' kuì','㕞':' shuā','㕜':' shǐ','㕛':' xù','㕚':' zhǎo','㕙':' jùn','㕗':' yòu','㕖':' sù','㕕':' huàn','㕒':' wēi','㕐':' xiě','㕄':' zhǐ','㕏':' chú','㕎':' kè','㕌':' ài','㕋':' qín','㕊':' fū','㕉':' kè','㕈':' yǐ','㕇':' lā','㕆':' hù','㕅':' jiá','㖤':' hán','㖦':' dǒng','㔤':' xìn','㗼':' yè','㘇':' róng','㘆':' tǎi','㘅':' xián','㘄':' lēng','㘂':' cí','㘁':' yì','㘀':' zuò','㗿':' hé','㗾':' xuē','㗽':' xiǎng','㗻':' guō','㘉':' zhì','㗷':' sǎi','㗶':' pō','㗵':' xù','㗴':' yán','㗳':' tǎ','㗲':' huò','㗱':' jí','㗰':' cóng','㗭':' xī','㗬':' zhā','㘈':' yì','㘊':' xī','㗩':' xī','㘚':' hǎn','㘥':' yóu','㘤':' wān','㘣':' xuán','㘢':' wěng','㘡':' xiá','㘠':' bì','㘞':' huò','㘝':' niè','㘜':' chǐ','㘛':' kān','㘙':' yán','㘋':' xián','㘗':' qū','㘖':' yán','㘕':' hǎn','㘔':' sǎi','㘓':' lán','㘑':' lì','㘐':' pào','㘎':' hǎn','㘍':' jí','㘌':' jù','㗫':' qiè','㗨':' xiē','㖧':' hūn','㖺':' chǔn','㗄':' kū','㗃':' wěn','㗂':' shěng','㗁':' è','㗀':' yōu','㖿':' xié','㖾':' è','㖽':' zé','㖼':' duǒ','㖻':' niú','㖹':' pēn','㗆':' gé','㖸':' xué','㖷':' shí','㖶':' yān','㖵':' gé','㖮':' lún','㖭':' tiǎn','㖫':' líng','㖪':' huò','㖩':' jū','㖨':' lù','㗅':' hú','㗇':' xiá','㗧':' zhì','㗗':' bēi','㗦':' láo','㗥':' kuò','㗤':' cù','㗣':' tì','㗢':' hóng','㗜':' xiù','㗛':' xiào','㗚':' lì','㗙':' chū','㗘':' bó','㗖':' dàn','㗈':' màn','㗕':' gòu','㗔':' qiān','㗓':' zhuī','㗒':' ài','㗑':' bai','㗏':' wāi','㗌':' zhì','㗋':' hóu','㗊':' jí','㗉':' lüè','㔥':' bài','㔣':' léi','㘧':' xù','㑯':' xǔ','㑻':' mà','㑺':' jùn','㑹':' huì','㑸':' yáo','㑷':' tài','㑶':' xì','㑵':' hàn','㑳':' zhòu','㑱':' rǎo','㑰':' huì','㑮':' hún','㑽':' táng','㑪':' chái','㑩':' luó','㑨':' yǔ','㑧':' jì','㑦':' lì','㑥':' yì','㑤':' miáo','㑣':' lán','㑟':' běng','㑞':' yìng','㑼':' lüè','㑾':' yáo','㑜':' yì','㒌':' qióng','㒙':' mián','㒗':' tái','㒖':' ǒu','㒕':' yāng','㒔':' shú','㒓':' tà','㒒':' pú','㒑':' kuǐ','㒎':' sà','㒍':' léi','㒊':' sè','㑿':' zhào','㒉':' tǎng','㒈':' hàn','㒇':' wǔ','㒆':' chì','㒅':' qǐ','㒄':' rǎn','㒃':' èr','㒂':' zhuó','㒁':' yǔ','㒀':' zhāi','㑝':' lòng','㑛':' sù','㒛':' diào','㐫':' xiōng','㐵':' rú','㐴':' pān','㐳':' wù','㐲':' dài','㐱':' zhěn','㐰':' xìn','㐯':' yōng','㐮':' xiāng','㐭':' lǐn','㐬':' liú','㐩':' xíng','㐸':' qiàn','㐨':' xù','㐤':' dān','㐡':' nuò','㐜':' chóu','㐖':' xié','㐌':' yí','㐆':' yǐn','㐅':' wǔ','㐄':' kuà','㐁':' tiàn','㐷':' mǎ','㐹':' yì','㑚':' nuó','㑊':' yì','㑙':' dié','㑘':' jiè','㑗':' shēn','㑔':' xǔ','㑐':' shū','㑏':' zhù','㑎':' nǎo','㑍':' lèi','㑌':' kuāng','㑋':' qióng','㑉':' sù','㐺':' yín','㑈':' dòng','㑇':' zhòu','㑅':' zuò','㑄':' wǔ','㑃':' ǎo','㑂':' fǎng','㑁':' zhuō','㐽':' fēng','㐼':' chèng','㐻':' nèi','㒚':' yìn','㒜':' yǔ','㔢':' jué','㓴':' ruǎn','㔀':' lüè','㓾':' xī','㓽':' chóng','㓼':' chì','㓺':' jiān','㓹':' ruì','㓸':' zhuō','㓷':' yì','㓶':' qiè','㓵':' è','㓳':' dī','㔂':' lín','㓲':' piān','㓱':' tóu','㓰':' huà','㓯':' lí','㓭':' shé','㓪':' lǎng','㓩':' xuān','㓨':' cí','㓧':' gān','㓦':' bāi','㔁':' dēng','㔃':' jué','㓤':' qià','㔓':' jiǎn','㔡':' biē','㔠':' xiā','㔞':' kuài','㔝':' liǎng','㔜':' bá','㔚':' jié','㔙':' bēng','㔘':' chù','㔗':' fèi','㔕':' jí','㔒':' xí','㔄':' sù','㔑':' chì','㔏':' lì','㔎':' xiè','㔍':' chuā','㔌':' zòu','㔋':' jiān','㔊':' zhǎn','㔉':' zhǔ','㔆':' zàn','㔅':' xiào','㓥':' tāng','㓣':' qià','㒝':' miè','㒲':' cái','㒿':' lí','㒾':' shì','㒽':' quān','㒼':' mán','㒻':' mào','㒸':' suì','㒷':' guǎ','㒵':' mào','㒴':' gǔ','㒳':' liǎng','㒰':' quán','㓂':' kòu','㒫':' jì','㒩':' luǒ','㒧':' lì','㒦':' lěi','㒥':' fēng','㒤':' chè','㒡':' yóu','㒠':' xiè','㒟':' niǎo','㒞':' jùn','㓁':' wǎng','㓃':' dù','㓢':' luò','㓔':' xiè','㓡':' fǔ','㓠':' diàn','㓟':' pí','㓞':' qià','㓝':' xíng','㓜':' yòu','㓚':' gōng','㓘':' sù','㓗':' jié','㓖':' bì','㓓':' nán','㓄':' zhèn','㓑':' xìng','㓐':' lù','㓏':' jiǒng','㓎':' qīn','㓌':' chēng','㓋':' gòng','㓊':' dòng','㓉':' huò','㓈':' bìng','㓅':' tīng','㘦':' qín','㘨':' niè','㠆':' dān','㝦':' jùn','㝲':' qǐn','㝱':' mèng','㝰':' mián','㝯':' qiáo','㝮':' cuì','㝭':' xǐng','㝫':' lóng','㝪':' diàn','㝩':' kāng','㝧':' wěn','㝥':' mǐ','㝵':' dé','㝤':' gòu','㝣':' yì','㝢':' yǔ','㝡':' zuì','㝠':' míng','㝟':' máo','㝞':' yā','㝝':' lín','㝛':' sù','㝚':' yán','㝴':' wán','㝶':' ài','㝘':' yóng','㞄':' ān','㞏':' zhé','㞎':' bǎ','㞌':' yùn','㞋':' niǎn','㞊':' xù','㞉':' zā','㞈':' bō','㞇':' wěi','㞆':' jǐ','㞅':' luò','㞃':' jì','㝸':' biàn','㞂':' tuǐ','㞁':' yào','㞀':' huī','㝿':' bǒ','㝾':' zuǒ','㝽':' chuí','㝼':' yū','㝻':' jǐn','㝺':' lián','㝹':' nóu','㝙':' yín','㝗':' láng','㞑':' wěi','㜯':' xī','㜹':' qú','㜸':' niè','㜷':' mí','㜶':' wǎn','㜵':' niǎo','㜴':' mèng','㜳':' huái','㜲':' wěng','㜱':' zhì','㜰':' yuè','㜮':' làn','㜻':' liàn','㜫':' mà','㜪':' shēn','㜩':' ào','㜨':' nái','㜧':' yuè','㜦':' xín','㜥':' mái','㜤':' niǎn','㜣':' rán','㜡':' cōng','㜺':' zàn','㜼':' zhí','㝖':' yí','㝊':' shǒu','㝕':' níng','㝔':' yǎo','㝓':' kè','㝑':' máng','㝐':' róng','㝏':' jiè','㝎':' dìng','㝍':' xiě','㝌':' jiù','㝋':' liǎo','㝉':' zhù','㜽':' zǐ','㝈':' luán','㝇':' chún','㝅':' gòu','㝄':' chún','㝃':' miǎn','㝂':' zhì','㝁':' xuān','㝀':' hào','㜿':' xù','㜾':' hái','㞐':' jū','㞒':' xiè','㜞':' qiàn','㟚':' qí','㟧':' è','㟦':' yùn','㟤':' lù','㟢':' qí','㟠':' gǎng','㟟':' xiàng','㟞':' zhàn','㟝':' péi','㟜':' mí','㟛':' zàn','㟙':' zé','㟩':' mín','㟘':' tiáo','㟖':' lòng','㟔':' hán','㟓':' qí','㟒':' qūn','㟑':' bó','㟐':' mǎng','㟏':' hán','㟎':' tuǒ','㟍':' láng','㟨':' duān','㟪':' wēi','㟋':' duì','㟹':' láo','㠅':' fú','㠄':' xí','㠂':' áo','㠀':' dǎo','㟿':' mǎng','㟾':' yōng','㟽':' biǎo','㟼':' áo','㟻':' qiàn','㟺':' lóu','㟷':' da','㟫':' quán','㟶':' yuán','㟵':' gǎng','㟴':' kuài','㟳':' lì','㟲':' jué','㟱':' yǎo','㟰':' mǐng','㟮':' tū','㟭':' mín','㟬':' sǒu','㟌':' máng','㟊':' fú','㞓':' qì','㞠':' láo','㞬':' qìn','㞫':' jù','㞪':' náo','㞩':' lán','㞨':' zǐ','㞧':' huì','㞦':' jǐ','㞥':' cén','㞤':' yín','㞡':' zhǎn','㞟':' diàn','㞯':' jié','㞞':' sóng','㞜':' tuī','㞛':' jǐ','㞚':' qì','㞙':' niào','㞘':' dū','㞗':' qiú','㞖':' cí','㞕':' xiè','㞔':' yí','㞭':' dài','㞰':' xǔ','㟉':' láo','㞾':' ní','㟈':' qiú','㟇':' cuò','㟆':' huá','㟅':' yáng','㟄':' xiáng','㟃':' sī','㟂':' mǔ','㟁':' àn','㟀':' lián','㞿':' chì','㞽':' xuè','㞱':' cōng','㞼':' chéng','㞻':' hào','㞺':' zú','㞹':' kě','㞸':' suì','㞷':' huáng','㞶':' mǐn','㞴':' chí','㞳':' dǒu','㞲':' yòng','㜠':' cuī','㜝':' ǎn','㘩':' bì','㙶':' táng','㚂':' nàng','㚁':' qiào','㚀':' xī','㙾':' xì','㙼':' lěi','㙻':' chán','㙺':' kuí','㙹':' méng','㙸':' bào','㙷':' zhí','㙵':' tái','㚅':' lóng','㙴':' chàn','㙳':' kǎn','㙲':' yǒng','㙱':' hào','㙰':' xiè','㙯':' yì','㙮':' dā','㙬':' yín','㙫':' jí','㙪':' yì','㚃':' yūn','㚆':' fù','㙨':' jì','㚖':' gǎo','㚠':' xiāo','㚟':' chuò','㚞':' shěn','㚝':' zhuī','㚜':' yù','㚛':' xì','㚚':' kōng','㚙':' jiā','㚘':' bàn','㚗':' qié','㚕':' fú','㚇':' zōng','㚔':' niè','㚓':' lǎi','㚒':' shǎn','㚐':' tào','㚏':' gǎo','㚍':' kuǐ','㚌':' huà','㚋':' diāo','㚊':' kāi','㚉':' gǔ','㙩':' liáo','㙦':' xié','㚢':' nú','㘸':' zàng','㙇':' chù','㙅':' bǎo','㙄':' bì','㙃':' bāng','㙂':' duì','㙁':' méi','㙀':' liù','㘿':' niè','㘺':' fá','㘹':' cí','㘷':' ài','㙉':' tiǎn','㘶':' jié','㘵':' bù','㘴':' zuò','㘲':' jú','㘱':' tān','㘰':' zhēn','㘭':' ào','㘬':' ào','㘫':' jǐng','㘪':' hào','㙈':' xià','㙊':' cháng','㙥':' gùn','㙚':' xīng','㙤':' xià','㙣':' zhàng','㙢':' mán','㙡':' zōng','㙠':' yī','㙟':' lǎng','㙞':' niè','㙝':' xié','㙜':' chí','㙛':' bǔ','㙙':' lǒng','㙍':' duō','㙘':' yāo','㙗':' wēi','㙕':' kuài','㙔':' wěi','㙓':' kuí','㙒':' yě','㙑':' yǔ','㙐':' duǒ','㙏':' fù','㙎':' wēi','㚡':' jǐ','㚣':' xiáo','㜜':' ào','㛳':' yì','㛾':' xián','㛼':' chā','㛻':' kuā','㛺':' ān','㛹':' pián','㛸':' shù','㛷':' jī','㛶':' tàn','㛵':' chēng','㛴':' nǎo','㛲':' fà','㜂':' fēng','㛱':' wěi','㛯':' fàn','㛮':' sǎo','㛭':' xī','㛬':' lù','㛫':' xī','㛪':' yàn','㛩':' zhóu','㛨':' qiǎng','㛧':' mǎn','㛿':' zhì','㜃':' liàn','㛥':' tà','㜐':' shù','㜛':' nèn','㜚':' sù','㜙':' lù','㜘':' jù','㜗':' cān','㜖':' cáo','㜕':' lián','㜓':' dá','㜒':' yì','㜑':' fú','㜏':' yún','㜄':' xún','㜎':' xī','㜍':' táng','㜌':' nǒu','㜋':' yì','㜊':' zhǎn','㜉':' yōng','㜈':' mù','㜇':' huì','㜆':' mì','㜅':' xù','㛦':' lǎn','㛤':' lí','㚤':' yì','㚱':' qiū','㚾':' xiōng','㚽':' qiǎo','㚻':' jī','㚺':' yùn','㚹':' mǎo','㚷':' ěr','㚶':' sì','㚵':' dōng','㚴':' bù','㚲':' chān','㚰':' pēi','㛀':' chú','㚯':' xín','㚭':' yóu','㚬':' jūn','㚫':' sà','㚪':' hào','㚩':' rǎn','㚨':' shěn','㚧':' yǎn','㚦':' yí','㚥':' yú','㚿':' páo','㛁':' pēng','㛣':' yún','㛔':' fēng','㛞':' lòng','㛝':' bèi','㛜':' yóu','㛛':' xìn','㛚':' tǒng','㛙':' xīn','㛘':' pò','㛗':' qiē','㛖':' suō','㛕':' yì','㛓':' xī','㛂':' nuǒ','㛒':' dòu','㛑':' càn','㛐':' sǒu','㛏':' qiú','㛎':' lǚ','㛍':' qiè','㛊':' duǒ','㛆':' duò','㛅':' èr','㛄':' yī','㛃':' jié','㯜':' cuì','㯞':' juàn','䍒':' mǒu','䃪':' tán','䃴':' zhū','䃳':' là','䃲':' pán','䃱':' xiàn','䃰':' cā','䃯':' lì','䃮':' dá','䃭':' gǎn','䃬':' wěi','䃫':' dǎn','䃩':' náo','䃶':' huái','䃧':' lóng','䃦':' dūn','䃥':' chuáng','䃤':' sù','䃣':' huǐ','䃢':' qīn','䃡':' jīn','䃠':' xuàn','䃞':' shú','䃝':' qiào','䃵':' niǎo','䃷':' yíng','䃛':' lián','䄆':' huó','䄑':' huó','䄐':' quàn','䄏':' yú','䄎':' qǐ','䄍':' zhà','䄌':' zhuì','䄋':' yǎn','䄉':' é','䄈':' dòu','䄇':' chéng','䄅':' juàn','䃸':' xiàn','䄄':' yīn','䄂':' liù','䄁':' yì','䄀':' huò','䃿':' fū','䃾':' bǐ','䃽':' guǐ','䃻':' bà','䃺':' mó','䃹':' làn','䃜':' yī','䃚':' cù','䄓':' huáng','䂰':' là','䂺':' wǒ','䂹':' suǒ','䂸':' guó','䂷':' guāi','䂶':' jié','䂵':' gōng','䂴':' yán','䂳':' cuǒ','䂲':' fǎ','䂱':' ruì','䂯':' guài','䂼':' niè','䂮':' lüè','䂭':' qiāo','䂬':' gǒng','䂫':' hāng','䂪':' qiǎo','䂩':' yàn','䂧':' zhěn','䂦':' zhēn','䂥':' mín','䂤':' fù','䂻':' zhèng','䂽':' diào','䃙':' lù','䃍':' zhào','䃘':' kēng','䃗':' bō','䃖':' wù','䃕':' láo','䃔':' hóng','䃓':' gòu','䃒':' hé','䃑':' bān','䃏':' xīng','䃎':' zhà','䃌':' zhēn','䂾':' lǎi','䃋':' yú','䃊':' jǔ','䃉':' mín','䃈':' jiē','䃇':' mián','䃅':' dī','䃂':' gǔn','䃁':' yā','䃀':' cuì','䂿':' tà','䄒':' niè','䄔':' jǔ','䂢':' dǒng','䅛':' chāng','䅥':' jié','䅤':' qì','䅣':' huáng','䅢':' jiù','䅡':' xǔ','䅠':' tí','䅟':' cǎn','䅞':' nè','䅝':' kōng','䅜':' duò','䅚':' quǎn','䅧':' yān','䅙':' hùn','䅘':' lái','䅗':' suì','䅖':' ān','䅕':' jū','䅔':' zī','䅓':' jǔ','䅒':' máng','䅑':' ruí','䅐':' jiǎn','䅦':' máo','䅩':' zhǐ','䅎':' yǒu','䅷':' tú','䆁':' gāo','䆀':' měi','䅿':' huáng','䅾':' cén','䅽':' xīn','䅼':' mán','䅻':' lí','䅺':' biāo','䅹':' lǒu','䅸':' shēn','䅶':' nòu','䅪':' tuí','䅵':' zhuó','䅴':' suǒ','䅳':' chú','䅲':' qí','䅱':' hùn','䅰':' ěn','䅯':' táng','䅮':' càng','䅭':' páng','䅬':' ài','䅏':' huì','䅍':' tǐng','䄕':' shè','䄥':' líng','䄯':' jiǎn','䄮':' fū','䄭':' nián','䄬':' yí','䄫':' qǐ','䄪':' diǎo','䄩':' yì','䄨':' yú','䄧':' réng','䄦':' liǎo','䄤':' lài','䄱':' fāng','䄢':' qí','䄡':' dān','䄠':' shàn','䄟':' cuī','䄝':' chuāng','䄜':' lí','䄛':' lóu','䄚':' cáo','䄙':' míng','䄘':' péng','䄰':' yá','䄲':' ruì','䅌':' juān','䅁':' àn','䅋':' wǎn','䅊':' chá','䅉':' yà','䅈':' yuàn','䅇':' sù','䅆':' zì','䅅':' guī','䅄':' lì','䅃':' qióng','䅂':' hé','䅀':' liè','䄳':' xiān','䄿':' yì','䄾':' rù','䄽':' tiǎn','䄼':' tiǎn','䄻':' táo','䄺':' zhì','䄹':' nián','䄸':' pò','䄷':' shí','䄶':' bì','䂣':' cí','䂡':' dǐ','䆃':' dào','䀍':' kàn','䀗':' jué','䀖':' tiān','䀕':' zhèn','䀔':' rèn','䀓':' huàn','䀒':' qiān','䀑':' wò','䀐':' shān','䀏':' xuàn','䀎':' miǎn','䀌':' xì','䀙':' qì','䀋':' yán','䀊':' jiǎo','䀉':' qiáo','䀈':' jì','䀇':' gǔ','䀆':' jìn','䀅':' shè','䀄':' méng','䀃':' tuí','䀂':' ān','䀘':' xié','䀚':' áng','䀀':' fàn','䀨':' huà','䀲':' mù','䀱':' fēng','䀰':' gǔ','䀯':' bǔ','䀮':' huāng','䀭':' gāi','䀬':' quán','䀫':' jiá','䀪':' háng','䀩':' luò','䀧':' hǒng','䀛':' mèi','䀦':' gǔ','䀥':' shuò','䀤':' mào','䀣':' bì','䀢':' shùn','䀡':' chàn','䀠':' jù','䀟':' fán','䀞':' tāo','䀜':' gǔ','䀁':' yòu','㿿':' yǎ','䀴':' yǐng','㿖':' lú','㿢':' yào','㿠':' huàng','㿟':' bái','㿞':' mào','㿜':' biě','㿛':' lì','㿚':' luò','㿙':' pì','㿘':' yíng','㿗':' tuí','㿕':' yán','㿤':' chǔn','㿔':' lěi','㿓':' jiá','㿒':' dǎo','㿑':' yào','㿏':' qún','㿎':' fèn','㿍':' jiè','㿌':' xiān','㿋':' sào','㿊':' cǎn','㿣':' hē','㿥':' hé','㿾':' zhù','㿳':' zī','㿽':' xī','㿼':' yán','㿻':' gān','㿺':' báo','㿹':' tà','㿸':' wǎn','㿷':' cuó','㿶':' bāng','㿵':' rǎn','㿴':' dā','㿱':' xué','㿦':' nìng','㿰':' áo','㿯':' dá','㿮':' yàng','㿭':' chè','㿬':' bā','㿫':' bì','㿪':' huán','㿩':' tǎng','㿨':' lì','㿧':' chóu','䀳':' ài','䀵':' shùn','䂠':' shǐ','䁸':' náng','䂂':' qú','䂁':' chán','䂀':' xī','䁿':' mò','䁾':' miè','䁽':' liè','䁼':' mò','䁻':' shuò','䁺':' shì','䁹':' bì','䁷':' jué','䂄':' huò','䁶':' jī','䁵':' biǎn','䁴':' zhǎn','䁳':' mǎng','䁲':' mái','䁱':' kōu','䁰':' jiǎng','䁯':' xī','䁮':' qián','䁭':' biāo','䂃':' jiào','䂅':' xiān','䁫':' hú','䂔':' xìng','䂟':' jiā','䂞':' zhè','䂝':' jié','䂜':' bàng','䂛':' yú','䂚':' yáo','䂙':' duī','䂗':' kū','䂖':' shí','䂕':' huì','䂒':' qià','䂆':' xù','䂑':' jī','䂐':' zhuō','䂏':' diāo','䂎':' zuǎn','䂍':' bó','䂌':' chōng','䂊':' yù','䂉':' hóu','䂈':' tóng','䂇':' niǔ','䁬':' céng','䁪':' zhǎn','䀶':' liàng','䁃':' biāo','䁍':' qià','䁌':' yù','䁋':' xiè','䁊':' wò','䁉':' qì','䁈':' qì','䁇':' mì','䁆':' yè','䁅':' měng','䁄':' xìng','䁂':' xiàn','䁏':' yǎo','䁁':' liàng','䀿':' dì','䀾':' dǔ','䀽':' yán','䀼':' chēn','䀻':' pìng','䀺':' chōu','䀹':' jié','䀸':' chì','䀷':' jié','䁎':' chéng','䁐':' yīng','䁩':' yú','䁝':' yíng','䁨':' huò','䁧':' miáo','䁦':' qù','䁥':' nì','䁤':' chè','䁣':' chuán','䁢':' xuán','䁠':' lián','䁟':' chá','䁞':' shěng','䁜':' huàng','䁑':' yáng','䁛':' guì','䁚':' sǔn','䁙':' yǎn','䁘':' yǎo','䁗':' kǎi','䁖':' lōu','䁕':' mín','䁔':' xuān','䁓':' zōng','䁒':' jí','䆂':' lián','䆄':' zhǎn','㿇':' xí','䊵':' qiú','䋂':' yáo','䋁':' gěng','䋀':' huà','䊿':' bó','䊾':' mù','䊽':' guài','䊼':' chǐ','䊻':' gān','䊺':' hù','䊶':' zhèn','䊴':' qiàn','䋄':' wǎng','䊳':' mí','䊲':' chàn','䊱':' xiān','䊰':' chú','䊯':' kuàng','䊮':' dí','䊭':' dào','䊬':' chuā','䊫':' cuǐ','䊪':' lì','䋃':' mào','䋈':' rú','䊨':' luó','䋘':' chuò','䋤':' yuè','䋣':' fán','䋢':' biē','䋠':' bǔ','䋟':' jì','䋞':' wǎng','䋜':' qìng','䋛':' mǐ','䋚':' yì','䋙':' ěr','䋖':' yù','䋉':' xué','䋕':' rèn','䋔':' bì','䋓':' zhòu','䋑':' liè','䋐':' yuè','䋏':' zuó','䋎':' zhàn','䋌':' jiǎng','䋋':' mín','䋊':' zhēng','䊩':' fán','䊧':' bì','䋦':' fán','䉹':' líng','䊄':' qióng','䊃':' pèi','䊂':' cè','䊀':' hú','䉿':' hú','䉾':' bì','䉽':' bǎn','䉼':' liào','䉻':' qí','䉺':' hóng','䉸':' biàn','䊆':' jiù','䉷':' yán','䉶':' shuāng','䉵':' zhuàn','䉴':' ráng','䉳':' xiān','䉲':' mí','䉱':' ōu','䉰':' xiào','䉯':' xiàn','䉮':' lìn','䊅':' míng','䊇':' bù','䊦':' yè','䊙':' yān','䊥':' xiào','䊤':' tán','䊣':' huáng','䊡':' mán','䊠':' xì','䊟':' mén','䊞':' zhé','䊝':' xiè','䊜':' tuán','䊛':' sà','䊘':' jiù','䊈':' méi','䊗':' huáng','䊖':' nǎn','䊔':' yíng','䊓':' shì','䊑':' xiǎng','䊐':' hún','䊎':' quǎn','䊍':' lí','䊊':' wèi','䊉':' sǎn','䋥':' lí','䋧':' qú','䉬':' fèi','䌪':' yǎn','䌵':' zhú','䌴':' luò','䌳':' shī','䌱':' luò','䌰':' niè','䌯':' quān','䌮':' shuāng','䌭':' jiāo','䌬':' chóng','䌫':' lǎn','䌩':' miè','䌸':' juàn','䌨':' cā','䌧':' chóu','䌦':' dào','䌥':' yǐn','䌤':' shī','䌣':' zuǎn','䌢':' líng','䌡':' tǐ','䌠':' jiān','䌟':' bó','䌷':' chōu','䌹':' jiǒng','䌝':' jīn','䍆':' zhù','䍑':' hǎn','䍐':' hǎn','䍎':' cùn','䍍':' kòu','䍌':' bù','䍋':' chuí','䍊':' jiāo','䍉':' zhǎi','䍈':' píng','䍇':' tà','䍅':' líng','䌺':' ěr','䍄':' diǎn','䍃':' yóu','䍂':' yú','䍁':' suì','䍀':' lán','䌿':' fú','䌾':' rén','䌽':' cǎi','䌼':' ruì','䌻':' yì','䌞':' liǎn','䌜':' niè','䋨':' fǔ','䋴':' niù','䋿':' wēi','䋾':' zhǎ','䋽':' běng','䋼':' tīng','䋻':' nín','䋹':' fú','䋸':' xún','䋷':' móu','䋶':' xǔ','䋵':' yì','䋳':' běi','䌁':' yāo','䋲':' chě','䋱':' lái','䋰':' jú','䋯':' qǐ','䋮':' jìn','䋭':' yù','䋬':' tiān','䋫':' zhēng','䋪':' ē','䋩':' ér','䌀':' kē','䌂':' òu','䌛':' yáo','䌐':' mì','䌚':' sū','䌙':' huàng','䌘':' biè','䌗':' fǔ','䌖':' jié','䌕':' mí','䌔':' ōu','䌓':' fán','䌒':' lù','䌑':' jiān','䌏':' mì','䌃':' xiāo','䌎':' lüè','䌍':' jǐn','䌌':' qì','䌋':' dā','䌊':' yáo','䌈':' tā','䌇':' huì','䌆':' guì','䌅':' táng','䌄':' gěng','䉭':' liè','䉫':' lí','䆅':' zī','䇑':' bà','䇞':' gān','䇜':' qiǎn','䇛':' zhǐ','䇙':' yǐn','䇘':' hù','䇗':' zhōng','䇖':' yǔn','䇔':' luò','䇓':' xū','䇒':' jiè','䇐':' lì','䇠':' zhù','䇏':' duì','䇎':' què','䇍':' chù','䇌':' qiào','䇋':' hài','䇈':' huà','䇇':' méng','䇅':' fá','䇃':' sì','䇂':' qiān','䇟':' jiàn','䇡':' zhù','䇀':' róng','䇮':' rèn','䇺':' dòu','䇹':' jùn','䇸':' chéng','䇷':' bié','䇶':' jué','䇵':' yí','䇲':' cè','䇱':' nà','䇰':' zhēng','䇯':' róng','䇭':' lǎo','䇢':' kǔ','䇬':' zhū','䇫':' jī','䇪':' chī','䇩':' yì','䇨':' gòng','䇧':' zhì','䇦':' ǎng','䇥':' zé','䇤':' ruì','䇣':' niè','䇁':' sī','䆿':' yì','䇼':' yì','䆔':' chōng','䆞':' yǎo','䆝':' xuè','䆜':' yòu','䆛':' zhà','䆚':' tóng','䆙':' yáo','䆘':' yā','䆗':' yǎo','䆖':' hóng','䆕':' yuè','䆓':' è','䆠':' huàn','䆒':' jiù','䆑':' chéng','䆐':' guó','䆏':' fèi','䆎':' xiān','䆍':' lóng','䆋':' qiū','䆊':' cuì','䆉':' bà','䆈':' zhì','䆟':' kè','䆡':' láng','䆾':' lán','䆱':' tān','䆽':' qú','䆻':' qiào','䆺':' pān','䆹':' chōng','䆸':' zhēng','䆷':' xuè','䆶':' jiū','䆵':' chéng','䆳':' qióng','䆲':' kāng','䆰':' yū','䆢':' yuè','䆯':' zhuó','䆮':' jìn','䆭':' xuān','䆬':' yǔn','䆫':' chuāng','䆪':' hōng','䆩':' míng','䆨':' níng','䆦':' shèn','䆣':' chén','䇻':' wěi','䇽':' zhé','䉪':' lèi','䉃':' jiǎng','䉎':' táng','䉍':' jiǎn','䉌':' suì','䉋':' mèi','䉊':' fàn','䉉':' gū','䉈':' sǎn','䉆':' diǎo','䉅':' zhì','䉄':' léng','䉂':' lěi','䉐':' kū','䉁':' líng','䉀':' shù','䈿':' mì','䈾':' shāo','䈽':' jīn','䈼':' miè','䈻':' pú','䈺':' zhōng','䈹':' sǒu','䈸':' hú','䉏':' xiè','䉑':' wú','䈶':' róng','䉞':' dǎn','䉨':' yì','䉧':' liú','䉦':' qiān','䉥':' sǒng','䉤':' sǒu','䉣':' xiè','䉢':' sè','䉡':' tán','䉠':' wéi','䉟':' huò','䉝':' yǐ','䉒':' fán','䉜':' zhì','䉛':' yù','䉚':' méng','䉙':' yún','䉘':' cóng','䉗':' yī','䉖':' líng','䉕':' céng','䉔':' cān','䉓':' luò','䈷':' luò','䈵':' wēng','䇾':' yán','䈋':' tà','䈖':' kē','䈕':' shí','䈓':' gé','䈒':' nǎn','䈑':' guǎ','䈐':' guì','䈏':' báo','䈎':' yè','䈍':' máng','䈌':' qū','䈊':' líng','䈘':' cí','䈉':' shà','䈈':' féi','䈇':' zhào','䈆':' dài','䈅':' yù','䈄':' hán','䈃':' zhǎo','䈂':' píng','䈁':' lún','䈀':' sān','䈗':' suǒ','䈙':' zhòu','䈴':' qiàn','䈧':' wěi','䈳':' tà','䈲':' bān','䈱':' tāo','䈰':' shāo','䈯':' zhēn','䈮':' jù','䈭':' sōu','䈬':' pú','䈫':' nà','䈪':' xì','䈦':' zōng','䈚':' tái','䈥':' jīn','䈤':' qián','䈣':' zhèng','䈢':' sǎi','䈡':' cōng','䈠':' huǎn','䈟':' cè','䈞':' dǔ','䈝':' xū','䈜':' qìn','䈛':' kuài','㿉':' tuǐ','㿆':' guō','㯟':' lù','㴝':' lí','㴮':' xiè','㴭':' yǎo','㴬':' xiè','㴫':' jùn','㴪':' niè','㴩':' yōng','㴨':' zhèn','㴧':' xī','㴦':' guàn','㴥':' qiào','㴜':' biàn','㴰':' néng','㴛':' zhì','㴚':' suì','㴙':' zhǎ','㴘':' mào','㴗':' yōu','㴖':' luò','㴕':' jí','㴔':' xī','㴓':' shāi','㴒':' yì','㴯':' zhī','㴲':' sī','㴐':' miàn','㵃':' shé','㵐':' jué','㵏':' cuǐ','㵎':' jiàn','㵍':' mèn','㵌':' xún','㵋':' mì','㵊':' nà','㵆':' gǎo','㵅':' tān','㵄':' hàn','㵂':' shù','㴳':' lǒng','㵀':' zú','㴿':' dǐng','㴾':' bó','㴽':' xiè','㴼':' sù','㴸':' shǎn','㴷':' dān','㴶':' què','㴵':' mì','㴴':' chén','㴑':' sù','㴏':' wǎng','㵒':' fèi','㳙':' xuàn','㳩':' tān','㳨':' jiǎn','㳧':' chè','㳦':' xiè','㳥':' lòng','㳡':' guō','㳠':' tà','㳜':' xiū','㳛':' yú','㳚':' xù','㳘':' chōng','㳫':' zǎn','㳗':' chài','㳖':' yī','㳕':' lán','㳔':' duì','㳒':' biàn','㳑':' yì','㳐':' zhá','㳏':' shì','㳎':' biàn','㳍':' bù','㳪':' pì','㳬':' xuán','㴋':' sù','㳾':' qiāng','㴉':' jǐ','㴈':' yìn','㴇':' shè','㴆':' jìn','㴄':' yǒng','㴃':' lèi','㴂':' tān','㴁':' yì','㴀':' fàn','㳿':' xiè','㳽':' mǐ','㳭':' xián','㳼':' bì','㳻':' zé','㳺':' yóu','㳹':' wǎng','㳸':' huā','㳷':' hū','㳶':' nǒu','㳵':' jì','㳴':' mì','㳮':' niào','㵑':' hè','㵓':' shí','㳋':' qiū','㶣':' chán','㶲':' yòng','㶰':' hán','㶯':' liù','㶭':' yǒu','㶬':' mò','㶫':' liǎo','㶧':' nèn','㶦':' jìn','㶥':' gān','㶤':' chǎo','㶡':' dài','㶴':' chǐ','㶠':' yì','㶟':' lěi','㶞':' nǎng','㶛':' yú','㶚':' bà','㶘':' diàn','㶗':' fàn','㶖':' shù','㶕':' jiǎn','㶔':' bèi','㶳':' jìn','㶵':' rèn','㶒':' shǎn','㷆':' fù','㷒':' yú','㷐':' huǐ','㷏':' yǒng','㷎':' hè','㷍':' lún','㷋':' tán','㷊':' fén','㷉':' wèi','㷈':' è','㷇':' huī','㷅':' chǎo','㶶':' nóng','㷄':' huǐ','㷃':' chuǐ','㷂':' shù','㷀':' qióng','㶿':' bó','㶾':' biāo','㶽':' guā','㶼':' āi','㶺':' tiàn','㶹':' hòng','㶓':' cáng','㶑':' liàn','㵔':' chě','㵥':' bì','㵯':' féng','㵮':' chún','㵭':' zhǔ','㵬':' yíng','㵫':' nì','㵪':' xián','㵩':' yì','㵨':' pì','㵧':' gé','㵦':' suí','㵤':' shà','㵱':' piǎo','㵣':' kě','㵢':' léi','㵡':' báo','㵠':' kū','㵞':' chóu','㵝':' yì','㵘':' màn','㵗':' píng','㵖':' nǜ','㵕':' shèn','㵰':' xù','㵲':' wǔ','㶏':' yīn','㶀':' jiāo','㶎':' huán','㶍':' xiǎn','㶌':' lián','㶉':' xī','㶈':' yíng','㶇':' héng','㶆':' zhū','㶅':' xué','㶄':' yán','㶁':' guó','㵿':' xiào','㵳':' liáo','㵾':' qìng','㵽':' lěi','㵻':' xiū','㵺':' pài','㵹':' huán','㵸':' yào','㵷':' biàn','㵶':' zuō','㵵':' zòu','㵴':' cáng','㳌':' yā','㳊':' yōu','㷔':' yàn','㰬':' xún','㰶':' yǒu','㰵':' zú','㰴':' pǒu','㰳':' yà','㰲':' yū','㰱':' shà','㰰':' xiā','㰯':' kòu','㰮':' shèn','㰭':' xū','㰫':' chān','㰸':' liǎn','㰪':' guī','㰩':' hāi','㰨':' xiā','㰧':' hāi','㰦':' qù','㰥':' xì','㰤':' hē','㰣':' zī','㰢':' kēng','㰡':' xiè','㰷':' zì','㰹':' xiān','㰟':' jì','㱆':' xī','㱔':' xiē','㱏':' zhèng','㱎':' kūn','㱍':' luán','㱌':' yé','㱋':' què','㱊':' yōu','㱉':' yè','㱈':' jìn','㱇':' sè','㱅':' yì','㰺':' xià','㱄':' hēi','㱃':' yǐn','㱂':' kāng','㱁':' shì','㱀':' chǐ','㰿':' xī','㰾':' jiào','㰽':' yàn','㰼':' shà','㰻':' yǐ','㰠':' hāng','㰞':' chī','㱗':' xiū','㯮':' shú','㯺':' jiàn','㯹':' biǎo','㯸':' jǐn','㯷':' pú','㯶':' zōng','㯳':' qíng','㯲':' jìn','㯱':' pāo','㯰':' zhé','㯯':' gòng','㯭':' lǔ','㯾':' zāo','㯬':' liǎn','㯫':' qú','㯪':' líng','㯩':' tì','㯦':' qí','㯥':' cáo','㯤':' lì','㯢':' zhèn','㯡':' pào','㯠':' qiàn','㯻':' gǔn','㯿':' liè','㰝':' yǐ','㰎':' zuì','㰛':' yuè','㰚':' lí','㰙':' nuó','㰘':' yí','㰗':' qí','㰖':' lǎn','㰔':' xiè','㰒':' xué','㰑':' shān','㰐':' jué','㰍':' lóng','㰀':' lí','㰌':' què','㰋':' pín','㰊':' xián','㰈':' liǎn','㰆':' bèi','㰅':' dí','㰄':' jiàn','㰃':' mián','㰂':' shěn','㰁':' luǒ','㱖':' cuì','㱘':' àn','㳈':' pèi','㲟':' yǐng','㲫':' pú','㲪':' dēng','㲨':' róng','㲧':' sào','㲦':' hàn','㲥':' táng','㲤':' shuāi','㲢':' biàn','㲡':' nài','㲠':' máo','㲞':' sū','㲭':' tǎn','㲝':' rǒng','㲜':' tán','㲛':' zhǐ','㲚':' shā','㲘':' qú','㲗':' fū','㲖':' xiāo','㲕':' lèi','㲔':' xiān','㲓':' róng','㲬':' jiāo','㲯':' rán','㲏':' pāo','㲽':' niàn','㳇':' fù','㳆':' tǒu','㳅':' jiǎo','㳄':' xián','㳃':' cuì','㳂':' yán','㳁':' zè','㳀':' guò','㲿':' wǎng','㲾':' yǔ','㲼':' yì','㲰':' níng','㲻':' nì','㲺':' jí','㲹':' guǐ','㲸':' xī','㲷':' dàn','㲶':' lǜ','㲴':' zhòng','㲳':' dié','㲲':' dié','㲱':' liè','㲒':' bào','㲎':' lóu','㱙':' xiǔ','㱦':' qī','㱰':' zǎi','㱯':' ái','㱮':' kuài','㱭':' duàn','㱬':' wěi','㱫':' làn','㱪':' mèn','㱩':' dú','㱨':' liàn','㱧':' wò','㱥':' líng','㱲':' yì','㱤':' xī','㱣':' tuǐ','㱢':' láng','㱡':' shēng','㱠':' kū','㱟':' pī','㱞':' yì','㱜':' zhá','㱛':' chuǎn','㱚':' cán','㱱':' huì','㱳':' mò','㲍':' zhī','㲁':' kōng','㲌':' nèng','㲋':' chuò','㲊':' ruì','㲉':' què','㲈':' sháo','㲆':' líng','㲅':' jì','㲄':' jué','㲃':' jiù','㲂':' chéng','㲀':' zhēn','㱴':' zì','㱿':' què','㱾':' gāi','㱽':' zhěn','㱼':' hāi','㱻':' luò','㱺':' lú','㱹':' lì','㱸':' bì','㱶':' péng','㱵':' fèn','㷓':' zǒng','㷕':' qiú','㿅':' xiǎn','㼦':' gǒng','㼰':' pí','㼯':' dòng','㼮':' chāi','㼭':' diàn','㼬':' xìng','㼫':' huàn','㼪':' jié','㼩':' chéng','㼨':' hán','㼧':' tóng','㼥':' tǒu','㼲':' liè','㼤':' qiè','㼣':' bó','㼢':' yí','㼡':' shū','㼠':' tuó','㼟':' bó','㼞':' pèng','㼝':' fàn','㼜':' àng','㼛':' xíng','㼱':' ruǎn','㼳':' shěng','㼙':' zhòu','㽀':' zhèng','㽋':' luó','㽊':' xiè','㽉':' xiàn','㽈':' yì','㽇':' hú','㽆':' dāng','㽄':' sī','㽃':' pān','㽂':' sà','㽁':' lì','㼿':' tóng','㼴':' ǒu','㼾':' lù','㼽':' chuǎng','㼼':' piáo','㼻':' cóng','㼺':' táng','㼹':' kāng','㼸':' róng','㼷':' chuán','㼶':' yú','㼵':' dì','㼚':' gāng','㼘':' wǎ','㽎':' tán','㻡':' xuē','㻲':' lǚ','㻱':' jīn','㻰':' miǎn','㻯':' tú','㻮':' càn','㻭':' sè','㻬':' tū','㻫':' bì','㻪':' suì','㻧':' duò','㻠':' tú','㻶':' bǐ','㻟':' suí','㻞':' bīn','㻝':' là','㻗':' bèi','㻖':' dài','㻕':' jué','㻔':' duǒ','㻓':' zōu','㻒':' jùn','㻑':' jì','㻵':' zhàn','㻷':' jí','㼗':' tíng','㼌':' yǔ','㼖':' lì','㼕':' dāng','㼔':' wēn','㼓':' lián','㼒':' tǎng','㼑':' liàn','㼐':' pián','㼏':' něi','㼎':' bó','㼍':' lěi','㼋':' gū','㻸':' zēn','㼊':' tún','㼉':' zhèn','㼈':' luó','㼇':' qióng','㼂':' é','㻿':' shǔ','㻾':' yōng','㻽':' suì','㻺':' lì','㻹':' xuān','㽌':' liù','㽏':' gàn','㻎':' lì','㾚':' xiē','㾤':' qiāng','㾣':' qīn','㾢':' ài','㾡':' què','㾠':' kuáng','㾟':' bù','㾞':' yóu','㾝':' chè','㾜':' qiè','㾛':' qǐn','㾙':' xìn','㾦':' pèi','㾘':' gěng','㾗':' liàng','㾖':' lǐ','㾕':' shěn','㾔':' lǚ','㾓':' yuān','㾒':' rú','㾑':' dá','㾐':' lì','㾏':' jiè','㾥':' chù','㾧':' kuò','㾍':' nái','㾷':' xī','㿄':' ài','㿃':' zhì','㾿':' láng','㾾':' xiān','㾽':' zhuì','㾼':' tuǐ','㾻':' zhù','㾺':' mà','㾹':' chái','㾸':' gǎo','㾶':' gǔ','㾨':' yī','㾵':' jì','㾴':' zhā','㾱':' bèi','㾰':' hú','㾯':' huī','㾮':' huáng','㾭':' zhòu','㾫':' piān','㾪':' shěng','㾩':' guāi','㾎':' yā','㾌':' xuǎn','㽑':' tán','㽡':' bēi','㽫':' yōng','㽪':' zěng','㽩':' càn','㽨':' cuó','㽧':' zī','㽦':' xún','㽥':' róu','㽤':' jú','㽣':' yù','㽢':' ǎn','㽠':' xiá','㽭':' ruǎn','㽟':' liè','㽞':' liú','㽝':' lì','㽜':' wǎn','㽛':' gōu','㽚':' chì','㽙':' jùn','㽘':' gǎng','㽖':' nán','㽕':' yóu','㽬':' fù','㽯':' xí','㾋':' xiū','㾀':' qiè','㾊':' jí','㾉':' líng','㾈':' fù','㾇':' mù','㾆':' rán','㾅':' zǐ','㾄':' dú','㾃':' tuó','㾂':' hāi','㾁':' shù','㽾':' wù','㽰':' shù','㽽':' gù','㽻':' zhī','㽺':' jí','㽹':' fǎn','㽸':' chén','㽷':' shuì','㽴':' zhàng','㽳':' xū','㽲':' jiǎo','㽱':' jiǎo','㻏':' líng','㻍':' wú','㷖':' zhào','㸩':' ān','㸳':' líng','㸲':' zuó','㸱':' tuó','㸰':' tuó','㸯':' kē','㸮':' fén','㸭':' bā','㸬':' bèi','㸫':' qián','㸪':' chún','㸨':' jiū','㸶':' yān','㸧':' kèn','㸦':' hù','㸥':' chàn','㸤':' piàn','㸣':' yè','㸢':' bèi','㸡':' shū','㸠':' tiǎo','㸟':' zhī','㸞':' zhé','㸵':' guǐ','㸷':' shì','㸜':' kòng','㹅':' zǒng','㹏':' jǐn','㹎':' léi','㹍':' dí','㹌':' chǎn','㹋':' xiū','㹊':' yuè','㹉':' yuán','㹈':' lí','㹇':' hé','㹆':' huī','㹄':' jì','㸸':' hǒu','㹃':' fèi','㹂':' qiǎn','㹁':' liáng','㹀':' bó','㸿':' dú','㸾':' rèn','㸽':' bèi','㸻':' sì','㸺':' shā','㸹':' liè','㸝':' xiān','㸛':' sháo','㹑':' sì','㷬':' mò','㷹':' zhào','㷸':' dié','㷷':' juǎn','㷶':' bèi','㷵':' mò','㷴':' gé','㷳':' yàn','㷰':' chī','㷯':' bèng','㷮':' zāo','㷫':' qǐng','㷼':' yàn','㷪':' cuì','㷦':' xù','㷤':' hù','㷣':' xīng','㷢':' zhǎ','㷡':' jiǒng','㷠':' lín','㷟':' tuì','㷘':' tái','㷗':' jiǒng','㷻':' wú','㷾':' jué','㸚':' lǐ','㸎':' niè','㸙':' zhē','㸘':' wàn','㸗':' tóng','㸖':' qū','㸕':' jué','㸓':' mì','㸒':' yín','㸑':' cuàn','㸐':' rán','㸏':' mí','㸍':' xì','㷿':' xiān','㸌':' huò','㸋':' fán','㸊':' lài','㸉':' xiè','㸇':' zuǎn','㸅':' jié','㸄':' jì','㸃':' diǎn','㸁':' hǎn','㸀':' tái','㹐':' chóng','㹒':' pǔ','㻌':' tú','㺛':' zhù','㺥':' chán','㺤':' xiān','㺣':' xī','㺢':' huò','㺡':' lì','㺠':' yòu','㺟':' zhuó','㺞':' yú','㺝':' hàn','㺜':' nóng','㺚':' tǎ','㺨':' sī','㺘':' zhàn','㺗':' chān','㺖':' hǎn','㺕':' fán','㺔':' hài','㺓':' zé','㺒':' xiāo','㺑':' shān','㺐':' lǎo','㺏':' lóu','㺦':' lián','㺩':' jiù','㺍':' pín','㺹':' biàn','㻋':' là','㻊':' máng','㻉':' bù','㻅':' huì','㻄':' bǎo','㻃':' qū','㻂':' píng','㻀':' yú','㺿':' yí','㺺':' mào','㺸':' píng','㺪':' pú','㺷':' xù','㺵':' jiú','㺴':' bā','㺳':' méi','㺲':' niǔ','㺱':' réng','㺮':' yú','㺭':' zǐ','㺬':' gǒng','㺫':' qiú','㺎':' róng','㺌':' xiàn','㹓':' yǎo','㹟':' jué','㹬':' shǐ','㹫':' yí','㹨':' yòu','㹦':' diāo','㹥':' zhù','㹤':' qiè','㹣':' zhōng','㹢':' jiā','㹡':' xuán','㹠':' tún','㹞':' yín','㹮':' mò','㹝':' shì','㹜':' yín','㹛':' ráo','㹚':' yíng','㹙':' wěng','㹘':' rù','㹗':' tāo','㹖':' huàn','㹕':' huān','㹔':' jiāng','㹭':' yì','㹱':' què','㺋':' wēng','㹿':' zhuó','㺊':' yàng','㺉':' hù','㺈':' chī','㺇':' sī','㺅':' hóu','㺄':' yǔ','㺃':' gǒu','㺂':' yán','㺁':' nǎo','㺀':' hū','㹾':' piǎo','㹲':' xiāo','㹽':' chǎn','㹼':' jú','㹻':' wō','㹺':' tà','㹹':' gēng','㹸':' ní','㹷':' shǐ','㹶':' tíng','㹵':' yǐng','㹴':' gēng','㹳':' wú','冇':' mǎo','冉':' rǎn','殓':' liàn','拡':' kuò','拫':' hén','拪':' qiān','择':' zé','拨':' bō','拧':' níng','拦':' lán','拥':' yōng','拤':' qiá','拣':' jiǎn','拢':' lǒng','拠':' jù','拭':' shì','拟':' nǐ','拞':' dǐ','拝':' bài','拜':' bài','招':' zhāo','拚':' pàn','拙':' zhuō','拘':' jū','拗':' ǎo','拖':' tuō','括':' kuò','拮':' jié','拔':' bá','拻':' huī','挅':' duǒ','挄':' kuò','挃':' zhì','挂':' guà','持':' chí','挀':' bāi','拿':' ná','拾':' shí','拽':' zhuāi','拼':' pīn','拺':' cè','拯':' zhěng','拹':' xié','拸':' yí','拷':' kǎo','拶':' zā','拵':' cún','拴':' shuān','拳':' quán','拲':' gǒng','拱':' gǒng','拰':' nǐn','拕':' tuō','拓':' tà','指':' zhǐ','抭':' yǎo','抷':' pī','抶':' chì','抵':' dǐ','抴':' yè','抳':' nǐ','抲':' hē','抱':' bào','抰':' yāng','抯':' zhā','抮':' zhěn','抬':' tái','抹':' mǒ','披':' pī','抪':' bù','抩':' tān','抨':' pēng','抧':' zhǐ','抦':' bǐng','报':' bào','护':' hù','抣':' yun','抢':' qiǎng','抸':' jiā','抺':' mèi','拒':' jù','拇':' mǔ','拑':' qián','拐':' guǎi','拏':' ná','拎':' līn','拍':' pāi','拌':' bàn','拋':' pāo','拊':' fǔ','拉':' lā','拈':' niān','拆':' chāi','抻':' chēn','担':' dān','拄':' zhǔ','拃':' zhǎ','拂':' fú','拁':' jiā','拀':' chù','抿':' mǐn','抾':' qū','抽':' chōu','押':' yā','挆':' duǒ','挈':' qiè','抠':' kōu','捉':' zhuō','捓':' yé','捒':' shù','捑':' zè','捐':' juān','捏':' niē','捎':' shāo','捍':' hàn','捌':' bā','捋':' lǚ','捊':' póu','捈':' tú','捕':' bǔ','捇':' huò','捆':' kǔn','捅':' tǒng','捄':' jiù','捃':' jùn','捂':' wǔ','捁':' jiǎo','捀':' féng','挿':' chā','挾':' xié','捔':' jué','捖':' wán','挼':' ruá','捣':' dǎo','捭':' bǎi','捬':' fǔ','捫':' mén','捪':' mín','捩':' liè','捨':' shě','捧':' pěng','捦':' qín','捥':' wàn','捤':' wei','换':' huàn','捗':' bù','捡':' jiǎn','捠':' bāng','损':' sǔn','捞':' lāo','捝':' tuō','捜':' sōu','捛':' lǚ','捚':' zhāi','捙':' yì','捘':' zùn','挽':' wǎn','挻':' shān','按':' àn','挕':' dié','挟':' xié','挞':' tà','挝':' wō','挜':' yà','挛':' luán','挚':' zhì','挙':' jǔ','挘':' lie','挗':' jué','挖':' wā','挔':' lǚ','挡':' dǎng','挓':' zhā','挒':' liè','挑':' tiāo','挐':' ná','挏':' dòng','挎':' kuà','挍':' jiào','挌':' gé','挋':' zhèn','挊':' nòng','挠':' náo','挢':' jiǎo','挺':' tǐng','振':' zhèn','挹':' yì','挸':' jiǎn','挷':' péng','挶':' jū','挵':' lòng','挴':' měi','挳':' kēng','挲':' sā','挱':' sā','挰':' chéng','挮':' tǐ','挣':' zhēng','挭':' gěng','挬':' bó','挫':' cuò','挪':' nuó','挩':' tuō','挨':' āi','挧':' yu','挦':' xián','挥':' huī','挤':' jǐ','抡':' lūn','抟':' tuán','捯':' dáo','我':' wǒ','戛':' jiá','戚':' qī','戙':' dòng','战':' zhàn','戗':' qiāng','或':' huò','戕':' qiāng','戔':' jiān','戓':' gē','戒':' jiè','成':' chéng','戝':' zéi','戏':' xì','戎':' róng','戍':' shù','戌':' xū','戋':' jiān','戊':' wù','戉':' yuè','戈':' gē','戇':' zhuàng','戆':' gàng','戜':' dié','戞':' jiá','戄':' jué','戫':' yù','戵':' qú','戴':' dài','戳':' chuō','戲':' xì','戱':' xì','戰':' zhàn','戯':' hū','戮':' lù','戭':' yǎn','戬':' jiǎn','截':' jié','戟':' jǐ','戩':' jiǎn','戨':' gē','戧':' qiāng','戦':' zhàn','戥':' děng','戤':' gài','戣':' kuí','戢':' jí','戡':' kān','戠':' zhī','戅':' gàng','戃':' tǎng','户':' hù','懝':' ài','懧':' nuò','懦':' nuò','懥':' zhì','懤':' chóu','懣':' mèn','懢':' lán','懡':' mǒ','懠':' qí','懟':' duì','懞':' méng','懜':' měng','懩':' yǎng','懛':' dāi','懚':' yìn','懙':' yǔ','懘':' chì','懗':' xià','懖':' kuò','懕':' yān','懔':' lǐn','懓':' ài','懒':' lǎn','懨':' yān','懪':' bó','戂':' mí','懷':' huái','戁':' nǎn','戀':' liàn','懿':' yì','懾':' shè','懽':' huān','懼':' jù','懻':' jì','懺':' chàn','懹':' ràng','懸':' xuán','懶':' lǎn','懫':' zhì','懵':' měng','懴':' chàn','懳':' hui','懲':' chéng','懱':' miè','懰':' liú','懯':' fū','懮':' yǒu','懭':' kuǎng','懬':' kuàng','戶':' hù','戸':' hù','択':' zé','批':' pī','抃':' biàn','抂':' kuáng','抁':' yǎn','技':' jì','承':' chéng','找':' zhǎo','扽':' dèn','扼':' è','扻':' zhì','扺':' zhǐ','扸':' xī','抅':' jū','扷':' ào','扶':' fú','扵':' yú','扴':' jiá','扳':' bān','扲':' qián','扱':' xī','扰':' rǎo','扯':' chě','扮':' bàn','抄':' chāo','抆':' wěn','扬':' yáng','抓':' zhuā','抝':' ǎo','抜':' bá','抛':' pāo','抚':' fǔ','抙':' póu','折':' zhé','抗':' kàng','抖':' dǒu','投':' tóu','抔':' póu','抒':' shū','抇':' hú','抑':' yì','抐':' nè','抏':' wán','抎':' yǔn','抍':' zhěng','抌':' dǎn','抋':' qìn','把':' bǎ','抉':' jué','抈':' yuè','扭':' niǔ','扫':' sǎo','戹':' è','扅':' yí','扏':' qiú','扎':' zhā','才':' cái','扌':' shou','手':' shǒu','扊':' yǎn','扉':' fēi','扈':' hù','扇':' shàn','扆':' yǐ','扄':' shǎng','扑':' pū','扃':' jiōng','扂':' diàn','扁':' biǎn','所':' suǒ','房':' fáng','戾':' lì','戽':' hù','戼':' mǎo','戻':' tì','戺':' shì','扐':' lè','扒':' bā','扪':' mén','扟':' shēn','扩':' kuò','扨':' rèn','执':' zhí','扦':' qiān','扥':' dèn','扤':' wù','扣':' kòu','扢':' gǔ','扡':' tuō','扠':' chā','扞':' gǎn','打':' dǎ','扝':' kū','扜':' yū','扛':' káng','扚':' diǎo','扙':' zhàng','托':' tuō','扗':' zài','扖':' ru','払':' fǎn','扔':' rēng','据':' jù','捰':' wǒ','懐':' huái','撂':' liào','撌':' guì','撋':' ruán','撊':' xiàn','撉':' dūn','撈':' lāo','撇':' piē','撆':' piē','撅':' juē','撄':' yīng','撃':' jí','撁':' qiān','撎':' yì','撀':' gòu','摿':' yīn','摾':' jiàng','摽':' biāo','摼':' kēng','摻':' càn','摺':' zhé','摹':' mó','摸':' mō','摷':' jiǎo','撍':' zǎn','撏':' xián','摵':' shè','撜':' zhěng','撦':' chě','撥':' bō','撤':' chè','撣':' dǎn','撢':' dǎn','撡':' cāo','撠':' jǐ','撟':' jiǎo','撞':' zhuàng','撝':' huī','撛':' lǐn','撐':' chēng','撚':' niǎn','撙':' zǔn','撘':' dā','撗':' guàng','撖':' hàn','撕':' sī','撔':' hòng','撓':' náo','撒':' sā','撑':' chēng','摶':' tuán','摴':' chū','撨':' fǔ','摎':' jiū','摘':' zhāi','摗':' sōu','摖':' qì','摕':' dì','摔':' shuāi','摓':' féng','摒':' bǐng','摑':' guāi','摐':' chuāng','摏':' chōng','摍':' suō','摚':' chēng','摌':' chǎn','摋':' sà','摊':' tān','摉':' sōu','摈':' bìn','摇':' yáo','摆':' bǎi','摅':' shū','摄':' shè','摃':' káng','摙':' liǎn','摛':' chī','摳':' kōu','摨':' nái','摲':' chàn','摱':' màn','摰':' niè','摯':' zhì','摮':' áo','摭':' zhí','摬':' yǐng','摫':' guī','摪':' jiāng','摩':' mó','摧':' cuī','摜':' guàn','摦':' huà','摥':' tàng','摤':' chuǎng','摣':' zhā','摢':' hù','摡':' gài','摠':' zǒng','摟':' lǒu','摞':' luò','摝':' lù','撧':' juē','撩':' liāo','摁':' èn','擪':' yè','擴':' kuò','擳':' zhì','擲':' zhì','擱':' gē','擰':' níng','擯':' bìn','擮':' jí','擭':' wò','擬':' nǐ','擫':' yè','擩':' rǔ','擶':' jiàn','擨':' yé','擧':' jǔ','擦':' cā','擥':' lǎn','擤':' xǐng','擣':' dǎo','擢':' zhuó','擡':' tái','擠':' jǐ','擟':' mí','擵':' mó','擷':' xié','擝':' meng','攄':' shū','攎':' lú','攍':' yíng','攌':' huǎn','攋':' là','攊':' lì','攉':' huō','攈':' jùn','攇':' xiǎn','攆':' niǎn','攅':' zǎn','攃':' cā','擸':' liè','攂':' lèi','攁':' yǎng','攀':' pān','擿':' tī','擾':' rǎo','擽':' lüè','擼':' lǔ','擻':' sǒu','擺':' bǎi','擹':' tān','擞':' sǒu','擜':' e','撪':' bèn','撶':' huá','擀':' gǎn','撿':' jiǎn','撾':' wō','撽':' qiào','撼':' hàn','撻':' tà','撺':' cuān','撹':' jiǎo','撸':' lū','撷':' xié','撵':' niǎn','擂':' léi','撴':' dūn','撳':' qìn','撲':' pū','撱':' wěi','撰':' zhuàn','撯':' zhuó','撮':' cuō','播':' bō','撬':' qiào','撫':' fǔ','擁':' yōng','擃':' nǎng','擛':' yè','擐':' huàn','據':' jù','擙':' ào','擘':' bāi','擗':' pǐ','擖':' kā','擕':' xié','擔':' dān','擓':' kuǎi','擒':' qín','擑':' jiē','擏':' qíng','擄':' lǔ','擎':' qíng','操':' cāo','擌':' sè','擋':' dǎng','擊':' jī','擉':' chuò','擈':' pū','擇':' zé','擆':' zhuó','擅':' shàn','摂':' shè','摀':' wǔ','捱':' ái','掱':' pá','掻':' sāo','掺':' càn','掹':' meng','掸':' dǎn','掷':' zhì','掶':' geng','掵':' ming','掴':' guāi','掳':' lǔ','掲':' jiē','掰':' bāi','掽':' pèng','掯':' kèn','掮':' qián','掭':' tiàn','掬':' jū','掫':' zhōu','措':' cuò','掩':' yǎn','推':' tuī','控':' kòng','掦':' tì','掼':' guàn','掾':' yuàn','掤':' bīng','揋':' wēi','揕':' zhèn','揔':' zǒng','揓':' shì','插':' chā','揑':' niē','提':' tí','描':' miáo','揎':' xuān','揍':' zòu','揌':' sāi','揊':' pì','掿':' nuò','揉':' róu','揈':' hōng','揇':' nǎn','揆':' kuí','揅':' yán','揄':' yú','揃':' jiǎn','揂':' jiū','揁':' zhēng','揀':' jiǎn','接':' jiē','掣':' chè','揗':' xún','捽':' zuó','掇':' duō','掆':' gāng','掅':' qìng','掄':' lūn','掃':' sǎo','掂':' diān','掁':' chéng','掀':' xiān','捿':' xī','捾':' wò','捼':' ruó','掉':' diào','捻':' niǎn','捺':' nà','捹':' bèn','捸':' tū','捷':' jié','捶':' chuí','捵':' chēn','捴':' zǒng','捳':' yuè','捲':' juǎn','授':' shòu','掊':' póu','探':' tàn','掗':' yà','採':' cǎi','掠':' lüè','掟':' zhěng','掞':' shàn','掝':' huò','掜':' yì','掛':' guà','掚':' liǎng','掙':' zhēng','掘':' jué','掖':' yē','掋':' dǐ','掕':' líng','掔':' qiān','掓':' shū','排':' pái','掑':' qí','掐':' qiā','掏':' tāo','掎':' jǐ','掍':' hùn','掌':' zhǎng','揖':' yī','揘':' yóng','搿':' gé','搚':' lā','搤':' è','搣':' miè','搢':' jìn','搡':' sǎng','搠':' shuò','搟':' xiǎn','搞':' gǎo','搝':' qiǔ','搜':' sōu','搛':' jiān','搙':' nù','搦':' nuò','搘':' zhī','搗':' dǎo','搖':' yáo','搕':' kē','搔':' sāo','搓':' cuō','搒':' bàng','搑':' róng','搐':' chù','搏':' bó','搥':' chuí','搧':' shān','損':' sǔn','搴':' qiān','搾':' zhà','搽':' chá','搼':' quán','搻':' nuò','携':' xié','搹':' è','搸':' zhēn','搷':' tián','搶':' qiǎng','搵':' wèn','搳':' huá','搨':' tà','搲':' wā','搱':' zhì','搰':' hú','搯':' tāo','搮':' lì','搭':' dā','搬':' bān','搫':' pán','搪':' táng','搩':' zhǎ','搎':' sūn','搌':' zhǎn','揙':' biān','揥':' tì','揯':' gèn','揮':' huī','揭':' jiē','揬':' tú','揫':' jiū','揪':' jiū','揩':' kāi','揨':' chén','揧':' là','揦':' lá','揤':' jí','揱':' xiāo','揣':' chuāi','揢':' ké','握':' wò','揠':' yà','揟':' xū','揞':' ǎn','揝':' zǎn','揜':' yǎn','換':' huàn','揚':' yáng','揰':' chòng','揲':' dié','搋':' chuāi','搀':' chān','搊':' chōu','搉':' què','搈':' róng','搇':' qìn','搆':' gòu','搅':' jiǎo','搄':' gēng','搃':' zǒng','搂':' lǒu','搁':' gē','揿':' qìn','揳':' xiē','揾':' wèn','揽':' lǎn','揼':' beng','揻':' wēi','揺':' yáo','揹':' bēi','揸':' zhā','揷':' chā','揶':' yé','揵':' qián','援':' yuán','懑':' mèn','懏':' jùn','攐':' qiān','徠':' lái','循':' xún','復':' fù','徨':' huáng','徧':' biàn','徦':' jiǎ','徥':' shì','徤':' jiàn','徣':' jiè','徢':' xiè','御':' yù','徟':' zhōu','徬':' páng','從':' cóng','徝':' zhì','徜':' cháng','徛':' jì','徚':' dōng','徙':' xǐ','徘':' pái','得':' dé','徖':' cóng','徕':' lái','徫':' wěi','徭':' yáo','従':' cóng','徺':' jiǎo','忄':' xin','心':' xīn','忂':' qú','忁':' bào','忀':' xiāng','徿':' lòng','徾':' méi','徽':' huī','徼':' jiǎo','徻':' huì','徹':' chè','微':' wēi','徸':' chōng','德':' dé','徶':' bié','徵':' zhēng','徴':' zhēng','徳':' dé','徲':' tí','徱':' piào','徰':' zhēng','徯':' xī','徔':' zhi','徒':' tú','忆':' yì','彬':' bīn','彶':' jí','彵':' tuǒ','彴':' zhuó','彳':' chì','彲':' chī','影':' yǐng','彰':' zhāng','彯':' piǎo','彮':' yǒng','彭':' péng','彫':' diāo','彸':' zhōng','彪':' biāo','彩':' cǎi','彨':' chī','彧':' yù','彦':' yàn','彥':' yàn','彤':' tóng','彣':' wén','形':' xíng','彡':' shān','彷':' fǎng','役':' yì','徑':' jìng','徆':' xī','徐':' xú','徏':' zhì','徎':' chěng','徍':' wǎng','後':' hòu','律':' lǜ','徊':' huái','徉':' yáng','很':' hěn','徇':' xùn','待':' dài','彺':' wáng','径':' jìng','徃':' wǎng','徂':' cú','征':' zhēng','往':' wǎng','彿':' fú','彾':' líng','彽':' dī','彼':' bǐ','彻':' chè','必':' bì','忇':' lè','彟':' yuē','怈':' yì','怒':' nù','怑':' bàn','怐':' jù','怏':' yàng','怎':' zěn','怍':' zuò','怌':' pēi','怋':' mín','怊':' chāo','怉':' bǎo','怇':' jù','怔':' zhēng','怆':' chuàng','怅':' chàng','怄':' òu','怃':' wǔ','怂':' sǒng','态':' tài','怀':' huái','忿':' fèn','忾':' kài','忽':' hū','怓':' náo','怕':' pà','忻':' xīn','怢':' tū','怬':' xì','怫':' fú','怪':' guài','怩':' ní','怨':' yuàn','性':' xìng','怦':' pēng','急':' jí','怤':' fū','怣':' yóu','怡':' yí','怖':' bù','怠':' dài','怟':' dì','怞':' chóu','思':' sī','怜':' lián','怛':' dá','怚':' jù','怙':' hù','怘':' hù','怗':' tiē','忼':' kāng','忺':' xiān','忈':' rén','忔':' qì','忞':' mín','忝':' tiǎn','応':' yīng','忛':' fán','忚':' xī','忙':' máng','忘':' wàng','志':' zhì','忖':' cǔn','忕':' shì','忓':' gān','忠':' zhōng','忒':' tè','忑':' tè','忐':' tǎn','忏':' chàn','忎':' rén','忍':' rěn','忌':' jì','忋':' gǎi','忊':' dìng','忉':' dāo','忟':' wěn','忡':' chōng','忹':' kuáng','忮':' zhì','忸':' niǔ','忷':' xiōng','忶':' hún','念':' niàn','忴':' qián','忳':' tún','忲':' tài','忱':' chén','忰':' cuì','忯':' qí','忭':' biàn','忢':' wù','忬':' yù','快':' kuài','忪':' sōng','忩':' cōng','忨':' wàn','忧':' yōu','忦':' jiá','忥':' xì','忤':' wǔ','忣':' jí','彠':' yuē','彞':' yí','怮':' yōu','廐':' jiù','廚':' chú','廙':' yì','廘':' lù','廗':' dài','廖':' liào','廕':' yìn','廔':' lóu','廓':' kuò','廒':' áo','廑':' jǐn','廏':' jiù','廜':' tú','廎':' qǐng','廍':' pǒu','廌':' zhì','廋':' sōu','廊':' láng','廉':' lián','廈':' shà','廇':' liù','廆':' guī','廅':' è','廛':' chán','廝':' sī','廃':' fèi','廪':' lǐn','廴':' yǐn','廳':' tīng','廲':' lí','廱':' yōng','廰':' tīng','廯':' xiān','廮':' yǐng','廭':' ji','廬':' lú','廫':' liáo','廩':' lǐn','廞':' xīn','廨':' xiè','廧':' qiáng','廦':' bì','廥':' kuài','廤':' kù','廣':' guǎng','廢':' fèi','廡':' wǔ','廠':' chǎng','廟':' miào','廄':' jiù','廂':' xiāng','延':' yán','府':' fǔ','度':' dù','庥':' xiū','庤':' zhì','庣':' tiāo','庢':' zhì','庡':' yǐ','庠':' xiáng','废':' fèi','庞':' páng','庝':' tóng','庛':' cì','庨':' xiāo','庚':' gēng','庙':' miào','庘':' yā','店':' diàn','庖':' páo','底':' dǐ','应':' yīng','库':' kù','庒':' zhuang','庑':' wǔ','座':' zuò','庩':' tú','廁':' cè','庶':' shù','廀':' sōu','庿':' miào','庾':' yǔ','庽':' yù','庼':' qǐng','庻':' shù','庺':' sōng','庹':' tuǒ','庸':' yōng','康':' kāng','庵':' ān','庪':' guǐ','庴':' jí','庳':' bì','庲':' lái','庱':' chěng','庰':' bìng','庯':' bū','庮':' yǒu','庭':' tíng','庬':' máng','庫':' kù','廵':' xún','廷':' tíng','彝':' yí','弸':' péng','彂':' fā','彁':' ge','彀':' gòu','弿':' jiǎn','弾':' dàn','弽':' shè','弼':' bì','弻':' bì','强':' qiáng','弹':' dàn','強':' qiáng','彄':' kōu','弶':' jiàng','張':' zhāng','弴':' diāo','弳':' jìng','弲':' xuān','弱':' ruò','弰':' shāo','弯':' wān','弮':' quān','弭':' mǐ','彃':' bì','彅':' jian','弫':' zhěn','归':' guī','彜':' yí','彛':' yí','彚':' huì','彙':' huì','彘':' zhì','彗':' huì','彖':' tuàn','录':' lù','彔':' lù','当':' dāng','彑':' jì','彆':' biè','彐':' jì','彏':' jué','彎':' wān','彍':' guō','彌':' mí','彋':' hóng','彊':' jiàng','彉':' guō','彈':' dàn','彇':' xiāo','弬':' yí','弪':' jìng','廸':' dí','弄':' nòng','弎':' sān','弍':' èr','弌':' yī','弋':' yì','弊':' bì','弉':' zàng','弈':' yì','弇':' yǎn','弆':' jǔ','弅':' fèn','弃':' qì','弐':' èr','异':' yì','弁':' biàn','开':' kāi','廿':' niàn','廾':' gǒng','廽':' huí','廼':' nǎi','廻':' huí','建':' jiàn','廹':' pǎi','式':' shì','弑':' shì','弩':' nǔ','弞':' shěn','弨':' chāo','弧':' hú','弦':' xián','弥':' mí','弤':' dǐ','弣':' fǔ','弢':' tāo','弡':' jué','张':' zhāng','弟':' dì','弝':' bà','弒':' shì','弜':' jiàng','弛':' chí','弚':' tuí','弙':' wū','弘':' hóng','弗':' fú','弖':' hù','引':' yǐn','弔':' diào','弓':' gōng','怭':' bì','怯':' qiè','懎':' sè','慁':' hùn','態':' tài','慊':' qiàn','慉':' xù','慈':' cí','慇':' yīn','慆':' tāo','慅':' sāo','慄':' lì','慃':' yǎng','慂':' yǒng','慀':' xì','慍':' yùn','愿':' yuàn','愾':' kài','愽':' bó','愼':' shèn','愻':' xùn','愺':' cǎo','愹':' yǒng','愸':' zhěng','愷':' kǎi','愶':' xié','慌':' huāng','慎':' shèn','愴':' chuàng','慛':' cuī','慥':' zào','慤':' què','慣':' guàn','慢':' màn','慡':' shuǎng','慠':' ào','慟':' tòng','慞':' zhāng','慝':' tè','慜':' mǐn','慚':' cán','慏':' mǐng','慙':' cán','慘':' cǎn','慗':' chì','慖':' guó','慕':' mù','慔':' mù','慓':' piāo','慒':' cóng','慑':' shè','慐':' gong','愵':' nì','愳':' jù','慧':' huì','愍':' mǐn','愗':' mào','愖':' chén','愕':' è','愔':' yīn','愓':' dàng','愒':' kài','愑':' yǒng','愐':' miǎn','意':' yì','愎':' bì','愌':' huàn','愙':' kè','愋':' xuān','愊':' bì','愉':' yú','愈':' yù','愇':' wěi','愆':' qiān','愅':' gé','愄':' wēi','愃':' xuān','愂':' bèi','愘':' qià','愚':' yú','愲':' gǔ','愧':' kuì','愱':' jí','愰':' huàng','愯':' sǒng','愮':' yáo','愭':' qí','愬':' sù','愫':' sù','愪':' yún','愩':' gōng','愨':' què','愦':' kuì','愛':' ài','愥':' ying','愤':' fèn','愣':' lèng','愢':' sāi','愡':' zǒng','愠':' yùn','感':' gǎn','愞':' nuò','愝':' yǎn','愜':' qiè','慦':' jiù','慨':' kǎi','愀':' qiǎo','憩':' qì','憳':' tǎn','憲':' xiàn','憱':' cù','憰':' jué','憯':' cǎn','憮':' wǔ','憭':' liǎo','憬':' jǐng','憫':' mǐn','憪':' xián','憨':' hān','憵':' pī','憧':' chōng','憦':' lào','憥':' láo','憤':' fèn','憣':' fān','憢':' xiāo','憡':' cè','憠':' jué','憟':' sù','憞':' duì','憴':' shéng','憶':' yì','憜':' duǒ','懃':' qín','懍':' lǐn','懌':' yì','懋':' mào','懊':' ào','應':' yīng','懈':' xiè','懇':' kěn','懆':' cǎo','懅':' jù','懄':' qín','懂':' dǒng','憷':' chù','懁':' xuān','懀':' wèi','憿':' jiǎo','憾':' hàn','憽':' sōng','憼':' jǐng','憻':' tǎn','憺':' dàn','憹':' náo','憸':' xiān','憝':' duì','憛':' tán','慩':' lián','慵':' yōng','慿':' píng','慾':' yù','慽':' qī','慼':' qī','慻':' juàn','慺':' lóu','慹':' zhí','慸':' dì','慷':' kāng','慶':' qìng','慴':' shè','憁':' còng','慳':' qiān','慲':' mán','慱':' tuán','慰':' wèi','慯':' shāng','慮':' lǜ','慭':' yìn','慬':' qín','慫':' sǒng','慪':' òu','憀':' liáo','憂':' yōu','憚':' dàn','憏':' chì','憙':' xī','憘':' xǐ','憗':' yìn','憖':' yìn','憕':' chéng','憔':' qiáo','憓':' huì','憒':' kuì','憑':' píng','憐':' lián','憎':' zēng','憃':' chōng','憍':' jiāo','憌':' qióng','憋':' biē','憊':' bèi','憉':' péng','憈':' qū','憇':' qì','憆':' chēng','憅':' tòng','憄':' zhì','愁':' chóu','惿':' tí','怰':' xuàn','恰':' qià','恺':' kǎi','恹':' yān','恸':' tòng','恷':' xiao','恶':' è','恵':' huì','恴':' dé','恳':' kěn','恲':' pēng','恱':' yuè','息':' xī','恼':' nǎo','恮':' quān','恭':' gōng','恬':' tián','恫':' dòng','恪':' kè','恩':' ēn','恨':' hèn','恧':' nǜ','恦':' shàng','恥':' chǐ','恻':' cè','恽':' yùn','恣':' zì','悊':' zhé','悔':' huǐ','悓':' qiàn','悒':' yì','悑':' bù','悐':' tì','悏':' qiè','悎':' hào','悍':' hàn','悌':' tì','悋':' lìn','悉':' xī','恾':' máng','悈':' jiè','悇':' tú','悆':' yù','悅':' yuè','悄':' qiāo','悃':' kǔn','悂':' pī','悁':' yuān','悀':' yǒng','恿':' yǒng','恤':' xù','恢':' huī','悖':' bèi','怼':' duì','恆':' héng','恅':' lǎo','恄':' xì','恃':' shì','恂':' xún','恁':' nèn','恀':' shì','怿':' yì','怾':' zhǐ','怽':' mo','总':' zǒng','恈':' móu','怺':' yong','怹':' tān','怸':' xī','怷':' shù','怶':' bì','怵':' chù','怴':' xù','怳':' huǎng','怲':' bǐng','怱':' cōng','恇':' kuāng','恉':' zhǐ','恡':' lìn','恖':' si','恠':' guài','恟':' xiōng','恞':' yí','恝':' jiá','恜':' chì','恛':' huí','恚':' huì','恙':' yàng','恘':' qiū','恗':' hū','恕':' shù','恊':' xié','恔':' jiǎo','恓':' xī','恒':' héng','恑':' guǐ','恐':' kǒng','恏':' hào','恎':' dié','恍':' huǎng','恌':' tiāo','恋':' liàn','悕':' xī','悗':' mán','惾':' zōng','惙':' chuò','惣':' zǒng','惢':' suǒ','惡':' è','惠':' huì','惟':' wéi','惞':' xīn','惝':' chǎng','惜':' xī','惛':' hūn','惚':' hū','惘':' wǎng','惥':' yǒng','惗':' niè','惖':' tì','惕':' tì','惔':' tán','惓':' quán','惒':' hé','惑':' huò','惐':' yù','惏':' lán','惎':' jì','惤':' jiān','惦':' diàn','惌':' yuān','想':' xiǎng','惽':' mǐn','惼':' biǎn','惻':' cè','惺':' xīng','惹':' rě','惸':' qióng','惷':' chǔn','惶':' huáng','惵':' dié','惴':' zhuì','惲':' yùn','惧':' jù','惱':' nǎo','惰':' duò','惯':' guàn','惮':' dàn','惭':' cán','惬':' qiè','惫':' bèi','惪':' dé','惩':' chéng','惨':' cǎn','惍':' jīn','惋':' wǎn','悘':' yī','悤':' cōng','悮':' wù','悭':' qiān','悬':' xuán','悫':' què','悪':' è','悩':' nǎo','您':' nín','悧':' lì','悦':' yuè','悥':' yì','患':' huàn','悰':' cóng','悢':' liàng','悡':' lí','悠':' yōu','悟':' wù','悞':' wù','悝':' kuī','悜':' chěng','悛':' quān','悚':' sǒng','悙':' hēng','悯':' mǐn','悱':' fěi','惊':' jīng','悿':' tiǎn','惉':' zhān','惈':' guǒ','惇':' dūn','惆':' chóu','情':' qíng','惄':' nì','惃':' gǔn','惂':' kǎn','惁':' xī','惀':' lún','悾':' kōng','悲':' bēi','悽':' qī','悼':' dào','悻':' xìng','悺':' guàn','悹':' guàn','悸':' jì','悷':' sàn','悶':' mèn','悵':' chàng','悴':' cuì','悳':' duó','攏':' lǒng','攑':' qiān','序':' xù','楥':' xuàn','楯':' dùn','楮':' chǔ','業':' yè','楬':' jié','楫':' jí','楪':' yè','楩':' pián','楨':' zhēn','楧':' yǎng','楦':' xuàn','楤':' sǒng','楱':' zòu','楣':' méi','楢':' yóu','楡':' yú','楠':' nán','楟':' tíng','楞':' léng','楝':' liàn','楜':' hú','楛':' hù','楚':' chǔ','楰':' yú','楲':' wēi','楘':' mù','楿':' xiang','榉':' jǔ','榈':' lǘ','榇':' chèn','榆':' yú','榅':' wēn','榄':' lǎn','榃':' tán','概':' gài','榁':' shi','榀':' pǐn','楾':' quan','楳':' méi','楽':' lè','楼':' lóu','楻':' huáng','楺':' rǒu','楹':' yíng','楸':' qiū','楷':' kǎi','楶':' jié','極':' jí','楴':' tì','楙':' mào','楗':' jiàn','榋':' chu','椱':' fù','椻':' yàn','椺':' xí','椹':' shèn','椸':' yí','椷':' jiān','椶':' zōng','椵':' jiǎ','椴':' duàn','椳':' wēi','椲':' wěi','椰':' yē','椽':' chuán','椯':' duǒ','椮':' sēn','椭':' tuǒ','椬':' yi','椫':' zhǎn','椪':' pèng','椩':' geng','椨':' fu','椧':' mìng','椦':' quan','椼':' yǎn','椾':' jiān','楖':' zhì','楋':' là','楕':' tuǒ','楔':' xiē','楓':' fēng','楒':' sī','楑':' kuí','楐':' jiè','楏':' kuí','楎':' huī','楍':' běn','楌':' yán','楊':' yáng','椿':' chūn','楉':' ruò','楈':' xū','楇':' huò','楆':' yāo','楅':' bī','楄':' pián','楃':' wò','楂':' zhā','楁':' hé','楀':' yǔ','榊':' shen','榌':' pi','椤':' luó','槍':' qiāng','槗':' qiao','槖':' tuó','槕':' zhuó','槔':' gāo','槓':' gàng','槒':' xù','槑':' méi','槐':' huái','槏':' qiǎn','槎':' chá','槌':' chuí','槙':' diān','構':' gòu','槊':' shuò','槉':' jí','槈':' nòu','槇':' diān','槆':' xún','槅':' gé','槄':' tāo','槃':' pán','槂':' sūn','様':' yàng','槚':' jiǎ','槀':' gǎo','槧':' qiàn','槱':' yǒu','槰':' péng','槯':' cuī','槮':' sēn','槭':' qī','槬':' huà','槫':' tuán','槪':' gài','槩':' gài','槨':' guǒ','槦':' yōng','槛':' kǎn','槥':' huì','槤':' lián','槣':' jī','槢':' xí','槡':' sang','槠':' zhū','槟':' bīn','槞':' long','槝':' dao','槜':' zuì','槁':' gǎo','榿':' qī','榍':' xiè','榙':' tā','榣':' yáo','榢':' jià','榡':' sù','榠':' míng','榟':' zǐ','榞':' yuán','榝':' shā','榜':' bǎng','榛':' zhēn','榚':' yǎo','榘':' jǔ','榥':' huàng','榗':' jiàn','榖':' gǔ','榕':' róng','榔':' láng','榓':' mì','榒':' nuò','榑':' fú','榐':' zhǎn','榏':' yì','榎':' jiǎ','榤':' jié','榦':' gàn','榾':' gǔ','榳':' tíng','榽':' xī','榼':' kē','榻':' tà','榺':' shèng','榹':' sī','榸':' zhāi','榷':' què','榶':' táng','榵':' róng','榴':' liú','榲':' yún','榧':' fěi','榱':' cuī','榰':' zhī','榯':' shí','榮':' róng','榭':' xiè','榬':' yuán','榫':' sǔn','榪':' mà','榩':' qián','榨':' zhà','椥':' zhī','椣':' dian','槳':' jiǎng','梕':' rèn','梟':' xiāo','梞':' jì','條':' tiáo','梜':' jiā','梛':' nuó','梚':' wǎn','梙':' huàn','梘':' jiǎn','梗':' gěng','梖':' bèi','梔':' zhī','梡':' hún','梓':' zǐ','梒':' hán','梑':' dí','梐':' bì','梏':' gù','梎':' āo','梍':' zào','梌':' tú','梋':' xuān','梊':' dì','梠':' lǚ','梢':' shāo','梈':' pēng','梯':' tī','梹':' bīn','梸':' lí','梷':' jìng','梶':' wěi','梵':' fàn','梴':' chān','梳':' shū','梲':' zhuó','梱':' kǔn','械':' xiè','梮':' jū','梣':' cén','梭':' suō','梬':' yǐng','梫':' qǐn','梪':' dòu','梩':' lí','梨':' lí','梧':' wú','梦':' mèng','梥':' sōng','梤':' fén','梉':' zhuāng','梇':' lòng','梻':' fo','桡':' ráo','桫':' suō','桪':' xún','桩':' zhuāng','桨':' jiǎng','桧':' guì','桦':' huà','桥':' qiáo','桤':' qī','档':' dàng','桢':' zhēn','桠':' yā','桭':' zhēn','桟':' zhàn','桞':' liu','桝':' jie','桜':' yīng','桚':' zǎn','桙':' yú','桘':' zhuì','桗':' duò','桖':' xuè','桕':' jiù','桬':' shā','桮':' bēi','梆':' bāng','桻':' fēng','梅':' méi','梄':' yǒu','梃':' tǐng','梂':' qiú','梁':' liáng','梀':' sù','桿':' gǎn','桾':' jūn','桽':' wěn','桼':' qī','桺':' liǔ','桯':' tīng','桹':' láng','桸':' xī','桷':' jué','桶':' tǒng','桵':' ruí','桴':' fú','桳':' bèn','桲':' po','桱':' jìng','桰':' kuò','梺':' xia','梼':' táo','椢':' guì','棽':' shēn','椇':' jǔ','椆':' chóu','椅':' yǐ','椄':' jiē','椃':' háo','椂':' lù','椁':' guǒ','椀':' wǎn','棿':' ní','棾':' qíng','棼':' fén','椉':' chéng','棻':' fēn','棺':' guān','棹':' zhào','棸':' zōu','棷':' zōu','棶':' lái','棵':' kē','棴':' fú','棳':' zhuō','棲':' qī','椈':' jú','椊':' zuó','棰':' chuí','椗':' dìng','椡':' dao','椠':' qiàn','椟':' dú','椞':' xì','椝':' guī','検':' jiǎn','椛':' hua','椚':' men','椙':' chang','椘':' chǔ','椖':' péng','椋':' liáng','椕':' bīn','椔':' zī','椓':' zhuó','椒':' jiāo','椑':' bēi','椐':' jū','椏':' yā','椎':' chuí','植':' zhí','椌':' qiāng','棱':' léng','棯':' rěn','梽':' zhì','棉':' mián','棓':' bàng','棒':' bàng','棑':' pái','棐':' fěi','棏':' dé','棎':' chán','棍':' gùn','棌':' cài','棋':' qí','棊':' qí','棈':' qiàn','棕':' zōng','棇':' cōng','棆':' lún','棅':' bìng','棄':' qì','棃':' lí','棂':' líng','棁':' zhuō','检':' jiǎn','梿':' lián','梾':' lái','棔':' hūn','棖':' chéng','森':' sēn','棣':' dì','棭':' yì','棬':' quān','棫':' yù','棪':' yǎn','棩':' yuān','棨':' qǐ','棧':' zhàn','棦':' chēng','棥':' fán','棤':' cuò','棢':' wǎng','棗':' zǎo','棡':' gāng','棠':' táng','棟':' dòng','棞':' jùn','棝':' gù','棜':' yù','棛':' yù','棚':' péng','棙':' lì','棘':' jí','槲':' hú','槴':' hù','桓':' huán','欆':' shuāng','欐':' lì','欏':' luó','欎':' yù','欍':' jiu','欌':' cang','欋':' qú','權':' quán','欉':' cóng','欈':' wéi','欇':' shè','欅':' jǔ','欒':' luán','欄':' lán','欃':' chán','欂':' bó','欁':' nóng','欀':' xiāng','櫿':' yíng','櫾':' yóu','櫽':' yǐn','櫼':' jiān','櫻':' yīng','欑':' cuán','欓':' dǎng','櫹':' xiāo','欠':' qiàn','欪':' chù','欩':' chāo','欨':' xū','欧':' ōu','欦':' qiān','欥':' yì','欤':' yú','欣':' xīn','欢':' huān','次':' cì','欟':' guang','欔':' jué','欞':' líng','欝':' yù','欜':' náng','欛':' bà','欚':' lǐ','欙':' léi','欘':' zhú','欗':' lán','欖':' lǎn','欕':' yan','櫺':' líng','櫸':' jǔ','欬':' kài','櫒':' sà','櫜':' gāo','櫛':' zhì','櫚':' lú','櫙':' ōu','櫘':' huì','櫗':' miè','櫖':' lǜ','櫕':' cuán','櫔':' lì','櫓':' lǔ','櫑':' léi','櫞':' yuán','櫐':' lěi','櫏':' qiān','櫎':' huǎng','櫍':' zhì','櫌':' yōu','櫋':' mián','櫊':' ge','櫉':' chú','櫈':' dèng','櫇':' pó','櫝':' dú','櫟':' lì','櫷':' guī','櫬':' chèn','櫶':' xiǎn','櫵':' jiao','櫴':' lài','櫳':' lóng','櫲':' yù','櫱':' niè','櫰':' huái','櫯':' sū','櫮':' è','櫭':' jié','櫫':' zhū','櫠':' fèi','櫪':' lì','櫩':' yán','櫨':' lú','櫧':' zhū','櫦':' qing','櫥':' chú','櫤':' jiang','櫣':' lián','櫢':' sǒu','櫡':' zhuó','欫':' qì','欭':' yì','櫅':' jī','歮':' sè','歸':' guī','歷':' lì','歶':' yú','歵':' cuò','歴':' lì','歳':' suì','歲':' suì','歱':' zhǒng','歰':' sè','歯':' chǐ','歭':' chí','歺':' è','歬':' qián','歫':' jù','歪':' wāi','歩':' bù','歨':' bù','歧':' qí','武':' wǔ','步':' bù','此':' cǐ','正':' zhèng','歹':' dǎi','死':' sǐ','歡':' huān','殈':' xù','殒':' yǔn','殑':' qíng','殐':' sù','殏':' qiú','殎':' qià','殍':' piǎo','殌':' jué','残':' cán','殊':' shū','殉':' xùn','殇':' shāng','歼':' jiān','殆':' dài','殅':' shēng','殄':' tiǎn','殃':' yāng','殂':' cú','殁':' mò','殀':' yāo','歿':' mò','歾':' mò','歽':' zhé','止':' zhǐ','歠':' chuò','欮':' jué','欺':' qī','歄':' guā','歃':' shà','歂':' chuǎn','歁':' kǎn','歀':' kuǎn','欿':' kǎn','款':' kuǎn','欽':' qīn','欼':' chǐ','欻':' chuā','欹':' yī','歆':' xīn','欸':' āi','欷':' xī','欶':' shuò','欵':' kuǎn','欴':' láng','欳':' kuì','欲':' yù','欱':' hē','欰':' xù','欯':' xì','歅':' yīn','歇':' xiē','歟':' yú','歔':' xū','歞':' è','歝':' yì','歜':' chù','歛':' hān','歚':' shàn','歙':' shè','歘':' chuā','歗':' xiào','歖':' xǐ','歕':' pēn','歓':' huān','歈':' yú','歒':' tì','歑':' hū','歐':' ōu','歏':' jìn','歎':' tàn','歍':' wū','歌':' gē','歋':' yè','歊':' xiāo','歉':' qiàn','櫆':' kuí','櫄':' chūn','槵':' huàn','樵':' qiáo','樿':' shàn','樾':' yuè','樽':' zūn','樼':' zhēn','樻':' kuì','樺':' huà','樹':' shù','樸':' pǔ','樷':' cóng','樶':' zuī','樴':' zhí','橁':' chūn','樳':' xún','樲':' èr','樱':' yīng','樰':' xue','樯':' qiáng','樮':' yan','樭':' ji','樬':' cōng','樫':' jiān','横':' héng','橀':' xī','橂':' diàn','樨':' xī','橏':' zhǎn','橙':' chéng','橘':' jú','橗':' méng','橖':' táng','橕':' chēng','橔':' dūn','橓':' shùn','橒':' yún','橑':' lǎo','橐':' tuó','橎':' fán','橃':' fá','橍':' rùn','橌':' xiàn','橋':' qiáo','橊':' liú','橉':' lìn','橈':' ráo','橇':' qiāo','橆':' wǔ','橅':' mó','橄':' gǎn','権':' quán','樧':' shā','橛':' jué','樁':' zhuāng','樋':' tǒng','樊':' fán','樉':' shuǎng','樈':' qíng','樇':' xiū','樆':' lí','樅':' cōng','樄':' chén','樃':' lǎng','樂':' lè','樀':' dī','樍':' zé','槿':' jǐn','槾':' màn','槽':' cáo','槼':' guī','槻':' guī','槺':' kāng','槹':' gāo','槸':' yì','槷':' niè','槶':' guì','樌':' guàn','樎':' sù','樦':' zhù','樛':' jiū','樥':' péng','樤':' tiáo','樣':' yàng','樢':' niǎo','模':' mó','樠':' mán','樟':' zhāng','樞':' shū','樝':' zhā','樜':' zhè','樚':' lù','樏':' lěi','標':' biāo','樘':' táng','樗':' chū','樖':' kē','樕':' sù','樔':' cháo','樓':' lóu','樒':' mì','樑':' liáng','樐':' lǔ','橚':' sù','橜':' jué','櫃':' guì','檞':' jiě','檨':' shē','檧':' sōng','檦':' biǎo','檥':' yǐ','檤':' dào','檣':' qiáng','檢':' jiǎn','檡':' zhái','檠':' qíng','檟':' jiǎ','檝':' jí','檪':' li','檜':' guì','檛':' zhuā','檚':' chǔ','檙':' chéng','檘':' píng','檗':' bò','檖':' suì','檕':' jì','檔':' dàng','檓':' huǐ','檩':' lǐn','檫':' chá','檑':' léi','檸':' níng','櫂':' zhào','櫁':' mì','櫀':' qí','檿':' yǎn','檾':' qǐng','檽':' nòu','檼':' yìn','檻':' kǎn','檺':' gǎo','檹':' yī','檷':' nǐ','檬':' méng','檶':' qiān','檵':' jì','檴':' huò','檳':' bīn','檲':' tuán','檱':' qí','檰':' mián','檯':' tái','檮':' táo','檭':' yín','檒':' fēng','檐':' yán','橝':' diàn','橩':' qióng','橳':' sheng','橲':' xi','橱':' chú','橰':' gāo','橯':' lào','橮':' liǔ','橭':' gū','橬':' qián','橫':' héng','橪':' rǎn','橨':' fén','橵':' san','橧':' zēng','橦':' tóng','橥':' zhū','橤':' ruǐ','橣':' nǐng','橢':' tuǒ','橡':' xiàng','橠':' nuǒ','機':' jī','橞':' huì','橴':' zi','橶':' jí','檏':' pǔ','檄':' xí','檎':' qín','檍':' yì','檌':' zuì','檋':' jú','檊':' gàn','檉':' chēng','檈':' xuán','檇':' zuì','檆':' shān','檅':' suì','檃':' yǐn','橷':' dōu','檂':' nóng','檁':' lǐn','檀':' tán','橿':' jiāng','橾':' shū','橽':' tà','橼':' yuán','橻':' chu','橺':' jian','橹':' lǔ','橸':' jing','桔':' jú','桒':' sāng','攒':' zǎn','昣':' zhěn','昭':' zhāo','昬':' hūn','昫':' xù','昪':' biàn','昩':' mò','昨':' zuó','昧':' mèi','昦':' hào','春':' chūn','昤':' líng','昢':' pò','是':' shì','昡':' xuàn','映':' yìng','星':' xīng','昞':' bǐng','昝':' zǎn','昜':' yáng','昛':' jù','昚':' shèn','昙':' tán','昘':' fǎng','昮':' zòng','昰':' shì','昖':' yán','昽':' lóng','晇':' xū','晆':' kuí','晅':' xuǎn','晄':' huǎng','晃':' huǎng','時':' shí','晁':' cháo','晀':' tiǎo','昿':' kuàng','显':' xiǎn','昼':' zhòu','昱':' yù','昻':' áng','昺':' bǐng','昹':' ǎi','昸':' dōng','昷':' wēn','昶':' chǎng','昵':' nì','昴':' mǎo','昳':' dié','昲':' fèi','昗':' zè','昕':' xīn','晉':' jìn','旯':' lá','旹':' shí','旸':' yáng','旷':' kuàng','时':' shí','旵':' chǎn','旴':' xū','旳':' dì','旲':' tái','旱':' hàn','旰':' gàn','旮':' gā','旻':' mín','旭':' xù','旬':' xún','旫':' tiāo','旪':' xié','早':' zǎo','旨':' zhǐ','旧':' jiù','旦':' dàn','日':' rì','旤':' huò','旺':' wàng','旼':' mín','昔':' xī','昉':' fǎng','易':' yì','昒':' hū','昑':' qǐn','昐':' fēn','昏':' hūn','明':' míng','昍':' xuān','昌':' chāng','昋':' guì','昊':' hào','昈':' hù','旽':' tùn','昇':' shēng','昆':' kūn','昅':' jié','昄':' bǎn','昃':' zè','昂':' áng','昁':' bèi','昀':' yún','旿':' wǔ','旾':' chūn','晈':' jiǎo','晊':' zhì','既':' jì','暋':' mǐn','暕':' jiǎn','暔':' nán','暓':' mào','暒':' qíng','暑':' shǔ','暐':' wěi','暏':' shǔ','暎':' yìng','暍':' yē','暌':' kuí','暊':' xǔ','暗':' àn','暉':' huī','暈':' yūn','暇':' xiá','暆':' yí','暅':' gèng','暄':' xuān','暃':' fei','暂':' zàn','暁':' xiǎo','暀':' wǎng','暖':' nuǎn','暘':' yáng','晾':' liàng','暥':' yàn','暯':' mò','暮':' mù','暭':' hào','暬':' xiè','暫':' zàn','暪':' mèn','暩':' jì','暨':' jì','暧':' ài','暦':' lì','暤':' hào','暙':' chūn','暣':' qì','暢':' chàng','暡':' wěng','暠':' gǎo','暟':' kǎi','暞':' jiǎo','暝':' míng','暜':' jìn','暛':' suǒ','暚':' yáo','晿':' chāng','晽':' lín','晋':' jìn','晗':' hán','晡':' bū','晠':' shèng','晟':' chéng','晞':' xī','晝':' zhòu','晜':' kūn','晛':' xiàn','晚':' wǎn','晙':' jùn','晘':' hàn','晖':' huī','晣':' zhé','晕':' yūn','晔':' yè','晓':' xiǎo','晒':' shài','晑':' xiǎng','晐':' gāi','晏':' yàn','晎':' hǒng','晍':' tóng','晌':' shǎng','晢':' zhé','晤':' wù','晼':' wǎn','晱':' shǎn','晻':' àn','智':' zhì','晹':' yì','晸':' zhěng','晷':' guǐ','晶':' jīng','晵':' qǐ','晴':' qíng','晳':' xī','晲':' nǐ','晰':' xī','晥':' hàn','景':' jǐng','普':' pǔ','晭':' zhǒu','晬':' zuì','晫':' zhuó','晪':' tiǎn','晩':' wǎn','晨':' chén','晧':' hào','晦':' huì','旣':' jì','旡':' jì','暱':' nì','敓':' duó','敝':' bì','敜':' niè','敛':' liǎn','敚':' duó','教':' jiào','敘':' xù','敗':' bài','敖':' áo','敕':' chì','敔':' yǔ','救':' jiù','敟':' diǎn','敐':' chén','敏':' mǐn','敎':' jiào','敍':' xù','敌':' dí','敋':' gé','敊':' chù','敉':' mǐ','效':' xiào','敇':' cè','敞':' chǎng','敠':' duō','故':' gù','敭':' yáng','敷':' fū','敶':' zhèn','敵':' dí','整':' zhěng','敳':' ái','敲':' qiāo','敱':' ái','数':' shù','敯':' mín','敮':' xiá','敬':' jìng','敡':' yì','敫':' jiǎo','敪':' duó','敩':' xiào','敨':' tǒu','敧':' jī','敦':' dūn','敥':' yàn','敤':' kě','散':' sàn','敢':' gǎn','敆':' hé','敄':' wù','敹':' liáo','攞':' luó','攨':' wā','攧':' diān','攦':' lì','攥':' zuàn','攤':' tān','攣':' luán','攢':' zǎn','攡':' lí','攠':' mí','攟':' jùn','攝':' shè','攪':' jiǎo','攜':' xié','攛':' cuān','攚':' ying','攙':' chān','攘':' rǎng','攗':' méi','攖':' yīng','攕':' xiān','攔':' lán','攓':' qiān','攩':' dǎng','攫':' jué','敃':' mǐn','攸':' yōu','敂':' kòu','敁':' diān','敀':' pò','政':' zhèng','放':' fàng','攽':' bān','攼':' gān','攻':' gōng','攺':' yǐ','改':' gǎi','攷':' kǎo','攬':' lǎn','收':' shōu','攵':' pū','攴':' pū','攳':' xún','攲':' qī','攱':' guǐ','攰':' guì','支':' zhī','攮':' nǎng','攭':' lì','數':' shù','敺':' qū','无':' wú','斻':' háng','旅':' lǚ','旄':' máo','旃':' zhān','旂':' qí','旁':' páng','旀':' mèi','斿':' yóu','斾':' pèi','施':' shī','於':' yú','斺':' chǎn','旇':' pī','方':' fāng','斸':' zhǔ','斷':' duàn','斶':' chù','斵':' zhuó','斴':' lín','斳':' qín','斲':' zhuó','斱':' zhuó','新':' xīn','旆':' pèi','旈':' liú','斮':' cuò','旕':' yú','旟':' yú','旞':' suì','旝':' kuài','旜':' zhān','旛':' fān','旚':' piāo','旙':' fān','旘':' zhì','旗':' qí','旖':' yǐ','旔':' jiàn','旉':' fū','旓':' shāo','旒':' liú','旑':' yǐ','旐':' zhào','族':' zú','旎':' nǐ','旍':' jīng','旌':' jīng','旋':' xuán','旊':' fǎng','斯':' sī','断':' duàn','敻':' xiòng','文':' wén','斑':' bān','斐':' fěi','斏':' láng','斎':' zhāi','斍':' jué','斌':' bīn','斋':' zhāi','斊':' qí','斉':' qí','斈':' xué','斆':' xiào','斓':' lán','斅':' xiào','斄':' lí','斃':' bì','斂':' liǎn','斁':' yì','斀':' zhuó','敿':' jiǎo','敾':' shan','敽':' jiǎo','敼':' yǐ','斒':' bān','斔':' yǔ','斬':' zhǎn','斡':' wò','斫':' zhuó','斪':' qú','斩':' zhǎn','斨':' qiāng','斧':' fǔ','斦':' yín','斥':' chì','斤':' jīn','斣':' dòu','斢':' tiǎo','斠':' jiào','斕':' lán','斟':' zhēn','斞':' yǔ','斝':' jiǎ','斜':' xié','斛':' hú','斚':' jiǎ','料':' liào','斘':' shēng','斗':' dòu','斖':' wěi','暰':' cōng','暲':' zhāng','桑':' sāng','柄':' bǐng','柎':' fū','柍':' yǎng','柌':' cí','柋':' dài','柊':' zhōng','柉':' fán','柈':' bàn','柇':' hé','柆':' lā','柅':' nǐ','柃':' líng','某':' mǒu','柂':' yí','柁':' duò','柀':' bǐ','枿':' niè','枾':' shì','枽':' yè','枼':' yè','枻':' yì','枺':' mò','枹':' bāo','柏':' bǎi','柑':' gān','枷':' jiā','柞':' zhà','柨':' bù','柧':' gū','柦':' dàn','查':' chá','柤':' zhā','柣':' zhì','柢':' dǐ','柡':' yǒng','柠':' níng','柟':' nán','柝':' tuò','柒':' qī','柜':' guì','柛':' shēn','柚':' yòu','柙':' xiá','柘':' zhè','柗':' sōng','柖':' sháo','柕':' mào','柔':' róu','染':' rǎn','枸':' gǒu','架':' jià','柪':' āo','析':' xī','枚':' méi','枙':' ě','枘':' ruì','林':' lín','枖':' yāo','枕':' zhěn','枔':' xín','枓':' dǒu','枒':' yā','枑':' hù','枏':' nán','果':' guǒ','枎':' fú','枍':' yì','枌':' fén','枋':' fāng','枊':' àng','枉':' wǎng','枈':' bì','枇':' pí','枆':' máo','枅':' jī','枛':' zhào','枝':' zhī','枵':' xiāo','枪':' qiāng','枴':' guǎi','枳':' zhǐ','枲':' xǐ','枱':' tái','枰':' píng','枯':' kū','枮':' xiān','枭':' xiāo','枬':' nán','枫':' fēng','枩':' song','枞':' cōng','枨':' chéng','枧':' jiǎn','枦':' lu','枥':' lì','枤':' duo','枣':' zǎo','枢':' shū','枡':' dǒu','枠':' zui','枟':' yùn','柩':' jiù','柫':' fú','枃':' jìn','栬':' zuì','栶':' yīn','栵':' liè','栴':' zhān','栳':' lǎo','栲':' kǎo','栱':' gǒng','栰':' fá','栯':' yǒu','栮':' ěr','栭':' ér','栫':' jiàn','核':' hé','株':' zhū','栩':' xǔ','栨':' cì','栧':' yì','栦':' chóu','栥':' zī','栤':' bìng','栣':' rěn','栢':' bǎi','校':' xiào','样':' yàng','根':' gēn','栟':' bēn','框':' kuāng','桐':' tóng','桏':' qióng','桎':' zhì','桍':' kū','桌':' zhuō','桋':' yí','桊':' juàn','桉':' ān','案':' àn','桇':' rú','桅':' wéi','栺':' yì','桄':' guāng','桃':' táo','桂':' guì','桁':' héng','桀':' jié','栿':' fú','栾':' luán','栽':' zāi','格':' gé','栻':' shì','栠':' rěn','栞':' kān','柬':' jiǎn','柸':' pēi','栂':' méi','栁':' liǔ','栀':' zhī','柿':' shì','柾':' jiù','柽':' chēng','柼':' yǎo','査':' zhā','柺':' guǎi','柹':' shì','柷':' chù','栄':' róng','柶':' sì','柵':' shān','柴':' chái','柳':' liǔ','柲':' bì','柱':' zhù','柰':' nài','柯':' kē','柮':' duò','柭':' bā','栃':' li','栅':' zhà','栝':' guā','栒':' xún','栜':' sè','栛':' lì','栚':' zhèn','栙':' xiáng','栘':' yí','栗':' lì','栖':' qī','栕':' zhēn','栔':' qì','栓':' shuān','树':' shù','栆':' zao','栐':' yǒng','栏':' lán','栎':' lì','栍':' shēng','栌':' lú','栋':' dòng','栊':' lóng','栉':' zhì','栈':' zhàn','标':' biāo','构':' gòu','枂':' wò','暳':' huì','曳':' yè','曽':' cēng','曼':' màn','曻':' sheng','曺':' cáo','曹':' cáo','書':' shū','曷':' hé','曶':' hū','曵':' yè','更':' gèng','曲':' qū','替':' tì','曱':' yuē','曰':' yuē','曯':' zhú','曮':' yǎn','曭':' tǎng','曬':' shài','曫':' luán','曪':' luǒ','曩':' nǎng','曨':' lóng','曾':' céng','最':' zuì','曦':' xī','服':' fú','朗':' lǎng','朖':' lǎng','朕':' zhèn','朔':' shuò','朓':' tiǎo','朒':' nǜ','朑':' tì','朐':' qú','朏':' fěi','朎':' líng','朌':' fén','朁':' cǎn','朋':' péng','朊':' ruǎn','有':' yǒu','月':' yuè','朇':' pí','朆':' fēn','朅':' qiè','朄':' yǐn','會':' huì','朂':' xù','曧':' róng','曥':' lú','朙':' míng','暿':' xǐ','曉':' xiǎo','曈':' tóng','曇':' tán','曆':' lì','曅':' yè','曄':' yè','曃':' dài','曂':' huàng','曁':' jì','曀':' yì','暾':' tūn','曋':' shěn','暽':' lín','暼':' piē','暻':' jǐng','暺':' dàn','暹':' xiān','暸':' liáo','暷':' chuán','暶':' xuán','暵':' hàn','暴':' bào','曊':' fèi','曌':' zhào','曤':' huò','曙':' shǔ','曣':' yàn','曢':' liǎo','曡':' dié','曠':' kuàng','曟':' chén','曞':' lì','曝':' pù','曜':' yào','曛':' xūn','曚':' méng','曘':' rú','曍':' hào','曗':' yè','曖':' ài','曕':' yàn','曔':' jìng','曓':' bào','曒':' jiǎo','曑':' shēn','曐':' xīng','曏':' xiǎng','曎':' yì','朘':' zuī','朚':' huāng','极':' jí','杜':' dù','杦':' jiu','来':' lái','杤':' wan','杣':' shan','杢':' jiang','条':' tiáo','杠':' gāng','束':' shù','杞':' qǐ','杝':' lí','杛':' gōng','杨':' yáng','杚':' gài','杙':' yì','杘':' chì','杗':' máng','杖':' zhàng','杕':' dì','杔':' tuō','杓':' biāo','杒':' rèn','村':' cūn','杧':' máng','杩':' mà','杏':' xìng','杶':' chūn','枀':' sōng','板':' bǎn','松':' sōng','杽':' chǒu','杼':' zhù','杻':' chǒu','杺':' xīn','杹':' huà','杸':' shū','杷':' pá','杵':' chǔ','杪':' miǎo','杴':' xiān','杳':' yǎo','杲':' gǎo','東':' dōng','杰':' jié','杯':' bēi','杮':' fèi','杭':' háng','杬':' yuán','杫':' sì','材':' cái','李':' lǐ','望':' wàng','朧':' lóng','朱':' zhū','朰':' mù','术':' shù','朮':' shù','札':' zhá','本':' běn','末':' mò','未':' wèi','朩':' děng','木':' mù','朦':' méng','朳':' bā','朥':' lao','朤':' lǎng','朣':' tóng','朢':' wàng','朡':' zōng','朠':' yīng','期':' qī','朞':' jī','朝':' cháo','朜':' tūn','朲':' rén','朴':' pǔ','杍':' zǐ','杂':' zá','杌':' wù','杋':' fán','杊':' xún','杉':' shān','杈':' chā','杇':' wū','杆':' gān','杅':' yú','杄':' qiān','权':' quán','杁':' ru','朵':' duǒ','杀':' shā','朿':' cì','朾':' chéng','朽':' xiǔ','朼':' bǐ','朻':' jiū','机':' jī','朹':' guǐ','朸':' lì','朷':' dāo','朶':' duǒ','庐':' lú','庎':' jiè','冊':' cè','嗛':' qiǎn','嗥':' háo','嗤':' chī','嗣':' sì','嗢':' wà','嗡':' wēng','嗠':' luò','嗟':' jiē','嗞':' zī','嗝':' gé','嗜':' shì','嗚':' wū','嗨':' hāi','嗙':' pǎng','嗘':' jī','嗗':' wā','嗖':' sōu','嗕':' rù','嗔':' chēn','嗓':' sǎng','嗒':' dā','嗑':' kē','嗐':' hài','嗦':' suo','嗩':' suǒ','嗎':' ma','嗶':' bì','嘀':' dí','嗿':' tǎn','嗾':' sǒu','嗽':' sòu','嗼':' mò','嗻':' zhē','嗺':' zuī','嗹':' lián','嗸':' áo','嗷':' áo','嗵':' tōng','嗪':' qín','嗴':' qiang','嗳':' āi','嗲':' diǎ','嗱':' ná','嗰':' gè','嗯':' ń','嗮':' sài','嗭':' zhí','嗬':' hē','嗫':' niè','嗏':' chā','嗍':' suō','嘂':' jiào','喧':' xuān','喱':' lí','喰':' cān','喯':' pèn','單':' dān','喭':' yàn','喬':' qiáo','喫':' chī','喪':' sàng','喩':' yù','喨':' liàng','喦':' niè','喳':' zhā','喥':' duó','喤':' huáng','喣':' xù','喢':' shà','喡':' wéi','喠':' zhǒng','喟':' kuì','喞':' jī','喝':' hē','喜':' xǐ','喲':' yō','喴':' wēi','嗌':' ài','嗁':' tí','嗋':' xié','嗊':' hǒng','嗉':' sù','嗈':' yōng','嗇':' sè','嗆':' qiāng','嗅':' xiù','嗄':' á','嗃':' hè','嗂':' yáo','嗀':' hù','喵':' miāo','喿':' zào','喾':' kù','喽':' lóu','喼':' jié','喻':' yù','喺':' xì','喹':' kuí','喸':' bǔ','喷':' pēn','営':' yíng','嘁':' qī','嘃':' chōng','喚':' huàn','噄':' chī','噎':' yē','噍':' jiào','噌':' cēng','噋':' tūn','噊':' yù','噉':' dàn','噈':' cù','噇':' chuáng','噆':' zǎn','噅':' huī','噃':' fān','噐':' qì','噂':' zǔn','噁':' ě','噀':' xùn','嘿':' hēi','嘾':' dàn','嘽':' chǎn','嘼':' chù','嘻':' xī','嘺':' qiáo','嘹':' liáo','噏':' xī','噑':' háo','嘷':' háo','噞':' yǎn','器':' qì','噧':' xiè','噦':' huì','噥':' nóng','噤':' jìn','噣':' zhòu','噢':' ō','噡':' zhān','噠':' dā','噟':' yìng','噝':' sī','噒':' lián','噜':' lū','噛':' niè','噚':' xún','噙':' qín','噘':' juē','噗':' pū','噖':' yín','噕':' huī','噔':' dēng','噓':' xū','嘸':' fǔ','嘶':' sī','嘄':' jiāo','嘐':' xiāo','嘚':' dē','嘙':' pó','嘘':' xū','嘗':' cháng','嘖':' zé','嘕':' xiān','嘔':' ǒu','嘓':' guō','嘒':' huì','嘑':' hū','嘏':' gǔ','嘜':' mà','嘎':' gā','嘍':' lóu','嘌':' piào','嘋':' xiāo','嘊':' ái','嘉':' jiā','嘈':' cáo','嘇':' shān','嘆':' tàn','嘅':' kǎi','嘛':' ma','嘝':' hú','嘵':' xiāo','嘪':' mǎi','嘴':' zuǐ','嘳':' kuì','嘲':' cháo','嘱':' zhǔ','嘰':' jī','嘯':' xiào','嘮':' láo','嘭':' pēng','嘬':' chuài','嘫':' rán','嘩':' huā','嘞':' lei','嘨':' xiào','嘧':' mì','嘦':' jiào','嘥':' sai','嘤':' yīng','嘣':' bēng','嘢':' yě','嘡':' tāng','嘠':' gā','嘟':' dū','喛':' huàn','喙':' huì','噪':' zào','唋':' tū','唕':' zào','唔':' wú','唓':' chē','唒':' qiú','唑':' zuò','唐':' táng','唏':' xī','唎':' lì','唍':' wǎn','唌':' xián','唊':' jiá','唗':' dōu','唉':' āi','唈':' yì','唇':' chún','唆':' suō','唅':' hán','唄':' bei','唃':' gǔ','唂':' gū','唁':' yàn','唀':' yòu','唖':' yǎ','唘':' qǐ','哾':' shuō','唥':' lang','唯':' wéi','售':' shòu','唭':' qì','唬':' hǔ','唫':' jìn','唪':' fěng','唩':' wō','唨':' zuǒ','唧':' jī','唦':' shā','唤':' huàn','唙':' dí','唣':' zào','唢':' suǒ','唡':' liǎng','唠':' láo','唟':' qù','唞':' dǒu','唝':' gòng','唜':' mò','唛':' mà','唚':' qìn','哿':' gě','哽':' gěng','唱':' chàng','哗':' huā','員':' yuán','哠':' hào','哟':' yō','哞':' mōu','哝':' nóng','哜':' jì','哛':' fēn','哚':' duǒ','哙':' kuài','哘':' xing','哖':' nián','哣':' pǒu','哕':' huì','哔':' bì','哓':' xiāo','哒':' dā','哑':' yǎ','哐':' kuāng','哏':' gén','哎':' āi','响':' xiǎng','哌':' pài','哢':' lòng','哤':' máng','哼':' hēng','哱':' bō','哻':' hàn','哺':' bǔ','哹':' fú','哸':' suī','哷':' liè','哶':' miē','哵':' bā','哴':' liàng','哳':' zhā','哲':' zhé','哰':' láo','哥':' gē','哯':' xiàn','哮':' xiāo','哭':' kū','哬':' hé','哫':' zú','哪':' nǎ','哩':' lī','哨':' shào','哧':' chī','哦':' ó','唰':' shuā','唲':' ér','喘':' chuǎn','啳':' quán','啽':' án','啼':' tí','啻':' chì','啺':' táng','啹':' jú','啸':' xiào','啷':' lāng','啶':' dìng','啵':' bo','啴':' chǎn','啲':' dì','啿':' dàn','啱':' yān','啰':' luō','啯':' guō','啮':' niè','啭':' zhuàn','啬':' sè','啫':' zhě','啪':' pā','啩':' guà','啨':' yīng','啾':' jiū','喀':' kā','啦':' la','喍':' chái','喗':' yǔn','喖':' hú','喕':' miǎn','喔':' ō','喓':' yāo','喒':' zá','喑':' yīn','喐':' yù','喏':' nuò','喎':' wāi','喌':' zhōu','喁':' yóng','喋':' dié','喊':' hǎn','喉':' hóu','喈':' jiē','喇':' lǎ','喆':' zhé','喅':' yù','善':' shàn','喃':' nán','喂':' wèi','啧':' zé','啥':' shà','唳':' lì','唿':' hū','啉':' lín','啈':' hēng','啇':' dì','商':' shāng','啅':' zhuó','啄':' zhuó','啃':' kěn','啂':' nǒu','啁':' zhāo','啀':' ái','唾':' tuò','啋':' cǎi','唽':' xī','唼':' shà','唻':' lài','唺':' tiǎn','唹':' yū','唸':' niàn','唷':' yō','唶':' zé','唵':' ǎn','唴':' qiàng','啊':' a','啌':' xiāng','啤':' pí','啙':' zǐ','啣':' xián','啢':' liǎng','啡':' fēi','啠':' zhé','啟':' qǐ','啞':' yǎ','啝':' hé','啜':' chuài','啛':' cuì','啚':' bǐ','啘':' yè','啍':' tūn','啗':' dàn','啖':' dàn','啕':' táo','啔':' qǐ','啓':' qǐ','啒':' gǔ','啑':' shà','啐':' cuì','問':' wèn','啎':' wǔ','噩':' è','噫':' yī','哊':' yòu','坽':' líng','垇':' ào','垆':' lú','垅':' lǒng','垄':' lǒng','垃':' lā','垂':' chuí','垁':' zhì','垀':' hū','坿':' fù','坾':' zhù','坼':' chè','垉':' páo','坻':' chí','坺':' bá','坹':' xuè','坸':' gòu','坷':' kě','坶':' mǔ','坵':' qiū','坴':' lù','坳':' ào','坲':' fó','垈':' dài','垊':' min','坰':' jiōng','垗':' zhào','垡':' fá','垠':' yín','垟':' yáng','垞':' chá','垝':' guǐ','垜':' duǒ','垛':' duǒ','垚':' yáo','垙':' guāng','垘':' fú','垖':' duī','型':' xíng','垕':' hòu','垔':' yīn','垓':' gāi','垒':' lěi','垑':' chǐ','垐':' cí','垏':' lǜ','垎':' hè','垍':' jì','垌':' dòng','坱':' yǎng','坯':' pī','垣':' yuán','坉':' tún','坓':' jǐng','坒':' bì','坑':' kēng','坐':' zuò','坏':' huài','坎':' kǎn','坍':' tān','坌':' bèn','坋':' bèn','坊':' fāng','坈':' rǒng','坕':' jīng','均':' jūn','坆':' méi','坅':' qǐn','坄':' yì','坃':' xūn','坂':' bǎn','坁':' zhǐ','址':' zhǐ','圿':' jiá','圾':' jī','坔':' dì','坖':' jì','坮':' tái','坣':' tāng','坭':' ní','坬':' guà','坫':' diàn','坪':' píng','坩':' gān','坨':' tuó','坧':' zhī','坦':' tǎn','坥':' qū','坤':' kūn','坢':' bàn','块':' kuài','坡':' pō','坠':' zhuì','坟':' fén','坞':' wù','坝':' bà','坜':' lì','坛':' tán','坚':' jiān','坙':' jīng','坘':' dǐ','垢':' gòu','垤':' dié','圼':' niè','埥':' qīng','埯':' ǎn','埮':' tàn','埭':' dài','埬':' dōng','埫':' chǒng','埪':' kōng','埩':' zhēng','埨':' lǔn','埧':' jù','埦':' wǎn','埤':' pí','埱':' chù','埣':' suì','埢':' quán','埡':' yā','埠':' bù','域':' yù','埞':' dǐ','埝':' niàn','埜':' yě','埛':' jiōng','埚':' guō','埰':' cài','埲':' běng','埘':' shí','埿':' ní','堉':' yù','堈':' gāng','堇':' jǐn','堆':' duī','堅':' jiān','堄':' nì','堃':' kūn','堂':' táng','堁':' kè','堀':' kū','埾':' jù','埳':' kǎn','埽':' sào','埼':' qí','埻':' zhǔn','基':' jī','培':' péi','埸':' yì','執':' zhí','埶':' yì','埵':' duǒ','埴':' zhí','埙':' xūn','埗':' bù','垥':' xié','垱':' dàng','垻':' bà','垺':' fū','垹':' bāng','垸':' yuàn','垷':' xiàn','垶':' xīng','垵':' ǎn','垴':' nǎo','垳':' hang','垲':' kǎi','垰':' ka','垽':' yìn','垯':' da','垮':' kuǎ','垭':' yā','垬':' hóng','垫':' diàn','垪':' bing','垩':' è','垨':' shǒu','垧':' shǎng','垦':' kěn','垼':' yì','垾':' hàn','埖':' hua','埋':' mái','埕':' chéng','埔':' bù','埓':' liè','埒':' liè','埑':' zhé','埐':' jīn','埏':' shān','城':' chéng','埍':' juǎn','埌':' làng','埊':' dì','垿':' xù','埉':' jiā','埈':' jùn','埇':' yǒng','埆':' què','埅':' fáng','埄':' běng','埃':' āi','埂':' gěng','埁':' qín','埀':' chuí','圽':' mò','圻':' qí','噬':' shì','嚬':' pín','嚶':' yīng','嚵':' chán','嚴':' yán','嚳':' kù','嚲':' duǒ','嚱':' xì','嚰':' mó','嚯':' huò','嚮':' xiàng','嚭':' pǐ','嚫':' chèn','嚸':' diǎn','嚪':' dàn','嚩':' mó','嚨':' lóng','嚧':' lú','嚦':' lì','嚥':' yàn','嚤':' mó','嚣':' xiāo','嚢':' náng','嚡':' hai','嚷':' rǎng','嚹':' lá','嚟':' lí','囆':' chài','囐':' zá','囏':' jiān','囎':' zen','囍':' xǐ','囌':' sū','囋':' zá','囊':' náng','囉':' luō','囈':' yì','囇':' lì','囅':' chǎn','嚺':' tà','囄':' lí','囃':' cà','囂':' xiāo','囁':' niè','囀':' zhuàn','嚿':' huò','嚾':' huān','嚽':' chuò','嚼':' jué','嚻':' xiāo','嚠':' liú','嚞':' zhé','囒':' lán','噸':' dūn','嚂':' làn','嚁':' dí','嚀':' níng','噿':' zuǐ','噾':' yīn','噽':' pǐ','噼':' pī','噻':' sāi','噺':' xin','噹':' dāng','噷':' hm','嚄':' huō','噶':' gá','噵':' dào','噴':' pēn','噳':' yǔ','噲':' kuài','噱':' jué','噰':' yōng','噯':' āi','噮':' yuàn','噭':' jiào','嚃':' tā','嚅':' rú','嚝':' hōng','嚒':' me','嚜':' me','嚛':' hù','嚚':' yín','嚙':' niè','嚘':' yōu','嚗':' bó','嚖':' huì','嚕':' lǔ','嚔':' tì','嚓':' cā','嚑':' xun','嚆':' hāo','嚐':' cháng','嚏':' tì','嚎':' háo','嚍':' jìn','嚌':' jì','嚋':' chóu','嚊':' pì','嚉':' duō','嚈':' yè','嚇':' xià','囑':' zhǔ','囓':' niè','场':' chǎng','圕':' tú','土':' tǔ','圞':' luán','圝':' luán','圜':' huán','圛':' yì','圚':' huì','圙':' lüè','團':' tuán','圗':' tú','圖':' tú','圔':' yà','圡':' tǔ','圓':' yuán','園':' yuán','圑':' fù','圐':' kū','圏':' quān','圎':' yuán','圍':' wéi','圌':' chuán','國':' guó','圊':' qīng','圠':' yà','圢':' tǐng','圈':' quān','圯':' yí','圹':' kuàng','圸':' shan','圷':' xia','圶':' qià','圵':' dàng','圴':' zhuó','圳':' zhèn','圲':' qiān','圱':' qiān','地':' dì','圮':' pǐ','圣':' shèng','圭':' guī','圬':' wū','圫':' yù','圪':' gē','圩':' wéi','在':' zài','圧':' yā','圦':' kuai','圥':' lù','圤':' pǔ','圉':' yǔ','圇':' lún','囔':' nāng','因':' yīn','囪':' cōng','囩':' yún','囨':' piān','囧':' jiǒng','囦':' yuān','囥':' kàng','囤':' dùn','団':' tuán','团':' tuán','囡':' nān','囟':' xìn','囬':' huí','回':' huí','囝':' jiǎn','囜':' nín','四':' sì','囚':' qiú','囙':' yīn','囘':' huí','囗':' wéi','囖':' lo','囕':' lǎn','囫':' hú','园':' yuán','圆':' yuán','囻':' guó','圅':' hán','圄':' yǔ','圃':' pǔ','圂':' hùn','圁':' yín','圀':' guó','囿':' yòu','图':' tú','国':' guó','囼':' tāi','固':' gù','囮':' é','囹':' líng','囸':' rì','囷':' qūn','囶':' guó','囵':' lún','围':' wéi','図':' tú','囲':' tōng','囱':' cōng','困':' kùn','囯':' guó','哋':' diè','哉':' zāi','堋':' péng','劚':' zhǔ','劤':' jìn','劣':' liè','劢':' mài','务':' wù','加':' jiā','功':' gōng','办':' bàn','劝':' quàn','劜':' yà','力':' lì','劙':' lí','劦':' xié','劘':' mó','劗':' jiǎn','劖':' chán','劕':' zhì','劔':' jiàn','劓':' yì','劒':' jiàn','劑':' jì','劐':' huō','劏':' tāng','劥':' kēng','劧':' zhǐ','劍':' jiàn','労':' láo','劾':' hé','劽':' liè','劼':' jié','劻':' kuāng','劺':' móu','効':' xiào','劸':' wā','劷':' yáng','劶':' kǒu','劵':' juàn','劳':' láo','动':' dòng','劲':' jìn','励':' lì','劰':' mò','劯':' zhū','劮':' yì','劭':' shào','劬':' qú','劫':' jié','努':' nǔ','助':' zhù','劎':' jiàn','劌':' guì','勀':' kè','剦':' yān','剰':' shèng','副':' fù','剮':' guǎ','剭':' wū','剬':' duān','剫':' duó','剪':' jiǎn','剩':' shèng','剨':' huō','剧':' jù','剥':' bō','割':' gē','剤':' jì','剣':' jiàn','剢':' dū','剡':' shàn','剠':' qíng','剟':' duō','剞':' jī','剝':' bō','剜':' wān','剛':' gāng','剱':' jiàn','剳':' dá','劋':' jiǎo','劀':' guā','劊':' guì','劉':' liú','劈':' pī','劇':' jù','劆':' lián','劅':' zhuò','劄':' zhā','劃':' huà','劂':' jué','劁':' qiāo','剿':' jiǎo','剴':' kǎi','剾':' kōu','剽':' piāo','剼':' shān','剻':' pěng','剺':' lí','剹':' lù','剸':' tuán','剷':' chǎn','剶':' chuān','創':' chuàng','势':' shì','勁':' jìn','剙':' chuàng','匂':' bi','匌':' gé','匋':' táo','匊':' jū','匉':' pēng','匈':' xiōng','匇':' yi','匆':' cōng','包':' bāo','匄':' gài','匃':' gài','匁':' wén','匎':' è','匀':' yún','勿':' wù','勾':' gōu','勽':' bào','勼':' jiū','勻':' yún','勺':' sháo','勹':' bāo','勸':' quàn','勷':' ráng','匍':' pú','匏':' páo','勵':' lì','匜':' yí','匦':' guǐ','匥':' biàn','匤':' qū','匣':' xiá','匢':' hū','匡':' kuāng','匠':' jiàng','匟':' kàng','匞':' jiàng','匝':' zā','匛':' jiù','匐':' fú','匚':' fāng','匙':' shi','匘':' nǎo','北':' běi','化':' huà','匕':' bǐ','匔':' qiōng','匓':' jiù','匒':' dá','匑':' gōng','勶':' chè','勴':' lǜ','勂':' gào','勎':' lù','勘':' kān','勗':' xù','勖':' xù','動':' dòng','勔':' miǎn','勓':' kài','勒':' lè','勑':' chì','勐':' měng','勏':' bù','勍':' qíng','勚':' yì','勌':' juàn','勋':' xūn','勊':' kè','勉':' miǎn','勈':' yǒng','勇':' yǒng','勆':' láng','勅':' chì','勄':' mǐn','勃':' bó','務':' wù','勛':' xūn','勳':' xūn','勨':' xiàng','勲':' xūn','勱':' mài','勰':' xié','勯':' dān','勮':' jù','勭':' tóng','勬':' juān','勫':' fān','勪':' jué','勩':' yì','勧':' quàn','勜':' wěng','勦':' chāo','勥':' jiàng','勤':' qín','勣':' jī','勢':' shì','勡':' piào','勠':' lù','募':' mù','勞':' láo','勝':' shèng','剚':' zì','剘':' qí','匨':' zāng','凊':' qìng','凔':' chuàng','凓':' lì','凒':' yí','凑':' còu','凐':' yīn','减':' jiǎn','凎':' gàn','凍':' dòng','凌':' líng','凋':' diāo','凉':' liáng','凖':' zhun','凈':' jìng','凇':' sōng','准':' zhǔn','凅':' gù','凄':' qī','凃':' tú','凂':' měi','凁':' shù','净':' jìng','冿':' jiān','凕':' mǐng','凗':' cuī','冽':' liè','凤':' fèng','凮':' fēng','凭':' píng','凬':' fēng','凫':' fú','凪':' zhi','凩':' mu','凨':' fēng','凧':' zheng','処':' chǔ','凥':' jū','凣':' fán','凘':' sī','凢':' fán','凡':' fán','几':' jǐ','凟':' dú','凞':' xī','凝':' níng','凜':' lǐn','凛':' lǐn','凚':' jìn','凙':' duó','冾':' qià','冼':' xiǎn','凰':' huáng','冖':' mì','冠':' guān','冟':' shì','冞':' mí','冝':' yí','农':' nóng','军':' jūn','冚':' kǎn','写':' xiě','冘':' yín','冗':' rǒng','冕':' miǎn','冢':' zhǒng','冔':' xǔ','冓':' gòu','冒':' mào','冑':' zhòu','冐':' mào','冏':' jiǒng','冎':' guǎ','再':' zài','册':' cè','冋':' jiōng','冡':' méng','冣':' jù','冻':' dòng','冰':' bīng','冺':' mǐn','冹':' fú','冸':' pàn','冷':' lěng','冶':' yě','况':' kuàng','冴':' hù','决':' jué','冲':' chōng','冱':' hù','冯':' féng','冤':' yuān','冮':' gāng','冭':' tái','冬':' dōng','冫':' bīng','冪':' mì','冩':' xiě','冨':' fù','冧':' lín','冦':' kòu','冥':' míng','凯':' kǎi','凱':' kǎi','剗':' chǎn','刲':' kuī','刼':' jié','刻':' kè','刺':' cì','刹':' shā','券':' quàn','刷':' shuā','制':' zhì','刵':' èr','刴':' duò','刳':' kū','刱':' chuàng','刾':' cì','到':' dào','刯':' gēng','刮':' guā','刭':' jǐng','刬':' chǎn','别':' bié','刪':' shān','利':' lì','刨':' páo','刧':' jié','刽':' guì','刿':' guì','別':' bié','剌':' lá','剖':' pōu','剕':' fèi','剔':' tī','剓':' lí','剒':' cuò','剑':' jiàn','剐':' guǎ','剏':' chuàng','剎':' shā','前':' qián','剋':' kè','剀':' kǎi','削':' xuē','剉':' cuò','剈':' yuān','則':' zé','剆':' luǒ','剅':' lóu','剄':' jǐng','剃':' tì','剂':' jì','剁':' duò','刦':' jié','判':' pàn','凲':' gān','凾':' hán','刈':' yì','切':' qiè','分':' fēn','刅':' chuāng','刄':' rèn','刃':' rèn','刂':' dāo','刁':' diāo','刀':' dāo','凿':' záo','函':' hán','刊':' kān','凼':' dàng','击':' jī','出':' chū','凹':' āo','凸':' tū','凷':' kuài','凶':' xiōng','凵':' qiǎn','凴':' píng','凳':' dèng','刉':' jī','刋':' qiàn','刣':' zhōng','刘':' liú','刢':' líng','刡':' mǐn','删':' shān','刟':' jū','刞':' qù','初':' chū','刜':' fú','创':' chuàng','刚':' gāng'};exports.default=DICTIONARY;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DICTIONARY = {
  '则': ' zé',
  '列': ' liè',
  '刌': ' cǔn',
  '刖': ' yuè',
  '刕': ' lí',
  '刔': ' jué',
  '刓': ' wán',
  '划': ' huà',
  '刑': ' xíng',
  '刐': ' dǎn',
  '刏': ' jī',
  '刎': ' wěn',
  '刍': ' chú',
  '匧': ' qiè',
  '匩': ' kuāng',
  '哈': ' hā',
  '吻': ' wěn',
  '呅': ' méi',
  '呄': ' gé',
  '呃': ' è',
  '呂': ' lǚ',
  '呁': ' jùn',
  '呀': ' ya',
  '吿': ' gào',
  '吾': ' wú',
  '吽': ' hōng',
  '吼': ' hǒu',
  '吺': ' dōu',
  '呇': ' qǐ',
  '吹': ' chuī',
  '吸': ' xī',
  '吷': ' xuè',
  '吶': ' nà',
  '吵': ' chǎo',
  '吴': ' wú',
  '吳': ' wú',
  '吲': ' yǐn',
  '吱': ' zhī',
  '吰': ' hóng',
  '呆': ' dāi',
  '呈': ' chéng',
  '吮': ' shǔn',
  '呕': ' ǒu',
  '呟': ' juǎn',
  '呞': ' shī',
  '呝': ' è',
  '呜': ' wū',
  '呛': ' qiāng',
  '呚': ' wen',
  '呙': ' guō',
  '员': ' yuán',
  '呗': ' bei',
  '呖': ' lì',
  '呔': ' dāi',
  '呉': ' wú',
  '呓': ' yì',
  '呒': ' fǔ',
  '呑': ' tūn',
  '呐': ' nà',
  '呏': ' shēng',
  '呎': ' chǐ',
  '呍': ' hōng',
  '呌': ' jiào',
  '呋': ' fū',
  '告': ' gào',
  '启': ' qǐ',
  '吭': ' kēng',
  '呡': ' wěn',
  '吇': ' zǐ',
  '向': ' xiàng',
  '吐': ' tǔ',
  '吏': ' lì',
  '后': ' hòu',
  '名': ' míng',
  '同': ' tóng',
  '吋': ' cùn',
  '吊': ' diào',
  '吉': ' jí',
  '合': ' hé',
  '吆': ' yāo',
  '吓': ' xià',
  '吅': ' xuān',
  '各': ' gè',
  '吃': ' chī',
  '吂': ' máng',
  '吁': ' xū',
  '吀': ' miē',
  '叿': ' hōng',
  '叾': ' liǎo',
  '叽': ' jī',
  '叼': ' diāo',
  '吒': ' zhā',
  '吔': ' yě',
  '听': ' tīng',
  '吡': ' bǐ',
  '含': ' hán',
  '吪': ' é',
  '吩': ' fēn',
  '吨': ' dūn',
  '吧': ' ba',
  '否': ' fǒu',
  '吥': ' bù',
  '吤': ' jiè',
  '吣': ' qìn',
  '吢': ' qìn',
  '吠': ' fèi',
  '吕': ' lǚ',
  '吟': ' yín',
  '吞': ' tūn',
  '吝': ' lìn',
  '吜': ' chǒu',
  '君': ' jūn',
  '吚': ' yī',
  '吙': ' huō',
  '吘': ' ǒu',
  '吗': ' ma',
  '吖': ' yā',
  '呠': ' pěn',
  '呢': ' ne',
  '叺': ' chǐ',
  '咣': ' guāng',
  '咭': ' jī',
  '咬': ' yǎo',
  '咫': ' zhǐ',
  '咪': ' mī',
  '咩': ' miē',
  '咨': ' zī',
  '咧': ' liě',
  '咦': ' yí',
  '咥': ' xì',
  '咤': ' zhà',
  '咢': ' è',
  '咯': ' gē',
  '咡': ' èr',
  '咠': ' qì',
  '咟': ' huò',
  '咞': ' xiàn',
  '咝': ' sī',
  '咜': ' ta',
  '咛': ' níng',
  '咚': ' dōng',
  '咙': ' lóng',
  '咘': ' bù',
  '咮': ' zhòu',
  '咰': ' shù',
  '咖': ' kā',
  '咽': ' yàn',
  '哇': ' wa',
  '哆': ' duō',
  '哅': ' xiōng',
  '哄': ' hōng',
  '哃': ' tóng',
  '哂': ' shěn',
  '品': ' pǐn',
  '哀': ' āi',
  '咿': ' yī',
  '咾': ' lǎo',
  '咼': ' guō',
  '咱': ' zán',
  '咻': ' xiū',
  '咺': ' xuǎn',
  '咹': ' è',
  '咸': ' xián',
  '咷': ' táo',
  '咶': ' huài',
  '咵': ' kuǎ',
  '咴': ' huī',
  '咳': ' hāi',
  '咲': ' xiào',
  '咗': ' zuo',
  '咕': ' gū',
  '呣': ' ḿ',
  '呯': ' píng',
  '呹': ' yì',
  '呸': ' pēi',
  '呷': ' gā',
  '呶': ' náo',
  '呵': ' ā',
  '呴': ' xǔ',
  '味': ' wèi',
  '呲': ' cī',
  '呱': ' gū',
  '呰': ' zǐ',
  '呮': ' qì',
  '呻': ' shēn',
  '呭': ' yì',
  '呬': ' xì',
  '呫': ' tiè',
  '呪': ' zhòu',
  '呩': ' shì',
  '周': ' zhōu',
  '呧': ' dǐ',
  '呦': ' yōu',
  '呥': ' rán',
  '呤': ' lìng',
  '呺': ' xiāo',
  '呼': ' hū',
  '咔': ' kā',
  '咉': ' yāng',
  '咓': ' wǎ',
  '咒': ' zhòu',
  '咑': ' dā',
  '咐': ' fù',
  '咏': ' yǒng',
  '咎': ' jiù',
  '咍': ' hāi',
  '和': ' hé',
  '咋': ' zǎ',
  '咊': ' hé',
  '咈': ' fú',
  '命': ' mìng',
  '咇': ' bié',
  '咆': ' páo',
  '咅': ' pǒu',
  '咄': ' duō',
  '咃': ' tuō',
  '咂': ' zā',
  '咁': ' hán',
  '咀': ' jǔ',
  '呿': ' qù',
  '呾': ' dá',
  '叻': ' lè',
  '叹': ' tàn',
  '匪': ' fěi',
  '卪': ' jié',
  '却': ' què',
  '即': ' jí',
  '卲': ' shào',
  '危': ' wēi',
  '印': ' yìn',
  '卯': ' mǎo',
  '卮': ' zhī',
  '卭': ' qióng',
  '卬': ' áng',
  '卫': ' wèi',
  '卩': ' jié',
  '卶': ' chǐ',
  '卨': ' xiè',
  '卧': ' wò',
  '卦': ' guà',
  '卥': ' xī',
  '卤': ' lǔ',
  '卣': ' yǒu',
  '卢': ' lú',
  '卡': ' kǎ',
  '占': ' zhàn',
  '卟': ' bǔ',
  '卵': ' luǎn',
  '卷': ' juǎn',
  '卝': ' kuàng',
  '厄': ' è',
  '厎': ' dǐ',
  '厍': ' shè',
  '厌': ' yàn',
  '压': ' yā',
  '厊': ' yǎ',
  '厉': ' lì',
  '厈': ' hǎn',
  '厇': ' zhé',
  '历': ' lì',
  '厅': ' tīng',
  '厃': ' wěi',
  '卸': ' xiè',
  '厂': ' chǎng',
  '厁': ' san',
  '厀': ' xī',
  '卿': ' qīng',
  '卾': ' è',
  '卽': ' jí',
  '卼': ' wù',
  '卻': ' què',
  '卺': ' jǐn',
  '卹': ' xù',
  '卞': ' biàn',
  '卜': ' bo',
  '厐': ' páng',
  '匶': ' jiù',
  '區': ' qū',
  '匿': ' nì',
  '匾': ' biǎn',
  '匽': ' yǎn',
  '匼': ' kē',
  '医': ' yī',
  '区': ' qū',
  '匹': ' pǐ',
  '匸': ' xì',
  '匷': ' jué',
  '匵': ' dú',
  '卂': ' xùn',
  '匴': ' suǎn',
  '匳': ' lián',
  '匲': ' lián',
  '匱': ' guì',
  '匰': ' dān',
  '匯': ' huì',
  '匮': ' kuì',
  '匭': ' guǐ',
  '匬': ' yǔ',
  '匫': ' hū',
  '十': ' shí',
  '千': ' qiān',
  '卛': ' shuài',
  '卐': ' wàn',
  '博': ' bó',
  '卙': ' jí',
  '単': ' dān',
  '南': ' nán',
  '卖': ' mài',
  '单': ' dān',
  '協': ' xié',
  '卓': ' zhuō',
  '卒': ' zú',
  '卑': ' bēi',
  '协': ' xié',
  '卄': ' niàn',
  '华': ' huá',
  '卍': ' wàn',
  '卌': ' xì',
  '卋': ' shì',
  '半': ' bàn',
  '卉': ' huì',
  '午': ' wǔ',
  '升': ' shēng',
  '卆': ' zú',
  '卅': ' sà',
  '厏': ' zhǎ',
  '厑': ' yá',
  '司': ' sī',
  '叓': ' shì',
  '叝': ' gào',
  '叜': ' sǒu',
  '叛': ' pàn',
  '叚': ' jiǎ',
  '叙': ' xù',
  '变': ' biàn',
  '受': ' shòu',
  '取': ' qǔ',
  '叕': ' zhuó',
  '叔': ' shū',
  '叒': ' ruò',
  '叟': ' sǒu',
  '发': ' fā',
  '叐': ' bá',
  '叏': ' guài',
  '収': ' shōu',
  '反': ' fǎn',
  '双': ' shuāng',
  '友': ' yǒu',
  '及': ' jí',
  '叉': ' chā',
  '又': ' yòu',
  '叞': ' wèi',
  '叠': ' dié',
  '叆': ' ài',
  '叭': ' bā',
  '号': ' hào',
  '叶': ' yè',
  '叵': ' pǒ',
  '叴': ' qiú',
  '右': ' yòu',
  '史': ' shǐ',
  '叱': ' chì',
  '台': ' tái',
  '可': ' kě',
  '叮': ' dīng',
  '召': ' zhào',
  '叡': ' ruì',
  '叫': ' jiào',
  '只': ' zhǐ',
  '叩': ' kòu',
  '叨': ' dāo',
  '叧': ' guǎ',
  '另': ' lìng',
  '句': ' jù',
  '古': ' gǔ',
  '口': ' kǒu',
  '叢': ' cóng',
  '叇': ' dài',
  '叅': ' cān',
  '厒': ' hé',
  '厞': ' fèi',
  '厨': ' chú',
  '厧': ' diān',
  '厦': ' shà',
  '厥': ' jué',
  '厤': ' lì',
  '厣': ' yǎn',
  '厢': ' xiāng',
  '厡': ' yuán',
  '厠': ' cè',
  '原': ' yuán',
  '厝': ' cuò',
  '厪': ' jǐn',
  '厜': ' zuī',
  '厛': ' tīng',
  '厚': ' hòu',
  '厙': ' shè',
  '厘': ' lí',
  '厗': ' tí',
  '厖': ' páng',
  '厕': ' cè',
  '厔': ' zhì',
  '厓': ' yá',
  '厩': ' jiù',
  '厫': ' áo',
  '叄': ' cān',
  '厹': ' róu',
  '參': ' cān',
  '参': ' cān',
  '叁': ' sān',
  '叀': ' zhuān',
  '县': ' xiàn',
  '厾': ' dū',
  '厽': ' lěi',
  '厼': ' ěr',
  '去': ' qù',
  '厺': ' qù',
  '厸': ' lín',
  '厬': ' guǐ',
  '厷': ' gōng',
  '厶': ' sī',
  '厵': ' yuán',
  '厴': ' yǎn',
  '厳': ' yán',
  '厲': ' lì',
  '厱': ' lán',
  '厰': ' chǎng',
  '厯': ' lì',
  '厮': ' sī',
  '厭': ' yàn',
  '堊': ' è',
  '堌': ' gù',
  '庍': ' bài',
  '屟': ' xiè',
  '屩': ' juē',
  '屨': ' jù',
  '屧': ' xiè',
  '屦': ' jù',
  '履': ' lǚ',
  '層': ' céng',
  '屣': ' xǐ',
  '屢': ' lǚ',
  '屡': ' lǚ',
  '屠': ' tú',
  '属': ' shǔ',
  '屫': ' jué',
  '屝': ' fèi',
  '屜': ' tì',
  '屛': ' píng',
  '屚': ' lòu',
  '屙': ' ē',
  '屘': ' mǎn',
  '屗': ' wěi',
  '屖': ' xī',
  '展': ' zhǎn',
  '屔': ' ní',
  '屪': ' liáo',
  '屬': ' shǔ',
  '屒': ' zhěn',
  '屹': ' yì',
  '岃': ' rèn',
  '岂': ' qǐ',
  '岁': ' suì',
  '岀': ' chū',
  '屿': ' yǔ',
  '屾': ' shēn',
  '屽': ' hàn',
  '屼': ' wù',
  '屻': ' rèn',
  '屺': ' qǐ',
  '屸': ' lóng',
  '屭': ' xì',
  '屷': ' hui',
  '屶': ' dao',
  '屵': ' è',
  '屴': ' lì',
  '屳': ' xiān',
  '屲': ' wa',
  '山': ' shān',
  '屰': ' nì',
  '屯': ' tún',
  '屮': ' chè',
  '屓': ' xiè',
  '屑': ' xiè',
  '岅': ' bǎn',
  '尫': ' wāng',
  '尵': ' tuí',
  '尴': ' gān',
  '尳': ' gǔ',
  '尲': ' gān',
  '就': ' jiù',
  '尰': ' zhǒng',
  '尯': ' kuì',
  '尮': ' duò',
  '尭': ' yáo',
  '尬': ' gà',
  '尪': ' wāng',
  '尷': ' gān',
  '尩': ' wāng',
  '尨': ' máng',
  '尧': ' yáo',
  '尦': ' liào',
  '尥': ' liào',
  '尤': ' yóu',
  '尣': ' wāng',
  '尢': ' yóu',
  '尡': ' kun',
  '尠': ' xiǎn',
  '尶': ' gān',
  '尸': ' shī',
  '屐': ' jī',
  '居': ' jū',
  '屏': ' píng',
  '屎': ' shǐ',
  '屍': ' shī',
  '屌': ' diǎo',
  '屋': ' wū',
  '届': ' jiè',
  '屉': ' tì',
  '屈': ' qū',
  '屇': ' tián',
  '屆': ' jiè',
  '屄': ' bī',
  '尹': ' yǐn',
  '屃': ' xì',
  '层': ' céng',
  '屁': ' pì',
  '局': ' jú',
  '尿': ' niào',
  '尾': ' wěi',
  '尽': ' jǐn',
  '尼': ' ní',
  '尻': ' kāo',
  '尺': ' chǐ',
  '岄': ' yuè',
  '岆': ' yǎo',
  '尞': ' liào',
  '峇': ' bā',
  '峑': ' quān',
  '峐': ' gāi',
  '峏': ' ér',
  '峎': ' ěn',
  '峍': ' lù',
  '峌': ' dié',
  '峋': ' xún',
  '峊': ' fù',
  '峉': ' è',
  '峈': ' luò',
  '峆': ' hé',
  '峓': ' yí',
  '峅': ' bian',
  '峄': ' yì',
  '峃': ' xué',
  '峂': ' tóng',
  '峁': ' mǎo',
  '峀': ' xiù',
  '岿': ' kuī',
  '岾': ' hàn',
  '岽': ' dōng',
  '岼': ' ping',
  '峒': ' dòng',
  '峔': ' mǔ',
  '岺': ' líng',
  '峡': ' xiá',
  '峫': ' xié',
  '峪': ' yù',
  '峩': ' é',
  '峨': ' é',
  '峧': ' jiāo',
  '峦': ' luán',
  '峥': ' zhēng',
  '峤': ' jiào',
  '峣': ' yáo',
  '峢': ' lǐ',
  '峠': ' gu',
  '峕': ' shí',
  '峟': ' yòu',
  '峞': ' wéi',
  '峝': ' tóng',
  '峜': ' jì',
  '峛': ' lǐ',
  '峚': ' mì',
  '峙': ' zhì',
  '峘': ' huán',
  '峗': ' wéi',
  '峖': ' ān',
  '岻': ' chí',
  '岹': ' tiáo',
  '岇': ' áng',
  '岓': ' qí',
  '岝': ' zuò',
  '岜': ' bā',
  '岛': ' dǎo',
  '岚': ' lán',
  '岙': ' ào',
  '岘': ' xiàn',
  '岗': ' gǎng',
  '岖': ' qū',
  '岕': ' jiè',
  '岔': ' chà',
  '岒': ' qián',
  '岟': ' yǎng',
  '岑': ' cén',
  '岐': ' qí',
  '岏': ' wán',
  '岎': ' fén',
  '岍': ' qiān',
  '岌': ' jí',
  '岋': ' è',
  '岊': ' jié',
  '岉': ' wù',
  '岈': ' yá',
  '岞': ' zuò',
  '岠': ' jù',
  '岸': ' àn',
  '岭': ' lǐng',
  '岷': ' mín',
  '岶': ' pò',
  '岵': ' hù',
  '岴': ' qū',
  '岳': ' yuè',
  '岲': ' kuàng',
  '岱': ' dài',
  '岰': ' ào',
  '岯': ' pí',
  '岮': ' tuó',
  '岬': ' jiǎ',
  '岡': ' gāng',
  '岫': ' xiù',
  '岪': ' fú',
  '岩': ' yán',
  '岨': ' qū',
  '岧': ' tiáo',
  '岦': ' lì',
  '岥': ' pō',
  '岤': ' xué',
  '岣': ' gǒu',
  '岢': ' kě',
  '尟': ' xiǎn',
  '尝': ' cháng',
  '峭': ' qiào',
  '宏': ' hóng',
  '宙': ' zhòu',
  '官': ' guān',
  '宗': ' zōng',
  '宖': ' hóng',
  '宕': ' dàng',
  '宔': ' zhǔ',
  '宓': ' mì',
  '宒': ' zhūn',
  '宑': ' jǐng',
  '宐': ' yí',
  '宎': ' yǎo',
  '宛': ' wǎn',
  '宍': ' ròu',
  '完': ' wán',
  '宋': ' sòng',
  '宊': ' tū',
  '安': ' ān',
  '守': ' shǒu',
  '宇': ' yǔ',
  '宆': ' qióng',
  '宅': ' zhái',
  '宄': ' guǐ',
  '定': ' dìng',
  '宜': ' yí',
  '宂': ' rǒng',
  '宩': ' shǐ',
  '害': ' hài',
  '宲': ' bǎo',
  '宱': ' zhà',
  '宰': ' zǎi',
  '宯': ' xiāo',
  '宮': ' gōng',
  '宭': ' qún',
  '宬': ' chéng',
  '宫': ' gōng',
  '宪': ' xiàn',
  '宨': ' tiǎo',
  '宝': ' bǎo',
  '宧': ' yí',
  '宦': ' huàn',
  '宥': ' yòu',
  '室': ' shì',
  '宣': ' xuān',
  '客': ' kè',
  '审': ' shěn',
  '宠': ' chǒng',
  '実': ' shí',
  '实': ' shí',
  '它': ' tā',
  '宁': ' níng',
  '宵': ' xiāo',
  '孛': ' bèi',
  '孥': ' nú',
  '孤': ' gū',
  '季': ' jì',
  '孢': ' bāo',
  '孡': ' tāi',
  '孠': ' sì',
  '孟': ' mèng',
  '孞': ' xìn',
  '孝': ' xiào',
  '孜': ' zī',
  '孚': ' fú',
  '孧': ' you',
  '孙': ' sūn',
  '存': ' cún',
  '字': ' zì',
  '孖': ' mā',
  '孕': ' yùn',
  '孔': ' kǒng',
  '孓': ' jué',
  '孒': ' jué',
  '孑': ' jié',
  '子': ' zi',
  '学': ' xué',
  '孨': ' zhuǎn',
  '宀': ' mián',
  '孵': ' fū',
  '孿': ' luán',
  '孾': ' yīng',
  '孽': ' niè',
  '孼': ' niè',
  '孻': ' nái',
  '孺': ' rú',
  '孹': ' bò',
  '學': ' xué',
  '孷': ' lí',
  '孶': ' zī',
  '孴': ' nǐ',
  '孩': ' hái',
  '孳': ' zī',
  '孲': ' yā',
  '孱': ' càn',
  '孰': ' shú',
  '孯': ' qiān',
  '孮': ' cóng',
  '孭': ' miē',
  '孬': ' nāo',
  '孫': ' sūn',
  '孪': ' luán',
  '宴': ' yàn',
  '家': ' jiā',
  '尜': ' gá',
  '寷': ' fēng',
  '封': ' fēng',
  '尀': ' pǒ',
  '寿': ' shòu',
  '対': ' duì',
  '寽': ' lǜ',
  '导': ' dǎo',
  '寻': ' xún',
  '寺': ' sì',
  '对': ' duì',
  '寸': ' cùn',
  '寶': ' bǎo',
  '尃': ' fū',
  '寵': ' chǒng',
  '寴': ' qīn',
  '寳': ' bǎo',
  '寲': ' yí',
  '寱': ' yì',
  '寰': ' huán',
  '寯': ' jùn',
  '寮': ' liáo',
  '寭': ' huì',
  '寬': ' kuān',
  '専': ' zhuān',
  '射': ' shè',
  '寪': ' wěi',
  '少': ' shǎo',
  '尛': ' mo',
  '尚': ' shàng',
  '尙': ' shàng',
  '尘': ' chén',
  '尗': ' shū',
  '尖': ' jiān',
  '尕': ' gǎ',
  '尔': ' ěr',
  '尓': ' ěr',
  '尒': ' ěr',
  '尐': ' jié',
  '尅': ' kè',
  '小': ' xiǎo',
  '導': ' dǎo',
  '對': ' duì',
  '尌': ' shù',
  '尋': ' xún',
  '尊': ' zūn',
  '尉': ' wèi',
  '專': ' zhuān',
  '將': ' jiāng',
  '将': ' jiāng',
  '寫': ' xiě',
  '審': ' shěn',
  '宷': ' shěn',
  '寃': ' yuān',
  '寍': ' níng',
  '富': ' fù',
  '寋': ' jiàn',
  '寊': ' zhēn',
  '寉': ' què',
  '寈': ' qīng',
  '寇': ' kòu',
  '密': ' mì',
  '寅': ' yín',
  '寄': ' jì',
  '寂': ' jì',
  '寏': ' huán',
  '寁': ' zǎn',
  '寀': ' cǎi',
  '宿': ' sù',
  '宾': ' bīn',
  '宽': ' kuān',
  '宼': ' kòu',
  '宻': ' mì',
  '宺': ' huǎng',
  '容': ' róng',
  '宸': ' chén',
  '寎': ' bìng',
  '寐': ' mèi',
  '寨': ' zhài',
  '寝': ' qǐn',
  '寧': ' níng',
  '實': ' shí',
  '寥': ' liáo',
  '寤': ' wù',
  '寣': ' hū',
  '寢': ' qǐn',
  '寡': ' guǎ',
  '寠': ' jù',
  '察': ' chá',
  '寞': ' mò',
  '寜': ' níng',
  '寑': ' qǐn',
  '寛': ' kuān',
  '寚': ' bǎo',
  '寙': ' yǔ',
  '寘': ' zhì',
  '寗': ' níng',
  '寖': ' jìn',
  '寕': ' níng',
  '寔': ' shí',
  '寓': ' yù',
  '寒': ' hán',
  '峬': ' bū',
  '峮': ' qūn',
  '孎': ' zhú',
  '帀': ' zā',
  '帊': ' pà',
  '帉': ' fēn',
  '师': ' shī',
  '帇': ' niè',
  '帆': ' fān',
  '帅': ' shuài',
  '帄': ' dīng',
  '布': ' bù',
  '市': ' shì',
  '币': ' bì',
  '巿': ' fú',
  '希': ' xī',
  '巾': ' jīn',
  '巽': ' xùn',
  '巼': ' bā',
  '巻': ' juàn',
  '巺': ' xùn',
  '巹': ' jǐn',
  '巸': ' yí',
  '巷': ' xiàng',
  '巶': ' zhāo',
  '巵': ' zhī',
  '帋': ' zhǐ',
  '帍': ' hù',
  '巳': ' sì',
  '帚': ' zhǒu',
  '帤': ' rú',
  '帣': ' juǎn',
  '帢': ' qià',
  '帡': ' píng',
  '帠': ' yì',
  '帟': ' yì',
  '帞': ' mò',
  '帝': ' dì',
  '帜': ' zhì',
  '帛': ' bó',
  '帙': ' zhì',
  '帎': ' dàn',
  '帘': ' lián',
  '帗': ' bō',
  '帖': ' tiē',
  '帕': ' pà',
  '帔': ' pèi',
  '帓': ' mò',
  '帒': ' dài',
  '帑': ' tǎng',
  '帐': ' zhàng',
  '帏': ' wéi',
  '巴': ' bā',
  '已': ' yǐ',
  '带': ' dài',
  '巌': ' yán',
  '巖': ' yán',
  '巕': ' nie',
  '巔': ' diān',
  '巓': ' diān',
  '巒': ' luán',
  '巑': ' cuán',
  '巐': ' chǎo',
  '巏': ' quán',
  '巎': ' náo',
  '巍': ' wēi',
  '巋': ' kuī',
  '巘': ' yǎn',
  '巊': ' yǐng',
  '巉': ' chán',
  '巈': ' jú',
  '巇': ' xī',
  '巆': ' róng',
  '巅': ' diān',
  '巄': ' lóng',
  '巃': ' lóng',
  '巂': ' guī',
  '巁': ' lì',
  '巗': ' yán',
  '巙': ' kuí',
  '己': ' jǐ',
  '左': ' zuǒ',
  '巰': ' qiú',
  '巯': ' qiú',
  '差': ' chà',
  '巭': ' pu',
  '巬': ' pu',
  '巫': ' wū',
  '巪': ' jù',
  '巩': ' gǒng',
  '巨': ' jù',
  '巧': ' qiǎo',
  '工': ' gōng',
  '巚': ' yǎn',
  '巤': ' liè',
  '巣': ' cháo',
  '巢': ' cháo',
  '巡': ' xún',
  '巠': ' jīng',
  '巟': ' huāng',
  '州': ' zhōu',
  '川': ' chuān',
  '巜': ' kuài',
  '巛': ' chuān',
  '帥': ' shuài',
  '帧': ' zhèng',
  '嶿': ' ru',
  '幨': ' chān',
  '干': ' gàn',
  '幱': ' lán',
  '幰': ' xiǎn',
  '幯': ' jié',
  '幮': ' chú',
  '幭': ' miè',
  '幬': ' chóu',
  '幫': ' bāng',
  '幪': ' méng',
  '幩': ' fén',
  '幧': ' qiāo',
  '年': ' nián',
  '幦': ' mì',
  '幥': ' zhang',
  '幤': ' bi',
  '幣': ' bì',
  '幢': ' chuáng',
  '幡': ' fān',
  '幠': ' hū',
  '幟': ' zhì',
  '幞': ' fú',
  '幝': ' chǎn',
  '平': ' píng',
  '幵': ' jiān',
  '幛': ' zhàng',
  '庂': ' zè',
  '庌': ' yǎ',
  '庋': ' guǐ',
  '床': ' chuáng',
  '庉': ' dùn',
  '庈': ' qín',
  '庇': ' bì',
  '庆': ' qìng',
  '庅': ' mó',
  '庄': ' zhuāng',
  '広': ' guǎng',
  '庁': ' tīng',
  '并': ' bìng',
  '庀': ' pǐ',
  '广': ' guǎng',
  '幾': ' jǐ',
  '幽': ' yōu',
  '幼': ' yòu',
  '幻': ' huàn',
  '幺': ' yāo',
  '幹': ' gàn',
  '幸': ' xìng',
  '幷': ' bìng',
  '幜': ' jǐng',
  '幚': ' bāng',
  '帨': ' shuì',
  '帴': ' sàn',
  '帾': ' dǔ',
  '帽': ' mào',
  '帼': ' guó',
  '帻': ' zé',
  '帺': ' qí',
  '帹': ' shà',
  '常': ' cháng',
  '帷': ' wéi',
  '帶': ' dài',
  '帵': ' wān',
  '帳': ' zhàng',
  '幀': ' zhèng',
  '帲': ' píng',
  '帱': ' chóu',
  '帰': ' guī',
  '帯': ' dài',
  '帮': ' bāng',
  '席': ' xí',
  '帬': ' qún',
  '師': ' shī',
  '帪': ' zhēn',
  '帩': ' qiào',
  '帿': ' hóu',
  '幁': ' xū',
  '幙': ' mù',
  '幎': ' mì',
  '幘': ' zé',
  '幗': ' guó',
  '幖': ' biāo',
  '幕': ' mù',
  '幔': ' màn',
  '幓': ' shān',
  '幒': ' zhōng',
  '幑': ' huī',
  '幐': ' téng',
  '幏': ' jià',
  '幍': ' tāo',
  '幂': ' mì',
  '幌': ' huǎng',
  '幋': ' pán',
  '幊': ' gōng',
  '幉': ' die',
  '幈': ' píng',
  '幇': ' bāng',
  '幆': ' yì',
  '幅': ' fú',
  '幄': ' wò',
  '幃': ' wéi',
  '巀': ' jié',
  '嶾': ' yǐn',
  '峯': ' fēng',
  '崯': ' yín',
  '崹': ' tí',
  '崸': ' yáng',
  '崷': ' qiú',
  '崶': ' fēng',
  '崵': ' yáng',
  '崴': ' wǎi',
  '崳': ' yú',
  '崲': ' huáng',
  '崱': ' zè',
  '崰': ' zi',
  '崮': ' gù',
  '崻': ' zhì',
  '崭': ' zhǎn',
  '崬': ' dōng',
  '崫': ' kū',
  '崪': ' zú',
  '崩': ' bēng',
  '崨': ' jié',
  '崧': ' sōng',
  '崦': ' yān',
  '崥': ' pí',
  '崤': ' xiáo',
  '崺': ' yǐ',
  '崼': ' shì',
  '崢': ' zhēng',
  '嵉': ' tíng',
  '嵓': ' yán',
  '嵒': ' yán',
  '嵑': ' kě',
  '嵐': ' lán',
  '嵏': ' zōng',
  '嵎': ' yú',
  '嵍': ' wù',
  '嵌': ' qiàn',
  '嵋': ' méi',
  '嵊': ' shèng',
  '嵈': ' huàn',
  '崽': ' zǎi',
  '嵇': ' jī',
  '嵆': ' jī',
  '嵅': ' hán',
  '嵄': ' měi',
  '嵃': ' yǎn',
  '嵂': ' lǜ',
  '嵁': ' kān',
  '嵀': ' zhù',
  '崿': ' è',
  '崾': ' yǎo',
  '崣': ' wěi',
  '崡': ' hán',
  '嵕': ' zōng',
  '峻': ' jùn',
  '崅': ' què',
  '崄': ' xiǎn',
  '崃': ' lái',
  '崂': ' láo',
  '崁': ' kàn',
  '崀': ' làng',
  '峿': ' yǔ',
  '峾': ' yín',
  '峽': ' xiá',
  '峼': ' hào',
  '峺': ' gěng',
  '崇': ' chóng',
  '峹': ' tú',
  '峸': ' chéng',
  '峷': ' shēn',
  '島': ' dǎo',
  '峵': ' hóng',
  '峴': ' xiàn',
  '峳': ' yóu',
  '峲': ' lǐ',
  '峱': ' náo',
  '峰': ' fēng',
  '崆': ' kōng',
  '崈': ' chóng',
  '崠': ' dōng',
  '崕': ' yá',
  '崟': ' yín',
  '崞': ' guō',
  '崝': ' zhēng',
  '崜': ' duō',
  '崛': ' jué',
  '崚': ' léng',
  '崙': ' lún',
  '崘': ' lún',
  '崗': ' gǎng',
  '崖': ' yá',
  '崔': ' cuī',
  '崉': ' tà',
  '崓': ' gù',
  '崒': ' zú',
  '崑': ' kūn',
  '崐': ' kūn',
  '崏': ' mín',
  '崎': ' qí',
  '崍': ' lái',
  '崌': ' jū',
  '崋': ' huà',
  '崊': ' lín',
  '嵔': ' wěi',
  '嵖': ' chá',
  '嶽': ' yuè',
  '嶘': ' zhàn',
  '嶢': ' yáo',
  '嶡': ' guì',
  '嶠': ' jiào',
  '嶟': ' zūn',
  '嶞': ' duò',
  '嶝': ' dèng',
  '嶜': ' jīn',
  '嶛': ' liáo',
  '嶚': ' liáo',
  '嶙': ' lín',
  '嶗': ' láo',
  '嶤': ' yáo',
  '嶖': ' yǎn',
  '嶕': ' jiāo',
  '嶔': ' qīn',
  '嶓': ' bō',
  '嶒': ' céng',
  '嶑': ' xiàng',
  '嶐': ' lóng',
  '嶏': ' pèi',
  '嶎': ' yù',
  '嶍': ' xí',
  '嶣': ' jiāo',
  '嶥': ' jué',
  '嶋': ' dǎo',
  '嶲': ' xī',
  '嶼': ' yǔ',
  '嶻': ' zá',
  '嶺': ' lǐng',
  '嶹': ' dǎo',
  '嶸': ' róng',
  '嶷': ' yí',
  '嶶': ' wei',
  '嶵': ' zuǐ',
  '嶴': ' ào',
  '嶳': ' dì',
  '嶱': ' kě',
  '嶦': ' zhān',
  '嶰': ' xiè',
  '嶯': ' jí',
  '嶮': ' xiǎn',
  '嶭': ' niè',
  '嶬': ' yí',
  '嶫': ' yè',
  '嶪': ' yè',
  '嶩': ' náo',
  '嶨': ' xué',
  '嶧': ' yì',
  '嶌': ' dǎo',
  '嶊': ' zuǐ',
  '嵗': ' suì',
  '嵣': ' dàng',
  '嵭': ' bēng',
  '嵬': ' wéi',
  '嵫': ' zī',
  '嵪': ' qiāo',
  '嵩': ' sōng',
  '嵨': ' wù',
  '嵧': ' liú',
  '嵦': ' kǎi',
  '嵥': ' jié',
  '嵤': ' róng',
  '嵢': ' cāng',
  '嵯': ' cuó',
  '嵡': ' wěng',
  '嵠': ' xī',
  '嵟': ' duī',
  '嵞': ' tú',
  '嵝': ' lǒu',
  '嵜': ' ti',
  '嵛': ' yú',
  '嵚': ' qīn',
  '嵙': ' ke',
  '嵘': ' róng',
  '嵮': ' diān',
  '嵰': ' qiǎn',
  '嶉': ' cuī',
  '嵾': ' cēn',
  '嶈': ' qiāng',
  '嶇': ' qū',
  '嶆': ' cáo',
  '嶅': ' áo',
  '嶄': ' zhǎn',
  '嶃': ' zhǎn',
  '嶂': ' zhàng',
  '嶁': ' lǒu',
  '嶀': ' tū',
  '嵿': ' dǐng',
  '嵽': ' dié',
  '嵱': ' yǒng',
  '嵼': ' chǎn',
  '嵻': ' kāng',
  '嵺': ' liáo',
  '嵹': ' jiàng',
  '嵸': ' zōng',
  '嵷': ' sǒng',
  '嵶': ' ruo',
  '嵵': ' shi',
  '嵴': ' jǐ',
  '嵳': ' cuó',
  '嵲': ' niè',
  '孏': ' lǎn',
  '孍': ' yán',
  '堍': ' tù',
  '夞': ' wài',
  '夨': ' zè',
  '大': ' dà',
  '夦': ' chěn',
  '夥': ' huǒ',
  '夤': ' yín',
  '夣': ' mèng',
  '夢': ' mèng',
  '夡': ' qì',
  '夠': ' gòu',
  '够': ' gòu',
  '夝': ' qíng',
  '太': ' tài',
  '夜': ' yè',
  '夛': ' duō',
  '多': ' duō',
  '夙': ' sù',
  '夘': ' mǎo',
  '夗': ' yuàn',
  '外': ' wài',
  '夕': ' xī',
  '夔': ' kuí',
  '夓': ' xià',
  '天': ' tiān',
  '夫': ' fū',
  '夑': ' xie',
  '夸': ' kuā',
  '奂': ' huàn',
  '奁': ' lián',
  '奀': ' ēn',
  '夿': ' bā',
  '夾': ' jiā',
  '夽': ' yǔn',
  '夼': ' kuǎng',
  '夻': ' huà',
  '夺': ' duó',
  '夹': ' jiā',
  '夷': ' yí',
  '夬': ' guài',
  '夶': ' bǐ',
  '夵': ' yǎn',
  '头': ' tóu',
  '夳': ' tài',
  '夲': ' tāo',
  '失': ' shī',
  '夰': ' gǎo',
  '夯': ' hāng',
  '央': ' yāng',
  '夭': ' yāo',
  '夒': ' náo',
  '夐': ' xiòng',
  '奄': ' yǎn',
  '壪': ' wān',
  '壴': ' zhù',
  '壳': ' ké',
  '売': ' mài',
  '壱': ' yī',
  '声': ' shēng',
  '壯': ' zhuàng',
  '壮': ' zhuàng',
  '壭': ' san',
  '壬': ' rén',
  '士': ' shì',
  '壩': ' bà',
  '壶': ' hú',
  '壨': ' léi',
  '壧': ' yán',
  '壦': ' xūn',
  '壥': ' chan',
  '壤': ' rǎng',
  '壣': ' lín',
  '壢': ' lì',
  '壡': ' ruì',
  '壠': ' lǒng',
  '壟': ' lǒng',
  '壵': ' zhuàng',
  '壷': ' hú',
  '夏': ' xià',
  '处': ' chù',
  '夎': ' cuò',
  '复': ' fù',
  '夌': ' líng',
  '夋': ' qūn',
  '夊': ' suī',
  '変': ' biàn',
  '夈': ' zhai',
  '备': ' bèi',
  '夆': ' féng',
  '夅': ' jiàng',
  '夃': ' gǔ',
  '壸': ' kǔn',
  '夂': ' zhǐ',
  '夁': ' yī',
  '夀': ' shòu',
  '壿': ' zūn',
  '壾': ' mǎng',
  '壽': ' shòu',
  '壼': ' kǔn',
  '壻': ' xù',
  '壺': ' hú',
  '壹': ' yī',
  '奃': ' dī',
  '奅': ' pào',
  '壝': ' wěi',
  '妆': ' zhuāng',
  '妐': ' zhōng',
  '妏': ' wèn',
  '妎': ' hài',
  '妍': ' yán',
  '妌': ' jìng',
  '妋': ' fū',
  '妊': ' rèn',
  '妉': ' dān',
  '妈': ' mā',
  '妇': ' fù',
  '妅': ' hóng',
  '妒': ' dù',
  '妄': ' wàng',
  '妃': ' fēi',
  '如': ' rú',
  '妁': ' shuò',
  '妀': ' jǐ',
  '奿': ' fàn',
  '奾': ' xiān',
  '好': ' hǎo',
  '奼': ' chà',
  '奻': ' nuán',
  '妑': ' pā',
  '妓': ' jì',
  '她': ' tā',
  '妠': ' nà',
  '妪': ' yù',
  '妩': ' wǔ',
  '妨': ' fáng',
  '妧': ' wàn',
  '妦': ' fēng',
  '妥': ' tuǒ',
  '妤': ' yú',
  '妣': ' bǐ',
  '妢': ' fén',
  '妡': ' xīn',
  '妟': ' yàn',
  '妔': ' kēng',
  '妞': ' niū',
  '妝': ' zhuāng',
  '妜': ' yuè',
  '妛': ' chi',
  '妚': ' fǒu',
  '妙': ' miào',
  '妘': ' yún',
  '妗': ' jìn',
  '妖': ' yāo',
  '妕': ' zhòng',
  '奺': ' jiǔ',
  '奸': ' jiān',
  '奆': ' juàn',
  '奒': ' kāi',
  '奜': ' fěi',
  '奛': ' huǎng',
  '奚': ' xī',
  '奙': ' běn',
  '奘': ' zàng',
  '套': ' tào',
  '奖': ' jiǎng',
  '奕': ' yì',
  '奔': ' bēn',
  '奓': ' zhā',
  '契': ' qì',
  '奞': ' xùn',
  '奐': ' huàn',
  '奏': ' zòu',
  '奎': ' kuí',
  '奍': ' yang',
  '奌': ' diǎn',
  '奋': ' fèn',
  '奊': ' xié',
  '奉': ' fèng',
  '奈': ' nài',
  '奇': ' qí',
  '奝': ' diāo',
  '奟': ' bēng',
  '奷': ' qiān',
  '奬': ' jiǎng',
  '奶': ' nǎi',
  '奵': ' dǐng',
  '奴': ' nú',
  '女': ' nǚ',
  '奲': ' duǒ',
  '奱': ' luán',
  '奰': ' bì',
  '奯': ' huò',
  '奮': ' fèn',
  '奭': ' shì',
  '奫': ' yūn',
  '奠': ' diàn',
  '奪': ' duó',
  '奩': ' lián',
  '奨': ' jiǎng',
  '奧': ' ào',
  '奦': ' wù',
  '奥': ' ào',
  '奤': ' hǎ',
  '奣': ' wěng',
  '奢': ' shē',
  '奡': ' ào',
  '壞': ' huài',
  '壜': ' tán',
  '妬': ' dù',
  '塍': ' chéng',
  '塗': ' tú',
  '塖': ' chéng',
  '塕': ' wěng',
  '塔': ' tǎ',
  '塓': ' mì',
  '塒': ' shí',
  '塑': ' sù',
  '塐': ' sù',
  '塏': ' kǎi',
  '塎': ' yǒng',
  '塌': ' tā',
  '塙': ' què',
  '塋': ' yíng',
  '塊': ' kuài',
  '塉': ' jí',
  '塈': ' jì',
  '塇': ' xuān',
  '塆': ' wān',
  '塅': ' duàn',
  '塄': ' léng',
  '塃': ' huāng',
  '塂': ' xiàng',
  '塘': ' táng',
  '塚': ' zhǒng',
  '塀': ' ping',
  '塧': ' ài',
  '塱': ' lǎng',
  '塰': ' hai',
  '塯': ' liù',
  '塮': ' xiè',
  '塭': ' wēn',
  '塬': ' yuán',
  '填': ' tián',
  '塪': ' kǎn',
  '塩': ' yán',
  '塨': ' gōng',
  '塦': ' zhèn',
  '塛': ' lì',
  '塥': ' gé',
  '塤': ' xūn',
  '塣': ' zhèng',
  '塢': ' wù',
  '塡': ' tián',
  '塠': ' duī',
  '塟': ' zàng',
  '塞': ' sāi',
  '塝': ' bàng',
  '塜': ' zhǒng',
  '塁': ' lei',
  '堿': ' jiǎn',
  '塳': ' péng',
  '堙': ' yīn',
  '堣': ' yú',
  '堢': ' bǎo',
  '堡': ' bǎo',
  '堠': ' hòu',
  '堟': ' zhuàn',
  '堞': ' dié',
  '堝': ' guō',
  '堜': ' liàn',
  '堛': ' bì',
  '堚': ' hún',
  '堘': ' chéng',
  '堥': ' máo',
  '堗': ' tū',
  '堖': ' nǎo',
  '堕': ' duò',
  '堔': ' shen',
  '堓': ' àn',
  '堒': ' kun',
  '堑': ' qiàn',
  '堐': ' yá',
  '堏': ' fang',
  '堎': ' lèng',
  '堤': ' dī',
  '堦': ' jiē',
  '堾': ' chūn',
  '堳': ' méi',
  '堽': ' gāng',
  '堼': ' hèng',
  '堻': ' jīn',
  '堺': ' jiè',
  '堹': ' zhòng',
  '堸': ' féng',
  '堷': ' yìn',
  '堶': ' tuó',
  '堵': ' dǔ',
  '場': ' chǎng',
  '堲': ' cí',
  '堧': ' ruán',
  '報': ' bào',
  '堰': ' yàn',
  '堯': ' yáo',
  '堮': ' è',
  '堭': ' huáng',
  '堬': ' yú',
  '堫': ' zōng',
  '堪': ' kān',
  '堩': ' gèng',
  '堨': ' yè',
  '塲': ' cháng',
  '塴': ' bèng',
  '壛': ' yán',
  '墶': ' da',
  '壀': ' pí',
  '墿': ' yì',
  '墾': ' kěn',
  '墽': ' qiāo',
  '墼': ' jī',
  '墻': ' qiáng',
  '墺': ' ào',
  '墹': ' jian',
  '墸': ' zhu',
  '墷': ' yè',
  '墵': ' tán',
  '壂': ' diàn',
  '墴': ' huáng',
  '墳': ' fén',
  '墲': ' mú',
  '墱': ' dèng',
  '墰': ' tán',
  '墯': ' duò',
  '墮': ' duò',
  '墭': ' shèng',
  '墬': ' dì',
  '墫': ' zūn',
  '壁': ' bì',
  '壃': ' jiāng',
  '墩': ' dūn',
  '壐': ' xǐ',
  '壚': ' lú',
  '壙': ' kuàng',
  '壘': ' lěi',
  '壗': ' jin',
  '壖': ' ruán',
  '壕': ' háo',
  '壔': ' dǎo',
  '壓': ' yā',
  '壒': ' ài',
  '壑': ' hè',
  '壏': ' xiàn',
  '壄': ' yě',
  '壎': ' xūn',
  '壍': ' qiàn',
  '壌': ' rǎng',
  '壋': ' dàng',
  '壊': ' huài',
  '壉': ' jù',
  '壈': ' lǎn',
  '壇': ' tán',
  '壆': ' xué',
  '壅': ' yōng',
  '墪': ' dūn',
  '墨': ' mò',
  '塵': ' chén',
  '墁': ' màn',
  '墋': ' chěn',
  '墊': ' diàn',
  '墉': ' yōng',
  '墈': ' kàn',
  '墇': ' zhāng',
  '墆': ' zhì',
  '墅': ' shù',
  '墄': ' cè',
  '境': ' jìng',
  '墂': ' biāo',
  '墀': ' chí',
  '墍': ' xì',
  '塿': ' lǒu',
  '塾': ' shú',
  '塽': ' shuǎng',
  '塼': ' zhuān',
  '塻': ' mò',
  '塺': ' méi',
  '塹': ' qiàn',
  '塸': ' ōu',
  '塷': ' lǔ',
  '塶': ' lù',
  '墌': ' zhí',
  '墎': ' guō',
  '墧': ' què',
  '墜': ' zhuì',
  '墦': ' fán',
  '墥': ' dǒng',
  '墤': ' kuài',
  '墣': ' pú',
  '墢': ' bá',
  '墡': ' shàn',
  '墠': ' shàn',
  '墟': ' xū',
  '增': ' zēng',
  '墝': ' qiāo',
  '墛': ' wei',
  '墏': ' qiǎng',
  '墚': ' liáng',
  '墙': ' qiáng',
  '墘': ' qián',
  '増': ' zēng',
  '墖': ' tǎ',
  '墕': ' yàn',
  '墔': ' cuī',
  '墓': ' mù',
  '墒': ' shāng',
  '墑': ' dì',
  '墐': ' jìn',
  '妫': ' guī',
  '妭': ' bá',
  '孌': ' luán',
  '媿': ' kuì',
  '嫉': ' jí',
  '嫈': ' yīng',
  '嫇': ' míng',
  '嫆': ' róng',
  '嫅': ' jiē',
  '嫄': ' yuán',
  '嫃': ' zhēn',
  '嫂': ' sǎo',
  '嫁': ' jià',
  '嫀': ' qín',
  '媾': ' gòu',
  '嫋': ' niǎo',
  '媽': ' mā',
  '媼': ' ǎo',
  '媻': ' pán',
  '媺': ' měi',
  '媹': ' liú',
  '媸': ' chī',
  '媷': ' rù',
  '媶': ' róng',
  '媵': ' yìng',
  '媴': ' yuán',
  '嫊': ' sù',
  '嫌': ' xián',
  '媲': ' pì',
  '嫙': ' xuán',
  '嫣': ' yān',
  '嫢': ' guī',
  '嫡': ' dí',
  '嫠': ' lí',
  '嫟': ' nì',
  '嫞': ' yōng',
  '嫝': ' kāng',
  '嫜': ' zhāng',
  '嫛': ' yī',
  '嫚': ' mān',
  '嫘': ' léi',
  '嫍': ' tāo',
  '嫗': ' yù',
  '嫖': ' piáo',
  '嫕': ' yì',
  '嫔': ' pín',
  '嫓': ' pì',
  '嫒': ' ài',
  '嫑': ' báo',
  '嫐': ' nǎo',
  '嫏': ' láng',
  '嫎': ' páng',
  '媳': ' xí',
  '媱': ' yáo',
  '嫥': ' zhuān',
  '媋': ' chūn',
  '媕': ' ān',
  '媔': ' mián',
  '媓': ' huáng',
  '媒': ' méi',
  '媑': ' zhòng',
  '媐': ' yí',
  '媏': ' duān',
  '媎': ' jiě',
  '媍': ' fù',
  '媌': ' miáo',
  '媊': ' qián',
  '媗': ' xuān',
  '媉': ' wò',
  '媈': ' huī',
  '媇': ' qīn',
  '媆': ' ruǎn',
  '媅': ' dān',
  '媄': ' měi',
  '媃': ' róu',
  '媂': ' dì',
  '媁': ' wéi',
  '媀': ' yù',
  '媖': ' yīng',
  '媘': ' jiē',
  '媰': ' chú',
  '媥': ' piān',
  '媯': ' guī',
  '媮': ' tōu',
  '媭': ' xū',
  '媬': ' bǎo',
  '媫': ' qie',
  '媪': ' ǎo',
  '媩': ' hú',
  '媨': ' jiù',
  '媧': ' wā',
  '媦': ' wèi',
  '媤': ' sī',
  '媙': ' wēi',
  '媣': ' rǎn',
  '媢': ' mào',
  '媡': ' liàn',
  '媠': ' tuǒ',
  '媟': ' xiè',
  '媞': ' shì',
  '媝': ' qiū',
  '媜': ' zhēng',
  '媛': ' yuàn',
  '媚': ' mèi',
  '嫤': ' jǐn',
  '嫦': ' cháng',
  '婾': ' tōu',
  '嬧': ' jìn',
  '嬱': ' cán',
  '嬰': ' yīng',
  '嬯': ' tái',
  '嬮': ' yān',
  '嬭': ' nǎi',
  '嬬': ' rú',
  '嬫': ' róng',
  '嬪': ' pín',
  '嬩': ' yú',
  '嬨': ' cí',
  '嬦': ' chóu',
  '嬳': ' yuè',
  '嬥': ' tiǎo',
  '嬤': ' mā',
  '嬣': ' níng',
  '嬢': ' niáng',
  '嬡': ' ài',
  '嬠': ' cān',
  '嬟': ' yì',
  '嬞': ' dǒng',
  '嬝': ' niǎo',
  '嬜': ' xīn',
  '嬲': ' niǎo',
  '嬴': ' yíng',
  '嬚': ' liǎn',
  '孁': ' líng',
  '孋': ' lí',
  '孊': ' mǐ',
  '孉': ' quán',
  '孈': ' huì',
  '孇': ' shuāng',
  '孆': ' yīng',
  '孅': ' qiān',
  '孄': ' lǎn',
  '孃': ' niáng',
  '孂': ' jiǎo',
  '孀': ' shuāng',
  '嬵': ' mián',
  '嬿': ' yàn',
  '嬾': ' lǎn',
  '嬽': ' yuān',
  '嬼': ' liǔ',
  '嬻': ' dú',
  '嬺': ' nì',
  '嬹': ' xìng',
  '嬸': ' shěn',
  '嬷': ' mā',
  '嬶': ' bi',
  '嬛': ' huán',
  '嬙': ' qiáng',
  '嫧': ' zé',
  '嫳': ' piè',
  '嫽': ' liáo',
  '嫼': ' mò',
  '嫻': ' xián',
  '嫺': ' xián',
  '嫹': ' máo',
  '嫸': ' zhǎn',
  '嫷': ' tuǒ',
  '嫶': ' qiáo',
  '嫵': ' wǔ',
  '嫴': ' gū',
  '嫲': ' ma',
  '嫿': ' huà',
  '嫱': ' qiáng',
  '嫰': ' nèn',
  '嫯': ' ào',
  '嫮': ' hù',
  '嫭': ' hù',
  '嫬': ' zhē',
  '嫫': ' mó',
  '嫪': ' lào',
  '嫩': ' nèn',
  '嫨': ' hān',
  '嫾': ' lián',
  '嬀': ' guī',
  '嬘': ' suì',
  '嬍': ' měi',
  '嬗': ' shàn',
  '嬖': ' bì',
  '嬕': ' shì',
  '嬔': ' fù',
  '嬓': ' jiào',
  '嬒': ' huì',
  '嬑': ' yì',
  '嬐': ' xiān',
  '嬏': ' fān',
  '嬎': ' fàn',
  '嬌': ' jiāo',
  '嬁': ' dēng',
  '嬋': ' chán',
  '嬊': ' yàn',
  '嬉': ' xī',
  '嬈': ' ráo',
  '嬇': ' kuì',
  '嬆': ' xī',
  '嬅': ' huà',
  '嬄': ' yī',
  '嬃': ' xū',
  '嬂': ' zhí',
  '婿': ' xù',
  '婽': ' jiǎ',
  '妮': ' nī',
  '姮': ' héng',
  '姸': ' yán',
  '姷': ' yòu',
  '姶': ' è',
  '姵': ' pèi',
  '姴': ' liè',
  '姳': ' mǐng',
  '姲': ' yàn',
  '姱': ' kuā',
  '姰': ' jūn',
  '姯': ' guāng',
  '姭': ' xiàn',
  '姺': ' shēn',
  '姬': ' jī',
  '姫': ' jī',
  '姪': ' zhí',
  '姩': ' niàn',
  '姨': ' yí',
  '姧': ' jiān',
  '姦': ' jiān',
  '姥': ' lǎo',
  '姤': ' gòu',
  '姣': ' jiāo',
  '姹': ' chà',
  '姻': ' yīn',
  '姡': ' huá',
  '娈': ' luán',
  '娒': ' méi',
  '娑': ' suō',
  '娐': ' fū',
  '娏': ' máng',
  '娎': ' xiè',
  '娍': ' chéng',
  '娌': ' lǐ',
  '娋': ' shào',
  '娊': ' xiàn',
  '娉': ' pīng',
  '娇': ' jiāo',
  '姼': ' shí',
  '娆': ' ráo',
  '娅': ' yà',
  '娄': ' lóu',
  '娃': ' wá',
  '娂': ' hóng',
  '威': ' wēi',
  '娀': ' sōng',
  '姿': ' zī',
  '姾': ' quán',
  '姽': ' guǐ',
  '姢': ' juān',
  '姠': ' xiàng',
  '娔': ' kè',
  '妺': ' mò',
  '姄': ' mín',
  '姃': ' zhēng',
  '姂': ' fá',
  '姁': ' xǔ',
  '姀': ' hé',
  '妿': ' ē',
  '妾': ' qiè',
  '妽': ' shēn',
  '妼': ' bì',
  '妻': ' qī',
  '妹': ' mèi',
  '姆': ' mǔ',
  '妸': ' ē',
  '妷': ' zhí',
  '妶': ' xián',
  '妵': ' tǒu',
  '妴': ' yuàn',
  '妳': ' nǎi',
  '妲': ' dá',
  '妱': ' zhāo',
  '妰': ' zhuó',
  '妯': ' zhóu',
  '姅': ' bàn',
  '姇': ' fū',
  '姟': ' gāi',
  '委': ' wěi',
  '姞': ' jí',
  '姝': ' shū',
  '姜': ' jiāng',
  '姛': ' dòng',
  '姚': ' yáo',
  '姙': ' rèn',
  '姘': ' pīn',
  '姗': ' shān',
  '姖': ' jù',
  '姕': ' zī',
  '姓': ' xìng',
  '姈': ' líng',
  '姒': ' sì',
  '姑': ' gū',
  '姐': ' jiě',
  '姏': ' mán',
  '姎': ' yāng',
  '姍': ' shān',
  '姌': ' rǎn',
  '始': ' shǐ',
  '姊': ' zǐ',
  '姉': ' zǐ',
  '娓': ' wěi',
  '娕': ' chuò',
  '婼': ' chuò',
  '婗': ' ní',
  '婡': ' lái',
  '婠': ' wān',
  '婟': ' hù',
  '婞': ' xìng',
  '婝': ' diàn',
  '婜': ' qiān',
  '婛': ' jīng',
  '婚': ' hūn',
  '婙': ' jìng',
  '婘': ' quán',
  '婖': ' tiān',
  '婣': ' yīn',
  '婕': ' jié',
  '婔': ' fei',
  '婓': ' fēi',
  '婒': ' tán',
  '婑': ' ruí',
  '婐': ' wǒ',
  '婏': ' fàn',
  '婎': ' huī',
  '婍': ' qǐ',
  '婌': ' shú',
  '婢': ' bì',
  '婤': ' chōu',
  '婊': ' biǎo',
  '婱': ' xián',
  '婻': ' nàn',
  '婺': ' wù',
  '婹': ' yǎo',
  '婸': ' dàng',
  '婷': ' tíng',
  '婶': ' shěn',
  '婵': ' chán',
  '婴': ' yīng',
  '婳': ' huà',
  '婲': ' hua',
  '婰': ' diǎn',
  '婥': ' nào',
  '婯': ' lì',
  '婮': ' jū',
  '婭': ' yà',
  '婬': ' yín',
  '婫': ' kūn',
  '婪': ' lán',
  '婩': ' àn',
  '婨': ' lún',
  '婧': ' jìng',
  '婦': ' fù',
  '婋': ' xiāo',
  '婉': ' wǎn',
  '娖': ' chuò',
  '娢': ' hán',
  '娬': ' wǔ',
  '娫': ' yán',
  '娪': ' wú',
  '娩': ' miǎn',
  '娨': ' xiàn',
  '娧': ' tuì',
  '娦': ' pín',
  '娥': ' é',
  '娤': ' zhuāng',
  '娣': ' dì',
  '娡': ' zhì',
  '娮': ' yán',
  '娠': ' shēn',
  '娟': ' juān',
  '娞': ' něi',
  '娝': ' pōu',
  '娜': ' nà',
  '娛': ' yú',
  '娚': ' nán',
  '娙': ' xíng',
  '娘': ' niáng',
  '娗': ' tǐng',
  '娭': ' āi',
  '娯': ' yú',
  '婈': ' líng',
  '娽': ' lù',
  '婇': ' cāi',
  '婆': ' pó',
  '婅': ' jú',
  '婄': ' pǒu',
  '婃': ' cóng',
  '婂': ' mián',
  '婁': ' lóu',
  '婀': ' ē',
  '娿': ' ē',
  '娾': ' ǎi',
  '娼': ' chāng',
  '娰': ' sì',
  '娻': ' dōng',
  '娺': ' zhuó',
  '娹': ' xián',
  '娸': ' qī',
  '娷': ' zhuì',
  '娶': ' qǔ',
  '娵': ' jū',
  '娴': ' xián',
  '娳': ' lì',
  '娲': ' wā',
  '娱': ' yú',
  '皎': ' jiǎo'
};

exports.default = DICTIONARY;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DICTIONARY = {
  '万俟': ' mò qí',
  '尉迟': ' yù chí',
  '单于': ' chán yú',
  '不': ' fǒu',
  '沈': ' shěn',
  '称': ' chēng',
  '车': ' chē',
  '万': ' wàn',
  '汤': ' tāng',
  '阿': ' ā',
  '丁': ' dīng',
  '强': ' qiáng',
  '仇': ' qiú',
  '叶': ' yè',
  '阚': ' kàn',
  '乐': ' yuè',
  '乜': ' niè',
  '陆': ' lù',
  '殷': ' yīn',
  '牟': ' móu',
  '区': ' ōu',
  '宿': ' sù',
  '俞': ' yú',
  '余': ' yú',
  '齐': ' qí',
  '许': ' xǔ',
  '信': ' xìn',
  '无': ' wú',
  '浣': ' wǎn',
  '艾': ' ài',
  '浅': ' qiǎn',
  '烟': ' yān',
  '蓝': ' lán',
  '於': ' yú',
  '寻': ' xún',
  '殳': ' shū',
  '思': ' sī',
  '鸟': ' niǎo',
  '卜': ' bǔ',
  '单': ' shàn',
  '南': ' nán',
  '柏': ' bǎi',
  '朴': ' piáo',
  '繁': ' pó',
  '曾': ' zēng',
  '瞿': ' qú',
  '缪': ' miào',
  '石': ' shí',
  '冯': ' féng',
  '覃': ' qín',
  '幺': ' yāo',
  '种': ' chóng',
  '折': ' shè',
  '燕': ' yān',
  '纪': ' jǐ',
  '过': ' guō',
  '华': ' huà',
  '冼': ' xiǎn',
  '秘': ' bì',
  '重': ' chóng',
  '解': ' xiè',
  '那': ' nā',
  '和': ' hé',
  '贾': ' jiǎ',
  '塔': ' tǎ',
  '盛': ' shèng',
  '查': ' zhā',
  '盖': ' gě',
  '居': ' jū',
  '哈': ' hǎ',
  '的': ' dē',
  '薄': ' bó',
  '佴': ' nài',
  '六': ' lù',
  '都': ' dū',
  '翟': ' zhái',
  '扎': ' zā',
  '藏': ' zàng',
  '粘': ' niàn',
  '难': ' nàn',
  '若': ' ruò'
};

exports.default = DICTIONARY;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DICTIONARY = {
  'üē': ['ue', 1],
  'üé': ['ue', 2],
  'üě': ['ue', 3],
  'üè': ['ue', 4],
  'ā': ['a', 1],
  'ē': ['e', 1],
  'ī': ['i', 1],
  'ō': ['o', 1],
  'ū': ['u', 1],
  'ǖ': ['v', 1],
  'á': ['a', 2],
  'é': ['e', 2],
  'í': ['i', 2],
  'ó': ['o', 2],
  'ú': ['u', 2],
  'ǘ': ['v', 2],
  'ǎ': ['a', 3],
  'ě': ['e', 3],
  'ǐ': ['i', 3],
  'ǒ': ['o', 3],
  'ǔ': ['u', 3],
  'ǚ': ['v', 3],
  'à': ['a', 4],
  'è': ['e', 4],
  'ì': ['i', 4],
  'ò': ['o', 4],
  'ù': ['u', 4],
  'ǜ': ['v', 4]
};

exports.default = DICTIONARY;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

(function (ntils) {

  /**
   * 空函数
   */
  ntils.noop = function () { };

  /**
   * 验证一个对象是否为NULL
   * @method isNull
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isNull = function (obj) {
    return obj === null || typeof obj === "undefined";
  };

  /**
   * 除去字符串两端的空格
   * @method trim
   * @param  {String} str 源字符串
   * @return {String}     结果字符串
   * @static
   */
  ntils.trim = function (str) {
    if (this.isNull(str)) return str;
    if (str.trim) {
      return str.trim();
    } else {
      return str.replace(/(^[\\s]*)|([\\s]*$)/g, "");
    }
  };

  /**
   * 替换所有
   * @method replace
   * @param {String} str 源字符串
   * @param {String} str1 要替换的字符串
   * @param {String} str2 替换为的字符串
   * @static
   */
  ntils.replace = function (str, str1, str2) {
    if (this.isNull(str)) return str;
    return str.replace(new RegExp(str1, 'g'), str2);
  };

  /**
   * 从字符串开头匹配
   * @method startWith
   * @param {String} str1 源字符串
   * @param {String} str2 要匹配的字符串
   * @return {Boolean} 匹配结果
   * @static
   */
  ntils.startWith = function (str1, str2) {
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) === 0;
  };

  /**
   * 是否包含
   * @method contains
   * @param {String} str1 源字符串
   * @param {String} str2 检查包括字符串
   * @return {Boolean} 结果
   * @static
   */
  ntils.contains = function (str1, str2) {
    var self = this;
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) > -1;
  };

  /**
   * 从字符串结束匹配
   * @method endWidth
   * @param {String} str1 源字符串
   * @param {String} str2 匹配字符串
   * @return {Boolean} 匹配结果
   * @static
   */
  ntils.endWith = function (str1, str2) {
    if (this.isNull(str1) || this.isNull(str2)) return false;
    return str1.indexOf(str2) === (str1.length - str2.length);
  };

  /**
   * 是否包含属性
   * @method hasProperty
   * @param  {Object}  obj  对象
   * @param  {String}  name 属性名
   * @return {Boolean}      结果
   * @static
   */
  ntils.has = ntils.hasProperty = function (obj, name) {
    if (this.isNull(obj) || this.isNull(name)) return false;
    return (name in obj) || (obj.hasOwnProperty(name));
  };

  /**
   * 验证一个对象是否为Function
   * @method isFunction
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isFunction = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === "function";
  };

  /**
   * 验证一个对象是否为String
   * @method isString
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isString = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'string' || obj instanceof String;
  };

  /**
   * 验证一个对象是否为Number
   * @method isNumber
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isNumber = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'number' || obj instanceof Number;
  };

  /**
   * 验证一个对象是否为Boolean
   * @method isBoolean
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isBoolean = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === 'boolean' || obj instanceof Boolean;
  };

  /**
   * 验证一个对象是否为HTML Element
   * @method isElement
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isElement = function (obj) {
    if (this.isNull(obj)) return false;
    if (window.Element) {
      return obj instanceof Element;
    } else {
      return (obj.tagName && obj.nodeType && obj.nodeName && obj.attributes && obj.ownerDocument);
    }
  };

  /**
   * 验证一个对象是否为HTML Text Element
   * @method isText
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isText = function (obj) {
    if (this.isNull(obj)) return false;
    return obj instanceof Text;
  };

  /**
   * 验证一个对象是否为Object
   * @method isObject
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isObject = function (obj) {
    if (this.isNull(obj)) return false;
    return typeof obj === "object";
  };

  /**
   * 验证一个对象是否为Array或伪Array
   * @method isArray
   * @param  {Object}  obj 要验证的对象
   * @return {Boolean}     结果
   * @static
   */
  ntils.isArray = function (obj) {
    if (this.isNull(obj)) return false;
    var v1 = Object.prototype.toString.call(obj) === '[object Array]';
    var v2 = obj instanceof Array;
    var v3 = !this.isString(obj) && this.isNumber(obj.length) && this.isFunction(obj.splice);
    var v4 = !this.isString(obj) && this.isNumber(obj.length) && obj[0];
    return v1 || v2 || v3 || v4;
  };

  /**
   * 验证是不是一个日期对象
   * @method isDate
   * @param {Object} val   要检查的对象
   * @return {Boolean}           结果
   * @static
   */
  ntils.isDate = function (val) {
    if (this.isNull(val)) return false;
    return val instanceof Date;
  };

  /**
   * 验证是不是一个正则对象
   * @method isDate
   * @param {Object} val   要检查的对象
   * @return {Boolean}           结果
   * @static
   */
  ntils.isRegexp = function (val) {
    return val instanceof RegExp;
  };

  /**
   * 转换为数组
   * @method toArray
   * @param {Array|Object} array 伪数组
   * @return {Array} 转换结果数组
   * @static
   */
  ntils.toArray = function (array) {
    if (this.isNull(array)) return [];
    return Array.prototype.slice.call(array);
  };

  /**
   * 转为日期格式
   * @method toDate
   * @param {Number|String} val 日期字符串或整型数值
   * @return {Date} 日期对象
   * @static
   */
  ntils.toDate = function (val) {
    var self = this;
    if (self.isNumber(val))
      return new Date(val);
    else if (self.isString(val))
      return new Date(self.replace(self.replace(val, '-', '/'), 'T', ' '));
    else if (self.isDate(val))
      return val;
    else
      return null;
  };

  /**
   * 遍历一个对像或数组
   * @method each
   * @param  {Object or Array}   obj  要遍历的数组或对象
   * @param  {Function} fn            处理函数
   * @return {void}                   无返回值
   * @static
   */
  ntils.each = function (list, handler, scope) {
    if (this.isNull(list) || this.isNull(handler)) return;
    if (this.isArray(list)) {
      var listLength = list.length;
      for (var i = 0; i < listLength; i++) {
        var rs = handler.call(scope || list[i], i, list[i]);
        if (!this.isNull(rs)) return rs;
      }
    } else {
      for (var key in list) {
        var rs = handler.call(scope || list[key], key, list[key]);
        if (!this.isNull(rs)) return rs;
      }
    }
  };

  /**
   * 格式化日期
   * @method formatDate
   * @param {Date|String|Number} date 日期
   * @param {String} format 格式化字符串
   * @param {object} dict 反译字典
   * @return {String} 格式化结果
   * @static
   */
  ntils.formatDate = function (date, format, dict) {
    if (this.isNull(format) || this.isNull(date)) return date;
    date = this.toDate(date);
    dict = dict || {};
    var placeholder = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "w+": date.getDay(), //week
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var key in placeholder) {
      if (new RegExp("(" + key + ")").test(format)) {
        var value = placeholder[key];
        value = dict[value] || value;
        format = format.replace(RegExp.$1, RegExp.$1.length == 1
          ? value : ("00" + value).substr(("" + value).length));
      }
    }
    return format;
  };

  /**
   * 拷贝对象
   * @method copy
   * @param {Object} src 源对象
   * @param {Object} dst 目标对象
   * @static
   */
  ntils.copy = function (src, dst, igonres) {
    dst = dst || (this.isArray(src) ? [] : {});
    this.each(src, function (key) {
      if (igonres && igonres.indexOf(key) > -1) return;
      delete dst[key];
      if (Object.getOwnPropertyDescriptor) {
        try {
          Object.defineProperty(dst, key, Object.getOwnPropertyDescriptor(src, key));
        } catch (ex) {
          dst[key] = src[key];
        }
      } else {
        dst[key] = src[key];
      }
    })
    return dst;
  };

  /**
   * 深度克隆对象
   * @method clone
   * @param {Object} src 源对象
   * @return {Object} 新对象
   * @static
   */
  ntils.clone = function (src, igonres) {
    if (this.isNull(src) ||
      this.isString(src) ||
      this.isNumber(src) ||
      this.isBoolean(src) ||
      this.isDate(src)) {
      return src;
    }
    var objClone = src;
    try {
      objClone = new src.constructor();
    } catch (ex) { }
    this.each(src, function (key, value) {
      if (objClone[key] != value && !this.contains(igonres, key)) {
        if (this.isObject(value)) {
          objClone[key] = this.clone(value, igonres);
        } else {
          objClone[key] = value;
        }
      }
    }, this);
    ['toString', 'valueOf'].forEach(function (key) {
      if (this.contains(igonres, key)) return;
      this.defineFreezeProp(objClone, key, src[key]);
    }, this);
    return objClone;
  };

  /**
   * 合并对象
   * @method mix
   * @return 合并后的对象
   * @param {Object} dst 目标对象
   * @param {Object} src 源对象
   * @param {Array} igonres 忽略的属性名,
   * @param {Number} mode 模式
   */
  ntils.mix = function (dst, src, igonres, mode, igonreNull) {
    //根据模式来判断，默认是Obj to Obj的  
    if (mode) {
      switch (mode) {
        case 1: // proto to proto  
          return ntils.mix(dst.prototype, src.prototype, igonres, 0);
        case 2: // object to object and proto to proto  
          ntils.mix(dst.prototype, src.prototype, igonres, 0);
          break; // pass through  
        case 3: // proto to static  
          return ntils.mix(dst, src.prototype, igonres, 0);
        case 4: // static to proto  
          return ntils.mix(dst.prototype, src, igonres, 0);
        default: // object to object is what happens below  
      }
    }
    //---
    src = src || {};
    dst = dst || (this.isArray(src) ? [] : {});
    this.keys(src).forEach(function (key) {
      if (this.contains(igonres, key)) return;
      if (igonreNull && this.isNull(src[key])) return;
      if (this.isObject(src[key]) &&
        (src[key].constructor == Object ||
          src[key].constructor == Array ||
          src[key].constructor == null)) {
        dst[key] = ntils.mix(dst[key], src[key], igonres, 0, igonreNull);
      } else {
        dst[key] = src[key];
      }
    }, this);
    return dst;
  };

  /**
   * 定义不可遍历的属性
   **/
  ntils.defineFreezeProp = function (obj, name, value) {
    try {
      Object.defineProperty(obj, name, {
        value: value,
        enumerable: false,
        configurable: true, //能不能重写定义
        writable: false //能不能用「赋值」运算更改
      });
    } catch (err) {
      obj[name] = value;
    }
  };

  /**
   * 获取所有 key 
   */
  ntils.keys = function (obj) {
    if (Object.keys) return Object.keys(obj);
    var keys = [];
    this.each(obj, function (key) {
      keys.push(key);
    });
    return keys;
  };

  /**
   * 创建一个对象
   */
  ntils.create = function (proto, props) {
    if (Object.create) return Object.create(proto, props);
    var Cotr = function () { };
    Cotr.prototype = proto;
    var obj = new Cotr();
    if (props) this.copy(props, obj);
    return obj;
  };

  /**
   * 设置 proto
   * 在不支持 setPrototypeOf 也不支持 __proto__ 的浏览器
   * 中，会采用 copy 方式
   */
  ntils.setPrototypeOf = function (obj, proto) {
    if (Object.setPrototypeOf) {
      return Object.setPrototypeOf(obj, proto || this.create(null));
    } else {
      if (!('__proto__' in Object)) this.copy(proto, obj);
      obj.__proto__ = proto;
    }
  };

  /**
   * 获取 proto
   */
  ntils.getPrototypeOf = function (obj) {
    if (obj.__proto__) return obj.__proto__;
    if (Object.getPrototypeOf) return Object.getPrototypeOf(obj);
    if (obj.constructor) return obj.constructor.prototype;
  };

  /**
   * 是否深度相等
   */
  ntils.deepEqual = function (a, b) {
    if (a === b) return true;
    if (!this.isObject(a) || !this.isObject(b)) return false;
    var aKeys = this.keys(a);
    var bKeys = this.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    var allKeys = aKeys.concat(bKeys);
    var checkedMap = this.create(null);
    var result = true;
    this.each(allKeys, function (i, key) {
      if (checkedMap[key]) return;
      if (!this.deepEqual(a[key], b[key])) result = false;
      checkedMap[key] = true;
    }, this);
    return result;
  };

  /**
   * 从一个数值循环到别一个数
   * @param {number} fromNum 开始数值
   * @param {Number} toNum 结束数值
   * @param {Number} step 步长值
   * @param {function} handler 执行函数
   * @returns {void} 无返回
   */
  ntils.fromTo = function (fromNum, toNum, step, handler) {
    if (!handler) handler = [step, step = handler][0];
    step = Math.abs(step || 1);
    if (fromNum < toNum) {
      for (var i = fromNum; i <= toNum; i += step) handler(i);
    } else {
      for (var i = fromNum; i >= toNum; i -= step) handler(i);
    }
  };

  /**
   * 生成一个Guid
   * @method newGuid
   * @return {String} GUID字符串
   * @static
   */
  ntils.newGuid = function () {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  };

  /**
   * 对象变换
   **/
  ntils.map = function (list, fn) {
    var buffer = this.isArray(list) ? [] : {};
    this.each(list, function (name, value) {
      buffer[name] = fn(name, value);
    });
    return buffer;
  };

  /**
   * 通过路径设置属性值
   */
  ntils.setByPath = function (obj, path, value) {
    if (this.isNull(obj) || this.isNull(path) || path === '') {
      return;
    }
    if (!this.isArray(path)) {
      path = path.replace(/\[/, '.').replace(/\]/, '.').split('.');
    }
    this.each(path, function (index, name) {
      if (this.isNull(name) || name.length < 1) return;
      if (index === path.length - 1) {
        obj[name] = value;
      } else {
        obj[name] = obj[name] || {};
        obj = obj[name];
      }
    }, this);
  };

  /**
   * 通过路径获取属性值
   */
  ntils.getByPath = function (obj, path) {
    if (this.isNull(obj) || this.isNull(path) || path === '') {
      return obj;
    }
    if (!this.isArray(path)) {
      path = path.replace(/\[/, '.').replace(/\]/, '.').split('.');
    }
    this.each(path, function (index, name) {
      if (this.isNull(name) || name.length < 1) return;
      if (!this.isNull(obj)) obj = obj[name];
    }, this);
    return obj;
  };

  /**
   * 数组去重
   **/
  ntils.unique = function (array) {
    if (this.isNull(array)) return array;
    var newArray = [];
    this.each(array, function (i, value) {
      if (newArray.indexOf(value) > -1) return;
      newArray.push(value);
    });
    return newArray;
  };

  /**
   * 解析 function 的参数列表
   **/
  ntils.getFunctionArgumentNames = function (fn) {
    if (!fn) return [];
    var src = fn.toString();
    var parts = src.split(')')[0].split('=>')[0].split('(');
    return (parts[1] || parts[0]).split(',').map(function (name) {
      return name.trim();
    }).filter(function (name) {
      return name != 'function';
    });
  };

  /**
   * 缩短字符串
   */
  ntils.short = function (str, maxLength) {
    if (!str) return str;
    maxLength = maxLength || 40;
    var strLength = str.length;
    var trimLength = maxLength / 2;
    return strLength > maxLength ? str.substr(0, trimLength) + '...' + str.substr(strLength - trimLength) : str;
  };

  /**
   * 首字母大写
   */
  ntils.firstUpper = function (str) {
    if (this.isNull(str)) return;
    return str.substring(0, 1).toUpperCase() + str.substring(1);
  };

  /**
   * 编码正则字符串
   */
  ntils.escapeRegExp = function (str) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };

  /**
   * 解析字符串为 dom 
   * @param {string} str 字符串
   * @returns {HTMLNode} 解析后的 DOM 
   */
  ntils.parseDom = function (str) {
    this._PDD_ = this._PDD_ || document.createElement('div');
    this._PDD_.innerHTML = ntils.trim(str);
    var firstNode = this._PDD_.childNodes[0];
    //先 clone 一份再通过 innerHTML 清空
    //否则 IE9 下，清空时会导出返回的 DOM 没有子结点
    if (firstNode) firstNode = firstNode.cloneNode(true);
    this._PDD_.innerHTML = '';
    return firstNode;
  };

})(( false) ? (window.ntils = {}) : exports);

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form  id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_contactForm"  class=" contact-template-form " >\n    ';
 if(config.displayMode==1) {;
__p += '\n    <input type="hidden" name="id" value="" />\n    ';
};
__p += '\n    <input type="hidden" name="regType" value="' +
((__t = (config.regType)) == null ? '' : __t) +
'" />\n    <table cellpadding="0" cellspacing="0" align="center">\n      <tbody>\n          ';
 if(config.displayMode==1) {;
__p += '\n          <tr >\n            <td width="25%" align="right">域名持有者中文信息：</td>\n            <td ><input type="checkbox" class="margin-right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_autoFillCustomerInfo"/>用会员信息自动填写（如会员信息与域名持有者信息不符，请您仔细核对并修改）</td>\n          </tr>\n          <tr >\n            <td  align="right " class="text-danger">提醒：</td>\n            <td class="text-danger">域名持有者名称代表域名的拥有权，请填写与所有者证件完全一致的企业名称或姓名。</td>\n          </tr>\n          <tr >\n              <td  align="right">域名持有者类型：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_regTypeDesc">\n                  ';
 if(config.regType==1) {;
__p += '个人';
}else{;
__p += '企业';
};
__p += '\n              </td>\n          </tr>\n          ';
};
__p += '\n          ';
 if(config.regType==1) {;
__p += '\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_company_label_td"><span class="text-danger">*</span>域名持有者名称（中文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_company_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="c_company" value=""  />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_company_tips"></span>\n              </td>\n          </tr>\n          <tr >\n              <td  align="right"  class="text-danger">重要提醒：</td>\n              <td  class="text-danger">\n                  若该域名需备案，请确保域名持有者名称与备案主体名称一致，并完成域名实名认证。\n              </td>\n            </tr>\n          ';
 if(config.displayNameFieldAlways==1) {;
__p += '\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_name_label_td"><span class="text-danger">*</span>域名管理联系人（中文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_name_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="c_name" value=""  />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_name_tips"></span>\n              </td>\n          </tr>\n          ';
};
__p += '\n          ';
} else {;
__p += '\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_company_label_td"><span class="text-danger">*</span>域名持有者单位名称（中文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_company_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="c_company" value=""  />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_company_tips"></span>\n              </td>\n          </tr>\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_name_label_td"><span class="text-danger">*</span>域名管理联系人（中文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_name_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="c_name" value=""  />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_name_tips"></span>\n              </td>\n          </tr>\n          ';
};
__p += '\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>所属区域：</td>\n            <td >\n               <input type="hidden" name="regionType" value="1" />\n               <select name="c_country" class="form-control" onmousewheel="return false;">\n                        </select>\n                        <select name="c_province" class="form-control" onmousewheel="return false;">\n                          <option value="">\n                            -省份-\n                          </option>\n                        </select>\n                        <select name="c_city" class="form-control"  onmousewheel="return false;">\n                          <option value="">\n                            -城市-\n                          </option>\n                  </select>\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_region_tips"></span>\n            </td>\n          </tr>\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>通讯地址（中文）：</td>\n            <td >\n            <input type="text" class="form-control tao-w300" maxlength="200" name="c_venu" value=""  />\n            <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_c_venu_tips"></span>\n            </td>\n          </tr>\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>邮编：</td>\n            <td >\n              <input type="text" class="form-control tao-w300" maxlength="15" name="postalcode" value="" />\n              <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_postalcode_tips"></span>\n            </td>\n          </tr>\n          <!-- <tr >\n            <td  align="right"  class="text-danger">温馨提醒：</td>\n            <td  class="text-danger">\n              域名注册信息可被公众查询，为避免电话骚扰，推荐您及时免费开启隐私保护服务，真实注册信息将不会对公众显示，您可在域名控制台随时关闭/开启。\n              <a href="https://help.aliyun.com/knowledge_detail/35825.html" target="_blank">了解更多</a>\n            </td>\n          </tr> -->\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>联系电话1：</td>\n            <td >\n            <span class=\'txt-label\' >国家代码:</span>\n            <input type="text" class="form-control tao-w40 margin-right " maxlength="4"  name="telArea" value="" />\n            <span class=\'txt-label\' >区号固定电话或手机号码</span>\n             <input type="text" class="form-control tao-w200 margin-right " maxlength="20"  name="telMain" value=""  />\n            <span class=\'txt-label\' >分机号</span>\n            <input type="text" class="form-control tao-w60 margin-right " maxlength="20"  name="telExt" value=""  />\n            <br><br>\n            <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_tel_tips" style="height: 15px;"></span>\n            </td>\n          </tr>\n          <tr >\n            <td  align="right">联系电话2：</td>\n            <td >\n                <input type="text" class="form-control tao-w300" maxlength="100" name="mobile" value="" />\n                <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_mobile_tips"></span>\n            </td>\n  \n          </tr>\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>电子邮箱：</td>\n            <td >\n               <input class="form-control tao-w300" maxlength="60" name="email" value="" />\n               <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_email_tips"></span>\n            </td>\n          </tr>\n          ';
 if(config.displayEnglishFields==1) {;
__p += '\n          <tr >\n            <td  align="right" class="text-danger">提醒：</td>\n            <td class="text-danger">com等国际域名的所有者信息以英文为准，请不要缩写或简写。系统已自动翻译成拼音全拼，如您有英文名称或翻译有误，请直接进行修改。通讯地址（英文）请按照从小地址到大地址填写。\n            </td>\n          </tr>\n          ';
 if(config.regType==1) {;
__p += '\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_company_label_td"><span class="text-danger">*</span>域名持有者名称（英文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_company_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="e_company" value="" />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_company_tips"></span>\n              </td>\n          </tr>\n          ';
 if(config.displayNameFieldAlways==1) {;
__p += '\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_name_label_td"><span class="text-danger">*</span>域名管理联系人（英文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_name_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="e_name" value="" />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_name_tips"></span>\n              </td>\n          </tr>\n          ';
};
__p += '\n          ';
} else {;
__p += '\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_company_label_td"><span class="text-danger">*</span>域名持有者单位名称（英文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_company_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="e_company" value=""  />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_company_tips"></span>\n              </td>\n          </tr>\n          <tr >\n              <td  align="right" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_name_label_td"><span class="text-danger">*</span>域名管理联系人（英文）：</td>\n              <td id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_name_td">\n                  <input type="text" class="form-control tao-w300 " maxlength="128" name="e_name" value="" />\n                  <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_name_tips"></span>\n              </td>\n          </tr>\n          ';
};
__p += '\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>省份（英文）：</td>\n            <td >\n                <input type="text" class="form-control tao-w300 " maxlength="30" name="e_province" value=""  />\n                <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_province_tips"></span>\n            </td>\n          </tr>\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>城市（英文）：</td>\n            <td >\n              <input type="text" class="form-control tao-w300 " maxlength="30" name="e_city" value=""  />\n              <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_city_tips"></span>\n            </td>\n          </tr>\n          <tr >\n            <td  align="right"><span class="text-danger">*</span>通讯地址（英文）：</td>\n            <td >\n                <input type="text" class="form-control tao-w300 " maxlength="128" name="e_venu" value=""  />\n                <span class="tips" id="' +
((__t = (config.selectId)) == null ? '' : __t) +
'_e_venu_tips"></span>\n            </td>\n          </tr>\n          ';
};
__p += '\n          ';
 if(config.displayMode==1) {;
__p += '\n          <tr >\n              <td  align="right"></td>\n              <td >\n                  <label><input type="checkbox" class="margin-right" name="defaultTemplate" value="0"/>域名注册默认模板</label>\n                  <span class="muted-color">设置为默认模板后，可用于快速注册域名。</span>\n              </td>\n          </tr>\n          ';
};
__p += '\n      </tbody>\n    </table>\n  \n    </form>\n  ';

}
return __p
}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

var validate = {
  rules: {
    c_company: {
      required: true,
      regular: /^([^\x00-\xff]|[a-z0-9\s&,+,#_\-\'\:\：\"\.·•・\(\)])+$/i,
      rangelengthENCN: [2, 200]
    },
    e_company: {
      required: true,
      rangelength: [2, 128],
      regular: /^[-0-9a-zA-Z\(\)\s,+,#\._\-\'\"\<\>&]+$/
    },
    c_name: {
      required: true,
      regular: /^([^\x00-\xff]|[a-z0-9\s&,+,#_\-\'\:\：\"\.·•・\(\)])+$/i,
      rangelength: [2, 128]
    },
    e_name: {
      required: true,
      rangelength: [2, 128],
      regular: /^[-0-9a-zA-Z\(\)\s,#\._\-\'\"\<\>&]+$/
    },
    c_country: {
      required: true
    },
    c_province: {
      requiredif: ['regionType', '1']
    },
    e_province: {
      required: true,
      rangelength: [2, 30],
      regular: /^[-a-zA-Z0-9.,,\s,+,\&,(,)#_'";]+$/
    },
    c_city: {
      requiredif: ['regionType', '1']
    },
    e_city: {
      required: true,
      rangelength: [2, 30],
      regular: /^[-a-zA-Z0-9.,,\s,+,\&,(,)#_'";]+$/
    },
    c_venu: {
      required: true,
      regular: /[\u4E00-\u9FA5]+/,
      rangelength: [4, 126]

    },
    e_venu: {
      required: true,
      regular: /^[-a-zA-Z0-9.,,\s,+,\&,(,)#_'";]+$/,
      rangelength: [2, 128]
    },
    postalcode: {
      required: true,
      regular: /^\w{1,15}$/
    },
    email: {
      required: true,
      rangelength: [2, 50],
      email: true
    },
    telArea: {
      required: true,
      regular: /^[0-9]{1,3}$/
    },
    telMain: {
      required: true,
      regular: /^[0-9]{6,12}$/
    },
    telExt: {
      regular: /^[0-9]{1,6}$/
    },
    mobile: {
      regular: /^[0-9]{0,20}$/
    }
  },
  messages: {
    c_company: {
      required: '请输入域名持有者名称（中文）',
      regular: '请输入域名持有者名称（中文）',
      rangelengthENCN: '单位名称为2-200个字符'
    },
    e_company: {
      required: '请输入域名持有者名称(英文)！',
      rangelength: '英文单位名称为2-128个字符',
      regular: '请填写正确单位名称英文'
    },
    c_name: {
      required: '请填写联系人姓名',
      regular: '请输入联系人姓名',
      rangelength: '联系人名称为2-128个字符'
    },
    e_name: {
      required: '请填写联系人英文姓名或填写完整拼音',
      rangelength: '联系人(英文)姓名为2-128个字符',
      regular: '请输入正确英文姓名'
    },
    c_country: {
      required: '请选择国家'
    },
    c_province: {
      requiredif: '请选择您所在的省份'
    },
    e_province: {
      required: '请填写您所在省份英文名称或完整的拼音',
      rangelength: '省份英文为2-30个字符',
      regular: '请输入正确省份英文'
    },
    c_city: {
      requiredif: '请选择城市'
    },
    e_city: {
      required: '请填写您所在城市英文名称或完整的拼音',
      rangelength: '城市英文为2-30个字符',
      regular: '请输入正确城市英文'
    },
    c_venu: {
      required: '请填写详细的通信地址（中文）',
      regular: '请输入通信地址（中文）',
      rangelength: '中文地址为2-63个汉字'
    },
    e_venu: {
      required: '请填写您的英文地址或地址的完整拼音',
      regular: '请输入正确英文地址',
      rangelength: '英文地址为2-128个字符'
    },
    postalcode: {
      required: '请填写您的邮政编码',
      regular: '请填写正确邮编'
    },
    email: {
      required: '重要，您的帐号、密码等重要信息将会发送到此邮箱。',
      rangelength: '邮箱地址为2-50个字符',
      email: '请输入正确的邮箱地址'
    },
    telArea: {
      required: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      regular: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填'
    },
    telMain: {
      required: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      regular: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填'
    },
    telExt: {
      regular: '请正确填写电话分机号'
    },
    mobile: {
      regular: '请输入0-20位电话号码'
    }
  },
  tips: {
    c_company: {
      tips: '将作为您的域名持有者，请填写与公司注册证件一致的名称，由于实名认证材料限制，请海外客户此项填写英文。'
    },
    e_company: {
      tips: '重要，如无英文公司名称请填写与中文名称相同的完整拼音'
    },
    c_name: {
      tips: '请填写联系人中文姓名'
    },
    e_name: {
      tips: '请填写联系人英文姓名或填写完整拼音'
    },
    c_country: {
      tips: '请选择国家',
      groupName: 'region'
    },
    c_province: {
      tips: '请输入省份中文',
      groupName: 'region'
    },
    e_province: {
      tips: '请填写您所在省份英文名称或完整的拼音'
    },
    c_city: {
      tips: '请选择城市',
      groupName: 'region'
    },
    e_city: {
      tips: '请填写您所在城市英文名称或完整的拼音'
    },
    c_venu: {
      tips: '请输入中文地址'
    },
    e_venu: {
      tips: '请填写您的英文地址或地址的完整拼音'
    },
    postalcode: {
      tips: '请输入邮政编码'
    },
    email: {
      tips: '请输入邮箱'
    },
    telArea: {
      tips: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      groupName: 'tel'
    },
    telMain: {
      tips: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      groupName: 'tel'
    },
    telExt: {
      tips: '例如：国家代码:86    区号固定电话:01064242299或手机号码    分机号:6000，分机号可选填',
      groupName: 'tel'
    },
    mobile: {
      tips: '请输入0-20位电话号码'
    }
  }

};
// 正则验证 zhanxp
jQuery.validator.addMethod('regular', function (value, element, param) {
  var reg = new RegExp(param);
  return this.optional(element) || reg.test(value);
}, '不符合指定格式！');
// 国家号码
jQuery.validator.addMethod('countryCode', function (value, element, param) {
  var str = '\'244\',\'93\',\'355\',\'213\',\'376\',\'1264\',\'1268\',\'54\',\'374\',\'247\',\'61\',\'43\',\'994\',\'1242\',\'973\',\'880\',\'1246\',\'375\',\'32\',\'501\',\'229\',\'1441\',\'591\',\'267\',\'55\',\'673\',\'359\',\'226\',\'95\',\'257\',\'237\',\'1\',\'1345\',\'236\',\'235\',\'56\',\'86\',\'57\',\'242\',\'682\',\'506\',\'53\',\'357\',\'420\',\'45\',\'253\',\'1890\',\'593\',\'20\',\'503\',\'372\',\'251\',\'679\',\'358\',\'33\',\'594\',\'241\',\'220\',\'995\',\'49\',\'233\',\'350\',\'30\',\'1809\',\'1671\',\'502\',\'224\',\'592\',\'509\',\'504\',\'852\',\'36\',\'354\',\'91\',\'62\',\'98\',\'964\',\'353\',\'972\',\'39\',\'225\',\'1876\',\'81\',\'962\',\'855\',\'327\',\'254\',\'82\',\'965\',\'331\',\'856\',\'371\',\'961\',\'266\',\'231\',\'218\',\'423\',\'370\',\'352\',\'853\',\'261\',\'265\',\'60\',\'960\',\'223\',\'356\',\'1670\',\'596\',\'230\',\'52\',\'373\',\'377\',\'976\',\'1664\',\'212\',\'258\',\'264\',\'674\',\'977\',\'599\',\'31\',\'64\',\'505\',\'227\',\'234\',\'850\',\'47\',\'968\',\'92\',\'507\',\'675\',\'595\',\'51\',\'63\',\'48\',\'689\',\'351\',\'1787\',\'974\',\'262\',\'40\',\'7\',\'1758\',\'1784\',\'684\',\'685\',\'378\',\'239\',\'966\',\'221\',\'248\',\'232\',\'65\',\'421\',\'386\',\'677\',\'252\',\'27\',\'34\',\'94\',\'1758\',\'1784\',\'249\',\'597\',\'268\',\'46\',\'41\',\'963\',\'886\',\'992\',\'255\',\'66\',\'228\',\'676\',\'1809\',\'216\',\'90\',\'993\',\'256\',\'380\',\'971\',\'44\',\'598\',\'233\',\'58\',\'84\',\'967\',\'381\',\'263\',\'243\',\'260\'';
  var reg = '\'' + value + '\'';
  return str.search(reg) > -1;
}, '请输入86或者正确的国家区号！');

module.exports = validate;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="dd-contact-list">\n	<div>\n	';
 if ( templates.length != 0){;
__p += '\n	<a  class="add-template pull-right" href="//dc.console.aliyun.com/next/index?#/info-template/InfoTemplate" target="_blank">创建新的信息模板</a>\n	';
};
__p += '\n	以下为您曾使用过的域名信息，您可以直接选择使用：\n	<div style="color:orange;">1、按照ICANN政策要求，域名持有人Email邮箱必须真实准确，必须完成邮箱真实性验证的模板才能正常使用。\n	<a href="https://help.aliyun.com/document_detail/62839.html" target="_blank">了解更多</a>\n	</div>\n	';
 if ( config.filterStatus){;
__p += '\n		<div style="color:orange;">2、必须选择已经完成实名的信息模板。</div>\n	';
};
__p += '\n	</div>\n		<table  cellpadding="0" cellspacing="0"  class="list-table">\n			<tbody class="contact-template-rows">\n			';
 if (!templates){;
__p += '\n			<tr class="wait">\n				<td align="center" colspan="5" >\n					<img src="//img.alicdn.com/tps/TB1pXLPLFXXXXa7XXXXXXXXXXXX-200-200.gif">\n				</td>\n			</tr>\n			';
}else{;
__p += '\n				';
 if (!foldClose && selectTemplate) {;
__p += '\n				<tr>\n					<td class="col-1" style="width:30px;">\n						<input type="radio" name="templateRadio"\n						class="template-id" value="' +
((__t = (selectTemplate.registrantProfileId)) == null ? '' : __t) +
'"\n						';
if (selectTemplate) {;
__p += ' checked ';
};
__p += '\n						>\n					</td>\n					<td>' +
((__t = (selectTemplate.zhRegistrantOrganization)) == null ? '' : __t) +
'</td>\n					<td style="display: ' +
((__t = (config['smallStyle']&&'none')) == null ? '' : __t) +
'">' +
((__t = (selectTemplate.registrantOrganization)) == null ? '' : __t) +
'</td>\n					<td>' +
((__t = (selectTemplate.email)) == null ? '' : __t) +
'</td>\n					';
if(!(config['auditStatus'] === false)){;
__p += '\n						<td>\n							' +
((__t = (({FAILED:'审核失败',SUCCEED:'已实名认证',NONAUDIT:'未实名认证',AUDITING:'审核中'})[(selectTemplate.realNameStatus === undefined? "NONAUDIT" : selectTemplate.realNameStatus)] || '')) == null ? '' : __t) +
'\n						</td>\n					';
};
__p += '\n					<td><a   class="view-detail" data-id="' +
((__t = (selectTemplate.registrantProfileId)) == null ? '' : __t) +
'">详情</a></td>\n				</tr>\n				';
} else {;
__p += '\n				';
 for(var i=0; i<templates.length; i++) {;
__p += '\n				';
if (!foldClose && i>=1) break;;
__p += '\n				<tr style="color:' +
((__t = ( templates[i].emailVerificationStatus?'inherit':'gray' )) == null ? '' : __t) +
'">\n					<td class="col-1" style="width:30px;">\n						<input type="radio" name="templateRadio" class="template-id" value="' +
((__t = (templates[i].registrantProfileId)) == null ? '' : __t) +
'"\n						' +
((__t = ( templates[i].emailVerificationStatus?'':'disabled' )) == null ? '' : __t) +
'\n						';
if (selectTemplate && selectTemplate.registrantProfileId==templates[i].registrantProfileId) {;
__p += ' checked ';
};
__p += '\n					></td>\n					<td>' +
((__t = (templates[i].zhRegistrantOrganization)) == null ? '' : __t) +
'</td>\n					<td style="display: ' +
((__t = (config['smallStyle'] && 'none')) == null ? '' : __t) +
'">' +
((__t = (templates[i].registrantOrganization)) == null ? '' : __t) +
'</td>\n					<td >\n						' +
((__t = (templates[i].email)) == null ? '' : __t) +
'\n						(\n							';
 if(templates[i].emailVerificationStatus) {;
__p += '\n							已验证\n							';
 }else{ ;
__p += '\n							<a href="//domain.console.aliyun.com/next/index#/email-verify?email=' +
((__t = (templates[i].email)) == null ? '' : __t) +
'" style="color:#00a2ca;text-decoration:none;" target="_blank">去验证</a>\n							';
 } ;
__p += '\n						)\n					</td>\n					';
if(!(config['auditStatus'] === false)){;
__p += '\n						<td style="width:120px;">\n							' +
((__t = (({FAILED:'审核失败',SUCCEED:'已实名认证',NONAUDIT:'未实名认证',AUDITING:'审核中'})[(templates[i].realNameStatus === undefined?"NONAUDIT":templates[i].realNameStatus)] || '')) == null ? '' : __t) +
'\n						</td>\n					';
};
__p += '\n\n					<td style="width:55px;"><a   class="view-detail" data-id="' +
((__t = (templates[i].registrantProfileId)) == null ? '' : __t) +
'">详情</a></td>\n				</tr>\n			     ';
};
__p += '\n				';
 if ( templates.length == 0){;
__p += '\n				<tr class="wait">\n					<td align="center" colspan="5">\n					<!--亲，没有查询到可用的信息模板，请您直接<a  class="add-template">填写域名信息</a>-->\n					亲，没有查询到可用的信息模板，请去<a href="//dc.console.aliyun.com/next/index?#/info-template/InfoTemplate" target="_blank">创建信息模版</a>。（转入域名时，必须使用已实名认证的模版）\n					</td>\n				</tr>\n				';
};
__p += '\n			';
}};
__p += '\n\n			</tbody>\n		</table>\n		';
 if (foldClose && totalpage>1) {;
__p += '\n			<div class="pagination">\n					<li><a href="javascript:;" class="current-page" value="' +
((__t = (1)) == null ? '' : __t) +
'">«</a></li>\n					';
 if (currentpage != 1) {;
__p += '\n						<li><a href="javascript:;" class="current-page" value="' +
((__t = (currentpage-1)) == null ? '' : __t) +
'">‹</a></li>\n					';
};
__p += '\n					';
 for(var i=currentpage-1; i <= (currentpage+2); i++) {;
__p += '\n						';
 if (i > 0&&i != currentpage && i <= totalpage) {;
__p += '\n							<li><a href="javascript:;" class="current-page" value="' +
((__t = (i)) == null ? '' : __t) +
'">' +
((__t = (i)) == null ? '' : __t) +
'</a></li>\n						';
 }else if(i > 0&&i == currentpage && i <= totalpage){ ;
__p += '\n							<li><a href="javascript:;" class="current-page active" value="' +
((__t = (i)) == null ? '' : __t) +
'">' +
((__t = (i)) == null ? '' : __t) +
'</a></li>\n						';
};
__p += '\n					';
};
__p += '\n					';
 if (currentpage == 1 && currentpage+3 <= totalpage) {;
__p += '\n						<li><a href="javascript:;" class="current-page" value="' +
((__t = (currentpage+3)) == null ? '' : __t) +
'">' +
((__t = (currentpage+3)) == null ? '' : __t) +
'</a></li>\n					';
};
__p += '\n					';
 if (currentpage != totalpage) {;
__p += '\n						<li><a href="javascript:;" class="current-page" value="' +
((__t = (currentpage+1)) == null ? '' : __t) +
'">›</a></li>\n					';
};
__p += '\n					<li><a href="javascript:;" class="current-page" value="' +
((__t = (totalpage)) == null ? '' : __t) +
'">»</a></li>\n				</div>\n			';
} else {;

};
__p += '\n		<div class="clear"></div>\n	<div class="fold-list-block">\n		<a class="fold-list">';
 if (foldClose) {;
__p += '收起';
} else {;
__p += '显示更多';
};
__p += '</a>\n	</div>\n</div>\n';

}
return __p
}

/***/ })
],[39]);


// WEBPACK FOOTER //
// scripts/index.js